webpackJsonp([1],{

/***/ "++KJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['keywords', 'description', 'headline', 'subtitle']
});

/***/ }),

/***/ "+2No":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['bus', 'locked'],
  data: function data() {
    return { allowDrag: true };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['designId', 'selectedProductIsRounded', 'flags'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['setDesign', 'setPage']), {
    onUploadBack: function onUploadBack(event) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event.preventDefault();

                if (!_this.flags.seamlessBackUpload) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return _this.setDesign(event.design);

              case 4:
                _this.setPage('1'); // Switch to back page (numbered from 0)
                _context.next = 9;
                break;

              case 7:
                console.log('reloading...');
                window.location.reload();

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  })
});

/***/ }),

/***/ "+4XM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CartCheckoutWrapper',[_c('div',{staticClass:"basket-wrapper"},[_c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-lg-9"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table cart-table",attrs:{"cellspacing":"0"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"product-remove"},[_vm._v(" ")]),_vm._v(" "),_c('th',{staticClass:"product-thumbnail",attrs:{"id":"header"}},[_vm._v("Preview")]),_vm._v(" "),_c('th',{staticClass:"product-name",attrs:{"id":"header"}},[_vm._v("Description")]),_vm._v(" "),_c('th',{staticClass:"product-box-size",attrs:{"id":"header"}},[_vm._v("Quantity")]),_vm._v(" "),_c('th',{staticClass:"product-subtotal",attrs:{"id":"header"}},[_vm._v("Total")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.basketLines),function(line){return _c('LineItem',{key:line.url,attrs:{"data-url":line.url,"line":line},on:{"remove":_vm.onRemove}})}),1)])])]),_vm._v(" "),_c('div',{staticClass:"col-3 d-none d-lg-block"},[_c('div',{staticClass:"cart-subtotal action-card"},[_c('h2',{staticClass:"subtotal"},[_vm._v("Subtotal: $"+_vm._s(_vm.subtotalPrice.toFixed(2)))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('router-link',{staticClass:"btn-action proceed-to-checkout",staticStyle:{"margin-bottom":"12px"},attrs:{"to":"/checkout"}},[_vm._v("\n                Checkout\n                "),_c('i',{staticClass:"fa fa-arrow-right"})]),_vm._v(" "),_c('p',{staticClass:"continue-shopping"},[_vm._v("or "),_c('router-link',{attrs:{"to":"/business-cards"}},[_vm._v("continue shopping")])],1)],1),_vm._v(" "),_c('div',{staticClass:"cart-voucher action-card"},[(_vm.basketVoucher)?[_c('h2',[_vm._v("Discount Code applied")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b',[_vm._v("Name:")]),_vm._v(" "+_vm._s(_vm.basketVoucher.name)+"\n                "),_c('hr'),_vm._v(" "),(!_vm.enteringVoucher)?_c('p',{staticClass:"continue-shopping"},[_c('a',{on:{"click":function($event){_vm.enteringVoucher = true}}},[_vm._v("change coupon")])]):_vm._e()]:[_c('h2',[_vm._v("Have a Discount Code?")]),_vm._v(" "),_c('hr')],_vm._v(" "),(_vm.enteringVoucher || !_vm.basketVoucher)?[_c('b-input-group',[_c('b-form-input',{staticClass:"voucher-input",attrs:{"size":"sm","placeholder":"Code"},model:{value:(_vm.voucher),callback:function ($$v) {_vm.voucher=$$v},expression:"voucher"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-btn',{staticClass:"apply-voucher-btn",attrs:{"size":"sm","variant":"default"},on:{"click":_vm.applyVoucherCode}},[_vm._v("Apply")])],1)],1),_vm._v(" "),(_vm.voucherError)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.voucherError))]):_vm._e()]:_vm._e()],2)])])])])]),_vm._v(" "),_c('div',{staticClass:"fixed-menu d-lg-none"},[_c('div',{staticClass:"fixed-menu-body",staticStyle:{"flex-direction":"column"}},[(_vm.enteringVoucher)?_c('div',{staticClass:"discount-code"},[_c('h2',[_vm._v("Have a Discount Code?")]),_vm._v(" "),_c('b-input-group',[_c('b-form-input',{staticClass:"voucher-input",attrs:{"size":"sm","placeholder":"Code"},model:{value:(_vm.voucher),callback:function ($$v) {_vm.voucher=$$v},expression:"voucher"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-btn',{staticClass:"apply-voucher-btn",attrs:{"size":"sm","variant":"default"},on:{"click":_vm.applyVoucherCode}},[_vm._v("Apply")])],1)],1),_vm._v(" "),(_vm.voucherError)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.voucherError))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"continue-shopping"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.enteringVoucher = false}}},[_vm._v("cancel")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/businesscards"}},[_vm._v("continue shopping")])],1)],1):_c('div',[_c('h2',{staticClass:"subtotal",staticStyle:{"margin-bottom":"12px"}},[_vm._v("Subtotal: $"+_vm._s(_vm.subtotalPrice.toFixed(2)))]),_vm._v(" "),_c('router-link',{staticClass:"btn-action proceed-to-checkout",attrs:{"to":"/checkout"}},[_vm._v("\n          Checkout\n          "),_c('i',{staticClass:"fa fa-arrow-right"})]),_vm._v(" "),_c('p',{staticClass:"continue-shopping"},[(_vm.basketVoucher)?_c('span',[_vm._v("\n            Code applied: "),_c('b',[_vm._v(_vm._s(_vm.basketVoucher.name))]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.enteringVoucher = true}}},[_vm._v("change")])]):_c('span',[_c('a',{staticClass:"enter-discount-code-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.enteringVoucher = true}}},[_vm._v("enter discount code")])]),_vm._v("\n          | "),_c('router-link',{attrs:{"to":"/businesscards"}},[_vm._v("continue shopping")])],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+99l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");




//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['member']), {
    settings: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.member.settings || {}, { current_producttemplate: this.member.current_producttemplate });
      },
      set: function set() {
        var _this = this;

        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var current_producttemplate = _ref.current_producttemplate,
            settings = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['current_producttemplate']);

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
          var id;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  id = _this.member.id;
                  _context.next = 3;
                  return _this.updateUserProfile({ id: id, current_producttemplate: current_producttemplate, settings: settings });

                case 3:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }))();
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['updateUserProfile']))
});

/***/ }),

/***/ "+Anf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('h1',[_vm._v("Settings"),(_vm.sub)?_c('span',[_vm._v(": "+_vm._s(_vm.sub))]):_vm._e()])]),_vm._v(" "),_c('b-col',{staticClass:"text-right"},[_vm._t("default",[(_vm.showButtons)?_c('SettingsButtons',{attrs:{"saving":_vm.saving,"show-save":_vm.showSave,"show-cancel":_vm.showCancel}}):_vm._e()])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+CMB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+Twt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49d3085f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoStrings_vue__ = __webpack_require__("iPan");
function injectStyle (ssrContext) {
  __webpack_require__("ZB2G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49d3085f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49d3085f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoStrings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+c1+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_products__ = __webpack_require__("6TJt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_productData_json__ = __webpack_require__("z3lN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_productData_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__data_productData_json__);






/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    productInfo: {
      category: null,
      products: []
    }
  },
  mutations: {
    setProductState: function setProductState(state, obj) {
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(state.productInfo, obj);
    }
  },
  actions: {
    loadProducts: function loadProducts(_ref, _ref2) {
      var _this = this;

      var commit = _ref.commit;
      var category = _ref2.category;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var p;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_products__["a" /* products */])(category);

              case 2:
                p = _context.sent;

                commit('setProductState', { products: p, category: category });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    loadDefaultProductInfo: function loadDefaultProductInfo(_ref3) {
      var _this2 = this;

      var dispatch = _ref3.dispatch,
          state = _ref3.state;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _productData$defaultC, category, apiName;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _productData$defaultC = __WEBPACK_IMPORTED_MODULE_5__data_productData_json___default.a.defaultChoice, category = _productData$defaultC.category, apiName = _productData$defaultC.apiName;
                _context2.next = 3;
                return dispatch('loadProducts', { category: category });

              case 3:
                console.log(state.productInfo.products);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  getters: {
    defaultProductSelector: function defaultProductSelector(state) {
      var _productData$defaultC2 = __WEBPACK_IMPORTED_MODULE_5__data_productData_json___default.a.defaultChoice,
          quantity = _productData$defaultC2.quantity,
          apiName = _productData$defaultC2.apiName,
          corners = _productData$defaultC2.corners;

      var result = { quantity: quantity };

      var _loop = function _loop(prec) {
        if (prec.name !== apiName) return 'continue';
        // product recommendations have urls
        var attrs = {};
        prec.product.attributes.forEach(function (_ref4) {
          var sku_tag = _ref4.sku_tag;

          var m = /(sides|corners):\s*(.+)/.exec(sku_tag);
          attrs[m[1]] = m[2];
        });
        if (attrs.corners !== corners) return 'continue';
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(prec.product.prices), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var price = _step2.value;

            if (price.quantity === quantity) {
              result[attrs.sides] = price.stockrecord.product;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(state.productInfo.products), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var prec = _step.value;

          var _ret = _loop(prec);

          if (_ret === 'continue') continue;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return result;
    }
  }
});

/***/ }),

/***/ "+eQK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessCardsNew_vue__ = __webpack_require__("sC/8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fac67e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessCardsNew_vue__ = __webpack_require__("rFfw");
function injectStyle (ssrContext) {
  __webpack_require__("zo2H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9fac67e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessCardsNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fac67e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessCardsNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+epG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_orderStatus__ = __webpack_require__("FPeH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    statusInitial: { type: String, default: null }
  },
  data: function data() {
    return {
      status: null,
      showAllStatuses: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['totalOrders', 'recentOrdersBusy']), {
    statuses: function statuses() {
      var statuses = this.showAllStatuses ? __WEBPACK_IMPORTED_MODULE_1__lib_orderStatus__["a" /* ALL_STATUSES */] : __WEBPACK_IMPORTED_MODULE_1__lib_orderStatus__["c" /* MAIN_STATUSES */];
      return [{ status: null, shortStatus: 'All' }].concat(statuses.map(function (status) {
        return { status: status, shortStatus: Object(__WEBPACK_IMPORTED_MODULE_1__lib_orderStatus__["f" /* shortStatus */])(status) };
      }));
    }
  }),
  watch: {
    status: function status(val) {
      this.$emit('input', val);
    }
  },
  mounted: function mounted() {
    this.status = this.statusInitial;
  },

  methods: {
    reload: function reload() {
      // Re-emit the input. this should hopefully reload...
      this.$emit('input', this.status);
    }
  }
});

/***/ }),

/***/ "+i0y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+pgR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"design-preview"},[_c('div',{ref:"container",staticClass:"previews",style:(_vm.paddingOverride + _vm.previewsStyle)},_vm._l((_vm.previewUrls),function(url,index){return _c('img',{key:index,class:{active: _vm.currentIndex === index, rounded: _vm.rounded},style:(_vm.img[index].style),attrs:{"src":url},on:{"click":function($event){_vm.currentIndex = index},"load":function($event){return _vm.imgLoad($event, index)}}})}),0),_vm._v(" "),_c('div',{staticClass:"button-holder"},[(_vm.editButton)?_c('button',{staticClass:"btn edit-design",on:{"click":function($event){return _vm.$emit('edit')}}},[_c('i',{staticClass:"far fa-edit"}),_vm._v(" Edit Design")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+rOh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('SettingsTitleBar',{attrs:{"sub":"Emails","saving":_vm.saving}}),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.form.requireNotifyEmail),callback:function ($$v) {_vm.$set(_vm.form, "requireNotifyEmail", $$v)},expression:"form.requireNotifyEmail"}},[_vm._v("Require Manager Notification")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/8aW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    preview_urls: Array,
    stack: Boolean,
    rounded: Boolean,
    popover: Boolean
  },
  computed: {
    previews: function previews() {
      return this.preview_urls && this.preview_urls.length > 0;
    }
  },
  methods: {
    popoverItem: function popoverItem(url) {
      return this.popover && { content: '<img style=\'width: 504px;\' src=\'' + url + '\'>', html: true };
    },
    setPortraitClass: function setPortraitClass(evt) {
      // Use dom manipulation to set class
      // If this is an issue, easy enough to switch to using some piece of data
      var img = evt.target;
      img.classList.toggle('portrait', img.naturalWidth < img.naturalHeight);
    }
  }
});

/***/ }),

/***/ "/HXe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return postReOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateSalesTax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return shippingMethods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return placeOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getOrderInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return orders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ordersPaginated; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defineService__ = __webpack_require__("tVbG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__basket__ = __webpack_require__("gA2L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mungeAddress__ = __webpack_require__("RYrk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common__ = __webpack_require__("Cvgy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_assert__ = __webpack_require__("N+Om");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_assert__);










var postSalesTax = Object(__WEBPACK_IMPORTED_MODULE_4__defineService__["b" /* default */])("post", "api/v1/vendor/salestax/");

var getShippingMethods = Object(__WEBPACK_IMPORTED_MODULE_4__defineService__["b" /* default */])('get', 'api/v1/cart/basket/shipping-methods/');

var postCheckout = Object(__WEBPACK_IMPORTED_MODULE_4__defineService__["b" /* default */])('post', 'api/v1/cart/custom/checkout/');

var getOrder = Object(__WEBPACK_IMPORTED_MODULE_4__defineService__["b" /* default */])('get', 'api/v1/cart/orders/:id/', { alternatives: {
    paidWithVoucher: '-voucher' // payment method = voucher
  } });

var getOrders = Object(__WEBPACK_IMPORTED_MODULE_4__defineService__["b" /* default */])('get', 'api/v1/cart/orders/', { alternatives: {
    emptyTeam: '-empty' // an "empty" team -- no designs, team members, etc.
  } });

var getOrderLines = Object(__WEBPACK_IMPORTED_MODULE_4__defineService__["b" /* default */])('get', 'api/v1/cart/orders/:id/lines');

var postReOrder = Object(__WEBPACK_IMPORTED_MODULE_4__defineService__["b" /* default */])('post', 'api/v1/cart/orders/:id/re-order/');

var calculateSalesTax = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(nexus, lineItems) {
    var fakeOrderNumber, payload, result;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            fakeOrderNumber = 123;
            payload = { address: nexus, line_items: lineItems, doc_code: fakeOrderNumber, paid: false };
            // console.log('calculateSalesTax', payload);

            result = void 0;
            _context.prev = 3;
            _context.next = 6;
            return postSalesTax(payload);

          case 6:
            result = _context.sent;
            _context.next = 16;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);

            if (!(nexus.state && nexus.state != 'CA')) {
              _context.next = 15;
              break;
            }

            return _context.abrupt("return", 0);

          case 15:
            throw _context.t0;

          case 16:
            return _context.abrupt("return", parseFloat(result.TotalTax, 10));

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[3, 9]]);
  }));

  return function calculateSalesTax(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Return a list of shipping methods for the current basket.
 * NOTE: this api will need to change if multiple shipping options are introduced
 */
var shippingMethods = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
    var result;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getShippingMethods();

          case 2:
            result = _context2.sent;
            return _context2.abrupt("return", result.map(function (_ref3) {
              var code = _ref3.code,
                  name = _ref3.name,
                  price = _ref3.price;
              return { code: code, name: name, price: parseFloat(price.excl_tax, 10) };
            }));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function shippingMethods() {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Sample:
 *
 *
 *
 * {
   "shipping_charge" : {
      "excl_tax" : 8,
      "tax" : 0,
      "incl_tax" : 8
   },
   "billing_address" : {
      "notes" : "",
      "city" : "Pacifica",
      "first_name" : "B",
      "postcode" : "94044",
      "line1" : "101 Main",
      "state" : "CA",
      "line2" : "",
      "country" : "/services/cart/api/v1/cart/countries/US/",
      "last_name" : "B"
   },
   "shipping_method_code" : "standard",
   "shipping_address" : {
      "first_name" : "B",
      "city" : "Pacifica",
      "notes" : "",
      "state" : "CA",
      "line1" : "101 Main",
      "postcode" : "94044",
      "phone_number" : "6502489279",
      "line2" : "",
      "last_name" : "B",
      "country" : "/services/cart/api/v1/cart/countries/US/"
   },
   "total" : "92.83",
   "basket" : "http://www.brandly.biz/services/cart/api/v1/cart/baskets/4456/",
   "guest_email" : "tony@brandly.com"
}
 * @param {*} orderInfo
 */
var placeOrder = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(checkoutInfo, paymentInfo, line_items) {
    var paymentMethod, stripeToken, title, is_private, orderInfo;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            checkoutInfo = Object(__WEBPACK_IMPORTED_MODULE_6__mungeAddress__["b" /* toApiAddressFormat */])(checkoutInfo);
            paymentMethod = paymentInfo.paymentMethod, stripeToken = paymentInfo.stripeToken, title = paymentInfo.title, is_private = paymentInfo.is_private;

            console.assert(checkoutInfo.guest_email);
            _context3.next = 5;
            return postCheckout(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, checkoutInfo, { payment_method: paymentMethod, stripe_token: stripeToken, title: title, available_to_team: !is_private }));

          case 5:
            orderInfo = _context3.sent;
            _context3.next = 8;
            return postSalesTax({ address: checkoutInfo.billing_address, doc_code: orderInfo.number, paid: true, line_items: line_items });

          case 8:
            _context3.next = 10;
            return Object(__WEBPACK_IMPORTED_MODULE_5__basket__["c" /* expandOrderLines */])(orderInfo);

          case 10:
            orderInfo = _context3.sent;
            return _context3.abrupt("return", Object(__WEBPACK_IMPORTED_MODULE_6__mungeAddress__["a" /* fromApiAddressFormat */])(orderInfo));

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function placeOrder(_x3, _x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();

/**
 * Find the order for the given ID.
 * @param {*} orderID
 */
var getOrderInfo = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(orderID) {
    var order;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            console.assert(orderID);
            _context4.next = 3;
            return getOrder(orderID);

          case 3:
            order = _context4.sent;
            _context4.next = 6;
            return Object(__WEBPACK_IMPORTED_MODULE_5__basket__["c" /* expandOrderLines */])(order);

          case 6:
            order = _context4.sent;
            return _context4.abrupt("return", Object(__WEBPACK_IMPORTED_MODULE_6__mungeAddress__["a" /* fromApiAddressFormat */])(order));

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function getOrderInfo(_x6) {
    return _ref5.apply(this, arguments);
  };
}();

/**
 * Return list of recently placed orders.
 */
var orders = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
    var _ref7, _ref7$results, results;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return getOrders();

          case 2:
            _ref7 = _context5.sent;
            _ref7$results = _ref7.results;
            results = _ref7$results === undefined ? [] : _ref7$results;

            results = Object(__WEBPACK_IMPORTED_MODULE_6__mungeAddress__["a" /* fromApiAddressFormat */])(results);
            _context5.next = 8;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(results.map(__WEBPACK_IMPORTED_MODULE_5__basket__["c" /* expandOrderLines */]));

          case 8:
            return _context5.abrupt("return", results);

          case 9:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function orders() {
    return _ref6.apply(this, arguments);
  };
}();

/**
 * Return orders for provided `payload`.
 *
 * @param {Object} payload
 * @returns {Promise<{results, count}>}
 */
var ordersPaginated = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6(payload) {
    var _ref9, results, count;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return Object(__WEBPACK_IMPORTED_MODULE_7__common__["a" /* getItemsPaginated */])(getOrders, payload);

          case 2:
            _ref9 = _context6.sent;
            results = _ref9.results;
            count = _ref9.count;

            results = Object(__WEBPACK_IMPORTED_MODULE_6__mungeAddress__["a" /* fromApiAddressFormat */])(results);
            _context6.next = 8;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(results.map(__WEBPACK_IMPORTED_MODULE_5__basket__["c" /* expandOrderLines */]));

          case 8:
            return _context6.abrupt("return", { results: results, count: count });

          case 9:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function ordersPaginated(_x7) {
    return _ref8.apply(this, arguments);
  };
}();

/***/ }),

/***/ "/Kza":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Mbr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/MjH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/TtP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:{roundedCorners: _vm.selectedProductIsRounded},attrs:{"src":_vm.src},on:{"click":_vm.changePage}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/aou":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['member', 'approvalEnabled']), {
    showAdminPreferences: function showAdminPreferences() {
      // Only show when there are relevant settings
      return this.member.user_type === 'admin' && this.approvalEnabled;
    },

    suppressReviewEmails: {
      get: function get() {
        return !!(this.member.settings || {}).suppressReviewEmails;
      },
      set: function set(value) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
          var _member, id, settings;

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _member = _this.member, id = _member.id, settings = _member.settings;

                  if (!settings) settings = {};
                  settings.suppressReviewEmails = !!value;
                  _context.next = 5;
                  return _this.updateUserProfile({ id: id, settings: settings });

                case 5:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }))();
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['updateUserProfile']))
});

/***/ }),

/***/ "/crR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['team', 'productTemplates']), {
    defaultRestrictions: function defaultRestrictions() {
      // Return list of default orderer restrictions.
      var result = [],
          s = this.team.default_orderer_settings || {};
      if (s.restrictDesign) {
        var pt = this.productTemplates.find(function (pt) {
          return pt.id === s.current_producttemplate;
        });
        result.push('Restrict design to ' + (pt ? pt.name : '(template not found)'));
      }
      if (s.restrictQty) {
        result.push('Restrict changing qty');
      }
      if (s.restrictProduct) {
        result.push('Restrict changing paper');
      }
      return result;
    }
  })
});

/***/ }),

/***/ "/o6N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"canvas-container",class:{roundedCorners: _vm.selectedProductIsRounded}},[_c('div',{style:(_vm.trimStyle),attrs:{"id":"trimLine"}}),_vm._v(" "),_c('canvas',{ref:"canvasEl"}),_vm._v(" "),_c('EditorControlsOverlay',{ref:"editorControlsOverlay",attrs:{"fabricCanvas":this.fabricCanvas,"bleedPoints":this.bleedPoints,"displayBleed":_vm.displayBleed,"bus":_vm.bus},on:{"fileData":_vm.placeholderImageDataUploaded}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/v6Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cc5638c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Demo_vue__ = __webpack_require__("DDqq");
function injectStyle (ssrContext) {
  __webpack_require__("5VJ3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5cc5638c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cc5638c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Demo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/yRy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/zs1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return { saved_card: null };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['savedCards', 'savedCardsLoaded', 'defaultSavedCard', 'loggedIn']), {
    savedCardOptions: function savedCardOptions() {
      return this.savedCards.map(function (c) {
        return { value: c.id, text: c.title };
      });
    },
    noSavedCards: function noSavedCards() {
      return this.savedCardsLoaded && this.savedCards.length === 0;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['loadSavedCards']), {
    onMount: function onMount() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.loadSavedCards();

              case 2:
                _this.saved_card = _this.saved_card || _this.defaultSavedCard;

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }),
  mounted: function mounted() {
    this.onMount();
  }
});

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0/j+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "03dJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_SimplePagination__ = __webpack_require__("cVDX");
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SimplePagination: __WEBPACK_IMPORTED_MODULE_0__components_shared_SimplePagination__["default"]
  },
  props: {
    currentPage: { type: Number, required: true },
    totalItems: { type: Number, required: true },
    itemsOnPage: { type: Number, required: true },
    onPageNumberChange: { type: Function, required: true }
  },
  computed: {
    numberOfPages: function numberOfPages() {
      return Math.ceil(this.totalItems / this.itemsOnPage);
    }
  }
});

/***/ }),

/***/ "07s2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SharedLineItemProductForm',{attrs:{"line":_vm.line},on:{"save":_vm.save}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0C1I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"saved-card"},[_vm._t("default"),_vm._v(" "),_c('SavedCard',{attrs:{"card":_vm.value,"hide-title":""}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9"},[_c('b-form-group',{staticClass:"row compact",attrs:{"label":"Saved Card Options:","label-for":"title"}},[_c('div',{staticClass:"required"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value.title),expression:"value.title"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"id":"title","type":"text","placeholder":"Description of card","required":""},domProps:{"value":(_vm.value.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.value, "title", $event.target.value)}}})]),_vm._v(" "),_c('PrivateToggle',{attrs:{"noun":"card"},model:{value:(_vm.is_private),callback:function ($$v) {_vm.is_private=$$v},expression:"is_private"}})],1)],1)])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0D9M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0Gew":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['approvalSettings']), {
    state: function state() {
      return this.approvalSettings.requireNotifyEmail ? 'ON' : 'OFF';
    }
  })
});

/***/ }),

/***/ "0HZ9":
/***/ (function(module, exports) {

module.exports = {"min_prices":{"standard":{"quantity":50,"price":18.99},"premium":{"quantity":50,"price":21.99},"classic":{"quantity":50,"price":30.99},"specialty":{"quantity":50,"price":24.99},"colorcore":{"quantity":50,"price":42.99}},"prices":{"Standard":{"Square":[{"name":"Uncoated","prices":{"50":18.99,"100":24.99,"250":30.99,"500":37.99,"1000":59.99}},{"name":"Matte","prices":{"50":18.99,"100":23.99,"250":28.99,"500":37.99,"1000":59.99}},{"name":"Gloss","prices":{"50":19.99,"100":25.99,"250":32.99,"500":38.99,"1000":62.99}}],"Rounded":[{"name":"Uncoated","prices":{"50":21.99,"100":29.99,"250":38.99,"500":53.99,"1000":88.99}},{"name":"Matte","prices":{"50":22.99,"100":29.99,"250":38.99,"500":53.99,"1000":89.99}},{"name":"Gloss","prices":{"50":22.99,"100":30.99,"250":40.99,"500":57.99,"1000":93.99}}]},"Premium":{"Square":[{"name":"Bright White","prices":{"50":30.99,"100":37.99,"250":47.99,"500":61.99,"1000":112.99}},{"name":"Matte","prices":{"50":21.99,"100":27.99,"250":30.99,"500":35.99,"1000":51.99}},{"name":"Gloss","prices":{"50":21.99,"100":27.99,"250":32.99,"500":37.99,"1000":53.99}},{"name":"Double Thick","prices":{"50":39.99,"100":53.99,"250":80.99,"500":104.99}}],"Rounded":[{"name":"Bright White","prices":{"50":32.99,"100":40.99,"250":51.99,"500":66.99,"1000":133.99}},{"name":"Matte","prices":{"50":26.99,"100":32.99,"250":37.99,"500":48.99,"1000":73.99}},{"name":"Gloss","prices":{"50":26.99,"100":33.99,"250":39.99,"500":51.99,"1000":76.99}},{"name":"Double Thick","prices":{"50":42.99,"100":57.99,"250":92.99,"500":119.99}}]},"Classic":{"Square":[{"name":"Bright White Linen","prices":{"50":30.99,"100":35.99,"250":37.99,"500":47.99,"1000":68.99}},{"name":"Warm White Linen","prices":{"50":30.99,"100":35.99,"250":37.99,"500":47.99,"1000":68.99}},{"name":"Bright White Vellum","prices":{"50":30.99,"100":35.99,"250":37.99,"500":47.99,"1000":68.99}}],"Rounded":[{"name":"Bright White Linen","prices":{"50":36.99,"100":42.99,"250":44.99,"500":60.99,"1000":90.99}},{"name":"Warm White Linen","prices":{"50":36.99,"100":42.99,"250":44.99,"500":60.99,"1000":90.99}},{"name":"Bright White Vellum","prices":{"50":34.99,"100":40.99,"250":43.99,"500":57.99,"1000":85.99}}]},"Specialty":{"Square":[{"name":"Soft-Touch","prices":{"50":42.99,"100":55.99,"250":81.99,"500":126.99,"1000":221.99}},{"name":"Plastic","prices":{"50":45.99,"100":58.99,"250":76.99,"500":104.99,"1000":205.99}},{"name":"Pearlescent","prices":{"50":24.99,"100":35.99,"250":44.99,"500":56.99,"1000":115.99}}],"Rounded":[{"name":"Soft-Touch","prices":{}},{"name":"Plastic","prices":{"50":48.99,"100":61.99,"250":80.99,"500":112.99,"1000":219.99}},{"name":"Pearlescent","prices":{"50":26.99,"100":38.99,"250":48.99,"500":64.99,"1000":129.99}}]},"Color Core":{"Square":[{"name":"Black Color Core","prices":{"50":42.99,"100":59.99,"250":111.99,"500":171.99,"1000":252.99}},{"name":"Blue Color Core","prices":{"50":42.99,"100":59.99,"250":111.99,"500":171.99,"1000":252.99}},{"name":"Red Color Core","prices":{"50":42.99,"100":59.99,"250":111.99,"500":171.99,"1000":252.99}},{"name":"Aqua Color Core","prices":{"50":42.99,"100":59.99,"250":111.99,"500":171.99,"1000":252.99}},{"name":"Orange Color Core","prices":{"50":42.99,"100":59.99,"250":111.99,"500":171.99,"1000":252.99}}],"Rounded":[{"name":"Black Color Core","prices":{"50":45.99,"100":63.99,"250":125.99,"500":194.99,"1000":289.99}},{"name":"Blue Color Core","prices":{"50":45.99,"100":63.99,"250":125.99,"500":194.99,"1000":289.99}},{"name":"Red Color Core","prices":{"50":45.99,"100":63.99,"250":125.99,"500":194.99,"1000":289.99}},{"name":"Aqua Color Core","prices":{"50":45.99,"100":63.99,"250":125.99,"500":194.99,"1000":289.99}},{"name":"Orange Color Core","prices":{"50":45.99,"100":63.99,"250":125.99,"500":194.99,"1000":289.99}}]}}}

/***/ }),

/***/ "0IxP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_dashboard_Dashboard__ = __webpack_require__("rPVX");

var routes = [{
  path: "/dashboard",
  component: __WEBPACK_IMPORTED_MODULE_0__components_pages_dashboard_Dashboard__["a" /* default */],
  children: __WEBPACK_IMPORTED_MODULE_0__components_pages_dashboard_Dashboard__["a" /* default */].children,
  meta: {
    title: 'Brandly | Dashboard',
    requiresAuth: true
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "0JyP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input-group',[_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.joinTeamUrl),callback:function ($$v) {_vm.joinTeamUrl=$$v},expression:"joinTeamUrl"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-button',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.joinTeamUrl),expression:"joinTeamUrl",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.onCopy),expression:"onCopy",arg:"success"},{name:"clipboard",rawName:"v-clipboard:error",value:(_vm.onCopyError),expression:"onCopyError",arg:"error"}],attrs:{"variant":"default","type":"button"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.copyButton)}},[_vm._v("Copied!")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0LIU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LineItem__ = __webpack_require__("mxwC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LineItem: __WEBPACK_IMPORTED_MODULE_3__LineItem__["a" /* default */]
  },
  data: function data() {
    return { voucher: '', voucherError: null, enteringVoucher: false };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['subtotalPrice', 'basketLines', 'basketVoucher'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['loadBasket', 'changeNumberOfBoxes', 'removeFromCart', 'addVoucher', 'applyFutureVoucher']), {
    onRemove: function onRemove(obj) {
      this.removeFromCart(obj.line);
    },
    applyVoucherCode: function applyVoucherCode() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.voucherError = null;

                if (_this.voucher) {
                  _context.next = 4;
                  break;
                }

                _this.voucherError = "Enter a code";
                return _context.abrupt('return');

              case 4:
                _context.prev = 4;
                _context.next = 7;
                return _this.addVoucher(_this.voucher);

              case 7:
                // Success
                _this.voucher = '';
                _this.voucherError = 'Code applied';
                // After a short delay, hide the field, clear the success message
                setTimeout(function () {
                  _this.enteringVoucher = false;
                  _this.voucherError = '';
                }, 1000);
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](4);

                _this.voucherError = _context.t0;

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[4, 12]]);
      }))();
    }
  }),
  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.loadBasket();

            case 2:
              _context2.prev = 2;
              _context2.next = 5;
              return _this2.applyFutureVoucher();

            case 5:
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2['catch'](2);

              _this2.voucherError = _context2.t0;

            case 10:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[2, 7]]);
    }))();
  }
});

/***/ }),

/***/ "0R5z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-settings"},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0T9q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0VKA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    pages: {
      type: Number,
      required: true
    },
    currentpage: {
      type: Number,
      required: true
    },
    vspbutton: {
      type: String,
      default: 'vspButton'
    },
    vspbuttonselected: {
      type: String,
      default: 'vspButton-selected'
    },
    vspbuttonfast: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      maxPages: 10,
      leftPages: [],
      currPage: 0
    };
  },

  watch: {
    currentpage: function currentpage(val) {
      this.handlePageChange(val);
    }
  },
  methods: {
    handlePageChange: function handlePageChange(item) {
      if (this.currPage !== item) {
        this.currPage = item;
        this.generateLeftPages();
        this.$emit('changePage', item);
      }
    },
    generateLeftPages: function generateLeftPages() {
      var start = this.currPage - parseInt(this.maxPages / Math.pow(2, 2)) > 1 ? this.currPage - parseInt(this.maxPages / Math.pow(2, 2)) : 1;
      var stop = parseInt(this.maxPages / 2) + this.currPage - parseInt(this.maxPages / Math.pow(2, 2)) - 1;
      if (stop < parseInt(this.maxPages / 2)) stop = parseInt(this.maxPages / 2);
      if (stop >= this.pages - parseInt(this.maxPages / 2) + 1) {
        stop = this.pages - parseInt(this.maxPages / 2);
        start = this.pages - parseInt(this.maxPages / 2) - parseInt(this.maxPages / Math.pow(2, 2)) - 2;
      }

      this.leftPages = [];
      for (var i = start; i <= stop; i++) {
        this.leftPages.push(i);
      }
    }
  },
  mounted: function mounted() {
    this.currPage = this.currentpage;
    this.generateLeftPages();
  }
});

/***/ }),

/***/ "0YTx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0eNg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return { form: { first_name: '', last_name: '', email: '', job_role: '' }, info: {}, saving: false };
  },

  watch: {
    user: function user() {
      this.copyFromStore();
    }
  },
  mounted: function mounted() {
    this.copyFromStore();
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['flags', 'user', 'personalVars', 'isStaff', 'userTeams', 'team']),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['updateProfile', 'removeFromTeam']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])(['removeTeamFromUserTeams']), {
    copyFromStore: function copyFromStore() {
      for (var k in this.form) {
        this.form[k] = this.user[k];
      }
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.info, this.user.personal_info || {});
    },
    save: function save() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.saving = true;
                _context.next = 3;
                return _this.updateProfile(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this.form, { personal_info: _this.info }));

              case 3:
                _this.saving = false;
                _this.$router.push('/dashboard/settings');

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    leaveCurrentTeam: function leaveCurrentTeam() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var teamRemovedFromID;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                teamRemovedFromID = _this2.team.id;
                _context2.next = 3;
                return _this2.removeFromTeam(_this2.user);

              case 3:

                // After removing, current team will be reloaded - at this point teamRemovedFromID !== this.team.id
                _this2.removeTeamFromUserTeams(teamRemovedFromID);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  })
});

/***/ }),

/***/ "0h+a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header",class:{darkBackground: _vm.heroDark, transparent: _vm.transparent}},[_c('div',{staticClass:"nav-wrapper"},[_c('b-navbar',{class:{wideHeader: _vm.wideHeader},attrs:{"toggleable":"md"}},[_c('b-navbar-brand',{staticStyle:{"align-self":"start"},attrs:{"href":"/"}}),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"})],1)],1),_vm._v(" "),_c('b-modal',{ref:"flagsModal",attrs:{"hide-footer":"","title":"Flags"}},[_c('Flags')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0h4v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35e9f523_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LimitedHeader_vue__ = __webpack_require__("0h+a");
function injectStyle (ssrContext) {
  __webpack_require__("c2k6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35e9f523"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35e9f523_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LimitedHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0q5t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0qMr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bc6b24e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SummaryBlockDark_vue__ = __webpack_require__("pyEl");
function injectStyle (ssrContext) {
  __webpack_require__("6O1u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3bc6b24e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bc6b24e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SummaryBlockDark_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0uq0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard-teamlist"}},[_c('div',{staticClass:"row",attrs:{"id":"team-actions"}},[_c('b-col',{attrs:{"md":"5"}},[_c('h1',[_vm._v(_vm._s(_vm.team.name || 'Team'))])]),_vm._v(" "),_c('b-col',{staticClass:"pb-md-0 pb-5",staticStyle:{"height":"1em"},attrs:{"md":"7"}},[(_vm.showInviteAdmin || _vm.showInviteUser)?_c('MessageFormGroup',[_c('b-input-group',[_c('b-form-input',{attrs:{"size":"sm","id":"invite-email","placeholder":"Email"},model:{value:(_vm.inviteEmail),callback:function ($$v) {_vm.inviteEmail=$$v},expression:"inviteEmail"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-button-group',[(!_vm.showInviteAdmin)?_c('b-btn',{attrs:{"size":"sm","id":"invite-button","variant":"default"},on:{"click":_vm.onClickInviteUser}},[_c('i',{staticClass:"fa fa-envelope"}),_vm._v(" Invite")]):_c('b-dropdown',{attrs:{"size":"sm","id":"invite-button","variant":"default","right":"","split":""},on:{"click":_vm.onClickInviteUser}},[_c('span',{attrs:{"slot":"button-content"},slot:"button-content"},[_c('i',{staticClass:"fa fa-envelope"}),_vm._v(" Invite to Order")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.onClickInviteUser}},[_vm._v("Invite to order")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.onClickInviteAdmin}},[_vm._v("Invite admin")])],1)],1)],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('MessageAlert',[_c('div',{staticClass:"button-holder text-right"},[_c('button',{staticClass:"btn btn-clear pr-0",on:{"click":function($event){_vm.panel = _vm.panel === 'sharing' ? null : 'sharing'}}},[_c('span',{class:{active: _vm.panel === 'sharing'}},[_c('i',{staticClass:"fa fa-link"}),_vm._v(" Share using link\n        ")])]),_vm._v(" "),(_vm.flags.enableTeamMembersImport)?_c('button',{staticClass:"btn btn-clear",on:{"click":function($event){_vm.panel = _vm.panel === 'importing' ? null : 'importing'}}},[_c('span',{class:{active: _vm.panel === 'importing'}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" Import team members\n        ")])]):_vm._e()]),_vm._v(" "),(_vm.panel === 'importing')?_c('TeamMembersImport',{on:{"cancel":function($event){_vm.panel = null}}}):_vm._e(),_vm._v(" "),(_vm.panel === 'sharing')?_c('TeamSharePanel',{on:{"cancel":function($event){_vm.panel = null}}}):_vm._e(),_vm._v(" "),(_vm.isTeamBusy)?_c('WaveSpinner'):_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Team Member")]),_vm._v(" "),_c('th',[_vm._v("Date Joined")]),_vm._v(" "),_c('th',[_vm._v("Role")]),_vm._v(" "),(_vm.flags.showLastOrderDate)?_c('th',[_vm._v("Last order date")]):_vm._e()])]),_vm._v(" "),_c('tbody',{class:{hover: _vm.isAdmin}},_vm._l((_vm.members),function(member){return _c('MemberRow',{key:member.username,attrs:{"member":member}})}),1)])],1),_vm._v(" "),_c('b-alert',{attrs:{"variant":"success","id":"alert","show":""}},[_c('b',[_vm._v("Welcome to the Team page.")]),_vm._v(" Add team members to allow them to self-order or\n  to make admin-ordering easier by saving their imprint information.\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "19NW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1BkZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomepageSecondaryLayout',[_c('div',{staticClass:"header-dark-container"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"privacy-header"},[_c('h1',[_vm._v("Privacy Policy")]),_vm._v(" "),_c('h4',[_vm._v("Last Updated: Sept 25, 2017")]),_vm._v(" "),_c('p',[_vm._v("This Privacy Policy explains how Brandly, Inc. (“we” or “us”) collects and uses certain information that you provide through our \n            website currently located at http://www.brandly.com and its subpages, mobile versions, together with any content, materials, web \n            applications, and services made available therein, and successor site(s) (the “Site”).")]),_vm._v(" "),_c('p',[_vm._v("PLEASE READ THIS PRIVACY POLICY CAREFULLY. BY ACCESSING OR USING OUR SITE, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTAND, AND \n            AGREE TO BE BOUND TO ALL THE TERMS OF THIS PRIVACY POLICY AND OUR SITE TERMS OF USE. IF YOU DO NOT AGREE TO THESE TERMS, EXIT THIS \n            PAGE AND DO NOT ACCESS OR USE THE SITE.")])]),_vm._v(" "),_c('h4',[_vm._v("PERSONAL INFORMATION")]),_vm._v(" "),_c('h5',[_vm._v(" We May Collect.")]),_vm._v(" "),_c('p',[_vm._v("Depending on the circumstances, we may collect and hold a range of different information about you, including information that identifies \n        you as an individual or relates to an identifiable person, such as your name, contact details (including address, email address or phone number), \n        occupation, username or password, financial information (such as credit card) and information about how you use our Site, products and services \n        (“Personal Information”).")]),_vm._v(" "),_c('h5',[_vm._v("How We Collect Personal Information.")]),_vm._v(" "),_c('p',[_vm._v("We may collect your information in a number of ways, including:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Directly from you, such as where you provide information to us when you visit the Site, complete an application form, \n          register an account on the Site, contact us with a query or request or when you place an order for products or services with us.  \n          For example, if you place an order with us via the Site, we may collect your shipping, billing, and payment information. You \n          may also have the option to store credit card or other payment information to make it easier to purchase products or services \n          from the Site in the future. Another example is if you design and personalize a product, we collect information you provide to \n          customize the product, your name, contact details and professional title.")]),_vm._v(" "),_c('li',[_vm._v("From publicly available sources of information.")]),_vm._v(" "),_c('li',[_vm._v("From third parties, such as the U.S. Postal Service. We may incorporate this additional information with the existing \n          information we collect about our customers.")])]),_vm._v(" "),_c('h5',[_vm._v("How We May Use Personal Information.")]),_vm._v(" "),_c('p',[_vm._v("We may use Personal Information:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("To present the Site to you and others, including the content, features, applications, and functionalities made available \n            via the Site.")]),_vm._v(" "),_c('li',[_vm._v("To provide you with notices about your account.")]),_vm._v(" "),_c('li',[_vm._v("To fulfill our obligations and enforce our rights arising from any contracts entered into between you and us, including for \n            billing and collection.")]),_vm._v(" "),_c('li',[_vm._v("To send administrative information to you, for example, information regarding the Site and changes to our terms, conditions, \n            and policies.")]),_vm._v(" "),_c('li',[_vm._v("To provide products and services to you, to provide you with information about those products and services, to assist you with \n            enquiries or purchases, to enhance your experience on the Site or with our products, or to provide you with better customer service.")]),_vm._v(" "),_c('li',[_vm._v("To conduct analysis of our products and services, such as developing and enhancing our own offerings.")]),_vm._v(" "),_c('li',[_vm._v("For our business purposes, such as data analysis, audits, fraud monitoring and prevention, developing new products, enhancing, \n            improving or modifying our services, identifying usage trends, determining the effectiveness of our studies and promotional campaigns, \n            conducting studies and analyzing the results of studies, and operating and expanding our business activities.")]),_vm._v(" "),_c('li',[_vm._v("If we reasonably believe it is necessary or appropriate: (i) under applicable law, including laws outside your country of residence; \n            (ii) to comply with legal process; (iii) to respond to requests from public and government authorities, including public and government \n            authorities outside your country of residence; (iv) to enforce our terms and conditions; (v) to protect our operations or those of any of \n            our affiliates; (vi) to protect our rights, privacy, safety or property, and/or that of our affiliates, you or others; or (vii) to allow \n            us to pursue available remedies or limit the damages that we may sustain.")]),_vm._v(" "),_c('li',[_vm._v("In any other way we may describe when you provide the Personal Information.")]),_vm._v(" "),_c('li',[_vm._v("For any other purpose with your consent.")])]),_vm._v(" "),_c('h5',[_vm._v("How Personal Information May Be Disclosed.")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("To our employees, affiliates or third parties who provide services to us, including service providers and contractors that assist us with \n        the purposes for which we use your Personal Information. These services may include customer enquiries, mailing operations, billing and payment \n        processing functions, debt-recovery functions, manufacturers, printing functions, data analysis, shipping, auditing, web hosting, data entry and \n        services provided by professionals, such as accountants, lawyers, business advisors and consultants.")]),_vm._v(" "),_c('li',[_vm._v("For the purposes of facilitating or implementing a transfer/sale of all or part of our assets or business.")]),_vm._v(" "),_c('li',[_vm._v("To a third party in the event of any reorganization, merger, sale, joint venture, assignment, transfer or other disposition of all or any \n        portion of our business, assets or stock (including in connection with any bankruptcy or similar proceedings).")]),_vm._v(" "),_c('li',[_vm._v("To your authorized representatives or advisers, or when you ask us to do so.")]),_vm._v(" "),_c('li',[_vm._v("To third parties who assist us to manage or develop our business and corporate strategies and functions, including our corporate risk or \n        funding functions.")]),_vm._v(" "),_c('li',[_vm._v("If we reasonably believe it is necessary or appropriate: (i) under applicable law, including laws outside your country of residence; \n        (ii) to comply with legal process; (iii) to respond to requests from public and government authorities, including public and government \n        authorities outside your country of residence; (iv) to enforce our terms and conditions; (v) to protect our operations or those of any of \n        our affiliates; (vi) to protect our rights, privacy, safety or property, and/or that of our affiliates, you or others; and (vii) to allow us \n        to pursue available remedies or limit the damages that we may sustain. This includes exchanging information with other companies and organizations \n        for the purposes of fraud protection and credit risk reduction.")])]),_vm._v(" "),_c('h4',[_vm._v("OTHER INFORMATION")]),_vm._v(" "),_c('p',[_vm._v("Other Information We May Collect. “Other Information” is any information that does not reveal your specific identity or does not directly relate \n        to an identifiable individual, such as:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Browser and device information;")]),_vm._v(" "),_c('li',[_vm._v("Internet Protocol (“IP”) address;")]),_vm._v(" "),_c('li',[_vm._v("Pages visited;")]),_vm._v(" "),_c('li',[_vm._v("Average time spent on the Site;")]),_vm._v(" "),_c('li',[_vm._v("Information collected through cookies, pixel tags and other technologies; and")]),_vm._v(" "),_c('li',[_vm._v("Aggregated information.")])]),_vm._v(" "),_c('h5',[_vm._v(" How We May Collect Other Information.")]),_vm._v(" "),_c('p',[_vm._v("We may collect Other Information in a variety of ways, including:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Through your browser or device. Certain information is collected by most browsers or automatically through your device, such as your Media \n            Access Control (MAC) address, computer type (Windows or Macintosh), screen resolution, operating system name and version, device manufacturer and \n            model, language, and Internet browser type and version. We use this information to ensure that the Site and its services function properly.")]),_vm._v(" "),_c('li',[_vm._v("Through your use of the Site. When you visit the Site, we may track and collect Site usage data, such as the date and time your device \n            accessed the Site.")]),_vm._v(" "),_c('li',[_vm._v("Using cookies. Cookies are pieces of information stored directly on the computer that you are using. Cookies allow us to collect information, \n            such as browser type, time spent on the Site, pages visited, language preferences, and other website traffic data. We use the information for \n            security purposes, to facilitate navigation, and display information more effectively. We can recognize your computer to assist your use of the \n            Site.If you do not want information collected through the use of cookies, there is a simple procedure in most browsers that allows you to automatically \n            decline cookies, or be given the choice of declining or accepting the transfer to your computer of a particular cookie (or cookies) from a particular \n            site. You may also wish to refer to http://www.allaboutcookies.org/manage-cookies/index.html. However, if you do not accept these cookies, you may \n            experience some inconvenience in your use of the services. For example, we may not be able to recognize your computer, and you may need to log in every \n            time you visit the Site.")]),_vm._v(" "),_c('li',[_vm._v("Using pixel tags and other similar technologies. Pixel tags (also known as web beacons and clear GIFs) may be used in connection with the Site to, \n            among other things, track the actions of users of the Site to improve the Site and its associated services.")]),_vm._v(" "),_c('li',[_vm._v("IP Address. Your “IP Address” is a number that is automatically assigned to the computer that you are using by your Internet Service Provider (ISP). \n            An IP Address may be identified and logged automatically in our server log files whenever a user accesses the Site, along with the time of the visit and \n            the page(s) that were visited. Collecting IP Addresses is standard practice and is done automatically by many websites, applications and other services. \n            We may use IP Addresses for purposes such as calculating usage levels of the Site, helping diagnose server problems, and administering the Site and its \n            associated services.")]),_vm._v(" "),_c('li',[_vm._v("From you. Information, such as your location, as well as other information, such as your preferred means of communication, is collected when you \n            voluntarily provide this information.")]),_vm._v(" "),_c('li',[_vm._v("By aggregating information. Aggregated Personal Information does not personally identify you or any other user of the Site (for example, \n            we may aggregate Personal Information to calculate the percentage of our users who have a particular telephone area code).")])]),_vm._v(" "),_c('h5',[_vm._v("How We May Use and Disclose Other Information.")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("We may use and disclose Other Information for any lawful purpose. If we are required to treat Other Information as Personal Information under \n            applicable law, then we may use it for all the purposes for which we use and disclose Personal Information.")]),_vm._v(" "),_c('li',[_vm._v("In some instances, we may combine Other Information with Personal Information (such as by combining your name with the state in which you live). \n            If we combine any Other Information with Personal Information, the combined information will be treated by us as Personal Information as long \n            as it is combined.")])]),_vm._v(" "),_c('h4',[_vm._v("THIRD PARTY SERVICES")]),_vm._v(" "),_c('p',[_vm._v("This Privacy Policy does not address, and we are not responsible for, the privacy, information, or other practices of any third parties, \n        including our other customers or any third party operating any site or service to which the Site links to or is linked from. The inclusion of \n        a link on the Site does not imply endorsement of the linked site or service by us or by our affiliates.")]),_vm._v(" "),_c('p',[_vm._v("Our Site may contain third-party advertisements or offers that are complementary to your use of the Site. If you choose to use these separate \n        products or services, disclose information to the providers, and/or grant them permission to collect information about you, then their use of \n        your information is governed by their privacy policy. You should evaluate their practices before deciding to use their services.")]),_vm._v(" "),_c('p',[_vm._v("Our Site may use social plug-ins which are provided and operated by third-party companies, such as Facebook’s Like Button.  As a result of this, \n        you may send to the third-party company the information that you are viewing on a certain part of our Site.")]),_vm._v(" "),_c('p',[_vm._v("You may link your account on a third-party social networking site to your Brandly account. When you create this linkage, some of the information \n        you provide to us from the linking of your accounts may be published on your Brandly account profile, and your activities on the Site may be displayed \n        to your social network “contacts” on the Site or that third-party site.")]),_vm._v(" "),_c('h4',[_vm._v("SECURITY")]),_vm._v(" "),_c('p',[_vm._v("We seek to use reasonable organizational, technical and administrative measures to protect Personal Information that we maintain within our organization. \n        We also seek to use third-party service providers capable of protecting the information they maintain or process for us. Unfortunately, no data transmission \n        or storage system can be guaranteed to be fully secure.")]),_vm._v(" "),_c('p',[_vm._v("The safety and security of your information also depends on you. Where you have chosen a password for access to certain parts of our Site, you are \n        responsible for keeping this password confidential. We ask that you not share your password with anyone. If you have created an account or have logged onto \n        the Site via your social media account (such as through your Facebook account), you are responsible for maintaining the security of your login credentials \n        in accordance with the instructions and policies of the relevant social media provider.")]),_vm._v(" "),_c('p',[_vm._v("If you have reason to believe that your interaction with us is no longer secure (for example, if you feel that the security of any account you have \n        with us has been compromised), please immediately notify us of the problem by contacting us in accordance with Section ‎11 (Contacting Us) below.")]),_vm._v(" "),_c('h4',[_vm._v("DIRECT MARKETING.")]),_vm._v(" "),_c('p',[_vm._v("We may also use your Personal Information so that we can promote and market products, services and special offers that we think will be of interest \n        to you. This marketing will be carried out by email using the email address you have provided us, and may continue after you cease acquiring any products \n        or services from us until you opt-out. You may opt-out on a going-forward basis, by clicking on the “unsubscribe” link (or similar) provided in the relevant \n        marketing email. We will try to comply with your request as soon as reasonably practicable.")]),_vm._v(" "),_c('p',[_vm._v("Please also note that if you do opt-out of receiving marketing-related emails from us, we may still send you important administrative messages, and you \n        cannot opt-out from receiving administrative messages.")]),_vm._v(" "),_c('h4',[_vm._v("ACCESSING & CORRECTING YOUR PERSONAL INFORMATION.")]),_vm._v(" "),_c('p',[_vm._v("You may request access to any Personal Information we hold about you at any time by contacting us in accordance with Section ‎11 (Contacting Us) below. \n        Where we hold Personal Information that you are entitled to access, we will try to provide you with suitable means of accessing it (for example, by mailing \n        or emailing it to you). If you make an access request, we may ask you to verify your identity.")]),_vm._v(" "),_c('p',[_vm._v("There may be instances where we cannot grant you access to the Personal Information we hold. For example, we may need to refuse access if granting access \n        would interfere with the privacy of others, or if it would result in a breach of confidentiality. If that happens, we will give you reasons for any refusal.")]),_vm._v(" "),_c('p',[_vm._v("If you believe that Personal Information we hold about you is incorrect, incomplete or inaccurate, then you may request that we update it by contacting us \n        in accordance with Section ‎11 (Contacting Us) below. We will consider if the information requires updating. If we do not agree that there are grounds for \n        updating it, then we will add a note to the Personal Information stating that you disagree with it.")]),_vm._v(" "),_c('p',[_vm._v("If you are a registered user of the Site, you will generally be able to access and update your registration details online. We request that you keep \n        your information as current as possible.")]),_vm._v(" "),_c('h4',[_vm._v("YOUR CALIFORNIA PRIVACY RIGHTS")]),_vm._v(" "),_c('p',[_vm._v("Accessing Your Information. California Civil Code section 1798.83 permits users of the Site that are California residents to request certain \n        information regarding our disclosure of personal information to third parties for their direct marketing purposes. To make such a request, please \n        send an email using the contact details found in Section ‎11 (Contacting Us) below.")]),_c('p'),_c('p',[_vm._v("Do Not Track Disclosure. As we do not track you across the web, we do not respond to “Do Not Track” signals.")]),_vm._v(" "),_c('h4',[_vm._v("USE OF SERVICES BY MINORS")]),_vm._v(" "),_c('p',[_vm._v("The services are not directed to individuals under the age of eighteen (18), and we request that these individuals do not provide Personal Information \n        through the Site or its associated services.")]),_vm._v(" "),_c('h4',[_vm._v("JURISDICTION")]),_vm._v(" "),_c('p',[_vm._v("The Site is controlled and operated by us from the United States, and is not intended to subject us to the laws or jurisdiction of any state, country \n        or territory other than that of the United States. The Site may not be used in any non-U.S. jurisdiction. Your Personal Information may be stored and \n        processed in any country where we have facilities or in which we engage service providers, and by using the Site and its associated services you consent \n        to the transfer of information to countries outside of your country of the United States, which may have different data protection rules.")]),_vm._v(" "),_c('h4',[_vm._v("UPDATES TO THIS PRIVACY POLICY")]),_vm._v(" "),_c('p',[_vm._v("We may change this Privacy Policy by notifying you of such changes by any reasonable means, including by posting a revised Privacy Policy through \n        the Site, or, if we think the changes will be materially detrimental to you and we have your contact details, then by emailing you via the contact \n        details you provided us.")]),_vm._v(" "),_c('p',[_vm._v("Any changes to this Privacy Policy will become effective when we post the revised Privacy Policy on the Site.  Your use of the Site following \n        any changes to this Privacy Policy will constitute your acceptance of such changes.  The “Last Updated” legend above indicates when this Privacy \n        Policy was last changed.")]),_vm._v(" "),_c('h4',[_vm._v("CONTACTING US.")]),_vm._v(" "),_c('p',[_vm._v("If you have any questions about this Privacy Policy or if you have any privacy related concerns, please contact us at:")]),_vm._v(" "),_c('p',[_vm._v("support@brandly.com")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1OZg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"addresses"},[_vm._l((_vm.combinedAddresses.slice(0,3)),function(address){return _c('Address',{key:JSON.stringify(address),attrs:{"value":address}})}),_vm._v(" "),(_vm.combinedAddresses.length > 3)?_c('div',{staticClass:"more"},[_vm._v("..."+_vm._s(_vm.combinedAddresses.length - 3)+" more...")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1THI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_vm._l((_vm.flags),function(value,key){return _c('div',{key:key},[(key != 'voucher')?_c('label',[_c('input',{staticClass:"browser-default",attrs:{"type":"checkbox"},domProps:{"checked":_vm.flags[key]},on:{"change":function($event){return _vm.toggle(key)}}}),_vm._v("\n      "+_vm._s(key)+"\n    ")]):_vm._e()])}),_vm._v(" "),_c('label',{staticStyle:{"display":"block"}},[_vm._v("voucher: "),_c('input',{attrs:{"type":"text"},domProps:{"value":_vm.flags.voucher},on:{"input":_vm.setVoucher}})]),_vm._v(" "),(_vm.needsReload)?_c('b-button',{staticClass:"reload-btn",on:{"click":_vm.reload}},[_vm._v("Reload Page")]):_vm._e(),_vm._v(" "),_c('b-button',{attrs:{"variant":"clear"},on:{"click":_vm.resetFlags}},[_vm._v("Reset Flags")]),_vm._v(" "),(_vm.isStaff)?_c('b-button',{attrs:{"variant":"clear"},on:{"click":_vm.saveTeamFlags}},[_vm._v("Save Team Flags")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1XwJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    showSave: { default: true },
    showCancel: { default: true },
    saving: { type: Boolean },
    bottom: { type: Boolean }
  },
  methods: {
    clickCancel: function clickCancel() {
      // Provide a fake event that can be prevented using Vue's @cancel.prevent syntax
      var fakeEvent = {
        doDefault: true,
        preventDefault: function preventDefault() {
          this.doDefault = false;
        }
      };
      this.$emit('cancel', fakeEvent);
      if (fakeEvent.doDefault) this.$router.push('/dashboard/settings');
    }
  }
});

/***/ }),

/***/ "1cYv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: { noEdit: { type: Boolean } },
  data: function data() {
    return {
      isEditingTemplateName: false,
      newName: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["productTemplates", "productTemplate", "isAdmin", "flags", "userSettings"]), {
    currentTemplateId: {
      get: function get() {
        return this.productTemplate.id;
      },
      set: function set(id) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (_this.isEditingTemplateName) {
                    // "stop" editing right away, instead of waiting until save is complete
                    _this.isEditingTemplateName = false;
                    _this.acceptEdits();
                  }

                  if (!(id === '*new*')) {
                    _context.next = 7;
                    break;
                  }

                  _context.next = 4;
                  return _this.addProductTemplate();

                case 4:
                  _this.isEditingTemplateName = true;
                  _context.next = 9;
                  break;

                case 7:
                  _context.next = 9;
                  return _this.setCurrentProductTemplate(id);

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }))();
      }
    },
    showDropdown: function showDropdown() {
      return this.isAdmin && !this.noEdit;
    },
    showAddButton: function showAddButton() {
      return this.allProductTemplatesSaved && !this.noEdit;
    },
    allProductTemplatesSaved: function allProductTemplatesSaved() {
      return this.productTemplates.every(function (pt) {
        return pt.id;
      });
    },
    show: function show() {
      // This component must be enabled with a flag.
      // Also, if the user has "restrictDesign" set, and a template chosen,
      // hide the component (even from admins -- this lets admins "experience"
      // how a restricted design would appear).
      var single = this.productTemplates.length <= 1,
          restricted = this.userSettings.restrictDesign && this.productTemplate;
      if (restricted || this.noEdit && single) {
        // Hide
        return null;
      } else if (single) {
        return 'menu';
      } else {
        return 'component';
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["updateProductTemplate", "deleteProductTemplates", "setCurrentProductTemplate", "cloneProductTemplate", "addProductTemplate"]), {
    acceptEdits: function acceptEdits() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.updateProductTemplate(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this2.productTemplate, { name: _this2.newName }));

              case 2:
                _this2.newName = null;
                _this2.isEditingTemplateName = false;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    cancelEdits: function cancelEdits() {
      this.newName = null;
      this.isEditingTemplateName = false;
    },
    deleteCurrentDesign: function deleteCurrentDesign() {
      this.deleteProductTemplates();
    },
    updateDesignName: function updateDesignName(value, product_template) {
      this.newName = value;
    },
    cloneCurrentDesign: function cloneCurrentDesign() {
      this.cloneProductTemplate();
    }
  })
});

/***/ }),

/***/ "1rqv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Team_vue__ = __webpack_require__("mDBc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa0c7a56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Team_vue__ = __webpack_require__("eFRp");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Team_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa0c7a56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Team_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "22Bo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  Manager notification is "+_vm._s(_vm.state)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "26Aa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("qr test")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.url),expression:"url"}],attrs:{"size":"50"},domProps:{"value":(_vm.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.url=$event.target.value}}}),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.shorten),expression:"shorten"}],staticClass:"browser-default",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.shorten)?_vm._i(_vm.shorten,null)>-1:(_vm.shorten)},on:{"change":function($event){var $$a=_vm.shorten,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.shorten=$$a.concat([$$v]))}else{$$i>-1&&(_vm.shorten=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.shorten=$$c}}}}),_vm._v(" Shorten "+_vm._s(_vm.shorturl)),_c('br'),_vm._v("\n\n  err:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.errLevel),expression:"errLevel"}],attrs:{"size":"2"},domProps:{"value":(_vm.errLevel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.errLevel=$event.target.value}}}),_vm._v("\n  scale: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.scale),expression:"scale"}],attrs:{"type":"number"},domProps:{"value":(_vm.scale)},on:{"input":function($event){if($event.target.composing){ return; }_vm.scale=$event.target.value}}}),_vm._v("\n  margin: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.margin),expression:"margin"}],attrs:{"type":"number"},domProps:{"value":(_vm.margin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.margin=$event.target.value}}}),_vm._v("\n  dark: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dark),expression:"dark"}],attrs:{"type":"color"},domProps:{"value":(_vm.dark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dark=$event.target.value}}}),_vm._v("\n  light: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.light),expression:"light"}],attrs:{"type":"color"},domProps:{"value":(_vm.light)},on:{"input":function($event){if($event.target.composing){ return; }_vm.light=$event.target.value}}}),_c('br'),_vm._v(" "),_c('pre',[_vm._v(_vm._s(JSON.stringify(_vm.params, null, 4)))]),_vm._v("\n  "+_vm._s(_vm.dataUrl.length)+" bytes"),_c('br'),_vm._v(" "),_c('img',{attrs:{"src":_vm.dataUrl}}),_vm._v(" "),_c('br'),_vm._v("\n  "+_vm._s(_vm.svg.length)+" bytes"),_c('br'),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.svg)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2BSR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomepageWideLayout',[(_vm.user_type != 'admin')?_c('ProgressDots',{attrs:{"step":"1","steps":_vm.steps}}):_vm._e(),_vm._v(" "),_c('b-container',{staticClass:"invite-content text-center"},[_c('h1',[_vm._v("Accept Invite")]),_vm._v(" "),(_vm.user_type == 'admin')?_c('h2',[_vm._v("You have been invited"),_c('br'),_vm._v("to administer a Brandly team")]):_c('h2',[_vm._v("You have been invited"),_c('br'),_vm._v("to order business cards")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[(_vm.inviteLoaded)?_c('div',{staticClass:"signup-fieldset"},[_c('b-form-input',{staticClass:"signup-account-input",attrs:{"placeholder":"Your name","required":"required","type":"text","autofocus":"autofocus","name":"name"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),(_vm.email)?_c('b-form-input',{attrs:{"value":_vm.email,"lass":"signup-account-input","name":"email","disabled":""}}):_vm._e(),_vm._v(" "),_c('b-form-input',{staticClass:"signup-account-input",attrs:{"placeholder":"Password","required":"required","type":"password","autofocus":"autofocus","name":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('b-btn',{staticClass:"wide-btn",attrs:{"variant":"default","size":"lg"},on:{"click":_vm.submit}},[_vm._v("Accept Invite")]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()],1):_vm._e()])],1),_vm._v(" "),_c('p',{staticClass:"fineprint"},[_vm._v("See a mistake or don't want to accept the invite? Just close the window.\n    "),_c('br'),_vm._v("\n    Questions? "),_c('a',{attrs:{"href":"/contact","target":"_blank"}},[_vm._v("Contact us")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2Ikr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2O9G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2c7B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_bubble_wrapAction__ = __webpack_require__("514v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_track_events__ = __webpack_require__("Dg6a");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      inviteEmail: '',
      showJoinLink: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['heroState', 'team', 'flags'])),
  methods: {
    onClickInvite: Object(__WEBPACK_IMPORTED_MODULE_2__lib_bubble_wrapAction__["a" /* default */])({
      action: "inviteMember",
      arg: { data: "inviteEmail" },
      success: "Message has been sent!"
    }),
    onShowEmail: function onShowEmail() {
      this.showJoinLink = false;
      this.copied = false;
    },
    onShowJoinLink: function onShowJoinLink() {
      this.showJoinLink = true;
      Object(__WEBPACK_IMPORTED_MODULE_3__lib_track_events__["a" /* adminLinkShare */])('reveal');
    }
  }
});

/***/ }),

/***/ "2lRL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideMenu_vue__ = __webpack_require__("DBgY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f92311c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideMenu_vue__ = __webpack_require__("QNoD");
function injectStyle (ssrContext) {
  __webpack_require__("at1t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f92311c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f92311c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2oJl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2oW4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_integrations_sendIntercomMessage__ = __webpack_require__("HhLQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      name: "",
      email: "",
      message: ""
    };
  },

  computed: {
    formValid: function formValid() {
      return this.name && this.email && this.message;
    }
  },
  methods: {
    submit: function submit() {
      var name = this.name,
          email = this.email,
          message = this.message;

      Object(__WEBPACK_IMPORTED_MODULE_0__lib_integrations_sendIntercomMessage__["a" /* default */])(message, { name: name, email: email }, true);
    }
  }
});

/***/ }),

/***/ "2x/M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard-teamlist"}},[_c('BackButton'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-col',{staticClass:"name-col",attrs:{"sm":"11"}},[_c('h1',{class:{notset: !_vm.name}},[_vm._v(_vm._s(_vm.name|| '(no name)'))]),_vm._v(" "),_c('span',{staticClass:"role-badge"},[_vm._v(_vm._s(_vm.userRoleText()))]),_vm._v(" "),(!_vm.member.is_active)?_c('span',{staticClass:"invite-fineprint"},[_c('i',{staticClass:"fa fa-envelope"}),_vm._v(" "),_c('span',[_vm._v("Invite sent!")])]):_vm._e()]),_vm._v(" "),_c('b-col',{attrs:{"sm":"1"}},[(_vm.showActionDropdown())?_c('b-dropdown',{attrs:{"size":"sm","variant":"clear","right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fas fa-ellipsis-v"})]),_vm._v(" "),(_vm.showChangeRole())?_c('b-dropdown-item',{on:{"click":_vm.onClickChangeRole}},[_vm._v("Change role to "+_vm._s(_vm.otherRole()))]):_vm._e(),_vm._v(" "),(_vm.showRemoveFromTeam())?_c('b-dropdown-item',{on:{"click":_vm.onClickRemoveFromTeam}},[_vm._v("Remove from team")]):_vm._e(),_vm._v(" "),(_vm.showDelete())?_c('b-dropdown-item',{on:{"click":_vm.onClickDelete}},[_vm._v("Delete User")]):_vm._e(),_vm._v(" "),(_vm.showImpersonate())?_c('b-dropdown-item',{on:{"click":_vm.onClickImpersonate}},[_vm._v("Log In As "+_vm._s(_vm.member.username))]):_vm._e()],2):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"profile-and-actions"},[_c('ProfileRow',{key:_vm.member.id,staticClass:"profile",attrs:{"member-id":_vm.id}}),_vm._v(" "),_c('div',{staticClass:"actions"},[(_vm.showResend())?_c('b-button',{on:{"click":_vm.onClickResend}},[_vm._v("Resend Invite")]):_vm._e(),_vm._v(" "),(_vm.showStartOrder())?_c('StartOrderButton',{attrs:{"member":_vm.member}}):_vm._e()],1)],1),_vm._v(" "),_c('div',[_c('AdminPreferences',{key:'adminprefs'+_vm.member.id}),_vm._v(" "),_c('MemberRestrictions',{key:_vm.member.id})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "36SL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "39Xj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getCurrentTeamUsers; });
/* unused harmony export getTeam */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getTeams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return postTeamUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getUsers; });
/* unused harmony export getUser */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return team; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return updateTeam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return updateProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return updateUserProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createProductTeamTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return updateTeamProductTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return removeTeamProductTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return switchTeam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return savedCards; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deleteSavedCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addSavedCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return editSavedCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return removeUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return removeFromTeam; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defineService__ = __webpack_require__("tVbG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mungeAddress__ = __webpack_require__("RYrk");






var getCurrentTeam = Object(__WEBPACK_IMPORTED_MODULE_3__defineService__["b" /* default */])('get', 'api/v1/team/current/', { alternatives: {
    emptyTeam: '-empty' // an "empty" team -- no designs, team members, etc.
  } });

var getCurrentTeamUsers = Object(__WEBPACK_IMPORTED_MODULE_3__defineService__["b" /* default */])('get', 'api/v1/team/current/users/', { mainKey: 'results' });

var getTeam = Object(__WEBPACK_IMPORTED_MODULE_3__defineService__["b" /* default */])('get', 'api/v1/team/:id/');

var patchTeam = Object(__WEBPACK_IMPORTED_MODULE_3__defineService__["b" /* default */])('patch', 'api/v1/team/:id/');

var patchSelf = Object(__WEBPACK_IMPORTED_MODULE_3__defineService__["b" /* default */])('patch', 'api/v1/user/');

var patchUser = Object(__WEBPACK_IMPORTED_MODULE_3__defineService__["b" /* default */])('patch', 'api/v1/user/:id/');

var postTeamProductTemplate = Object(__WEBPACK_IMPORTED_MODULE_3__defineService__["b" /* default */])('post', 'api/v1/team/producttemplate/');

var patchTeamProductTemplate = Object(__WEBPACK_IMPORTED_MODULE_3__defineService__["b" /* default */])('patch', 'api/v1/team/producttemplate/:id/');

var deleteTeamProductTemplate = Object(__WEBPACK_IMPORTED_MODULE_3__defineService__["b" /* default */])('delete', 'api/v1/team/producttemplate/:id/');

var postTeamClients = Object(__WEBPACK_IMPORTED_MODULE_3__defineService__["b" /* default */])('post', 'api/v1/team/:id/clients/');

var postCurrentTeam = Object(__WEBPACK_IMPORTED_MODULE_3__defineService__["b" /* default */])('post', 'api/v1/team/current/');

var getTeams = Object(__WEBPACK_IMPORTED_MODULE_3__defineService__["b" /* default */])('get', 'api/v1/team/');

var getTeamCards = Object(__WEBPACK_IMPORTED_MODULE_3__defineService__["b" /* default */])('get', 'api/v1/team/:id/cards/', { mainKey: 'results' });

var postTeamCard = Object(__WEBPACK_IMPORTED_MODULE_3__defineService__["b" /* default */])('post', 'api/v1/team/:id/cards/');

var patchTeamCard = Object(__WEBPACK_IMPORTED_MODULE_3__defineService__["b" /* default */])('patch', 'api/v1/team/:id/cards/:card');

var deleteTeamCard = Object(__WEBPACK_IMPORTED_MODULE_3__defineService__["b" /* default */])('delete', 'api/v1/team/:id/cards/:card');

var deleteUser = Object(__WEBPACK_IMPORTED_MODULE_3__defineService__["b" /* default */])('delete', 'api/v1/user/:id/');

var deleteTeamUser = Object(__WEBPACK_IMPORTED_MODULE_3__defineService__["b" /* default */])('delete', 'api/v1/team/:id/users/:userid/');

var postTeamUser = Object(__WEBPACK_IMPORTED_MODULE_3__defineService__["b" /* default */])('post', 'api/v1/team/:id/users/');

var getUsers = Object(__WEBPACK_IMPORTED_MODULE_3__defineService__["b" /* default */])('get', 'api/v1/users/');

var getUser = Object(__WEBPACK_IMPORTED_MODULE_3__defineService__["b" /* default */])('get', 'api/v1/users/:id/');

/**
 * Return current team info. This ideally includes templates
 * and profile details.
 */
var team = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", getCurrentTeam());

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function team() {
    return _ref.apply(this, arguments);
  };
}();

var updateTeam = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(teamId, updates) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", patchTeam(teamId, Object(__WEBPACK_IMPORTED_MODULE_4__mungeAddress__["b" /* toApiAddressFormat */])(updates)));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function updateTeam(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();

var updateProfile = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(updates) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", patchSelf(updates));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function updateProfile(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

var updateUserProfile = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(userid, updates) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", patchUser(userid, updates));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function updateUserProfile(_x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();

var createProductTeamTemplate = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(data) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", postTeamProductTemplate(data));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function createProductTeamTemplate(_x6) {
    return _ref5.apply(this, arguments);
  };
}();

var updateTeamProductTemplate = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(_ref7) {
    var id = _ref7.id,
        updates = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref7, ["id"]);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", patchTeamProductTemplate(id, updates));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function updateTeamProductTemplate(_x7) {
    return _ref6.apply(this, arguments);
  };
}();

var removeTeamProductTemplate = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7(id) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", deleteTeamProductTemplate(id));

          case 1:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function removeTeamProductTemplate(_x8) {
    return _ref8.apply(this, arguments);
  };
}();

var createClient = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8(agencyTeamId, clientTeamInfo) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", postTeamClients(agencyTeamId, clientTeamInfo));

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));

  return function createClient(_x9, _x10) {
    return _ref9.apply(this, arguments);
  };
}();

var switchTeam = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9(team) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            return _context9.abrupt("return", postCurrentTeam({ team: team }));

          case 4:
            _context9.prev = 4;
            _context9.t0 = _context9["catch"](0);

            console.log(_context9.t0);

            if (!(_context9.t0.response && _context9.t0.response.data && _context9.t0.response.data.details)) {
              _context9.next = 9;
              break;
            }

            throw _context9.t0.response.data.details;

          case 9:
            throw _context9.t0;

          case 10:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, this, [[0, 4]]);
  }));

  return function switchTeam(_x11) {
    return _ref10.apply(this, arguments);
  };
}();

var savedCards = function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10(id) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            if (!(id === undefined)) {
              _context10.next = 2;
              break;
            }

            throw Error('Missing id');

          case 2:
            return _context10.abrupt("return", getTeamCards(id));

          case 3:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, this);
  }));

  return function savedCards(_x12) {
    return _ref11.apply(this, arguments);
  };
}();

var deleteSavedCard = function () {
  var _ref12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11(teamId, cardId) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt("return", deleteTeamCard(teamId, cardId));

          case 1:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, this);
  }));

  return function deleteSavedCard(_x13, _x14) {
    return _ref12.apply(this, arguments);
  };
}();

var addSavedCard = function () {
  var _ref13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12(teamId, stripe_token, title) {
    var available_to_team = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.prev = 0;
            _context12.next = 3;
            return postTeamCard(teamId, { stripe_token: stripe_token, title: title, available_to_team: available_to_team });

          case 3:
            return _context12.abrupt("return", _context12.sent);

          case 6:
            _context12.prev = 6;
            _context12.t0 = _context12["catch"](0);

            if (!(_context12.t0.response && _context12.t0.response.data && _context12.t0.response.data.error)) {
              _context12.next = 10;
              break;
            }

            throw _context12.t0.response.data.error;

          case 10:
            throw _context12.t0;

          case 11:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, this, [[0, 6]]);
  }));

  return function addSavedCard(_x15, _x16, _x17) {
    return _ref13.apply(this, arguments);
  };
}();

var editSavedCard = function () {
  var _ref14 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee13(teamId, info) {
    var id, rest;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.prev = 0;
            id = info.id, rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(info, ["id"]);
            _context13.next = 4;
            return patchTeamCard(teamId, id, rest);

          case 4:
            return _context13.abrupt("return", _context13.sent);

          case 7:
            _context13.prev = 7;
            _context13.t0 = _context13["catch"](0);

            if (!(_context13.t0.response && _context13.t0.response.data && _context13.t0.response.data.error)) {
              _context13.next = 11;
              break;
            }

            throw _context13.t0.response.data.error;

          case 11:
            throw _context13.t0;

          case 12:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, this, [[0, 7]]);
  }));

  return function editSavedCard(_x19, _x20) {
    return _ref14.apply(this, arguments);
  };
}();

var removeUser = function () {
  var _ref15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee14(id) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            return _context14.abrupt("return", deleteUser(id));

          case 1:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, this);
  }));

  return function removeUser(_x21) {
    return _ref15.apply(this, arguments);
  };
}();

var removeFromTeam = function () {
  var _ref16 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee15(team_id, user_id) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            return _context15.abrupt("return", deleteTeamUser(team_id, user_id));

          case 1:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15, this);
  }));

  return function removeFromTeam(_x22, _x23) {
    return _ref16.apply(this, arguments);
  };
}();

/***/ }),

/***/ "3Cm2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomepageWideLayout',[_c('ProgressDots',{attrs:{"step":"2","steps":_vm.steps}}),_vm._v(" "),_c('b-container',{staticClass:"text-center"},[_c('h1',[_vm._v("Hi "+_vm._s(_vm.firstName)+"!")]),_vm._v(" "),_c('h1',[_vm._v("Welcome to Brandly")]),_vm._v(" "),_c('b-form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('p',{staticClass:"form-intro"},[_vm._v("Before you place your order, please complete the following:")]),_vm._v(" "),_vm._l((_vm.personalVars),function(ref){
var key = ref.key;
var label = ref.label;
return _c('b-form-input',{key:key,staticClass:"inp",attrs:{"placeholder":'Your '+label},model:{value:(_vm.info[key]),callback:function ($$v) {_vm.$set(_vm.info, key, $$v)},expression:"info[key]"}})}),_vm._v(" "),(_vm.personalVars.address && _vm.teamAddresses !== null)?_c('div',{staticClass:"addresses"},[(_vm.address)?_c('div',{staticClass:"chosen-address"},[_c('Address',{attrs:{"value":_vm.address}}),_vm._v(" "),_c('b-button',{attrs:{"variant":"link"},on:{"click":function($event){_vm.address_id = null}}},[_vm._v("Change")])],1):(_vm.adding)?_c('div',{staticClass:"new-address"},[_vm._v("\n          Enter your address:\n          "),_c('address',[_c('b-form-input',{staticClass:"inp",attrs:{"placeholder":"Line1"},model:{value:(_vm.newAddress.line1),callback:function ($$v) {_vm.$set(_vm.newAddress, "line1", $$v)},expression:"newAddress.line1"}}),_vm._v(" "),_c('b-form-input',{staticClass:"inp",attrs:{"placeholder":"Line2"},model:{value:(_vm.newAddress.line2),callback:function ($$v) {_vm.$set(_vm.newAddress, "line2", $$v)},expression:"newAddress.line2"}}),_vm._v(" "),_c('b-form-input',{staticClass:"inp",attrs:{"placeholder":"City"},model:{value:(_vm.newAddress.city),callback:function ($$v) {_vm.$set(_vm.newAddress, "city", $$v)},expression:"newAddress.city"}}),_vm._v(" "),_c('b-form-input',{staticClass:"inp",attrs:{"placeholder":"State"},model:{value:(_vm.newAddress.state),callback:function ($$v) {_vm.$set(_vm.newAddress, "state", $$v)},expression:"newAddress.state"}}),_vm._v(" "),_c('b-form-input',{staticClass:"inp",attrs:{"placeholder":"Zip"},model:{value:(_vm.newAddress.postcode),callback:function ($$v) {_vm.$set(_vm.newAddress, "postcode", $$v)},expression:"newAddress.postcode"}})],1),_vm._v(" "),_c('b-button',{attrs:{"variant":"default","size":"lg"},on:{"click":_vm.addAddress}},[_vm._v("Done")]),_vm._v(" "),(_vm.addError)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.addError))]):_vm._e()],1):_c('div',{staticClass:"address-list"},[_vm._v("\n          Choose your address:\n          "),_vm._l((_vm.teamAddresses),function(addr){return _c('Address',{key:JSON.stringify(addr),attrs:{"value":addr},on:{"click":function($event){return _vm.chooseAddress(addr)}}})}),_vm._v(" "),_c('address',{on:{"click":_vm.startAdding}},[_vm._v("+ New Address")])],2)]):_vm._e(),_vm._v(" "),(!_vm.adding)?_c('b-button',{attrs:{"type":"submit","variant":"default","size":"lg"}},[(_vm.saving && !_vm.skip)?_c('WaveSpinner',{attrs:{"inline":"","color":"white"}}):(_vm.requireProductTemplateChoice)?_c('span',[_vm._v("Continue")]):_c('span',[_vm._v("Start Order")])],1):_vm._e(),_vm._v(" "),(!_vm.adding)?_c('b-button',{attrs:{"type":"submit","variant":"clear","size":"lg"},on:{"click":function($event){_vm.skip=true}}},[(_vm.saving && _vm.skip)?_c('WaveSpinner',{attrs:{"inline":"","color":"red"}}):_c('span',[_vm._v("Go to dashboard")])],1):_vm._e()],2),_vm._v(" "),(_vm.flags.debugTools)?_c('pre',{staticStyle:{"text-align":"left","font-size":"small","border":"3px dashed blue"},domProps:{"innerHTML":_vm._s(JSON.stringify(_vm.personalInfo, null, 4))},on:{"click":_vm.save}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3FFg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:("wistia_embed wistia_async_" + _vm.asset + " popover=true popoverAnimateThumbnail=true popoverContent=html")},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3GQm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pricing_TopPapers__ = __webpack_require__("FZ1a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pricing_PricingGrid__ = __webpack_require__("rQLO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pricing_Portal__ = __webpack_require__("n0l+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { TopPapers: __WEBPACK_IMPORTED_MODULE_0__pricing_TopPapers__["a" /* default */], PricingGrid: __WEBPACK_IMPORTED_MODULE_1__pricing_PricingGrid__["a" /* default */], Portal: __WEBPACK_IMPORTED_MODULE_2__pricing_Portal__["a" /* default */] }
});

/***/ }),

/***/ "3Jps":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"placeholder",class:{locked: _vm.locked, roundedCorners: _vm.selectedProductIsRounded}},[(!_vm.locked)?_c('PdfUploader',{attrs:{"control-style":"link","extra":{designId: _vm.designId},"allow-drag":false},on:{"upload":_vm.onUploadBack}},[_vm._v("+ back side")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3KZv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Sy+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fabric__ = __webpack_require__("tsU9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fabric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fabric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_Scaler__ = __webpack_require__("IiRJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ToolBar__ = __webpack_require__("4nLY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SideMenu__ = __webpack_require__("2lRL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FixedMenu__ = __webpack_require__("AqRf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EditorCanvas__ = __webpack_require__("RXVb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__EditorFonts__ = __webpack_require__("AE5E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EditorThumbnail__ = __webpack_require__("DLmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__EditorBackPlaceholder__ = __webpack_require__("R5BO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ImageUploadDropzone__ = __webpack_require__("56jv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__FieldOptionsArea__ = __webpack_require__("QQQE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue__ = __webpack_require__("7+uW");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loaded: false,
      fontsLoaded: false,
      from: null,
      nofill: false,
      unlock: false,

      canvasStates: [{}, {}],
      busses: [new __WEBPACK_IMPORTED_MODULE_15_vue__["default"](), new __WEBPACK_IMPORTED_MODULE_15_vue__["default"]()]
    };
  },
  mounted: function mounted() {
    var _$route$params = this.$route.params,
        id = _$route$params.id,
        from = _$route$params.from;

    this.from = from;
    this.nofill = this.$route.query.fill === 'no';
    this.unlock = this.$route.query.unlock == 'yes';
    this.setCurrentDesignId(id);
    this.loadSelectedLine({ designId: +id });
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['design', 'pageNum', 'designPageCount', 'editorMessage', 'flags', 'selectedLine', 'missingFonts', 'isTemplate', 'designOptions']), {
    currentCanvasState: function currentCanvasState() {
      return this.canvasStates[this.pageNum];
    },
    currentBus: function currentBus() {
      return this.busses[this.pageNum];
    },
    designLocked: function designLocked() {
      if (this.isTemplate || !this.designOptions || this.unlock) return false;
      return this.designOptions.lockDesign;
    },
    lockButtons: function lockButtons() {
      return this.designLocked && !this.isTemplate;
    },
    showThumbnails: function showThumbnails() {
      return this.designPageCount > 1 || !this.designLocked;
    },
    actionParams: function actionParams() {
      // Return an object describing how the "next action" should be presented.
      if (this.isTemplate) {
        return {
          variant: 'primary',
          button: 'Set Template',
          help: "When your card looks perfect, save your team's template.",
          action: 'setDesignAsTemplate',
          next: '/dashboard/' + (this.from || 'design')
        };
      } else if (this.from) {
        // Approval uses this
        return {
          variant: 'primary',
          button: 'Continue',
          help: "When your card looks perfect, continue below.",
          next: '/dashboard/' + this.from
        };
      } else if (this.selectedLine) {
        return {
          variant: 'action',
          button: 'Checkout',
          help: "When your card looks perfect, continue checking out.",
          action: 'checkout',
          next: '/cart'
        };
      } else {
        // Continue to catalog to choose a card
        return {
          variant: 'action',
          button: 'Choose Card',
          help: "When your card looks perfect, continue checking out.",
          action: 'checkout',
          next: { name: 'Catalog', query: { design: this.design.id } }
        };
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['setCurrentDesignId', 'showEditorMessage', 'loadSelectedLine', 'setDesignAsTemplate', 'invalidateDesign']), {
    onFontsLoaded: function onFontsLoaded() {
      this.fontsLoaded = true;
    },
    onFontLoadError: function onFontLoadError(e) {
      // TODO: display error
      console.error(e);
      this.fontsLoaded = true;
    },
    onDropFail: function onDropFail(_ref) {
      var droppedType = _ref.droppedType,
          allowedTypes = _ref.allowedTypes,
          allowedText = _ref.allowedText;

      console.log('drop fail', droppedType, allowedTypes, allowedText);
      this.showEditorMessage('Unable to handle dropped file type. Please upload ' + (allowedText || ' valid file'));
    },
    onCanvasState: function onCanvasState(_ref2) {
      var canvasState = _ref2.canvasState,
          pageNum = _ref2.pageNum;

      this.canvasStates.splice(pageNum, 1, canvasState);
    },
    testMessage: function testMessage() {
      this.showEditorMessage('test');
    },
    clearMessage: function clearMessage() {
      this.showEditorMessage('');
    },
    onAction: function onAction() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var action;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.currentBus) {
                  _this.currentBus.$emit('exit');
                }
                action = _this.actionParams.action;

                if (!action) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return _this[action]();

              case 5:
                _this.$router.push(_this.actionParams.next);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    checkout: function checkout() {
      // This is the only action we need to perform.
      // By invalidating the design, we avoid issues
      // where later editing doesn't re-load the design correctly.
      return this.invalidateDesign();
    }
  }),
  components: {
    ToolBar: __WEBPACK_IMPORTED_MODULE_6__ToolBar__["a" /* default */],
    SideMenu: __WEBPACK_IMPORTED_MODULE_7__SideMenu__["a" /* default */],
    FixedMenu: __WEBPACK_IMPORTED_MODULE_8__FixedMenu__["a" /* default */],
    EditorCanvas: __WEBPACK_IMPORTED_MODULE_9__EditorCanvas__["a" /* default */],
    EditorFonts: __WEBPACK_IMPORTED_MODULE_10__EditorFonts__["a" /* default */],
    EditorThumbnail: __WEBPACK_IMPORTED_MODULE_11__EditorThumbnail__["a" /* default */],
    EditorBackPlaceholder: __WEBPACK_IMPORTED_MODULE_12__EditorBackPlaceholder__["a" /* default */],
    ImageUploadDropzone: __WEBPACK_IMPORTED_MODULE_13__ImageUploadDropzone__["a" /* default */],
    FieldOptionsArea: __WEBPACK_IMPORTED_MODULE_14__FieldOptionsArea__["a" /* default */]
  }
});

/***/ }),

/***/ "3eCB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3hM4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      skip: false,
      saving: false,
      info: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.user ? this.user.personal_info : {}),
      address_id: this.user ? this.user.default_team_address : null,
      adding: false,
      addError: '',
      newAddress: {
        line1: '',
        line2: '',
        city: '',
        state: '',
        postcode: '',
        country: 'US'
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.refreshTeamAddresses();

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    user: function user(val) {
      if (!val) return;
      console.log('got user');
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(this.info, val.personal_info);
      this.address_id = this.user.default_team_address;
      this.setOrdereeId(this.user.id);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(['user', 'requireProductTemplateChoice', 'teamAddresses', 'designId', 'flags', 'personalInfo', 'personalVars', 'personalInfoSettings']), {
    firstName: function firstName() {
      return this.user && this.user.first_name;
    },
    address: function address() {
      var _this2 = this;

      if (this.address_id === null) return null;
      return this.teamAddresses.find(function (addr) {
        return addr.id === _this2.address_id;
      });
    },
    steps: function steps() {
      return this.requireProductTemplateChoice ? ['Accept invitation', 'Enter details', 'Choose Design', 'Place order'] : ['Accept invitation', 'Enter details', 'Place order'];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['updateProfile', 'refreshTeamAddresses', "startOrderFromProductTemplate", "addTeamAddress", "setOrdereeId"]), {
    startOrder: function startOrder() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    onSubmit: function onSubmit() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.saving = true;

                if (_this4.user) {
                  _context3.next = 7;
                  break;
                }

                // can't save yet, the personal_info was never loaded
                // hopefully this will resolve itself soon?
                console.log("can't save");
                // Wait a little bit so user can notice it tried
                _context3.next = 5;
                return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (r) {
                  return setTimeout(r, 150);
                });

              case 5:
                _this4.saving = false;
                return _context3.abrupt('return');

              case 7:
                _context3.next = 9;
                return _this4.updateProfile({
                  personal_info: _this4.info,
                  default_team_address: _this4.address_id
                });

              case 9:
                if (!_this4.requireProductTemplateChoice) {
                  _context3.next = 14;
                  break;
                }

                _this4.saving = false;
                _this4.$router.push('/choosedesign');
                _context3.next = 24;
                break;

              case 14:
                if (!_this4.skip) {
                  _context3.next = 18;
                  break;
                }

                _this4.$router.push('/dashboard');
                _context3.next = 24;
                break;

              case 18:
                _context3.next = 20;
                return _this4.setOrdereeId(_this4.user.id);

              case 20:
                _context3.next = 22;
                return _this4.startOrderFromProductTemplate(_this4.user.team_user_id);

              case 22:
                _this4.saving = false;
                _this4.$router.push({ name: 'Editor', params: { id: _this4.designId } });

              case 24:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    save: function save() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this5.updateProfile({ personal_info: _this5.info, default_team_address: _this5.address_id });

              case 2:
                _context4.next = 4;
                return _this5.setOrdereeId(_this5.user.id);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    chooseAddress: function chooseAddress(addr) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.address_id = addr.id;

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    startAdding: function startAdding() {
      this.adding = true;
      // Clear new address?
    },
    addAddress: function addAddress() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                // save new address
                console.log(_this7.newAddress);
                _context6.prev = 1;
                _context6.next = 4;
                return _this7.addTeamAddress(_this7.newAddress);

              case 4:
                _this7.address_id = _context6.sent;

                // TODO animate?
                _this7.adding = false;
                _context6.next = 13;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6['catch'](1);

                if (_context6.t0.response && _context6.t0.response.data) _context6.t0 = _context6.t0.response.data;
                _this7.addError = _context6.t0;
                return _context6.abrupt('return');

              case 13:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7, [[1, 8]]);
      }))();
    }
  })
});

/***/ }),

/***/ "3p2K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_orderStatus__ = __webpack_require__("FPeH");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function yes(order) {
  return true;
}
function statusFilter(status) {
  if (!status) return yes;
  return function (order) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__lib_orderStatus__["e" /* default */])(order.status) === status;
  };
}
function _ownerFilter(id) {
  return function (order) {
    return order.owner === id;
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['in', 'isBusy'],
  data: function data() {
    return {
      ownership: 'mine',
      status: null
    };
  },
  mounted: function mounted() {
    this.emit();
    if (this.user && this.user.user_type === 'admin') {
      this.ownership = 'all';
    }
  },

  watch: {
    filtered: function filtered() {
      this.emit();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['user', 'approvalEnabled']), {
    showOwnershipFilters: function showOwnershipFilters() {
      return this.user.user_type === 'admin';
    },
    showReview: function showReview() {
      // Show if feature enabled, or if someone has orders
      // to review (ie, they used to have feature enabled).
      return this.numToReview > 0 || this.approvalEnabled;
    },
    showCancelled: function showCancelled() {
      // Don't show cancelled tab, unless there are cancelled orders.
      // We don't want people solving their issues that way.
      var numCancelled = this.ownerFiltered.filter(statusFilter('cancelled')).length;
      return numCancelled > 0;
    },
    ownerFiltered: function ownerFiltered() {
      return (this.in || []).filter(this.ownerFilter());
    },
    filtered: function filtered() {
      return this.ownerFiltered.filter(statusFilter(this.status));
    },
    numToReview: function numToReview() {
      return this.ownerFiltered.filter(statusFilter('review')).length;
    },
    noMessage: function noMessage() {
      if (this.filtered.length) return;
      var s = { mine: 'You have ', all: 'Team has ' }[this.ownership];
      if (this.status === 'review') {
        s += 'no orders to review';
      } else if (this.status) {
        s += 'no ' + this.status + ' orders';
      } else {
        s += 'no orders';
      }
      return s;
    }
  }),
  methods: {
    emit: function emit() {
      this.$emit('out', this.filtered);
      if (!this.status) this.chooseStatus();
    },
    ownerFilter: function ownerFilter() {
      return this.ownership === 'mine' ? _ownerFilter(this.user.id) : yes;
    },
    chooseStatus: function chooseStatus() {
      var _this = this;

      // Find first tab where there are orders.
      // We don't expect to find no statuses, since
      // this component doesn't show in the no-order case.
      // However, just return null in that case.
      this.status = ['review', 'open', 'shipped', 'cancelled'].find(function (status) {
        return _this.filtered.some(statusFilter(status));
      });
    }
  }
});

/***/ }),

/***/ "3pLA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "45CS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChooseProduct__ = __webpack_require__("Akzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_track_events__ = __webpack_require__("Dg6a");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      uploadError: null
    };
  },

  components: { ChooseProduct: __WEBPACK_IMPORTED_MODULE_2__ChooseProduct__["a" /* default */] },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["productTemplate", "productTemplateDesignId", "flags", "isAdmin"])),
  mounted: function mounted() {
    if (!this.productTemplateDesignId) {
      this.$router.push('design/new');
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["updateProductTemplate", "deleteProductTemplates"]), {
    onError: function onError(message) {
      Object(__WEBPACK_IMPORTED_MODULE_3__lib_track_events__["c" /* designUploadError */])(message);
      this.uploadError = message;
    },
    onUpload: function onUpload() {
      Object(__WEBPACK_IMPORTED_MODULE_3__lib_track_events__["d" /* designUploadSuccess */])();
    },
    onEditTemplate: function onEditTemplate() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      console.log('onEditTemplate', args);
      this.$router.push({ name: 'Editor', params: { id: this.productTemplateDesignId } });
    },
    resetDesign: function resetDesign() {
      this.updateProductTemplate({ template: null });
    },
    deleteDesign: function deleteDesign() {
      this.deleteProductTemplates();
    }
  })
});

/***/ }),

/***/ "45O6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "46x5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProfile_vue__ = __webpack_require__("0eNg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36f68e74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProfile_vue__ = __webpack_require__("tC48");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36f68e74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "49VO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["message"],
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["impersonating", "team"]), {
    showTopBar: function showTopBar() {
      return this.impersonating;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['enterTeam']), {
    switchBack: function switchBack() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.enterTeam(_this.team.agency);

              case 2:
                console.log('switched back!');
                _this.$router.push('/admin/teams');

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  })
});

/***/ }),

/***/ "4B3K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Invite_vue__ = __webpack_require__("H7gk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d267823_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Invite_vue__ = __webpack_require__("2BSR");
function injectStyle (ssrContext) {
  __webpack_require__("5U96")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d267823"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Invite_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d267823_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Invite_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4HuA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-secondary",attrs:{"href":"https://meetings.hubspot.com/brandlysales/demo-of-brandly-portal"}},[_vm._v("SCHEDULE A DEMO")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4KwP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrdersList_vue__ = __webpack_require__("fWrj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a161ee3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrdersList_vue__ = __webpack_require__("7qa/");
function injectStyle (ssrContext) {
  __webpack_require__("OqPs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a161ee3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrdersList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a161ee3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrdersList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4OY/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditBilling_vue__ = __webpack_require__("OIVy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16943208_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditBilling_vue__ = __webpack_require__("apaE");
function injectStyle (ssrContext) {
  __webpack_require__("EWPh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16943208"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditBilling_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16943208_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditBilling_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4QOv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxes"},[(!_vm.onboardingHidden)?_c('div',{staticClass:"dashboard-box informational"},[_c('OnboardSection')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dashboard-box"},[_c('DesignSection')],1),_vm._v(" "),(_vm.showTeamSection)?_c('div',{staticClass:"dashboard-box"},[_c('TeamSection')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dashboard-box social"},[_c('ShareSection')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4UJt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomepageWideLayout',[_c('section',[_c('SecondaryHeader',[_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("Ordering methods, team management and workflows, billing options. Business-level pricing, free backside printing, free shipping.")])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',[_c('b-card-group',{staticClass:"mt-3",attrs:{"deck":""}},[_c('b-card',{staticClass:"mb-3",attrs:{"deck":"","border-variant":"secondary","header":"GETTING STARTED","header-bg-variant":"secondary","header-text-variant":"white","align":"center"}},[_c('b-card-text',[_c('ul',[_c('li',[_vm._v("One Minute onboarding")]),_vm._v(" "),_c('li',[_vm._v("On-brand custom business card template")]),_vm._v(" "),_c('li',[_vm._v("Multi-template support")])])])],1),_vm._v(" "),_c('b-card',{staticClass:"mb-3",attrs:{"deck":"","border-variant":"secondary","header":"ORDERING","header-bg-variant":"secondary","header-text-variant":"white","align":"center"}},[_c('b-card-text',[_c('ul',[_c('li',[_vm._v("Admin Ordering")]),_vm._v(" "),_c('li',[_vm._v("Employee self-ordering")]),_vm._v(" "),_c('li',[_vm._v("Profile ordering")])])])],1)],1)],1),_vm._v(" "),_c('div',[_c('b-card-group',{staticClass:"mt-3",attrs:{"deck":""}},[_c('b-card',{staticClass:"mb-3",attrs:{"deck":"","border-variant":"secondary","header":"TEAM MANAGEMENT","header-bg-variant":"secondary","header-text-variant":"white","align":"center"}},[_c('b-card-text',[_c('ul',[_c('li',[_vm._v("Spreadsheet import")]),_vm._v(" "),_c('li',[_vm._v("Add, delete, edit team member profiles manually")]),_vm._v(" "),_c('li',[_vm._v("Photo support")])])])],1),_vm._v(" "),_c('b-card',{staticClass:"mb-3",attrs:{"deck":"","border-variant":"secondary","header":"ORDER CONTROLS","header-bg-variant":"secondary","header-text-variant":"white","align":"center"}},[_c('b-card-text',[_c('ul',[_c('li',[_vm._v("Restrict quantity, paper, and template choices ")]),_vm._v(" "),_c('li',[_vm._v("Restrict editable fields within template")]),_vm._v(" "),_c('li',[_vm._v("Order Approval")])])])],1)],1)],1),_vm._v(" "),_c('div',[_c('b-card-group',{staticClass:"mt-3",attrs:{"deck":""}},[_c('b-card',{staticClass:"mb-3",attrs:{"deck":"","border-variant":"secondary","header":"PAYMENT","header-bg-variant":"secondary","header-text-variant":"white","align":"center"}},[_c('b-card-text',[_c('ul',[_c('li',[_vm._v("Indivual credit cards")]),_vm._v(" "),_c('li',[_vm._v("Team credit cards")]),_vm._v(" "),_c('li',[_vm._v("inovoice")])])])],1),_vm._v(" "),_c('b-card',{staticClass:"mb-3",attrs:{"deck":"","border-variant":"secondary","header":"MORE FEATURES","header-bg-variant":"secondary","header-text-variant":"white","align":"center"}},[_c('b-card-text',[_c('ul',[_c('li',[_vm._v("Address verification")]),_vm._v(" "),_c('li',[_vm._v("Find previous orders with \"Start order for... \" ")]),_vm._v(" "),_c('li',[_vm._v("Template and typesetting logic")])])])],1)],1)],1)]),_vm._v(" "),_c('Demo')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4dyO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadJoinTeamData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defineService__ = __webpack_require__("tVbG");




var getTeamWithToken = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('get', 'api/v1/team/:team/:token');

var loadJoinTeamData = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(team, token) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', getTeamWithToken(team, token));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function loadJoinTeamData(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ "4gAD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("Team: "+_vm._s(_vm.team.name))]),_vm._v(" "),_c('div',[_vm._v("Domain: "+_vm._s(_vm.team.domain))]),_vm._v(" "),(_vm.team.company_size)?_c('div',[_vm._v("Company Size: "+_vm._s(_vm.team.company_size))]):_vm._e(),_vm._v(" "),(_vm.team.have_design)?_c('div',[_vm._v("Have Design? "+_vm._s(_vm.team.have_design))]):_vm._e(),_vm._v(" "),(_vm.defaultRestrictions.length > 0)?_c('div',{staticClass:"default-restrictions"},[_vm._v("\n    Default Member Restrictions:\n    "),_vm._l((_vm.defaultRestrictions),function(restriction){return _c('div',{key:restriction},[_c('i',{staticClass:"fas fa-lock fa-xs",staticStyle:{"vertical-align":"10%","margin-right":"1em"}}),_vm._v(_vm._s(restriction))])})],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4gj8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4hHw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderDetail_vue__ = __webpack_require__("xHLl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53c573e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderDetail_vue__ = __webpack_require__("U3gh");
function injectStyle (ssrContext) {
  __webpack_require__("BCtc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53c573e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53c573e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4hsh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4nLY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToolBar_vue__ = __webpack_require__("LpJy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f93f0ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToolBar_vue__ = __webpack_require__("azN1");
function injectStyle (ssrContext) {
  __webpack_require__("RKWU")
  __webpack_require__("YFXu")
  __webpack_require__("czP3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f93f0ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToolBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f93f0ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToolBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4tvC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BasketItemDetail_vue__ = __webpack_require__("z7cW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9bbf4d2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BasketItemDetail_vue__ = __webpack_require__("Qo3V");
function injectStyle (ssrContext) {
  __webpack_require__("VYx4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9bbf4d2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BasketItemDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9bbf4d2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BasketItemDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4v/R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewDesign_vue__ = __webpack_require__("74Xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26b87bc9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewDesign_vue__ = __webpack_require__("s47Y");
function injectStyle (ssrContext) {
  __webpack_require__("v1OC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26b87bc9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewDesign_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26b87bc9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewDesign_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5+P3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "50UU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "514v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifyPromise__ = __webpack_require__("pXqx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__confirmPromise__ = __webpack_require__("7YyT");





/**
 * wrapAction - wrap a vuex action and trigger a notification based on success or not.
 *
 * Argument source may be from the component data `{data: 'key'}`, or
 * a getter `{getter: 'name'}`, or a function taking the component `vm => vm.foo()`
 *
 * @param {*} action -- a vuex action
 * @param {*} arg -- argument source
 */
function wrapAction(_ref) {
  var confirm = _ref.confirm,
      action = _ref.action,
      arg = _ref.arg,
      success = _ref.success,
      error = _ref.error;

  return function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(triggerEvent) {
      var value, message;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              value = resolveArg(this, arg);

              if (!confirm) {
                _context.next = 8;
                break;
              }

              message = resolveMessage(this, confirm);
              _context.next = 5;
              return Object(__WEBPACK_IMPORTED_MODULE_3__confirmPromise__["a" /* default */])(triggerEvent.path, message);

            case 5:
              if (_context.sent) {
                _context.next = 8;
                break;
              }

              console.log('action cancelled');
              return _context.abrupt("return");

            case 8:
              return _context.abrupt("return", Object(__WEBPACK_IMPORTED_MODULE_2__notifyPromise__["a" /* default */])(triggerEvent.path, resolveAction(this, action, value), success, error));

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function resolveArg(vm) {
  var arg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof arg === 'function') return arg.call(vm, vm);
  var data = arg.data,
      getter = arg.getter;

  if (data) return vm[data];
  if (getter) return vm.$store.getters[getter];
  return undefined;
}

function resolveMessage(vm, message) {
  if (typeof message === 'function') return message.call(vm, vm);
  return message;
}

function resolveAction(vm, action, value) {
  if (typeof action === 'string') {
    return vm.$store.dispatch(action, value);
  } else {
    return action.call(vm, value, vm);
  }
}

/***/ }),

/***/ "51J/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showDebugTools)?_c('b-dropdown',{staticClass:"debug-tools",attrs:{"variant":"link","size":"lg","no-caret":""}},[_c('template',{slot:"button-content"},[(_vm.loading)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_vm._l((_vm.design.pages),function(page,pageIndex){return [_c('b-dropdown-item',{key:'d'+pageIndex,attrs:{"href":'data:image/svg,'+encodeURIComponent(page.backgroundLayer.svgMarkup),"download":("design" + _vm.designId + "-bg" + pageIndex + ".svg")}},[_c('i',{staticClass:"fa fa-file"}),_vm._v("Download Page "+_vm._s(pageIndex)+" bg SVG File\n      ")]),_vm._v(" "),_c('b-dropdown-item',{key:'t'+pageIndex,attrs:{"href":'data:image/svg,'+encodeURIComponent(_vm.pageSvg[pageIndex]),"download":("design" + _vm.designId + "-text" + pageIndex + ".svg")}},[_c('i',{staticClass:"fa fa-file"}),_vm._v("Download Page "+_vm._s(pageIndex)+" text SVG File ("+_vm._s(_vm.pageSvg[pageIndex].length)+")\n      ")]),_vm._v(" "),_c('b-dropdown-form',{key:'u'+pageIndex,staticStyle:{"padding":".25rem 1.5rem"}},[_c('label',{staticStyle:{"margin":"0"}},[_c('i',{staticClass:"fa fa-file"}),_vm._v("Upload Page "+_vm._s(pageIndex)+" SVG File\n          "),_c('input',{staticStyle:{"display":"none"},attrs:{"accept":"image/svg","type":"file"},on:{"change":function($event){return _vm.uploadFile(page, $event)}}})])])]}),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":_vm.downloadProductionFile}},[(_vm.loading)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_c('i',{staticClass:"fa fa-file-o"}),_vm._v("\n      Create Production File\n    ")]),_vm._v(" "),(_vm.url)?_c('b-dropdown-item',{attrs:{"href":_vm.url,"target":"_blank"}},[_c('i',{staticClass:"fa fa-file"}),_vm._v("Download Production File\n    ")]):_vm._e(),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.unlockDesign}},[_c('i',{staticClass:"fa fa-file"}),_vm._v("Unlock design\n    ")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"target":"_blank","href":_vm.templateUrl}},[_c('i',{staticClass:"fa fa-file"}),_vm._v("View Template\n    ")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"target":"_blank","href":_vm.sourceFileUrl}},[_c('i',{staticClass:"fa fa-file"}),_vm._v("Source file\n    ")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":{ name: 'upload-list', query: { search: _vm.design.id } }}},[_c('i',{staticClass:"fas fa-arrow-right"}),_vm._v(" View uploaded file details\n    ")]),_vm._v(" "),(!_vm.isTemplate)?_c('b-dropdown-item',{on:{"click":function($event){return _vm.updateDesign(true)}}},[_c('i',{staticClass:"fa fa-file"}),_vm._v("Clone and Update design...\n    ")]):_vm._e(),_vm._v(" "),(!_vm.isTemplate)?_c('b-dropdown-item',{on:{"click":function($event){return _vm.updateDesign(false)}}},[_c('i',{staticClass:"fa fa-file"}),_vm._v("Update design in-place...\n    ")]):_vm._e()],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "52Su":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{on:{"click":_vm.goToDetail}},[_c('td',{staticClass:"product-remove"},[_c('p',{staticClass:"remove",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('remove', {line: _vm.line})}}},[_vm._v("x")])]),_vm._v(" "),_c('td',{staticClass:"product-thumbnail"},[_c('LineItemThumbnails',{attrs:{"preview_urls":_vm.line.preview_urls,"rounded":_vm.lineIsRounded}})],1),_vm._v(" "),_c('td',{staticClass:"product-name"},[_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"placement":"right","title":_vm.line.product.title}},[_vm._v("\n    "+_vm._s(_vm.line.product.title.substr(0,40) + '...')+"\n    "),_vm._v(" "),(_vm.flags.debugTools)?_c('pre',{staticStyle:{"text-align":"left","font-size":"small","border":"3px dashed blue"}},[_vm._v("ordered_for:"+_vm._s(_vm.line.ordered_for_id))]):_vm._e()])]),_vm._v(" "),_c('td',{staticClass:"product-box-size"},[_c('span',[_vm._v(_vm._s(_vm.boxSize))])]),_vm._v(" "),_c('td',{staticClass:"product-subtotal"},[_c('span',{staticClass:"amount"},[_vm._v(_vm._s(_vm.totalPrice.toFixed(2)))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "56jv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageUploadDropzone_vue__ = __webpack_require__("rof0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ac6dfe4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageUploadDropzone_vue__ = __webpack_require__("SZ9m");
function injectStyle (ssrContext) {
  __webpack_require__("mCqg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ac6dfe4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageUploadDropzone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ac6dfe4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageUploadDropzone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "58+U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-input-group',{staticClass:"searchForm"},[_c('b-form-input',{attrs:{"size":"sm","placeholder":"Search"},on:{"input":function($event){return _vm.$emit('input', _vm.search)}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('b-input-group-append',[(_vm.search)?_c('span',{on:{"click":_vm.cleanInput}},[_c('i',{staticClass:"fa fa-times search-form-clean"})]):_vm._e(),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"default"},on:{"click":_vm.onButtonClick}},[(_vm.isBusy)?_c('WaveSpinner',{attrs:{"color":"white","inline":""}}):_c('span',[_c('i',{staticClass:"fa",class:_vm.buttonIcon}),_vm._v(" "+_vm._s(_vm.buttonText)+"\n        ")])],1)],1)],1),_vm._v(" "),(_vm.helpText)?_c('small',{staticClass:"form-text text-muted search-form-text",attrs:{"tabindex":"-1"}},[_vm._v(_vm._s(_vm.helpText))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5Fl0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e2f2a7d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomepageSecondaryLayout_vue__ = __webpack_require__("Ymfd");
function injectStyle (ssrContext) {
  __webpack_require__("rKOG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e2f2a7d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e2f2a7d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomepageSecondaryLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5Lgr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadStripe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createToken; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);



var stripeAPI = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', load("pk_live_Vr5XsjDMLOqwCAAqlm8r5Tq7"));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function stripeAPI() {
    return _ref.apply(this, arguments);
  };
}();

// Setup stripe lib
var load = __webpack_require__("rh+9");

if (Object({"NODE_ENV":"production","STRIPE_KEY":"pk_live_Vr5XsjDMLOqwCAAqlm8r5Tq7","GTM_ID":"GTM-WGZN6ZH","SENTRY_DSN":"https://941bc37eccc94edb902d528ecfcd7900@sentry.io/502819","INTERCOM_APP_ID":"wq8ruy5f","LEGACY":true,"ADMIN_BUILD":false,"FILESTACK_KEY":'Alk3WMOHgRFWXlzfjOqstz',"LOGROCKET":'vrewso/brandly-com'}).STATIC_ASSETS) {
  load.version = '/static/cdn/stripe.js';
}

var loadStripe = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return stripeAPI();

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function loadStripe() {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Create a Stripe token that server will use later to auth/capture.
 * Note that dollar amount / line items are not needed here.
 *
 * @param {*} payment
 * @param {*} billing_address
 */
var createToken = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(payment, billing_address) {
    var stripe;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return stripeAPI();

          case 2:
            stripe = _context3.sent;
            return _context3.abrupt('return', stripe.card.createToken({
              number: payment.card_number,
              exp: payment.expiration,
              cvc: payment.cvc,
              name: billing_address.first_name + ' ' + billing_address.last_name,
              address_line1: billing_address.line1,
              address_line2: billing_address.line2,
              address_city: billing_address.city,
              address_state: billing_address.state,
              address_zip: billing_address.postcode,
              address_country: billing_address.country // Change to EG US?
            }));

          case 4:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function createToken(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();

/***/ }),

/***/ "5Ln6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{bottom: _vm.bottom}},[(_vm.showSave)?_c('b-button',{attrs:{"variant":"primary","type":"submit"}},[(_vm.saving)?_c('WaveSpinner',{attrs:{"inline":"","color":"white"}}):_c('span',[_vm._v("Save")])],1):_vm._e(),_vm._v(" "),(_vm.showCancel)?_c('b-button',{staticClass:"btn-secondary",on:{"click":_vm.clickCancel}},[_vm._v("Cancel")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5Mrv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-menu d-lg-none"},[_c('div',{staticClass:"fixed-menu-body"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"btn-action sidebar-purchase-link",attrs:{"to":"/cart"}},[_vm._v("Checkout "),_c('i',{staticClass:"fa fa-arrow-right"})])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-hint"},[_c('a',{attrs:{"href":"mailto:support@brandly.com"}},[_vm._v("Need help?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5U96":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5VJ3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Vav":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.impersonating)?_c('div',{attrs:{"id":"topbar"}},[_vm._v("\n    Viewing information for team\n    "),_c('b',[_vm._v(_vm._s(_vm.team.name))]),_vm._v(" "),_c('button',{on:{"click":_vm.switchBack}},[_vm._v("switch back")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5Xrs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5jPv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomepageHeroLayout_vue__ = __webpack_require__("WtRg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f4b1ce2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomepageHeroLayout_vue__ = __webpack_require__("eRel");
function injectStyle (ssrContext) {
  __webpack_require__("cqAz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f4b1ce2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomepageHeroLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f4b1ce2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomepageHeroLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5lwu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      message: '', type: ''
    };
  },

  computed: {
    state: function state() {
      // This used to return 'valid', but that no longer shows
      if (this.type == 'success') return false;
      if (this.type == 'error') return false;
      return null;
    }
  },
  methods: {
    messageReceived: function messageReceived(event) {
      console.log('messageReceived', event);
      var _event$detail = event.detail,
          message = _event$detail.message,
          type = _event$detail.type;

      this.message = message;
      this.type = type;
    },
    clearMessage: function clearMessage() {
      this.message = '';
      this.type = '';
    }
  }
});

/***/ }),

/***/ "5mjD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5uTt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-wrapper"},[_c('form',{attrs:{"accept-charset":"UTF-8","method":"post"},on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"signup-fieldset"},[_c('b-form-input',{staticClass:"signup-account-input",attrs:{"placeholder":"Your name","required":"required","type":"text","autofocus":"autofocus","name":"name"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('b-form-input',{staticClass:"signup-account-input",attrs:{"placeholder":"Your work email","required":"required","type":"email","autofocus":"autofocus","name":"email","pattern":"[^@]+@[^@]+\\.[a-zA-Z]*"},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('b-form-input',{staticClass:"signup-account-input",attrs:{"placeholder":"Password","required":"required","type":"password","autofocus":"autofocus","name":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),(_vm.loginError)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.loginErrorText))]):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"signup-account-submit",attrs:{"type":"submit","name":"commit","disabled":_vm.loginBusy || (!_vm.formValid && !_vm.formEmpty)}},[(_vm.loginBusy)?_c('span',[_vm._v("Signing Up...")]):_c('span',[_vm._t("default",[_vm._v("Sign Up for Free "),_c('i',{staticClass:"fa fa-arrow-right"})])],2)])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6/9m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',{attrs:{"id":"image-right"}},[_c('b-col',{attrs:{"sm":"13","lg":"6"}},[_c('div',{staticClass:"parent"},[_c('div',{staticClass:"copy-container"},[_c('div',{staticClass:"copy"},[_c('div',{staticClass:"eyebrow"},[_vm._v("CUSTOM QUOTE")]),_vm._v(" "),_c('h2',[_vm._v("Looking for more?")]),_vm._v(" "),_c('p',[_vm._v("Let use know what you're looking for and we'll get right back to you. Please consider including any/all of the following:")]),_vm._v(" "),_c('ul',{staticClass:"list-3"},[_c('li',{staticClass:"container-3"},[_c('div',{staticClass:"item-container-3"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"middle"},[_c('img',{attrs:{"src":"/static/images/homepage/quality.svg","alt":"icon"}}),_vm._v(" "),_c('p',{staticClass:"list-copy"},[_vm._v("High employee count")])])])])]),_vm._v(" "),_c('li',{staticClass:"container-3"},[_c('div',{staticClass:"item-container-3"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"middle"},[_c('img',{attrs:{"src":"/static/images/homepage/quality.svg","alt":"icon"}}),_vm._v(" "),_c('p',{staticClass:"list-copy"},[_vm._v("Custom requirements")])])])])]),_vm._v(" "),_c('li',{staticClass:"container-3"},[_c('div',{staticClass:"item-container-3"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"middle"},[_c('img',{attrs:{"src":"/static/images/homepage/quality.svg","alt":"icon"}}),_vm._v(" "),_c('p',{staticClass:"list-copy"},[_vm._v("Non-profit, government, education")])])])])]),_vm._v(" "),_c('li',{staticClass:"container-3"},[_c('div',{staticClass:"item-container-3"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"middle"},[_c('img',{attrs:{"src":"/static/images/homepage/quality.svg","alt":"icon"}}),_vm._v(" "),_c('p',{staticClass:"list-copy"},[_vm._v("Special stock requests")])])])])]),_vm._v(" "),_c('li',{staticClass:"container-3"},[_c('div',{staticClass:"item-container-3"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"middle"},[_c('img',{attrs:{"src":"/static/images/homepage/quality.svg","alt":"icon"}}),_vm._v(" "),_c('p',{staticClass:"list-copy"},[_vm._v("RFQ date")])])])])]),_vm._v(" "),_c('li',{staticClass:"container-3"},[_c('div',{staticClass:"item-container-3"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"middle"},[_c('img',{attrs:{"src":"/static/images/homepage/quality.svg","alt":"icon"}}),_vm._v(" "),_c('p',{staticClass:"list-copy"},[_vm._v("Billing Requirements")])])])])])])])])])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"parent",attrs:{"id":"formcontainer"}},[_c('HubspotForm',{attrs:{"portalId":"4911672","formId":"43ed682c-9c9b-4ed7-9b23-152d73b11b90"}})],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "62Q0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_productData_json__ = __webpack_require__("z3lN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_productData_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__data_productData_json__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["value", "autoselect", "slug"],
  data: function data() {
    return { selected: null };
  },
  mounted: function mounted() {
    console.log('mounted:', this.slug, this.selected);
    if (!this.selected) {
      if (this.slug) {
        // Deep link into product
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.productData.categories), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var category = _step.value;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(category.products), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var product = _step2.value;

                if (product.slug === this.slug) {
                  this.selected = product.apiName;
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
          // Replace URL
          // In the future, we should have a link for each product
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        this.$router.replace('/business-cards');
      } else if (this.autoselect) {
        // wide viewport, catalog is visible
        // auto-select first item
        this.selected = __WEBPACK_IMPORTED_MODULE_1__data_productData_json___default.a.categories[0].products[0].apiName;
      }
    }
  },

  watch: {
    product: function product(val) {
      this.$emit('input', val);
    }
  },
  computed: {
    productData: function productData() {
      return __WEBPACK_IMPORTED_MODULE_1__data_productData_json___default.a;
    },
    product: function product() {
      var _this = this;

      var result = void 0,
          prev = void 0,
          next = void 0;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.productData.categories), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var category = _step3.value;
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(category.products), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var product = _step4.value;

              if (product.apiName === this.selected) {
                product.category = category.title;
                result = product;
                continue;
              }
              if (result && !next) next = product;
              if (!result) prev = product;
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      if (result && prev) result.prev = function () {
        return _this.selected = prev.apiName;
      };
      if (result && next) result.next = function () {
        return _this.selected = next.apiName;
      };
      return result;
    }
  }
});
// $('.collapse').collapse()

/***/ }),

/***/ "68ar":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "68iR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"saved-card"},[(!_vm.hideTitle)?_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.card.title))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"icons"},[_vm._t("default")],2),_vm._v(" "),(_vm.isCardOwner)?_c('div',{staticClass:"ccard"},[_c('div',{staticClass:"card-brand"},[(_vm.card.brand == 'Visa')?_c('img',{staticClass:"svg",attrs:{"src":"/static/images/creditcards/visa.svg"}}):_vm._e(),_vm._v(" "),(_vm.card.brand == 'MasterCard')?_c('img',{staticClass:"svg",attrs:{"src":"/static/images/creditcards/mastercard.svg"}}):_vm._e(),_vm._v(" "),(_vm.card.brand == 'American Express')?_c('img',{staticClass:"svg",attrs:{"src":"/static/images/creditcards/amex.svg"}}):_vm._e(),_vm._v(" "),(_vm.card.brand == 'Discover')?_c('img',{staticClass:"svg",attrs:{"src":"/static/images/creditcards/discover.svg"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card-info"},[_c('div',{staticClass:"card-name"},[_vm._v(_vm._s(_vm.card.name))]),_vm._v(" "),_c('div',[_c('span',[_vm._v("**** **** ****")]),_vm._v(" "+_vm._s(_vm.card.last4))]),_vm._v(" "),_c('div',[_vm._v("Expires: "+_vm._s(_vm.card.exp_month)+"/"+_vm._s(_vm.card.exp_year))])])]):_c('div',[_c('small',[_vm._v("This is a shared card owned by "+_vm._s(_vm.ownerName))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6IH0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6KIs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['user', 'personalVars'])
});

/***/ }),

/***/ "6O1u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6QMR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileRow_vue__ = __webpack_require__("EpMG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e376080_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileRow_vue__ = __webpack_require__("Jla1");
function injectStyle (ssrContext) {
  __webpack_require__("4gj8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e376080"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e376080_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6TJt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return products; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defineService__ = __webpack_require__("tVbG");



var productRecommendations = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('get', 'api/v1/vendor/productrecommendation/', {
  suffixFunc: function suffixFunc(_ref) {
    var category = _ref.category;

    return category ? '-' + category : '';
  }
});

var cache = {};

/**
 * Return list of all products. Use a local cache, because the
 * API call is very slow.
 */
var products = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var cached, _ref3, results;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Note: we do not handle or anticipate multiple pages for results
            cached = cache[category];

            if (!cached) {
              _context.next = 3;
              break;
            }

            return _context.abrupt('return', cached);

          case 3:
            _context.next = 5;
            return productRecommendations({ category: category });

          case 5:
            _ref3 = _context.sent;
            results = _ref3.results;

            cache[category] = results;
            return _context.abrupt('return', results);

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function products() {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),

/***/ "6WXE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',{staticClass:"outer"},[(_vm.isAdmin)?_c('b-form-radio-group',{class:{pillbox: true, dark: _vm.dark},attrs:{"size":"sm","buttons":"","button-variant":"clear","checked":_vm.choice},on:{"input":_vm.input}},[_c('b-form-radio',{attrs:{"value":"private"}},[_c('i',{staticClass:"fas fa-user"}),_vm._v(" Private")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"shared"}},[_c('i',{staticClass:"fas fa-users"}),_vm._v(" Shared with Team")])],1):_c('small',[_c('i',{staticClass:"fas fa-user"}),_vm._v(" Your card will only be available to you")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6WY7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: Boolean,
    trueIcon: { type: String, default: 'check' },
    falseIcon: { type: String, default: 'times' },
    trueLabel: String,
    falseLabel: String
  },
  methods: {
    input: function input($event) {
      this.$emit('input', $event);
    }
  }
});

/***/ }),

/***/ "6avI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminOrderFilter_vue__ = __webpack_require__("+epG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04a41f64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminOrderFilter_vue__ = __webpack_require__("BP3H");
function injectStyle (ssrContext) {
  __webpack_require__("v3GA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminOrderFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04a41f64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminOrderFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6cos":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6e1g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05a9176c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HowItWorks_vue__ = __webpack_require__("kVJo");
function injectStyle (ssrContext) {
  __webpack_require__("pHJi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05a9176c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05a9176c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HowItWorks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "6qv1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      required: false,
      default: 'dropdown',
      note: 'Input name'
    },
    options: {
      type: Array,
      required: true,
      default: [],
      note: 'Options of dropdown. An array of options with id and name'
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Please select an option',
      note: 'Placeholder of dropdown'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
      note: 'Disable the dropdown'
    },
    maxItem: {
      type: Number,
      required: false,
      default: 20,
      note: 'Max items showing'
    },
    selectedDefault: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      },
      note: 'Initial selected value'
    }
  },
  data: function data() {
    return {
      selected: {},
      optionsShown: false,
      searchFilter: ''
    };
  },
  created: function created() {
    this.$emit('selected', this.selected);
  },

  computed: {
    filteredOptions: function filteredOptions() {
      var filtered = [];
      var regOption = new RegExp(this.searchFilter, 'ig');
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.options), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var option = _step.value;

          if (this.searchFilter.length < 1 || option.name.match(regOption)) {
            if (filtered.length < this.maxItem) filtered.push(option);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return filtered;
    }
  },
  methods: {
    selectOption: function selectOption(option) {
      this.selected = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, option);
      this.optionsShown = false;
      if (option.id) {
        this.searchFilter = this.selected.name;
      } else {
        this.searchFilter = '';
      }
      this.$emit('selected', this.selected);
    },
    showOptions: function showOptions() {
      if (!this.disabled) {
        this.searchFilter = '';
        this.optionsShown = true;
      }
    },
    exit: function exit() {
      if (!this.selected.id) {
        this.selected = {};
        this.searchFilter = '';
      } else {
        this.searchFilter = this.selected.name;
      }
      this.$emit('selected', this.selected);
      this.optionsShown = false;
    },

    // Selecting when pressing Enter
    keyMonitor: function keyMonitor(event) {
      if (event.key === "Enter" && this.filteredOptions[0]) this.selectOption(this.filteredOptions[0]);
    }
  },
  watch: {
    searchFilter: function searchFilter() {
      if (this.filteredOptions.length === 0) {
        this.selected = {};
      } else {
        this.selected = this.filteredOptions[0];
      }
      this.$emit('filter', this.searchFilter);
    },
    selectedDefault: function selectedDefault() {
      this.selectOption(this.selectedDefault);
    }
  }
});

/***/ }),

/***/ "6r+W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6uWi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Editor_vue__ = __webpack_require__("3Sy+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_357280a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Editor_vue__ = __webpack_require__("ckjT");
function injectStyle (ssrContext) {
  __webpack_require__("3KZv")
  __webpack_require__("GhAm")
  __webpack_require__("zaiM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-357280a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_357280a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6uqK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_approval__ = __webpack_require__("M78G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_checkout__ = __webpack_require__("/HXe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_approval__ = __webpack_require__("M78G");






/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    // Order loaded for viewing in orders screen
    // By default we act on this order
    order: null

    // TODO move recent orders logic here as well
  },
  mutations: {
    setOrderDetails: function setOrderDetails(state, order) {
      state.order = order;
      // TODO update any recent orders as well
    }
  },
  actions: {
    loadOrderDetails: function loadOrderDetails(_ref, id) {
      var state = _ref.state,
          dispatch = _ref.dispatch,
          commit = _ref.commit;

      // Nothing to do if order is in state already
      if (state.order && state.order.id === id) return;

      // Clear state so old data isn't shown
      commit('setOrderDetails', null);

      // Load state
      return dispatch('reloadOrderDetails', id);
    },
    reloadOrderDetails: function reloadOrderDetails(_ref2, id) {
      var _this = this;

      var state = _ref2.state,
          commit = _ref2.commit,
          dispatch = _ref2.dispatch;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var orderInfo;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_3__services_checkout__["b" /* getOrderInfo */])(id || state.order.id);

              case 2:
                orderInfo = _context.sent;

                commit('setOrderDetails', orderInfo);
                dispatch('updateRecentOrders');

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    approveOrder: function approveOrder(_ref3, payment) {
      var _this2 = this;

      var state = _ref3.state,
          dispatch = _ref3.dispatch;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var saved_card;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!state.order.needs_payment) {
                  _context2.next = 4;
                  break;
                }

                saved_card = payment.saved_card;
                _context2.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_approval__["b" /* addPayment */])(state.order.url, saved_card);

              case 4:
                _context2.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_approval__["c" /* approveOrder */])(state.order.id);

              case 6:
                return _context2.abrupt("return", dispatch('reloadOrderDetails'));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    cancelOrder: function cancelOrder(_ref4, cancellation_reason) {
      var _this3 = this;

      var state = _ref4.state,
          dispatch = _ref4.dispatch;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_approval__["d" /* cancelOrder */])(state.order.id, cancellation_reason);

              case 2:
                return _context3.abrupt("return", dispatch('reloadOrderDetails'));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    changeOrderLine: function changeOrderLine(_ref5, _ref6) {
      var _this4 = this;

      var state = _ref5.state,
          dispatch = _ref5.dispatch;
      var line = _ref6.line,
          product = _ref6.product,
          boxSize = _ref6.boxSize;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_approval__["e" /* changeLine */])(state.order.id, line, product, boxSize);

              case 2:
                return _context4.abrupt("return", dispatch('reloadOrderDetails'));

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    deleteOrderLine: function deleteOrderLine(_ref7, _ref8) {
      var _this5 = this;

      var state = _ref7.state,
          dispatch = _ref7.dispatch;
      var order = _ref8.order,
          line = _ref8.line;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!order) {
                  _context5.next = 3;
                  break;
                }

                _context5.next = 3;
                return dispatch('loadOrderDetails', order);

              case 3:
                _context5.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_approval__["h" /* deleteLine */])(state.order.id, line);

              case 5:
                return _context5.abrupt("return", dispatch('reloadOrderDetails'));

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    addOrderDiscount: function addOrderDiscount(_ref9, voucherCode) {
      var _this6 = this;

      var state = _ref9.state,
          dispatch = _ref9.dispatch;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_approval__["a" /* addDiscount */])(state.order.id, voucherCode);

              case 2:
                return _context6.abrupt("return", dispatch('reloadOrderDetails'));

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    cloneForResend: function cloneForResend(_ref10, _ref11) {
      var _this7 = this;

      var commit = _ref10.commit;
      var order = _ref11.order,
          lines = _ref11.lines;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var newOrder;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_approval__["g" /* cloneForResend */])({ source: order, lines: lines });

              case 2:
                newOrder = _context7.sent;
                return _context7.abrupt("return", commit('setOrderDetails', newOrder));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    changeShippingMethod: function changeShippingMethod(_ref12, _ref13) {
      var _this8 = this;

      var dispatch = _ref12.dispatch,
          state = _ref12.state;
      var order = _ref13.order,
          shipping_method = _ref13.shipping_method;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!order) order = state.order.id;
                _context8.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_approval__["f" /* changeShippingMethod */])(order, shipping_method);

              case 3:
                return _context8.abrupt("return", dispatch('reloadOrderDetails', order));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    loadApprovers: function loadApprovers(_ref14) {
      var dispatch = _ref14.dispatch;

      return dispatch('loadTeamMembers');
    }
  },
  getters: {
    // TODO use local state
    // This re-uses the "last order stuff"
    orderDetails: function orderDetails(state) {
      return state.order;
    },
    approvers: function approvers(state, getters) {
      return getters.members.filter(function (m) {
        return m.user_type == 'admin';
      }).map(function (m) {
        return { name: m.first_name + " " + m.last_name, email: m.email };
      });
    }
  }
});

/***/ }),

/***/ "74Xh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_selectedProduct__ = __webpack_require__("D3mI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__upload_UploaderBox_vue__ = __webpack_require__("ejR0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__upload_SideMenu_vue__ = __webpack_require__("MGPA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__upload_FixedMenu_vue__ = __webpack_require__("xIwb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_track_events__ = __webpack_require__("Dg6a");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: { UploaderBox: __WEBPACK_IMPORTED_MODULE_5__upload_UploaderBox_vue__["a" /* default */], SideMenu: __WEBPACK_IMPORTED_MODULE_6__upload_SideMenu_vue__["a" /* default */], FixedMenu: __WEBPACK_IMPORTED_MODULE_7__upload_FixedMenu_vue__["a" /* default */] },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // TODO determine context
              Object(__WEBPACK_IMPORTED_MODULE_8__lib_track_events__["e" /* designUploadVisited */])(_this.context);

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['productTemplateDesignId', 'hasMultipleProductTemplates']), {
    context: function context() {
      return this.productTemplateDesignId ? 're-upload' : this.hasMultipleProductTemplates ? 'add-design' : 'new-design';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['setDesign']), {
    onUpload: function onUpload(event) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var design;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                Object(__WEBPACK_IMPORTED_MODULE_8__lib_track_events__["d" /* designUploadSuccess */])();
                event.preventDefault();
                design = event.design;

                _this2.setDesign(design);
                return _context2.abrupt('return', _this2.$router.push({ name: 'Editor', params: { id: design.id } }));

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    onError: function onError(event) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                Object(__WEBPACK_IMPORTED_MODULE_8__lib_track_events__["c" /* designUploadError */])(event);

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  })
});

/***/ }),

/***/ "77kB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer",class:{portrait: _vm.portrait, one: _vm.one, two: _vm.two, rounded: _vm.rounded, imgBorder: _vm.imgBorder}},[_c('div',{staticClass:"previews"},[_c('img',{attrs:{"src":_vm.previewUrls[0]},on:{"load":_vm.imgLoad}}),_vm._v(" "),(_vm.previewUrls[1])?_c('img',{attrs:{"src":_vm.previewUrls[1]}}):_vm._e()]),_vm._v(" "),(_vm.editButton)?_c('div',{staticClass:"button-holder"},[_c('button',{staticClass:"btn edit-design",on:{"click":function($event){return _vm.$emit('edit')}}},[_c('i',{staticClass:"far fa-edit"}),_vm._v(" Edit Design")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7C3i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Jaz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamMembersImport_vue__ = __webpack_require__("FaP6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25d34279_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeamMembersImport_vue__ = __webpack_require__("rcKs");
function injectStyle (ssrContext) {
  __webpack_require__("t3BV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25d34279"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamMembersImport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25d34279_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeamMembersImport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7OeA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReturningCustomerLogin_vue__ = __webpack_require__("CuTT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3babc21a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReturningCustomerLogin_vue__ = __webpack_require__("HuOx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReturningCustomerLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3babc21a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReturningCustomerLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7Rgv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7SH7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  "+_vm._s(_vm.orderReviewMessage)+"\n  "),(_vm.value)?_c('div',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.dontSkipReview($event)}}},[_vm._v("[Re-enable review]")])]):(_vm.allowSkipApproval)?_c('div',[_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.bottom",modifiers:{"hover":true,"bottom":true}}],attrs:{"title":"Skip review process for this order. Shown because you are an admin.","href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.skipReview($event)}}},[_vm._v("[Skip review]")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7YyT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = confirmPromise;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/**
 * confirmPromise - send custom confirm event that allows deeply nested components
 * to request confirmation on an action.
 *
 *
 * @param {*} message -- confirmation text
 * @returns {*} promise -- resolves with true/false
 */
function confirmPromise(path, message) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (confirm) {
    var detail = { message: message, confirm: confirm };
    var target = path.find(function (d) {
      return d.isConnected;
    });
    var event = new CustomEvent('confirmation', { detail: detail, bubbles: true, cancelable: true });
    console.log('dispatching', event, '->', target);
    if (target.dispatchEvent(event)) {
      // event not prevented, default to confirming using built-in
      confirm(window.confirm(message));
    }
  });
}

/***/ }),

/***/ "7bmB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-summary-wrapper"},[_c('h3',{staticClass:"title"},[_vm._v("Order Summary")]),_vm._v(" "),_c('div',{staticClass:"order-summary-container"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table cart-table review-order-table"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.orderLines),function(line,index){return _c('tr',{key:index,staticClass:"item"},[_c('td',{staticClass:"product-name"},[_c('span',[_vm._v(_vm._s(line.boxSize))]),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":line.product.title}},[_vm._v(_vm._s(line.product.title.substr(0, 40))+"...\n              ")])]),_vm._v(" "),_c('td',{staticClass:"product-total"},[_c('Currency',{attrs:{"amount":line.price_incl_tax}})],1)])}),0),_vm._v(" "),_c('tfoot',[_c('tr',{staticClass:"cart-subtotal"},[_c('th',{attrs:{"id":"left"}},[_vm._v("Subtotal")]),_vm._v(" "),_c('td',[_c('Currency',{attrs:{"amount":_vm.subtotalPrice}})],1)]),_vm._v(" "),_c('tr',{staticClass:"shipping"},[_c('th',[_vm._v("Shipping")]),_vm._v(" "),_c('td',[(_vm.isUSA)?_c('Currency',{attrs:{"amount":_vm.shipAmount}}):_c('span',{attrs:{"title":"As Quoted"}},[_vm._v("AQ")])],1)]),_vm._v(" "),_c('tr',{staticClass:"tax"},[_c('th',[_vm._v("Tax")]),_vm._v(" "),_c('td',[_c('Currency',{attrs:{"amount":_vm.taxAmount}})],1)]),_vm._v(" "),_c('tr',{staticClass:"order-total"},[_c('th',[_vm._v("Total")]),_vm._v(" "),_c('td',[_c('strong',[_c('Currency',{attrs:{"amount":_vm.totalPrice}})],1)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"product-name",attrs:{"width":"70%"}},[_vm._v("Product")]),_vm._v(" "),_c('th',{staticClass:"product-total"},[_vm._v("Total")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7e19":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7jUO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: { value: Boolean, dark: Boolean },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['user', 'isAdmin']), {
    choice: function choice() {
      return this.value ? 'private' : 'shared';
    }
  }),
  methods: {
    input: function input($event) {
      this.$emit('input', $event === 'private');
    }
  }
});

/***/ }),

/***/ "7jZB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

var downloaded = false;
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['asset', 'autoplay'],
  created: function created() {
    if (this.autoplay) {
      //note: popoverShowOnLoad didn't work
      window._wq = window._wq || [];
      window._wq.push({
        id: this.asset,
        onReady: function onReady(video) {
          video.popover.show();
          video.play();
        }
      });
    }
    if (!downloaded) {
      this.addScript('//fast.wistia.com/embed/medias/' + this.asset + '.jsonp');
      this.addScript("//fast.wistia.com/assets/external/E-v1.js");
      downloaded = true;
    }
  },

  methods: {
    addScript: function addScript(src, onload) {
      var node = document.createElement('script');
      node.setAttribute('src', src);
      node.setAttribute('async', '');
      if (onload) node.onload = onload;
      document.head.appendChild(node);
    }
  }
});

/***/ }),

/***/ "7puy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_design__ = __webpack_require__("VFA2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flatten__ = __webpack_require__("6YxY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_webfontloader__ = __webpack_require__("01M/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_webfontloader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_webfontloader__);


//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["design"],
  data: function data() {
    return { fontCss: '', fontLoading: null };
  },

  computed: {
    designId: function designId() {
      return this.design && this.design.id;
    },
    fonts: function fonts() {
      return this.design && __WEBPACK_IMPORTED_MODULE_3_flatten___default()(this.design.fonts);
    }
  },
  watch: {
    designId: function designId(val) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.requestFonts();

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fonts: function fonts(val) {
      this.lookForFonts();
    }
  },
  methods: {
    requestFonts: function requestFonts() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('requestFonts');

                if (_this2.design) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return', console.log('No designId'));

              case 3:
                ;
                _context2.prev = 4;
                _context2.next = 7;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_design__["c" /* getFonts */])(_this2.designId);

              case 7:
                result = _context2.sent;

                _this2.fontCss = '<style>' + result + '</style>';
                _context2.next = 15;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](4);

                console.error('font-load-error:', _context2.t0);
                _this2.$emit('font-load-error', _context2.t0);

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[4, 11]]);
      }))();
    },
    lookForFonts: function lookForFonts() {
      var _this3 = this;

      console.log('lookForFonts', this.fonts);
      if (!this.design) return;

      // Time out in 1.5 seconds. This is a short time, but the user (currently)
      // sees a blank screen when loading for those 1.5 seconds. It will be expected
      // for this to fire, and then the fonts-loaded to fire.
      this.fontLoading = setTimeout(function () {
        return _this3.$emit('font-load-error', 'timeout');
      }, 1500);

      __WEBPACK_IMPORTED_MODULE_4_webfontloader___default.a.load({
        custom: {
          families: this.fonts
        },
        active: function active() {
          clearTimeout(_this3.fontLoading);
          _this3.$emit('fonts-loaded');
        }
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this4.requestFonts();

            case 2:
              _context3.next = 4;
              return _this4.lookForFonts();

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  }
});

/***/ }),

/***/ "7qa/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"md":"6","lg":"5"}},[_c('h1',[_vm._v("Recent Orders")])]),_vm._v(" "),(_vm.showSearchForm())?_c('b-col',{staticClass:"pb-md-0 pb-5",attrs:{"md":"6","lg":"7"}},[_c('SearchForm',{attrs:{"search-text-default":_vm.search},on:{"input":_vm.onSearchTermChange}})],1):_vm._e()],1),_vm._v(" "),_c('b-row',[(_vm.isStaffDashboard)?_c('AdminOrderFilter',{attrs:{"status-initial":_vm.filterInitialStatus},on:{"input":_vm.onStatusChange}}):_c('OrderFilter',{attrs:{"in":_vm.recentOrders,"is-busy":_vm.recentOrdersBusy},on:{"out":_vm.onStatusChange}})],1),_vm._v(" "),(_vm.isStaffDashboard)?_c('ItemsOnPageSelect',{attrs:{"items-on-page-default":_vm.itemsOnPage,"on-select-change":_vm.onItemsOnPageChange,"options":_vm.itemsOnPageOptions}}):_vm._e(),_vm._v(" "),_vm._l((_vm.orderListToShow),function(order){return _c('OrderDetailCommon',{key:order.id,attrs:{"order":order,"id":order.id,"is-back-button-shown":false},scopedSlots:_vm._u([{key:"shipping",fn:function(ref){
var order = ref.order;
return _c('div',{},[_vm._t("shipping",null,{"order":order})],2)}},{key:"actions",fn:function(ref){
var order = ref.order;
return _c('div',{},[_vm._t("actions",null,{"order":order})],2)}},{key:"line-actions",fn:function(ref){
var order = ref.order;
var line = ref.line;
return _c('div',{},[_vm._t("line-actions",null,{"order":order,"line":line})],2)}}],null,true)})}),_vm._v(" "),(_vm.isStaffDashboard)?[(!this.recentOrders)?_c('article',{staticClass:"order no-orders"},[(_vm.recentOrdersBusy)?_c('WaveSpinner'):_c('span',[(_vm.statusSelected)?_c('span',[_vm._v("No orders with status \""+_vm._s(_vm.statusSelected)+"\" found")]):_c('span',[_vm._v("No orders found")])])],1):_vm._e(),_vm._v(" "),_c('Pagination',{attrs:{"current-page":_vm.pageNumberOrders || 1,"total-items":_vm.totalOrders || 0,"items-on-page":_vm.itemsOnPage,"on-page-number-change":_vm.onPageNumberChange}})]:[(!_vm.orderList.length)?_c('article',{staticClass:"order no-orders"},[(_vm.recentOrdersBusy)?_c('WaveSpinner'):(_vm.orderListFiltered.length)?_c('span',[_vm._v("No orders found")]):_vm._e()],1):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7qho":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SavedCard_vue__ = __webpack_require__("GTfq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0aa6370_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SavedCard_vue__ = __webpack_require__("68iR");
function injectStyle (ssrContext) {
  __webpack_require__("Uvhn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e0aa6370"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SavedCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0aa6370_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SavedCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7sms":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomepageWideLayout',[_c('SignUpProgress',{attrs:{"step":"2"}}),_vm._v(" "),_c('b-container',{staticClass:"text-center"},[_c('h1',[_vm._v("Hi "+_vm._s(_vm.firstName)+"!")]),_vm._v(" "),_c('b-form',{staticClass:"form text-left",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[(!_vm.notification)?_c('p',{staticClass:"form-intro"},[_vm._v("To get the most out of your account please complete the following:")]):_c('b-alert',{attrs:{"show":"","variant":_vm.notification.type}},[_vm._v(_vm._s(_vm.notification.message))]),_vm._v(" "),_c('div',{class:{error: _vm.errors.first('name')}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"inp",attrs:{"name":"name","placeholder":"Your Company's Name"},model:{value:(_vm.teamUpdates.name),callback:function ($$v) {_vm.$set(_vm.teamUpdates, "name", $$v)},expression:"teamUpdates.name"}})],1),_vm._v(" "),(_vm.needsDomain)?_c('div',{class:{error: _vm.errors.first('domain')}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"inp",attrs:{"name":"domain","placeholder":"Your Company's Website"},model:{value:(_vm.teamUpdates.domain),callback:function ($$v) {_vm.$set(_vm.teamUpdates, "domain", $$v)},expression:"teamUpdates.domain"}})],1):_vm._e(),_vm._v(" "),_c('div',{class:{error: _vm.errors.first('company_size')}},[_c('b-form-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"inp",class:{placeholder: !_vm.teamUpdates.company_size},attrs:{"name":"company_size"},model:{value:(_vm.teamUpdates.company_size),callback:function ($$v) {_vm.$set(_vm.teamUpdates, "company_size", $$v)},expression:"teamUpdates.company_size"}},[_c('option',{domProps:{"value":null}},[_vm._v("Your Company Size")]),_vm._v(" "),_c('option',[_vm._v("1 or 2")]),_vm._v(" "),_c('option',[_vm._v("3+")]),_vm._v(" "),_c('option',[_vm._v("10+")]),_vm._v(" "),_c('option',[_vm._v("30+")]),_vm._v(" "),_c('option',[_vm._v("100+")])])],1),_vm._v(" "),_c('div',{class:{error: _vm.errors.first('job_role')}},[_c('b-form-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"inp",class:{placeholder: !_vm.profileUpdates.job_role},attrs:{"name":"job_role"},model:{value:(_vm.profileUpdates.job_role),callback:function ($$v) {_vm.$set(_vm.profileUpdates, "job_role", $$v)},expression:"profileUpdates.job_role"}},[_c('option',{domProps:{"value":null}},[_vm._v("Your Job Role")]),_vm._v(" "),_c('option',[_vm._v("Owner/Founder")]),_vm._v(" "),_c('option',[_vm._v("Office Manager/Admin")]),_vm._v(" "),_c('option',[_vm._v("Designer")]),_vm._v(" "),_c('option',[_vm._v("Marketing")]),_vm._v(" "),_c('option',[_vm._v("HR")]),_vm._v(" "),_c('option',[_vm._v("Sales")]),_vm._v(" "),_c('option',[_vm._v("Other")])])],1),_vm._v(" "),_c('div',{class:{error: _vm.errors.first('haveDesign')}},[_c('div',{staticClass:"have-design"},[_c('label',[_vm._v("Do you have a business card design?")]),_vm._v(" "),_c('b-form-radio-group',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"text-center",attrs:{"id":"haveDesign","name":"haveDesign","options":[{text:'Yes', value:'yes'}, {text:'No', value: 'no'}]},model:{value:(_vm.teamUpdates.have_design),callback:function ($$v) {_vm.$set(_vm.teamUpdates, "have_design", $$v)},expression:"teamUpdates.have_design"}})],1)]),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","variant":_vm.buttonVariant,"disabled":_vm.buttonDisabled,"size":"lg"}},[(_vm.saving)?_c('WaveSpinner',{attrs:{"inline":"","color":"white"}}):_c('span',[_vm._v("Done")])],1),_vm._v(" "),(_vm.flags.debugTools)?_c('pre',{staticStyle:{"text-align":"left","font-size":"small","border":"3px dashed blue"}},[_vm._v(_vm._s(JSON.stringify(_vm.errors, null, 4)))]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7xHn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_414a33e3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandlyApp_vue__ = __webpack_require__("yVEb");
function injectStyle (ssrContext) {
  __webpack_require__("Qd5V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-414a33e3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_414a33e3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandlyApp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8+In":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "81Jc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "82B1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"div",on:{"confirmation":_vm.confirmationReceived,"notification":_vm.messageReceived}},[(_vm.show)?_c('b-alert',{attrs:{"show":"","variant":_vm.variant,"dismissible":!_vm.confirming},on:{"dismiss":_vm.clearMessage}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n    "),(_vm.confirming)?_c('span',{staticClass:"buttons"},[_c('b-button',{attrs:{"size":"sm","variant":"success"},on:{"click":_vm.onConfirm}},[_vm._v("Ok")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.onCancel}},[_vm._v("Cancel")])],1):_vm._e()]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "83za":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dlFontUrl;
function dlFontUrl(font) {
  return {"API":"https://www.brandly.com/backend/","APP":"https://www.brandly.com","STATIC":false}.API + 'fonts/dl/' + font;
}

/***/ }),

/***/ "8ARW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{domProps:{"innerHTML":_vm._s(_vm.fontCss)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8JM6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    headline: { type: String, default: 'Headline goes here' },
    subtitle: { type: String, default: 'Subtitle goes here.' }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["loginError"]), {
    hasIntercom: function hasIntercom() {
      console.log('hasIntercom', window.Intercom);
      return !!window.Intercom;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["socialAuth"]), {
    onGoogleLogin: function onGoogleLogin(userinfo) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("google user:", userinfo);
                _context.next = 3;
                return _this.socialAuth({
                  provider: "google",
                  access_token: userinfo.auth.access_token
                });

              case 3:
                _this.redirect();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    onFacebookLogin: function onFacebookLogin() {
      // not implemented

      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    onLinkedInLogin: function onLinkedInLogin(info) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log("linkedin info:", info);
                _context3.next = 3;
                return _this3.socialAuth(info);

              case 3:
                _this3.redirect();

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    redirect: function redirect() {
      if (!this.loginError) this.$router.push("/dashboard");
    },
    openIntercom: function openIntercom(event) {
      if (window.Intercom) {
        event.preventDefault();
        Intercom("showNewMessage", "");
      }
    }
  })
});

/***/ }),

/***/ "8M+/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUpForm_vue__ = __webpack_require__("bMIv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cf12b7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUpForm_vue__ = __webpack_require__("5uTt");
function injectStyle (ssrContext) {
  __webpack_require__("ikt8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1cf12b7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUpForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cf12b7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUpForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8N8U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-summary-wrapper"},[_c('h3',{staticClass:"title"},[_vm._v("Order Summary")]),_vm._v(" "),_c('div',{staticClass:"order-summary-container"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table cart-table review-order-table"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.basketLines),function(line,index){return _c('tr',{key:index,staticClass:"item"},[_c('td',{staticClass:"product-name"},[_c('span',[_vm._v(_vm._s(line.boxSize))]),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":line.product.title}},[_vm._v(_vm._s(line.product.title.substr(0, 40))+"...\n              ")])]),_vm._v(" "),_c('td',{staticClass:"product-total"},[_c('Currency',{attrs:{"amount":line.price_incl_tax}})],1)])}),0),_vm._v(" "),_c('tfoot',[_c('tr',{staticClass:"cart-subtotal"},[_c('th',{attrs:{"id":"left"}},[_vm._v("Subtotal")]),_vm._v(" "),_c('td',[_c('Currency',{attrs:{"amount":_vm.subtotalPrice}})],1)]),_vm._v(" "),_c('tr',{staticClass:"shipping"},[_c('th',[_vm._v("Shipping")]),_vm._v(" "),_c('td',[(_vm.isShippingCountryUSA)?_c('Currency',{attrs:{"amount":_vm.shipAmount}}):_c('span',{attrs:{"title":"As Quoted"}},[_vm._v("AQ")])],1)]),_vm._v(" "),_c('tr',{staticClass:"tax"},[_c('th',[_vm._v("Tax")]),_vm._v(" "),_c('td',[_c('Currency',{attrs:{"amount":_vm.taxAmount}})],1)]),_vm._v(" "),_c('tr',{staticClass:"order-total"},[_c('th',[_vm._v("Total")]),_vm._v(" "),_c('td',[_c('strong',[_c('Currency',{attrs:{"amount":_vm.totalPrice}})],1)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"product-name",attrs:{"width":"70%"}},[_vm._v("Product")]),_vm._v(" "),_c('th',{staticClass:"product-total"},[_vm._v("Total")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8RFy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return { ready: true };
  },
  mounted: function mounted() {
    var _this = this;

    window.onOauth = function (provider, _ref) {
      var code = _ref.code;

      _this.$emit('login', { provider: provider, code: code });
    };
  },
  beforeDestroy: function beforeDestroy() {
    delete window.onOauth;
  },

  methods: {
    onClick: function onClick() {
      var base = 'https://www.linkedin.com/oauth/v2/authorization';
      var params = {
        response_type: 'code',
        client_id: '86em1vwv504o9r',
        redirect_uri: window.location.origin + '/oauth/linkedin',
        state: '987654321', // we don't check this so no point making it random
        scope: 'r_basicprofile r_emailaddress'
      };
      var url = base + '?' + Object(__WEBPACK_IMPORTED_MODULE_0_qs__["stringify"])(params);
      window.open(url, 'linkedinAuth', 'width=600,height=400');
    }
  }
});

/***/ }),

/***/ "8cOd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_CheckoutLogic__ = __webpack_require__("KrFv");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['orderLines', 'orderInfo']), {
    shipAmount: function shipAmount() {
      return this.orderInfo.details.shipping_incl_tax;
    },
    taxAmount: function taxAmount() {
      var _orderInfo$details = this.orderInfo.details,
          total_incl_tax = _orderInfo$details.total_incl_tax,
          total_excl_tax = _orderInfo$details.total_excl_tax;

      return total_incl_tax - total_excl_tax;
    },
    totalPrice: function totalPrice() {
      var total_incl_tax = this.orderInfo.details.total_incl_tax;

      return total_incl_tax;
    },
    subtotalPrice: function subtotalPrice() {
      return this.orderLines.reduce(function (sum, lineItem) {
        return sum + parseFloat(lineItem.price_excl_tax, 10);
      }, 0);
    },
    isUSA: function isUSA() {
      return Object(__WEBPACK_IMPORTED_MODULE_2__lib_CheckoutLogic__["g" /* isUSA */])(this.orderInfo.details.shipping_address.country);
    }
  })
});

/***/ }),

/***/ "8dWM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Basket_vue__ = __webpack_require__("0LIU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f3ee023_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Basket_vue__ = __webpack_require__("+4XM");
function injectStyle (ssrContext) {
  __webpack_require__("MywT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f3ee023"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Basket_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f3ee023_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Basket_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8dmq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8eHU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_069488b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__ = __webpack_require__("bnxi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_069488b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8fPy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderFilter_vue__ = __webpack_require__("3p2K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_383a60a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderFilter_vue__ = __webpack_require__("gjI5");
function injectStyle (ssrContext) {
  __webpack_require__("dVfd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_383a60a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8uSK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUp_vue__ = __webpack_require__("Y8rI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3acf3329_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__ = __webpack_require__("9V7W");
function injectStyle (ssrContext) {
  __webpack_require__("T9qD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3acf3329"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3acf3329_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8woP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      saving: false,
      form: {}
    };
  },
  mounted: function mounted() {
    this.form = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
      approvalMode: null

    }, this.approvalSettings);
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['approvalSettings'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['updateTeam']), {
    save: function save() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.saving = true;
                _context.next = 3;
                return _this.updateTeam({ approval_settings: _this.form });

              case 3:
                _this.saving = false;
                _this.$router.push('/dashboard/settings');

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  })
});

/***/ }),

/***/ "8yyd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment-wrapper no-label-css"},[_c('h3',[_vm._v("Payment")]),_vm._v(" "),(_vm.savedCardsLoaded || !_vm.loggedIn)?_c('div',{staticClass:"payment-box"},[(_vm.savedCardsLoaded)?_c('b-form-group',{attrs:{"label":"Payment Method"}},[_c('b-form-select',{attrs:{"options":_vm.savedCardOptions},model:{value:(_vm.form.saved_card),callback:function ($$v) {_vm.$set(_vm.form, "saved_card", $$v)},expression:"form.saved_card"}},[_c('option',{domProps:{"value":null}},[_vm._v("Add New card...")])])],1):_vm._e(),_vm._v(" "),(!_vm.form.saved_card)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"required"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.card_number),expression:"form.card_number"},{name:"validate",rawName:"v-validate",value:('required|credit_card'),expression:"'required|credit_card'"}],staticClass:"form-control",attrs:{"id":"card_number","type":"text","placeholder":"Credit Card Number","required":""},domProps:{"value":(_vm.form.card_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "card_number", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_c('svg',{staticClass:"icon icon-lock"},[_c('use',{attrs:{"xlink:href":"#icon-lock"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-md-4"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"required"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.expiration),expression:"form.expiration"},{name:"validate",rawName:"v-validate",value:('required|date_format:MM/YY'),expression:"'required|date_format:MM/YY'"}],staticClass:"form-control",attrs:{"type":"text","id":"expiration","placeholder":"MM/YY","required":""},domProps:{"value":(_vm.form.expiration)},on:{"blur":_vm.fixExpiration,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "expiration", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"required"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.cvc),expression:"form.cvc"},{name:"validate",rawName:"v-validate",value:({ required: true, regex: /^\d{3}(\d{1})?$/ }),expression:"{ required: true, regex: /^\\d{3}(\\d{1})?$/ }"}],staticClass:"form-control",attrs:{"type":"text","id":"cvc","placeholder":"CVC","data-stripe":"cvc","required":""},domProps:{"value":(_vm.form.cvc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "cvc", $event.target.value)}}})])])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),(_vm.allowSave)?_c('div',[_c('b-checkbox',{model:{value:(_vm.form.save_card),callback:function ($$v) {_vm.$set(_vm.form, "save_card", $$v)},expression:"form.save_card"}},[_vm._v("Save card for future use")]),_vm._v(" "),(_vm.form.save_card)?_c('div',[_c('div',{staticClass:"required"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.title),expression:"form.title"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"id":"title","type":"text","placeholder":"Description of card","required":""},domProps:{"value":(_vm.form.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "title", $event.target.value)}}})]),_vm._v(" "),_c('PrivateToggle',{attrs:{"dark":""},model:{value:(_vm.form.is_private),callback:function ($$v) {_vm.$set(_vm.form, "is_private", $$v)},expression:"form.is_private"}})],1):_vm._e()],1):_vm._e()]):_vm._e()],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card-row"},[_c('img',{staticClass:"credit-card",attrs:{"src":"/static/images/creditcards/visa.svg"}}),_vm._v(" "),_c('img',{staticClass:"credit-card",attrs:{"src":"/static/images/creditcards/mastercard.svg"}}),_vm._v(" "),_c('img',{staticClass:"credit-card",attrs:{"src":"/static/images/creditcards/amex.svg"}}),_vm._v(" "),_c('img',{staticClass:"credit-card",attrs:{"src":"/static/images/creditcards/discover.svg"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"id":"shield","target":"_blank","href":"https://ssl.comodo.com/wildcard-ssl-certificates.php"}},[_c('img',{staticStyle:{"border":"0px"},attrs:{"src":"/static/images/creditcards/comodo-seal.svg","alt":"Comodo Trusted Site Seal","width":"auto","height":"40"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9+Cu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9/A6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__("2oW4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4657a8b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__("a0u3");
function injectStyle (ssrContext) {
  __webpack_require__("9cqZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4657a8b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4657a8b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "92So":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_cookie__ = __webpack_require__("+FgK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_tiny_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_defineService__ = __webpack_require__("tVbG");









var FLAGS = {
  // This is set when browser is IE11, ie not capable of modern web
  // functionality. We restrict features + show message based on this.
  legacy: { default: false },

  // voucher to auto-apply to cart.
  voucher: { default: '' },

  // #region Almost done

  // Enable team import
  // Todo: rollout
  enableTeamMembersImport: { default: false },

  // Allow picking the people being ordered for to fill
  // in template
  // Todo: finish bugs, decide how to roll out
  startOrderDropdown: { default: false },

  // #endregion

  // #region WIP marketing pages

  // Enable WIP features page
  featuresPage: { default: false },

  // #endregion


  // #region debug/for developers
  // Enable debug toolbar
  debugTools: { default: false },

  // Debug tool to remove user (not just teamuser)
  enableDeleteUser: { default: false },

  // Enable debugging onboarding
  forceOnboarding: { default: false },

  // Nametags stuff
  showUncategorizedTemplates: { default: false },

  // #endregion


  // #region WIP editor UIs

  // Enable upload of back file without refreshing. This
  // is buggy.
  seamlessBackUpload: { default: false },

  // Enables block creation logic
  // Todo: polish UI
  enableBlocks: { default: false },

  // Enables field options
  // Todo: work on UI
  enableFieldOptions: { default: false },

  // Enables the lock template feature for template editor
  // Todo: just enable for everyone
  enableLockTemplate: { default: false },

  // Enables the superscript option
  // Todo: make behavior more intuitive (should act like a toggle)
  enableSuperscript: { default: false },

  // Enables SVG upload, which has bad production characteristics
  svgUpload: { default: false },

  // Enables button on template editor
  // Todo: decide if we need the button
  toggleCropBleed: { default: false },

  // Use filestack for upload? Allows cropping
  // Todo: find limitations, pricing, decide on use
  filestackUpload: { default: false },

  // #endregion


  // #region WIP ordering UI

  // WIP Emails settings section. Too sparse to publish.
  enableEmailsSettings: { default: false },

  // WIP option to verify addresses in checkout screen.
  // This doesn't surface the errors very well.
  verifyCheckoutShippingAddressData: { default: false },

  // Enable international shipping options on checkout.
  // Still experimental (have to explain AQ, etc)
  internationalShipping: { default: false },

  // #endregion


  // #region WIP dashboard UI

  // WIP team list - show last order date
  // This can't be rolled out until team/teamuser is backfilled
  showLastOrderDate: { default: false },

  // WIP UI for adding discount on approval
  // TODO: finish polish and roll out
  enableDiscountApplying: { default: false },

  // WIP option to edit design during approval.
  // The workflow is not smooth, and we don't keep
  // a good change log.
  approvalEditDesign: { default: false },

  // Option to unlock design when editing. Not sure
  // if this should be default. Some workflows may
  // want reviewer to stick to content edits, ie keep
  // the locked design.
  approvalEditDesignUnlocks: { default: false },

  // This enables re-order.
  // Todo: rename (involves migrating a customer..)
  // Todo: test out automatic design update?
  showUnimplementedOrderActions: { default: false },

  // Remove Team tab for orderers
  showTeamTabToOrderers: { default: false }

  // #endregion
};

function defaults() {
  var result = {};
  for (var k in FLAGS) {
    result[k] = FLAGS[k].default;
  }
  if ({"API":"https://www.brandly.com/backend/","APP":"https://www.brandly.com","STATIC":false}.STATIC) __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()(result, __WEBPACK_IMPORTED_MODULE_7__services_defineService__["a" /* ALL_ALTERNATIVES */]);
  if (true) result.legacy = true;
  return result;
}

function _cleanFlags(flags) {
  // Return a clean version (non-default values only)
  var result = {};
  for (var key in flags) {
    var defaultValue = (FLAGS[key] || { default: false }).default;
    if (flags[key] !== defaultValue) result[key] = flags[key];
  }
  return result;
}

var loadedFlags = {};
try {
  loadedFlags = Object(__WEBPACK_IMPORTED_MODULE_6_tiny_cookie__["getCookie"])('flags', JSON.parse) || {};
} catch (e) {
  console.error(e);
}
// Allow other scripts to set flags without having access to Vue.
// Code should do:
// (window._appFlags||(window._appFlags=[])).push({getStartedSignup: true})
if (window._appFlags) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default.a.apply(Object, [loadedFlags].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(window._appFlags)));
  console.log('window._appFlags loaded', window._appFlags);
}
// Install "reactive" version
window._appFlags = [];
window._appFlags.push = function (value) {
  window.VueApp.$store.dispatch('updateFlags', value);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    flags: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, defaults(), loadedFlags),
    needsReload: false
  },
  mutations: {
    setFlags: function setFlags(state, flags) {
      for (var flag in flags) {
        // If flag is defined to need reload and we're changing the value,
        // user needs to reload
        if (FLAGS[flag] && FLAGS[flag].reload && flags[flag] != state.flags[flag]) {
          state.needsReload = true;
        }
      }
      state.flags = flags;
      console.log('flags->', state.flags, 'needsReload->', state.needsReload);
    }
  },
  actions: {
    updateFlags: function updateFlags(_ref, updates) {
      var _this = this;

      var commit = _ref.commit,
          state = _ref.state,
          dispatch = _ref.dispatch;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit('setFlags', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, state.flags, updates));
                Object(__WEBPACK_IMPORTED_MODULE_6_tiny_cookie__["setCookie"])('flags', state.flags, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default.a);
                commit('setFutureVoucher', state.flags.voucher || '');

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    resetFlags: function resetFlags(_ref2) {
      var _this2 = this;

      var dispatch = _ref2.dispatch,
          commit = _ref2.commit;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                Object(__WEBPACK_IMPORTED_MODULE_6_tiny_cookie__["setCookie"])('flags', "{}");
                commit('setFlags', defaults());
                dispatch('setTeamFlags');

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  getters: {
    flags: function flags(state) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaults(), state.flags);
    },
    cleanFlags: function cleanFlags(state) {
      return _cleanFlags(state.flags);
    },
    needsReload: function needsReload(state) {
      return state.needsReload;
    }
  }
});

/***/ }),

/***/ "96kP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectWithSearch_vue__ = __webpack_require__("6qv1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed499898_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectWithSearch_vue__ = __webpack_require__("lHkn");
function injectStyle (ssrContext) {
  __webpack_require__("Olxo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ed499898"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectWithSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed499898_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectWithSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "9E09":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomepageWideLayout',[_c('div',{staticClass:"hero-background"},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"hero-text-area"},[_c('h1',{staticClass:"rw-sentence"},[_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v("Business cards")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v("for teams made")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"rw-words rw-words-1"},[_c('span',[_vm._v("simple")]),_vm._v(" "),_c('span',[_vm._v("fast")]),_vm._v(" "),_c('span',[_vm._v("easy")]),_vm._v(" "),_c('span',[_vm._v("affordable")])])]),_vm._v(" "),_c('h2',[_vm._v("\n                Brandly is the fastest and easiest\n                "),_c('br'),_vm._v("business card ordering solution\n                "),_c('br'),_vm._v("for any size business.\n              ")]),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('GetStartedButton'),_vm._v(" "),_c('p',[_vm._v("No credit card required. 1 minute setup.")])],1)])])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"hero-wrapper"},[_c('img',{staticClass:"hero-image",attrs:{"src":"/static/images/homepage/hero/hero.png"}})])])],1)],1)],1),_vm._v(" "),_c('BrandlyApp'),_vm._v(" "),_c('Testimonial'),_vm._v(" "),_c('Demo')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9F4c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('SettingsTitleBar',{attrs:{"sub":"Team","saving":_vm.saving}}),_vm._v(" "),_c('b-alert',{attrs:{"show":"","variant":_vm.notification.type}},[_vm._v(_vm._s(_vm.notification.message))]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Team Name:","label-for":"team_name"}},[_c('b-form-input',{attrs:{"id":"team_name","placeholder":"Enter team name"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Domain:","label-for":"domain"}},[_c('b-form-input',{attrs:{"id":"domain","placeholder":"Enter domain"},model:{value:(_vm.form.domain),callback:function ($$v) {_vm.$set(_vm.form, "domain", $$v)},expression:"form.domain"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Company Size:","label-for":"company_size"}},[_c('b-form-select',{model:{value:(_vm.form.company_size),callback:function ($$v) {_vm.$set(_vm.form, "company_size", $$v)},expression:"form.company_size"}},[_c('option',{attrs:{"value":""}},[_vm._v("(select one)")]),_vm._v(" "),_c('option',[_vm._v("1 or 2")]),_vm._v(" "),_c('option',[_vm._v("3+")]),_vm._v(" "),_c('option',[_vm._v("10+")]),_vm._v(" "),_c('option',[_vm._v("30+")]),_vm._v(" "),_c('option',[_vm._v("100+")])])],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Have Design?"}},[_c('b-form-radio-group',{attrs:{"options":[{text:'Yes', value:'yes'}, {text:'No', value: 'no'}]},model:{value:(_vm.form.have_design),callback:function ($$v) {_vm.$set(_vm.form, "have_design", $$v)},expression:"form.have_design"}})],1)],1),_vm._v(" "),_c('Restrictions',{model:{value:(_vm.restrictions),callback:function ($$v) {_vm.restrictions=$$v},expression:"restrictions"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9Jv0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9V7W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"no-gutters"},[_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"vcenter"},[_c('div',[_c('div',{staticClass:"signup-header"},[_c('img',{staticClass:"logo",attrs:{"src":"/static/images/logos/brandly/brandly-logo-dark.svg"}}),_vm._v(" "),_c('h1',[_vm._v("Start ordering business cards like a pro.")]),_vm._v(" "),_c('h2',[_vm._v("NO CREDIT CARD REQUIRED")])]),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('SignUpForm')],1),_vm._v(" "),_c('div',{staticClass:"wrapper",attrs:{"id":"social"}},[_c('h2',[_vm._v("OR SIGNUP USING")]),_vm._v(" "),_c('div',[_c('GoogleCircle',{on:{"login":_vm.onGoogleLogin}}),_vm._v(" "),_c('LinkedInCircle',{on:{"login":_vm.onLinkedInLogin}})],1)]),_vm._v(" "),_c('div',{staticClass:"has-account"},[_c('p',[_vm._v("\n              Already have an account?\n              "),_c('a',{attrs:{"href":"https://www.brandly.com/signin"}},[_vm._v("  Log in here")])])])])])]),_vm._v(" "),_c('b-col',{staticClass:"d-none d-lg-block",attrs:{"lg":"6"}},[_c('div',{staticClass:"team"},[_c('div',{staticClass:"team"},[_c('div',{staticClass:"red-zone"},[_c('blockquote',[_c('q',[_vm._v("Brandly lets new team members easily join our account, edit their info, and self-order their cards in minutes. As a manager, it's one less thing for me to worry about")]),_vm._v(" "),_c('div',{staticClass:"testimonial"},[_c('span',{staticClass:"circle"}),_vm._v(" "),_c('cite',[_vm._v("Amrit Singh, Cofounder of GoodHands")])])])])])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9VUA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9cqZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9e1g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createAndInviteUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return resendInvite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return acceptInvite; });
/* unused harmony export loadInviteData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defineService__ = __webpack_require__("tVbG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authorize__ = __webpack_require__("lKgw");





var postInvite = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('post', 'api/v1/invite/', {
  alternatives: { dupInvite: '-dup-400' }
});

var putInvite = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('put', 'api/v1/invite/');

var postAcceptInvite = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('post', 'api/v1/invite/:uidtoken/');

var createAndInviteUser = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(teamId, email, user_type) {
    var data, errors;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            data = { brandly_team: [teamId], email: email, user_type: user_type };

            console.log('createAndInviteUser', data);
            _context.prev = 2;
            _context.next = 5;
            return postInvite(data);

          case 5:
            return _context.abrupt('return', _context.sent);

          case 8:
            _context.prev = 8;
            _context.t0 = _context['catch'](2);

            if (!(_context.t0.response && _context.t0.response.data)) {
              _context.next = 24;
              break;
            }

            errors = _context.t0.response.data;

            console.log(errors);

            if (!errors.email) {
              _context.next = 17;
              break;
            }

            throw errors.email.join(', ');

          case 17:
            if (!errors.detail) {
              _context.next = 21;
              break;
            }

            throw errors.detail;

          case 21:
            console.error(_context.t0);
            console.log(errors);
            throw 'Error occurred';

          case 24:
            throw _context.t0;

          case 25:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[2, 8]]);
  }));

  return function createAndInviteUser(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var resendInvite = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(email) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', putInvite({ email: email }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function resendInvite(_x4) {
    return _ref2.apply(this, arguments);
  };
}();

var acceptInvite = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(user_id, token, payload) {
    var data;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return postAcceptInvite(user_id + '-' + token, payload);

          case 3:
            data = _context3.sent;
            return _context3.abrupt('return', Object(__WEBPACK_IMPORTED_MODULE_3__authorize__["d" /* setAuthState */])(data));

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3['catch'](0);

            if (_context3.t0.response && _context3.t0.response.data) {
              // Unwrap error
              _context3.t0 = _context3.t0.response.data;
              if (!_context3.t0.error) {
                // Some other response...
                console.error(_context3.t0);
                _context3.t0.error = 'Error occurred';
              }
            } else {
              // Unknown error. COnvert from error object to string.
              _context3.t0 = { error: '' + _context3.t0 };
            }
            throw _context3.t0;

          case 11:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this, [[0, 7]]);
  }));

  return function acceptInvite(_x5, _x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();

function loadInviteData(user_id, token) {
  // TODO check state of invitation
}

/***/ }),

/***/ "9edP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DesignSection_vue__ = __webpack_require__("oeyE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70352481_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DesignSection_vue__ = __webpack_require__("Vy8U");
function injectStyle (ssrContext) {
  __webpack_require__("uxOt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70352481"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DesignSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70352481_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DesignSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9f50":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['nav']
});

/***/ }),

/***/ "9f7z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filestackClient__ = __webpack_require__("saO9");





/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(filestackHandle) {
    var client, blob;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Object(__WEBPACK_IMPORTED_MODULE_3__filestackClient__["a" /* default */])();

          case 2:
            client = _context.sent;
            _context.next = 5;
            return client.retrieve(filestackHandle);

          case 5:
            blob = _context.sent;
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
              var reader = new FileReader();
              reader.readAsDataURL(blob);
              reader.onloadend = function () {
                var base64data = reader.result;
                resolve(base64data);
              };
            }));

          case 7:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  function retrieveBase64FromFilestack(_x) {
    return _ref.apply(this, arguments);
  }

  return retrieveBase64FromFilestack;
})());

/***/ }),

/***/ "9fhP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"welcome-section"}},[_c('a',{staticClass:"minor cta-link",attrs:{"href":"#"},on:{"click":_vm.nextHeroState}},[_vm._v("Next")]),_vm._v(" "),(_vm.heroState === 'welcome')?[_c('h2',[_vm._v("Your Brandly Dashboard")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{staticClass:"signature"},[_vm._v("-Doug Ballinger, CEO")])]:_vm._e(),_vm._v(" "),(_vm.heroState === 'step1')?[_c('h2',[_vm._v("Create your account")]),_vm._v(" "),_c('p',[_vm._v("You've completed this step already!\n    ")])]:_vm._e(),_vm._v(" "),(_vm.heroState === 'step2')?[_c('h2',[_vm._v("Setup your portal")]),_vm._v(" "),_c('p',[_vm._v("You've probably completed this step already! Please just continue to the next step. Let us\n      know if you feel stuck in any way.\n    ")])]:_vm._e(),_vm._v(" "),(_vm.heroState === 'step3')?[_c('h2',[_vm._v("Upload your design")]),_vm._v(" "),_vm._m(1)]:_vm._e(),_vm._v(" "),(_vm.heroState === 'step4')?[_c('h2',[_vm._v("Share with your Team")]),_vm._v(" "),_vm._m(2)]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("You've successfuly create a self-managing system for YOUR BRANDS business cards. While we\n      firmly believe that savvy brands will want full power to control how their solutions work,\n      "),_c('b',[_vm._v("we're here to help")]),_vm._v(": so please tell us how we are doing and let us know if we can help\n      in any way.\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("What is your design? It's the PDF of "),_c('strong',[_vm._v("your brand's")]),_vm._v(" business card. Upload it now and our system will convert it into an\n      EDITABLE card that your whole team can use "),_c('strong',[_vm._v("hands off")]),_vm._v(". Uploading is easy: click the "),_c('q',[_vm._v("browse")]),_vm._v(" button, then find your PDF\n      If you want extra details about the format needed, click "),_c('q',[_vm._v("VIEW")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The final step! Share out your business cards with your team. Just enter their email below and press "),_c('q',[_vm._v("invite")]),_vm._v(". Then your team mates\n    can handle putting in an order on their own without bothering you!\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9hkR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewProfile_vue__ = __webpack_require__("6KIs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_740aa0cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewProfile_vue__ = __webpack_require__("rwXd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_740aa0cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9lrZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9xFa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"product-form"}},[_c('b-form-group',{attrs:{"label":"paper"}},[_c('b-select',{model:{value:(_vm.paper),callback:function ($$v) {_vm.paper=$$v},expression:"paper"}},_vm._l((_vm.paperOptionGroups),function(options,label){return _c('optgroup',{key:label,attrs:{"label":label}},_vm._l((options),function(value){return _c('option',{key:value,domProps:{"value":value}},[_vm._v(_vm._s(value))])}),0)}),0)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"quantity"}},[_c('b-form-radio-group',{attrs:{"buttons":"","options":_vm.quantityOptions},model:{value:(_vm.quantity),callback:function ($$v) {_vm.quantity=$$v},expression:"quantity"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"corners"}},[_c('b-form-radio-group',{attrs:{"buttons":"","options":_vm.cornerOptions},model:{value:(_vm.corners),callback:function ($$v) {_vm.corners=$$v},expression:"corners"}})],1),_vm._v(" "),(_vm.price)?_c('div',{staticClass:"price"},[_c('label',[_vm._v("Your price")]),_vm._v(" "),_c('span',{staticClass:"amount"},[_vm._v("$"+_vm._s(_vm.price.toFixed(2)))]),_vm._v(" "),(_vm.saving)?_c('div',{staticClass:"saving-icon"},[_c('i',{staticClass:"fas fa-spinner fa-spin"})]):_vm._e()]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A8z5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-design"},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A9Ar":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingPageHero_vue__ = __webpack_require__("8JM6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f3bbcf6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingPageHero_vue__ = __webpack_require__("IaDX");
function injectStyle (ssrContext) {
  __webpack_require__("xS4n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f3bbcf6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingPageHero_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f3bbcf6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingPageHero_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "AE5E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditorFonts_vue__ = __webpack_require__("7puy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0af59fab_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditorFonts_vue__ = __webpack_require__("8ARW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditorFonts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0af59fab_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditorFonts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AT2g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVouchers; });
/* unused harmony export getVoucher */
/* unused harmony export postVoucher */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineService__ = __webpack_require__("tVbG");


var getVouchers = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('get', 'api/v1/vouchers/');

var getVoucher = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('get', 'api/v1/vouchers/:id/');

var postVoucher = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('post', 'api/v1/vouchers/');

/***/ }),

/***/ "AUhL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{class:{invited: !_vm.member.is_active, hover: _vm.isAdmin},on:{"click":_vm.onClickRow}},[_c('td',[_vm._v("\n    "+_vm._s(_vm.member.email)+"\n  ")]),_vm._v(" "),_c('td',[(!_vm.member.is_active)?_c('div',{staticClass:"invite-fineprint"},[_c('i',{staticClass:"fa fa-envelope"}),_vm._v(" "),(_vm.sending)?_c('span',[_vm._v("Sending...")]):_c('span',[_vm._v("Invite sent!")])]):_c('span',[_vm._v(_vm._s(_vm.member.date_joined.substring(0,10)))])]),_vm._v(" "),_c('td',[_vm._v("\n    "+_vm._s(_vm.userRoleText())+"\n  ")]),_vm._v(" "),(_vm.flags.showLastOrderDate)?_c('td',[_vm._v("\n    "+_vm._s(_vm.member.last_order_date ? _vm.member.last_order_date.substring(0,10) : '')+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Akzj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChooseProduct_vue__ = __webpack_require__("KeyZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61251a1a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChooseProduct_vue__ = __webpack_require__("rV1K");
function injectStyle (ssrContext) {
  __webpack_require__("XGBw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61251a1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChooseProduct_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61251a1a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChooseProduct_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AqRf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FixedMenu_vue__ = __webpack_require__("TWDo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bfd8bff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FixedMenu_vue__ = __webpack_require__("JBsK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FixedMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bfd8bff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FixedMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BCtc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BP3H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"orderFilter"}},[_c('div',{staticClass:"flexer"},[_c('b-form-radio-group',{staticClass:"pillbox",attrs:{"size":"sm","buttons":"","button-variant":"clear"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},_vm._l((_vm.statuses),function(ref){
var status = ref.status;
var shortStatus = ref.shortStatus;
return _c('b-form-radio',{key:status,attrs:{"value":status}},[_vm._v(_vm._s(shortStatus))])}),1),_vm._v(" "),_c('span',{staticClass:"status"},[(_vm.recentOrdersBusy)?_c('WaveSpinner',{attrs:{"inline":""}}):_c('span',{on:{"click":_vm.reload}},[_vm._v(_vm._s(_vm.totalOrders)+" orders")])],1),_vm._v(" "),_c('b-dropdown',{attrs:{"size":"sm","variant":"clear","right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fas fa-ellipsis-v"})]),_vm._v(" "),(_vm.showAllStatuses)?_c('b-dropdown-item',{on:{"click":function($event){_vm.showAllStatuses=false}}},[_vm._v("Show key statuses")]):_c('b-dropdown-item',{on:{"click":function($event){_vm.showAllStatuses=true}}},[_vm._v("Show all statuses")])],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BT85":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Support_vue__ = __webpack_require__("DlT1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e07f446_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Support_vue__ = __webpack_require__("nN2H");
function injectStyle (ssrContext) {
  __webpack_require__("gAjd")
  __webpack_require__("EBMx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e07f446"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Support_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e07f446_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Support_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "BVSF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer"},[_c('b-form-radio-group',{class:{pillbox: true},attrs:{"size":"sm","buttons":"","button-variant":"clear","checked":!!_vm.value},on:{"input":_vm.input}},[_c('b-form-radio',{attrs:{"value":false}},[_c('i',{class:("fas fa-" + _vm.falseIcon)}),(_vm.falseLabel)?_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.falseLabel))]):_vm._e()]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":true}},[_c('i',{class:("fas fa-" + _vm.trueIcon)}),(_vm.trueLabel)?_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.trueLabel))]):_vm._e()])],1),_vm._v(" "),(_vm.value)?_vm._t("trueDescription"):_vm._t("falseDescription"),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BW4t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsTitleBar_vue__ = __webpack_require__("eoa9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03a4bf8c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsTitleBar_vue__ = __webpack_require__("+Anf");
function injectStyle (ssrContext) {
  __webpack_require__("gYqH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03a4bf8c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsTitleBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03a4bf8c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsTitleBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "BmkL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CartCheckoutWrapper',[_c('section',{staticClass:"checkout-wrapper"},[_c('div',{staticClass:"container-fluid"},[_c('form',{staticClass:"checkout-form inputs-border inputs-bg",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-lg-6"},[(_vm.showLoginLink)?_c('div',{staticClass:"alert alert-info"},[_c('strong',[_vm._v("Returning customer?")]),_vm._v(" "),_c('a',{staticClass:"effect",attrs:{"href":"#","data-slide-toggle":".checkout-login-form"},on:{"click":function($event){_vm.showLogin = !_vm.showLogin}}},[_vm._v("\n              Click here to Login")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-lg-6"}),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-lg-6"},[(!_vm.user)?_c('div',[(_vm.showLogin && !_vm.loggedIn)?_c('div',{staticClass:"checkout-login-form box"},[_c('ReturningCustomerLogin')],1):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-lg-6",attrs:{"fromGroupName":"shipping_address"}},[_c('CustomerInfo',{attrs:{"info-type":"Shipping"},model:{value:(_vm.shipping),callback:function ($$v) {_vm.shipping=$$v},expression:"shipping"}}),_vm._v(" "),(_vm.flags.debugTools && _vm.shippingAddressVerification)?_c('div',[_c('pre',{staticClass:"debug-data"},[_vm._v(_vm._s(_vm.shippingAddressVerification))])]):_vm._e(),_vm._v(" "),(_vm.needsPayment)?_c('div',{staticClass:"form-group"},[_c('h3',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.billing_different_address),expression:"billing_different_address"}],attrs:{"type":"checkbox","id":"billing-different-address"},domProps:{"checked":Array.isArray(_vm.billing_different_address)?_vm._i(_vm.billing_different_address,null)>-1:(_vm.billing_different_address)},on:{"change":function($event){var $$a=_vm.billing_different_address,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.billing_different_address=$$a.concat([$$v]))}else{$$i>-1&&(_vm.billing_different_address=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.billing_different_address=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"checkbox",attrs:{"for":"billing-different-address","data-slide-toggle":".different-address"}},[_vm._v("Different billing address?")])]),_vm._v(" "),(_vm.billing_different_address)?_c('CustomerInfo',{attrs:{"info-type":"Billing"},model:{value:(_vm.billing),callback:function ($$v) {_vm.billing=$$v},expression:"billing"}}):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-lg-6"},[_c('div',{staticClass:"review-order"},[_c('div',{staticClass:"box"},[_c('BasketSummary'),_vm._v(" "),(_vm.needsPayment)?_c('CheckoutPayment',{model:{value:(_vm.payment),callback:function ($$v) {_vm.payment=$$v},expression:"payment"}}):_vm._e(),_vm._v(" "),_c('CheckoutReviewSettings'),_vm._v(" "),_c('div',{staticClass:"text-right place-order-buttons"},[_c('div',{on:{"mouseover":_vm.onMouseOver}},[(_vm.busy)?_c('WaveSpinner',{attrs:{"inline":""}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn-action",attrs:{"disabled":_vm.busy || !_vm.paymentInfoComplete || !_vm.isShippingAddressValid}},[_vm._v("\n                    "+_vm._s(_vm.busy ? 'Placing Order...' : 'Place Order')+"  "),_c('i',{staticClass:"fa fa-arrow-right"})])],1),_vm._v(" "),_c('OrderReviewMessage',{model:{value:(_vm.skip_review),callback:function ($$v) {_vm.skip_review=$$v},expression:"skip_review"}})],1),_vm._v(" "),(_vm.checkoutErrors.length)?_c('ul',{staticClass:"error"},_vm._l((_vm.checkoutErrors),function(err){return _c('li',{key:err},[_vm._v(_vm._s(err))])}),0):_vm._e()],1)])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BsGs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button-group',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"placement":"bottom","title":"Convert to Text Block","variant":"clear"},on:{"click":function($event){return _vm.emit('convertToBlock')}}},[_c('i',{staticClass:"fa fa-object-group",attrs:{"aria-hidden":"true"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BvLC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toggle_vue__ = __webpack_require__("6WY7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77e134d1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toggle_vue__ = __webpack_require__("BVSF");
function injectStyle (ssrContext) {
  __webpack_require__("LZqL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77e134d1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toggle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77e134d1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toggle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "BxuS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value'],
  data: function data() {
    return {
      saving: false,
      adding: false,
      choosing: false,
      addError: '',
      newAddress: {
        line1: '',
        line2: '',
        city: '',
        state: '',
        postcode: '',
        country: 'US'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['combinedMemberAddresses']), {
    address: function address() {
      if (this.choosing) return null;
      return this.value;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['addTeamAddress']), {
    chooseAddress: function chooseAddress(addr) {
      this.choosing = false;
      this.$emit('input', addr);
    },
    startAdding: function startAdding() {
      this.adding = true;
    },
    addAddress: function addAddress() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var id;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.addTeamAddress(_this.newAddress);

              case 3:
                id = _context.sent;

                _this.$emit('input', _this.combinedMemberAddresses.find(function (a) {
                  return a.id == id;
                }));
                // TODO animate?
                _this.adding = false;
                _this.choosing = false;
                _context.next = 14;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                if (_context.t0.response && _context.t0.response.data) _context.t0 = _context.t0.response.data;
                _this.addError = _context.t0;
                return _context.abrupt('return');

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    }
  })
});

/***/ }),

/***/ "ByP9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__billing_SavedCard_vue__ = __webpack_require__("7qho");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { SavedCard: __WEBPACK_IMPORTED_MODULE_4__billing_SavedCard_vue__["a" /* default */] },
  data: function data() {
    return { loaded: false, loading: false, error: '' };
  },
  mounted: function mounted() {
    this.load();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['forceInvoice', 'savedCards', 'user']), {
    numOwned: function numOwned() {
      var _this = this;

      return this.savedCards.filter(function (c) {
        return c.owner.id === _this.user.id;
      }).length;
    },
    numShared: function numShared() {
      return this.savedCards.length - this.numOwned;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['loadSavedCards']), {
    load: function load() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this2.forceInvoice) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _context.prev = 2;

                _this2.loading = true;
                _this2.loaded = false;
                _this2.error = '';
                _context.next = 8;
                return _this2.loadSavedCards();

              case 8:
                _this2.loading = false;
                _this2.loaded = true;
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](2);

                console.error(_context.t0);
                _this2.error = '' + _context.t0 || 'Error';

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[2, 12]]);
      }))();
    }
  })
});

/***/ }),

/***/ "C1V3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomepageWideLayout',{attrs:{"heroDark":""}},[_c('section',[_c('SecondaryHeader',[_c('h2',[_vm._v("Artwork Guidelines")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("\n        Review our tips for creating a design that will generate a flawless ready-to-use online print template.\n\n\n      ")])]),_vm._v(" "),_c('ArtworkTips')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C9Vj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DashboardBase__ = __webpack_require__("e40e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__design_Design__ = __webpack_require__("vO8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orders_Orders__ = __webpack_require__("ueji");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__team_Team__ = __webpack_require__("1rqv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__home_Home__ = __webpack_require__("M9C1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__settings_Settings__ = __webpack_require__("eZpL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");

//
//
//
//








var _children = [{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_5__home_Home__["a" /* default */],
  meta: {
    noBorder: true,
    //icon: 'fas fa-tachometer-alt',
    symbol: "dashboard"
  }
}, {
  path: 'design',
  component: __WEBPACK_IMPORTED_MODULE_2__design_Design__["a" /* default */],
  children: __WEBPACK_IMPORTED_MODULE_2__design_Design__["a" /* default */].children,
  meta: {
    // icon: 'fas fa-pencil-alt'
    symbol: "pencil"
  }
}, {
  path: 'team',
  component: __WEBPACK_IMPORTED_MODULE_4__team_Team__["a" /* default */],
  children: __WEBPACK_IMPORTED_MODULE_4__team_Team__["a" /* default */].children,
  meta: {
    // icon: 'fas fa-users'
    symbol: "team"
  }
}, {
  path: 'orders',
  component: __WEBPACK_IMPORTED_MODULE_3__orders_Orders__["a" /* default */],
  children: __WEBPACK_IMPORTED_MODULE_3__orders_Orders__["a" /* default */].children,
  meta: {
    //  icon: 'fas fa-sticky-note'
    symbol: "order"
  }
}, {
  path: 'settings',
  component: __WEBPACK_IMPORTED_MODULE_6__settings_Settings__["a" /* default */],
  children: __WEBPACK_IMPORTED_MODULE_6__settings_Settings__["a" /* default */].children,
  meta: {
    // icon: 'fas fa-cog',
    symbol: "gear"
  }
}];


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DashboardBase: __WEBPACK_IMPORTED_MODULE_1__DashboardBase__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(['flags', 'isAdmin']), {
    children: function children() {
      var _this = this;

      return _children.filter(function (_ref) {
        var path = _ref.path;
        return path !== 'team' || _this.isAdmin || _this.flags.showTeamTabToOrderers;
      });
    }
  }),
  // Non-standard Vue property, used to make sub
  children: _children
});

/***/ }),

/***/ "CA5q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_track_events__ = __webpack_require__("Dg6a");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['flags', 'steps', 'heroState']), {
    canLaunchTour: function canLaunchTour() {
      // If userpilot is installed we can launch the tour
      return !!window.userpilot;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['setInitialHeroState', 'setHeroState', 'nextHeroState', 'hideOnboarding']), {
    onClickStep: function onClickStep(step) {
      if (step.done) return;
      this.setHeroState(step.key);
    },
    launchTour: function launchTour() {
      Object(__WEBPACK_IMPORTED_MODULE_2__lib_track_events__["g" /* launchTourClicked */])('156270243pNpy4853');
      window.userpilot.trigger('156270243pNpy4853');
    }
  }),
  mounted: function mounted() {
    this.setInitialHeroState();
  }
});

/***/ }),

/***/ "CQfM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CRkJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: { step: { default: 1 } }
});

/***/ }),

/***/ "CTGo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LinkedInCircle_vue__ = __webpack_require__("EJd9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b924d12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LinkedInCircle_vue__ = __webpack_require__("Wwu7");
function injectStyle (ssrContext) {
  __webpack_require__("jmDq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LinkedInCircle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b924d12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LinkedInCircle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "CkWj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsButtons_vue__ = __webpack_require__("1XwJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee5f4c0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsButtons_vue__ = __webpack_require__("5Ln6");
function injectStyle (ssrContext) {
  __webpack_require__("Rxzk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ee5f4c0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsButtons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee5f4c0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsButtons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "CoOB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnboardSection_vue__ = __webpack_require__("CA5q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_688fcdaf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnboardSection_vue__ = __webpack_require__("G7wm");
function injectStyle (ssrContext) {
  __webpack_require__("3eCB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-688fcdaf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnboardSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_688fcdaf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnboardSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CrEO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ctmo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BleedPointDisplay_vue__ = __webpack_require__("R0BY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ba94a91_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BleedPointDisplay_vue__ = __webpack_require__("ux69");
function injectStyle (ssrContext) {
  __webpack_require__("kEqj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ba94a91"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BleedPointDisplay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ba94a91_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BleedPointDisplay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CuTT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      password: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['loginBusy', 'loginError'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['login']), {
    submit: function submit() {
      this.login({ username: this.email, password: this.password });
    }
  }),
  mounted: function mounted() {
    console.log('focusing');
    this.$refs.email.focus();
  }
});

/***/ }),

/***/ "Cvgy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getOffset */
/* harmony export (immutable) */ __webpack_exports__["a"] = getItemsPaginated;
/* unused harmony export snakeCaseToCamelCase */
/* unused harmony export camelCaseToSnakeCase */
/* harmony export (immutable) */ __webpack_exports__["b"] = objectKeysToCamelCase;
/* unused harmony export convertObjectKeysToSnakeCase */
/* unused harmony export addQueryToProps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties__);




/**
 * Calculate `offset` needed to get paginated results.
 *
 * @example
 *  To get results from the 1st page with 10 items on a page,
 *  a URL must be extended with "?limit=10&offset=0".
 *  "?limit=10&offset=10" for the 2nd page.
 *  "?limit=10&offset=20" for the 3rd page etc.
 *
 * @param {Number} pageNumber
 * @param {Number} itemsOnPage
 */
function getOffset(pageNumber, itemsOnPage) {
  return (pageNumber - 1) * itemsOnPage;
}

/**
 * Return promise that returns object with paginated results.
 * The structure of returned object:
 * {
 *   count: Items qty {Number}.
 *   next: URL of the next page {String} or {null}.
 *   previous: URL of the previous page {String} or {null}.
 *   results: {Array of Objects}.
 * }
 *
 * @param {Function} serviceToCall - E.g. `getUsers`, `getTeams`.
 * @param {Object} payload
 * @return {Promise<{count, next, previous, results}>}
 */
function getItemsPaginated(serviceToCall, payload) {
  var pageNumber = payload.pageNumber,
      itemsOnPage = payload.itemsOnPage,
      otherQueryParams = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties___default()(payload, ['pageNumber', 'itemsOnPage']);

  var offset = getOffset(pageNumber, itemsOnPage);
  var updatedQueryParams = convertObjectKeysToSnakeCase(otherQueryParams);
  return serviceToCall(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ limit: itemsOnPage, offset: offset }, updatedQueryParams));
}

/**
 * Convert "snake case" string to "camel case" string.
 *
 * @example "product_title" -> "productTitle"
 *
 * @param {String} s
 * @returns {String} Converted string
 */
function snakeCaseToCamelCase(s) {
  return s.replace(/([-_][a-z])/ig, function ($1) {
    return $1.toUpperCase().replace('_', '');
  });
}

/**
 * Convert "camel case" string to "snake case" string.
 *
 * @example "productTitle" -> "product_title"
 *
 * @param {String} s
 * @returns {String} Converted string
 */
function camelCaseToSnakeCase(s) {
  return s.replace(/[\w]([A-Z])/g, function (m) {
    return m[0] + '_' + m[1];
  }).toLowerCase();
}

/**
 * Extend object with keys from `keyArray` converted to "camel case".
 *
 * @param {Object} obj
 * @param {Array} keyArray
 * @returns {Object} Updated object
 */
function objectKeysToCamelCase(obj, keyArray) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(keyArray), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      if (obj[key]) {
        var camelCaseKey = snakeCaseToCamelCase(key);
        obj[camelCaseKey] = obj[key];
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return obj;
}

/**
 * Convert all object's keys from "camel case" to "snake case".
 *
 * @example
 * { teamId: 12, 'productTitle': 'Title' } -> { team_id: 12, product_title: 'Title' }
 *
 * @param {Object} obj
 * @returns {Object} Updated object
 */
function convertObjectKeysToSnakeCase(obj) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var key = _step2.value;

      var snakeCaseKey = camelCaseToSnakeCase(key);
      if (snakeCaseKey !== key) {
        obj[snakeCaseKey] = obj[key];
        delete obj[key];
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return obj;
}

/**
 * Extend URL params with data from query string.
 *
 * @param route
 */
function addQueryToProps(route) {
  var props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, route.params);
  props.query = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, route.query);
  return props;
}

/***/ }),

/***/ "D3mI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compressed;
/* harmony export (immutable) */ __webpack_exports__["b"] = expanded;
/* harmony export (immutable) */ __webpack_exports__["c"] = idFromProductUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);



var URL = 'http://www.lvh.me/services/cart/api/v1/cart/products/448/';

function compressed(_ref) {
  var quantity = _ref.quantity,
      urlForSide1 = _ref[1],
      urlForSide2 = _ref[2];

  return [quantity, idFromProductUrl(urlForSide1), idFromProductUrl(urlForSide2)].join(',');
}

function expanded(selectedProductString) {
  if (!selectedProductString) return null;
  if ((typeof selectedProductString === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(selectedProductString)) === 'object') return validateProductSelector(selectedProductString);

  var _selectedProductStrin = selectedProductString.split(','),
      _selectedProductStrin2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_selectedProductStrin, 3),
      quantity = _selectedProductStrin2[0],
      id1 = _selectedProductStrin2[1],
      id2 = _selectedProductStrin2[2];

  return { quantity: +quantity, 1: urlFromProductId(id1), 2: urlFromProductId(id2) };
}

function validateProductSelector(_ref2) {
  var quantity = _ref2.quantity,
      urlForSide1 = _ref2[1],
      urlForSide2 = _ref2[2];

  if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(+quantity) || !(urlForSide1 || urlForSide2)) throw new Error('invalid selector');
  return { quantity: quantity, 1: urlForSide1, 2: urlForSide2 };
}

/**
 * Return URL from id encoded by idFromProductUrl. ALways return www.brandly.com, regardless
 * of environment, as all backends accept that format.
 *
 * @param {*} id
 */
function urlFromProductId(id) {
  return id ? 'https://www.brandly.com/services/cart/api/v1/cart/products/' + id + '/' : null;
}

/**
 * Return an id as a string suitable to be encoded in a url.
 *
 * @param {*} url
 */
function idFromProductUrl(url) {
  if (!url) return '';
  var m = /\/products\/(\d+)\//.exec(url);
  if (!m) throw new Error("Invalid URL");
  return m[1];
}

/***/ }),

/***/ "D8Zu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage-layout"},[_c('LimitedHeader'),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DBgY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WarningBox__ = __webpack_require__("is0N");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { WarningBox: __WEBPACK_IMPORTED_MODULE_2__WarningBox__["a" /* default */] },
  props: ['actionParams', 'canvasState', 'bus'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['isTemplate', 'flags', 'designOptions']), {
    designLocked: function designLocked() {
      if (!this.designOptions) return false;
      return this.designOptions.lockDesign;
    },
    lockButtons: function lockButtons() {
      return this.designLocked && !this.isTemplate;
    },
    buttonClass: function buttonClass() {
      if (this.actionParams.variant == 'action') {
        // the btn-action overrides the bootstrap styles,
        // and needs to NOT include btn. As a consequence, it's also square.
        // TODO make it look right with "btn"
        return 'btn-action sidebar-purchase-link';
      } else {
        return 'btn btn-' + this.actionParams.variant + ' wide-button';
      }
    }
  })
});

/***/ }),

/***/ "DC6H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DCWn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DDqq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"demo"},[_c('b-container',[_c('b-row',[_c('b-col',{staticClass:"position: relative;",attrs:{"sm":"12","md":"6"}},[_c('div',{staticClass:"brandly-bar"}),_vm._v(" "),_c('div',{staticClass:"demo-wrapper"},[_c('div',{staticClass:"demo-copy"},[_c('h2',[_vm._v("Ready to step into smart business card ordering?")]),_vm._v(" "),_c('p',[_vm._v("\n              Opening an account is free.\n              "),_c('br'),_vm._v("Just pay for the cards you order.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"action-button"},[_c('GetStartedButton')],1)])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"6"}},[_c('div',{staticClass:"demo-wrapper"},[_c('div',{staticClass:"demo-copy"},[_c('h2',[_vm._v("\n              Want to learn more?\n              "),_c('br'),_vm._v("See how it works...\n            ")]),_vm._v(" "),_c('p',[_vm._v("We'll walk you through our product and answer any questions you have.")])]),_vm._v(" "),_c('div',{staticClass:"action-button"},[_c('GetDemoButton')],1)])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DLmx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditorThumbnail_vue__ = __webpack_require__("OwFv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fa02a05_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditorThumbnail_vue__ = __webpack_require__("/TtP");
function injectStyle (ssrContext) {
  __webpack_require__("45O6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5fa02a05"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditorThumbnail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fa02a05_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditorThumbnail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DRHf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dbfs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent"},[_c('div',{staticClass:"copy-container"},[_c('div',{staticClass:"copy"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dg6a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["j"] = uploadPageVisited;
/* harmony export (immutable) */ __webpack_exports__["l"] = uploadedFileSuccess;
/* harmony export (immutable) */ __webpack_exports__["k"] = uploadedFileError;
/* harmony export (immutable) */ __webpack_exports__["e"] = designUploadVisited;
/* harmony export (immutable) */ __webpack_exports__["d"] = designUploadSuccess;
/* harmony export (immutable) */ __webpack_exports__["c"] = designUploadError;
/* harmony export (immutable) */ __webpack_exports__["b"] = designSetTemplate;
/* harmony export (immutable) */ __webpack_exports__["f"] = fontsMissingWarning;
/* unused harmony export downloadStarterPack */
/* unused harmony export downloadLeadMagnet */
/* harmony export (immutable) */ __webpack_exports__["n"] = userInviteSent;
/* harmony export (immutable) */ __webpack_exports__["m"] = userInviteAccepted;
/* harmony export (immutable) */ __webpack_exports__["p"] = userSignedUp;
/* harmony export (immutable) */ __webpack_exports__["o"] = userJoinedTeam;
/* harmony export (immutable) */ __webpack_exports__["a"] = adminLinkShare;
/* harmony export (immutable) */ __webpack_exports__["h"] = lineAddedToCart;
/* harmony export (immutable) */ __webpack_exports__["i"] = orderPlaced;
/* harmony export (immutable) */ __webpack_exports__["q"] = viewedPricing;
/* harmony export (immutable) */ __webpack_exports__["g"] = launchTourClicked;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);

/* events.js
 *
 * This module defines all "app events" that are tracked by marketing software.
 *
 * The naming convention is broken into three parts: area, action, item
 * areas:
 *  home - homepage / marketing site
 *  app - dashboard/upload flow
 *  lp - landing page (future use)
 *  checkout - checkout flow
 * actions:
 *   clicked, visited, uploaded
 * item:
 *   typically a dashed name
 *   sometimes add -success or -failure
 *
 * The combined event name formula is `area: action-item`
 */

function uploadPageVisited() {
  _track('app', 'visited', 'upload-page');
}

function uploadedFileSuccess() {
  _track('app', 'uploaded', 'file-success');
}

function uploadedFileError(error) {
  _track('app', 'uploaded', 'file-error', { error: error });
}

function designUploadVisited(context) {
  // context is new-design | re-upload | add-design
  _track('app', 'design', 'upload-visited', { context: context });
}

function designUploadSuccess() {
  _track('app', 'design', 'file-success');
}

function designUploadError(error) {
  _track('app', 'design', 'file-error', { error: error });
}

function designSetTemplate() {
  _track('app', 'design', 'set-template');
}

function fontsMissingWarning(fonts) {
  _track('app', 'fonts', 'missing-warning', { fonts: fonts });
}

function downloadStarterPack() {
  // TODO
}

function downloadLeadMagnet() {
  // TODO
}

function userInviteSent(invitedEmail, userType) {
  _track('app', 'team', 'invite-sent', { invitedEmail: invitedEmail, userType: userType });
}

function userInviteAccepted() {
  _track('app', 'team', 'invite-accepted');
}

function userSignedUp() {
  _track('app', 'user', 'signup');
}

function userJoinedTeam() {
  _track('app', 'team', 'user-signup');
}

function adminLinkShare(method) {
  // method: 'reveal' | 'copy' | other things in future
  _track('app', 'team', 'join-link-share', { method: method });
}

function lineAddedToCart() {
  _track('cart', 'line', 'added');
}

function orderPlaced(_ref) {
  var paymentMethod = _ref.paymentMethod,
      numItems = _ref.numItems,
      total = _ref.total;

  var value = Math.round(total * 100); // Convert to cents
  _track('checkout', 'order', 'placed', {
    value: value, // only value tracked by GA
    paymentMethod: paymentMethod,
    numItems: numItems
  });
}

function viewedPricing(location) {
  _track('app', 'pricing', 'viewed', { location: location });
}

function launchTourClicked(tour) {
  _track('tour', 'launch', 'clicked', { tour: tour });
}

// Utility methods
function _track(area, action, item, extra) {
  var evt = area + ': ' + action + '-' + item;
  gaEvent(area, action, item, extra);
  intercomEvent(evt, extra);
  dripEvent(evt, extra);
  amplitudeEvent(evt, extra);
  userpilotEvent(evt, extra);
}

function gaEvent(category, action, label) {
  var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var value = _ref2.value,
      extra = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['value']);

  if (typeof value !== 'number') {
    // GA can't handle non-numbers here
    extra.value = value;
    value = null;
  }
  if (!window.ga) {
    console.log('gaEvent - ga not installed!', { category: category, action: action, label: label, value: value, extra: extra });
  } else {
    // TODO check if this is the right tracker or send to all?
    window.ga(function () {
      var tracker = window.ga.getAll()[0];
      tracker.send("event", category, action, label, value, extra);
      console.log('events->ga', { category: category, action: action, label: label, value: value, extra: extra });
    });
  }
}

function intercomEvent(eventName, meta) {
  if (!window.Intercom) console.log('intercomEvent - Intercom not installed');else Intercom('trackEvent', eventName, meta), console.log('intercomEvent', eventName, meta);
}

function dripEvent(evt, extra) {
  // NOTE: "value" is a special key, must be in cents
  if (window._dcq) {
    window._dcq.push(["track", evt, extra]);
  }
}

function amplitudeEvent(evt, extra) {
  if (window.amplitude) {
    amplitude.getInstance().logEvent(evt, extra);
  }
}

function userpilotEvent(evt, extra) {
  if (window.userpilot) {
    window.userpilot.track(evt, extra);
  }
}

/***/ }),

/***/ "DlT1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _questions;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var FAQ = {
  account: {
    name: "Account",
    questions: {
      accountCreate: {
        q: "How do I create an account?",
        a: "Click on the <strong> Sign Up </strong> link in the header to create an account or upload a PDF of your business card and you will \
          be prompted to create an account when you save your design."
      },
      accountBenefits: {
        q: "What are the benefits of creating an account?",
        a: "The main benefits are the ability to save your business card template(s) for future use and the ability to save other business information\
          that expedites business card ordering including team member, shipping, and payment information."
      },
      accountFee: {
        q: "Is there a fee or subscription to create an account?",
        a: "No, there are no fees or subscriptions associated with your online account. We only charge for the print orders you generate through your account."
      },
      accountPayment: {
        q: "How do I pay for my business card orders?",
        a: 'We accept most major credit cards including Visa, Mastercard, American Express, and Discover.'
      }
    }
  },
  artwork: {
    name: "Artwork",
    questions: {
      artworkSize: {
        q: "What size should I make my artwork?",
        a: 'We accept standard sized business card formats in landscape or portrait layouts so \
              your files should measure <strong> 3.5 x 2 inches </strong> (252 pts x 144 pts) or <strong> 2 x 3.5 inches </strong>  (144 pts x 252 pts).\
              If your artwork is on a larger artboard or combined with other other designs, or is in a "multi-up" format and you are not sure how \
              to fix it, please contact us and we will be happy to help you create a file that can be uploaed into our app.'
      },
      artworkSave: {
        q: "How should I save save my artwork file to upload into the Brandly app?",
        a: "Please save it as a <strong> PDF </strong>file."
      },
      artworkText: {
        q: "How does the Brandly app recognize text that I want to make editable?",
        a: 'In order to make text editable in the Brandly app, do <strong>not</strong> convert it to outlines - all "live" text will left editable after uploading into the app.\
                Conversely, if your artwork contains a logo, slogan, or URL with text that never changes, the best practice is to convert that text to outlines.'
      },
      artworkLine: {
        q: "Can I use different fonts, font sizes, and colors in the same line of text?",
        a: 'Yes, you may design a card with two or more fonts, font sizes, or colors on the same line. \
               When you edit your card online, be careful to select a single style at a time to edit otherwise you may erase part\
               of your "line style". If you make a mistake, just click the "redo" button and start over.'
      },
      artworkSecondside: {
        q: "What if my business card has a second side?",
        a: 'You may upload your second side in the app after your front side but if you prefer, our app supports uploading a 2-page PDF file.\
            Just make sure that you create your 2-page PDF file in your native design app (e.g. Illustrator) or Adobe Acrobat rather than a utility like the Mac OS \
            Preview tool - which does not yield a good result with our app.'
      },
      artworkApps: {
        q: "What apps should I use to create my original artwork?",
        a: 'We recommend Adobe InDesign, Illustrator, and Photoshop - all part of the Adobe Creative Cloud suite of professinal design tools. \
                These are the most popular and universal tools that graphic designers use to create layouts, illustrations, and images for their design projects.'
      },
      artworkResolution: {
        q: "What image resolution do you recommend for photos or non-vector graphics?",
        a: 'If you are uploading images (e.g. JPEGs), higher resolutions - around <strong>300 dpi</strong> - work best .'
      },
      artworkColorspace: {
        q: "What colorspace do you recommend?",
        a: 'While there are many color models available today, eventually your file will be converted to<strong> CMYK </strong>(four-color process) for printing purposes so we recommend CMYK.'
      },
      artworkBleed: {
        q: "How do I create a bleed in my artwork?",
        a: 'Bleed is printing that goes beyond the edge of where the sheet will be trimmed - in other words, the area to be trimmed off. \
                You need to create bleeds when printing goes to the edge of a printed piece so that after trimming, you only see the background artwork\
                and not white paper if the trim varies slightly. Watch our <a href="https://www.brandly.com/upload/filepreparation"><span style="text-decoration:underline;">file preparation video</span></a> that explains how to create a bleed in your artwork.'
      }
    }
  },
  browserSupport: {
    name: "Browsers",
    questions: {
      browsersSupported: {
        q: "What browsers work with the Brandly app?",
        a: 'The Brandly app is designed to operate on modern browsers. We recommend our users to use the following supported browsers:\
              <ul style = "width:170px;line-height:2;">\
                <li style="margin-left:1.5em;"> \
                <a href="https://www.google.com/chrome"><span style="text-decoration:underline;">Google Chrome</span></a>\
                <img style = "float:right" src="/static/images/support/chrome.png" height="24" width="24"></li>\
                <li style="margin-left:1.5em;"> \
                <a href="https://www.mozilla.org/en-US"><span style="text-decoration:underline;">Mozilla Firefox</span></a>\
                <img style = "float:right" src="/static/images/support/firefox.png" height="24" width="24"></li>\
                <li style=" display: none; /*TODO coming soon*/ margin-left:1.5em;"> \
                <a href="https://www.apple.com/safari"><span style="text-decoration:underline;">Apple Safari</span></a>\
                <img style = "float:right" src="/static/images/support/safari.png" height="24" width="24"></li>\
                <li style=" display: none; /*TODO coming soon*/ margin-left:1.5em;"> \
                <a href="https://www.microsoft.com/en-us/windows/microsoft-edge"><span style="text-decoration:underline;">Microsoft Edge</span></a>\
                <img style = "float:right" src="/static/images/support/edge.png" height="24" width="24"></li>\
              </ul>'
      },
      otherBrowsers: {
        q: "What about other browsers?",
        a: "Browsers other than those present in the list of recommended web browsers may have compatibility issues with the Brandly App and we recommend users to switch\
               to a browser in the list if they are using one that is not present here."
      },
      olderBrowsers: {
        q: "What about older versions of approved browsers?",
        a: 'Most modern web browsers will automatically update themselves so that you are always running the most current version. You no longer need to actually\
                "download and install" the latest version yourself; it will do it for you.'
      }
    }
  },
  businesscardTemplates: {
    name: "Business Card Templates",
    questions: {
      squareCorners: {
        q: "Standard Size Business Cards",
        a: 'To begin creating your (US) Standard Size Business Cards designs, please download a blank template.',
        l: ' <a href="/static/downloads/blank-ai-templates.zip">Adobe Illustrator Template</a>'
      }
    }
  },
  fileupload: {
    name: "File Upload",
    questions: {
      fileuploadPDF: {
        q: "Why do you require a PDF upload to create my business card template?",
        a: "Everything we need is in the PDF, including embedded fonts and graphics which means fewer issues. PDF is the print industry standard so\
              from one provider to the next, they allow a consistent and unchanging view of what the file should look like. <strong>Note:</strong> while\
              we require a PDF to generate your online business card template, you may upload image files within the Brandly app if your business card contains photos."
      },
      fileuploadFile: {
        q: "Are there any restrictions on the file size I upload?",
        a: "We limit the size of uploaded files to 5 megabytes. The physical size of the layout should be standard landscape or portrait size for\
            a US business card - or 3.5 x 2 inches or 2 x 3.5 inches plus bleed if necessary. Learn more about file dimensions in the Artwork section of our support docs."
      },
      fileuploadScan: {
        q: "Can I upload a scan of my card saved as a PDF?",
        a: "<b>Scanned images</b> or photos of your business card saved as PDFs <b>do not work</b>. Scans and photos, are made up of pixels - tiny squares of\
               individual color - that make up what you see on your screen, but do not contain the necessary embedded graphic information - fonts, logos, images\
               - to make high quality graphic reproductions."
      },
      fileuploadOriginal: {
        q: "What happens to my original artwork file on upload?",
        a: 'Your PDF file is convered into a 2 layer file - an editable "type layer" in <a href="https://en.wikipedia.org/wiki/Scalable_Vector_Graphics"> \
            <span style="text-decoration:underline;">SVG format</span></a> and a background layer which consists of any static background artwork \
            (e.g. images and logos). Your original file and the converted file are saved in the cloud for future use.'

      },
      fileuploadProblem: {
        q: "What should I do if there is a problem during my upload?",
        a: 'If you see something in the proof that looks wrong or if your file fails to upload, \
                please contact us and we will look into the the underlying probem.'
      },
      fileCommmonproblems: {
        q: "What are the most common problems you encounter with file upload?",
        a: 'Here is a list of issues that frequently cause problems:\
              <ul>\
                <li style="margin-left:1.5em;">incorrect document (trim) size</li>\
                <li style="margin-left:1.5em;">missing bleeds (extending artwork 1/8" beyond trim size) </li>\
                <li style="margin-left:1.5em;">leaving trim marks in the file. Files need only contain artwork that prints. Leave off extraneous marks. </li>\
                <li style="margin-left:1.5em;">missing fonts - we do not have your fonts. Please contact us to resolve.</li>\
                <li style="margin-left:1.5em;">garbled text/fonts - often associated with 2-page PDFs that are created using MacOS Preview utility</li>\
                \
              </ul>'
      }
    }
  },
  fonts: {
    name: "Fonts",
    questions: {
      fontInclude: {
        q: "How do I include fonts in my business card PDF for you to match?",
        a: "If you save your file <strong>without</strong> converting the text to outlines, you include fonts in your file thanks to the Adobe PDF format. \
            When you convert fonts to outlines in Adobe Illustrator or InDesign you erase all of the embedded font information and render the text uneditable to service providers. \
            If you want to be able to make a file editable in the Brandly application, do <b>not</b> convert fonts to outlines."
      },
      fontMatch: {
        q: "How does Brandly match the fonts in my PDF?",
        a: "We extract the font information from your uploaded PDF and use algorithms to compare it to our library of fonts from which\
            we find matches."
      },
      fontWhy: {
        q: "Why does Brandly need to match the fonts in my PDF?",
        a: "The Adobe PDF format only stores the font information necessary to support the characters used in a given file. In order to make the file editable; to create any letter,\
            number, or character in a given font, we need to have the matching font resident in our computer systems."
      },
      fontMissing: {
        q: "What if you don't have my font?",
        a: 'If we do not have your font, you will encounter a "font missing" error upon uploading your PDF. If this happens, please contact us and we will look into obtainibng\
            the missing font.'
      },
      fontScramble: {
        q: "Why do my letters look scrambled?",
        a: 'We have emcountered some uploads that contain garbled or scrambled text and have tracked it down to files edited in the MacOS Preview utility. If you encounter\
            scrambled text, please send up your artwork files and we will resave them for you.'
      }
    }
  },
  orders: {
    name: "Orders",
    questions: (_questions = {
      ordersTeam: {
        q: "How do I place an order for myself?",
        a: 'Log in and find your design template and edit the fields as necessary, add to your cart and checkout. Ordering usually takes about a minute.'
      }

    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_questions, "ordersTeam", {
      q: "What is the best way to order for large teams?",
      a: 'If you are an account admin, go to the "teams" tab on your dashboard and invite team members to self-order. When you send a team member an invite and they\
            accept, they need only imput a few missing pieces of information and they will be presented with a final proof and then they can check out.'
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_questions, "ordersReorder", {
      q: "How do I place reorders?",
      a: "There are a few ways to place a reorder - log into your account and go to the orders tab and find the order you wish to reorder and\
            click submit. Alternatively, you may search for a specific order ID in your email and click on the reorder link in your original order\
            confirmation."
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_questions, "ordersChange", {
      q: "Can I request a change after I approve my proof?",
      a: "If you catch a mistake after editing and proofing your card you may either hit the back button in your browser to navigate to\
            the page where you edited your card information or you may drop the item from your cart at checkout."
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_questions, "ordersCharge", {
      q: "When do you charge my credit card?",
      a: "Your card is charged when your order is submitted into production."
    }), _questions)
  },
  paper: {
    name: "Paper",
    questions: {
      paperTypes: {
        q: "What types of papers and substrates do you print on?",
        a: 'We print on eighteen different papers and substrates from 11pt to 34pt in thickness. We have coated and uncoated papers, bright white paper, \
              linen and vellum textured papers, UV gloss and Soft-touch finishes, double-thick and Color Core card stocks, as well as plastic, and pearlescent subtrates. \
              There is a great choice for every design and every use case. Click on the "Business Cards" link in the header to learn more about our papers.'
      },
      paperPopular: {
        q: "What are your most popular papers?",
        a: "Standard Uncoated is a popular choice and a great value. It's clean, super-white, and it's easy to write on with pen or pencil. We also find a lot of customers gravitate to matte coated papers\
             in both Standard and Premium weights because they're versatile - great for fine print and saturated color."
      },
      paperHeavyink: {
        q: "What are your best papers for heavy ink coverage?",
        a: 'Coated papers are the best option for heavy ink coverage. We carry coated papers in both Standard 14 pt. and Premium 16 pt. thicknesses. UV Coating is a  \
            great option for photo cards or edge-to-edge ink coverage.'
      },
      paperThickness: {
        q: "How thick are your thickest papers?",
        a: "We sell a Double Thick Ultrawhite card that weighs in at 34 pt. That's over twice as thick as our 16 pt. Premium papers so plenty thick for anyone looking for that type of product. \
            The Color Core papers are all 32 pt. so they're also double the thickness of most Premium papers and available with 5 different seam colors that are visible along the edge of each card."
      },
      paperSoftTouch: {
        q: "What is Soft Touch?",
        a: 'SofTouch is actually a coating applied to the front side of your cards that makes them feel soft to the touch. The texture is often described as  \
            "velvety" or "refined" - a tactile experience that surprises many of our customers. For best results and a superior tactile experience, we recommend \
            choosing Soft Touch for projects with light coverage artwork, where the design background is "mostly white".'
      },
      paperCustom: {
        q: "Do you print on other papers or substrates not listed on the website?",
        a: 'We have pared our paper options down to the ones most customers care about but if you have a special request, plese contact us and we will let you know if we can\
            find it.'
      }
    }
  },
  printing: {
    name: "Printing",
    questions: {
      printingSize: {
        q: "What size are the business cards you print?",
        a: 'Brandly currently offers Standard US sized cards:\
              <ul>\
                <li style="margin-left:1.5em;">3.5 x 2 inches landscape</li>\
                <li style="margin-left:1.5em;">2 x 3.5 inches portrait</li>\
                \
              </ul>'
      },
      printingFullcolor: {
        q: "Do you print in full color?",
        a: 'Yes, we print full color on one or both sides. Full color printing, also called four-color process printing, combines four "additive" colors -\
               cyan, yellow, magenta, and black - to create the full gamut of colors.'
      },
      printingBothsides: {
        q: "Do you print on both sides?",
        a: "Yes, we print full color on one or both sides. Be sure to follow our instructions in the Artwork and File Upload sections of this FAQ on how to best\
            prepare and upload files for 2 sided business cards."
      },
      printingBothsidecosts: {
        q: "Is there an extra charge for printing on the second side of my business cards?",
        a: "No, second side printing is<strong> FREE </strong>on all business cards."
      },
      printingRaised: {
        q: "Do you offer raised printing?",
        a: 'We offer <a href="https://en.wikipedia.org/wiki/Thermographic_printing"><span style="text-decoration:underline;">thermography</span></a> which is a process where plastic is applied to the printed page and heated causing\
               the printed image to "rise" resulting in raised printing.'
      },
      printingFinishing: {
        q: "What finishing options do you offer?",
        a: 'We offer rounded corners - adding a radius to all 4 corners of your cards - on most paper stocks. Go to the "Business Cards" link\
            in the header to learn more.'
      }
    }
  },
  shipping: {
    name: "Shipping",
    questions: {
      shippingCost: {
        q: "How much does shipping cost?",
        a: "Shipping is <strong>FREE</strong> on all orders. Really."
      },
      shippingHow: {
        q: "How do orders ship?",
        a: "All orders are shipped UPS Ground."
      },
      shippingArrive: {
        q: "How long does it take to print and ship my order?",
        a: "Your business cards will be <strong>printed in 3 business days</strong> after the day you place your order and UPS Ground will add <strong> 3 - 5 shipping days</strong>.\
               Note: Brandly's business days are Monday to Friday, excluding major US holidays. "
      },
      shippingTrack: {
        q: "Can I track my order?",
        a: "We email a tracking link to you when we ship your order."
      }

    }
  },
  support: {
    name: "Support",
    questions: {
      supportGeneral: {
        q: "What is the best way to find out more about the application or your products?",
        a: 'We prefer that you use our chat, email, or our <a href="https://www.brandly.com/contact"><span style="text-decoration:underline;">contact form</span></a> as a first step.'
      },
      supportUpload: {
        q: "I'm having trouble uploading a PDF of my business card.",
        a: 'Click the suggested links on the upload page or go directly to the Artwork and File Upload sectons of this FAQ. Contact us if the issue persists.'
      },

      supportLogin: {
        q: "I'm having trouble signing in.",
        a: 'Try the "Forgot password" link on the Sign-In page first. Contact us if the issue persists.'
      },
      supportQuote: {
        q: "Can I get a quote?",
        a: 'If you need a custom quote on a project, please contact us.'
      },
      supportRep: {
        q: "Can I speak to a support representative?",
        a: 'Leave us your number and we will call you back.'
      }
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["topic", "question"],
  computed: {
    topics: function topics() {
      return FAQ;
    },
    name: function name() {
      return FAQ[this.topic].name;
    },
    questions: function questions() {
      return FAQ[this.topic].questions;
    }
  }
});

/***/ }),

/***/ "DllR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Duz3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_join__ = __webpack_require__("4dyO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_full_name_splitter__ = __webpack_require__("zImE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_full_name_splitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_full_name_splitter__);






/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    joinInfo: {
      loaded: false,
      teamName: null
    }
  },
  mutations: {
    setJoinState: function setJoinState(state, obj) {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(state.joinInfo, obj);
    }
  },
  actions: {
    loadJoinTeamData: function loadJoinTeamData(_ref, _ref2) {
      var _this = this;

      var commit = _ref.commit;
      var team = _ref2.team,
          token = _ref2.token;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var teamData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_3__services_join__["a" /* loadJoinTeamData */])(team, token);

              case 3:
                teamData = _context.sent;

                commit('setJoinState', {
                  loaded: true,
                  teamName: teamData.name
                });
                _context.next = 9;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    }
  },
  getters: {
    joinTeamName: function joinTeamName(state) {
      return state.joinInfo.teamName;
    },
    joinTeamUrl: function joinTeamUrl(state, getters) {
      var team = getters.team;
      return team && {"API":"https://www.brandly.com/backend/","APP":"https://www.brandly.com","STATIC":false}.APP + '/join/' + team.id + '/' + team.join_token;
    },
    joinTeamLoaded: function joinTeamLoaded(state) {
      return state.joinInfo.loaded;
    }
  }
});

/***/ }),

/***/ "EBMx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EF6X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomepageLayout_vue__ = __webpack_require__("iGgY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2328ffd8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomepageLayout_vue__ = __webpack_require__("LSvg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomepageLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2328ffd8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomepageLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "EIcW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16912fde_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GetPortalButton_vue__ = __webpack_require__("o3pX");
function injectStyle (ssrContext) {
  __webpack_require__("uexP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16912fde"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16912fde_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GetPortalButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "EJNV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EJd9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return { ready: true };
  },
  mounted: function mounted() {
    var _this = this;

    window.onOauth = function (provider, _ref) {
      var code = _ref.code;

      _this.$emit('login', { provider: provider, code: code });
    };
  },
  beforeDestroy: function beforeDestroy() {
    delete window.onOauth;
  },

  methods: {
    onClick: function onClick() {
      var base = 'https://www.linkedin.com/oauth/v2/authorization';
      var params = {
        response_type: 'code',
        client_id: '86em1vwv504o9r',
        redirect_uri: window.location.origin + '/oauth/linkedin',
        state: '987654321', // we don't check this so no point making it random
        scope: 'r_basicprofile r_emailaddress'
      };
      var url = base + '?' + Object(__WEBPACK_IMPORTED_MODULE_0_qs__["stringify"])(params);
      window.open(url, 'linkedinAuth', 'width=600,height=400');
    }
  }
});

/***/ }),

/***/ "EURA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  meta: { title: "Sign In To Your Account" },
  data: function data() {
    return {
      email: "",
      password: "",
      forgot: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["loginBusy", "loginError", "resetState", "resetMessage"]), {
    badCreds: function badCreds() {
      return (/Unable to login with provided credentials/.test(this.loginError || "")
      );
    },
    systemError: function systemError() {
      return !this.badCreds && this.loginError;
    },
    showWelcome: function showWelcome() {
      return !this.badCreds && this.resetState !== "ok";
    },
    formValid: function formValid() {
      return this.email && this.password;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["login", "resetPassword", "socialAuth"]), {
    submit: function submit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.login({ username: _this.email, password: _this.password });

              case 2:
                _this.redirect();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    reset: function reset() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.resetPassword(_this2.email);

              case 2:
                if (_this2.resetState === "ok") {
                  _this2.forgot = false;
                }

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    onGoogleLogin: function onGoogleLogin(userinfo) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log("google user:", userinfo);
                _context3.next = 3;
                return _this3.socialAuth({
                  provider: "google",
                  access_token: userinfo.auth.access_token
                });

              case 3:
                _this3.redirect();

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    onFacebookLogin: function onFacebookLogin() {
      // not implemented

      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    onLinkedInLogin: function onLinkedInLogin(info) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                console.log("linkedin info:", info);
                _context5.next = 3;
                return _this5.socialAuth(info);

              case 3:
                _this5.redirect();

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    redirect: function redirect() {
      if (!this.loginError) this.$router.push("/dashboard");
    }
  })
});

/***/ }),

/***/ "EWPh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Edwh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e1c37a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Testimonial_vue__ = __webpack_require__("i/xQ");
function injectStyle (ssrContext) {
  __webpack_require__("g7AP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e1c37a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Testimonial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "EiWH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberRow_vue__ = __webpack_require__("iUmS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3471c1d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberRow_vue__ = __webpack_require__("AUhL");
function injectStyle (ssrContext) {
  __webpack_require__("en40")
  __webpack_require__("DC6H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3471c1d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3471c1d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ElTA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_selectedProduct__ = __webpack_require__("D3mI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UploaderBox_vue__ = __webpack_require__("ejR0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SideMenu_vue__ = __webpack_require__("MGPA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PseudoToolBar_vue__ = __webpack_require__("N/nZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FixedMenu_vue__ = __webpack_require__("xIwb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_track_events__ = __webpack_require__("Dg6a");



//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['selectedInfo', 'designId'],
  components: { UploaderBox: __WEBPACK_IMPORTED_MODULE_5__UploaderBox_vue__["a" /* default */], SideMenu: __WEBPACK_IMPORTED_MODULE_6__SideMenu_vue__["a" /* default */], ToolBar: __WEBPACK_IMPORTED_MODULE_7__PseudoToolBar_vue__["a" /* default */], FixedMenu: __WEBPACK_IMPORTED_MODULE_8__FixedMenu_vue__["a" /* default */] },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.designId) {
                _context.next = 4;
                break;
              }

              _context.next = 3;
              return _this.setCurrentDesignId(_this.designId);

            case 3:
              _this.startOrder({ destination: '/cart' });

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var selectedInfo;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this2.selectedInfo === 'default')) {
                _context2.next = 5;
                break;
              }

              _context2.next = 3;
              return _this2.loadDefaultProductInfo();

            case 3:
              selectedInfo = Object(__WEBPACK_IMPORTED_MODULE_4__lib_selectedProduct__["a" /* compressed */])(_this2.defaultProductSelector);

              _this2.$router.replace({ name: 'Upload', params: { selectedInfo: selectedInfo, designId: _this2.designId } });

            case 5:
              Object(__WEBPACK_IMPORTED_MODULE_9__lib_track_events__["j" /* uploadPageVisited */])();

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['design', 'defaultProductSelector']), {
    uploadExtra: function uploadExtra() {
      var p = Object(__WEBPACK_IMPORTED_MODULE_4__lib_selectedProduct__["b" /* expanded */])(this.selectedInfo);
      return { force_two_pages: !!(p[2] && !p[1]) };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['setDesign', 'addLineFromProductSelector', 'setCurrentDesignId', 'dropSecondPageFromDesign', 'showEditorMessage', 'loadDefaultProductInfo']), {
    onUpload: function onUpload(event) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var design;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                Object(__WEBPACK_IMPORTED_MODULE_9__lib_track_events__["l" /* uploadedFileSuccess */])();
                event.preventDefault();
                design = event.design;

                _this3.setDesign(design);
                return _context3.abrupt('return', _this3.startOrder());

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    onError: function onError(event) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                Object(__WEBPACK_IMPORTED_MODULE_9__lib_track_events__["k" /* uploadedFileError */])(event);

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    startOrder: function startOrder() {
      var _this5 = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          destination = _ref.destination;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this5.addLineFromProductSelector(_this5.selectedInfo);

              case 2:
                _this5.$router.push(destination || { name: 'Editor', params: { id: _this5.design.id } });

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    }
  })
});

/***/ }),

/***/ "EpMG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_debouncePromise__ = __webpack_require__("cOIa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EditMemberAddress__ = __webpack_require__("P1+S");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { EditMemberAddress: __WEBPACK_IMPORTED_MODULE_7__EditMemberAddress__["a" /* default */] },
  props: ['memberId'],
  data: function data() {
    console.log('data!', this.member);
    return {
      saving: false,
      editing: false,
      info: null,
      optimisticAddress: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["member", "combinedMemberAddresses", "defaultMemberAddress", "personalVars"]), {
    address: {
      get: function get() {
        return this.optimisticAddress || this.defaultMemberAddress;
      },
      set: function set(address) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  // Ensure the address is immediately reflected in the getter, even
                  // though it takes time for the "set" operation to round trip from server.
                  _this.optimisticAddress = address;
                  _context.next = 3;
                  return _this.setDefaultMemberAddress(address);

                case 3:
                  // Avoid possible bugs by clearing this cached value.
                  _this.optimisticAddress = null;

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }))();
      }
    }
  }),
  mounted: function mounted() {
    console.log('mount', this.info, this.member);
    this.setOrdereeId(this.memberId);
    this.setInfo();
    this.refreshTeamAddresses();
  },
  beforeDestroy: function beforeDestroy() {
    console.log('beforeDestroy');
    this.info = null;
  },

  watch: {
    member: {
      deep: true,
      handler: function handler(val, old) {
        console.log('watch: member', this.info, val);
        if (val) this.setInfo();
      }
    },
    info: {
      deep: true,
      handler: function handler(val, old) {
        // Save whenever info changes, except the first time (old is null)
        // or last (val is null).
        if (val && old) this.save();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(['updateUserProfile', 'refreshTeamAddresses', 'setDefaultMemberAddress', 'setOrdereeId']), {
    setInfo: function setInfo() {
      if (!this.member || !this.member.id) return; // Only run if this has been set
      if (this.info && this.info.id == this.member.id) return; // Only run once

      var _ref = this.member || {},
          _ref$personal_info = _ref.personal_info,
          personal_info = _ref$personal_info === undefined ? {} : _ref$personal_info,
          id = _ref.id,
          email = _ref.email,
          first_name = _ref.first_name,
          last_name = _ref.last_name;

      this.info = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, { id: id, email: email, first_name: first_name, last_name: last_name }, personal_info);
      console.log('setInfo', this.info, this.setDefaultMemberAddress);
    },

    save: Object(__WEBPACK_IMPORTED_MODULE_5__lib_debouncePromise__["a" /* default */])(function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _info, id, email, first_name, last_name, personal_info;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.saving = true;
                _info = this.info, id = _info.id, email = _info.email, first_name = _info.first_name, last_name = _info.last_name, personal_info = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_info, ["id", "email", "first_name", "last_name"]);
                _context2.next = 4;
                return this.updateUserProfile({ id: id, email: email, first_name: first_name, last_name: last_name, personal_info: personal_info });

              case 4:
                this.saving = false;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function save() {
        return _ref2.apply(this, arguments);
      }

      return save;
    }(), 500)
  })
});

/***/ }),

/***/ "Ev13":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_products_js__ = __webpack_require__("6TJt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_selectedProduct__ = __webpack_require__("D3mI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_productAttrs__ = __webpack_require__("X9yx");







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// Common function that is invoked by watch on paper, quantity and corners.
// Trigger save upon change and 250 ms after user has stopped fiddling
var triggerSave = _.debounce(function (val, old) {
  if (this.autoSave && old !== null) this.save();
}, 250, { leading: true });

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    line: Object,
    autoSave: { type: Boolean },
    restrictQty: { type: Boolean },
    restrictProduct: { type: Boolean }
  },
  data: function data() {
    return {
      products: [],
      productUrls: {},
      paperOptionGroups: [],
      paper: null,
      quantity: null,
      corners: null,
      saving: true
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.loadProducts();

            case 2:
              _this.setCurrentValues();

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    price: function price() {
      return this.info && this.info.price;
    },
    quantityOptions: function quantityOptions() {
      var quantities = this.selectedProducts.map(function (p) {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(p.prices);
      });
      return Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["sortBy"])(Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["uniq"])(Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["flatten"])(quantities)), parseInt);
    },
    cornerOptions: function cornerOptions() {
      // Always put square first
      // reverse the array so we sort by highest index first and unfound items (-1) are last
      var order = ['Square', 'Rounded'].reverse();
      var sortFn = function sortFn(a, b) {
        return order.indexOf(b) - order.indexOf(a);
      };
      return Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["uniq"])(this.selectedProducts.map(function (p) {
        return p.attrs.corners;
      })).sort(sortFn);
    },
    selectedProducts: function selectedProducts() {
      var _this2 = this;

      return this.products.filter(function (_ref) {
        var name = _ref.name;
        return name === _this2.paper;
      });
    },
    info: function info() {
      // Return url, price for current # of sides.
      // If the # of sides isn't an option for chosen product,
      // choose a valid # of sides and add a 'sides' key.
      // TODO caller should do something intelligent with the 'sides' key
      // TODO what about corners mismatch
      var otherSide = null;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.selectedProducts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var p = _step.value;

          if (p.attrs.corners !== this.corners) continue;
          var price = p.prices[this.quantity];
          var url = p.urls[this.quantity];
          if (+p.attrs.sides === this.numSides) {
            return { price: price, url: url };
          } else {
            otherSide = { price: price, url: url, sides: p.attrs.sides };
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      console.log('not a perfect match ->', otherSide);
      return otherSide;
    },
    numSides: function numSides() {
      // Use preview_urls as proxy for nunber of pages on the design (so we don't load)
      // anything else here
      return this.line.preview_urls.length;
    }
  },
  watch: {
    quantity: triggerSave,
    paper: triggerSave,
    corners: triggerSave
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])(['selectProduct']), {
    loadProducts: function loadProducts() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = _this3;
                _context2.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_7__services_products_js__["a" /* products */])('any');

              case 3:
                _context2.t1 = _context2.sent;
                _this3.products = _context2.t0.decorateProducts.call(_context2.t0, _context2.t1);

                _this3.calcOptions();

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    setCurrentValues: function setCurrentValues() {
      console.log(this.line);
      this.quantity = +this.line.boxSize;
      try {
        this.paper = this.productUrls[this.line.product.url].name;
        console.log('paper->', this.paper);
      } catch (e) {
        console.error('cant set paper from url', e);
        console.log(this.line.product.url, this.productUrls, this.productUrls[this.line.product.url]);
        console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.productUrls, null, 4));
      }
      this.corners = Object(__WEBPACK_IMPORTED_MODULE_11__lib_productAttrs__["a" /* isRounded */])(this.line.product) ? 'Rounded' : 'Square';
      this.saving = false;
    },
    decorateProducts: function decorateProducts(products) {
      // decorate the products with an unpacked attrs, derived from product.attributes
      // same with prices
      // Also set productUrls
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(products), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var p = _step2.value;

          p.attrs = {};
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(p.product.attributes), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _ref2 = _step3.value;
              var sku_tag = _ref2.sku_tag;

              var _sku_tag$split = sku_tag.split(':'),
                  _sku_tag$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_sku_tag$split, 2),
                  key = _sku_tag$split2[0],
                  value = _sku_tag$split2[1];

              p.attrs[key] = value;
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          p.prices = {};
          p.urls = {};
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(p.product.prices), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var _ref3 = _step4.value;
              var quantity = _ref3.quantity,
                  retail_price = _ref3.retail_price,
                  stockrecord = _ref3.stockrecord;

              p.prices[quantity] = retail_price;
              p.urls[quantity] = stockrecord.product;
              this.productUrls[stockrecord.product] = p;
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return products;
    },
    calcOptions: function calcOptions() {
      console.log(this.products);
      function category_title(product) {
        var s = product.category_name;
        s = s.replace('colorcore', 'color core');
        return s.replace(/\b[a-z]/g, function (m) {
          return m[0].toUpperCase();
        });
      }
      var categorized = Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["groupBy"])(this.products, category_title);
      console.log(categorized);
      this.paperOptionGroups = Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["mapValues"])(categorized, function (l) {
        return Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["uniq"])(l.map(function (p) {
          return p.name;
        }));
      });
    },
    save: function save() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log('save');

                if (!_this4.saving) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt('return', console.log('already saving'));

              case 3:
                if (_this4.line) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt('return', console.log('no selected line'));

              case 5:
                if (_this4.info) {
                  _context4.next = 7;
                  break;
                }

                return _context4.abrupt('return', console.log('no info'));

              case 7:
                if (!(_this4.saving || !_this4.line || !_this4.info)) {
                  _context4.next = 9;
                  break;
                }

                return _context4.abrupt('return');

              case 9:
                console.log('saving...');

                // Event handler can call:
                // await evt.saving(this.action(...));
                // ...for spinner to show
                _this4.$emit('save', {
                  boxSize: _this4.quantity,
                  product: _this4.info.url,

                  saving: function () {
                    var _ref4 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3(promise) {
                      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              _this4.saving = true;
                              _context3.next = 3;
                              return promise;

                            case 3:
                              _this4.saving = false;

                            case 4:
                            case 'end':
                              return _context3.stop();
                          }
                        }
                      }, _callee3, _this4);
                    }));

                    return function saving(_x) {
                      return _ref4.apply(this, arguments);
                    };
                  }(),
                  start: function start() {
                    return _this4.saving = true;
                  },
                  done: function done() {
                    return _this4.saving = false;
                  }
                });

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    }
  })
});

/***/ }),

/***/ "F5BH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineAddressLists;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function combineAddressLists(teamAddrs, userAddrs, defaultTeamAddrId) {
  var userTag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'user';

  // Combine address lists. This decorates the addresses, so that UI can treat the types the same.
  teamAddrs = tagAddrs('team', teamAddrs);
  userAddrs = tagAddrs(userTag, userAddrs);
  if (defaultTeamAddrId) {
    // Set is_default_for_shipping flag on the team address.
    // This way UI can just use this flag.
    teamAddrs.forEach(function (addr) {
      if (addr.id === defaultTeamAddrId) {
        addr.is_default_for_shipping = true;
      }
    });
    // Unset flag on the user addrs. At API level, the is_default_for_shipping flag is not written
    // to user addresses when a team address is favorited, so for the UI to be able to use the flag
    // we clear it now.
    userAddrs.forEach(function (addr) {
      return addr.is_default_for_shipping = false;
    });
  }
  return userAddrs.concat(teamAddrs);
}

function tagAddrs(type, addrs) {
  return (addrs || []).map(function (a) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, a, { type: type });
  });
}

/***/ }),

/***/ "FAAZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FBhG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamShareInput_vue__ = __webpack_require__("vIT7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee962d32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeamShareInput_vue__ = __webpack_require__("0JyP");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamShareInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee962d32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeamShareInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "FNdV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FPeH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = orderStatus;
/* harmony export (immutable) */ __webpack_exports__["f"] = shortStatus;
/* unused harmony export ORDER_CREATED */
/* unused harmony export WAITING_FOR_REVIEW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return READY_FOR_PRODUCTION; });
/* unused harmony export PENDING_PRODUCTION */
/* unused harmony export IN_PRODUCTION */
/* unused harmony export PARTIALLY_SHIPPED */
/* unused harmony export SHIPPED */
/* unused harmony export DELIVERED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MAIN_STATUSES; });
/* unused harmony export resendable */
/* unused harmony export unsent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

function orderStatus(status) {
  var _WAITING_FOR_REVIEW$O;

  // Remap statuses to a smaller set that is presented to users
  return (_WAITING_FOR_REVIEW$O = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_WAITING_FOR_REVIEW$O, WAITING_FOR_REVIEW, 'review'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_WAITING_FOR_REVIEW$O, ORDER_CREATED, 'open'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_WAITING_FOR_REVIEW$O, READY_FOR_PRODUCTION, 'open'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_WAITING_FOR_REVIEW$O, PENDING_PRODUCTION, 'open'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_WAITING_FOR_REVIEW$O, IN_PRODUCTION, 'open'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_WAITING_FOR_REVIEW$O, PARTIALLY_SHIPPED, 'open'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_WAITING_FOR_REVIEW$O, SHIPPED, 'shipped'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_WAITING_FOR_REVIEW$O, DELIVERED, 'shipped'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_WAITING_FOR_REVIEW$O, CANCELLED, 'cancelled'), _WAITING_FOR_REVIEW$O)[status] || status;
}

function shortStatus(status) {
  var _ORDER_CREATED$WAITIN;

  // Return shorter labels of statuses for admin purposes.
  // Every status results in different value.
  return (_ORDER_CREATED$WAITIN = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ORDER_CREATED$WAITIN, ORDER_CREATED, 'Created'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ORDER_CREATED$WAITIN, WAITING_FOR_REVIEW, 'Review'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ORDER_CREATED$WAITIN, READY_FOR_PRODUCTION, 'Ready'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ORDER_CREATED$WAITIN, PENDING_PRODUCTION, 'Pending'), _ORDER_CREATED$WAITIN)[status] || status;
}

var ORDER_CREATED = 'Order Created';
var WAITING_FOR_REVIEW = 'Waiting for Review';
var READY_FOR_PRODUCTION = 'Ready for production';
var PENDING_PRODUCTION = 'Pending production';
var IN_PRODUCTION = 'In Production';
var PARTIALLY_SHIPPED = 'Partially Shipped';
var SHIPPED = 'Shipped';
var DELIVERED = 'Delivered';
var CANCELLED = 'Cancelled';

var ALL_STATUSES = [ORDER_CREATED, WAITING_FOR_REVIEW, READY_FOR_PRODUCTION, PENDING_PRODUCTION, IN_PRODUCTION, PARTIALLY_SHIPPED, SHIPPED, DELIVERED, CANCELLED];

// Main subset that staff need to care about
var MAIN_STATUSES = [READY_FOR_PRODUCTION, IN_PRODUCTION, SHIPPED];

function resendable(status) {
  // Statuses for which orders can be resent.
  return ALL_STATUSES.indexOf(status) > ALL_STATUSES.indexOf(READY_FOR_PRODUCTION);
}

function unsent(status) {
  // Statuses for which orders haven't been sent.
  return ALL_STATUSES.indexOf(status) < ALL_STATUSES.indexOf(PENDING_PRODUCTION);
}

/***/ }),

/***/ "FQ9t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Currency_vue__ = __webpack_require__("NlBh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bfedfff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Currency_vue__ = __webpack_require__("R6xP");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Currency_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bfedfff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Currency_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "FUN9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return putVerifyAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return postVerifyAddressData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCountries; });
/* harmony export (immutable) */ __webpack_exports__["c"] = addUserAddress;
/* harmony export (immutable) */ __webpack_exports__["n"] = updateUserAddress;
/* harmony export (immutable) */ __webpack_exports__["j"] = removeUserAddress;
/* harmony export (immutable) */ __webpack_exports__["o"] = userAddresses;
/* harmony export (immutable) */ __webpack_exports__["a"] = addMemberAddress;
/* harmony export (immutable) */ __webpack_exports__["l"] = updateMemberAddress;
/* harmony export (immutable) */ __webpack_exports__["h"] = removeMemberAddress;
/* harmony export (immutable) */ __webpack_exports__["e"] = memberAddresses;
/* harmony export (immutable) */ __webpack_exports__["b"] = addTeamAddress;
/* harmony export (immutable) */ __webpack_exports__["m"] = updateTeamAddress;
/* harmony export (immutable) */ __webpack_exports__["i"] = removeTeamAddress;
/* harmony export (immutable) */ __webpack_exports__["k"] = teamAddresses;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineService__ = __webpack_require__("tVbG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mungeAddress__ = __webpack_require__("RYrk");



var postUserAddress = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('post', 'api/v1/cart/custom/useraddresses/');
var putUserAddress = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('put', 'api/v1/cart/custom/useraddresses/:id/');
var deleteUserAddress = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('delete', 'api/v1/cart/custom/useraddresses/:id/');
var getUserAddresses = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('get', 'api/v1/cart/custom/useraddresses/', { mainKey: 'results' });

var postMemberAddress = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('post', 'api/v1/cart/custom/user/:uid/addresses/');
var putMemberAddress = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('put', 'api/v1/cart/custom/user/:uid/addresses/:id/');
var deleteMemberAddress = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('delete', 'api/v1/cart/custom/user/:uid/addresses/:id/');
var getMemberAddresses = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('get', 'api/v1/cart/custom/user/:uid/addresses/', { mainKey: 'results' });

var postTeamAddress = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('post', 'api/v1/cart/teamaddresses/');
var putTeamAddress = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('put', 'api/v1/cart/teamaddresses/:id/');
var deleteTeamAddress = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('delete', 'api/v1/cart/teamaddresses/:id/');
var getTeamAddresses = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('get', 'api/v1/cart/teamaddresses/', { mainKey: 'results' });

var putVerifyAddress = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('put', 'api/v1/cart/address/:id/:type/verify/');
var postVerifyAddressData = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('post', 'api/v1/cart/address/data/verify/');

var getCountries = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('get', 'api/v1/cart/countries/');

function processError(e) {
  // Transform error into usable error message
  if (e.response && e.response.data) {
    var errors = e.response.data;
    if (errors.detail) {
      throw translateAddressError(errors.detail);
    } else {
      console.error(e);
      console.log(errors);

      // Typical errors structure will be {key: ['This field may not be blank.']}
      // Translate that to: Label is required
      var req = [],
          errs = [];
      for (var key in errors) {
        if (errors[key].length === 1 && errors[key][0].match(/not be blank/)) {
          req.push(key);
        } else {
          errs.push(key + ': ' + errors[key].join(', '));
        }
      }
      if (req.length == 1) {
        errs.push(req[0] + ' is required');
      } else if (req.length > 1) {
        errs.push(req.join(', ') + ' are required');
      }
      throw errs.join('. ');
    }
  }
  throw translateAddressError(e);
}

function translateAddressError(error) {
  console.log('-->', error);
  if (/^duplicate key value/.test(error)) {
    return 'That address is already in your list';
  }
  return error;
}

function addUserAddress(address) {
  return postUserAddress(Object(__WEBPACK_IMPORTED_MODULE_1__mungeAddress__["b" /* toApiAddressFormat */])(address)).catch(processError);
}

function updateUserAddress(address) {
  return putUserAddress(address.id, Object(__WEBPACK_IMPORTED_MODULE_1__mungeAddress__["b" /* toApiAddressFormat */])(address)).catch(processError);
}

function removeUserAddress(address) {
  return deleteUserAddress(address.id).catch(processError);
}

function userAddresses() {
  return getUserAddresses().then(__WEBPACK_IMPORTED_MODULE_1__mungeAddress__["a" /* fromApiAddressFormat */]);
}

function addMemberAddress(uid, address) {
  return postMemberAddress(uid, Object(__WEBPACK_IMPORTED_MODULE_1__mungeAddress__["b" /* toApiAddressFormat */])(address)).catch(processError);
}

function updateMemberAddress(uid, address) {
  return putMemberAddress(uid, address.id, Object(__WEBPACK_IMPORTED_MODULE_1__mungeAddress__["b" /* toApiAddressFormat */])(address)).catch(processError);
}

function removeMemberAddress(uid, address) {
  return deleteMemberAddress(uid, address.id).catch(processError);
}

function memberAddresses(uid) {
  return getMemberAddresses(uid).then(__WEBPACK_IMPORTED_MODULE_1__mungeAddress__["a" /* fromApiAddressFormat */]);
}

function addTeamAddress(address) {
  return postTeamAddress(Object(__WEBPACK_IMPORTED_MODULE_1__mungeAddress__["b" /* toApiAddressFormat */])(address)).catch(processError);
}

function updateTeamAddress(address) {
  return putTeamAddress(address.id, Object(__WEBPACK_IMPORTED_MODULE_1__mungeAddress__["b" /* toApiAddressFormat */])(address)).catch(processError);
}

function removeTeamAddress(address) {
  return deleteTeamAddress(address.id).catch(processError);
}

function teamAddresses() {
  return getTeamAddresses().then(__WEBPACK_IMPORTED_MODULE_1__mungeAddress__["a" /* fromApiAddressFormat */]);
}

/***/ }),

/***/ "FY0g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showReviewSettings || _vm.showManagerNotify)?_c('div',{staticClass:"wrapper no-label-css"},[(_vm.showReviewSettings)?[_c('h3',[_vm._v("Review Settings")]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('b-form-group',{attrs:{"label":"Select appropriate admin to approve your order:"}},[_c('b-select',{attrs:{"options":_vm.approverOptions},model:{value:(_vm.checkoutInfo.reviewer),callback:function ($$v) {_vm.$set(_vm.checkoutInfo, "reviewer", $$v)},expression:"checkoutInfo.reviewer"}})],1)],1)]:_vm._e(),_vm._v(" "),(_vm.showManagerNotify)?[_c('h3',[_vm._v("Manager Notification")]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('b-form-checkbox',{model:{value:(_vm.checkoutInfo.managerCheckbox),callback:function ($$v) {_vm.$set(_vm.checkoutInfo, "managerCheckbox", $$v)},expression:"checkoutInfo.managerCheckbox"}},[_vm._v("Ordering of these business cards are approved by my manager")]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Manager email:"}},[_c('b-form-input',{model:{value:(_vm.checkoutInfo.reviewer),callback:function ($$v) {_vm.$set(_vm.checkoutInfo, "reviewer", $$v)},expression:"checkoutInfo.reviewer"}})],1)],1)]:_vm._e()],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FY8P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchForm_vue__ = __webpack_require__("PG+a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_367bc6b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchForm_vue__ = __webpack_require__("58+U");
function injectStyle (ssrContext) {
  __webpack_require__("bqQl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_367bc6b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "FZ1a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3037465a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopPapers_vue__ = __webpack_require__("p+bV");
function injectStyle (ssrContext) {
  __webpack_require__("HgD7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3037465a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3037465a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopPapers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FaP6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_dashboard__ = __webpack_require__("39Xj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_full_name_splitter__ = __webpack_require__("zImE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_full_name_splitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_full_name_splitter__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Flatfile importer settings
var licenseKey = "8023fb60-98f3-11e9-9a01-23081a1ddf80";
var scriptSource = "https://unpkg.com/flatfile-csv-importer/build/dist/index.min.js";
var emailValidator = {
  validate: 'regex_matches',
  // From http://emailregex.com/
  regex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  error: 'Please provide a valid email'
};
var addressValidator = {
  validate: 'regex_matches',
  regex: /SET LATER/i,
  error: 'Address not found'
};
var dataConfig = {
  fields: [{ label: "First Name", key: "first_name", isRequired: false }, { label: "Last Name", key: "last_name", isRequired: false }, { label: "Name", key: "full_name", isRequired: false }, { label: "Email", key: "email", isRequired: true, validator: emailValidator }, { label: "Title", key: "title", isRequired: false }, { label: "Phone 1", key: "ph1", isRequired: false }, { label: "Phone 2", key: "ph2", isRequired: false }, { label: "Address", key: "address", isRequired: false, validator: addressValidator }],
  type: 'Team member',
  allowCustom: false,
  managed: true, // Enable XLS upload
  styleOverrides: {
    borderRadius: '0px', // Flatfile wrapper, modals, & buttons
    primaryButtonColor: '#ea1947', // Primary buttons
    linkColor: '#ea1947', // Links
    linkAltColor: '#4a90e2', // :hover, :active, & :focus states of links
    primaryTextColor: '#50535b', // Main text color, background-color of certain buttons
    secondaryTextColor: '#9daab6', // 'Dimmed' text
    errorColor: '#d0011b', // Invalid and error indicator borders, icons, and text
    successColor: '#60b700', // Success text, buttons, icons, toggles, required indicators
    warningColor: '#f6a623', // Warning text and icons
    borderColor: '#e8e8e8', // Flatfile wrapper, modals, and some buttons
    fontFamily: '"aktiv-grotesk", sans-serif' // Main font
  },
  maxRecords: 1000
};
var importer = void 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      inviteEmail: '',
      isImporterBusy: false, // To indicate that importer is running
      isImporting: false, // To indicate that we are in the "importing" stage
      isImportingDone: false, // To indicate that the importing is done
      importerData: [], // Data received from importer
      savedUsersQty: 0,
      notSavedUsersQty: 0,
      invalidData: [], // To keep invalid data (after the API request)
      cancelled: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["teamId", "teamAddresses"])),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.loadTeamAddresses();

            case 2:
              _this.buildAddressIndex();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(["reloadTeamInfo", "loadTeamAddresses", "reloadTeamMembers"]), {
    initImporter: function initImporter() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var script;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isImporterBusy = true;

                if (!document.querySelector("script[src='" + scriptSource + "']")) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 4;
                return _this2.createImporter();

              case 4:
                _context2.next = 11;
                break;

              case 6:
                // Script tag does not added - we will add it and when it will be loaded,
                // we will create importer (it will open automatically).
                script = document.createElement("script");

                script.setAttribute("src", scriptSource);
                script.setAttribute("type", "text/javascript");
                script.onload = function () {
                  return _this2.createImporter();
                };
                document.head.appendChild(script);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    createImporter: function createImporter() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                importer = new FlatfileImporter(licenseKey, dataConfig);
                _context3.next = 3;
                return _this3.openImporter();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    openImporter: function openImporter() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                importer.requestDataFromUser().then(function (results) {
                  importer.close();
                  _this4.saveUsers(results.data);
                }, function () {
                  // Importer is closed by a user.
                  _this4.isImporterBusy = false;
                });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    saveUsers: function saveUsers(data) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, userData, key, full_name, first_name, last_name, email, title, ph1, ph2, address, personal_info, default_team_address, _splitter, _splitter2, payload, _e$response$data$erro, errors;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.isImporting = true;
                _this5.isImportDone = false;
                _this5.invalidData = [];
                _this5.importerData = data;
                _this5.savedUsersQty = 0;
                _this5.notSavedUsersQty = 0;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context5.prev = 9;
                _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(data);

              case 11:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context5.next = 34;
                  break;
                }

                userData = _step.value;

                if (!_this5.cancelled) {
                  _context5.next = 15;
                  break;
                }

                return _context5.abrupt("break", 34);

              case 15:
                for (key in userData) {
                  userData[key] = userData[key].trim();
                }
                full_name = userData.full_name, first_name = userData.first_name, last_name = userData.last_name, email = userData.email, title = userData.title, ph1 = userData.ph1, ph2 = userData.ph2, address = userData.address;
                personal_info = { title: title, ph1: ph1, ph2: ph2 };
                default_team_address = address ? _this5.findTeamAddress(address) : null;

                if (full_name) {
                  _splitter = __WEBPACK_IMPORTED_MODULE_8_full_name_splitter___default()(full_name);
                  _splitter2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_splitter, 2);
                  first_name = _splitter2[0];
                  last_name = _splitter2[1];
                }
                payload = { first_name: first_name, last_name: last_name, email: email, personal_info: personal_info, default_team_address: default_team_address };
                _context5.prev = 21;
                _context5.next = 24;
                return Object(__WEBPACK_IMPORTED_MODULE_7__services_dashboard__["i" /* postTeamUser */])(_this5.teamId, payload);

              case 24:
                _this5.savedUsersQty += 1;
                _context5.next = 31;
                break;

              case 27:
                _context5.prev = 27;
                _context5.t0 = _context5["catch"](21);

                _this5.notSavedUsersQty += 1;
                if (_context5.t0.response && _context5.t0.response.data) {
                  // Expect an object with an errors key. Use generic message if there is no errors key.
                  _e$response$data$erro = _context5.t0.response.data.errors, errors = _e$response$data$erro === undefined ? ["Error saving user"] : _e$response$data$erro;

                  _this5.invalidData.push(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, userData, { errors: errors }));
                }

              case 31:
                _iteratorNormalCompletion = true;
                _context5.next = 11;
                break;

              case 34:
                _context5.next = 40;
                break;

              case 36:
                _context5.prev = 36;
                _context5.t1 = _context5["catch"](9);
                _didIteratorError = true;
                _iteratorError = _context5.t1;

              case 40:
                _context5.prev = 40;
                _context5.prev = 41;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 43:
                _context5.prev = 43;

                if (!_didIteratorError) {
                  _context5.next = 46;
                  break;
                }

                throw _iteratorError;

              case 46:
                return _context5.finish(43);

              case 47:
                return _context5.finish(40);

              case 48:
                if (_this5.savedUsersQty > 0) {
                  _this5.reloadTeamInfo();
                  _this5.reloadTeamMembers();
                }
                _this5.isImportingDone = true;

              case 50:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[9, 36, 40, 48], [21, 27], [41,, 43, 47]]);
      }))();
    },
    buildAddressIndex: function buildAddressIndex() {
      var seen = { state: {}, postcode: {}, line1: {}, line2: {}, line3: {}, city: {}, country: {} };
      this.addressIndex = {};
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.teamAddresses), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var addr = _step2.value;

          for (var key in seen) {
            var value = addr[key];
            if (!value) continue;
            // Remove non-alphanumerics from key.
            value = value.toLowerCase();
            if (seen[key][value]) {
              delete this.addressIndex[value];
            } else {
              seen[key][value] = true;
              this.addressIndex[value] = addr.id;
            }
          }
        }

        // Update the validation regex to match only any of the values
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var keysEscaped = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.addressIndex).map(function (s) {
        return s.replace(/[^a-z0-9 ]/g, '\\$&');
      });
      addressValidator.regex = new RegExp('^(' + keysEscaped.join('|') + ')$', 'i');
      console.log(addressValidator.regex);
    },
    findTeamAddress: function findTeamAddress(matchKey) {
      // Given a string, find the matching team address id.
      // We allow matching by any field, as long as
      // that field is unique among the addresses.
      // So if matchKey is "CA" and there is one
      // address with state = "CA", its good.
      return this.addressIndex[matchKey.toLowerCase()];
    },
    cancelImporting: function cancelImporting() {
      this.cancelled = true;
    }
  })
});

/***/ }),

/***/ "Fs9o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fsh9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ft35":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CartCheckoutWrapper',[_c('section',{staticClass:"section",attrs:{"id":"page-order-received"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[(_vm.orderInfo.busy)?_c('div',{staticClass:"col-sm-12"},[_c('WaveSpinner')],1):(_vm.orderInfo.error)?_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.orderInfo.error))])]):(_vm.orderInfo.details)?_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"order-info"},[_c('h3',{staticClass:"title"},[_vm._v("Order Details")]),_vm._v(" "),_c('div',{staticClass:"alert alert-success active"},[_vm._v("Thank you, Your order has been "+_vm._s(_vm.receivedStatus)+".\n          ")]),_vm._v(" "),_c('p',[_vm._v("We've sent an order confirmation email to"),_c('strong',[_vm._v(" "+_vm._s(_vm.orderInfo.details.guest_email))])]),_vm._v(" "),_c('ul',{staticClass:"order-details"},[_c('li',{staticClass:"order"},[_c('span',{attrs:{"id":"detail-title"}},[_vm._v("Order Number:")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.orderInfo.details.number))])]),_vm._v(" "),_c('li',{staticClass:"date"},[_c('span',{attrs:{"id":"detail-title"}},[_vm._v("Date:")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.orderInfo.details.date_placed.substring(0,10)))])]),_vm._v(" "),_c('li',{staticClass:"total"},[_c('span',{attrs:{"id":"detail-title"}},[_vm._v("Total:")]),_vm._v(" "),_c('strong',[_c('span',{staticClass:"amount"},[_vm._v("$"+_vm._s((+_vm.orderInfo.details.total_incl_tax).toFixed(2)))])])]),_vm._v(" "),_c('li',{staticClass:"method"},[_c('span',{attrs:{"id":"detail-title"}},[_vm._v("Payment Method:")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.orderInfo.details.payment_method || 'Credit Card'))])])])]),_vm._v(" "),_c('SurveyLink'),_vm._v(" "),_c('div',{staticClass:"box table-responsive"},[_c('OrderSummary')],1)],1):_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"error"},[_vm._v("An error occurred, please go to the homepage")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FuP2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminPreferences_vue__ = __webpack_require__("/aou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_770a2cfa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminPreferences_vue__ = __webpack_require__("kJc9");
function injectStyle (ssrContext) {
  __webpack_require__("FAAZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-770a2cfa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminPreferences_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_770a2cfa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminPreferences_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G5mD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isBackButtonShown)?_c('BackButton',{staticClass:"mb-3"}):_vm._e(),_vm._v(" "),(!_vm.order)?_c('WaveSpinner'):_c('article',{key:_vm.order.id,staticClass:"order"},[_c('b-row',{staticClass:"order-header"},[_c('b-col',{attrs:{"lg":"5","sm":"7"}},[_c('div',[_vm._v("Order # "),_c('b',[_vm._v(_vm._s(_vm.order.number))])]),_vm._v(" "),_c('div',{staticClass:"long"},[_vm._v("Email "),_c('b',{attrs:{"title":_vm.order.guest_email}},[_vm._v(_vm._s(_vm.order.guest_email))])]),_vm._v(" "),(_vm.order.date_shipped)?_c('div',[_vm._v("Date Shipped "),_c('b',[_vm._v(_vm._s(_vm.order.date_shipped.substring(0,10)))])]):_c('div',[_vm._v("Date Placed "),_c('b',[_vm._v(_vm._s(_vm.order.date_placed.substring(0,10)))])]),_vm._v(" "),_c('div',[_vm._v("Total "),_c('b',[_vm._v("$"+_vm._s(_vm.order.total_incl_tax.toFixed(2)))])])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"4","sm":"5"}},[_c('dl',[_c('dt',[_vm._v("\n              Ship To\n              "),_c('AddressVerification',{attrs:{"address":_vm.order.shipping_address,"on-verification-finish":_vm.onAddressVerificationFinish,"address-type":"shipping"}})],1),_vm._v(" "),_c('dd',[_c('Address',{attrs:{"value":_vm.order.shipping_address}})],1),_vm._v(" "),_vm._t("shipping",null,{"order":_vm.order})],2)]),_vm._v(" "),_c('b-col',{staticClass:"order-actions text-center text-lg-left",attrs:{"lg":"3","sm":"12"}},[(_vm.showReviewButton(_vm.order))?_c('b-button',{staticClass:"d-lg-block mb-lg-3",attrs:{"to":_vm.reviewPagePath(_vm.order),"variant":"default"}},[_vm._v("Review")]):_vm._e(),_vm._v(" "),(_vm.showTrackButton(_vm.order))?_c('b-button',{staticClass:"d-lg-block mb-lg-3",attrs:{"variant":"default"},on:{"click":function($event){return _vm.trackOrder(_vm.order)}}},[_vm._v("Track")]):_vm._e(),_vm._v(" "),(_vm.showReorderButton(_vm.order))?_c('b-button',{staticClass:"d-lg-block mb-lg-3",attrs:{"disabled":_vm.showReorderButtonSpinner(_vm.order.id),"variant":"primary"},on:{"click":function($event){return _vm.onReOrder(_vm.order.id)}}},[(_vm.showReorderButtonSpinner(_vm.order.id))?_c('WaveSpinner',{attrs:{"inline":""}}):_c('span',[_vm._v("Re-order")])],1):_vm._e(),_vm._v(" "),_vm._t("actions",null,{"order":_vm.order})],2)],1),_vm._v(" "),_vm._l((_vm.order.lines),function(line){return _c('b-row',{key:line.url,staticClass:"order-line"},[_c('b-col',[_c('LineItemThumbnails',{attrs:{"preview_urls":line.preview_urls,"popover":""}})],1),_vm._v(" "),_c('b-col',[_c('b',[_vm._v("Qty:")]),_vm._v(" "+_vm._s(+line.quantity * +line.boxSize)+"\n        "),_c('div',[_vm._t("line-actions",null,{"order":_vm.order,"line":line})],2)]),_vm._v(" "),_c('b-col',{staticClass:"productTitle",attrs:{"sm":"12"}},[_vm._v("\n        "+_vm._s(line.productTitle || (line.product ? line.product.title : '(product information is loading)'))+"\n        "),_c('hr')])],1)})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G7wm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"onboard-section"}},[_c('h2',[_vm._v("Get Started")]),_vm._v(" "),(_vm.canLaunchTour)?_c('a',{staticClass:"minor cta-link",attrs:{"href":"#"},on:{"click":_vm.launchTour}},[_vm._v("Tour")]):_vm._e(),_vm._v(" "),_c('ol',_vm._l((_vm.steps),function(step){return _c('li',{key:step.key,class:{fulfilled: step.done, todo: !step.done, active: step.active},on:{"click":function($event){return _vm.onClickStep(step)}}},[_vm._v(_vm._s(step.title))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GSN3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      required: true
    }
  }
});

/***/ }),

/***/ "GTfq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: { card: Object, hideTitle: Boolean },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['user']), {
    isCardOwner: function isCardOwner() {
      return this.user.id === this.card.owner.id;
    },
    ownerName: function ownerName() {
      var owner = this.card.owner;
      return owner ? owner.first_name + ' ' + owner.last_name : 'another person on your team';
    }
  })
});

/***/ }),

/***/ "GhAm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gin7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_splitNametag__ = __webpack_require__("aa7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_splitNametag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__lib_splitNametag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_tiny_cookie__ = __webpack_require__("+FgK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_tiny_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_tiny_cookie__);









var loadedInfo = {};
try {
  loadedInfo = Object(__WEBPACK_IMPORTED_MODULE_7_tiny_cookie__["getCookie"])('info', JSON.parse) || { nametag: undefined };
} catch (e) {
  console.error(e);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    // id of member, or null for user
    ordereeId: null,
    info: loadedInfo
  },
  mutations: {
    setInfo: function setInfo(state, info) {
      state.info = info;
      Object(__WEBPACK_IMPORTED_MODULE_7_tiny_cookie__["setCookie"])('info', info, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default.a);
      console.log('info->', info);
    },
    setOrdereeId: function setOrdereeId(state, id) {
      state.ordereeId = id;
    }
  },
  actions: {
    setOrdereeId: function setOrdereeId(_ref, ordereeId) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('setOrdereeId', ordereeId);
      return ordereeId && dispatch('loadTeamMember', ordereeId);
    },
    updateLocalProfile: function updateLocalProfile(_ref2, info) {
      var commit = _ref2.commit,
          state = _ref2.state;

      // Store some info locally. This allows personalInfo
      // to be prefilled for anonymous users
      commit('setInfo', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.info || {}, info || {}));
    },
    updatePersonalInfo: function updatePersonalInfo(_ref3, info) {
      var dispatch = _ref3.dispatch,
          commit = _ref3.commit,
          getters = _ref3.getters;

      var u = getters.user;
      if (u) {
        return dispatch('updateProfile', { personal_info: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, u.personal_info, info) });
      } else {
        // Store some info locally. This allows personalInfo
        // to be prefilled for anonymous users
        commit('setInfo', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.info || {}, info || {}));
      }
    }
  },
  getters: {
    /**
     * Return personal info for the "current" person being ordered for.
     * @param {*} state
     */
    personalInfo: function personalInfo(state, getters) {
      var user = getters.orderee;
      if (!user) return mungeNametag(state.info);
      var address = getters.ordereeDefaultAddress;
      // TODO not sure if it makes sense to incorporate state.info here
      var info = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, state.info, user.personal_info || {});
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
        fname: user.first_name,
        lname: user.last_name,
        name: user.first_name + ' ' + user.last_name,
        email: user.email
      }, personalAddr(address), mungeNametag(info));
    },

    personalVars: function personalVars(state, getters) {
      return getters.orderee && _personalVars(getters.orderee.personal_info, getters.personalInfoSettings);
    },
    orderee: function orderee(state, getters) {
      return state.ordereeId ? getters.member : getters.user;
    },

    ordereeDefaultAddress: function ordereeDefaultAddress(state, getters) {
      if (!state.ordereeId) return;
      // Caller should ensure the team addresses are loaded
      var default_team_address = getters.orderee.default_team_address;
      // Return team address specified by the address_id, or
      // the personal address has the is_default_for_shipping,

      if (default_team_address) {
        if (!getters.teamAddresses) return null; // Team addresses not loaded yet.
        return getters.teamAddresses.find(function (addr) {
          return default_team_address == addr.id;
        });
      } else {
        var userAddresses = getters.orderee.addresses || [];
        return userAddresses.find(function (addr) {
          return addr.is_default_for_shipping;
        });
      }
    }
  }
});

function personalAddr(address) {
  var _ref4 = address || {},
      line1 = _ref4.line1,
      line2 = _ref4.line2,
      line3 = _ref4.line3,
      city = _ref4.city,
      state = _ref4.state,
      postcode = _ref4.postcode;

  var line4 = city || state || postcode ? city + ', ' + state + ' ' + postcode : '';

  var _filter = [line1, line2, line3, line4].filter(Boolean),
      _filter2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_filter, 4),
      addr1 = _filter2[0],
      addr2 = _filter2[1],
      addr3 = _filter2[2],
      addr4 = _filter2[3];

  return { addr1: addr1, addr2: addr2, addr3: addr3, addr4: addr4 };
}

function mungeNametag(_ref5) {
  var nametag = _ref5.nametag,
      info = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref5, ['nametag']);

  if (nametag) info.nametag = __WEBPACK_IMPORTED_MODULE_6__lib_splitNametag___default()(nametag);
  return info;
}

// This defines the default settings new teams will see.
// The format is designed to allow simple merging using Object.assign.
var DEFAULT_SETTINGS = {
  // Fields are listed by key.
  title: { label: 'Title' },
  ph1: { label: 'Phone' },

  // Special keys: don't use these as field names!
  // Gives the list of field keys, in order.
  fields: ['title', 'ph1'],
  // Whether to ask for the address as part of the persona info
  address: true
};

function _personalVars(info, settings) {
  // return a series of objects for each entry in the personal_info.
  // This basically exposes the title of well-known variables, in a
  // consistent order.

  settings = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, DEFAULT_SETTINGS, settings);

  var labels = {
    // These well-known variables are returned first, in this order
    title: 'Title',
    ph1: 'Phone 1',
    ph2: 'Phone 2'
  };
  info = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, info); // make a copy
  var result = [];
  result.address = settings.address;

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(settings.fields), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      var _ref6 = settings[key] || {},
          _ref6$label = _ref6.label,
          label = _ref6$label === undefined ? key : _ref6$label,
          value = info[key];

      result.push({ key: key, label: label, value: value });
      delete info[key];
    }

    // Add all other info that has been set
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  for (var _key in info) {
    var label = _key,
        value = info[_key];
    if (value) result.push({ key: _key, label: label, value: value });
  }

  return result;
}

/***/ }),

/***/ "GmE8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberRestrictions_vue__ = __webpack_require__("+99l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6746c68_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberRestrictions_vue__ = __webpack_require__("m+BL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberRestrictions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6746c68_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberRestrictions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GojV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineItemProductForm_vue__ = __webpack_require__("TlUu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddde228c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineItemProductForm_vue__ = __webpack_require__("P14B");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineItemProductForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddde228c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineItemProductForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gph9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    footer: String,
    wideHeader: String,
    heroDark: Boolean
  }
});

/***/ }),

/***/ "GuAU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerInfo_vue__ = __webpack_require__("tz0Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c095ba2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerInfo_vue__ = __webpack_require__("cpJX");
function injectStyle (ssrContext) {
  __webpack_require__("PK0i")
  __webpack_require__("2Ikr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9c095ba2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c095ba2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H/Pd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PdfUploader_vue__ = __webpack_require__("RLK9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04e5f00f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PdfUploader_vue__ = __webpack_require__("lB86");
function injectStyle (ssrContext) {
  __webpack_require__("Hwkn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04e5f00f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PdfUploader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04e5f00f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PdfUploader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "H0Z0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditEmails_vue__ = __webpack_require__("sked");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e38c3f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditEmails_vue__ = __webpack_require__("+rOh");
function injectStyle (ssrContext) {
  __webpack_require__("V3Wu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e38c3f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditEmails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e38c3f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditEmails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H7gk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['uid', 'token', 'user_type'],
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['inviteLoaded', 'inviteUser', 'isAdmin', 'requireProductTemplateChoice']), {
    steps: function steps() {
      return this.requireProductTemplateChoice ? ['Accept invitation', 'Enter details', 'Choose Design', 'Place order'] : ['Accept invitation', 'Enter details', 'Place order'];
    }
  }),
  data: function data() {
    return {
      name: '',
      email: '',
      password: '',
      error: ''
    };
  },

  watch: {
    inviteUser: function inviteUser(val) {
      if (!val) return;
      if (!this.name) this.name = ((val.first_name || '') + ' ' + (val.last_name || '')).trim();
      this.email = val.email;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.loadInviteData({ uid: _this.uid, token: _this.token });

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['acceptInvite', 'loadInviteData']), {
    submit: function submit() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var error, active;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this2.acceptInvite({ uid: _this2.uid, token: _this2.token, name: _this2.name, password: _this2.password });

              case 3:
                if (!_this2.loginError) {
                  // All good -- users continue to setup, admins to dashboard
                  _this2.$router.push(_this2.isAdmin ? '/dashboard' : '/setup');
                }
                _context2.next = 12;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2['catch'](0);
                error = _context2.t0.error;
                active = _context2.t0.active;

                if (active) {
                  // TODO Go to login page
                  console.log("Go to login page");
                }
                _this2.error = error;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 6]]);
      }))();
    }
  })
});

/***/ }),

/***/ "H7sd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H8fS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HG0L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',_vm._b({on:{"click":_vm.onClick}},'b-button',_vm.$attrs,false),[(_vm.busy)?_c('WaveSpinner',{attrs:{"color":_vm.spinnerColor,"inline":""}}):_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HMF7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeatureSection_vue__ = __webpack_require__("SRV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1778955a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeatureSection_vue__ = __webpack_require__("dQqr");
function injectStyle (ssrContext) {
  __webpack_require__("IRLX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1778955a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeatureSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1778955a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeatureSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "HOKS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Stay Informed")]),_vm._v("\n  Get our informative newsletter\n  directly in your inbox.\n  "),_c('GetEmail',{staticStyle:{"margin-top":"1em"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HR0b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleCircle_vue__ = __webpack_require__("b0fZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11d8b3ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleCircle_vue__ = __webpack_require__("rZTG");
function injectStyle (ssrContext) {
  __webpack_require__("+CMB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleCircle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11d8b3ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleCircle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "HgD7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HgU1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dccdbe2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecondaryHeader_vue__ = __webpack_require__("VCwS");
function injectStyle (ssrContext) {
  __webpack_require__("ILrN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4dccdbe2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dccdbe2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecondaryHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "HhLQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sendIntercomMessage;
/**
 * Send a message using intercom's bot. This is kind of a hack but it works.
 * Caller is expected to test that intercom is even loaded.
 *
 * @param {*} message
 * @param {*} userinfo
 * @param {*} autosend
 */
function sendIntercomMessage(message, userinfo, autosend) {
  var _ref = userinfo || {},
      name = _ref.name,
      email = _ref.email;

  if (name || email) Intercom("update", { name: name, email: email });
  Intercom("showNewMessage", message);

  if (!autosend) return;

  // Click the send button within intercom
  // If this fails, user will need to click manually
  setTimeout(function () {
    try {
      document.querySelector("iframe[name=intercom-messenger-frame]").contentDocument.querySelector(".intercom-composer-send-button").click();
    } catch (e) {
      console.error(e);
    }
  }, 250);
}

/***/ }),

/***/ "HuOx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Sign In")]),_vm._v(" "),_c('p',[_vm._v("\n    If you have shopped with us before, please enter your details in the boxes below. If you are a new customer please proceed to the Billing & Shipping section.\n  ")]),_vm._v(" "),_c('form',{staticClass:"login-form inputs-border inputs-bg",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],ref:"email",staticClass:"form-control",attrs:{"type":"text","id":"username","required":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"username"}},[_vm._v("Username or email*")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"password","id":"password","required":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"password"}},[_vm._v("Password*")])]),_vm._v(" "),_c('div',{staticClass:"form-group text-right"},[(_vm.loginError)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.loginError.toString()))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-default signin-submit",attrs:{"type":"submit","id":"button","disabled":_vm.loginBusy}},[(_vm.loginBusy)?_c('span',[_vm._v("Signing In...")]):_c('span',[_vm._v("Sign In")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hwkn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I0FD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckoutPayment_vue__ = __webpack_require__("u3J8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7419179a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckoutPayment_vue__ = __webpack_require__("8yyd");
function injectStyle (ssrContext) {
  __webpack_require__("P2lH")
  __webpack_require__("RCUT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7419179a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckoutPayment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7419179a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckoutPayment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I0no":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditAddresses_vue__ = __webpack_require__("O/l8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d84c0ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditAddresses_vue__ = __webpack_require__("ISl2");
function injectStyle (ssrContext) {
  __webpack_require__("Mivk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d84c0ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditAddresses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d84c0ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditAddresses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ICnN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUpProgress_vue__ = __webpack_require__("CRkJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15e6a72f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUpProgress_vue__ = __webpack_require__("YHaQ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUpProgress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15e6a72f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUpProgress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "IKBG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['providerRedirect'],
  mounted: function mounted() {
    window.opener.onOauth(this.providerRedirect, this.$route.query);
    window.close();
  }
});

/***/ }),

/***/ "ILHl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingPage_vue__ = __webpack_require__("++KJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04203237_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingPage_vue__ = __webpack_require__("UpSE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04203237_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ILrN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IM/j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-list",attrs:{"role":"tablist"}},_vm._l((_vm.productData.categories),function(category){return _c('b-card',{key:category.title,staticClass:"mb-1",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion1",modifiers:{"accordion1":true}}],attrs:{"block":"","href":"#","variant":"info"}},[_vm._v(_vm._s(category.title))])],1),_vm._v(" "),_c('b-card-body',[_c('ul',{staticClass:"card-text"},_vm._l((category.products),function(product){return _c('li',{key:product.name,class:(_vm.selected === product.apiName ? 'active ' : '') + (product['class'] ? product['class'] + ' chip ' : ''),on:{"click":function($event){_vm.selected = product.apiName}}},[_vm._v(_vm._s(product.name))])}),0)])],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IO6r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04dc6371_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GetDemoButton_vue__ = __webpack_require__("4HuA");
function injectStyle (ssrContext) {
  __webpack_require__("KIte")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04dc6371"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04dc6371_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GetDemoButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "IRLX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ISl2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notif-wrapper",nativeOn:{"notification":function($event){return _vm.messageReceived($event)}}},[_c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[(_vm.editing)?_c('div',[_c('SettingsTitleBar',{attrs:{"sub":"Addresses"},on:{"cancel":function($event){$event.preventDefault();return _vm.cancel($event)}}}),_vm._v(" "),_c('b-alert',{attrs:{"show":"","variant":_vm.notification.type}},[_vm._v(_vm._s(_vm.notification.message))]),_vm._v(" "),_c('b-form-group',_vm._b({attrs:{"label":"Address:","label-for":"line1"}},'b-form-group',_vm.validationAttrsFor('line1'),false),[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"line1","id":"line1","data-vv-as":"address line 1","placeholder":"Enter address"},model:{value:(_vm.editing.line1),callback:function ($$v) {_vm.$set(_vm.editing, "line1", $$v)},expression:"editing.line1"}})],1),_vm._v(" "),_c('b-form-group',_vm._b({attrs:{"label":" ","label-for":"line2"}},'b-form-group',_vm.validationAttrsFor('line2'),false),[_c('b-form-input',{attrs:{"name":"line2","id":"line2","placeholder":"Address line 2 - optional"},model:{value:(_vm.editing.line2),callback:function ($$v) {_vm.$set(_vm.editing, "line2", $$v)},expression:"editing.line2"}})],1),_vm._v(" "),_c('b-form-group',_vm._b({attrs:{"label":" ","label-for":"line3"}},'b-form-group',_vm.validationAttrsFor('line3'),false),[_c('b-form-input',{attrs:{"name":"line3","id":"line3","placeholder":"Address line 3 - optional"},model:{value:(_vm.editing.line3),callback:function ($$v) {_vm.$set(_vm.editing, "line3", $$v)},expression:"editing.line3"}})],1),_vm._v(" "),_c('b-form-group',_vm._b({attrs:{"label":"City:","label-for":"city"}},'b-form-group',_vm.validationAttrsFor('city'),false),[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"city","id":"city","placeholder":"Enter city"},model:{value:(_vm.editing.city),callback:function ($$v) {_vm.$set(_vm.editing, "city", $$v)},expression:"editing.city"}})],1),_vm._v(" "),_c('b-form-group',_vm._b({attrs:{"label":_vm.isUSA ? 'State:' : 'Province',"label-for":"state"}},'b-form-group',_vm.validationAttrsFor('state'),false),[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({required: _vm.isUSA}),expression:"{required: isUSA}"}],attrs:{"name":"state","id":"state","placeholder":_vm.isUSA ? 'Enter state' : 'Enter province'},model:{value:(_vm.editing.state),callback:function ($$v) {_vm.$set(_vm.editing, "state", $$v)},expression:"editing.state"}})],1),_vm._v(" "),_c('b-form-group',_vm._b({attrs:{"label":_vm.isUSA ? 'Zip code:' : 'Postal code:',"label-for":"postcode"}},'b-form-group',_vm.validationAttrsFor('postcode'),false),[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"postcode","id":"postcode","placeholder":"Enter postcode"},model:{value:(_vm.editing.postcode),callback:function ($$v) {_vm.$set(_vm.editing, "postcode", $$v)},expression:"editing.postcode"}})],1),_vm._v(" "),(_vm.flags.internationalShipping)?_c('b-form-group',_vm._b({attrs:{"label":"Country:","label-for":"country"}},'b-form-group',_vm.validationAttrsFor('country'),false),[_c('b-form-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"country","id":"country","options":_vm.countries,"value-field":"iso_3166_1_a2","text-field":"printable_name"},model:{value:(_vm.editing.country),callback:function ($$v) {_vm.$set(_vm.editing, "country", $$v)},expression:"editing.country"}})],1):_vm._e(),_vm._v(" "),_c('b-form-checkbox',{staticClass:"default-shipping",model:{value:(_vm.editing.is_default_for_shipping),callback:function ($$v) {_vm.$set(_vm.editing, "is_default_for_shipping", $$v)},expression:"editing.is_default_for_shipping"}},[_vm._v("\n      Save as my default address")]),_vm._v(" "),_c('b-form-checkbox',{staticClass:"is-private",model:{value:(_vm.is_private),callback:function ($$v) {_vm.is_private=$$v},expression:"is_private"}},[_vm._v("\n      Save as a private address (not available to team)")])],1):_c('div',{staticClass:"address-list"},[_c('SettingsTitleBar',{attrs:{"sub":"Addresses"}},[_c('div',{staticClass:"add-address btn btn-primary",on:{"click":_vm.add}},[_vm._v("Add New")]),_vm._v(" "),_c('b-button',{staticClass:"btn-secondary",on:{"click":_vm.quit}},[_vm._v("Cancel")])],1),_vm._v(" "),_c('b-alert',{attrs:{"show":"","variant":_vm.notification.type}},[_vm._v(_vm._s(_vm.notification.message))]),_vm._v(" "),_vm._l((_vm.combinedAddresses),function(address,index){return _c('div',{key:address.id + '_' + index,staticClass:"card"},[_c('Address',{staticClass:"pointer",attrs:{"value":address},on:{"click":function($event){return _vm.edit(address)}}}),_vm._v(" "),_c('div',{staticClass:"card-buttons"},[_c('AddressVerification',{attrs:{"address":address,"on-verification-finish":_vm.refreshAddresses}}),_vm._v(" "),_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"pointer",attrs:{"title":"Make default address"},domProps:{"innerHTML":_vm._s(_vm.favoriteIconHtml(address))},on:{"click":function($event){return _vm.favorite(address)}}}),_vm._v(" "),_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"pointer",attrs:{"title":"Edit address"},on:{"click":function($event){return _vm.edit(address)}}},[_c('i',{staticClass:"fa fa-edit"})]),_vm._v(" "),_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"pointer",attrs:{"title":"Delete address"},on:{"click":function($event){return _vm.del(address)}}},[_c('i',{staticClass:"fa fa-trash"})]),_vm._v(" "),(address.type === 'team')?_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Team address"}},[_c('i',{staticClass:"fas fa-users"})]):_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Personal address"}},[_c('i',{staticClass:"fas fa-user"})])],1)],1)}),_vm._v(" "),_c('div',{staticClass:"add-address btn btn-primary",on:{"click":_vm.add}},[_vm._v("Create New Address")])],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IaDX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"parent"},[_c('div',[_c('div',{staticClass:"portal-lp"},[_c('h1',{staticClass:"mt-0",domProps:{"innerHTML":_vm._s(_vm.headline)}}),_vm._v(" "),_c('p',{staticStyle:{"font-size":"1.15em","margin-bottom":"1.3em"},domProps:{"innerHTML":_vm._s(_vm.subtitle)}}),_vm._v(" "),_c('ul',{staticClass:"list-3"},[_c('li',{staticClass:"container-3"},[_c('div',{staticClass:"item-container-3"},[_c('div',{staticClass:"item-wrapper"},[_c('div',{staticClass:"middle"},[_c('img',{attrs:{"src":"/static/images/homepage/quality.svg","alt":"icon"}}),_vm._v(" "),_c('p',{staticClass:"list-copy"},[_vm._v("All-in-one business card solution")])])])])]),_vm._v(" "),_c('li',{staticClass:"container-3"},[_c('div',{staticClass:"item-container-3"},[_c('div',{staticClass:"item-wrapper"},[_c('div',{staticClass:"middle"},[_c('img',{attrs:{"src":"/static/images/homepage/quality.svg","alt":"icon"}}),_vm._v(" "),_c('p',{staticClass:"list-copy"},[_vm._v("1-minute setup")])])])])]),_vm._v(" "),_c('li',{staticClass:"container-3"},[_c('div',{staticClass:"item-container-3"},[_c('div',{staticClass:"item-wrapper"},[_c('div',{staticClass:"middle"},[_c('img',{attrs:{"src":"/static/images/homepage/quality.svg","alt":"icon"}}),_vm._v(" "),_c('p',{staticClass:"list-copy"},[_vm._v("Free shipping, always")])])])])])])])]),_vm._v(" "),_c('div',{staticStyle:{"height":"1.8em"}}),_vm._v(" "),_c('div',{staticClass:"icon-wrapper"},[_c('img',{attrs:{"src":"/static/images/landingpages/kettlebell_logo.svg","alt":"icon"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/images/landingpages/shipworks_logo.svg","alt":"icon"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/images/landingpages/stockwell_logo.svg","alt":"icon"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/images/landingpages/medly_logo.svg","alt":"icon"}})])])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"parent",attrs:{"id":"scroll-to-signup"}},[_c('div',{staticClass:"box-shape"},[_c('div',{staticClass:"signup-header"},[_c('h1',{staticStyle:{"margin-top":"10px"}},[_vm._v("See Brandly in action.")]),_vm._v(" "),_c('h2',[_vm._v("NO CREDIT CARD REQUIRED")])]),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('SignUpForm',[_vm._v("Open free portal now")])],1),_vm._v(" "),_c('div',{staticClass:"wrapper",attrs:{"id":"social"}},[_c('h2',[_vm._v("OR SIGNUP USING")]),_vm._v(" "),_c('div',[_c('GoogleCircle',{on:{"login":_vm.onGoogleLogin}}),_vm._v(" "),_c('LinkedInCircle',{on:{"login":_vm.onLinkedInLogin}})],1)]),_vm._v(" "),_c('div',{staticClass:"questions"},[_c('p',[_vm._v("\n              Questions?\n              "),_c('a',{attrs:{"href":"https://www.brandly.com/contact","target":"_blank"},on:{"click":_vm.openIntercom}},[_vm._v("  Chat with us now\n                "),_c('img',{attrs:{"src":"/static/images/landingpages/chat.svg","alt":"icon"}})])])])])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ib14":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"right"}},[(_vm.product)?_c('div',{staticClass:"product"},[_c('TitlePrevNext',{attrs:{"obj":_vm.product}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.product.details))]),_vm._v(" "),_c('div',{staticClass:"flip-box"},[(_vm.hasPerspectiveClass)?_c('img',{staticClass:"colorcore",attrs:{"src":"/static/images/product/icons/flip2.svg"}}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"card-image",class:_vm.product['class'],attrs:{"src":_vm.product.src}})]),_vm._v(" "),_c('div',{staticClass:"product-details"},[_c('div',{staticClass:"icon-section"},[(_vm.showIcon('11pt'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/caliper.svg"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("11 pt paper")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('13pt'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/caliper.svg"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("13 pt paper")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('14pt'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/caliper.svg"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("14 pt paper")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('16pt'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/caliper.svg"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("16 pt paper")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('18pt'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/caliper.svg"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("38 pt paper")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('32pt'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/caliper.svg"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("32 pt paper")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('34pt'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/caliper.svg"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("34 pt paper")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('15mil'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/caliper.svg"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("15 mil plastic")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('black'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/core.svg"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("black center")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('blue'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/core.svg"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("blue center")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('red'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/core.svg"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("red center")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('aqua'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/core.svg"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("aqua center")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('orange'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/core.svg"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("orange center")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('white'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/bright.svg"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("bright white")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('gloss'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/gloss.svg"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("high gloss finish")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('linen'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/linen.svg"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("linen texture")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('vellum'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/vellum.svg"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("vellum texture")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('raised'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/raised.svg","id":"raised"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("raised print")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('pearl'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/pearl.svg","id":"pearl"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("iridescent finish")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('soft'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/soft.svg","id":"soft"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("soft to the touch")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('plastic'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/plastic.svg","id":"plastic"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("waterproof")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('ink'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/ink.svg"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("heavy coverage")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('color'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/color.svg"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("saturated color")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('hybrid'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/knife.svg"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("versatile")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('photo'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/photo.svg"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("great for photos")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('extra'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/extra.svg"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("extra thick paper")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('sturdy'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/sturdy.svg"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("sturdy")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('font'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/font.svg"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("crisp type")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('magnet'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/magnet.svg","id":"magnet"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("magnetic backer")])]):_vm._e(),_vm._v(" "),(_vm.showIcon('write'))?_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/pencil.svg","id":"write"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("write on me")])]):_vm._e()])])],1):_vm._e(),_vm._v(" "),(_vm.product)?_c('QtyPriceForm',{staticClass:"qtybox",attrs:{"paper":_vm.product.apiName || _vm.product.name}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IdgM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2639f2b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SummaryBlock_vue__ = __webpack_require__("Dbfs");
function injectStyle (ssrContext) {
  __webpack_require__("JX+q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2639f2b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2639f2b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SummaryBlock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Igay":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = centerRectWithinBounds;
// expects ({width:width, height:height}, {left, top, width:width, height:height});
// returns {top:top, left:left}
function centerRectWithinBounds(rect, bounds) {
  return {
    left: (bounds.left || 0) + bounds.width / 2 - rect.width / 2,
    top: (bounds.top || 0) + bounds.height / 2 - rect.height / 2
  };
}

/***/ }),

/***/ "IiRJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_pick__ = __webpack_require__("w9Mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_pick__);









/**
 * The Scaler class encapsulates the scaling/unscaling operations needed to make frabic canvas
 * objects appear the correct size.
 */

var Scaler = function () {
  function Scaler(scaleX, scaleY) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, Scaler);

    this.scaleX = parseFloat(scaleX);
    this.scaleY = parseFloat(scaleY);
  }

  /** Return the appropriate size for the canvas
   * Currently we always use 2x, and don't adjust for viewport.
   * In the future this class may need to be given viewport coordinates
   */


  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(Scaler, [{
    key: 'canvasSize',
    value: function canvasSize(mediaBox) {
      var _mediaBox = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(mediaBox, 4),
          w = _mediaBox[2],
          h = _mediaBox[3];

      return [w * this.scaleX, h * this.scaleY];
    }

    /** Return the X, Y trim size. We assume the trim box is equal on left/right and top/bottom.
     */

  }, {
    key: 'trimSize',
    value: function trimSize(trimBox) {
      var _trimBox = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(trimBox, 2),
          x = _trimBox[0],
          y = _trimBox[1];

      return [x * this.scaleX, y * this.scaleY];
    }

    /**
     * Load the objects onto the canvas with appropriate scale. Returns a
     * promise. Caller must call renderAll().
     */

  }, {
    key: 'loadScaledObjects',
    value: function loadScaledObjects(fabricCanvas, objects) {
      var _this = this;

      // preprocess text. Adds a new "styles" entry to the last character so that the
      // correct font style, color and size shows when the cursor is at the end.
      if (objects.objects) {
        objects.objects.forEach(function (obj) {
          if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(obj.styles) === 'object' && obj.styles[0] && typeof obj.text === 'string') {

            var styles = obj.styles[0];
            var keys = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(styles);
            if (keys && keys.length > 0) {
              var last = parseInt(keys[keys.length - 1], 10);

              if (obj.text.length > last) {
                styles[last + 1] = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(styles[last]));
              }
            }
          }
        });
      }

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        var scaledObjectJson = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(objects, function (key, object) {
          if ((typeof object === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(object)) === 'object') {
            object = _this.scaleToContainer(object);
          }
          return object;
        });
        fabricCanvas.loadFromJSON(scaledObjectJson, resolve);
      });
    }

    /* (private) Apply scale and other transforms to object. Only affect
     * canvas objects (with a 'type') or style objects (with a 'fontSize')
     */

  }, {
    key: 'scaleToContainer',
    value: function scaleToContainer(object) {
      var inverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (object && (object.type || object.fontSize)) {
        object = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, object);
        var pow = inverse ? -1 : 1;
        this.scaleProp(object, 'left', Math.pow(this.scaleX, pow));
        this.scaleProp(object, 'width', Math.pow(this.scaleX, pow));
        this.scaleProp(object, 'fontSize', Math.pow(this.scaleY, pow));
        this.scaleProp(object, 'top', Math.pow(this.scaleY, pow));
        this.scaleProp(object, 'height', Math.pow(this.scaleY, pow));
        object.hasRotatingPoint = false;
      }
      return object;
    }
  }, {
    key: 'scaleProp',
    value: function scaleProp(object, prop, scale) {
      if (object[prop]) object[prop] = parseFloat(object[prop]) * scale;
    }
  }, {
    key: 'unscaledObjects',
    value: function unscaledObjects(fabricCanvas) {
      var _this2 = this;

      var _fabricCanvas$toJSON = fabricCanvas.toJSON(['brandly']),
          objects = _fabricCanvas$toJSON.objects; // This returns an object despite name.


      var acceptedKeys = ['charSpacing', 'fill', 'fontSize', 'fontFamily', 'id', 'left', 'lineHeight', 'text', 'textAlign', 'top', 'type', 'styles', 'width', 'height', 'originX', 'scaleX', 'scaleY', 'padding', 'src', 'deltaY', 'brandly'];
      return JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(objects, function (key, object) {
        if (object && (object.type || object.fontSize)) {
          if (object.type === 'image') console.log(object);
          object = _this2.scaleToContainer(__WEBPACK_IMPORTED_MODULE_8_lodash_pick___default()(object, acceptedKeys), true);
        }
        return object;
      }));
    }
  }]);

  return Scaler;
}();

/* harmony default export */ __webpack_exports__["a"] = (Scaler);

/***/ }),

/***/ "IkdP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J3pk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartOrderButton_vue__ = __webpack_require__("Nype");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_273db64e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartOrderButton_vue__ = __webpack_require__("y//D");
function injectStyle (ssrContext) {
  __webpack_require__("kb0k")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartOrderButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_273db64e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartOrderButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "JBsK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-menu d-lg-none"},[_c('div',{staticClass:"fixed-menu-body"},[_vm._m(0),_vm._v(" "),_c('button',{class:("btn-" + (_vm.actionParams.variant) + " sidebar-purchase-link"),on:{"click":function($event){return _vm.$emit('action')}}},[_vm._v("\n      "+_vm._s(_vm.actionParams.button)+"\n      "),_c('i',{staticClass:"fa fa-arrow-right"})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-hint"},[_c('a',{attrs:{"href":"mailto:support@brandly.com"}},[_vm._v("Need help?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JIZ4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JTlq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JVU6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard-design"}},[_c('h1',[_vm._v("Team Designs")]),_vm._v(" "),_c('TemplateChooser',{attrs:{"no-edit":!_vm.isAdmin}}),_vm._v(" "),_c('ProductTemplatePreview',{attrs:{"edit-button":_vm.isAdmin},on:{"edit":_vm.onEditTemplate}}),_vm._v(" "),_c('ChooseProduct',{attrs:{"edit-button":_vm.isAdmin}}),_vm._v(" "),_c('div',{attrs:{"id":"dashboard-actions"}},[_c('StartOrderButton'),_vm._v(" "),(_vm.isAdmin)?_c('b-button',{attrs:{"to":"design/new","variant":"primary"}},[(_vm.productTemplateDesignId)?_c('span',[_vm._v("Re-upload Design")]):_c('span',[_vm._v("Upload New Design")])]):_vm._e()],1),_vm._v(" "),_c('b-alert',{staticClass:"error",attrs:{"variant":"danger","id":"error-alert","show":!!_vm.uploadError}},[_vm._v(_vm._s(_vm.uploadError))]),_vm._v(" "),(_vm.flags.debugTools)?_c('span',{staticStyle:{"text-align":"left","font-size":"small","border":"3px dashed blue","padding":"3px"}},[_c('button',{on:{"click":_vm.resetDesign}},[_vm._v("Reset PDT")]),_vm._v(" "),_c('button',{on:{"click":_vm.deleteDesign}},[_vm._v("Delete PDT")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JX+q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JXDa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JZOG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"hsformdiv"}})}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JZed":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderReviewMessage_vue__ = __webpack_require__("ehbu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ae2b301_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderReviewMessage_vue__ = __webpack_require__("7SH7");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderReviewMessage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ae2b301_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderReviewMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jg45":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LeftNav__ = __webpack_require__("RSB7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MobileLeftNav__ = __webpack_require__("oIea");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LeftNav: __WEBPACK_IMPORTED_MODULE_2__LeftNav__["a" /* default */],
    MobileLeftNav: __WEBPACK_IMPORTED_MODULE_3__MobileLeftNav__["a" /* default */]
  },
  props: {
    children: { type: Array, required: true },
    prefix: { type: String, default: 'dashboard' }
  },
  mounted: function mounted() {
    this.loadTeamInfo();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['loggedIn', 'teamId']), {
    ready: function ready() {
      return this.loggedIn && this.teamId;
    },
    nav: function nav() {
      var _this = this;

      // Used by LeftNav and MobileLeftNav etc.
      // derive the nav items from the children automatically,

      return this.children.filter(function (o) {
        return !o.isHidden;
      }).map(function (_ref) {
        var path = _ref.path,
            children = _ref.children,
            _ref$meta = _ref.meta,
            meta = _ref$meta === undefined ? {} : _ref$meta;
        var to = void 0,
            linkClass = void 0,
            title = meta.title,
            icon = meta.icon,
            symbol = meta.symbol,
            src = meta.src;
        if (!icon && !src && !symbol) icon = 'danger';
        if (path === '/') {
          to = '/' + _this.prefix;
          title = title || 'Dashboard';
        } else {
          // Ignore extra parts of the path, assuming they are optional
          // placeholders (eg name/:foo?)
          // We link to the base part of the path from the Nav, (eg, /dashboard/name)
          // and use the base part to form the title.
          path = path.split('/')[0];
          to = '/' + _this.prefix + '/' + path;
          title = title || path.substr(0, 1).toUpperCase() + path.substr(1);
        }
        // This keeps the nav item selected even when sub-routes are active, eg /dashboard/settings/addresses
        if (children) linkClass = 'non-exact';
        return { to: to, title: title, icon: icon, symbol: symbol, src: src, linkClass: linkClass };
      });
    }
  }),
  methods: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['loadTeamInfo'])
});

/***/ }),

/***/ "Jla1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-card"},[(!_vm.info)?_c('WaveSpinner'):(!_vm.editing)?_c('div',{staticClass:"view"},[_c('div',{key:"view",staticClass:"icons",on:{"click":function($event){_vm.editing=true}}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),_c('dl',[_c('dt',[_vm._v("Name:")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.info.first_name)+" "+_vm._s(_vm.info.last_name))]),_vm._v(" "),_c('dt',[_vm._v("Email:")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.info.email))]),_vm._v(" "),_vm._l((_vm.personalVars),function(ref){
var label = ref.label;
var value = ref.value;
return [_c('dt',{key:label},[_vm._v(_vm._s(label)+":")]),_vm._v(" "),_c('dd',{key:'dd-'+label},[_vm._v(_vm._s(value))])]}),_vm._v(" "),(_vm.personalVars.address)?[_c('dt',[_vm._v("Address:")]),_vm._v(" "),_c('dd',[(_vm.address)?_c('Address',{staticClass:"d-inline-block",attrs:{"value":_vm.address}}):_vm._e()],1)]:_vm._e()],2)]):_c('div',{staticClass:"edit"},[(_vm.saving)?_c('div',{key:"save",staticClass:"icons",on:{"click":function($event){_vm.editing=false}}},[_c('i',{staticClass:"fas fa-spinner fa-spin"})]):_c('div',{key:"edit",staticClass:"icons",on:{"click":function($event){_vm.editing=false}}},[_c('i',{staticClass:"fas fa-times"})]),_vm._v(" "),_c('b-form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}},nativeOn:{"change":function($event){return _vm.save($event)}}},[_c('div',{staticClass:"sbs"},[_c('b-form-input',{staticClass:"inp",attrs:{"placeholder":"First Name"},model:{value:(_vm.info.first_name),callback:function ($$v) {_vm.$set(_vm.info, "first_name", $$v)},expression:"info.first_name"}}),_vm._v(" "),_c('b-form-input',{staticClass:"inp",attrs:{"placeholder":"Last Name"},model:{value:(_vm.info.last_name),callback:function ($$v) {_vm.$set(_vm.info, "last_name", $$v)},expression:"info.last_name"}})],1),_vm._v(" "),_c('b-form-input',{staticClass:"inp",attrs:{"placeholder":"Email"},model:{value:(_vm.info.email),callback:function ($$v) {_vm.$set(_vm.info, "email", $$v)},expression:"info.email"}}),_vm._v(" "),_vm._l((_vm.personalVars),function(ref){
var key = ref.key;
var label = ref.label;
return _c('b-form-input',{key:key,staticClass:"inp",attrs:{"placeholder":label},model:{value:(_vm.info[key]),callback:function ($$v) {_vm.$set(_vm.info, key, $$v)},expression:"info[key]"}})}),_vm._v(" "),(_vm.personalVars.address)?_c('EditMemberAddress',{model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}}):_vm._e()],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jn/n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_CheckoutLogic__ = __webpack_require__("KrFv");
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value'],
  computed: {
    isUSA: function isUSA() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__lib_CheckoutLogic__["g" /* isUSA */])(this.value.country);
    }
  }
});

/***/ }),

/***/ "JqLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressDots_vue__ = __webpack_require__("YkFR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cd59fc8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressDots_vue__ = __webpack_require__("bmT6");
function injectStyle (ssrContext) {
  __webpack_require__("d3vr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7cd59fc8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressDots_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cd59fc8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressDots_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Jqq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_selectedProduct__ = __webpack_require__("D3mI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_track_events__ = __webpack_require__("Dg6a");






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// Common function that is invoked by watch on paper, quantity and corners.
// Trigger save upon change and 350 ms after user has stopped fiddling
var triggerSave = _.debounce(function (val, old) {
  if (old !== null) this.save();
}, 250, { leading: true });

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      products: [],
      productUrls: {},
      paperOptionGroups: [],
      paper: null,
      quantity: null,
      corners: null,
      saving: true
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.loadProducts();

            case 2:
              _this.setCurrentValues();

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    Object(__WEBPACK_IMPORTED_MODULE_9__lib_track_events__["q" /* viewedPricing */])('design-tab');
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(['productTemplate', 'productTemplateAttrs', 'productRecs']), {
    price: function price() {
      return this.info && this.info.price;
    },
    quantityOptions: function quantityOptions() {
      var quantities = this.selectedProducts.map(function (p) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(p.prices);
      });
      return Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["sortBy"])(Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["uniq"])(Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["flatten"])(quantities)), parseInt);
    },
    cornerOptions: function cornerOptions() {
      // Always put square first
      // reverse the array so we sort by highest index first and unfound items (-1) are last
      var order = ['Square', 'Rounded'].reverse();
      var sortFn = function sortFn(a, b) {
        return order.indexOf(b) - order.indexOf(a);
      };
      return Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["uniq"])(this.selectedProducts.map(function (p) {
        return p.attrs.corners;
      })).sort(sortFn);
    },
    selectedProducts: function selectedProducts() {
      var _this2 = this;

      return this.productRecs.filter(function (_ref) {
        var name = _ref.name;
        return name === _this2.paper;
      });
    },
    info: function info() {
      // Return url, price for current # of sides.
      // If the # of sides isn't an option for chosen product,
      // choose a valid # of sides and add a 'sides' key.
      // TODO caller should do something intelligent with the 'sides' key
      // TODO what about corners mismatch
      var otherSide = null;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.selectedProducts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var p = _step.value;

          if (p.attrs.corners !== this.corners) continue;
          var price = p.prices[this.quantity];
          var url = p.urls[this.quantity];
          if (+p.attrs.sides === this.numSides) {
            return { price: price, url: url };
          } else {
            otherSide = { price: price, url: url, sides: p.attrs.sides };
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      console.log('not a perfect match ->', otherSide);
      return otherSide;
    },
    numSides: function numSides() {
      // TODO determine from design?
      return 2;
    }
  }),
  watch: {
    quantity: triggerSave,
    paper: triggerSave,
    corners: triggerSave
  },
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])(['selectProduct', 'updateLine', 'loadProductRecs', 'updateProductTemplate']), {
    loadProducts: function loadProducts() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.loadProductRecs();

              case 2:
                _this3.products = _this3.decorateProducts(_this3.productRecs);
                _this3.calcOptions();

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    setCurrentValues: function setCurrentValues() {
      this.quantity = this.productTemplate.default_qty;
      this.paper = this.productTemplateAttrs.paper;
      this.corners = this.productTemplateAttrs.corners;
      this.saving = false;
    },
    decorateProducts: function decorateProducts(products) {
      // decorate the products with an unpacked attrs, derived from product.attributes
      // same with prices
      // Also set productUrls
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(products), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var p = _step2.value;

          p.attrs = {};
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(p.product.attributes), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _ref2 = _step3.value;
              var sku_tag = _ref2.sku_tag;

              var _sku_tag$split = sku_tag.split(':'),
                  _sku_tag$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_sku_tag$split, 2),
                  key = _sku_tag$split2[0],
                  value = _sku_tag$split2[1];

              p.attrs[key] = value;
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          p.prices = {};
          p.urls = {};
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(p.product.prices), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var _ref3 = _step4.value;
              var quantity = _ref3.quantity,
                  retail_price = _ref3.retail_price,
                  stockrecord = _ref3.stockrecord;

              p.prices[quantity] = retail_price;
              p.urls[quantity] = stockrecord.product;
              this.productUrls[stockrecord.product] = p;
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return products;
    },
    calcOptions: function calcOptions() {
      console.log(this.products);
      function category_title(product) {
        var s = product.category_name;
        s = s.replace('colorcore', 'color core');
        return s.replace(/\b[a-z]/g, function (m) {
          return m[0].toUpperCase();
        });
      }
      var categorized = Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["groupBy"])(this.products, category_title);
      console.log(categorized);
      this.paperOptionGroups = Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["mapValues"])(categorized, function (l) {
        return Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["uniq"])(l.map(function (p) {
          return p.name;
        }));
      });
    },
    save: function save() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('save');

                if (!_this4.saving) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt('return', console.log('already saving'));

              case 3:

                _this4.updateProductTemplate({
                  product: +Object(__WEBPACK_IMPORTED_MODULE_8__lib_selectedProduct__["c" /* idFromProductUrl */])(_this4.info.url),
                  default_qty: +_this4.quantity
                });

                _this4.saving = false;
                console.log('saved');

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    }
  })
});

/***/ }),

/***/ "K/ni":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_vm._v(" "),_c('b-container',{staticClass:"app-main",class:{warning: _vm.warning}},[(_vm.warning)?_c('div',{staticClass:"app-wide-warning"},[_c('b',[_vm._v("Important:")]),_vm._v(" Brandly "),_c('a',{attrs:{"href":"/support/browserSupport/browsersSupported"}},[_vm._v("requires a recent browser")]),_vm._v(" for full functionality. Please try "),_c('b',[_vm._v("Chrome")]),_vm._v(" or "),_c('b',[_vm._v("FireFox")])]):_vm._e(),_vm._v(" "),_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "K1U0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SavedCard_vue__ = __webpack_require__("7qho");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { SavedCard: __WEBPACK_IMPORTED_MODULE_0__SavedCard_vue__["a" /* default */] },
  props: ['value'],
  watch: {
    value: {
      deep: true,
      handler: function handler(val) {
        this.$emit('input', val);
      }
    }
  },
  computed: {
    is_private: {
      get: function get() {
        return !this.value.available_to_team;
      },
      set: function set(value) {
        this.value.available_to_team = !value;
      }
    }
  }
});

/***/ }),

/***/ "KEPf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KFJF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KIte":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KK3D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__ = __webpack_require__("8cOd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d806f52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__ = __webpack_require__("7bmB");
function injectStyle (ssrContext) {
  __webpack_require__("Z9Zk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d806f52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d806f52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KN6e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentRow_vue__ = __webpack_require__("/zs1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e24cf09_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentRow_vue__ = __webpack_require__("aiG8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e24cf09_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KalV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"product-form"}},[_c('b-form-group',{attrs:{"label":"paper"}},[(_vm.restrictProduct)?_c('span',[_vm._v(_vm._s(_vm.paper)+" - "+_vm._s(_vm.corners))]):_c('b-select',{model:{value:(_vm.paper),callback:function ($$v) {_vm.paper=$$v},expression:"paper"}},_vm._l((_vm.paperOptionGroups),function(options,label){return _c('optgroup',{key:label,attrs:{"label":label}},_vm._l((options),function(value){return _c('option',{key:value,domProps:{"value":value}},[_vm._v(_vm._s(value))])}),0)}),0)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"quantity"}},[(_vm.restrictQty)?_c('span',[_vm._v(_vm._s(_vm.quantity))]):_c('b-form-radio-group',{attrs:{"buttons":"","options":_vm.quantityOptions},model:{value:(_vm.quantity),callback:function ($$v) {_vm.quantity=$$v},expression:"quantity"}})],1),_vm._v(" "),(!_vm.restrictProduct)?_c('b-form-group',{attrs:{"label":"corners"}},[_c('b-form-radio-group',{attrs:{"buttons":"","options":_vm.cornerOptions},model:{value:(_vm.corners),callback:function ($$v) {_vm.corners=$$v},expression:"corners"}})],1):_vm._e(),_vm._v(" "),(_vm.price)?_c('div',{staticClass:"price"},[_c('label',[_vm._v("Your price")]),_vm._v(" "),_c('span',{staticClass:"amount"},[_vm._v("$"+_vm._s(_vm.price.toFixed(2)))]),_vm._v(" "),(_vm.saving)?_c('div',{staticClass:"saving-icon"},[_c('i',{staticClass:"fas fa-spinner fa-spin"})]):(!_vm.autoSave)?_c('b-button',{on:{"click":_vm.save}},[_vm._v("Save")]):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kbzo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WaveSpinner_vue__ = __webpack_require__("aJjv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d611cc5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WaveSpinner_vue__ = __webpack_require__("sXOC");
function injectStyle (ssrContext) {
  __webpack_require__("KEPf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d611cc5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WaveSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d611cc5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WaveSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "KeyZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TeamProductForm__ = __webpack_require__("Vz62");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { TeamProductForm: __WEBPACK_IMPORTED_MODULE_2__TeamProductForm__["a" /* default */] },
  props: {
    editButton: {
      type: Boolean
    }
  },
  data: function data() {
    return { editing: false };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["productTemplate", "productTemplateAttrs"]), {
    noCurrentProduct: function noCurrentProduct() {
      return !this.productTemplateAttrs;
    }
  }),
  mounted: function mounted() {
    this.loadProductRecs();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['loadProductRecs']), {
    toggleEditing: function toggleEditing() {
      this.editing = !this.editing;
    },
    editIcon: function editIcon() {
      // Work around font awesome not interacting with vue well
      return "<i class=\"fas fa-" + (this.editing ? 'times' : 'edit') + "\" />";
    }
  })
});

/***/ }),

/***/ "KrFv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ADDRESS_TYPE_SHIPPING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADDRESS_TYPE_VERIFY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USA; });
/* harmony export (immutable) */ __webpack_exports__["g"] = isUSA;
/* harmony export (immutable) */ __webpack_exports__["h"] = nexus;
/* harmony export (immutable) */ __webpack_exports__["i"] = nexusEqual;
/* unused harmony export postcodeComplete */
/* harmony export (immutable) */ __webpack_exports__["j"] = validateInfo;
/* unused harmony export getBillingAddress */
/* harmony export (immutable) */ __webpack_exports__["f"] = isAddressComplete;
/* unused harmony export isPaymentComplete */
/* harmony export (immutable) */ __webpack_exports__["e"] = expandCheckoutInfo;
/* harmony export (immutable) */ __webpack_exports__["c"] = empty_address;
/* harmony export (immutable) */ __webpack_exports__["d"] = empty_payment;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);



/* This module exports several functions related to the
information on a checkout page -- who to ship to, contact name,
billing name, etc.

Checkout data has the following fields:

  shipping: address
  billing: address
  billing_different_address: bool

*/

var ADDRESS_TYPE_SHIPPING = 'shipping';
var ADDRESS_TYPE_VERIFY = 'verify';

var USA = {
  name: "United States",
  code: "US",
  url: "/services/cart/api/v1/cart/countries/US/"

  /**
   * Check that provided country is USA.
   *
   * @param {string} country
   * @returns {boolean}
   */
};function isUSA(country) {
  var isString = typeof country === "string";
  return isString && (country === USA.code || country.endsWith(USA.url));
}

/**
 * Return the tax/shipping nexus data. Basically, this should be all
 * the information needed to calculate tax rate. Therefore if this
 * returns value, the tax rate API call can be made, and if the return
 * value changes, then a new tax rate call can be made.
 * @param {*} checkoutData
 */
function nexus(_ref) {
  var shipping = _ref.shipping;

  if (!shipping) return;
  var country = shipping.country,
      state = shipping.state,
      postcode = shipping.postcode;

  if (!country || isUSA(country) && !state || !postcode) return;
  if (!postcodeComplete(country, postcode)) return;
  return { country: country, state: state, postcode: postcode };
}

/**
 * Compare sameness for nexus. a or b can be null, or an object with country and postcode.
 * @param {*} a
 * @param {*} b
 */
function nexusEqual(a, b) {
  return !a && !b || a && b && a.country === b.country && a.postcode === b.postcode;
}

/**
 * Return whether the postcode is complete, ie we should be able
 * to figure out shipping / tax.
 * NOTE: Only US postcode is checked here.
 */
function postcodeComplete(country, postcode) {
  if (isUSA(country)) {
    return (/^[0-9]{5}(?:-[0-9]{4})?/.test(postcode)
    );
  }
  return country && postcode;
}

/**
 * Validate whether the checkout form is complete enough to allow checkout
 * @param {*} param0
 */
function validateInfo(_ref2, issues) {
  var checkout = _ref2.checkout,
      payment = _ref2.payment,
      needsPayment = _ref2.needsPayment;

  var why = [];
  if (!isAddressComplete(checkout.shipping, 'shipping')) why.push('Shipping address not complete');
  if (!isAddressComplete(getBillingAddress(checkout), 'billing')) why.push('Billing address not complete');
  if (needsPayment && !isPaymentComplete(payment)) why.push('Payment info not complete');
  if (issues) issues.push.apply(issues, why);
  return why.length === 0;
}

/**
 * Return the billing address for checkout, either a copy of the shipping address of not.
 * @param {*} checkout
 */
function getBillingAddress(checkout) {
  if (checkout.billing_different_address) {
    return checkout.billing;
  } else {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, checkout.shipping);
  }
}

function isAddressComplete(address, address_type) {
  // ADDRESS_TYPE_VERIFY only needs the address fields
  // ADDRESS_TYPE_SHIPPING needs address fields, name, email and phone number
  // Other addresses need name, and address fields
  return (address_type === ADDRESS_TYPE_VERIFY || address.first_name) && (address_type === ADDRESS_TYPE_VERIFY || address.last_name) && (address_type !== ADDRESS_TYPE_SHIPPING || address.email_address) && (address_type !== ADDRESS_TYPE_SHIPPING || address.phone_number) && address.line1 && address.city && (!isUSA(address.country) || address.state) && postcodeComplete(address.country, address.postcode);
}

function isPaymentComplete(payment) {
  return payment.saved_card || payment.card_number && payment.expiration && payment.cvc && saveInfoComplete(payment);
}

function saveInfoComplete(payment) {
  // The "title" is required when saving a card
  return !payment.save_card || payment.title;
}

function expandCheckoutInfo(checkout) {
  var billing = checkout.billing,
      rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(checkout, ['billing']);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ billing: getBillingAddress(checkout) }, rest);
}

function empty_address() {
  return {
    country: USA.code,
    first_name: "",
    last_name: "",
    line1: "",
    line2: "",
    notes: "",
    postcode: "",
    state: "",
    city: "",
    phone_number: "",
    email_address: ""
  };
}

function empty_payment() {
  return {
    card_number: '',
    expiration: '',
    cvc: '',
    save_card: false
  };
}

/***/ }),

/***/ "Kwom":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditModeToggle_vue__ = __webpack_require__("us/4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78149fa7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditModeToggle_vue__ = __webpack_require__("WH4A");
function injectStyle (ssrContext) {
  __webpack_require__("ox3m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditModeToggle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78149fa7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditModeToggle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "L2oh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L4y1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "LEUq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLayout_vue__ = __webpack_require__("UmAZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b832cd40_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLayout_vue__ = __webpack_require__("K/ni");
function injectStyle (ssrContext) {
  __webpack_require__("aGa6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b832cd40"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b832cd40_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "LJlt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['nav']
});

/***/ }),

/***/ "LSvg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage-layout"},[_c('Header',_vm._b({},'Header',_vm.$props,false)),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LZqL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LpJy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DebugTools_vue__ = __webpack_require__("NuDt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditModeToggle__ = __webpack_require__("Kwom");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_isMobile__ = __webpack_require__("iL6W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_admin_dlFontUrl__ = __webpack_require__("83za");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['bus', 'canvasState', 'designLocked'],
  components: { DebugTools: __WEBPACK_IMPORTED_MODULE_3__DebugTools_vue__["a" /* default */], EditModeToggle: __WEBPACK_IMPORTED_MODULE_4__EditModeToggle__["a" /* default */] },
  mounted: function mounted() {
    window.addEventListener('keydown', this.keypress);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('keydown', this.keypress);
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(['flags', 'isTemplate', 'validUploadTypes', 'design', 'designOptions']), {
    designLoaded: function designLoaded() {
      return !!this.design;
    },
    lockButtons: function lockButtons() {
      return this.designLocked && !this.isTemplate;
    },
    posX: function posX() {
      if (!this.canvasState.position) return '';
      return Math.round(this.canvasState.position.x * 100) / 100;
    },
    posY: function posY() {
      if (!this.canvasState.position) return '';
      return Math.round(this.canvasState.position.y * 100) / 100;
    },
    dlFontUrl: function dlFontUrl() {
      return Object(__WEBPACK_IMPORTED_MODULE_7__lib_admin_dlFontUrl__["a" /* default */])(this.canvasState.fontName);
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['setDesignOptions']), {
    keypress: function keypress(evt) {

      // avoid catching keypresses if user is typing in another field in the editor
      if (document.activeElement && (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA')) {
        return;
      }

      var emittedEvent = false;

      if (!this.lockButtons && (evt.keyCode === 8 || evt.keyCode == 46)) {
        this.emit('deleteField');
        emittedEvent = true;
      }

      //ctrl/cmd z or ctrl/cmd + Shift z
      if (evt.keyCode === 90 && (evt.metaKey || evt.ctrlKey)) {
        this.emit(evt.shiftKey ? 'redo' : 'undo');
        emittedEvent = true;
      }

      if (emittedEvent) {
        evt.stopPropagation();
      }
    },
    emit: function emit(event, value) {
      this.bus.$emit(event, value);
    },
    onChangeFontSize: function onChangeFontSize(event) {
      this.emit('fontSize', parseFloat(event.target.value));
    },
    onChangeFontName: function onChangeFontName(newName) {
      this.emit('fontName', newName);
    },
    onChangeColor: function onChangeColor(newColor) {
      this.emit('color', newColor);
    },
    onChangeAlignment: function onChangeAlignment(newAlignment) {
      if (newAlignment !== this.canvasState.originX) {
        this.emit('setOriginX', newAlignment);
      }
    },
    onChangePositionX: function onChangePositionX(event) {
      this.onChangePosition(event, 'x');
    },
    onChangePositionY: function onChangePositionY(event) {
      this.onChangePosition(event, 'y');
    },
    onChangePosition: function onChangePosition(event, attr) {
      var value = parseFloat(event.target.value);
      var pos = this.canvasState.position;
      var cur = pos[attr];
      if (!pos || isNaN(value) || cur === value) return;
      this.emit('setPosition', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, pos, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, attr, value)));
    },
    toggleLockDesign: function toggleLockDesign() {
      var _designOptions = this.designOptions,
          lockDesign = _designOptions.lockDesign,
          rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_designOptions, ['lockDesign']);

      lockDesign = !lockDesign;
      this.setDesignOptions(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ lockDesign: lockDesign }, rest));
    }
  }),
  data: function data() {
    return { showingFieldOptions: false };
  },


  directives: {
    // tooltip seems to block click on mobile so this disables it.
    //
    // This demo I made on codepen seems to work, however. https://codepen.io/TheRoccoB/pen/MLrEGb
    // not sure if some dependency (v-bootstrap?) needs to be updated or what, but this solves the problem for now.
    "disable-mobile-tooltip": {
      inserted: function inserted(el) {
        //set timeout to make sure that the v-b-tooltip directive has already been done
        setTimeout(function () {
          var BVTT = '__BV_ToolTip__';
          if (Object(__WEBPACK_IMPORTED_MODULE_6__lib_isMobile__["a" /* default */])() && el[BVTT]) {
            if (el[BVTT]) {
              el[BVTT].destroy();
              el[BVTT] = null;
              delete el[BVTT];
            }
          }
        }, 1);
      }
    }
  },
  events: {
    fieldOptionsVisibilityChange: function fieldOptionsVisibilityChange(_ref) {
      var shown = _ref.shown;

      this.showingFieldOptions = shown;
    }
  }
});

/***/ }),

/***/ "Lq8s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomepageWideLayout_vue__ = __webpack_require__("Gph9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ad23e3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomepageWideLayout_vue__ = __webpack_require__("wpHw");
function injectStyle (ssrContext) {
  __webpack_require__("9VUA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ad23e3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomepageWideLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ad23e3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomepageWideLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Lqhu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LuKJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{staticClass:"artwork-bg"},[_c('div',{staticClass:"copy-container"},[_c('div',{staticClass:"copy"},[_c('p',{staticClass:"eyebrow"},[_vm._v("BASIC PRINCIPLES")]),_vm._v(" "),_c('h2',[_vm._v("5 Tips for print perfection")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("\n                  Brandly is not like any other printing solution. We help brands print business cards for their entire team in an easy and fast way.\n                  We achieve this by instantly transforming business card files into templates that can be edited on-site, shared and self-ordered by\n                  the entire company. That’s why we only accept PDF\n                ")])])])])])],1),_vm._v(" "),_c('div',{staticClass:"icon-wrapper"},[_c('div',{staticClass:"guideline-tips"},[_c('img',{attrs:{"src":"/static/images/artworkguidelines/pdf_red.svg"}}),_vm._v(" "),_c('h5',[_vm._v("1. PDF files")]),_vm._v(" "),_c('p',[_vm._v("Make sure your files are saved as PDFs")])]),_vm._v(" "),_c('div',{staticClass:"guideline-tips"},[_c('img',{attrs:{"src":"/static/images/artworkguidelines/size.svg"}}),_vm._v(" "),_c('h5',[_vm._v("2. Card size")]),_vm._v(" "),_c('p',[_vm._v("3.5\" x 2\" plus 1/8\" bleeds if needed")])]),_vm._v(" "),_c('div',{staticClass:"guideline-tips"},[_c('img',{attrs:{"src":"/static/images/artworkguidelines/livetext.svg"}}),_vm._v(" "),_c('h5',[_vm._v("3. Live text")]),_vm._v(" "),_c('p',[_vm._v("Leave editable text \"live\" - not outlined")])]),_vm._v(" "),_c('div',{staticClass:"guideline-tips"},[_c('img',{attrs:{"src":"/static/images/artworkguidelines/cropmarks.svg"}}),_vm._v(" "),_c('h5',[_vm._v("4. No crop marks")]),_vm._v(" "),_c('p',[_vm._v("Remove crop marks - we'll make them.")])]),_vm._v(" "),_c('div',{staticClass:"guideline-tips"},[_c('img',{attrs:{"src":"/static/images/artworkguidelines/color.png"}}),_vm._v(" "),_c('h5',[_vm._v("5. CMYK colors")]),_vm._v(" "),_c('p',[_vm._v("Prepare files in CMYK mode for best results")])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{staticClass:"artwork-bg"},[_c('div',{staticClass:"copy-container"},[_c('div',{staticClass:"copy"},[_c('p',{staticClass:"eyebrow"},[_vm._v("SHAPE")]),_vm._v(" "),_c('h2',[_vm._v("Size and corners")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("\n                  At Brandly, we print standard sized business cards. That is 2” x 3.5”. You can choose either\n                  "),_c('strong',[_vm._v("square corners")]),_vm._v(" for a more classic style or\n                  "),_c('strong',[_vm._v("rounded corners")]),_vm._v(" for a modern style.\n                ")])])])])])],1),_vm._v(" "),_c('b-row',{staticClass:"bleed-details"},[_c('b-col',{attrs:{"sm":"12","md":"6"}},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-1"},[_c('div',{staticClass:"box-2"},[_vm._v("3.5\" x 2\"")])]),_vm._v(" "),_c('div',{staticClass:"card-corners"},[_vm._v("Square Corners\n                "),_c('p',[_vm._v("50 cards from $18.99")])])])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"6"}},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-1",attrs:{"id":"rounded"}},[_c('div',{staticClass:"box-2",attrs:{"id":"rounded"}},[_vm._v("3.5\" x 2\"\n                "),_c('br'),_c('span',[_vm._v(" Radius: 1/4\"")])])]),_vm._v(" "),_c('div',{staticClass:"card-corners"},[_vm._v("Round Corners\n              "),_c('p',[_vm._v("50 cards from $21.99")])])])])],1),_vm._v(" "),_c('b-row',{staticClass:"bleed-details"},[_c('b-col',{attrs:{"sm":"12","md":"6"}},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-bleed"},[_c('div',{staticClass:"box-trim"},[_c('div',{staticClass:"box-live"})])])])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"6"}},[_c('div',{staticClass:"box"},[_c('ul',{staticClass:"bleed-list"},[_c('li',[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"mini"}),_vm._v(" "),_c('div',{staticClass:"middle"},[_c('h5',[_vm._v("Bleed Area: 3.75” x 2.25”")]),_vm._v(" "),_c('p',[_vm._v("Make sure your background extends to fill the bleed area (to avoid nasty white edges!)")])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"mini",attrs:{"id":"trim"}}),_vm._v(" "),_c('div',{staticClass:"middle"},[_c('h5',[_vm._v("Trim: 3.5\" x 2.0\"")]),_vm._v(" "),_c('p',[_vm._v("This is where we aim to cut your cards.")])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"mini",attrs:{"id":"live"}}),_vm._v(" "),_c('div',{staticClass:"middle"},[_c('h5',[_vm._v("Safe Area: 3.34\" x 1.84\"")]),_vm._v(" "),_c('p',[_vm._v("Make sure important aspects of your design (like text and logos) are inside the safe area.")])])])])])])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{staticClass:"artwork-bg"},[_c('div',{staticClass:"copy-container"},[_c('div',{staticClass:"copy"},[_c('p',{staticClass:"eyebrow"},[_vm._v("TEXT FIELDS")]),_vm._v(" "),_c('h2',[_vm._v("Live vs Outlined texts")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("As we mentioned previously, Brandly instantly transforms PDF files into editable and sharable templates. Our app automatically identifies your card’s fonts, sizes, and colors, so that you just upload your design once and later use it for your entire company’s orders.")]),_vm._v(" "),_c('ul',{staticClass:"live-text"},[_c('li',[_vm._v("\n                    Live Text (Editable fields)\n                    "),_c('p',[_vm._v("Prepare your file so that the fields you’ll want to edit/customize for each employee (name, phone, job title, etc.) are live text. Live text is simply regular text (non-outlined). Also, keeping text at 8pt or higer guarantees great reproduction.")])]),_vm._v(" "),_c('li',[_vm._v("\n                    Outlined Text (Non-editable fields)\n                    "),_c('p',[_vm._v("\n                      Business cards usually have content that won’t be customized to each employee (ie. Your company’s slogan, or webpage address). To make sure this content is not mistakenly edited by the orderer, convert it to curves (Create Outlines).\n                      To learn how to transform text into curves, watch\n                      "),_c('a',{attrs:{"href":"https://www.youtube.com/watch?v=4eF2JPl01_Y","target":"_blank"}},[_c('span',[_vm._v("this short video")]),_vm._v(".\n                      ")])])])])])])])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{staticClass:"artwork-bg",attrs:{"id":"other-content"}},[_c('div',{staticClass:"copy-container"},[_c('div',{staticClass:"copy"},[_c('p',{staticClass:"eyebrow"},[_vm._v("OTHER CONTENT")]),_vm._v(" "),_c('h2',[_vm._v("Images and graphics")])])])])])],1),_vm._v(" "),_c('b-row',{staticClass:"images-graphics"},[_c('b-col',{attrs:{"sm":"12","md":"6"}},[_c('div',{staticClass:"artwork-bg",attrs:{"id":"other-content"}},[_c('div',{staticClass:"copy-container"},[_c('div',{staticClass:"copy"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"other-image"},[_c('img',{attrs:{"src":"/static/images/artworkguidelines/b-logo.svg"}})]),_vm._v(" "),_c('div',{staticClass:"middle",attrs:{"id":"graphics"}},[_c('h3',[_vm._v("Imagery")]),_vm._v(" "),_c('p',[_vm._v("When possible, make artwork a vector PDF. Vector graphics retain high image quality at any size. Also, keep photographs at 300dpi or higher.")])])])])])])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"6"}},[_c('div',{staticClass:"artwork-bg"},[_c('div',{staticClass:"copy-container"},[_c('div',{staticClass:"copy"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"other-image"},[_c('img',{attrs:{"src":"/static/images/artworkguidelines/lines.svg"}})]),_vm._v(" "),_c('div',{staticClass:"middle",attrs:{"id":"graphics"}},[_c('h3',[_vm._v("Lines")]),_vm._v(" "),_c('p',[_vm._v("If your design has lines or stroked shapes, aim to keeping them at 0.5pt or thicker for great reproduction.")])])])])])])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{staticClass:"artwork-bg",attrs:{"id":"other-content"}},[_c('div',{staticClass:"copy-container"},[_c('div',{staticClass:"copy"},[_c('p',{staticClass:"eyebrow"},[_vm._v("TEMPLATES")]),_vm._v(" "),_c('h2',[_vm._v("Downloadable templates")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("\n                  If you prefer starting from scratch, download one of our blank business card templates in Adobe Illustrator or PDF format or try our\n                  starter pack of generic business card designs in Illustrator and PDF formats with content ready to edit or replace.\n                ")])])])])])],1),_vm._v(" "),_c('b-row',{staticClass:"images-graphics",attrs:{"id":"download-links"}},[_c('b-col',{attrs:{"sm":"4"}},[_c('div',{staticClass:"download"},[_c('div',{staticClass:"download-box",attrs:{"id":"ai"}},[_vm._v("ai")]),_vm._v(" "),_c('h5',[_vm._v("Illustrator")]),_vm._v(" "),_c('a',{attrs:{"href":"/static/downloads/blank-ai-templates.zip"}},[_vm._v("Blank Template >")])])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('div',{staticClass:"download"},[_c('div',{staticClass:"download-box",attrs:{"id":"pdf"}},[_vm._v("pdf")]),_vm._v(" "),_c('h5',[_vm._v("PDF")]),_vm._v(" "),_c('a',{attrs:{"href":"/static/downloads/blank-pdf-templates.zip"}},[_vm._v("Blank Template >")])])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('div',{staticClass:"download"},[_c('div',{staticClass:"download-box",attrs:{"id":"id"}},[_vm._v("sp")]),_vm._v(" "),_c('h5',[_vm._v("AI & PDF ")]),_vm._v(" "),_c('a',{attrs:{"href":"/static/downloads/starterpack.zip"}},[_vm._v("Starter Pack >")])])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{staticClass:"artwork-bg"},[_c('div',{staticClass:"copy-container"},[_c('div',{staticClass:"copy"},[_c('p',{staticClass:"eyebrow"},[_vm._v("BLEED")]),_vm._v(" "),_c('h2',[_vm._v("Understanding the bleed")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("\n                  The bleed is an area that gets printed beyond the trim edge of the business card to avoid white lines when we trim it. If your\n                  business card contains a backgound color or graphics that extend to the edges, make sure to add a 1/8 inch bleed beyond the trim.\n                ")])])])])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12","lg":"6"}},[_c('div',{staticClass:"parent"},[_c('img',{staticClass:"bleed-image",attrs:{"src":"/static/images/artworkguidelines/left.png"}})])]),_vm._v(" "),_c('b-col',{staticClass:"bleed-right",attrs:{"md":"12","lg":"6"}},[_c('div',{staticClass:"parent"},[_c('img',{staticClass:"bleed-image",attrs:{"src":"/static/images/artworkguidelines/right.png"}})]),_vm._v(" "),_c('div',{staticClass:"center-text"},[_c('p',[_vm._v("Final printed and trimmed business card")])])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',{staticClass:"faq-section"},[_c('b-col',{attrs:{"sm":"12","md":"6"}},[_c('div',{staticClass:"artwork-bg",attrs:{"id":"faq"}},[_c('div',{staticClass:"copy-container"},[_c('div',{staticClass:"copy"},[_c('h3',[_vm._v("Frequently asked questions")]),_vm._v(" "),_c('h5',[_vm._v("Not seeing your question here?")]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.brandly.com/contact","target":"_blank"}},[_vm._v("Contact us >")])])])])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"6"}},[_c('div',{staticClass:"artwork-bg",attrs:{"id":"other-content"}},[_c('div',{staticClass:"copy-container"},[_c('div',{staticClass:"faq-copy"},[_c('ul',{staticClass:"faq-list"},[_c('li',[_c('h5',[_vm._v("What if I don’t have a design?")]),_vm._v(" "),_c('p',[_vm._v("You could either design it yourself using our templates or get help from a designer. For professional looking business cards we suggest you to hire a designer.")])]),_vm._v(" "),_c('li',[_c('h5',[_vm._v("Will I need to upload a design for each employee?")]),_vm._v(" "),_c('p',[_vm._v("Nope. Just upload a pdf design an set it up as your template. A template can be used by anybody on your team to order their cards. No design skills required.")])]),_vm._v(" "),_c('li',[_c('h5',[_vm._v("Do you offer templates?")]),_vm._v(" "),_c('p',[_vm._v("Brandly does not provide ready-to-use templates but you can always use our Starter pack to create one in an easy way!")])])])])])])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Luf5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',{attrs:{"id":"image-right"}},[_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"parent"},[_c('div',{staticClass:"copy-container"},[_c('div',{staticClass:"copy"},[_c('div',{staticClass:"eyebrow"},[_vm._v("BRANDLY PORTAL")]),_vm._v(" "),_c('h2',[_vm._v("Your private company portal")]),_vm._v(" "),_c('p',[_vm._v("\n                  Everything your company needs to order business cards like a pro.\n                  Centralized control, admin or employee self-ordering ordering, on-brand templates, and more.\n                ")]),_vm._v(" "),_c('router-link',{staticClass:"learn-more",attrs:{"to":"/signup","title":""}},[_vm._v("Open your free portal >")])],1)])])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"parent"},[_c('ul',{staticClass:"list-2"},[_c('li',{staticClass:"container-2"},[_c('div',{staticClass:"item-container-2"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"middle"},[_c('img',{attrs:{"src":"/static/images/homepage/quality.svg","alt":"icon"}}),_vm._v(" "),_c('p',{staticClass:"list-copy"},[_vm._v("Admin or employee self-ordering")])])])])]),_vm._v(" "),_c('li',{staticClass:"container-2"},[_c('div',{staticClass:"item-container-2"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"middle"},[_c('img',{attrs:{"src":"/static/images/homepage/quality.svg","alt":"icon"}}),_vm._v(" "),_c('p',{staticClass:"list-copy"},[_vm._v("Editable online templates")])])])])]),_vm._v(" "),_c('li',{staticClass:"container-2"},[_c('div',{staticClass:"item-container-2"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"middle"},[_c('img',{attrs:{"src":"/static/images/homepage/quality.svg","alt":"icon"}}),_vm._v(" "),_c('p',{staticClass:"list-copy"},[_vm._v("Business level pricing")])])])])]),_vm._v(" "),_c('li',{staticClass:"container-2"},[_c('div',{staticClass:"item-container-2"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"middle"},[_c('img',{attrs:{"src":"/static/images/homepage/quality.svg","alt":"icon"}}),_vm._v(" "),_c('p',{staticClass:"list-copy"},[_vm._v("Team member management")])])])])])])])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LyaO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBleedPoints;
// there is a comment for what this returns where this function is called.
function getSamples(canvasWidth, canvasHeight, horizontalMargins, verticalMargins) {
  var OFFSET_PX = 4; //test OFFSET_PX inside bleed and outside bleed.

  var innerHorizontalMargins = horizontalMargins + OFFSET_PX;
  var innerVerticalMargins = verticalMargins + OFFSET_PX;

  var trimWidth = canvasWidth - innerHorizontalMargins * 2;
  var trimHeight = canvasHeight - innerVerticalMargins * 2;

  var xOffset = innerHorizontalMargins;
  var yOffset = innerVerticalMargins;

  var REQ_SPACING = 10;
  var numHorizontalSamples = Math.ceil(trimWidth / REQ_SPACING);
  var numVerticalSamples = Math.ceil(trimHeight / REQ_SPACING);
  var horizontalSpacing = trimWidth / (numHorizontalSamples - 1);
  var verticalSpacing = trimHeight / (numVerticalSamples - 1);

  var samples = [];

  for (var j = 0; j < 2; j++) {
    var offsetSign = j == 0 ? -1 : 1;
    var yPosition = j == 0 ? yOffset : yOffset + trimHeight;

    for (var i = 0; i < numHorizontalSamples; i++) {
      var checkAgainst = [{
        x: Math.round(xOffset + i * horizontalSpacing),
        y: Math.round(yPosition + OFFSET_PX * 2 * offsetSign)
      }];

      if (i == 0) {
        checkAgainst.push({
          x: Math.round(xOffset + i * horizontalSpacing - OFFSET_PX * 2),
          y: Math.round(yPosition)
        });
      }

      if (i === numHorizontalSamples - 1) {
        checkAgainst.push({
          x: Math.round(xOffset + i * horizontalSpacing + OFFSET_PX * 2),
          y: Math.round(yPosition)
        });
      }

      samples.push({
        x: Math.round(xOffset + i * horizontalSpacing),
        y: Math.round(yPosition),
        o: checkAgainst
      });
    }
  }

  for (var _j = 0; _j < 2; _j++) {
    var _offsetSign = _j == 0 ? -1 : 1;
    var xPosition = _j == 0 ? xOffset : xOffset + trimWidth;
    for (var _i = 1; _i < numVerticalSamples - 1; _i++) {
      samples.push({
        x: Math.round(xPosition),
        y: Math.round(yOffset + _i * verticalSpacing),
        o: [{
          x: Math.round(xPosition + OFFSET_PX * 2 * _offsetSign),
          y: Math.round(yOffset + _i * verticalSpacing)
        }]
      });
    }
  }

  return samples;
}

//isWhite with small amount of tolerance
function isWhite(rgba) {
  return rgba[3] < 3 || rgba[0] > 252 && rgba[1] > 252 && rgba[2] > 252;
}

function isPointColored(ctx, x, y) {
  return !isWhite(ctx.getImageData(Math.round(x * window.devicePixelRatio), Math.round(y * window.devicePixelRatio), 1, 1).data);
}

function getBleedPoints(fabricCanvas, ctx, horizontalMargins, verticalMargins) {
  var showThreshold = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;


  var activeObject = fabricCanvas.getActiveObject();

  // hide the controls by setting them transparent
  // avoids false positives on the handles
  var controlsColorTypes = ['borderColor', 'cornerColor', 'cornerStrokeColor'];
  var prevControlsColors = [];
  if (activeObject) {
    prevControlsColors = controlsColorTypes.map(function (controlsColorType) {
      var lastColor = activeObject[controlsColorType];
      activeObject[controlsColorType] = 'transparent';
      return lastColor;
    });
    fabricCanvas.renderAll();
  }

  /*
  getSamples returns:
   [{x:x, y:y,                           // sample points inside bleed
     o: [{x:x, y:y}, {x:x1, y:y1} ...],  // points to compare against outside of bleed
     ...
   ]
  */
  var samples = getSamples(fabricCanvas.getWidth(), fabricCanvas.getHeight(), horizontalMargins, verticalMargins);

  var badBleedDisplayPoints = [];
  // decorates samples with "isColored" for colored points inside bleed,
  // and "badBleed" for outer points if necessary
  samples.forEach(function (sample) {
    sample.isColored = isPointColored(ctx, sample.x, sample.y);
    if (sample.isColored) {
      sample.o.forEach(function (checkAgainst) {
        checkAgainst.badBleed = !isPointColored(ctx, checkAgainst.x, checkAgainst.y);
        badBleedDisplayPoints.push(checkAgainst);
      });
    }
  });

  if (badBleedDisplayPoints.length > 0 && badBleedDisplayPoints.length <= showThreshold) {
    console.log('hiding bleed points because there are only ' + badBleedDisplayPoints.length);
    badBleedDisplayPoints.forEach(function (displayPoint) {
      displayPoint.badBleed = false;
    });
  }

  // return the controls colors to their original color
  if (activeObject) {
    controlsColorTypes.forEach(function (controlsColorType, idx) {
      activeObject[controlsColorType] = prevControlsColors[idx];
    });
    fabricCanvas.renderAll();
  }

  return samples;
}

/***/ }),

/***/ "M78G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return approveOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return cancelOrder; });
/* unused harmony export addLine */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return changeLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return deleteLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addDiscount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return changeShippingMethod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return cloneForResend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defineService__ = __webpack_require__("tVbG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_selectedProduct__ = __webpack_require__("D3mI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_orderStatus__ = __webpack_require__("FPeH");






var postOrderChange = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('post', 'api/v1/cart/orders/:id/change/', {
  suffixFunc: function suffixFunc(_ref) {
    var category = _ref.category;

    return category ? '-' + category : '';
  }
});
var postAddPayment = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('post', 'api/v1/cart/custom/checkout/add-payment/');

var postOrderClone = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('post', 'api/v1/cart/custom/orders/clone');

function processError(e) {
  // Unwrap error
  if (e.response && e.response.data) e = e.response.data;
  if (e.non_field_errors) e = e.non_field_errors;
  if (e.reason) e = e.reason;
  if (e.cancellation_reason) {
    // Transform { "cancellation_reason": [ "This field may not be blank." ] }
    e = "Please provide a reason for cancellation";
  }
  if (e.join) e = e.join(' ');
  throw e;
}

var approveOrder = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(order_id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', changeOrder(order_id, {
              change_type: 'change_status',
              new_status: __WEBPACK_IMPORTED_MODULE_4__lib_orderStatus__["d" /* READY_FOR_PRODUCTION */]
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function approveOrder(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var cancelOrder = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(order_id, cancellation_reason) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', changeOrder(order_id, {
              change_type: 'change_status',
              new_status: __WEBPACK_IMPORTED_MODULE_4__lib_orderStatus__["b" /* CANCELLED */],
              cancellation_reason: cancellation_reason
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function cancelOrder(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();

var addLine = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(order_id, product, boxSize) {
    var quantity = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            product = Object(__WEBPACK_IMPORTED_MODULE_3__lib_selectedProduct__["c" /* idFromProductUrl */])(product);
            return _context3.abrupt('return', changeOrder(order_id, {
              change_type: 'add_line',
              product: product,
              quantity: quantity,
              attributes: [{ type: 'box_size', value: boxSize }]
            }));

          case 2:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function addLine(_x4, _x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();

var changeLine = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(order_id, line, product, boxSize) {
    var quantity = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            product = Object(__WEBPACK_IMPORTED_MODULE_3__lib_selectedProduct__["c" /* idFromProductUrl */])(product);
            return _context4.abrupt('return', changeOrder(order_id, {
              change_type: 'change_line',
              line: line,
              product: product,
              quantity: quantity,
              attributes: [{ type: 'box_size', value: boxSize }]
            }));

          case 2:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function changeLine(_x8, _x9, _x10, _x11) {
    return _ref5.apply(this, arguments);
  };
}();

var deleteLine = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(order_id, line) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', changeOrder(order_id, {
              change_type: 'delete_line',
              line: line
            }));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function deleteLine(_x13, _x14) {
    return _ref6.apply(this, arguments);
  };
}();

var addDiscount = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(orderId, voucherCode) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', changeOrder(orderId, {
              change_type: 'add_discount',
              voucher: voucherCode
            }));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function addDiscount(_x15, _x16) {
    return _ref7.apply(this, arguments);
  };
}();

var changeShippingMethod = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(orderId, shipping_method) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt('return', changeOrder(orderId, {
              change_type: 'change_shipping_method',
              shipping_method: shipping_method
            }));

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function changeShippingMethod(_x17, _x18) {
    return _ref8.apply(this, arguments);
  };
}();

/**
 * Internal method that unwraps the error
 */
function changeOrder(order_id, data) {
  return postOrderChange(order_id, data).catch(processError);
}

var addPayment = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(orderUrl, saved_card) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt('return', postAddPayment({ order: orderUrl, payment_method: 'SavedCard', stripe_token: saved_card }));

          case 1:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));

  return function addPayment(_x19, _x20) {
    return _ref9.apply(this, arguments);
  };
}();

var cloneForResend = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(data) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt('return', postOrderClone(data));

          case 1:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, this);
  }));

  return function cloneForResend(_x21) {
    return _ref10.apply(this, arguments);
  };
}();

/***/ }),

/***/ "M8t8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_approval__ = __webpack_require__("M78G");




/* harmony default export */ __webpack_exports__["a"] = ({
  actions: {
    cancelOrderById: function cancelOrderById(_ref, _ref2) {
      var _this = this;

      var dispatch = _ref.dispatch;
      var id = _ref2.id,
          cancellation_reason = _ref2.cancellation_reason;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_approval__["d" /* cancelOrder */])(id, cancellation_reason);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),

/***/ "M8ye":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d2479f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("P99z");
function injectStyle (ssrContext) {
  __webpack_require__("H7sd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d2479f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M9C1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("RgZC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3c82124_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("4QOv");
function injectStyle (ssrContext) {
  __webpack_require__("o+lR")
  __webpack_require__("36SL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a3c82124"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3c82124_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MGPA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideMenu_vue__ = __webpack_require__("zqjF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1799266_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideMenu_vue__ = __webpack_require__("f6ai");
function injectStyle (ssrContext) {
  __webpack_require__("DRHf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d1799266"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1799266_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MHeR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MQyJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20eea388_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StarterPack_vue__ = __webpack_require__("uuvh");
function injectStyle (ssrContext) {
  __webpack_require__("JIZ4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20eea388"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20eea388_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StarterPack_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Mivk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MpnT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Invoice_vue__ = __webpack_require__("vGhO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f3bf70f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Invoice_vue__ = __webpack_require__("Ft35");
function injectStyle (ssrContext) {
  __webpack_require__("9Jv0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f3bf70f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Invoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f3bf70f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Invoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mxjm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckoutReviewSettings_vue__ = __webpack_require__("o5N7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eca10b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckoutReviewSettings_vue__ = __webpack_require__("FY0g");
function injectStyle (ssrContext) {
  __webpack_require__("6IH0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7eca10b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckoutReviewSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eca10b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckoutReviewSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MywT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N/nZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PseudoToolBar_vue__ = __webpack_require__("Qv8Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a56a1c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PseudoToolBar_vue__ = __webpack_require__("YCcG");
function injectStyle (ssrContext) {
  __webpack_require__("cNJ+")
  __webpack_require__("WsI8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a56a1c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PseudoToolBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a56a1c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PseudoToolBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N90E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_qrcode__ = __webpack_require__("71e1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_qrcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_qrcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_shorturl__ = __webpack_require__("os0Z");








/**
 * The TemplateVars class encapsulates text variable handling
 * within a template's fields
 *
 * Template vars are represented in the custom property
 * brandly.variable, or (deprecated) textually, eg in the
 * visible text of a template.
 *
 * The custom property brandly.variable takes precedence
 * and is preferred because the sample preview (shown on dashboard)
 * doesn't have weird variable stuff on it.
 *
 * In the textual case they MUST be surrounded by brackets.
 * In the custom property, if brackets are present, then the
 * bracket notation is used.
 *
 * An example of variables in bracket notation:
 *
 * [ph1]
 *
 * That makes creation of a variable simple, if undiscoverable -- just put some
 * text in particular locations.
 *
 * You can specify sub-field formatting such as:
 * [ph1|000.000.0000]   -- phone formatting (ensure dots separate numbers)
 * [title|caps]         -- uppercase value
 *
 * Finally, when there is text preceding a variable, and the variable is blank
 * the text is also elided.
 * EG:
 *   "mobile [ph2]"
 * when ph2 is blank, the result is "" not "mobile "
 *   "[addr1], [addr2]"
 * when addr2 is blank, and addr1 is say "123 main", the result is "123 main"
 * In these and most cases the behavior is helpful.
 *
 * As an example of when the behavior doesn't help: when addr1 is blank and addr2
 * is say "suite 10", the result is ", suite 10"
 *
 * TODO explain/test sample values -- are prefixes ever really elided?
 * TODO explain images
 *
 * Images can also have variables. They must use a bracket notaion,
 * only QR generation is supported. Use [url|https|shorten|qr]
 * where "https" prepends https if missing, "shorten" makes a QR1.TO url,
 * and "qr" makes the qr code (must be last). "url" in this example is the
 * variable.
 *
 */



var TemplateVars = function () {
  function TemplateVars(fabricCanvas, store) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, TemplateVars);

    this.fabricCanvas = fabricCanvas;
    this.store = store;
    this.issues = [];
  }

  /**
   * Return an object with well-known variables for personal values,
   * such as first name, last name, phone, etc.
   */


  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(TemplateVars, [{
    key: "personalValues",
    value: function personalValues() {
      return this.store.getters.personalInfo;
    }

    /**
     * Return sample values. Using sample values is more
     * obvious when using the product.
     */

  }, {
    key: "sampleValues",
    value: function sampleValues() {
      return {
        'name': 'First Last',
        'title': 'Title',
        'ph1': '000-000-0000',
        'ph2': '000-000-0000',
        'ph3': '000-000-0000',
        'addr1': 'Street Address',
        'addr2': 'City, ST 00000'
      };
    }
  }, {
    key: "missingVarValue",
    value: function missingVarValue(varname) {
      console.log('missingVarValue', varname);
      return this.sampleValues()[varname] || '';
    }

    /**
     * Update the fabric objects by replacing text.
     * Caller should call renderAll().
     */

  }, {
    key: "replaceAll",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this = this;

        var vars;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                vars = this.personalValues();
                return _context.abrupt("return", __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all(this.fabricCanvas.getObjects().map(function (object) {
                  return _this.replaceVars(object, vars);
                })));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function replaceAll() {
        return _ref.apply(this, arguments);
      }

      return replaceAll;
    }()
  }, {
    key: "replaceVars",
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(object, vars) {
        var _object$brandly, variable, replaced, textTransform, imageSpec, _replacementText, _replacementText2, prefix, replacement;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!object.brandly) object.brandly = {};
                _object$brandly = object.brandly, variable = _object$brandly.variable, replaced = _object$brandly.replaced, textTransform = _object$brandly.textTransform;

                if (!replaced) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                if (!(object.type == 'image')) {
                  _context2.next = 13;
                  break;
                }

                if (!variable) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 8;
                return this.replacementImageVars(variable, vars);

              case 8:
                imageSpec = _context2.sent;
                _context2.next = 11;
                return this.generateImage(object, imageSpec);

              case 11:
                _context2.next = 14;
                break;

              case 13:
                if (variable) {
                  _replacementText = this.replacementText(variable, vars, textTransform), _replacementText2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_replacementText, 2), prefix = _replacementText2[0], replacement = _replacementText2[1];

                  this.replaceText(object, prefix, replacement);
                } else {
                  // TODO deprecate
                  this.replaceTextVars(object, vars);
                }

              case 14:
                object.brandly.replaced = true;

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function replaceVars(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return replaceVars;
    }()
  }, {
    key: "generateImage",
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3(object, imageSpec) {
        var _this2 = this;

        var dataUrl, origWidth;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(imageSpec === 'remove:')) {
                  _context3.next = 5;
                  break;
                }

                // Delete object
                this.fabricCanvas.remove(object);
                this.fabricCanvas.renderAll();
                _context3.next = 15;
                break;

              case 5:
                if (!imageSpec.startsWith('qr:')) {
                  _context3.next = 14;
                  break;
                }

                _context3.next = 8;
                return __WEBPACK_IMPORTED_MODULE_8_qrcode___default.a.toDataURL(imageSpec.substring(3), { scale: 10 });

              case 8:
                dataUrl = _context3.sent;
                origWidth = object.getScaledWidth();

                object.setSrc(dataUrl, function (img) {
                  img.setCoords();
                  img.scaleToWidth(origWidth);
                  img.setCoords();
                  console.log('setSrc', dataUrl);
                  _this2.fabricCanvas.renderAll();
                });
                // Record the imageSpec for posterity
                object.brandly.imageSpec = imageSpec;
                _context3.next = 15;
                break;

              case 14:
                // Internal error.. we could remove..
                console.error('Bad imageSpec');

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function generateImage(_x3, _x4) {
        return _ref3.apply(this, arguments);
      }

      return generateImage;
    }()
  }, {
    key: "replacementText",
    value: function replacementText(variable, vars, textTransform) {
      var _this3 = this;

      // Allow just a variable name to work as expected
      if (variable.match(/^[a-z]+\d*$/)) variable = '[' + variable + ']';
      var re = /(.*?)\[([a-z]+\d*)(\|.*?)?\]/g;
      var text = variable.replace(re, function () {
        for (var _len = arguments.length, m = Array(_len), _key = 0; _key < _len; _key++) {
          m[_key] = arguments[_key];
        }

        return _this3.replacement(m, vars);
      });
      text = this.transformText(text, textTransform);

      // Now determine if the prefix (part of variable before "[")
      // matches the text, and if so, return seaparately.
      // This allows replaceText to intelligently keep the font of labels
      var m = re.exec(variable),
          prefix = m ? m[1] : '';
      if (text.startsWith(prefix)) {
        return [prefix, text.substring(prefix.length)];
      } else {
        return ['', text];
      }
    }
  }, {
    key: "replaceText",
    value: function replaceText(object, prefix, rest) {
      if (object.text.startsWith(prefix)) {
        var start = prefix.length;
        object.setSelectionStart(start);
        object.setSelectionEnd(start + 1);
        var styles = object.getSelectionStyles();
        var styleArray = Array(rest.length).fill(styles[0]);
        // Replace the rest of the object text with proper style
        object.insertChars(rest, styleArray, start, object.text.length);
      } else {
        // Replace the whole object text
        object.text = prefix + rest;
      }
    }
  }, {
    key: "transformText",
    value: function transformText(text, transform) {
      if (transform == 'uppercase') {
        text = text.toUpperCase();
      } else if (transform) {
        console.warn('Unknown transform', transform);
      }
      return text;
    }
  }, {
    key: "replaceTextVars",
    value: function replaceTextVars(object, vars) {

      if (!object.text) return;

      var re = /(.*?)\[([a-z]+\d*)(\|.*?)?\]/g;
      var string = object.text;

      var match = re.exec(string);
      while (match) {
        var _match = match,
            _match2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_match, 4),
            varSpec = _match2[0],
            prefix = _match2[1],
            varname = _match2[2],
            formatSpec = _match2[3];

        var start = match.index + prefix.length;
        object.setSelectionStart(start);
        object.setSelectionEnd(start + 1);
        var styles = object.getSelectionStyles();
        var replacement = this.replacement([varSpec, '', varname, formatSpec], vars);
        var styleArray = Array(replacement.length).fill(styles[0]);

        object.insertChars(replacement, styleArray, start, start + varSpec.length);
        string = object.text;
        match = re.exec(string);
      }
    }
  }, {
    key: "replacementImageVars",
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8(variable, vars) {

        // Hoisted transforms
        var http = function () {
          var _ref5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4(value) {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    return _context4.abrupt("return", !value.match(/^https?:/) ? 'http://' + value : value);

                  case 1:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, this);
          }));

          return function http(_x7) {
            return _ref5.apply(this, arguments);
          };
        }();

        var https = function () {
          var _ref6 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5(value) {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    return _context5.abrupt("return", !value.match(/^https?:/) ? 'https://' + value : value);

                  case 1:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5, this);
          }));

          return function https(_x8) {
            return _ref6.apply(this, arguments);
          };
        }();

        var shorten = function () {
          var _ref7 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6(value) {
            var url;
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    if (Object(__WEBPACK_IMPORTED_MODULE_9__services_shorturl__["b" /* validUrl */])(value)) {
                      _context6.next = 3;
                      break;
                    }

                    this.issues.push({ issue: 'badUrlForShorten', value: value });
                    // be strict in output.
                    return _context6.abrupt("return", '');

                  case 3:
                    _context6.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_9__services_shorturl__["a" /* shortenUrl */])(value);

                  case 5:
                    url = _context6.sent;
                    return _context6.abrupt("return", url.toUpperCase());

                  case 7:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6, this);
          }));

          return function shorten(_x9) {
            return _ref7.apply(this, arguments);
          };
        }();

        var unknownTransform = function () {
          var _ref8 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7(value) {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    this.issues.push({ issue: 'unknownTransform', variable: variable });
                    return _context7.abrupt("return", 'remove:');

                  case 2:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7, this);
          }));

          return function unknownTransform(_x10) {
            return _ref8.apply(this, arguments);
          };
        }();

        var match, varname, formatcodes, value, transforms, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, code, transform;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                // Similar to replaceTextVars, but async (to allow for image generation, shortening etc
                // and using a different output: a tagged text.
                // So return 'qr:something' to make a QR code,
                // Or 'remove:' to remove the image,
                // Or in the future icon:something, etc.

                // Look for something like [var|https|shorten|qr]
                match = /^\[([a-z]+\d*)\|([a-z|]+)\]$/.exec(variable);

                if (match) {
                  _context8.next = 4;
                  break;
                }

                this.issues.push({ issue: 'unknownImageVarFormat', variable: variable });
                return _context8.abrupt("return", 'remove:');

              case 4:
                varname = match[1];
                formatcodes = match[2].split('|');

                // Get the variable value.

                value = vars[varname];

                if (value) {
                  _context8.next = 9;
                  break;
                }

                return _context8.abrupt("return", 'remove:');

              case 9:
                if (!(formatcodes.pop() !== 'qr')) {
                  _context8.next = 12;
                  break;
                }

                this.issues.push({ issue: 'badFinalTransform', variable: variable });
                return _context8.abrupt("return", 'remove:');

              case 12:

                // Transform according to pipeline.
                // If transform returns blank, remove.
                transforms = { http: http, https: https, shorten: shorten };
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context8.prev = 16;
                _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(formatcodes);

              case 18:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context8.next = 27;
                  break;
                }

                code = _step.value;
                transform = transforms[code] || unknownTransform;
                _context8.next = 23;
                return transform(value);

              case 23:
                value = _context8.sent;

              case 24:
                _iteratorNormalCompletion = true;
                _context8.next = 18;
                break;

              case 27:
                _context8.next = 33;
                break;

              case 29:
                _context8.prev = 29;
                _context8.t0 = _context8["catch"](16);
                _didIteratorError = true;
                _iteratorError = _context8.t0;

              case 33:
                _context8.prev = 33;
                _context8.prev = 34;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 36:
                _context8.prev = 36;

                if (!_didIteratorError) {
                  _context8.next = 39;
                  break;
                }

                throw _iteratorError;

              case 39:
                return _context8.finish(36);

              case 40:
                return _context8.finish(33);

              case 41:
                return _context8.abrupt("return", value ? 'qr:' + value : 'remove:');

              case 42:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[16, 29, 33, 41], [34,, 36, 40]]);
      }));

      function replacementImageVars(_x5, _x6) {
        return _ref4.apply(this, arguments);
      }

      return replacementImageVars;
    }()
  }, {
    key: "replacement",
    value: function replacement(match, vars) {
      var _this4 = this;

      var _match3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(match, 4),
          varSpec = _match3[0],
          prefix = _match3[1],
          varname = _match3[2],
          formatSpec = _match3[3];

      var value = vars[varname];
      if (value === null || value === undefined) {
        this.issues.push({ issue: 'unknownVar', varname: varname, varSpec: varSpec, formatSpec: formatSpec });
      }
      if (!value) value = this.missingVarValue(varname);
      if (formatSpec) {
        // The primary use for formatting is to match phone format styles
        formatSpec = formatSpec.substring(1);
        var context = {
          issue: function issue(_issue) {
            var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return _this4.issues.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, obj, { issue: _issue, value: value, varname: varname, varSpec: varSpec, formatSpec: formatSpec }));
          }
        };
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(FORMATS), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _ref9 = _step2.value;
            var pattern = _ref9.pattern,
                format = _ref9.format;

            var _match4 = pattern.exec(formatSpec);
            if (_match4) {
              // Since the pattern matched, we will use the result
              // from the format func. The format func takes the
              // value and any groups from the match (no need to
              // pass the whole match).
              // The format func can signal an issue using this.issue('whatever')
              _match4[0] = value;
              value = format.apply(context, _match4);
              return value && prefix + value;
            }
          }
          // No format found. Continue with value.
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        this.issues.push({ issue: 'unknownFormat', varname: varname, varSpec: varSpec, formatSpec: formatSpec });
      }
      return value && prefix + value;
    }
  }]);

  return TemplateVars;
}();

/* harmony default export */ __webpack_exports__["a"] = (TemplateVars);


var FORMATS = [{
  // Handle formats like: [ph1|000.000.0000]
  // Incoming values that also match US phone numbers
  // will be changed to use the separators in the format.
  pattern: /^\d{3}(\W)\d{3}(\W)\d{4}/,
  format: function format(value, sep1, sep2) {
    var pieces = /^(\d{3})\W(\d{3})\W(\d{4})/.exec(value);
    if (!pieces) {
      this.issue("value isn't in xxx-xxx-xxxx format");
      return value;
    }
    return [pieces[1], sep1, pieces[2], sep2, pieces[3]].join('');
  }
}, {
  pattern: /^caps$/,
  format: function format(value) {
    return value.toUpperCase();
  }
}];

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__ = __webpack_require__("9mmO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_data_view__ = __webpack_require__("1uLP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_data_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_data_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_int8_array__ = __webpack_require__("52Wt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_int8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_int8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_array__ = __webpack_require__("TFWu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_uint8_clamped_array__ = __webpack_require__("MyjO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_uint8_clamped_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_uint8_clamped_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_int16_array__ = __webpack_require__("qtRy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_int16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_int16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_uint16_array__ = __webpack_require__("THnP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_uint16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_uint16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_int32_array__ = __webpack_require__("K0JP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_int32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_int32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_uint32_array__ = __webpack_require__("NfZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_uint32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_uint32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float32_array__ = __webpack_require__("dTzs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_typed_float64_array__ = __webpack_require__("+vXH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_typed_float64_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_typed_float64_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_map__ = __webpack_require__("MsuQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_set__ = __webpack_require__("dSUw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_map__ = __webpack_require__("ZDXm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_weak_set__ = __webpack_require__("V/H1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_weak_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_weak_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_apply__ = __webpack_require__("CVR+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_apply___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_apply__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct__ = __webpack_require__("vmSu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_define_property__ = __webpack_require__("4ZU1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_delete_property__ = __webpack_require__("yx1U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_delete_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_delete_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get__ = __webpack_require__("SPtU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_own_property_descriptor__ = __webpack_require__("A52B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_get_prototype_of__ = __webpack_require__("PuTd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_has__ = __webpack_require__("dm+7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_is_extensible__ = __webpack_require__("JG34");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_own_keys__ = __webpack_require__("Rw4K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_own_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_own_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_prevent_extensions__ = __webpack_require__("9mGU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set__ = __webpack_require__("bUY0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_reflect_set_prototype_of__ = __webpack_require__("mTp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_reflect_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_reflect_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_promise__ = __webpack_require__("y9m4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_symbol__ = __webpack_require__("A0n/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_freeze__ = __webpack_require__("VTn2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_seal__ = __webpack_require__("W/IU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_seal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_seal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_prevent_extensions__ = __webpack_require__("Y5ex");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_frozen__ = __webpack_require__("WpPb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_frozen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_frozen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_sealed__ = __webpack_require__("+yjc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_sealed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_sealed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_is_extensible__ = __webpack_require__("gPva");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_own_property_descriptor__ = __webpack_require__("C+4B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_get_prototype_of__ = __webpack_require__("W4Z6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_keys__ = __webpack_require__("tJwI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_get_own_property_names__ = __webpack_require__("eC2H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_assign__ = __webpack_require__("n12u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_object_is__ = __webpack_require__("nRs1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_object_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_object_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_object_set_prototype_of__ = __webpack_require__("jrHM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_function_name__ = __webpack_require__("EuXz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_function_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_function_name__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_raw__ = __webpack_require__("F3sI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_raw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_raw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_from_code_point__ = __webpack_require__("bqOW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_from_code_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_from_code_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_code_point_at__ = __webpack_require__("Racj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_code_point_at___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_code_point_at__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_repeat__ = __webpack_require__("tqSY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_repeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_repeat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_starts_with__ = __webpack_require__("CvWX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_starts_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_starts_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_string_ends_with__ = __webpack_require__("Y1S0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_string_ends_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_string_ends_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_string_includes__ = __webpack_require__("Gh7F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_string_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_string_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_flags__ = __webpack_require__("pd+2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_flags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_flags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_match__ = __webpack_require__("MfeA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_replace__ = __webpack_require__("VjuZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_regexp_split__ = __webpack_require__("mJx5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_regexp_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_regexp_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_regexp_search__ = __webpack_require__("qwQ3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_regexp_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_regexp_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_from__ = __webpack_require__("beEN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_of__ = __webpack_require__("xMpm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_copy_within__ = __webpack_require__("9vc3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_copy_within___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_copy_within__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_find__ = __webpack_require__("WpTh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_find_index__ = __webpack_require__("U6qc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_array_fill__ = __webpack_require__("No4x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_array_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_array_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_array_iterator__ = __webpack_require__("WgSQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_array_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_array_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_finite__ = __webpack_require__("yuXV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_integer__ = __webpack_require__("XtiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_is_safe_integer__ = __webpack_require__("A1ng");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_is_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_is_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_is_nan__ = __webpack_require__("LG56");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_epsilon__ = __webpack_require__("Stuz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_epsilon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_epsilon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_number_min_safe_integer__ = __webpack_require__("aJ2J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_number_min_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_number_min_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_number_max_safe_integer__ = __webpack_require__("WiIn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_acosh__ = __webpack_require__("v2lb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_acosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_acosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_asinh__ = __webpack_require__("7Jvp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_asinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_asinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_atanh__ = __webpack_require__("lyhN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_atanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_atanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_cbrt__ = __webpack_require__("kBOG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_cbrt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_cbrt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_clz32__ = __webpack_require__("xONB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_clz32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_clz32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_cosh__ = __webpack_require__("LlNE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_cosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_cosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_expm1__ = __webpack_require__("9xIj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_expm1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_expm1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_fround__ = __webpack_require__("m6Yj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_fround___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_fround__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_hypot__ = __webpack_require__("wrs0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_hypot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_hypot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_imul__ = __webpack_require__("Lqg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_imul___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_imul__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log1p__ = __webpack_require__("pWGb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log1p___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log1p__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_log10__ = __webpack_require__("1ip3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_log10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_log10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_log2__ = __webpack_require__("N4KQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_log2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_log2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_sign__ = __webpack_require__("Hl+4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_sinh__ = __webpack_require__("MjHD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_sinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_sinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_math_tanh__ = __webpack_require__("SRCy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_math_tanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_math_tanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_core_js_modules_es6_math_trunc__ = __webpack_require__("H0mh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_core_js_modules_es6_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86_core_js_modules_es6_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_array_includes__ = __webpack_require__("gbyG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_values__ = __webpack_require__("YVn/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_object_entries__ = __webpack_require__("FKfb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_object_get_own_property_descriptors__ = __webpack_require__("zmx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_core_js_modules_es7_string_pad_start__ = __webpack_require__("smQ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_core_js_modules_es7_string_pad_start___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91_core_js_modules_es7_string_pad_start__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_core_js_modules_es7_string_pad_end__ = __webpack_require__("m8F4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_core_js_modules_es7_string_pad_end___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92_core_js_modules_es7_string_pad_end__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_timers__ = __webpack_require__("v8VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_core_js_modules_web_immediate__ = __webpack_require__("dich");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_core_js_modules_web_immediate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94_core_js_modules_web_immediate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_core_js_modules_web_dom_iterable__ = __webpack_require__("fx22");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_core_js_modules_web_dom_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95_core_js_modules_web_dom_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_regenerator_runtime_runtime__ = __webpack_require__("SldL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_regenerator_runtime_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96_regenerator_runtime_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98_logrocket__ = __webpack_require__("oeg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98_logrocket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98_logrocket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102_bootstrap_vue__ = __webpack_require__("Tqaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105_raven_js__ = __webpack_require__("/Hyb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_105_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106_raven_js_plugins_vue__ = __webpack_require__("6fN7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_106_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__lib_VueBus__ = __webpack_require__("xhDO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108_vue_clipboard2__ = __webpack_require__("wvfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_108_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__components_global_js__ = __webpack_require__("Qs8C");


































































































// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// Set up logrocket. apparently it must be set up before anything else

 // Import after anything that wraps XHR

if (true) {
  __WEBPACK_IMPORTED_MODULE_98_logrocket___default.a.init('vrewso/brandly-com');
  window.LogRocket = __WEBPACK_IMPORTED_MODULE_98_logrocket___default.a;
}












if (true) {
  __WEBPACK_IMPORTED_MODULE_105_raven_js___default.a.config("https://941bc37eccc94edb902d528ecfcd7900@sentry.io/502819", { environment: "production" }).addPlugin(__WEBPACK_IMPORTED_MODULE_106_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_99_vue__["default"]).install();
  console.log('sentry:', "https://941bc37eccc94edb902d528ecfcd7900@sentry.io/502819");
}

__WEBPACK_IMPORTED_MODULE_99_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_102_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_99_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_107__lib_VueBus__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_99_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_108_vue_clipboard2___default.a);

var config = {
  errorBagName: 'errors', // change if property conflicts
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'en',
  dictionary: null,
  strict: true,
  classes: true,
  classNames: {
    touched: 'ng-touched', // the control has been blurred
    untouched: 'ng-untouched', // the control hasn't been blurred
    valid: 'ng-valid', // model is valid
    invalid: 'ng-invalid', // model is invalid
    pristine: 'ng-pristine', // control has not been interacted with
    dirty: 'ng-dirty' // control has been interacted with
  },
  events: 'input|blur',
  inject: true,
  validity: false,
  aria: true
};
__WEBPACK_IMPORTED_MODULE_99_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_104_vee_validate__["a" /* default */], config);

//Globally available components


__WEBPACK_IMPORTED_MODULE_99_vue__["default"].config.productionTip = false;
if (false) {
  Vue.config.devtools = true;
}

// Create the app, and make it available for debugging and testing infrastructure.
window.VueApp = new __WEBPACK_IMPORTED_MODULE_99_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_103__store_store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_101__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_100__App__["a" /* default */] }
});

// Expose URL config for debugging and testing infrastructure
window.APP_URLS = {"API":"https://www.brandly.com/backend/","APP":"https://www.brandly.com","STATIC":false};

/***/ }),

/***/ "NIcx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c2c89c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtworkGuidelines_vue__ = __webpack_require__("C1V3");
function injectStyle (ssrContext) {
  __webpack_require__("YSld")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c2c89c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c2c89c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtworkGuidelines_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NMoF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyLink_vue__ = __webpack_require__("ZyXO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b661995e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyLink_vue__ = __webpack_require__("icR4");
function injectStyle (ssrContext) {
  __webpack_require__("ymvS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b661995e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b661995e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NlBh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['amount']
});

/***/ }),

/***/ "Nq36":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkout_vue__ = __webpack_require__("lUDa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_791f79e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkout_vue__ = __webpack_require__("BmkL");
function injectStyle (ssrContext) {
  __webpack_require__("R92y")
  __webpack_require__("rn8n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-791f79e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_791f79e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Nr6S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"product-form"}},[_c('b-form-group',{staticClass:"not-too-wide",attrs:{"label":"quantity"}},[_c('b-form-radio-group',{attrs:{"buttons":"","options":_vm.quantityOptions},model:{value:(_vm.quantity),callback:function ($$v) {_vm.quantity=$$v},expression:"quantity"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"not-too-wide",attrs:{"label":"corners"}},[_c('b-form-radio-group',{attrs:{"buttons":"","options":_vm.cornerOptions},model:{value:(_vm.corners),callback:function ($$v) {_vm.corners=$$v},expression:"corners"}})],1),_vm._v(" "),(_vm.price)?_c('div',{staticClass:"price not-too-wide"},[_c('label',[_vm._v("Your price:\n      "),_c('div',{staticClass:"amount"},[_vm._v("$"+_vm._s(_vm.price.toFixed(2)))])]),_vm._v(" "),_c('b-button',{attrs:{"disabled":_vm.flags.legacy,"title":_vm.flags.legacy ? 'Cannot start order on IE11' : '',"variant":"default"},on:{"click":_vm.startOrder}},[_vm._v("Start Order")])],1):_vm._e(),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"standard-options"},[_c('div',{staticClass:"square"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/delivery.svg","id":"delivery"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("Free Delivery")])]),_vm._v(" "),_c('div',{staticClass:"square"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/backside.svg","id":"backsides"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("Free backsides")])]),_vm._v(" "),_c('div',{staticClass:"square"},[_c('img',{staticClass:"icons",attrs:{"src":"/static/images/product/icons/trust.svg","id":"care"}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("Handled with care")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NuDt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DebugTools_vue__ = __webpack_require__("pG7h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37377b21_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DebugTools_vue__ = __webpack_require__("51J/");
function injectStyle (ssrContext) {
  __webpack_require__("/Mbr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-37377b21"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DebugTools_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37377b21_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DebugTools_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Nype":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['member'],
  data: function data() {
    return { busy: false };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['designId', 'flags', 'members', 'user', 'isAdmin']), {
    membersExcludingSelf: function membersExcludingSelf() {
      var _this = this;

      return this.members.filter(function (member) {
        return member.email !== _this.user.email;
      });
    },
    showDropdown: function showDropdown() {
      // If the member is passed we will only start order for that member
      // Feature is gated, and requires admin access.
      // We disable the button for legacy. Therefore don't show the dropdown
      return !this.member && this.flags.startOrderDropdown && this.isAdmin && !this.flags.legacy;
    }
  }),
  mounted: function mounted() {
    if (this.showDropdown) this.loadTeamMembers();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['startOrderFromProductTemplate', 'setOrdereeId', 'loadTeamMembers']), {
    onClickStartOrderButton: function onClickStartOrderButton() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this2.member || !_this2.isAdmin)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', _this2.onClickStartOrderForMember(_this2.member || _this2.user));

              case 2:
                // Admin, no orderee
                _this2.busy = true;
                _context.next = 5;
                return _this2.setOrdereeId(null);

              case 5:
                _context.next = 7;
                return _this2.startOrderFromProductTemplate();

              case 7:
                _this2.$router.push({ name: 'Editor', params: { id: _this2.designId } });

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    onClickStartOrderForMyself: function onClickStartOrderForMyself() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', _this3.onClickStartOrderForMember(_this3.user));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    onClickStartOrderForMember: function onClickStartOrderForMember(member) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.busy = true;
                _context3.next = 3;
                return _this4.setOrdereeId(member.id);

              case 3:
                _context3.next = 5;
                return _this4.startOrderFromProductTemplate(member.team_user_id);

              case 5:
                _this4.$router.push({ name: 'Editor', params: { id: _this4.designId } });

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    memberName: function memberName(member) {
      // Return name, fall back to email
      var first_name = member.first_name,
          last_name = member.last_name,
          email = member.email;

      var name = (first_name + ' ' + last_name).trim();
      return name || email;
    }
  })
});

/***/ }),

/***/ "O+70":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getUploads; });
/* unused harmony export getUpload */
/* unused harmony export patchUpload */
/* unused harmony export postUploadNote */
/* unused harmony export getTags */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineService__ = __webpack_require__("tVbG");


var getUploads = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('get', 'spool/uploads/');

var getUpload = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('get', 'spool/uploads/:id/');

var patchUpload = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('patch', 'spool/uploads/:id/');

var postUploadNote = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('post', 'spool/uploads/:id/notes/');

var getTags = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('get', 'spool/tags/');

/***/ }),

/***/ "O/BJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_mixins__ = __webpack_require__("OeeG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    itemsOnPageDefault: { type: Number, required: false },
    totalItems: { type: Number, required: false },
    itemsName: { type: String, required: false },
    options: { type: Array, required: true },
    onSelectChange: { type: Function, required: true }
  },
  data: function data() {
    return {
      selected: this.itemsOnPageDefault || __WEBPACK_IMPORTED_MODULE_0__services_mixins__["a" /* itemsOnPageDefault */]
    };
  }
});

/***/ }),

/***/ "O/l8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_CheckoutLogic__ = __webpack_require__("KrFv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_AddressVerification__ = __webpack_require__("kuvY");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AddressVerification: __WEBPACK_IMPORTED_MODULE_6__components_shared_AddressVerification__["default"]
  },
  data: function data() {
    return {
      editing: null,
      notification: { message: '', type: '' },
      saveErrors: {}
    };
  },
  mounted: function mounted() {
    this.loadUserAddresses();
    this.loadTeamAddresses();

    if (this.flags.internationalShipping && this.countries.length === 0) {
      this.loadCountries();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["combinedAddresses", "flags", "countries"]), {
    is_private: {
      get: function get() {
        if (!this.editing) return;
        return this.editing.type !== 'team'; // Treat missing values as user addresses
      },
      set: function set(val) {
        if (!this.editing) return;
        this.editing.type = val ? 'user' : 'team';
      }
    },
    isUSA: function isUSA() {
      return Object(__WEBPACK_IMPORTED_MODULE_5__lib_CheckoutLogic__["g" /* isUSA */])(this.editing.country);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["removeAddress", "addAddress", "updateAddress", "loadTeamAddresses", "loadUserAddresses", "refreshAddresses", "setDefaultUserAddress", "loadCountries"]), {
    edit: function edit(address) {
      this.editing = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, address);
      this.editing.origType = this.editing.type;
      this.notification = {};
    },
    del: function del(address) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.removeAddress(address);

              case 3:
                _this.notification = { message: "Address deleted", type: "success" };
                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);
                _this.notification = { message: "Error deleting address: " + _context.t0, type: "danger" };

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 6]]);
      }))();
    },
    cancel: function cancel(event) {
      this.editing = null;
      this.notification = {};
    },
    quit: function quit() {
      this.$router.push('/dashboard/settings');
      this.notification = {};
    },
    add: function add() {
      this.editing = { type: 'team', adding: true, country: "US" };
      this.notification = {};
    },
    save: function save(event) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var valid, action;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.editing) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                _context2.next = 4;
                return _this2.$validator.validate();

              case 4:
                valid = _context2.sent;

                if (valid) {
                  _context2.next = 10;
                  break;
                }

                console.log(valid);
                console.log(_this2.errors.all());
                _this2.notification = { message: "Please fix the errors below", type: 'danger' };
                return _context2.abrupt('return');

              case 10:
                action = _this2.editing.adding ? 'addAddress' : 'updateAddress';
                _context2.prev = 11;
                _context2.next = 14;
                return _this2[action](_this2.editing);

              case 14:
                _this2.editing = null;
                _context2.next = 20;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2['catch'](11);

                if (_context2.t0 instanceof Error || typeof _context2.t0 === "string") {
                  _this2.notification = { message: "Error saving address: " + _context2.t0, type: "danger" };
                } else {
                  // error is a list of invalid field states
                  _this2.saveErrors = _context2.t0;
                }

              case 20:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[11, 17]]);
      }))();
    },
    favorite: function favorite(address) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.setDefaultUserAddress(address);

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    favoriteIconHtml: function favoriteIconHtml(_ref) {
      var is_default_for_shipping = _ref.is_default_for_shipping;

      // Work around font-not-awesome failing to notice class changes by
      // returning HTML elements
      var cls = is_default_for_shipping ? 'fas' : 'far';
      return '<i class="' + cls + ' fa-star"></i>';
    },
    messageReceived: function messageReceived(event) {
      console.log('messageReceived');
      this.notification = event.detail;
    },
    validationAttrsFor: function validationAttrsFor(fieldname) {
      var feedback = void 0,
          state = void 0;

      var err = this.saveErrors[fieldname] || this.errors.first(fieldname);

      feedback = err;
      state = !err; // TODO maybe return null when v-validate "untouched" flag or similar

      // console.log(this.errors);
      // console.log('validationAttrsFor', fieldname, feedback, state);

      return { state: state, 'invalid-feedback': feedback };
    }
  })
});

/***/ }),

/***/ "OEQ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-menu d-sm-none"},[_c('div',{staticClass:"fixed-menu-body"},_vm._l((_vm.nav),function(item){return _c('router-link',{key:item.title,staticClass:"link",class:item.linkClass,attrs:{"to":item.to}},[_c('div',{staticClass:"icon-container"},[(item.icon)?_c('i',{class:item.icon}):_vm._e(),_vm._v(" "),(item.src)?_c('img',{attrs:{"src":item.src}}):_vm._e(),_vm._v(" "),(item.symbol)?_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":("/static/images/dashboard/sprites.svg#" + (item.symbol))}})]):_vm._e()]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.title))])])}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OHIq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OIVy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__billing_SavedCard_vue__ = __webpack_require__("7qho");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__billing_NewSavedCard_vue__ = __webpack_require__("TDWY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__billing_EditSavedCard_vue__ = __webpack_require__("oK/h");






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { SavedCard: __WEBPACK_IMPORTED_MODULE_7__billing_SavedCard_vue__["a" /* default */], NewSavedCard: __WEBPACK_IMPORTED_MODULE_8__billing_NewSavedCard_vue__["a" /* default */], EditSavedCard: __WEBPACK_IMPORTED_MODULE_9__billing_EditSavedCard_vue__["a" /* default */] },
  data: function data() {
    return {
      loading: false,
      editing: null,
      saving: false,
      notification: { message: '', type: '' }
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.loadUserAddresses();

              _this.loading = true;
              _context.next = 4;
              return _this.loadSavedCards();

            case 4:
              _this.loading = false;
              if (!_this.hasSavedCards && !_this.forceInvoice) {
                // No card on file -- alert user
                _this.notification = {
                  // TODO should be info but doesn't look right
                  type: 'warning',
                  message: 'No cards on file'
                };
              }

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(['user', 'savedCards', 'isStaff', 'forceInvoice', 'userAddresses']), {
    defaultAddress: function defaultAddress() {
      // Return the users' default for shipping address,
      // or the first address, or null
      var addresses = this.userAddresses;
      if (!addresses || !addresses.length) return null;
      var address = addresses.find(function (addr) {
        return addr.is_default_for_shipping;
      }) || addresses[0];
      // Return only the address fields
      // TODO should we include name?
      var line1 = address.line1,
          line2 = address.line2,
          line3 = address.line3,
          city = address.city,
          state = address.state,
          postcode = address.postcode,
          country = address.country;

      return { line1: line1, line2: line2, line3: line3, city: city, state: state, postcode: postcode, country: country };
    },
    hasSavedCards: function hasSavedCards() {
      return this.savedCards && this.savedCards.length;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(['loadSavedCards', 'deleteSavedCard', 'addSavedCard', 'editSavedCard', 'loadUserAddresses']), {
    cancel: function cancel(event) {
      if (this.editing) {
        this.editing = null;
        event.preventDefault();
      }
      // otherwise go back to dashboard
    },
    isOwner: function isOwner(card) {
      return card.owner.id === this.user.id;
    },
    add: function add() {
      // Begin adding a card.
      this.editing = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.defaultAddress, { available_to_team: false });
      this.notification = {};
    },
    edit: function edit(card) {
      // Begin editing, from an existing card.
      this.editing = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, card);
      if (!this.editing.line1) {
        // No address, use default
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.editing, this.defaultAddress);
      }
    },
    del: function del(card) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.deleteSavedCard(card.id);

              case 2:
                _this2.notification = { message: "Card deleted", type: "success" };

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    save: function save() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var message;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('save!', _this3.editing);
                _this3.saving = true;
                _context3.prev = 2;
                message = void 0;

                if (!_this3.editing.id) {
                  _context3.next = 10;
                  break;
                }

                message = "Card edited";
                _context3.next = 8;
                return _this3.editSavedCard(_this3.editing);

              case 8:
                _context3.next = 13;
                break;

              case 10:
                message = "Card added";
                _context3.next = 13;
                return _this3.addSavedCard(_this3.editing);

              case 13:
                _this3.editing = null;
                _this3.notification = { message: message, type: "success" };
                _context3.next = 21;
                break;

              case 17:
                _context3.prev = 17;
                _context3.t0 = _context3['catch'](2);

                // Stay in editing mode
                if ((typeof _context3.t0 === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_context3.t0)) === 'object') {
                  // Try to unwrap the object
                  if (_context3.t0.message) _context3.t0 = _context3.t0.message;else _context3.t0 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_context3.t0);
                }
                _this3.notification = { type: 'danger', message: _context3.t0 };

              case 21:
                _this3.saving = false;

              case 22:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[2, 17]]);
      }))();
    }
  })
});

/***/ }),

/***/ "OKld":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2962892_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TOS_vue__ = __webpack_require__("x4PC");
function injectStyle (ssrContext) {
  __webpack_require__("PT+S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d2962892"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2962892_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TOS_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "OeeG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return itemsOnPageDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return listWithSearchAndPaginationMixin; });
var itemsOnPageDefault = 10;
var itemsOnPageOptions = [itemsOnPageDefault, 25, 50, 100];

var listWithSearchAndPaginationMixin = {
  props: {
    query: { type: Object, default: function _default() {
        return {};
      } }
  },
  data: function data() {
    return {
      itemsOnPage: this.query.itemsOnPage ? parseInt(this.query.itemsOnPage) : itemsOnPageDefault,
      itemsOnPageOptions: itemsOnPageOptions,
      pageNumber: this.query.pageNumber ? parseInt(this.query.pageNumber) : 1,
      search: this.query.search ? this.query.search.toString() : null,

      queryStringKeysToCheck: ['search', 'pageNumber', 'itemsOnPage'],

      useMountedFromMixin: true
      // Component that uses this mixin must return `functionToCallOnChange` and `listPathName`.
      // E.g.
      // functionToCallOnChange: this.loadVouchersPaginated,
      // listPathName: 'voucher-list',
    };
  },

  computed: {
    /**
     * Prepare params that will be used as a query string for API calls.
     *
     * If this method overridden in a component, `queryStringKeysToCheck`
     * in `data` must be overridden as well.
     *
     * @returns {Object}
     */
    loadingParams: function loadingParams() {
      return {
        itemsOnPage: this.itemsOnPage,
        pageNumber: this.pageNumber,
        search: this.search
      };
    },

    /**
     * Prepare params that will be used/shown as a query string in
     * browser's address bar.
     *
     * @returns {Object}
     */
    queryParams: function queryParams() {
      var _this = this;

      var params = {};
      this.queryStringKeysToCheck.forEach(function (key) {
        if (_this[key]) {
          params[key] = _this[key];
        }
      });
      return params;
    }
  },
  mounted: function mounted() {
    if (this.useMountedFromMixin) {
      this.loadList();
    }
  },

  methods: {
    loadList: function loadList() {
      // `replace` in this case will update a query string in browser's address bar.
      // `catch` needed here to remove "NavigationDuplicated" error from console.
      // Please see: https://github.com/vuejs/vue-router/issues/2872
      this.$router.replace({ name: this.listPathName, query: this.queryParams }).catch(function (error) {});

      // Update component's data respectively to the query string.
      this.functionToCallOnChange(this.loadingParams);
    },
    onSearchTermChange: function onSearchTermChange(searchTerm) {
      // Avoid searching on short search terms
      if (searchTerm.length && searchTerm.length < 3) return;

      // If `searchTerm == ''` (empty string) it is better to set it to `null`.
      // In this case in URL's query string we will not have "search=".
      var newSearchTerm = searchTerm.trim() || null;
      if (this.search !== newSearchTerm) {
        this.search = newSearchTerm;
        // Start from the 1st page on each search term change.
        this.pageNumber = 1;
        this.loadList();
      }
    },
    onPageNumberChange: function onPageNumberChange(pageNumber) {
      this.pageNumber = pageNumber;
      this.loadList();
    },
    goToDetailPage: function goToDetailPage(pageName, itemID) {
      this.$router.push({ name: pageName, params: { id: itemID } });
    },
    onItemsOnPageChange: function onItemsOnPageChange(itemsOnPageNew) {
      this.itemsOnPage = itemsOnPageNew;
      // Start from the 1st page on each change.
      this.pageNumber = 1;
      this.loadList();
    }
  }
};

/***/ }),

/***/ "Ogs3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RestrictedToggle_vue__ = __webpack_require__("up6a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c81ec54e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RestrictedToggle_vue__ = __webpack_require__("ejcI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RestrictedToggle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c81ec54e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RestrictedToggle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Olxo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OqPs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OwFv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['pageNum'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['thumbnails', 'selectedProductIsRounded']), {
    src: function src() {
      return this.thumbnails[this.pageNum];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['setPage']), {
    changePage: function changePage() {
      this.setPage(this.pageNum);
    }
  })
});

/***/ }),

/***/ "P1+S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditMemberAddress_vue__ = __webpack_require__("BxuS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7e63b9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditMemberAddress_vue__ = __webpack_require__("iVxh");
function injectStyle (ssrContext) {
  __webpack_require__("dzLO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a7e63b9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditMemberAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7e63b9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditMemberAddress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P14B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SharedLineItemProductForm',{attrs:{"line":_vm.line,"auto-save":"","restrict-qty":!!_vm.userSettings.restrictQty,"restrict-product":!!_vm.userSettings.restrictProduct},on:{"save":_vm.save}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P2lH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P61H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P8/q":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ActionButton.vue": "tkrX",
	"./Address.vue": "mKdL",
	"./AddressVerification.vue": "kuvY",
	"./BackButton.vue": "uvBe",
	"./CartCheckoutWrapper.vue": "Xvqp",
	"./Currency.vue": "FQ9t",
	"./DesignPreview.vue": "YqDi",
	"./GoogleCircle.vue": "HR0b",
	"./GoogleSignIn.vue": "uTlF",
	"./InlineEditToggle.vue": "nlQn",
	"./ItemsOnPageSelect.vue": "qwfB",
	"./LineItemPreview.vue": "sqHK",
	"./LineItemThumbnails.vue": "Ym/O",
	"./LinkedInCircle.vue": "CTGo",
	"./LinkedInSignIn.vue": "iObd",
	"./MessageAlert.vue": "i/fC",
	"./MessageFormGroup.vue": "bYCz",
	"./OverlappedPreview.vue": "jEl5",
	"./Pagination.vue": "ntQ2",
	"./PdfUploader.vue": "H/Pd",
	"./PrivateToggle.vue": "avd0",
	"./ProductTemplatePreview.vue": "QCix",
	"./ProgressDots.vue": "JqLU",
	"./RestrictedToggle.vue": "Ogs3",
	"./Restrictions.vue": "XxlJ",
	"./SearchForm.vue": "FY8P",
	"./SelectWithSearch.vue": "96kP",
	"./SettingsButtons.vue": "CkWj",
	"./SettingsTitleBar.vue": "BW4t",
	"./SharedLineItemProductForm.vue": "RSkm",
	"./SideBySidePreview.vue": "WylX",
	"./SignUpForm.vue": "8M+/",
	"./SignUpProgress.vue": "ICnN",
	"./SimplePagination.vue": "cVDX",
	"./StartOrderButton.vue": "J3pk",
	"./SurveyLink.vue": "NMoF",
	"./TeamShareInput.vue": "FBhG",
	"./TemplateChooser.vue": "b3El",
	"./TitlePrevNext.vue": "mvsB",
	"./Toggle.vue": "BvLC",
	"./WaveSpinner.vue": "Kbzo",
	"./WistiaMovie.vue": "YqKw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "P8/q";

/***/ }),

/***/ "P99z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('TopBar'),_vm._v(" "),(_vm.$route.meta.useAppHeader)?_c('AppHeader'):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PG+a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    searchTextDefault: { type: String, default: '' },
    buttonText: { type: String, default: 'Search' },
    buttonIcon: { type: String, default: 'fa-search' },
    helpText: { type: String, required: false },
    isBusy: { type: Boolean, default: false },
    onButtonClick: { type: Function, required: false }
  },
  data: function data() {
    return {
      search: this.searchTextDefault
    };
  },

  methods: {
    cleanInput: function cleanInput() {
      this.search = '';
      this.$emit('input', '');
    }
  }
});

/***/ }),

/***/ "PK0i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PT+S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PW1k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// from http://www.frontcoded.com/javascript-fit-rectange-into-bounds.html
/* harmony default export */ __webpack_exports__["a"] = (function (rect, bounds) {
  var rectRatio = rect.width / rect.height;
  var boundsRatio = bounds.width / bounds.height;

  var newDimensions = {};

  // Rect is more landscape than bounds - fit to width
  if (rectRatio > boundsRatio) {
    newDimensions.width = bounds.width;
    newDimensions.height = rect.height * (bounds.width / rect.width);
  }
  // Rect is more portrait than bounds - fit to height
  else {
      newDimensions.width = rect.width * (bounds.height / rect.height);
      newDimensions.height = bounds.height;
    }

  return newDimensions;
});;

/***/ }),

/***/ "Pysz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q6E8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_prices_json__ = __webpack_require__("0HZ9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_prices_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__data_prices_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_track_events__ = __webpack_require__("Dg6a");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["category", "corners"],
  computed: {
    rows: function rows() {
      return __WEBPACK_IMPORTED_MODULE_2__data_prices_json__["prices"][this.category][this.corners];
    },
    items: function items() {
      return this.rows.entries().map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            product = _ref2[0],
            prices = _ref2[1];

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ product: product }, prices);
      });
    }
  },
  mounted: function mounted() {
    Object(__WEBPACK_IMPORTED_MODULE_3__lib_track_events__["q" /* viewedPricing */])("pricing-page");
  },

  methods: {
    price: function price(row, qty) {
      var p = row.prices[qty];
      return p ? "$" + p.toFixed(2) : "N/A";
    }
  }
});

/***/ }),

/***/ "QCix":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductTemplatePreview_vue__ = __webpack_require__("QD5+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c59a543_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductTemplatePreview_vue__ = __webpack_require__("STbH");
function injectStyle (ssrContext) {
  __webpack_require__("CQfM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c59a543"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductTemplatePreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c59a543_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductTemplatePreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "QD5+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['compact', 'editButton'],
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["productTemplateDesignId", "productTemplatePreviewUrls", "productTemplateIsRounded"])
});

/***/ }),

/***/ "QNoD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer-container d-none d-lg-block"},[_c('div',{staticClass:"side-menu"},[_c('div',{staticClass:"action-card"},[_c('h2',[_vm._v("Done Editing?")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.actionParams.help))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{class:_vm.buttonClass,on:{"~click":function($event){return _vm.$emit('action')}}},[_vm._v("\n        "+_vm._s(_vm.actionParams.button)+" "),_c('i',{staticClass:"fa fa-arrow-right"})])]),_vm._v(" "),(_vm.canvasState.hasBadBleed && _vm.canvasState.displayBleed && !_vm.canvasState.dismissedBleedWarning)?_c('WarningBox',{attrs:{"title":"Check Document Bleed"}},[_c('p',[_vm._v("Be sure that images and solid colors extend beyond the final size of the card by 1/8\" on every side. The file dimensions should be 3.75\" x 2.25\".\n\n      ")]),_c('p',{staticClass:"mt-3"},[_vm._v("Look for the bleed warning indicators ("),_c('span',{staticClass:"bleed-point ml-1"}),_vm._v(" "),_c('span',{staticClass:"bleed-point"}),_vm._v(" "),_c('span',{staticClass:"bleed-point mr-1"}),_vm._v(") in your document.")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('b-btn',{staticClass:"mt-2 ",on:{"click":function($event){return _vm.bus.$emit('dismissBleedWarning');}}},[_vm._v("Looks OK")])],1)]):_vm._e(),_vm._v(" "),(!_vm.canvasState.hasTextAtStartup)?_c('WarningBox',{attrs:{"title":"Check Document Text"}},[_c('p',[_vm._v("Your document has no text.")]),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("Did you convert to curves? Consider uploading a new file that has text objects.")])]):(!_vm.lockButtons)?_c('div',{staticClass:"action-card"},[_c('h2',[_vm._v("Add images?")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"uploadArea",on:{"click":function($event){return _vm.bus.$emit('showUploadDialog')}}},[_c('span',[_c('i',{staticClass:"fas fa-upload"}),_vm._v(" Drag File")])])]):_vm._e(),_vm._v(" "),_vm._m(0)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-card"},[_c('h2',[_vm._v("Need Help?")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Can’t get everything to look as you want?")]),_vm._v(" "),_c('ul',{staticClass:"help-links"},[_c('li',[_vm._v("\n          Read "),_c('a',{attrs:{"href":"/support/artwork","target":"_blank"}},[_vm._v("Artwork Prep FAQs")])]),_vm._v(" "),_c('li',[_vm._v("\n          Read "),_c('a',{attrs:{"href":"/support/fileupload","target":"_blank"}},[_vm._v("Upload FAQs")])]),_vm._v(" "),_c('li',[_vm._v("Feel free to\n          "),_c('a',{attrs:{"href":"mailto:support@brandly.com","target":"_blank"}},[_vm._v("Email us")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QQQE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FieldOptionsArea_vue__ = __webpack_require__("Yw92");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42d7e8a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FieldOptionsArea_vue__ = __webpack_require__("rjIM");
function injectStyle (ssrContext) {
  __webpack_require__("EJNV")
  __webpack_require__("yW2/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42d7e8a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FieldOptionsArea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42d7e8a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FieldOptionsArea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QVrB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_emailDomainType__ = __webpack_require__("joGj");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  meta: {
    requiresAuth: true,
    requiresAuthRedirect: '/signup'
  },
  data: function data() {
    return {
      teamUpdates: {
        domain: null,
        name: '',
        company_size: null,
        have_design: null
      },
      profileUpdates: {
        job_role: null
      },
      saving: false,
      notification: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(['user', 'flags']), {
    firstName: function firstName() {
      return this.user && this.user.first_name;
    },
    target: function target() {
      // TODO go to a welcome tab
      return '/dashboard';
    },
    pristine: function pristine() {
      // All fields are pristine
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(this.fields).every(function (field) {
        return field.pristine;
      });
    },
    invalid: function invalid() {
      // Any field is invalid
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(this.fields).some(function (field) {
        return field.invalid;
      });
    },
    buttonVariant: function buttonVariant() {
      // We only switch to the CTA red when the user can submit.
      return !this.pristine && !this.invalid ? 'default' : 'secondary';
    },
    buttonDisabled: function buttonDisabled() {
      // The user can't press the button while the danger message is displaying.
      return this.notification && this.notification.type === 'danger';
    },
    needsDomain: function needsDomain() {
      return Object(__WEBPACK_IMPORTED_MODULE_6__lib_emailDomainType__["a" /* default */])(this.user.email) !== 'custom';
    }
  }),
  watch: {
    invalid: function invalid(val, old) {
      console.log(val, !!this.notification);
      if (!val && !!this.notification) {
        // User just finished thier job fixing the fields. Encourage them
        // with a nice message
        this.notification = { message: "Thank you! 😀", type: 'success' };
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['updateTeam', 'updateProfile']), {
    onSubmit: function onSubmit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var valid, teamUpdates;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$validator.validate();

              case 2:
                valid = _context.sent;

                if (valid) {
                  _context.next = 6;
                  break;
                }

                _this.notification = { message: "Please fill in all fields", type: 'danger' };
                return _context.abrupt('return');

              case 6:

                _this.saving = true;

                // Treat blank as "No update"
                // This allows user to continue in most cases
                // TODO: remove once we're sure we're not making these optional
                teamUpdates = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this.teamUpdates);

                if (!teamUpdates.name) delete teamUpdates.name;
                if (!teamUpdates.domain) delete teamUpdates.domain;
                _context.next = 12;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this.updateTeam(teamUpdates), _this.updateProfile(_this.profileUpdates)]);

              case 12:
                _this.saving = false;
                _this.$router.push(_this.target);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  })
});

/***/ }),

/***/ "Qd5V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QduS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QkeZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-outer"},[_c('div',{staticClass:"get-email"},[_c('b-form-group',{staticClass:"no-border",attrs:{"feedback":_vm.error,"state":!_vm.error}},[_c('b-input-group',[_c('b-form-input',{staticClass:"hero-input",attrs:{"type":"text","placeholder":"yourname@example.com"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-btn',{staticClass:"red",on:{"click":_vm.onClickSignUp}},[_vm._v("Subscribe")])],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Qo3V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedLine)?_c('CartCheckoutWrapper',{staticClass:"basket-item-detail"},[_c('b-container',{attrs:{"id":"basket-item-detail"}},[_c('div',{attrs:{"id":"item-detail-layout"}},[_c('div',{attrs:{"col-sm-12":"","col-lg-7":"","id":"images"}},[_c('h1',{staticClass:"product-title"},[_c('router-link',{attrs:{"to":"/cart"}},[_c('i',{staticClass:"fas fa-chevron-left"}),_vm._v("\n            "+_vm._s(_vm.selectedLine.product.title))])],1),_vm._v(" "),_c('LineItemPreview',{attrs:{"line":_vm.selectedLine},on:{"edit":_vm.editDesign}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-lg-5",attrs:{"id":"sidebar"}},[_c('div',{attrs:{"id":"details"}},[_c('div',{staticClass:"action-card actions d-none d-lg-block",attrs:{"id":"check-out"}},[_c('h2',[_vm._v("Ready to proceed?")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Press the button below when you are ready to check out.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"button-wrapper"},[_c('router-link',{staticClass:"btn-action",staticStyle:{"margin-bottom":"12px"},attrs:{"to":"/cart"}},[_vm._v("\n                  Cart\n                  "),_c('i',{staticClass:"fa fa-arrow-right"})])],1)]),_vm._v(" "),_c('div',{staticClass:"action-card actions",attrs:{"id":"action-form"}},[_c('div',{staticClass:"details-title"},[_c('i',{staticClass:"fa fa-arrow-down"}),_vm._v(" Edit Details")]),_vm._v(" "),_c('LineItemProductForm',{attrs:{"line":_vm.selectedLine}}),_vm._v(" "),_c('div',{staticClass:"more-actions"},[_c('button',{staticClass:"btn remove-from-cart",on:{"click":_vm.orderAnother}},[_c('i',{staticClass:"far fa-clone"}),_vm._v(" Order Another")]),_vm._v(" "),_c('button',{staticClass:"btn remove-from-cart",on:{"click":_vm.removeItem}},[_c('i',{staticClass:"far fa-trash-alt"}),_vm._v(" Remove Item")])])],1)])]),_vm._v(" "),_c('div',{staticClass:"fixed-menu d-lg-none"},[_c('div',{staticClass:"fixed-menu-wrapper"},[_c('div',{staticClass:"btn-hint"},[_c('a',{attrs:{"href":"mailto:support@brandly.com"}},[_vm._v("Need help?")])]),_vm._v(" "),_c('router-link',{staticClass:"btn-action",staticStyle:{"margin-bottom":"12px"},attrs:{"to":"/cart"}},[_vm._v("\n          Cart"),_c('i',{staticClass:"fa fa-arrow-right"})])],1)])])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Qs8C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


function registerAll(context_module) {
  context_module.keys().map(function (key) {
    var name = key.match(/\w+/)[0];
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(name, context_module(key).default);
  });
}
registerAll(__webpack_require__("uNuT"));
registerAll(__webpack_require__("P8/q"));
registerAll(__webpack_require__("W/tP"));

/***/ }),

/***/ "Qv8Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editor_EditModeToggle__ = __webpack_require__("Kwom");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { EditModeToggle: __WEBPACK_IMPORTED_MODULE_1__editor_EditModeToggle__["a" /* default */] },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['flags']), {
    canvasState: function canvasState() {
      return {};
    }
  }),
  methods: {}
});

/***/ }),

/***/ "R/vV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R0BY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    bleedPoints: {
      type: Array,
      default: []
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['flags']), {
    debug: function debug() {
      return this.flags.debugTools;
    },
    outerPoints: function outerPoints() {
      var _ref;

      var outerArrays = this.bleedPoints.map(function (bleedPoint) {
        return bleedPoint.o;
      });
      return (_ref = []).concat.apply(_ref, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(outerArrays)); // flatten array of arrays.
    }
  }),
  methods: {
    bleedPointStyle: function bleedPointStyle(sample, isOuterSample) {

      var display = this.debug ? 'block' : 'none';
      var backgroundColor = sample.isColored ? 'lime' : 'yellow';
      var border = 'none';

      if (isOuterSample) {
        backgroundColor = 'purple';
        if (sample.badBleed) {
          display = 'block';

          // colors to modify for production (all the other colors are just for debug.
          backgroundColor = 'magenta';
          border = '1px solid darkblue';
        }
      }
      return {
        left: sample.x + 'px',
        top: sample.y + 'px',
        backgroundColor: backgroundColor,
        display: display,
        border: border
      };
    }
  }
});

/***/ }),

/***/ "R5BO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditorBackPlaceholder_vue__ = __webpack_require__("+2No");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54a9c9a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditorBackPlaceholder_vue__ = __webpack_require__("3Jps");
function injectStyle (ssrContext) {
  __webpack_require__("q1WO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54a9c9a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditorBackPlaceholder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54a9c9a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditorBackPlaceholder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R6xP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.amount != null)?_c('span',{staticClass:"amount"},[_vm._v("$"+_vm._s((+_vm.amount).toFixed(2)))]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R7IX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__QtyPriceForm__ = __webpack_require__("sVcB");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["product"],
  components: {
    QtyPriceForm: __WEBPACK_IMPORTED_MODULE_0__QtyPriceForm__["a" /* default */]
  },
  computed: {
    hasPerspectiveClass: function hasPerspectiveClass() {
      var classStr = this.product["class"] || "";
      return classStr.match(/\bperspective\b/);
    }
  },
  methods: {
    showIcon: function showIcon(tag) {
      var p = this.product;
      return p && p.tags && p.tags.includes(tag);
    }
  }
});

/***/ }),

/***/ "R92y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RCUT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RKCl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',[(_vm.show == 'menu')?_c('b-dropdown',{staticClass:"header-menu",attrs:{"size":"sm","variant":"clear","right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fas fa-ellipsis-v"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.currentTemplateId = '*new*'}}},[_vm._v("Add design")])],2):_c('div',{staticClass:"template-chooser-row"},[_c('div',{staticClass:"hscroll"},[_c('b-radio-group',{staticClass:"template-choices",attrs:{"button-variant":"clear","buttons":""},model:{value:(_vm.currentTemplateId),callback:function ($$v) {_vm.currentTemplateId=$$v},expression:"currentTemplateId"}},[_vm._l((_vm.productTemplates),function(pt){return _c('b-radio',{key:pt.id,attrs:{"value":pt.id}},[(_vm.isEditingTemplateName && _vm.currentTemplateId === pt.id)?_c('div',{staticClass:"embedded-input-container"},[_c('b-input',{staticClass:"embedded-input",attrs:{"autofocus":"","value":pt.name},on:{"input":function($event){return _vm.updateDesignName($event, pt)}}}),_vm._v(" "),_c('span',{staticClass:"ok",on:{"click":_vm.acceptEdits}},[_c('i',{staticClass:"fas fa-check-circle"})]),_vm._v(" "),_c('span',{staticClass:"cancel",on:{"click":_vm.cancelEdits}},[_c('i',{staticClass:"fas fa-times-circle"})])],1):[_vm._v(_vm._s(pt.name))]],2)}),_vm._v(" "),(_vm.showAddButton)?_c('b-radio',{attrs:{"value":"*new*"}},[_c('i',{staticClass:"fas fa-plus"})]):_vm._e()],2)],1),_vm._v(" "),(_vm.showDropdown)?_c('b-dropdown',{staticClass:"template-chooser-menu",attrs:{"size":"sm","variant":"clear","right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fas fa-ellipsis-v"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.isEditingTemplateName=true}}},[_vm._v("Rename design")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.cloneCurrentDesign}},[_vm._v("Clone design")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.deleteCurrentDesign}},[_vm._v("Delete design")])],2):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RKT0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HowItWorksButton_vue__ = __webpack_require__("Ynxk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cb5e63c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HowItWorksButton_vue__ = __webpack_require__("zDIk");
function injectStyle (ssrContext) {
  __webpack_require__("u68k")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0cb5e63c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HowItWorksButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cb5e63c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HowItWorksButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "RKWU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RLK9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_design__ = __webpack_require__("VFA2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_track_events__ = __webpack_require__("Dg6a");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    extra: {},
    controlStyle: {
      default: 'combo'
    },
    allowDrag: {
      default: true
    },
    variant: {
      default: 'default'
    }
  },
  data: function data() {
    return {
      busy: false,
      error: null,
      dragging: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['flags']), {
    validUploadTypeText: function validUploadTypeText() {
      return 'PDF';
    },
    btnClass: function btnClass() {
      return this.controlStyle == 'link' ? '' : 'btn-' + this.variant;
    },
    waveColor: function waveColor() {
      return this.controlStyle === 'link' || this.variant === "primary" ? 'red' : 'white';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["setDesign"]), {
    startBrowsing: function startBrowsing() {
      this.error = null;
      this.$refs.file.click();
    },
    onFileSelected: function onFileSelected(evt) {
      try {
        this.uploadFile(evt.target.files[0]);
      } finally {
        // Clear the input so the user can upload again
        evt.target.value = '';
      }
    },
    uploadFile: function uploadFile(file) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var design, doDefault, event;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.busy = true;
                _context.prev = 1;
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_3__services_design__["k" /* upload */])(file, _this.extra);

              case 4:
                design = _context.sent;
                doDefault = true;
                event = {
                  design: design,
                  preventDefault: function preventDefault() {
                    doDefault = false;
                  }
                };

                if (design.missingFonts) {
                  Object(__WEBPACK_IMPORTED_MODULE_5__lib_track_events__["f" /* fontsMissingWarning */])(design.missingFonts.join(', '));
                }
                _this.$emit("upload", event);
                if (doDefault) {
                  _this.setDesign(design);
                  _this.$router.push({ name: "Editor", params: { id: design.id } });
                } else {
                  _this.busy = false;
                }
                _context.next = 19;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](1);

                if (_context.t0 == null) {
                  // It's possible for e to be null/undefined. Ensure we don't pass undefined,
                  // which causes wierdness. TODO how?
                  _context.t0 = null;
                } else {
                  // Stringify
                  _context.t0 = '' + _context.t0;
                }
                if (_context.t0 === 'Invalid file type.') {
                  // Rewrite to be friendlier and more useful.
                  _context.t0 = "Please upload a " + _this.validUploadTypeText + " file";
                }
                _this.error = _context.t0;
                _this.$emit("error", _this.error);
                _this.busy = false;

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 12]]);
      }))();
    },
    onDrop: function onDrop(evt) {
      console.log(evt, evt.dataTransfer.files);
      this.uploadFile(evt.dataTransfer.files[0]);
      this.dragging = false;
    },
    onDragOver: function onDragOver(evt) {},
    onDragEnter: function onDragEnter(evt) {
      if (this.allowDrag) this.dragging = true;
    },
    onDragLeave: function onDragLeave(evt) {
      this.dragging = false;
    }
  }),
  mounted: function mounted() {
    document.body.addEventListener('dragenter', this.onDragEnter);
  },
  beforeDestroy: function beforeDestroy() {
    document.body.removeEventListener('dragenter', this.onDragEnter);
  }
});

/***/ }),

/***/ "RS4M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"btn btn-secondary",attrs:{"to":"/signup"}},[_vm._v("OPEN YOUR FREE ACCOUNT")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RSB7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeftNav_vue__ = __webpack_require__("LJlt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b7f2a81_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeftNav_vue__ = __webpack_require__("bpDn");
function injectStyle (ssrContext) {
  __webpack_require__("DllR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b7f2a81"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeftNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b7f2a81_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeftNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RSkm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SharedLineItemProductForm_vue__ = __webpack_require__("Ev13");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f06f3a3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SharedLineItemProductForm_vue__ = __webpack_require__("KalV");
function injectStyle (ssrContext) {
  __webpack_require__("Fsh9")
  __webpack_require__("Z0C3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f06f3a3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SharedLineItemProductForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f06f3a3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SharedLineItemProductForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "RXVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditorCanvas_vue__ = __webpack_require__("UQF+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f2c73ab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditorCanvas_vue__ = __webpack_require__("/o6N");
function injectStyle (ssrContext) {
  __webpack_require__("H8fS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f2c73ab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditorCanvas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f2c73ab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditorCanvas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RYrk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export deeplyMunge */
/* unused harmony export shallowToApi */
/* unused harmony export shallowFromApi */
/* harmony export (immutable) */ __webpack_exports__["b"] = toApiAddressFormat;
/* harmony export (immutable) */ __webpack_exports__["a"] = fromApiAddressFormat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);





/** Utilities for dealing with Brandly API addresses
 * Oscar stores city as "line4". We convert to the more
 * conventional names at the service level, using the routines herein.
 *
 * NB "Munge" means "To perform a lossy transformation of data, for not very good reasons."
 *
 */

function deeplyMunge(func, object) {
  if (Array.isArray(object)) return object.map(function (item) {
    return deeplyMunge(func, item);
  });
  if (!object || (typeof object === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(object)) !== 'object') return object;
  var result = func(object);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(result)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var k = _step.value;

      result[k] = deeplyMunge(func, result[k]);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return result;
}

/**
 * Ensure address follows API conventions:
 * 1. countries specified by URL
 * 2. "city" renamed to "line4"
 * 3. Remove "address_verification"
 * Returns a copy of given object. Does not apply deeply.
 * @param {*} object
 */
function shallowToApi(object) {
  var country = object.country,
      line4 = object.city,
      address_verification = object.address_verification,
      rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(object, ['country', 'city', 'address_verification']);

  if (country && !/\//.test(country)) country = 'http://www.lvh.me/services/cart/api/v1/cart/countries/' + country + '/';
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ line4: line4, country: country }, rest);
}

/**
 * Ensure address follows App conventions:
 * 1. countries specified by two digit code, not URL
 * 2. "line4" renamed to "city"
 * Returns a copy of given object. Does not apply deeply.
 * @param {*} object
 */
function shallowFromApi(object) {
  var match = void 0,
      country = object.country,
      city = object.line4,
      rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(object, ['country', 'line4']);
  if (country && (match = /countries\/(..)\//.exec(country))) country = match[1];
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ city: city, country: country }, rest);
}

function toApiAddressFormat(object) {
  return deeplyMunge(shallowToApi, object);
}

function fromApiAddressFormat(object) {
  return deeplyMunge(shallowFromApi, object);
}

/***/ }),

/***/ "RgZC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WelcomeSection__ = __webpack_require__("uIng");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DesignSection__ = __webpack_require__("9edP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OnboardSection__ = __webpack_require__("CoOB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TeamSection__ = __webpack_require__("tAjI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ShareSection__ = __webpack_require__("geU/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    WelcomeSection: __WEBPACK_IMPORTED_MODULE_1__WelcomeSection__["a" /* default */],
    DesignSection: __WEBPACK_IMPORTED_MODULE_2__DesignSection__["a" /* default */],
    OnboardSection: __WEBPACK_IMPORTED_MODULE_3__OnboardSection__["a" /* default */],
    TeamSection: __WEBPACK_IMPORTED_MODULE_4__TeamSection__["a" /* default */],
    ShareSection: __WEBPACK_IMPORTED_MODULE_5__ShareSection__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(['onboardingHidden', 'flags', 'isAdmin']), {
    showTeamSection: function showTeamSection() {
      return this.isAdmin || this.flags.showTeamTabToOrderers;
    }
  })
});

/***/ }),

/***/ "Rjv0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-signin",attrs:{"id":"linkedin"},on:{"click":_vm.onClick}},[_c('img',{staticClass:"social-logo",attrs:{"src":"/static/images/signin/linkedin/linkedin.svg"}}),_vm._v(" "),_c('div',{staticClass:"social-text",attrs:{"id":"linkedin"}},[_vm._t("default",[_vm._v("Sign in with LinkedIn")])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Rmo0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_products_js__ = __webpack_require__("6TJt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_selectedProduct__ = __webpack_require__("D3mI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_track_events__ = __webpack_require__("Dg6a");






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["paper"],
  data: function data() {
    return {
      products: [],
      quantity: 50,
      corners: "Square"
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])(['flags']), {
    price: function price() {
      // May return undefined!
      var info = this.infoForSides[1] || this.infoForSides[2];
      return info && info.price;
    },
    twoSidedPrice: function twoSidedPrice() {
      // If different, return the price for a 2 sided card.
      // Some products may be one-sided only or two sided only.
      // In those cases this always returns null.
      var _infoForSides = this.infoForSides,
          one = _infoForSides[1],
          two = _infoForSides[2];

      if (!one || !two) return null;
      return one.price !== two.price ? two.price : null;
    },
    quantityOptions: function quantityOptions() {
      var quantities = this.selectedProducts.map(function (p) {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(p.prices);
      });
      return Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["sortBy"])(Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["uniq"])(Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["flatten"])(quantities)), parseInt);
    },
    cornerOptions: function cornerOptions() {
      // Always put square first
      // reverse the array so we sort by highest index fisrt and unfound items (-1) are last
      var order = ["Square", "Rounded"].reverse();
      var sortFn = function sortFn(a, b) {
        return order.indexOf(b) - order.indexOf(a);
      };
      return Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["uniq"])(this.selectedProducts.map(function (p) {
        return p.attrs.corners;
      })).sort(sortFn);
    },
    selectedProducts: function selectedProducts() {
      var _this = this;

      return this.products.filter(function (_ref) {
        var name = _ref.name;
        return name === _this.paper;
      });
    },
    infoForSides: function infoForSides() {
      // Return url, price for 1 or 2 sides {1: {url: ..., price: ...}, 2: ...}
      var result = {};
      console.log(this.paper);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.selectedProducts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var p = _step.value;

          var price = p.prices[this.quantity];
          var url = p.urls[this.quantity];

          if (p.attrs.corners === this.corners) {
            result[p.attrs.sides] = { price: price, url: url };
          } else {
            console.log("no corners match", p.attrs.corners, this.corners);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      console.log("infoForSides->", result);
      return result;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(["selectProduct"]), {
    loadProducts: function loadProducts() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = _this2;
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_6__services_products_js__["a" /* products */])("any");

              case 3:
                _context.t1 = _context.sent;
                _this2.products = _context.t0.decorateProducts.call(_context.t0, _context.t1);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    decorateProducts: function decorateProducts(products) {
      // decorate the products with an unpacked attrs, derived from product.attributes
      // same with prices
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(products), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var p = _step2.value;

          p.attrs = {};
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(p.product.attributes), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _ref2 = _step3.value;
              var sku_tag = _ref2.sku_tag;

              var _sku_tag$split = sku_tag.split(":"),
                  _sku_tag$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_sku_tag$split, 2),
                  key = _sku_tag$split2[0],
                  value = _sku_tag$split2[1];

              p.attrs[key] = value;
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          p.prices = {};
          p.urls = {};
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(p.product.prices), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var _ref3 = _step4.value;
              var quantity = _ref3.quantity,
                  retail_price = _ref3.retail_price,
                  stockrecord = _ref3.stockrecord;

              p.prices[quantity] = retail_price;
              p.urls[quantity] = stockrecord.product;
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return products;
    },
    startOrder: function startOrder() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var selectedInfo, url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                selectedInfo = {
                  quantity: _this3.quantity,
                  1: _this3.infoForSides[1] && _this3.infoForSides[1].url,
                  2: _this3.infoForSides[2] && _this3.infoForSides[2].url
                };
                url = "/upload/" + Object(__WEBPACK_IMPORTED_MODULE_9__lib_selectedProduct__["a" /* compressed */])(selectedInfo);

                if (_this3.$route.query.design) url += "/" + _this3.$route.query.design;
                _this3.$router.push(url);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  }),
  created: function created() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this4.loadProducts();

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  },
  mounted: function mounted() {
    Object(__WEBPACK_IMPORTED_MODULE_10__lib_track_events__["q" /* viewedPricing */])('catalog-page');
  }
});

/***/ }),

/***/ "RrUZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rv1s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppLayout',[_c('MobileLeftNav',{attrs:{"nav":_vm.nav}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"d-none d-sm-block",attrs:{"sm":"2","md":"3"}},[_c('LeftNav',{attrs:{"nav":_vm.nav}},[_vm._v(">")])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"10","md":"9"}},[(_vm.ready)?_c('div',{class:_vm.$route.meta.noBorder ? 'dashboard-bare' : 'dashboard-content p-lg-5 p-3'},[_c('router-view')],1):_vm._e()])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Rxzk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SMdB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = update;
function update() {
  if (false) console.log('track/update', window.location.href);
  if (window.Intercom) window.Intercom('update');
  if (window.Reamaze && window.Reamaze.reload) window.Reamaze.reload();
  if (window.ga) {
    window.ga(function () {
      // TODO check if this is the right tracker or send to all?
      var tracker = ga.getAll()[0];
      tracker.set('page', window.location.pathname);
      tracker.send('pageview');
    });
  }
  if (window.userpilot) window.userpilot.reload();
}

/***/ }),

/***/ "SRV0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["title", "items"]
});

/***/ }),

/***/ "SRy8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomepageWideLayout',[_c('div',{staticClass:"vheight"},[_c('div',{staticClass:"vcenter"},[_c('div',{staticClass:"vblock"},[_c('div',{staticClass:"wrapper"},[(_vm.showWelcome)?_c('div',[_c('h1',[_vm._v("Welcome back!")]),_vm._v(" "),_c('h2',[_vm._v("Sign in with email")])]):_vm._e(),_vm._v(" "),(_vm.badCreds || _vm.resetState === 'ok')?_c('div',[(!_vm.resetState || _vm.resetState === 'busy')?_c('div',[_c('h1',[_vm._v("That didn't work")]),_vm._v(" "),_c('h2',[_vm._v("Try again?")]),_vm._v(" "),_c('h3',{attrs:{"id":"reset"}},[_vm._v("or")]),_vm._v(" "),_c('h2',[_c('b-button',{staticClass:"reset-button",staticStyle:{"color":"white"},attrs:{"variant":"secondary","href":""},on:{"click":_vm.reset}},[(_vm.resetState === 'busy')?_c('span',[_vm._v("Resetting your password...")]):_c('span',[_vm._v("Reset your password")])])],1)]):_c('div',[_c('h1',[_vm._v("Email sent")]),_vm._v(" "),_c('h2',[_vm._v("Check your inbox")]),_vm._v(" "),_c('h3',{attrs:{"id":"reset"}},[_vm._v("or")]),_vm._v(" "),_c('h2',[_c('b-button',{staticStyle:{"color":"white"},attrs:{"variant":"secondary","href":""},on:{"click":_vm.reset}},[_vm._v("Send again")])],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-wrapper"},[_c('b-form-group',{staticClass:"signup-form",attrs:{"id":"new_sign_up","accept-charset":"UTF-8","method":"post"},on:{"submit":_vm.submit}},[_c('div',{staticClass:"signup-fieldset"},[_c('b-form-input',{staticClass:"signup-account-input",attrs:{"placeholder":"Your email address","required":"required","type":"email","autofocus":"autofocus","name":"email","pattern":"[^@]+@[^@]+\\.[a-zA-Z]*"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),(!_vm.forgot)?_c('b-form-input',{staticClass:"signup-account-input",attrs:{"placeholder":"Password","required":"required","type":"password","autofocus":"autofocus","name":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}):_vm._e(),_vm._v(" "),(_vm.loginError)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.loginError.toString()))]):_vm._e(),_vm._v(" "),(!_vm.forgot)?_c('b-button',{staticClass:"signup-account-submit",attrs:{"type":"submit","name":"commit","disabled":_vm.loginBusy || !_vm.formValid},on:{"click":_vm.submit}},[(_vm.loginBusy)?_c('span',[_vm._v("Signing In...")]):_c('span',[_vm._v("Sign In")])]):_vm._e(),_vm._v(" "),(!_vm.forgot)?_c('span',{attrs:{"id":"forgot-password"},on:{"click":function($event){_vm.forgot=true}}},[_vm._v("Forgot password?")]):_vm._e(),_vm._v(" "),(_vm.forgot)?_c('b-button',{on:{"click":_vm.reset}},[(_vm.resetState === 'busy')?_c('span',[_vm._v("Sending...")]):_c('span',[_vm._v("Send reset email")])]):_vm._e(),_vm._v(" "),(_vm.resetState === 'error' && _vm.resetMessage)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.resetMessage.toString()))]):_vm._e()],1)])],1),_vm._v(" "),_c('h3',[_vm._v("or")]),_vm._v(" "),_c('div',{staticClass:"social-wrapper"},[_c('GoogleSignIn',{on:{"login":_vm.onGoogleLogin}}),_vm._v(" "),_c('LinkedInSignIn',{on:{"login":_vm.onLinkedInLogin}})],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "STbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.productTemplateDesignId)?[_c('OverlappedPreview',_vm._g({staticClass:"preview",attrs:{"preview-urls":_vm.productTemplatePreviewUrls,"rounded":_vm.productTemplateIsRounded,"edit-button":_vm.editButton}},_vm.$listeners))]:_c('img',{staticClass:"placeholder",attrs:{"src":"/static/images/dashboard/placeholder_card.svg"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SZ9m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"absolute"}},[_c('input',{ref:"hiddenFileInput",staticStyle:{"display":"none"},attrs:{"accept":_vm.validUploadTypes,"type":"file"},on:{"change":_vm.uploadFileFromInput}}),_vm._v(" "),(_vm.dragging)?_c('div',{staticClass:"overlay-dropzone",on:{"click":_vm.onClick,"drop":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDrop($event)},"dragover":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragOver($event)},"dragenter":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragEnter($event)},"dragleave":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragLeave($event)}}},[(_vm.disabled)?_c('i',{staticClass:"fas fa-exclamation-triangle",staticStyle:{"pointer-events":"none"}}):_c('i',{staticClass:"fas fa-upload",staticStyle:{"pointer-events":"none"}}),_vm._v(" "),_c('div',{staticStyle:{"pointer-events":"none"}},[(_vm.disabled)?_c('div',[_vm._v("Design is locked.")]):_c('div',[_vm._v("Upload Image or Logo")])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Sn0f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SwHB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomepageWideLayout',[_c('section',[_c('SecondaryHeader',{attrs:{"heroDark":""}},[_c('h2',[_vm._v("About Brandly")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("Our goal is to build the fastest and easiest business card ordering platform for any size business.")])]),_vm._v(" "),_c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"sm":"12","lg":"4"}},[_c('div',{staticClass:"parent"},[_c('div',{staticClass:"copy-container"},[_c('div',{staticClass:"h2-copy"},[_c('h2',[_vm._v("Who we are")])])])])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"8"}},[_c('div',{staticClass:"parent"},[_c('div',{staticClass:"copy-container",attrs:{"id":"long-text"}},[_c('div',{staticClass:"copy"},[_c('p',[_vm._v("We are a young innovative company with extensive experience in the graphic arts industry. We work from the San Franciso Bay Area, Los Angeles, and South Carolina and all share a passion for taking care of our customers.")])])])])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"sm":"12","lg":"4"}},[_c('div',{staticClass:"parent"},[_c('div',{staticClass:"copy-container"},[_c('div',{staticClass:"h2-copy"},[_c('h2',[_vm._v("What we do")])])])])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"8"}},[_c('div',{staticClass:"parent"},[_c('div',{staticClass:"copy-container",attrs:{"id":"long-text"}},[_c('div',{staticClass:"copy"},[_c('p',[_vm._v("We help workplaces become more productive by simplifying their process for ordering printing. We started with the product that touches the most employees - business cards. We figured saving time on business cards would have the most dramatic impact on your time and effort.")])])])])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"sm":"12","lg":"4"}},[_c('div',{staticClass:"parent"},[_c('div',{staticClass:"copy-container"},[_c('div',{staticClass:"h2-copy"},[_c('h2',[_vm._v("Why it matters")])])])])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"8"}},[_c('div',{staticClass:"parent"},[_c('div',{staticClass:"copy-container",attrs:{"id":"long-text"}},[_c('div',{staticClass:"copy"},[_c('p',[_vm._v("\n                    As your organization grows, processes like ordering business cards can become more of a burden. The task is often passsed along or split up amongst teams or locations as things change.\n                    Brandly makes it easy for your print ordering to scale with your needs so you can free your employees up to focus on other things.\n                  ")])])])])])],1)],1)],1),_vm._v(" "),_c('Testimonial'),_vm._v(" "),_c('Demo')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T9qD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TDWY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewSavedCard_vue__ = __webpack_require__("stem");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ccdea0b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewSavedCard_vue__ = __webpack_require__("hH7a");
function injectStyle (ssrContext) {
  __webpack_require__("oXYQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ccdea0b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewSavedCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ccdea0b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewSavedCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TLBc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22def6c5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Features2_vue__ = __webpack_require__("4UJt");
function injectStyle (ssrContext) {
  __webpack_require__("2oJl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-22def6c5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22def6c5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Features2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "TPTq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14111c3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GetStartedButton_vue__ = __webpack_require__("RS4M");
function injectStyle (ssrContext) {
  __webpack_require__("RrUZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14111c3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14111c3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GetStartedButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "TWDo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['actionParams']
});

/***/ }),

/***/ "TbTU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["signedUp"]
});

/***/ }),

/***/ "Tc2H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_homepage_HomePage__ = __webpack_require__("i2cO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_homepage_BusinessCardsNew__ = __webpack_require__("+eQK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__("wtEF");






var routes = [{
  path: "/",
  name: "Home",
  component: __WEBPACK_IMPORTED_MODULE_2__components_pages_homepage_HomePage__["default"],
  meta: {
    title: "Brandly | Business Cards for Growing Teams"
  }
}, {
  // Redirect from /papers (printed on sample packs) to the most appropriate place
  path: "/papers",
  redirect: "/business-cards"
}, {
  // Redirect from /products (linked from the blog) to the most appropriate place
  path: "/products",
  redirect: "/business-cards"
}, {
  path: "/business-cards/:slug?",
  name: "Catalog",
  component: __WEBPACK_IMPORTED_MODULE_3__components_pages_homepage_BusinessCardsNew__["default"],
  props: true,
  meta: {
    title: "Brandly | Products"
  }
}, {
  path: "/blog",
  beforeEnter: function beforeEnter() {
    if (window.location.pathname != '/blog/') {
      window.location = "/blog/";
    }
  }
}, {
  path: "/get",
  redirect: "/signup"
}];

/***** Automatic route logic *****
 * Any files in components/pages/homepage become routes, ie SignIn.vue becomes /signin
 * The file can include a 'meta' key in the default export to override the default title logic.
 * eg:
 *
 * <script>
 * export default {
 *   meta: {title: "Foo"}
 * }
 * </script>
 *
 * Only files in the top level and under bubsinesscard/ are included,
 * subdirectories can be included by following the format used by businesscards.
 *
 * If the component has props they become OPTIONAL segments in the route.
 * Eg ResetPassword.vue has props uid, token
 * /resetpassword routes to the component, as does /resetpassword/1/123
 */
addRoutes(__webpack_require__("XpeC"));
/* harmony default export */ __webpack_exports__["a"] = (routes);

function addRoutes(context_module) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  context_module.keys().forEach(function (key) {
    return addRoute(path + key.replace(/^.\/|\.vue/g, ''), context_module(key));
  });
}
function addRoute(file, module) {
  var component = module.default;
  var path = '/' + file.toLowerCase();
  var meta = component.meta || {};

  var _file$split$slice = file.split('/').slice(-1),
      _file$split$slice2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_file$split$slice, 1),
      name = _file$split$slice2[0];

  if (!meta.title) meta.title = 'Brandly | ' + name.replace(/([a-z])([A-Z])/g, "$1 $2");
  var route = { name: name, path: path, component: component, meta: meta };

  if (component.props) {
    var propnames = Array.isArray(component.props) ? component.props : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(component.props);
    route.path += propnames.map(function (s) {
      return '/:' + s + '?';
    }).join('');
    route.props = true;
  }
  routes.push(route);
}

/***/ }),

/***/ "TeLn":
/***/ (function(module, exports) {

module.exports = {"AL":"Alabama","AK":"Alaska","AZ":"Arizona","AR":"Arkansas","CA":"California","CO":"Colorado","CT":"Connecticut","DC":"District of Columbia","DE":"Delaware","FL":"Florida","GA":"Georgia","HI":"Hawaii","ID":"Idaho","IL":"Illinois","IN":"Indiana","IA":"Iowa","KS":"Kansas","KY":"Kentucky","LA":"Louisiana","ME":"Maine","MD":"Maryland","MA":"Massachusetts","MI":"Michigan","MN":"Minnesota","MS":"Mississippi","MO":"Missouri","MT":"Montana","NE":"Nebraska","NV":"Nevada","NH":"New Hampshire","NJ":"New Jersey","NM":"New Mexico","NY":"New York","NC":"North Carolina","ND":"North Dakota","OH":"Ohio","OK":"Oklahoma","OR":"Oregon","PA":"Pennsylvania","RI":"Rhode Island","SC":"South Carolina","SD":"South Dakota","TN":"Tennessee","TX":"Texas","UT":"Utah","VT":"Vermont","VA":"Virginia","WA":"Washington","WV":"West Virginia","WI":"Wisconsin","WY":"Wyoming"}

/***/ }),

/***/ "TlUu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['line'],
  computed: Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['userSettings']),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['updateLine']), {
    save: function save(_ref) {
      var _this = this;

      var saving = _ref.saving,
          boxSize = _ref.boxSize,
          product = _ref.product;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return saving(_this.updateLine({
                  line: _this.line,
                  boxSize: boxSize,
                  product: product
                }));

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  })
});

/***/ }),

/***/ "U3gh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('BackButton'),_vm._v(" "),_c('MessageAlert',[(_vm.orderDetails)?_c('article',{staticClass:"order"},[_c('div',{staticClass:"order-header"},[_c('b-row',[_c('b-col',{staticClass:"pb-3",attrs:{"lg":"5","sm":"7"}},[_c('div',[_vm._v("Order # "),_c('b',{on:{"click":function($event){return _vm.reloadOrderDetails()}}},[_vm._v(_vm._s(_vm.orderDetails.number))])]),_vm._v(" "),_c('div',[_vm._v("Email "),_c('b',[_vm._v(_vm._s(_vm.orderDetails.guest_email))])]),_vm._v(" "),(_vm.orderDetails.date_shipped)?_c('div',[_vm._v("Date Shipped "),_c('b',[_vm._v(_vm._s(_vm.orderDetails.date_shipped.substring(0,10)))])]):_c('div',[_vm._v("Date Placed "),_c('b',[_vm._v(_vm._s(_vm.orderDetails.date_placed.substring(0,10)))])]),_vm._v(" "),(_vm.flags.enableDiscountApplying || _vm.isStaffDashboard)?_c('div',[_vm._v("\n              Code "),_c('b',[_vm._v(_vm._s(_vm.voucherCodeToShow))]),_vm._v(" "),(!_vm.hasVoucherDiscount)?_c('span',{on:{"click":function($event){_vm.isAddVoucherFormShown = true}}},[_c('i',{staticClass:"fas fa-edit clickable"})]):_vm._e(),_vm._v(" "),(!_vm.hasVoucherDiscount && _vm.isAddVoucherFormShown)?_c('span',{staticClass:"btn embedded-input-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.voucherCode),expression:"voucherCode"}],staticClass:"embedded-input",domProps:{"value":(_vm.voucherCode)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.applyDiscount($event)},"input":function($event){if($event.target.composing){ return; }_vm.voucherCode=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"ok clickable",on:{"click":_vm.applyDiscount}},[_c('i',{staticClass:"fas fa-check-circle"})]),_vm._v(" "),_c('span',{staticClass:"cancel clickable",on:{"click":_vm.hideVoucherForm}},[_c('i',{staticClass:"fas fa-times-circle"})])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',[_vm._v("Total "),_c('b',[_vm._v("$"+_vm._s(_vm.orderDetails.total_incl_tax.toFixed(2)))])])]),_vm._v(" "),_c('b-col',{staticClass:"pb-3",attrs:{"lg":"5","sm":"5"}},[_c('dl',[_c('dt',[_vm._v("Ship To")]),_vm._v(" "),_c('dd',[_c('Address',{attrs:{"value":_vm.orderDetails.shipping_address}})],1)])])],1),_vm._v(" "),(_vm.showButtons)?_c('b-row',[_c('b-col',{staticClass:"order-actions mt-3 mt-md-0",attrs:{"md":"6"}},[(_vm.orderDetails.needs_payment)?_c('b-button',{staticClass:"wide mb-3 mb-md-0",attrs:{"variant":"success"},on:{"click":_vm.startPayment}},[_vm._v("Pay & Approve Order")]):_c('ActionButton',{staticClass:"wide",attrs:{"variant":"success","action":"approveOrder","success":"Order has been Approved"}},[_vm._v("Approve Order")])],1),_vm._v(" "),_c('b-col',{staticClass:"order-actions text-center text-lg-left",attrs:{"md":"6"}},[_c('b-button',{staticClass:"wide",attrs:{"variant":"outline-secondary"},on:{"click":_vm.startCancel}},[_vm._v("Cancel Order")])],1)],1):_c('div',{staticClass:"close-button"},[_c('span',{on:{"click":function($event){_vm.mode = null}}},[_c('i',{staticClass:"fas fa-times"})])]),_vm._v(" "),(_vm.showPayment)?_c('PaymentRow',{staticClass:"mr-3"}):_vm._e(),_vm._v(" "),(_vm.showCancelDetails)?_c('b-row',{staticClass:"mr-3"},[_c('b-col',{staticClass:"pb-3",attrs:{"md":"7"}},[_c('b-textarea',{attrs:{"rows":"4","placeholder":"Enter reason for cancelling"},model:{value:(_vm.reason),callback:function ($$v) {_vm.reason=$$v},expression:"reason"}})],1),_vm._v(" "),_c('b-col',{staticClass:"text-right mb-3",attrs:{"md":"3"}},[_c('ActionButton',{attrs:{"action":"cancelOrder","arg":_vm.reason,"variant":"outline-secondary","success":"Order has been Cancelled"}},[_vm._v("Cancel Order")])],1)],1):_vm._e()],1),_vm._v(" "),_vm._l((_vm.orderDetails.lines),function(line){return _c('LineDetailRow',{key:line.url,staticClass:"order-line",attrs:{"order":_vm.orderDetails,"line":line,"can-delete":_vm.canDeleteLines,"can-change":_vm.canChangeLines}})})],2):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UAK+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UDnD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"mb-4",attrs:{"align-h":"end"}},[(_vm.totalItems)?_c('b-col',{attrs:{"cols":"8"}},[_c('div',[_vm._v(_vm._s(_vm.totalItems)+" "+_vm._s(_vm.itemsName))])]):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-form',{staticClass:"float-right",attrs:{"inline":""}},[_c('label',{staticClass:"label-select",attrs:{"for":"items-on-page-select"}},[_vm._v("Items on page")]),_vm._v(" "),_c('b-form-select',{staticClass:"ml-1",attrs:{"size":"sm","id":"items-on-page-select","options":_vm.options},on:{"change":_vm.onSelectChange},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UGVJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DesignPreview',{staticClass:"line-item-preview",attrs:{"preview-urls":_vm.line.preview_urls,"rounded":_vm.roundedCorners,"edit-button":"true"},on:{"edit":function($event){return _vm.$emit('edit')}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UQF+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_is__ = __webpack_require__("g4PW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_fabric__ = __webpack_require__("tsU9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_fabric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_fabric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_Scaler__ = __webpack_require__("IiRJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_TemplateVars__ = __webpack_require__("N90E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_UndoStack__ = __webpack_require__("aBMo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_initAligningGuidelines__ = __webpack_require__("jw2m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_fitRectIntoBounds__ = __webpack_require__("PW1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_centerRectWithinBounds__ = __webpack_require__("Igay");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_selectTopLeftObject__ = __webpack_require__("x+Up");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_cropCanvas__ = __webpack_require__("WVe7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lib_getBleedPoints__ = __webpack_require__("LyaO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lib_anyBadBleed__ = __webpack_require__("cUJk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__EditorControlsOverlay__ = __webpack_require__("lwsu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_flatten__ = __webpack_require__("6YxY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_uniq__ = __webpack_require__("WIDu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash_uniq__);








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















var RATIO = 1.5; // TODO where does this come from

//if there are <= this number of bad bleed points, we don't show them or put up the warning
var BLEED_POINT_THRESHOLD = 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    EditorControlsOverlay: __WEBPACK_IMPORTED_MODULE_20__EditorControlsOverlay__["a" /* default */]
  },
  props: ['pageNum', 'fontsLoaded', 'bus', 'designLocked', 'nofill'],
  data: function data() {
    return {
      fabricCanvas: null,
      loaded: false,
      currentObject: null,
      page: null,
      canvasState: {
        fonts: [],
        colors: [],
        fontName: '',
        fontSize: 0,
        color: '',
        position: { x: null, y: null },
        canUndo: false,
        canRedo: false,
        textSelected: false,
        originX: undefined,
        allowMultiline: undefined,
        textTransform: undefined,
        fieldLocked: undefined,
        fieldDeletable: undefined,
        variable: undefined,
        isPlaceholder: undefined,
        hasBadBleed: false,
        displayBleed: true,
        hasTextAtStartup: true,
        blockId: undefined,
        dismissedBleedWarning: false, //serialized via layers meta object
        blocks: null //serialized via layers meta object
      },
      trimHorizontalMargins: 0,
      trimVerticalMargins: 0,
      textMode: true,
      bleedPoints: [],
      forceDisplayBleed: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_19_vuex__["c" /* mapGetters */])(['design', 'selectedProductIsRounded', 'thumbnails', 'flags']), {
    backgroundSvgMarkup: function backgroundSvgMarkup() {
      return this.page && this.page.backgroundLayer.svgMarkup;
    },
    backgroundSvgDataUrl: function backgroundSvgDataUrl() {
      if (!this.backgroundSvgMarkup) return;
      var svg = this.backgroundSvgMarkup;
      return 'data:image/svg+xml;base64,' + btoa(svg);
    },
    trimStyle: function trimStyle() {
      if (this.trimHorizontalMargins < 0.1 && this.trimVerticalMargins < 0.1 && !this.selectedProductIsRounded) {
        return { display: 'none' };
      };

      var style = {
        position: 'absolute',
        top: 0, right: 0, bottom: 0, left: 0,
        margin: this.trimVerticalMargins + "px " + this.trimHorizontalMargins + "px",
        border: 'dashed 1px cyan',
        zIndex: 1,
        pointerEvents: 'none'
      };
      if (!this.displayBleed) {
        delete style.border;
        style.boxShadow = '0 0 0 30pt $gray-3';
      }
      return style;
    },
    thumbnail: function thumbnail() {
      return this.thumbnails[this.pageNum];
    },
    designPage: function designPage() {
      return this.design && this.design.pages[this.pageNum];
    },
    displayBleed: function displayBleed() {
      // When filling out a design (is, there is a source design) we don't show bleed.
      // This can be forced by a toggle as well.
      if (this.forceDisplayBleed != null) return this.forceDisplayBleed;
      return !this.canvasState.dismissedBleedWarning && this.design && !this.design.sourceDesign;
    }
  }),
  watch: {
    // When we have both fonts loaded and page for the design,
    // copy page data into $data and trigger canvas setup
    fontsLoaded: function fontsLoaded(val) {
      this.$data.page = val && this.designPage;
    },
    designPage: function designPage(val) {
      this.$data.page = this.fontsLoaded && val;
    },
    page: function page(val) {
      console.log('watch page', val);
      if (val) this.loadPage();
    },


    // Thumbanil may disappear when design is modified by adding back file.
    // Recreate the thumbnail in this case.
    thumbnail: function thumbnail(val, old) {
      if (this.page && old && !val) {
        this.updateThumbnail();
      }
    },


    // Copy current canvas object data over to where toolbar can access it.
    currentObject: function currentObject(obj) {
      this.updateCanvasState();
    },


    // Let parent component know the canvasState has been updated, in the Vue Way.
    canvasState: {
      deep: true,
      handler: function handler(canvasState, prevCanvasState) {
        this.$emit('input', { canvasState: canvasState, pageNum: this.pageNum });
        if (!prevCanvasState.dismissedBleedWarning !== canvasState.dismissedBleedWarning) {
          this.save();
        }
      }
    }
  },
  mounted: function mounted() {
    if (this.page) this.loadPage();
  },

  events: {
    undo: function undo() {
      this.undoStack.undo();
    },
    redo: function redo() {
      this.undoStack.redo();
    },
    convertToBlock: function convertToBlock() {
      var activeObject = this.fabricCanvas.getActiveObject();
      if (activeObject && activeObject.type === 'activeSelection') {
        this.updateCustomPropertiesOnMultipleObjects(activeObject.getObjects(), function (objWithinSelection) {
          return objWithinSelection.blockId = 1;
        });
        this.canvasState.blocks = this.canvasState.blocks || {};
        this.canvasState.blocks[1] = { verticalAlign: 'top' };
      }
      this.fabricCanvas.trigger('object:modified', { target: this.fabricCanvas.getActiveObject() });
      this.commitModification();
    },
    deleteBlock: function deleteBlock(blockIdToDelete) {
      this.fabricCanvas.getObjects().forEach(function (obj) {
        var _ref = obj.brandly || {},
            blockId = _ref.blockId;

        if (blockId === blockIdToDelete) {
          obj.brandly.blockId = undefined;
        }
      });
      this.canvasState.blocks[blockIdToDelete] = undefined;
      this.updateCanvasState();
      this.commitModification();
      this.setBorders();
    },
    exit: function exit() {
      var activeObject = this.fabricCanvas.getActiveObject();
      if (activeObject) {
        if (activeObject.type === 'IText') {
          activeObject.saveNow = true; //save immediate instead of debouncing
          activeObject.exitEditing(); //blur of text forces save
        }
      }
    },
    deleteField: function deleteField(options) {
      var activeObject = this.fabricCanvas.getActiveObject();
      if (activeObject) {

        if (activeObject.type === 'IText') {
          activeObject.exitEditing();
        }

        this.adjustObjectsAfterDeletion(activeObject);

        this.fabricCanvas.remove(activeObject);

        this.fabricCanvas.renderAll();

        this.commitModification();
      }
    },
    toggleDisplayBleed: function toggleDisplayBleed() {
      this.forceDisplayBleed = !this.displayBleed;
    },
    imageDataUploadedEvent: function imageDataUploadedEvent(data) {
      this.imageDataUploaded(data);
    },
    dismissBleedWarning: function dismissBleedWarning() {
      // this.brandlyMetadata = this.brandlyMetadata || {};
      // this.brandlyMetadata.userDismissedBleedWarning = true;
      this.canvasState.dismissedBleedWarning = true;
    },
    duplicateFieldOrAddText: function duplicateFieldOrAddText() {
      var activeObject = this.fabricCanvas.getActiveObject();

      if (activeObject) {
        var isText = activeObject.type === 'IText';
        if (isText) {
          activeObject.exitEditing();
        }

        var height = activeObject.height;
        var object = __WEBPACK_IMPORTED_MODULE_8_fabric__["fabric"].util.object.clone(this.fabricCanvas.getActiveObject());

        // init cloned IText: initBehavior required to initialize events
        // https://github.com/fabricjs/fabric.js/issues/2154
        if (object.initBehavior) {
          object.initBehavior();
        }

        var originalTop = object.top;

        if (isText) {
          object.top = originalTop + height + 5;
          object.left = object.left;
        } else {
          object.top = originalTop + 10;
          object.left = object.left + 10;
        }

        this.fabricCanvas.add(object);

        if (isText && this.intersectsWithAnyObject(object, activeObject)) {
          //try putting the text above.
          object.top = originalTop - height - 5;
        }

        this.fabricCanvas.setActiveObject(object);
      } else {
        var text = 'new text';
        var textConstructor = {
          type: 'IText'
        };

        var fontFamily = 'Arial';
        if (this.canvasState.fonts && this.canvasState.fonts[0]) {
          fontFamily = this.canvasState.fonts[0];
        }

        var fill = "rgb(237,28,36)";
        if (this.canvasState.colors && this.canvasState.colors[0]) {
          fill = this.canvasState.colors;
        }

        var styleTemplate = {
          hasRotatingPoint: false,
          fontSize: 12 * RATIO,
          fontFamily: fontFamily,
          fill: fill
        };

        var styles = {};
        for (var i = 0; i < text.length + 1; i++) {
          styles["" + i] = JSON.parse(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(styleTemplate));
        }

        //not sure why, but "styles" is actually a one element array
        textConstructor.styles = [];
        textConstructor.styles.push(styles);
        textConstructor.fontSize = styleTemplate.fontSize;
        textConstructor.fontFamily = styleTemplate.fontFamily;
        textConstructor.fill = styleTemplate.fill;
        var textObj = new __WEBPACK_IMPORTED_MODULE_8_fabric__["fabric"].IText(text, textConstructor);

        var textPos = Object(__WEBPACK_IMPORTED_MODULE_14__lib_centerRectWithinBounds__["a" /* default */])({ width: textObj.width, height: textObj.height }, { width: this.fabricCanvas.getWidth(), height: this.fabricCanvas.getHeight() });

        textObj.left = textPos.left;
        textObj.top = textPos.top;

        this.fabricCanvas.add(textObj);
      }

      this.fabricCanvas.renderAll();
      this.undoStack.push();
    },
    fontSize: function fontSize(value) {
      this.updateStyles({ fontSize: value * RATIO });
    },
    fontName: function fontName(value) {
      this.updateStyles({ fontFamily: value });
    },
    color: function color(value) {
      this.updateStyles({ fill: value });
    },
    onTextMode: function onTextMode() {
      this.textMode = true;
      this.refreshCursors();
      if (this.currentObject && this.currentObject.type === 'IText') {
        this.currentObject.enterEditing();
      }
    },
    onMoveMode: function onMoveMode() {
      this.textMode = false;
      this.refreshCursors();
      if (this.currentObject && this.currentObject.type === 'IText') {
        this.currentObject.exitEditing();
        this.fabricCanvas.setActiveObject(this.currentObject);
      }
    },
    setOriginX: function setOriginX(newValue) {
      var obj = this.currentObject;
      // Ignore operation on non-texts
      if (!obj || obj.type !== 'IText') return;
      // No change needed, avoid extra work. This will frequently happen because
      // of the 2-way binding in the toolbar control
      if (obj.originX === newValue) return;
      // Set the origin. This shifts the object, adjust the "left" by
      // the amount of the shift so the position stays the same.
      var x = obj.aCoords.bl.x;
      obj.originX = newValue;
      obj.textAlign = newValue;
      obj.setCoords();
      var newX = obj.aCoords.bl.x;
      obj.left = obj.left + x - newX;
      obj.setCoords();
      this.updateCanvasState();
      this.fabricCanvas.renderAll();
      this.save();
    },
    setPosition: function setPosition(_ref2) {
      var x = _ref2.x,
          y = _ref2.y;

      var obj = this.currentObject;
      obj.top = y;
      obj.left = x;
      obj.setCoords();
      this.updateCanvasState();
      this.fabricCanvas.renderAll();
      this.save();
    },
    makePlaceholder: function makePlaceholder() {
      this.updateCustomProperties(function (obj) {
        return obj.isPlaceholder = !obj.isPlaceholder;
      }, 'image');
      this.fabricCanvas.trigger('object:modified', { target: this.fabricCanvas.getActiveObject() });
      this.commitModification();
    },
    setVariable: function setVariable(value) {
      this.updateCustomProperties(function (obj) {
        return obj.variable = value;
      });
    },
    setAllowMultiline: function setAllowMultiline(value) {
      this.updateCustomProperties(function (obj) {
        obj.allowMultiline = value;
      }, 'IText');
    },
    setTextTransform: function setTextTransform(value) {
      this.updateCustomProperties(function (obj) {
        obj.textTransform = value;
      }, 'IText');
    },
    setFieldLock: function setFieldLock(value) {
      this.updateCustomProperties(function (brandly, obj) {
        brandly.fieldLocked = value;
        obj.editable = !value;
      }, 'IText');
    },
    setFieldDeletable: function setFieldDeletable(value) {
      this.updateCustomProperties(function (brandly, obj) {
        brandly.fieldDeletable = value;
      });
    },
    setBlockVerticalAlign: function setBlockVerticalAlign(value) {
      var block = this.canvasState.blocks[this.canvasState.blockId];
      if (!block || typeof block == 'string') {
        //temp TODO remove
        this.canvasState.blocks[this.canvasState.blockId] = block = {};
      }
      block.verticalAlign = value;
      this.commitModification();
    },
    nextObject: function nextObject() {
      this.selectPrevOrNextField(1);
    },
    prevObject: function prevObject() {
      this.selectPrevOrNextField(-1);
    },
    setSuperscript: function setSuperscript() {
      if (this.currentObject && this.currentObject.type == 'IText') {
        var _currentObject = this.currentObject,
            selectionStart = _currentObject.selectionStart,
            selectionEnd = _currentObject.selectionEnd;

        if (selectionStart != null && selectionEnd != null) {
          this.currentObject.setSuperscript(selectionStart, selectionEnd);
          this.fabricCanvas.renderAll();
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.saveNow();
  },

  methods: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_19_vuex__["b" /* mapActions */])(['setThumbnail', 'updateCanvasLayer', 'updatePage']), {
    loadPage: function loadPage() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var objects, _scaler$canvasSize, _scaler$canvasSize2, width, height, _scaler$canvasSize3, _scaler$canvasSize4, trimBoxWidth, trimBoxHeight, _scaler$trimSize, _scaler$trimSize2, isLandscape, MAX_TRIMBOX_WIDTH, MAX_TRIMBOX_HEIGHT;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('loadPage');
                _this.calculateFontsAndColors();
                objects = _this.page.textLayer.layerInfo;

                _this.scaler = new __WEBPACK_IMPORTED_MODULE_9__lib_Scaler__["a" /* default */](RATIO, RATIO);
                _this.fabricCanvas = new __WEBPACK_IMPORTED_MODULE_8_fabric__["fabric"].Canvas(_this.$refs.canvasEl, {
                  renderOnAddRemove: false,
                  backgroundColor: null,
                  enableRetinaScaling: true,
                  objectCaching: false,
                  imageSmoothingEnabled: false
                });
                console.log("mediaBox:", _this.page.mediaBox);
                _scaler$canvasSize = _this.scaler.canvasSize(_this.page.mediaBox), _scaler$canvasSize2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_scaler$canvasSize, 2), width = _scaler$canvasSize2[0], height = _scaler$canvasSize2[1];
                _scaler$canvasSize3 = _this.scaler.canvasSize(_this.page.trimBox), _scaler$canvasSize4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_scaler$canvasSize3, 2), trimBoxWidth = _scaler$canvasSize4[0], trimBoxHeight = _scaler$canvasSize4[1];


                // Business cards are 3.5" by 2" (or 2" by 3.5"). If the file's trimbox is greater than this,
                // then it was set up without a proper cropbox, and we assume there should be one here. Note that
                // numbers are calculated based on the size of the canvas, which is at 200% (eg, 3.5" * 72ppi * 2 = 504px).
                _scaler$trimSize = _this.scaler.trimSize(_this.page.trimBox);
                _scaler$trimSize2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_scaler$trimSize, 2);
                _this.trimHorizontalMargins = _scaler$trimSize2[0];
                _this.trimVerticalMargins = _scaler$trimSize2[1];
                isLandscape = trimBoxWidth > trimBoxHeight;
                MAX_TRIMBOX_WIDTH = 72 * (isLandscape ? 3.5 : 2.0) * 2;
                MAX_TRIMBOX_HEIGHT = 72 * (isLandscape ? 2.0 : 3.5) * 2;


                if (trimBoxWidth > MAX_TRIMBOX_WIDTH + 1) {
                  //plus 1 to account for any rounding errors
                  _this.trimHorizontalMargins = (width - MAX_TRIMBOX_WIDTH) / 2;
                }
                if (trimBoxHeight > MAX_TRIMBOX_HEIGHT + 1) {
                  //plus 1 to account for any rounding errors
                  _this.trimVerticalMargins = (height - MAX_TRIMBOX_HEIGHT) / 2;
                }

                _this.fabricCanvas.setWidth(width);
                _this.fabricCanvas.setHeight(height);

                // RCB: removed await Promise.all() here because loading order seems dependent on loadScaledObjects happening first
                // potentially bring it back if this slows things down too much.
                _context.next = 21;
                return _this.scaler.loadScaledObjects(_this.fabricCanvas, objects);

              case 21:
                if (objects.meta && objects.meta.dismissedBleedWarning) {
                  _this.canvasState.dismissedBleedWarning = true;
                }
                _context.next = 24;
                return _this.loadBackgroundImage();

              case 24:
                _this.loadMeta();
                _this.setBorders();
                _this.undoStack = new __WEBPACK_IMPORTED_MODULE_11__lib_UndoStack__["a" /* default */](_this.fabricCanvas, 50, _this.canvasState);
                _this.undoStack.push();

                _this.templateVars = new __WEBPACK_IMPORTED_MODULE_10__lib_TemplateVars__["a" /* default */](_this.fabricCanvas, _this.$store);
                if (!_this.design.isTemplate && !_this.nofill) {
                  _this.templateVars.replaceAll();
                  _this.deleteEmptyFields();
                }

                _this.fabricCanvas.renderAll();

                _this.assignBleedPoints();

                _this.checkForText();

                _this.refreshCursors();
                _this.lockObjects();
                _this.updateThumbnail();
                _this.bindCanvasEvents();

                Object(__WEBPACK_IMPORTED_MODULE_12__lib_initAligningGuidelines__["a" /* default */])(_this.fabricCanvas);
                Object(__WEBPACK_IMPORTED_MODULE_15__lib_selectTopLeftObject__["a" /* default */])(_this.fabricCanvas);

              case 39:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    placeholderImageDataUploaded: function placeholderImageDataUploaded(data) {
      this.imageDataUploaded(data, true);
    },
    refreshCursors: function refreshCursors() {
      var _this2 = this;

      this.fabricCanvas.forEachObject(function (obj) {
        if (_this2.designLocked) {
          obj.hoverCursor = 'default';
        } else if (obj.type === 'IText') {
          obj.hoverCursor = _this2.textMode ? 'text' : 'move';
        }
      });
    },
    lockObjects: function lockObjects() {
      if (this.designLocked) {
        console.log('locking!');
        this.fabricCanvas.forEachObject(function (obj) {
          obj.lockMovementX = true;
          obj.lockMovementY = true;
          obj.lockScalingX = true;
          obj.lockScalingY = true;
          obj.lockUniScaling = true;
          obj.hasControls = false;
        });
      }
    },


    // call this after an operation has completed.
    // adds a save
    commitModification: function commitModification(saveNow) {
      if (saveNow) {
        //saveNow if this was result of checkout being clicked.
        this.saveNow();
      } else {
        //normal case, debounce the save
        this.save();
      }
      this.undoStack.push();
      this.assignBleedPoints(); //getBleedPoints(this.fabricCanvas, this.$refs.canvasEl.getContext('2d'), this.trimHorizontalMargins, this.trimVerticalMargins);
    },
    assignBleedPoints: function assignBleedPoints() {
      this.bleedPoints = Object(__WEBPACK_IMPORTED_MODULE_17__lib_getBleedPoints__["a" /* default */])(this.fabricCanvas, this.$refs.canvasEl.getContext('2d'), this.trimHorizontalMargins, this.trimVerticalMargins, BLEED_POINT_THRESHOLD);
      this.canvasState.hasBadBleed = Object(__WEBPACK_IMPORTED_MODULE_18__lib_anyBadBleed__["a" /* default */])(this.bleedPoints);
    },
    checkForText: function checkForText() {
      var hasText = false;
      this.fabricCanvas.forEachObject(function (obj) {
        if (obj.type === 'IText') {
          hasText = true;
          console.log('found text');
        }
      });
      this.canvasState.hasTextAtStartup = hasText;
    },
    imageDataUploaded: function imageDataUploaded(data, replacePlaceholder) {
      var _this3 = this;

      var activeObject = this.fabricCanvas.getActiveObject();

      var bounds = void 0,
          maxSize = void 0,
          toRemove = void 0;

      bounds = { left: 0, top: 0, width: this.fabricCanvas.getWidth(), height: this.fabricCanvas.getHeight() };
      maxSize = { width: 250, height: 250 };

      if (activeObject) {
        if (activeObject.type === 'IText') {
          activeObject.exitEditing();
        }
        // Handle case where we click the upload while placeholder is selected
        // TODO remove replacePlaceholder? why added?
        if (replacePlaceholder) {
          // Upload into this spot
          var top = activeObject.top,
              left = activeObject.left;
          var width = activeObject.getScaledWidth(),
              height = activeObject.getScaledHeight();
          bounds = { top: top, left: left, width: width, height: height };
          maxSize = { width: width, height: height };
          toRemove = activeObject;
        }
      }

      // Create new image
      __WEBPACK_IMPORTED_MODULE_8_fabric__["fabric"].Image.fromURL(data, function (img) {
        var newDim = { width: img.width, height: img.height };

        if (newDim.width > maxSize.width || newDim.height > maxSize.height) {
          newDim = Object(__WEBPACK_IMPORTED_MODULE_13__lib_fitRectIntoBounds__["a" /* default */])(newDim, maxSize);
        }

        var newPos = Object(__WEBPACK_IMPORTED_MODULE_14__lib_centerRectWithinBounds__["a" /* default */])(newDim, bounds);

        img.scaleToWidth(newDim.width);
        img.set({ left: newPos.left, top: newPos.top, angle: 0 });

        _this3.fabricCanvas.add(img).setActiveObject(img);

        if (toRemove) {
          // this code would replace a placeholder with a new placeholder.
          // sounds like that's not exactly what we want.
          // this.updateCustomProperties(obj => obj.isPlaceholder = true, 'image', true);

          _this3.fabricCanvas.remove(toRemove);
        }
        _this3.fabricCanvas.renderAll();

        //this "reminds" the placeholder icon to turn on
        _this3.fabricCanvas.trigger('object:modified', { target: _this3.fabricCanvas.getActiveObject() });

        _this3.commitModification();
      });
    },
    calculateFontsAndColors: function calculateFontsAndColors() {
      // Update state with fonts and colors from design
      this.canvasState.fonts = __WEBPACK_IMPORTED_MODULE_23_lodash_uniq___default()(__WEBPACK_IMPORTED_MODULE_21_flatten___default()(this.design.fonts));
      this.canvasState.colors = this.design.colors.map(function (x) {
        return "rgb(" + x.rgb + ")";
      });
    },
    loadBackgroundImage: function loadBackgroundImage() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
                  __WEBPACK_IMPORTED_MODULE_8_fabric__["fabric"].Image.fromURL(_this4.backgroundSvgDataUrl, function (img) {
                    img.set({ width: _this4.fabricCanvas.width, height: _this4.fabricCanvas.height });
                    _this4.fabricCanvas.setBackgroundImage(img, function () {
                      resolve();
                    });
                  });
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    loadMeta: function loadMeta() {
      var _ref3 = this.page.textLayer.layerInfo.meta || {},
          blocks = _ref3.blocks;

      this.canvasState.blocks = blocks || {};
    },


    // adds the custom properties on the active object
    updateCustomProperties: function updateCustomProperties(updateFunc, validObjectType, skipCommitAndRender) {
      if (this.currentObject && (!validObjectType || this.currentObject.type === validObjectType)) {
        this.currentObject.brandly = this.currentObject.brandly || {};
        updateFunc(this.currentObject.brandly, this.currentObject);
        this.setBorder(this.currentObject);
        this.updateCanvasState();

        if (!skipCommitAndRender) {
          this.commitModification();
          this.fabricCanvas.renderAll();
        }
      }
    },


    // adds the custom properties on an array of objects
    updateCustomPropertiesOnMultipleObjects: function updateCustomPropertiesOnMultipleObjects(objArray, updateFunc, validObjectType) {
      var _this5 = this;

      objArray.forEach(function (obj) {
        if (obj && (!validObjectType || obj.type === validObjectType)) {

          // console.log('adding block thingy')
          obj.brandly = obj.brandly || {};
          updateFunc(obj.brandly);
          _this5.setBorder(obj);
        }
      });
      this.updateCanvasState();
      this.commitModification();
      this.fabricCanvas.renderAll();
    },
    setBorders: function setBorders() {
      var _this6 = this;

      // Ensure all placeholder objects have their borders set
      this.fabricCanvas.getObjects().map(function (obj) {
        return _this6.setBorder(obj);
      });
      this.fabricCanvas.renderAll();
    },
    setBorder: function setBorder(object) {
      // Set the color/controls for an image based on whether its a placeholder or in a group
      // Caller should renderAll()
      var STANDARD_BORDER_COLORS = ['rgba(102,153,255,0.75)', 'rgba(102,255,153,0.75)', 'rgba(153,102,255,0.75)'];
      var PLACEHOLDER_BORDER_COLORS = ['rgba(0,255,0, 0.75)', 'rgba(255,0,0, 0.75)', 'rgba(0,0,255, 0.75)'];

      var _ref4 = object.brandly || {},
          isPlaceholder = _ref4.isPlaceholder,
          blockId = _ref4.blockId;

      var colorIx = (blockId || 0) % STANDARD_BORDER_COLORS.length;
      object.borderColor = isPlaceholder ? PLACEHOLDER_BORDER_COLORS[colorIx] : STANDARD_BORDER_COLORS[colorIx];
      console.log('setBorder', object.borderColor, colorIx);
      if (object.type !== 'image') return;
      ['tl', 'ml', 'bl', 'mb', 'br', 'mr', 'tr', 'mt', 'mtr'].forEach(function (control) {
        object.setControlVisible(control, !isPlaceholder);
      });
    },
    intersectsWithAnyObject: function intersectsWithAnyObject(obj, except) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.fabricCanvas.getObjects()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var canvasObject = _step.value;

          if (canvasObject.type === 'IText' && obj !== canvasObject && canvasObject !== except) {
            if (obj.intersectsWithObject(canvasObject)) {
              console.log('intersects with', canvasObject);
              return true;
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    },
    onDeselected: function onDeselected(event) {
      // When leaving a field that is blank, delete it
      if (event.deselected && event.deselected.length === 1) {
        this.deleteIfEmpty(event.deselected);
      }
    },
    deleteIfEmpty: function deleteIfEmpty(field) {
      if (field.type === 'IText' && field.text === '') {
        this.adjustObjectsAfterDeletion(field);
        this.fabricCanvas.remove(field);
      }
    },
    deleteEmptyFields: function deleteEmptyFields() {
      var _this7 = this;

      this.fabricCanvas.getObjects().map(function (field) {
        return _this7.deleteIfEmpty(field);
      });
      this.fabricCanvas.renderAll();
    },
    onEditingEntered: function onEditingEntered(event) {
      var object = event.target;
      console.log('onEditingEntered', object);
      if (object.type === 'IText') {
        var _ref5 = object.brandly || {},
            fieldLocked = _ref5.fieldLocked;

        if (fieldLocked) object.exitEditing();
      }
    },
    onSelectionChanged: function onSelectionChanged(event) {
      var _this8 = this;

      var object = event.target;

      if (object.type === 'IText') {
        var _ref6 = object.brandly || {},
            fieldLocked = _ref6.fieldLocked;

        object.hasControls = false;

        // if(object.brandly && object.brandly.blockId){
        //   const textObjectsInBlock = this.fabricCanvas.getObjects().filter(filterObj => {
        //     return filterObj.brandly && filterObj.brandly.blockId === object.brandly.blockId;
        //   });
        // }

        if (!fieldLocked && (this.textMode || this.designLocked)) {

          // As soon as the object is selected, enter editing mode. This prevents movement, and is
          // an easier way to get into the editing mode.
          var _object = event.target;
          _object.enterEditing();

          var mouseEvent = event ? event.e : null;

          // if not a mouse event means that this likely came from "selectTopLeftObject" or something else that
          // doesn't know where to set the cursor based on the pointer.
          if (!!mouseEvent) {
            var selectionIdx = _object.getSelectionStartFromPointer(event);

            //this is wierd, I couldn't get the cursor to start w/ object.startCursorAnimation,
            //but after trying a bunch of things, this seems to work :-/
            _object.setSelectionStart(selectionIdx);
            this.$nextTick(function () {
              _object.setSelectionEnd(selectionIdx);
              _this8.updateCanvasState();
            });
          }

          this.currentObject = _object;
        }
      }

      this.currentObject = object;
      this.updateCanvasState();
    },
    bindCanvasEvents: function bindCanvasEvents() {
      var _this9 = this;

      this.fabricCanvas.on({
        'object:modified': function objectModified(event) {
          var saveNow = false;
          // if current object is decorated w/ saveNow, force save immediately.
          // used if checkout button is clicked while editing text.
          if (event.target && event.target.saveNow) {
            delete event.target.saveNow;
            saveNow = true;
          }
          _this9.commitModification(saveNow);
        },
        'selection:updated': function selectionUpdated(event) {
          _this9.onDeselected(event);
          _this9.onSelectionChanged(event);
        },
        'selection:created': function selectionCreated(event) {
          _this9.onSelectionChanged(event);
        },
        'selection:cleared': function selectionCleared(event) {
          _this9.onDeselected(event);
          if (_this9.currentObject) {
            _this9.currentObject = null;
          }
        },
        'mouse:over': function mouseOver(event) {
          if (!_this9.fabricCanvas.getActiveObject() && event.target) {
            var object = event.target;
            object.set('active', true);
            if (object.type === 'IText') {
              object.hasControls = false;
            }
            _this9.fabricCanvas.renderAll();
          }
        },
        'mouse:out': function mouseOut(event) {
          if (!_this9.fabricCanvas.getActiveObject() && event.target) {
            event.target.set('active', false);
            _this9.fabricCanvas.renderAll();
          }
        },
        'text:changed': function textChanged(event) {
          var object = _this9.fabricCanvas.getActiveObject();
          if (!object || object.type !== 'IText') return;

          var _ref7 = object.brandly || {},
              allowMultiline = _ref7.allowMultiline,
              textTransform = _ref7.textTransform;

          var text = object.text,
              newText = text;
          if (!allowMultiline) {
            newText = text.replace(/\n/gm, ""); //Remove line breaks
            newText = newText.replace('\t', ' '); // Replace tabs with spaces
          }
          if (textTransform) {
            // Errors if textTransform not found
            var func = {
              uppercase: function uppercase(text) {
                // return text.toUpperCase();
                // Fancy uppercasing that allows McDONALD, van ROSSUM, van der BEEK
                return text.replace(/M(a?c)|( va?n?)|( de?r?)|./g, function (m, ac, van, der) {
                  return ac || van || der ? m : m.toUpperCase();
                });
              }
            }[textTransform] || function (text) {
              return text;
            };
            newText = func(newText);
          }

          if (text !== newText) {
            object.set({ text: newText });
            object.moveCursorWithoutShift(newText.length - text.length); // Compensate for number of characters removed
            _this9.fabricCanvas.renderAll();
          }
        },
        'text:selection:changed': function textSelectionChanged(event) {
          if (_this9.currentObject) {
            _this9.updateCanvasState();
          }
        },
        'text:editing:entered': function textEditingEntered(event) {
          _this9.onEditingEntered(event);
        }

        //TODO -- this was implemented in `spa` (canvas.service.ts). Figure out need and incorporate
        // 'text:selection:changed': debounce((event) => {
        //       let target = event.target;
        //       this.currentObject = target;

        //       if (target.selectionEnd === target.selectionStart) {
        //           let textBeforeEdit = target._textBeforeEdit;

        //           // User about to enter text (make sure we have the right style)
        //           if (target.text == target._textBeforeEdit) {
        //               let previousChar = target.text[target.selectionStart-1];
        //               let nextChar = target.text[target.selectionStart];

        //               // Fabric for some reason defaults to previousChar style by default (we need to override)
        //               if (previousChar === " " && nextChar !== " ") {
        //                   let style = target.styles[0][target.selectionStart];
        //                   target.styles[0][target.selectionStart-1] = style;
        //                   this.persistChange();
        //               }

        //           }
        //       }
        //   }, 300),
      });
    },
    hideBorders: function hideBorders(block) {
      // Ensure we hide any current text editing controls
      var object = this.fabricCanvas.getActiveObject();
      if (!object || object.type !== 'IText' && object.type !== 'image' || !object.hasBorders) {
        // No need to hide borders
        block();
        return;
      }
      object.hasBorders = false;
      var orig = object.cornerSize;
      object.cornerSize = 0;
      this.fabricCanvas.renderAll();

      block();

      object.hasBorders = true;
      object.cornerSize = orig;
      this.fabricCanvas.renderAll();
    },
    updateThumbnail: function updateThumbnail() {
      var _this10 = this;

      this.hideBorders(function () {
        var dataUrl = Object(__WEBPACK_IMPORTED_MODULE_16__lib_cropCanvas__["a" /* default */])(_this10.$refs.canvasEl, _this10.trimHorizontalMargins, _this10.trimVerticalMargins).toDataURL();
        _this10.setThumbnail({ pageNum: _this10.pageNum, dataUrl: dataUrl });
        _this10.saveCanvasSvg(dataUrl);
      });
    },
    saveNow: function saveNow() {
      if (!this.fabricCanvas) {
        console.error("saveNow: page hasn't loaded");
        return;
      }
      this.saveLayerObjects();
      this.updateThumbnail();
    },

    save: __WEBPACK_IMPORTED_MODULE_22_lodash_debounce___default()(function () {
      this.saveNow();
    }, 300),
    updateStyles: function updateStyles(styles) {
      if (this.currentObject.type === 'IText') {
        this.currentObject.setSelectionStyles(styles);
      }
      this.fabricCanvas.renderAll();
      this.updateCanvasState();

      this.commitModification();
    },
    getTextStyleFromSelection: function getTextStyleFromSelection(textObject) {
      var styleStart = textObject.selectionStart;
      var styleEnd = textObject.selectionEnd;

      if (styleStart === styleEnd && textObject.text.length > 0) {
        //if we're at the beginning, get the style of the first char in string
        if (styleStart === 0) {
          styleEnd = 1;
        }
        //else get the style of the previous char
        else {
            styleStart -= 1;
          }
      }
      var styles = textObject.getSelectionStyles(styleStart, styleEnd, true);
      return styles[0] || null;
    },
    updateCanvasState: function updateCanvasState() {
      var canvasState = this.canvasState,
          object = this.currentObject;
      canvasState.displayBleed = this.displayBleed;
      if (!object) {
        canvasState.fontName = undefined;
        canvasState.fontSize = undefined;
        canvasState.color = undefined;
        canvasState.originX = undefined;
        canvasState.variable = undefined;
        canvasState.isPlaceholder = undefined;
        canvasState.allowMultiline = undefined;
        canvasState.textTransform = undefined;
        canvasState.textSelected = false;
        canvasState.fieldLocked = undefined;
        canvasState.fieldDeletable = undefined;
        canvasState.blockId = undefined;
        canvasState.position = { x: null, y: null };
        return;
      }
      if (object.type === 'IText') {
        var style = this.getTextStyleFromSelection(object);

        if (style) {
          canvasState.fontName = style.fontFamily;
          var fontSize = (style.fontSize || 12) / RATIO; // TODO port magic ratio crap
          if (Math.round(fontSize) !== fontSize) {
            fontSize = fontSize.toFixed(2);
          }
          canvasState.fontSize = fontSize;
          canvasState.color = style.fill;
        }
        canvasState.originX = object.originX;
      } else {
        canvasState.originX = undefined;
      }
      canvasState.position = { x: object.left, y: object.top };
      var brandly = object.brandly || {};
      canvasState.variable = brandly.variable || '';
      canvasState.isPlaceholder = brandly.isPlaceholder;
      canvasState.allowMultiline = brandly.allowMultiline;
      canvasState.textTransform = brandly.textTransform;
      canvasState.fieldLocked = brandly.fieldLocked;
      canvasState.fieldDeletable = brandly.fieldDeletable;
      canvasState.blockId = brandly.blockId;
      canvasState.textSelected = object.type === 'IText';
    },
    saveLayerObjects: function saveLayerObjects() {
      var pageNum = this.pageNum;

      var bg = this.fabricCanvas.backgroundImage;
      this.fabricCanvas.setBackgroundImage(null);
      var objects = this.scaler.unscaledObjects(this.fabricCanvas);
      this.fabricCanvas.setBackgroundImage(bg);

      var meta = {
        dismissedBleedWarning: this.canvasState.dismissedBleedWarning
      };
      meta.blocks = this.canvasState.blocks;

      this.updateCanvasLayer({ pageNum: pageNum, objects: objects, meta: meta });
    },
    saveCanvasSvg: function saveCanvasSvg(previewDataUrl) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var pageNum, el, canvas, objects, _page$mediaBox, x, y, width, height, svg, notPlaceholders;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                notPlaceholders = function notPlaceholders(_ref8) {
                  var brandly = _ref8.brandly;

                  if (brandly && brandly.isPlaceholder) {
                    console.log('saveCanvasSvg: isPlaceholder!');
                  }
                  return !(brandly && brandly.isPlaceholder);
                };

                pageNum = _this11.pageNum;

                // Create new canvas, and load with unscaled objects

                el = document.createElement('canvas');
                canvas = new __WEBPACK_IMPORTED_MODULE_8_fabric__["fabric"].Canvas(el);
                objects = _this11.scaler.unscaledObjects(_this11.fabricCanvas).filter(notPlaceholders);

                console.log(objects);
                canvas.loadFromJSON(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()({ objects: objects }));
                canvas.renderAll();
                _page$mediaBox = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_this11.page.mediaBox, 4), x = _page$mediaBox[0], y = _page$mediaBox[1], width = _page$mediaBox[2], height = _page$mediaBox[3];

                // Without this, images won't appear in output
                // TODO remove timeouts / understand why needed

                _context3.next = 11;
                return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (r) {
                  return setTimeout(r, 1);
                });

              case 11:
                svg = canvas.toSVG({
                  width: width, height: height, viewBox: { x: x, y: y, width: width, height: height }
                });


                _this11.updatePage({ pageNum: pageNum, svg: svg, previewDataUrl: previewDataUrl });

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this11);
      }))();
    },
    selectPrevOrNextField: function selectPrevOrNextField(offset) {
      var cur = this.currentObject;
      var objects = this.fabricCanvas.getObjects();
      if (objects.length === 0) return;
      var obj = void 0;
      if (!cur) {
        obj = objects[0];
      } else {
        var index = objects.indexOf(cur);
        console.log('cur index', index);
        index = (index + objects.length + offset) % objects.length;
        console.log('new index', index);
        obj = objects[index];
      }
      console.log('new object', obj);
      this.fabricCanvas.setActiveObject(obj);
    },
    adjustObjectsAfterDeletion: function adjustObjectsAfterDeletion(deletedObject) {
      // Adjust other objects in the same block based on vertical aligment.
      // Caller should renderAll.
      var _ref9 = deletedObject.brandly || {},
          blockId = _ref9.blockId;

      if (!blockId) return; // Most objects won't have a block

      var _ref10 = this.canvasState.blocks[blockId] || {},
          verticalAlign = _ref10.verticalAlign;

      if (!verticalAlign) {
        // If an object has a block it should have a vertical alignment
        console.error('Block missing vertical align', blockId);
        return;
      }

      // Find the other objects, in two lists (above, and below)
      // Keep the closest object at front of list
      var r = deletedObject.getBoundingRect();
      var above = [],
          below = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.fabricCanvas.getObjects()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var obj = _step2.value;

          if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_is___default()(obj, deletedObject) && obj.brandly && obj.brandly.blockId == blockId) {
            var r2 = obj.getBoundingRect();
            if (overlapsX(r, r2)) {
              var list = r.top > r2.top ? above : below;
              var gapIsSmaller = list.length && gap(r, r2) < gap(r, list[0]);
              list[gapIsSmaller ? 'unshift' : 'push'](obj);
            }
          }
        }

        // Calculate how much to move objects above and below, respectively
        // We move objects up or down so that the object above or below
        // would be in the same position after the move. If its centered,
        // then moving half works fine.
        // This is fine when all objects have a consistent gap, but when
        // line might have larger gaps we might need to tweak this.
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var moveDown = 0,
          moveUp = 0;
      if (verticalAlign === 'top') {
        moveUp = below.length && below[0].top - r.top;
      } else if (verticalAlign === 'bottom') {
        moveDown = above.length && r.top + r.height - (above[0].top + above[0].height);
      } else if (verticalAlign === 'middle') {
        moveUp = below.length && (below[0].top - r.top) / 2;
        moveDown = above.length && (r.top + r.height - (above[0].top + above[0].height)) / 2;
      }

      // Move
      above.forEach(function (obj) {
        obj.top += moveDown;obj.setCoords();
      });
      below.forEach(function (obj) {
        obj.top -= moveUp;obj.setCoords();
      });

      function gap(r1, r2) {
        // Gap between objects, vertically
        return r1.top < r2.top ? r2.top - r1.top + r1.height : r1.top - r2.top + r2.height;
      }
      function overlapsX(r1, r2) {
        return r2.left <= r1.left + r1.width && r2.left + r2.width >= r1.left;
      }
    }
  })
});

/***/ }),

/***/ "USD4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['flag', 'state'],
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['updateFlags', 'resetFlags', 'saveTeamFlags']), {
    toggle: function toggle(key) {
      this.updateFlags(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, !this.flags[key]));
    },
    reload: function reload() {
      window.location.reload();
    },
    setVoucher: function setVoucher(event) {
      this.updateFlags({ voucher: event.target.value });
    }
  }),
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['flags', 'needsReload', 'isStaff']),
  mounted: function mounted() {
    if (this.flag && this.state) {
      this.updateFlags(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.flag, this.state === 'on'));
      // Reload the homepage, with a full reload, just in case flags
      // affect routes or other Vue initialization logic.
      window.location = '/';
    }
  }
});

/***/ }),

/***/ "UmAZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['flags']), {
    warning: function warning() {
      // Return the type of warning. Not currently used,
      // but this could be used for outage alerts etc.
      return this.flags.legacy ? 'legacy' : null;
    }
  })
});

/***/ }),

/***/ "UnTq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-orders"},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UpSE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomepageLandingLayout',{attrs:{"keywords":_vm.keywords,"description":_vm.description}},[_c('LandingPageHero',{attrs:{"headline":_vm.headline,"subtitle":_vm.subtitle}}),_vm._v(" "),_c('LandingPageSaveTime'),_vm._v(" "),_c('LandingPagePortal'),_vm._v(" "),_c('Testimonial'),_vm._v(" "),_c('Demo')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Uulp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-card"},[_c('h2',[_c('i',{staticClass:"fa fa-exclamation-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.title))]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Uvhn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V1/i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['portalId', 'formId'],
  mounted: function mounted() {
    var _this = this;

    var node = document.createElement('script');
    node.setAttribute('src', '//js.hsforms.net/forms/shell.js');
    node.onload = function () {
      window.hbspt.forms.create({
        portalId: _this.portalId,
        formId: _this.formId,
        target: "#hsformdiv"
      });
    };
    document.body.appendChild(node);
  }
});

/***/ }),

/***/ "V2iM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewBilling_vue__ = __webpack_require__("ByP9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_357a30cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewBilling_vue__ = __webpack_require__("ouxW");
function injectStyle (ssrContext) {
  __webpack_require__("aOJY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-357a30cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewBilling_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_357a30cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewBilling_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V3Wu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VCwS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layer",attrs:{"id":"secondary-header"}},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"header-parent",attrs:{"id":"text-wrapper"}},[_c('div',{staticClass:"copy-container"},[_c('div',{staticClass:"copy-header"},[_vm._t("default")],2)])])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"header-parent",attrs:{"id":"button-wrapper"}},[_c('div',{staticClass:"copy-container",attrs:{"id":"portal-button"}},[_c('div',{staticClass:"copy-header"},[_c('GetPortalButton')],1)])])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VFA2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deletePage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return upload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return load; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFonts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return updatePage; });
/* harmony export (immutable) */ __webpack_exports__["h"] = updateLayerObjects;
/* harmony export (immutable) */ __webpack_exports__["i"] = updateLayerSvg;
/* harmony export (immutable) */ __webpack_exports__["e"] = productionFile;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateDesign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return updateDesignTemplate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defineService__ = __webpack_require__("tVbG");



var uploadNewDesign = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('post', 'spool/designs/', {
  suffixFunc: function suffixFunc(formData, flags) {
    if (formData.get('is_template')) return '-template';
    if (flags.oneSided) return '-onesided';
    return '';
  },

  alternatives: {
    oneSided: '-onesided'
  }
});
var getDesign = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('get', 'spool/designs/:id/', {
  suffixFunc: function suffixFunc(id) {
    return { 777: '-template', 778: '-onesided' }[id] || '';
  }
});
var getFontCss = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('post', 'fonts/get', {
  alternatives: {
    oneSided: '-onesided'
  }
});
var patchPage = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('patch', 'spool/pages/:id/');
var deletePage = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('delete', 'spool/pages/:id/');
var patchLayer = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('patch', 'spool/layers/:id/');
var postDesignClone = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('post', 'spool/designs/clone');
var uploadNewPage = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('put', 'spool/designs/:id/pages');
var patchDesign = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('patch', 'spool/designs/:id/');
var putDesignUpdate = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('put', 'spool/designs/:id/update');

/**
 * Uploads file to service, creating a design.
 * Extra keys can be passed, to make templates etc.
 * If designId is passed in extra, add a new page
 * to the design.
 *
 * @param {FileTarget} file
 * @returns {Design}
 */
var upload = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(file) {
    var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var method, designId, formData, key, response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            method = uploadNewDesign;

            if (extra.designId) {
              // post new page
              designId = extra.designId;

              delete extra.designId;
              method = function method(data) {
                return uploadNewPage(designId, data);
              };
            }
            formData = new FormData();

            formData.append("file", file);
            for (key in extra) {
              formData.append(key, '' + extra[key]);
            }
            _context.prev = 5;
            _context.next = 8;
            return method(formData);

          case 8:
            response = _context.sent;
            _context.next = 14;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context['catch'](5);
            throw _context.t0.response ? _context.t0.response.data.file : _context.t0;

          case 14:
            return _context.abrupt('return', response);

          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[5, 11]]);
  }));

  return function upload(_x) {
    return _ref.apply(this, arguments);
  };
}();

var load = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(id) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getDesign(id);

          case 2:
            response = _context2.sent;
            return _context2.abrupt('return', response);

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function load(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

var getFonts = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getFontCss({ design: id });

          case 2:
            response = _context3.sent;
            return _context3.abrupt('return', response);

          case 4:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function getFonts(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

var updatePage = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(pageId, svgMarkup, previewDataUrl) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', patchPage(pageId, { id: pageId, svgMarkup: svgMarkup, previewDataUrl: previewDataUrl }));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function updatePage(_x5, _x6, _x7) {
    return _ref4.apply(this, arguments);
  };
}();

function updateLayerObjects(layerId, objects, meta) {
  return patchLayer(layerId, { id: layerId, layerInfo: { objects: objects, meta: meta }, svgMarkup: null, type: 2 });
}

function updateLayerSvg(layerId, svgMarkup) {
  return patchLayer(layerId, { id: layerId, svgMarkup: svgMarkup });
}

function productionFile(designId) {
  return getDesign(designId, { production: 1 });
}

/**
 * Clones a template design, and returns the details of the new design.
 *
 * @param {id or url} source
 * @param {true or undefined} isTemplate
 */
var clone = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(source, isTemplate) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            console.log('cloning', source);
            return _context5.abrupt('return', postDesignClone({ source: source, isTemplate: isTemplate }));

          case 2:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function clone(_x8, _x9) {
    return _ref5.apply(this, arguments);
  };
}();

var updateDesign = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(id, updates) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', patchDesign(id, updates));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function updateDesign(_x10, _x11) {
    return _ref6.apply(this, arguments);
  };
}();

var updateDesignTemplate = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(id, updates) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt('return', putDesignUpdate(id, updates));

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function updateDesignTemplate(_x12, _x13) {
    return _ref7.apply(this, arguments);
  };
}();

/***/ }),

/***/ "VYx4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VaF6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["uid", "token"],
  data: function data() {
    return { password: "", password2: "" };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["loginBusy", "loginError"]),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["confirmReset"]), {
    submit: function submit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.confirmReset({
                  uid: _this.uid,
                  token: _this.token,
                  new_password1: _this.password,
                  new_password2: _this.confirm_password
                });

              case 2:
                if (!_this.loginError) _this.$router.push("/signin");

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  })
});

/***/ }),

/***/ "Vo6e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('address',{on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',[_vm._v(_vm._s(_vm.value.first_name)+" "+_vm._s(_vm.value.last_name))]),_vm._v(" "),(!_vm.isUSA && _vm.value.country_printable_name)?_c('span',[_vm._v("\n    "+_vm._s(_vm.value.country_printable_name)),_c('br')]):_vm._e(),_vm._v("\n  "+_vm._s(_vm.value.line1)),_c('br'),_vm._v(" "),(_vm.value.line2)?[_vm._v(_vm._s(_vm.value.line2)),_c('br')]:_vm._e(),_vm._v(" "),(_vm.value.line3)?[_vm._v(_vm._s(_vm.value.line3)),_c('br')]:_vm._e(),_vm._v("\n  "+_vm._s(_vm.value.city || _vm.value.line4)+", "+_vm._s(_vm.value.state)+" "+_vm._s(_vm.value.postcode)+"\n  "),_c('br')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VtcT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = libraries;
/* harmony export (immutable) */ __webpack_exports__["b"] = createLibrary;
/* harmony export (immutable) */ __webpack_exports__["e"] = removeLibrary;
/* harmony export (immutable) */ __webpack_exports__["d"] = library;
/* harmony export (immutable) */ __webpack_exports__["a"] = addTemplateToLibrary;
/* harmony export (immutable) */ __webpack_exports__["f"] = removeTemplateFromLibrary;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineService__ = __webpack_require__("tVbG");

var getLibraryList = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('get', 'spool/libraries/', { mainKey: 'results' });
var getLibrary = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('get', 'spool/libraries/:id/');
var postLibrary = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('post', 'spool/libraries/');
var deleteLibrary = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('delete', 'spool/libraries/:id/');
var postLibraryTemplate = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('post', 'spool/libraries/:id/templates/:template/');
var deleteLibraryTemplate = Object(__WEBPACK_IMPORTED_MODULE_0__defineService__["b" /* default */])('delete', 'spool/libraries/:id/templates/:template/');

function libraries() {
  return getLibraryList();
}

function createLibrary(_ref) {
  var name = _ref.name;

  // Return newly create library
  return postLibrary({ name: name });
}

function removeLibrary(id) {
  return deleteLibrary(id);
}

function library(library_id) {
  return getLibrary(library_id);
}

function addTemplateToLibrary(library_id, template_id) {
  return postLibraryTemplate(library_id, template_id, {});
}

function removeTemplateFromLibrary(library_id, template_id) {
  return deleteLibraryTemplate(library_id, template_id);
}

/***/ }),

/***/ "Vwpu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"sm":"12","lg":"7"}},[_c('div',{staticClass:"parent-2"},[_c('ul',{staticClass:"list-1"},[_c('li',{staticClass:"item-container-1"},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":"/static/images/homepage/quality.svg","alt":"icon"}})]),_vm._v(" "),_c('div',{staticClass:"list-copy-container-1"},[_c('p',{staticClass:"title"},[_vm._v("Fast and easy ordering")]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v("Say good-bye to long email threads and design software. Say hello to Brandly.")])])]),_vm._v(" "),_c('li',{staticClass:"item-container-1"},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":"/static/images/homepage/quality.svg","alt":"icon"}})]),_vm._v(" "),_c('div',{staticClass:"list-copy-container-1"},[_c('p',{staticClass:"title"},[_vm._v("Hassle-free roll-out")]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v("Whether your company has 50 or 5,000 employees, the roll-out takes minutes.")])])]),_vm._v(" "),_c('li',{staticClass:"item-container-1"},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":"/static/images/homepage/quality.svg","alt":"icon"}})]),_vm._v(" "),_c('div',{staticClass:"list-copy-container-1"},[_c('p',{staticClass:"title"},[_vm._v("Admin or Employee Self-serve")]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v("Order for your entire company or let employees self-order as needed.")])])]),_vm._v(" "),_c('li',{staticClass:"item-container-1"},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":"/static/images/homepage/quality.svg","alt":"icon"}})]),_vm._v(" "),_c('div',{staticClass:"list-copy-container-1"},[_c('p',{staticClass:"title"},[_vm._v("Free Shipping always")]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v("Get your orders delivered at zero cost anywhere in the United States.")])])])])])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"5"}},[_c('SummaryBlock',{staticStyle:{"height":"100%"}},[_c('p',{staticClass:"eyebrow"},[_vm._v("BUSINESS CARD PORTAL")]),_vm._v(" "),_c('h2',[_vm._v("All-in-one portal for your business card needs.")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("Streamline your company’s business card ordering process and stay in control of your brand identity with our free full featured online portal.")])])],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Vy8U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"welcome-section"}},[_c('h2',{attrs:{"id":"target"}},[_vm._v("Design")]),_vm._v(" "),_c('TemplateChooser',{attrs:{"no-edit":""}}),_vm._v(" "),_c('ProductTemplatePreview',{attrs:{"compact":"true"}}),_vm._v(" "),(_vm.productTemplateDesignId)?_c('div',{staticClass:"upload-cta-area"},[_c('StartOrderButton')],1):_c('div',{staticClass:"upload-cta-area"},[_c('b-button',{attrs:{"to":"/dashboard/design/new","variant":"default"}},[_vm._v("Upload Your Design")])],1),_vm._v(" "),_c('router-link',{staticClass:"minor cta-link",attrs:{"to":"/dashboard/design"}},[_vm._v("View")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Vz62":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamProductForm_vue__ = __webpack_require__("Jqq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64b9b455_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeamProductForm_vue__ = __webpack_require__("9xFa");
function injectStyle (ssrContext) {
  __webpack_require__("kR+s")
  __webpack_require__("Sn0f")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64b9b455"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamProductForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64b9b455_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeamProductForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W/tP":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ArtworkTips.vue": "i2pp",
	"./Benefits.vue": "tAcp",
	"./BrandlyApp.vue": "7xHn",
	"./Demo.vue": "/v6Z",
	"./FeatureItem.vue": "u6P3",
	"./FeatureSection.vue": "HMF7",
	"./GetDemoButton.vue": "IO6r",
	"./GetEmail.vue": "iYzm",
	"./GetPortalButton.vue": "EIcW",
	"./GetQuote.vue": "ap/+",
	"./GetStartedButton.vue": "TPTq",
	"./HowItWorksButton.vue": "RKT0",
	"./HubspotForm.vue": "pb8y",
	"./LandingPageHero.vue": "A9Ar",
	"./LandingPagePortal.vue": "eq6f",
	"./LandingPageSaveTime.vue": "tavi",
	"./NoStrings.vue": "+Twt",
	"./SecondaryHeader.vue": "HgU1",
	"./SectionHeader.vue": "i0Um",
	"./SummaryBlock.vue": "IdgM",
	"./SummaryBlockDark.vue": "0qMr",
	"./Testimonial.vue": "Edwh"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "W/tP";

/***/ }),

/***/ "WH4A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-radio-group',{staticClass:"pillbox",attrs:{"disabled":_vm.disabled,"buttons":"","button-variant":"clear"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('b-form-radio',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"value":"textMode","title":"Click to edit text"}},[_c('i',{staticClass:"fas fa-font"})]),_vm._v(" "),_c('b-form-radio',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"value":"moveMode","title":"Click to move text blocks"}},[_c('i',{staticClass:"fas fa-arrows-alt"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WVe7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cropCanvas;
function cropCanvas(canvas, trimHorizontalMargins, trimVerticalMargins) {
  //devicePixelRatio fixes retina displays
  trimHorizontalMargins = Math.round(trimHorizontalMargins * window.devicePixelRatio);
  trimVerticalMargins = Math.round(trimVerticalMargins * window.devicePixelRatio);

  // create a temporary canvas sized to the cropped size
  var newCanvas = document.createElement('canvas');
  var newContext = newCanvas.getContext('2d');

  var cropWidth = canvas.width - trimHorizontalMargins * 2;
  var cropHeight = canvas.height - trimVerticalMargins * 2;

  newCanvas.width = cropWidth;
  newCanvas.height = cropHeight;

  newContext.drawImage(canvas, trimHorizontalMargins, trimVerticalMargins, cropWidth, cropHeight, //source dimensions
  0, 0, cropWidth, cropHeight); //dest dimensions

  return newCanvas;
}

/***/ }),

/***/ "Wg25":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WqWh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_bubble_notifyPromise__ = __webpack_require__("pXqx");


//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    action: { type: String, required: true },
    arg: { default: null },
    success: { type: [String, Function], default: undefined },
    spinnerColor: { type: String, default: "white" }
  },
  data: function data() {
    return { busy: false };
  },

  methods: {
    onClick: function onClick(evt) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.busy = true;
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_2__lib_bubble_notifyPromise__["a" /* default */])(evt.path, _this.$store.dispatch(_this.action, _this.arg), _this.success);

              case 3:
                _this.busy = false;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),

/***/ "WsI8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wse+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_common__ = __webpack_require__("Cvgy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_vouchers__ = __webpack_require__("AT2g");





/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    vouchersInfo: {
      vouchers: [],
      busy: false,
      pageNumber: 1,
      totalVouchers: 0
    }
  },
  mutations: {
    setVouchersPaginated: function setVouchersPaginated(state, _ref) {
      var results = _ref.results,
          count = _ref.count,
          pageNumber = _ref.pageNumber;

      state.vouchersInfo = { vouchers: results, totalVouchers: count, pageNumber: pageNumber, busy: false };
    },
    setVouchersLoadingIsBusy: function setVouchersLoadingIsBusy(state) {
      state.vouchersInfo.busy = true;
    }
  },
  actions: {
    /**
     * Load vouchers.
     */
    loadVouchersPaginated: function loadVouchersPaginated(_ref2, payload) {
      var _this = this;

      var commit = _ref2.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref3, results, count, pageNumber;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit('setUploadsLoadingIsBusy');
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_common__["a" /* getItemsPaginated */])(__WEBPACK_IMPORTED_MODULE_3__services_vouchers__["a" /* getVouchers */], payload);

              case 3:
                _ref3 = _context.sent;
                results = _ref3.results;
                count = _ref3.count;
                pageNumber = payload.pageNumber;

                commit('setVouchersPaginated', { results: results, count: count, pageNumber: pageNumber });

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  getters: {
    vouchers: function vouchers(state) {
      return state.vouchersInfo.vouchers;
    },
    vouchersBusy: function vouchersBusy(state) {
      return state.vouchersInfo.busy;
    },
    pageNumberVouchers: function pageNumberVouchers(state) {
      return state.vouchersInfo.pageNumber;
    },
    totalVouchers: function totalVouchers(state) {
      return state.vouchersInfo.totalVouchers;
    }
  }
});

/***/ }),

/***/ "WtRg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['heroImage', 'footer', 'bgPos', 'minHeight'],
  computed: {
    heroBG: function heroBG() {
      return '\n      background-image: linear-gradient(rgba(44,44,44, 0.3), rgba(102,102,102, 1.0)), url(' + this.heroImage + ');\n    \n      min-height:' + (this.minHeight || 'calc(100vh - 100px') + ';\n      background-position: ' + (this.bgPos || 'middle middle') + ';\n      ';
    }
  }
});

/***/ }),

/***/ "Wwu7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle-signin",attrs:{"id":"linkedin-circle"},on:{"click":_vm.onClick}},[_c('img',{staticClass:"circle-logo",attrs:{"src":"/static/images/signin/linkedin/linkedin-icon.png"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WylX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBySidePreview_vue__ = __webpack_require__("giay");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5c70076_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBySidePreview_vue__ = __webpack_require__("77kB");
function injectStyle (ssrContext) {
  __webpack_require__("i2MF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a5c70076"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBySidePreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5c70076_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBySidePreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "X3kG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a164c62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BottomNavigation_vue__ = __webpack_require__("pTP1");
function injectStyle (ssrContext) {
  __webpack_require__("e44L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a164c62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a164c62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BottomNavigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "X9yx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isRounded;

function isRounded(product) {
  /* Ideally we would look at product attributes rather than a title,
  * but this works now
  * TODO: also look for an attribute
  */
  return product.title.includes("Rounded corners");
}

/***/ }),

/***/ "XGBw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XMq1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['previewUrls', 'rounded', 'editButton', 'imgBorder', 'compact'],
  data: function data() {
    return { currentIndex: 0, portrait: false };
  },

  methods: {
    imgLoad: function imgLoad(evt) {
      this.portrait = evt.target.naturalWidth < evt.target.naturalHeight;
    }
  },
  computed: {
    currentUrl: function currentUrl() {
      return this.previewUrls[this.currentIndex];
    },
    roundedCorners: function roundedCorners() {
      return this.rounded;
    }
  }
});

/***/ }),

/***/ "Xcxx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qrcode__ = __webpack_require__("71e1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qrcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qrcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_shorturl__ = __webpack_require__("os0Z");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // Generated data
      dataUrl: '',
      svg: '',
      shorturl: '',

      // Input parameters
      url: 'https://www.brandly.com/',
      shorten: false,
      errLevel: 'M',
      scale: 4,
      margin: 4,
      dark: '#000000',
      light: '#ffffff',

      // shortening process state
      shortenedUrl: '',
      shortening: false
    };
  },
  mounted: function mounted() {
    this.generate(this.params);
  },

  computed: {
    params: function params() {
      // While shorturl not setm, return url
      var url = this.shorten && this.shorturl || this.url;
      return { url: url, options: {
          errorCorrectionLevel: this.errLevel,
          scale: +this.scale,
          margin: +this.margin,
          color: {
            dark: this.dark + 'ff',
            light: this.light + 'ff'
          }
        }
      };
    }
  },
  methods: {
    generate: function generate(_ref) {
      var _this = this;

      var url = _ref.url,
          options = _ref.options;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2_qrcode___default.a.toDataURL(url, options);

              case 2:
                _this.dataUrl = _context.sent;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2_qrcode___default.a.toString(url, options);

              case 5:
                _this.svg = _context.sent;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    shortenUrl: function shortenUrl() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this2.shorten && _this2.url != _this2.shortenedUrl)) {
                  _context2.next = 7;
                  break;
                }

                _this2.shortening = true;
                _context2.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_3__services_shorturl__["a" /* shortenUrl */])(_this2.url);

              case 4:
                _this2.shorturl = _context2.sent.toUpperCase();

                _this2.shortening = false;
                _this2.shortenedUrl = _this2.url;

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  watch: {
    params: function params(_params) {
      this.generate(_params);
    },
    shorten: function shorten() {
      this.shortenUrl();
    },
    url: function url() {
      this.shortenUrl();
    }
  }
});

/***/ }),

/***/ "XjDl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChooseDesign_vue__ = __webpack_require__("qeSr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdcebc1a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChooseDesign_vue__ = __webpack_require__("nFjB");
function injectStyle (ssrContext) {
  __webpack_require__("/yRy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fdcebc1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChooseDesign_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdcebc1a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChooseDesign_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "XlDB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XpeC":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./About.vue": "r9dy",
	"./ArtworkGuidelines.vue": "NIcx",
	"./Blank.vue": "rMmh",
	"./BusinessCardsNew.vue": "+eQK",
	"./ChooseDesign.vue": "XjDl",
	"./Contact.vue": "9/A6",
	"./Features.vue": "gLNS",
	"./Features2.vue": "TLBc",
	"./HomePage.vue": "i2cO",
	"./HowItWorks.vue": "6e1g",
	"./Invite.vue": "4B3K",
	"./Join.vue": "fS8H",
	"./LandingPage.vue": "ILHl",
	"./Pricing.vue": "wa5P",
	"./Privacy.vue": "t8AH",
	"./Qr.vue": "ua/p",
	"./ResetPassword.vue": "r7EH",
	"./Setup.vue": "kSec",
	"./SignIn.vue": "npM1",
	"./SignUp.vue": "8uSK",
	"./StarterPack.vue": "MQyJ",
	"./Support.vue": "BT85",
	"./TOS.vue": "OKld",
	"./Welcome.vue": "l9ZU",
	"./oauth.vue": "pD6U"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XpeC";

/***/ }),

/***/ "Xvly":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['heroState']),
  methods: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])(['nextHeroState'])
});

/***/ }),

/***/ "Xvqp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfc8d458_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartCheckoutWrapper_vue__ = __webpack_require__("ZKUa");
function injectStyle (ssrContext) {
  __webpack_require__("6cos")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cfc8d458"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfc8d458_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartCheckoutWrapper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "XxLM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XxlJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Restrictions_vue__ = __webpack_require__("obOs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f497de6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Restrictions_vue__ = __webpack_require__("tciu");
function injectStyle (ssrContext) {
  __webpack_require__("8+In")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8f497de6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Restrictions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f497de6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Restrictions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Y/4c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['previewUrls', 'rounded', 'editButton'],
  data: function data() {
    return {
      currentIndex: 0,
      img: {
        0: { w: null, h: null, style: 'display: none;' },
        1: { w: null, h: null, style: 'display: none;' }
      },
      numLoaded: 0,
      previewsStyle: 'font-size: 25px;',
      paddingOverride: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    // onResize called for first time after styles are calculated
    this.onResize = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function () {
      return _this.calcRounded();
    }, 100);
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
  },

  methods: {
    imgLoad: function imgLoad(evt, index) {
      var i = this.img[index],
          t = evt.target;
      i.w = t.naturalWidth;i.h = t.naturalHeight;
      if (++this.numLoaded >= this.previewUrls.length) {
        this.calcStyles();
      }
      console.log('imgLoad', index, this.img);
    },
    calcStyles: function calcStyles() {
      var _img = this.img,
          i0 = _img[0],
          i1 = _img[1];

      var TL = 'top: 0; left: 0;',
          BR = 'bottom: 0; right: 0;',
          C = 'top: 50%; transform: translateY(-50%);',
          CONTAINER_ASPECT = 0.80;
      function cssW(i) {
        var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
        return 'width: ' + i.w + 'px; max-width: ' + max + '%;';
      }
      function cssH(i) {
        var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
        return 'height: ' + i.h + 'px; max-height: ' + max + '%;';
      }
      function portrait(_ref) {
        var w = _ref.w,
            h = _ref.h;
        return w < h;
      }
      function pctW(i) {
        return CONTAINER_ASPECT * i.w / i.h;
      }
      this.paddingOverride = '';
      if (!i1.w) {
        // Single card
        if (portrait(i0)) {
          // Center horizontally
          i0.style = 'top: 0; left: 50%; transform: translateX(-50%);' + cssH(i0);
        } else {
          // Use static positioning, so the container doesn't have extra vertical space
          i0.style = 'position: static;' + cssW(i0);
          this.paddingOverride = 'padding-top: 0;';
        }
      } else {
        // Two cards
        var p0 = portrait(i0),
            p1 = portrait(i1);
        if (p0 && p1) {
          // The cards should fit side-by-side
          // Overlap a little for effect
          i0.style = cssH(i0, 90) + 'top: 0; right: 48%';
          i1.style = cssH(i1, 90) + 'bottom: 0; left: 48%';
        } else if (p0 || p1) {
          // Mixed cards
          var max1 = 80,
              max2 = 80;
          if (p0) {
            max1 = pctW(i0) * 100;
          } else {
            max2 = pctW(i1) * 100;
          }
          i0.style = cssW(i0, max1) + 'left: 0;' + C;
          i1.style = cssW(i1, max2) + 'right: 0;' + C;
        } else {
          i0.style = cssW(i0, 90) + TL;
          i1.style = cssW(i0, 90) + BR;
        }
      }
      this.$nextTick(this.calcRounded);
    },
    calcRounded: function calcRounded() {
      var c = this.$refs.container,
          maxSize = 0;
      c.childNodes.forEach(function (i) {
        return maxSize = Math.max(maxSize, i.width, i.height);
      });
      // maxSize pixels = 3.5"  rounded corner = 1/4"   zoom = 2x   3.5/(1/4)/2 = 28
      // TODO is this right? looks a bit small.
      this.previewsStyle = 'font-size: ' + maxSize / 28 + 'px;';
    }
  },
  computed: {
    currentUrl: function currentUrl() {
      return this.previewUrls[this.currentIndex];
    }
  }
});

/***/ }),

/***/ "Y8rI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["loginError"]),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["socialAuth"]), {
    onGoogleLogin: function onGoogleLogin(userinfo) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("google user:", userinfo);
                _context.next = 3;
                return _this.socialAuth({
                  provider: "google",
                  access_token: userinfo.auth.access_token
                });

              case 3:
                _this.redirect();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    onFacebookLogin: function onFacebookLogin() {
      // not implemented

      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    onLinkedInLogin: function onLinkedInLogin(info) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log("linkedin info:", info);
                _context3.next = 3;
                return _this3.socialAuth(info);

              case 3:
                _this3.redirect();

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    redirect: function redirect() {
      if (!this.loginError) this.$router.push("/dashboard");
    }
  })
});

/***/ }),

/***/ "YCcG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbar-wrapper"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('ul',[_c('li',[_c('b-button-group',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"placement":"bottom","title":"Undo (⌘+z)","variant":"clear","disabled":""}},[_c('i',{staticClass:"fa fa-undo",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"placement":"bottom","title":"Redo (⌘+shift+z)","variant":"clear","disabled":""}},[_c('i',{staticClass:"fa fa-redo",attrs:{"aria-hidden":"true"}})])],1)],1),_vm._v(" "),(_vm.flags.addTextButton)?_c('li',[_c('b-button-group',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"placement":"bottom","title":"Duplicate Text","variant":"clear","disabled":true}},[_c('i',{staticClass:"fa fa-clone",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"variant":"clear","title":"Delete Object","disabled":true}},[_c('i',{staticClass:"fa fa-trash",attrs:{"aria-hidden":"true"}})])],1)],1):_vm._e(),_vm._v(" "),_c('li',[_c('EditModeToggle',{attrs:{"disabled":""},on:{"onTextMode":function($event){return _vm.emit('onTextMode')}}})],1),_vm._v(" "),_c('li',[_c('ul',{staticClass:"list-group"},[_c('li',{staticClass:"item fonts"},[_c('b-dropdown',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"m-md-2",style:({fontFamily:_vm.canvasState.fontName}),attrs:{"disabled":"","variant":"clear","text":_vm.canvasState.fontName,"id":"font-dropdown","title":"Click on active text to view font family"}},_vm._l((_vm.canvasState.fonts),function(font){return _c('b-dropdown-item',{key:font,style:({fontFamily:font})},[_vm._v(_vm._s(font))])}),1)],1),_vm._v(" "),_c('li',{staticClass:"item"},[_c('div',{staticClass:"font-size-wrapper dropdown-menu-right"},[_c('input',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"disabled":"","type":"text","size":"6","name":"currentFontSize","title":"Click on active text to view font size"},domProps:{"value":_vm.canvasState.fontSize}})])]),_vm._v(" "),_c('li',{staticClass:"item"},[_c('b-dropdown',{attrs:{"disabled":"","variant":"clear","size":"lg"}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"current color-square",style:(("background-color: " + (_vm.canvasState.color) + ";")),attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('b-dropdown-header',[_vm._v("Document Colors")]),_vm._v(" "),_vm._l((_vm.canvasState.colors),function(color){return _c('b-dropdown-item',{key:color},[_c('button',{staticClass:"dropdown-item color-square",style:(("background-color: " + color + ";"))})])})],2)],1)])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YFXu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YHAa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DesignMain_vue__ = __webpack_require__("45CS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f10a992_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DesignMain_vue__ = __webpack_require__("JVU6");
function injectStyle (ssrContext) {
  __webpack_require__("0T9q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f10a992"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DesignMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f10a992_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DesignMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YHMb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YHaQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProgressDots',{staticStyle:{"font-size":"15px"},attrs:{"step":_vm.step,"steps":[
    'Create your account',
    'Setup your portal',
    'Upload your design',
    'Share with your team'
]}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YSld":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__homepage__ = __webpack_require__("Tc2H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app__ = __webpack_require__("aRNo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dashboard__ = __webpack_require__("0IxP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__landingpages__ = __webpack_require__("ZgM1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_track_update__ = __webpack_require__("SMdB");












var routes = [].concat(__WEBPACK_IMPORTED_MODULE_4__homepage__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__dashboard__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__landingpages__["a" /* default */]);
var asyncRoutes = [];
if (false) {
  asyncRoutes.push(import('./admin'));
} else {
  routes.push({
    // Redirect from /admin to admin.brandly.com for staff users
    // or / for non-staff
    path: "/admin(/.*)?",
    beforeEnter: function beforeEnter(_ref) {
      var _this = this;

      var path = _ref.path;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */].dispatch('waitForLogin');

              case 2:
                path = __WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */].getters.isStaff ? 'https://admin.brandly.com' + path : '/';
                window.location = path;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  });
}

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  routes: routes,
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    // Always scroll to top
    return { x: 0, y: 0 };
  }
});

asyncRoutes.forEach(function (p) {
  return p.then(function (mod) {
    return router.addRoutes(mod.default);
  });
});

router.afterEach(function (to, from) {
  // Work around Chrome "bugs" with sticky, and always scroll to top
  setTimeout(function () {
    return document.getElementById('app').scrollTop = 0;
  }, 1);
  // Tell tracking libs we've visited a new page
  // Vue calls afterEach before actually changing URL, so
  // use a delay to get the actual URL
  setTimeout(__WEBPACK_IMPORTED_MODULE_9__lib_track_update__["a" /* default */], 20);
});

router.beforeEach(function (to, from, next) {
  console.log('beforeEach', to.matched);
  // Find the title from the deepest child in the set of matched routes
  document.title = to.matched.map(function (r) {
    return r.meta.title;
  }).filter(Boolean).pop();
  // Enforce auth
  var authedRoute = to.matched.find(function (r) {
    return r.meta.requiresAuth;
  });
  if (authedRoute) {
    __WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */].dispatch('waitForLogin').then(function () {
      var requiresIsStaff = !!to.matched.find(function (r) {
        return r.meta.requiresIsStaff;
      });
      var isStaff = __WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */].getters.isStaff;
      if (requiresIsStaff && !isStaff) {
        // If a path requires "staff" permission and a user does not have it,
        // redirect the user to the dashboard.
        next({ path: '/dashboard' });
      } else {
        next();
      }
    }, function (err) {
      console.log('waitForLogin->', err);
      next(authedRoute.meta.requiresAuthRedirect || { path: '/signin', query: { redirect: to.fullPath } });
    });
  } else {
    next();
  }
});

router.onReady(function () {
  console.log('onReady');
  if (window.dataLayer) window.dataLayer.push({ 'event': 'optimize.activate' });
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "YbXp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      form: { name: '', domain: '' },
      restrictions: {},
      saving: false,
      notification: { type: null, message: '' }
    };
  },
  mounted: function mounted() {
    this.form.name = this.team.name;
    this.form.domain = this.team.domain;
    this.form.company_size = this.team.company_size;
    this.form.have_design = this.team.have_design;
    this.restrictions = this.team.default_orderer_settings;
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['team']),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['updateTeam']), {
    save: function save() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var message;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                message = _this.formValidationError();

                if (!message) {
                  _context.next = 4;
                  break;
                }

                _this.notification = { message: message, type: 'danger' };
                return _context.abrupt('return');

              case 4:
                _this.saving = true;
                _context.next = 7;
                return _this.updateTeam(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this.form, { default_orderer_settings: _this.restrictions }));

              case 7:
                _this.saving = false;
                _this.$router.push('/dashboard/settings');

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    formValidationError: function formValidationError() {
      if (!this.form.domain) return 'Please enter a domain';
      if (!this.form.name) return 'Please enter a team name';
      var DOMAIN_NAME = /[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)+/;
      if (!DOMAIN_NAME.test(this.form.domain)) return 'Please enter a valid domain';
    }
  }),
  watch: {
    restrictions: {
      deep: true,
      handler: function handler(val, old) {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val) === __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.team.default_orderer_settings))) {
                    _context2.next = 2;
                    break;
                  }

                  return _context2.abrupt('return');

                case 2:
                  _this2.saving = true;
                  _context2.next = 5;
                  return _this2.updateTeam({ default_orderer_settings: _this2.restrictions });

                case 5:
                  _this2.saving = false;

                case 6:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }))();
      }
    }
  }
});

/***/ }),

/***/ "YkFR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    step: { default: 1 },
    steps: { default: ['one', 'two'] }
  }
});

/***/ }),

/***/ "Ym/O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineItemThumbnails_vue__ = __webpack_require__("/8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_621c1341_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineItemThumbnails_vue__ = __webpack_require__("pwrx");
function injectStyle (ssrContext) {
  __webpack_require__("0D9M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-621c1341"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineItemThumbnails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_621c1341_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineItemThumbnails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Ymfd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage-secondary-layout"},[_c('HomepageLayout',[_vm._t("default")],2),_vm._v(" "),_c('BottomNavigation')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ynxk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    autoplay: function autoplay() {
      return !!this.$route.query.openvideo;
    }
  }
});

/***/ }),

/***/ "Yo3d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: "",
      busy: false,
      error: ''
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["emailSignUp"]), {
    onClickSignUp: function onClickSignUp() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, success, message, email;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.email) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                // Do the request
                _this.busy = true;
                _context.next = 5;
                return _this.emailSignUp(_this.email);

              case 5:
                _ref = _context.sent;
                success = _ref.success;
                message = _ref.message;
                email = _ref.email;

                console.log('result:', success, message, email);
                _this.busy = false;

                if (success) {
                  _this.error = 'Thank you! Please check your inbox.';
                  _this.email = '';
                } else if (message === 'Member Exists') {
                  _this.error = 'All good! You have already subscribed.';
                } else {
                  // We got a list of errors for the email field. Shpw under the email.
                  _this.error = email ? email[0] : message || 'Sorry, an error occurred.';
                }

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  })
});

/***/ }),

/***/ "YqDi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DesignPreview_vue__ = __webpack_require__("XMq1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19778616_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DesignPreview_vue__ = __webpack_require__("adOp");
function injectStyle (ssrContext) {
  __webpack_require__("M8ye")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19778616"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DesignPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19778616_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DesignPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YqKw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WistiaMovie_vue__ = __webpack_require__("7jZB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acc1c67a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WistiaMovie_vue__ = __webpack_require__("3FFg");
function injectStyle (ssrContext) {
  __webpack_require__("IkdP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WistiaMovie_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acc1c67a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WistiaMovie_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Yw92":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['bus', 'canvasState'],
  data: function data() {
    return { show: false };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['flags']), {
    allowMultiline: {
      get: function get() {
        return this.canvasState.allowMultiline;
      },
      set: function set(val) {
        this.emit('setAllowMultiline', val);
      }
    },
    forceCaps: {
      get: function get() {
        return this.canvasState.textTransform === 'uppercase';
      },
      set: function set(val) {
        this.emit('setTextTransform', val ? 'uppercase' : null);
      }
    },
    fieldLocked: {
      get: function get() {
        return this.canvasState.fieldLocked;
      },
      set: function set(val) {
        this.emit('setFieldLock', val);
      }
    },
    fieldDeletable: {
      get: function get() {
        return this.canvasState.fieldDeletable;
      },
      set: function set(val) {
        this.emit('setFieldDeletable', val);
      }
    },
    variable: {
      get: function get() {
        return this.canvasState.variable;
      },
      set: function set(val) {
        this.emit('setVariable', val);
      }
    },
    blockId: function blockId() {
      return this.canvasState.blockId;
    },

    blockVerticalAlign: {
      get: function get() {
        return ((this.canvasState.blocks || {})[this.canvasState.blockId] || {}).verticalAlign;
      },
      set: function set(val) {
        this.emit('setBlockVerticalAlign', val);
      }
    }
  }),
  methods: {
    emit: function emit(event, value) {
      console.log('emit', event, value);
      this.bus.$emit(event, value);
    }
  },

  events: {
    toggleFieldOptions: function toggleFieldOptions() {
      this.show = !this.show;
    }
  },

  watch: {
    canvasState: {
      handler: function handler(val) {
        console.log('canvasState changed', val, val.fieldLocked);
      },

      deep: true
    },
    show: function show(shown) {
      this.bus.$emit('fieldOptionsVisibilityChange', { shown: shown });
    }
  }
});

/***/ }),

/***/ "Z/fi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamMemberList_vue__ = __webpack_require__("dpH0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c111098_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeamMemberList_vue__ = __webpack_require__("0uq0");
function injectStyle (ssrContext) {
  __webpack_require__("bqkq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c111098"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamMemberList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c111098_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeamMemberList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z0C3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z9Zk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZB2G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZBhT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZKUa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-wrapper"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZOM/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZcqC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DesignMain_vue__ = __webpack_require__("YHAa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NewDesign_vue__ = __webpack_require__("4v/R");
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  children: [{
    path: '',
    name: 'design-main',
    component: __WEBPACK_IMPORTED_MODULE_0__DesignMain_vue__["a" /* default */]
  }, {
    path: 'new',
    name: 'new-design',
    component: __WEBPACK_IMPORTED_MODULE_1__NewDesign_vue__["a" /* default */]
  }]
});

/***/ }),

/***/ "ZgM1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_homepage_LandingPage__ = __webpack_require__("ILHl");


var routes = [{
  component: __WEBPACK_IMPORTED_MODULE_0__components_pages_homepage_LandingPage__["default"],
  path: "/lp/business-card-portal",
  meta: { title: "Business Card Printing Portal | Brandly" },
  props: {
    headline: "Get the #1 business card printing portal, <span>for free</span>.",
    subtitle: "Simplify the way your company prints business cards dramatically with an all-in-one ordering portal.",
    description: "Open a free business card portal and print high-quality business cards for your entire company in minutes.",
    keywords: "Business Card Portal"
  }
}, {
  component: __WEBPACK_IMPORTED_MODULE_0__components_pages_homepage_LandingPage__["default"],
  path: "/lp/corporate-business-cards",
  meta: { title: "Corporate Business Card Printing | Brandly" },
  props: {
    headline: "The #1 business card printing solution for corporations.",
    subtitle: "Simplify the way your company prints business cards dramatically with an all-in-one ordering portal.",
    description: "Get a printing storefront just for your company and order top-quality business cards for your entire company in minutes",
    keywords: "Corporate Business Cards"
  }
}, {
  component: __WEBPACK_IMPORTED_MODULE_0__components_pages_homepage_LandingPage__["default"],
  path: "/lp/bulk-business-cards",
  meta: { title: "Bulk Business Card Printing | Brandly" },
  props: {
    headline: "Print business cards in bulk at low prices",
    subtitle: "Simplify the way your company prints business cards dramatically with an all-in-one ordering portal.",
    description: "Get more for less by printing business cards in bulk. Take advantage of our discounted printing and free shipping on every order.",
    keywords: "Bulk Business Cards"
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "Zhc1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    emit: function emit(event, value) {
      this.bus.$emit(event, value);
    }
  },
  props: ['bus']
});

/***/ }),

/***/ "ZoSi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditApproval_vue__ = __webpack_require__("8woP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5869bd88_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditApproval_vue__ = __webpack_require__("jgnI");
function injectStyle (ssrContext) {
  __webpack_require__("dXr5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5869bd88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditApproval_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5869bd88_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditApproval_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZpmN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zq/4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_productData_json__ = __webpack_require__("z3lN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_productData_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_productData_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PricingTable__ = __webpack_require__("wudB");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["selected"],
  components: {
    PricingTable: __WEBPACK_IMPORTED_MODULE_1__PricingTable__["a" /* default */]
  },
  data: function data() {
    return {
      cur: this.selected,
      corners: "Square"
    };
  },

  computed: {
    categories: function categories() {
      return __WEBPACK_IMPORTED_MODULE_0__data_productData_json___default.a.categories.map(function (c) {
        return c.title;
      });
    }
  },
  watch: {
    selected: function selected() {
      this.cur = this.selected;
    }
  }
});

/***/ }),

/***/ "Zqsl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Flags_vue__ = __webpack_require__("USD4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc882d38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Flags_vue__ = __webpack_require__("1THI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Flags_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc882d38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Flags_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZyXO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['details'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['orderVoucher']), {
    showSurvey: function showSurvey() {
      return this.orderVoucher && this.orderVoucher.description === 'FREE2018';
    }
  })
});

/***/ }),

/***/ "Zz4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineDetailProductForm_vue__ = __webpack_require__("syyg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fce6858_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineDetailProductForm_vue__ = __webpack_require__("07s2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineDetailProductForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fce6858_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineDetailProductForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a0u3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomepageSecondaryLayout',[_c('div',{staticClass:"vheight"},[_c('div',{staticClass:"vcenter"},[_c('div',{staticClass:"vblock"},[_c('div',{staticClass:"wrapper"},[_c('h2',[_vm._v("Send us an email ")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('b-form-group',{staticClass:"contact-form",attrs:{"id":"new_sign_up"}},[_c('div',{staticClass:"form-label"},[_vm._v("Your Name\n                "),_c('span',{attrs:{"id":"required"}},[_vm._v("(required)")])]),_vm._v(" "),_c('b-form-input',{staticClass:"contact-us-input",attrs:{"placeholder":"Your Name","required":"required","type":"text","autofocus":"autofocus","name":"contact_us_[name]"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('div',{staticClass:"form-label"},[_vm._v("Your Email\n                "),_c('span',{attrs:{"id":"required"}},[_vm._v("(required)")])]),_vm._v(" "),_c('b-form-input',{staticClass:"contact-us-input",attrs:{"placeholder":"Your email address","required":"required","type":"email","autofocus":"autofocus","name":"contact_us_[email]","pattern":"[^@]+@[^@]+\\.[a-zA-Z]*"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('div',{staticClass:"form-label"},[_vm._v("Message\n                "),_c('span',{attrs:{"id":"required"}},[_vm._v("(required)")])]),_vm._v(" "),_c('b-form-textarea',{staticClass:"contact-us-input",attrs:{"placeholder":"Your message","rows":3,"max-rows":6,"required":"required","type":"text","autofocus":"autofocus","name":"contact_us_[message]"},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}}),_vm._v(" "),_c('b-button',{staticClass:"contact-us-submit",attrs:{"type":"submit","name":"commit","disabled":!_vm.formValid}},[_vm._v("\n                Submit\n              ")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"hero-bottom"},[_c('img',{attrs:{"src":"/static/images/footer/product_footer.png"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a4KA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("bXtv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_422ac421_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("aIiQ");
function injectStyle (ssrContext) {
  __webpack_require__("0/j+")
  __webpack_require__("DCWn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-422ac421"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_422ac421_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aBMo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




var UndoStack = function () {
  function UndoStack(canvas, maxStackSize, canvasState) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, UndoStack);

    this.canvas = canvas;
    this.stack = [];
    this.stackPtr = -1;
    this.maxStackSize = maxStackSize || 50;

    // Store whether we can undo/redo here
    this.canvasState = canvasState || {};
    this.canvasState.canUndo = false;
    this.canvasState.canRedo = false;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(UndoStack, [{
    key: '_renderState',
    value: function _renderState(state) {
      var _this = this;

      if (state.blocks) {
        this.canvasState.blocks = state.blocks;
      }
      this.canvas.loadFromJSON(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state), function () {
        _this.canvas.renderAll();
      });
    }

    // returns whether we canUndo
    // after a push, implicitly canRedo == false

  }, {
    key: 'push',
    value: function push() {
      // 'brandly' is an additional propertyToInclude. Used to save brandly custom props including "isPlaceholder"
      var obj = this.canvas.toJSON(['brandly']);
      // Include a deep copy of the block state
      obj.blocks = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.canvasState.blocks));

      if (this.stackPtr < 0 || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.stack[this.stackPtr]) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj)) {
        this.stack = this.stack.splice(0, ++this.stackPtr);
        this.stack.push(obj);
        if (this.stack.length > this.maxStackSize) {
          // console.log('exceeded max stack size');
          this.stack = this.stack.splice(1, this.maxStackSize);
          this.stackPtr--;
        }
        this.canvasState.canUndo = this.stack.length > 1;
      } else {
        this.canvasState.canUndo = false;
      }
    }

    //implicitly canRedo == true
    //returns canUndoAgain?

  }, {
    key: 'undo',
    value: function undo() {
      if (this.stackPtr > 0) {
        var state = this.stack[--this.stackPtr];
        this._renderState(state);
        this.canvasState.canUndo = this.stackPtr > 0;
        this.canvasState.canRedo = true;
      } else {
        // error state: should not hit this, if UI respects the canvasState.canUndo
        console.log('UndoStack cannot undo');
      }
    }

    //implicitly, canUndo == true
    //returns canRedoAgain?

  }, {
    key: 'redo',
    value: function redo() {

      if (this.stackPtr + 1 < this.stack.length) {
        var state = this.stack[++this.stackPtr];
        this._renderState(state);

        this.canvasState.canUndo = true;
        this.canvasState.canRedo = this.stackPtr + 1 < this.stack.length;
      } else {
        //error state: should not hit this
        console.log('UndoStack cannot redo');
      }
    }
  }]);

  return UndoStack;
}();

/* harmony default export */ __webpack_exports__["a"] = (UndoStack);

/***/ }),

/***/ "aGa6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aIiQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header",class:{darkBackground: _vm.heroDark, transparent: _vm.transparent}},[_c('div',{staticClass:"nav-wrapper"},[_c('b-navbar',{class:{wideHeader: _vm.wideHeader},attrs:{"toggleable":"md"}},[_c('b-navbar-brand',{staticStyle:{"align-self":"start"},attrs:{"href":"/"},on:{"mousedown":_vm.startLongpress,"mouseup":_vm.stopLongpress}}),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('b-navbar-toggle',{attrs:{"is-nav":"","target":"header-nav"}},[_c('i',{staticClass:"fa fa-bars fa-lg",attrs:{"color":"black"}})])],1),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"header-nav"}},[_c('div',{staticClass:"sidebar-overlay"}),_vm._v(" "),_c('b-navbar-toggle',{staticClass:"close",attrs:{"is-nav":"","target":"header-nav"}},[_c('i',{staticClass:"fas fa-times fa-lg"})]),_vm._v(" "),_c('div',{staticClass:"header-nav mr-auto"},[_c('router-link',{staticClass:"header-nav-link header-nav-text-link",class:{"is-active" : _vm.$route.path.match(/business-?cards|products/)},attrs:{"to":"/products"}},[_vm._v("Business Cards")]),_vm._v(" "),_c('router-link',{staticClass:"header-nav-link header-nav-text-link",class:{"is-active" : _vm.$route.path.startsWith("/pricing")},attrs:{"to":"/pricing"}},[_vm._v("Pricing")]),_vm._v(" "),_c('router-link',{staticClass:"header-nav-link header-nav-text-link",class:{"is-active" : _vm.$route.path.startsWith("/features")},attrs:{"to":"/features"}},[_vm._v("Features")]),_vm._v(" "),_c('router-link',{staticClass:"header-nav-link header-nav-text-link",class:{"is-active" : _vm.$route.path.startsWith("/artworkguidelines")},attrs:{"to":"/artworkguidelines"}},[_vm._v("Artwork")])],1),_vm._v(" "),_c('div',{staticClass:"header-nav ml-auto"},[_c('router-link',{staticClass:"header-nav-link",attrs:{"id":"cart","to":"/cart"}},[_c('div',{staticClass:"cart-items"},[_c('svg',{staticClass:"dashboard-icons shopping-cart-icon"},[_c('use',{attrs:{"xlink:href":"/static/images/dashboard/sprites.svg#cart"}})]),_vm._v(" "),(_vm.numCartItems)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.numCartItems))]):_vm._e()])]),_vm._v(" "),(_vm.showLogin)?_c('router-link',{staticClass:"header-nav-link",class:{"is-active" : _vm.$route.path==="/signin"},attrs:{"to":"/signin"}},[_vm._v("Sign In")]):_vm._e(),_vm._v(" "),(_vm.showLogin)?_c('a',{staticClass:"header-nav-link",attrs:{"id":"signup","href":"/signup"}},[_vm._v("Sign Up")]):_vm._e(),_vm._v(" "),(_vm.showLoggedIn)?_c('router-link',{staticClass:"header-nav-link",class:{"is-active" : _vm.$route.path.startsWith("/dashboard")},attrs:{"to":"/dashboard"}},[_c('svg',{staticClass:"dashboard-icons"},[_c('use',{attrs:{"xlink:href":"/static/images/dashboard/sprites.svg#dashboard"}})])]):_vm._e(),_vm._v(" "),(_vm.showLoggedIn)?_c('b-dropdown',{staticClass:"profile-menu ",attrs:{"right":"","no-caret":"","text":_vm.initials,"variant":"round"}},[_c('b-dropdown-header',{attrs:{"href":"#"}},[_c('div',{staticClass:"menu-fullname"},[_vm._v(_vm._s(_vm.userFullName))]),_vm._v(" "),_c('div',{staticClass:"menu-auxname"},[_vm._v(_vm._s(_vm.username))]),_vm._v(" "),_c('div',{staticClass:"menu-auxname"},[_vm._v(_vm._s(_vm.teamName)),(_vm.isAdmin)?_c('span',{staticClass:"admin-badge"},[_vm._v("admin")]):_vm._e()])]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"/dashboard/settings/profile"}},[_c('i',{staticClass:"fas fa-lg fa-cog icon"}),_vm._v(" Edit Profile")]),_vm._v(" "),(_vm.isStaff)?_c('b-dropdown-item',[_c('router-link',{attrs:{"to":"/admin/teams"}},[_c('i',{staticClass:"fas fa-lg fa-sign-out-alt icon"}),_vm._v(" Internal Dashboard")])],1):_vm._e(),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onClickLogout($event)}}},[_c('i',{staticClass:"fas fa-lg fa-power-off icon"}),_vm._v(" Log Out")]),_vm._v(" "),(!_vm.isStaff && _vm.teamsToSwitch.length > 0)?[_c('b-dropdown-divider'),_vm._v(" "),_c('b-dropdown-item-button',{attrs:{"disabled":""}},[_vm._v("Switch to")]),_vm._v(" "),_vm._l((_vm.teamsToSwitch),function(team){return _c('b-dropdown-item',{key:team.id,attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.enterTeam(team.id)}}},[_c('i',{staticClass:"fas fa-lg fa-arrow-right icon"}),_vm._v(" "+_vm._s(team.name)+"\n              ")])})]:_vm._e()],2):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"flagsModal",attrs:{"hide-footer":"","title":"Flags"}},[_c('Flags')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aJbW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return emailSignUp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defineService__ = __webpack_require__("tVbG");



var postSignup = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('post', 'api/v1/cta/signup/');

/**
 * User has entered their email. Post to back end which should trigger an
 * email to user, etc.
 *
 * This returns new token / user details. Since we now know new information
 * about the user, that gets updated on the user. currently the user becomes
 * a "real" user.
 *
 * @param {String} email
 * @returns {TokenAndUser}
 */
var emailSignUp = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(email) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', postSignup({ email: email }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function emailSignUp(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ "aJjv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    inline: Boolean,
    color: String
  }
});

/***/ }),

/***/ "aOJY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aQz/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return login; });
/* harmony export (immutable) */ __webpack_exports__["e"] = logout;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return signUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return resetPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return confirmReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return socialAuth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return impersonate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defineService__ = __webpack_require__("tVbG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authorize__ = __webpack_require__("lKgw");





var postLogin = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('post', 'api/v1/auth/api-token-auth/', {
  alternatives: { altWrongPw: '-wrongpw-400' }
});
var postRegister = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('post', 'api/v1/auth/register-lazy-user/');
var postPasswordReset = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('post', 'api/v1/rest-auth/password/reset/');
var postPasswordResetConfirm = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('post', 'api/v1/rest-auth/password/reset/confirm/');
var postSocialAuth = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('post', 'rest-auth/:provider/');
var postLogout = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('post', 'rest-auth/logout/');
var postImpersonate = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('post', 'api/v1/auth/api-token-impersonate/');
var getUser = Object(__WEBPACK_IMPORTED_MODULE_2__defineService__["b" /* default */])('get', 'api/v1/user/');

var login = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(username, password) {
    var data;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return postLogin({ username: username, password: password });

          case 3:
            data = _context.sent;
            return _context.abrupt('return', Object(__WEBPACK_IMPORTED_MODULE_3__authorize__["d" /* setAuthState */])(data));

          case 7:
            _context.prev = 7;
            _context.t0 = _context['catch'](0);

            console.log(_context.t0);

            if (!(_context.t0.response && _context.t0.response.data && _context.t0.response.data.details)) {
              _context.next = 12;
              break;
            }

            throw _context.t0.response.data.details;

          case 12:
            throw _context.t0;

          case 13:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 7]]);
  }));

  return function login(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

function logout() {
  postLogout({});
  Object(__WEBPACK_IMPORTED_MODULE_3__authorize__["d" /* setAuthState */])({});
}

var signUp = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref3) {
    var email = _ref3.email,
        password = _ref3.password,
        first_name = _ref3.first_name,
        last_name = _ref3.last_name,
        team = _ref3.team,
        token = _ref3.token;
    var data;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return postRegister({ username: email, email: email, password: password, first_name: first_name, last_name: last_name, team: team, token: token });

          case 2:
            data = _context2.sent;
            return _context2.abrupt('return', Object(__WEBPACK_IMPORTED_MODULE_3__authorize__["d" /* setAuthState */])(data));

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function signUp(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

var resetPassword = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(email) {
    var _ref5, detail;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return postPasswordReset({ email: email });

          case 2:
            _ref5 = _context3.sent;
            detail = _ref5.detail;
            return _context3.abrupt('return', detail);

          case 5:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function resetPassword(_x4) {
    return _ref4.apply(this, arguments);
  };
}();

var confirmReset = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(params) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            console.log('confirmReset', params);
            _context4.prev = 1;
            _context4.next = 4;
            return postPasswordResetConfirm(params);

          case 4:
            return _context4.abrupt('return', _context4.sent);

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4['catch'](1);

            console.log(_context4.t0);

            if (!(_context4.t0.response && _context4.t0.response.data)) {
              _context4.next = 12;
              break;
            }

            throw _context4.t0.response.data;

          case 12:
            throw _context4.t0.toString();

          case 13:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this, [[1, 7]]);
  }));

  return function confirmReset(_x5) {
    return _ref6.apply(this, arguments);
  };
}();

var socialAuth = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(provider, _ref8) {
    var access_token = _ref8.access_token,
        code = _ref8.code;
    var data;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return postSocialAuth(provider, { access_token: access_token, code: code });

          case 2:
            data = _context5.sent;

            console.log(data);
            return _context5.abrupt('return', Object(__WEBPACK_IMPORTED_MODULE_3__authorize__["d" /* setAuthState */])(data));

          case 5:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function socialAuth(_x6, _x7) {
    return _ref7.apply(this, arguments);
  };
}();

var impersonate = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(username) {
    var data;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return postImpersonate({ username: username });

          case 2:
            data = _context6.sent;
            return _context6.abrupt('return', Object(__WEBPACK_IMPORTED_MODULE_3__authorize__["d" /* setAuthState */])(data));

          case 4:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function impersonate(_x8) {
    return _ref9.apply(this, arguments);
  };
}();

/***/ }),

/***/ "aRNo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pages_upload_Upload__ = __webpack_require__("e64a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_editor_Editor__ = __webpack_require__("6uWi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_basket_Basket__ = __webpack_require__("8dWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_basket_BasketItemDetail__ = __webpack_require__("4tvC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_checkout_Checkout__ = __webpack_require__("Nq36");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_invoice_Invoice__ = __webpack_require__("MpnT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_flags_Flags__ = __webpack_require__("Zqsl");









var routes = [{
  path: "/upload/:selectedInfo?/:designId?",
  name: "Upload",
  component: __WEBPACK_IMPORTED_MODULE_1__components_pages_upload_Upload__["a" /* default */],
  props: true,
  meta: {
    title: 'Brandly | Upload'
  }
}, {
  path: "/design/:id/:from?",
  name: "Editor",
  component: __WEBPACK_IMPORTED_MODULE_2__components_pages_editor_Editor__["a" /* default */],
  meta: {
    title: 'Brandly | Editor'
  }
}, {
  path: "/cart",
  name: "Cart",
  component: __WEBPACK_IMPORTED_MODULE_3__components_pages_basket_Basket__["a" /* default */],
  meta: {
    title: 'Brandly | Cart'
  }
}, {
  path: "/cart/:id",
  name: "Cart Detail",
  component: __WEBPACK_IMPORTED_MODULE_4__components_pages_basket_BasketItemDetail__["a" /* default */],
  meta: {
    title: 'Brandly | Cart'
  }
}, {
  path: "/checkout",
  name: "Checkout",
  component: __WEBPACK_IMPORTED_MODULE_5__components_pages_checkout_Checkout__["a" /* default */],
  meta: {
    title: 'Brandly | Checkout'
  }
}, {
  path: "/invoice/:id?",
  name: "Invoice",
  component: __WEBPACK_IMPORTED_MODULE_6__components_pages_invoice_Invoice__["a" /* default */],
  props: true,
  meta: {
    title: 'Brandly | Invoice'
  }
}, {
  path: "/flags/:flag/:state",
  component: __WEBPACK_IMPORTED_MODULE_7__components_pages_flags_Flags__["a" /* default */],
  props: true
}, {
  path: "/flags",
  component: __WEBPACK_IMPORTED_MODULE_7__components_pages_flags_Flags__["a" /* default */],
  props: true
}].map(function (route) {
  route.meta = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ useAppHeader: true }, route.meta || {});
  return route;
});

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "aa7g":
/***/ (function(module, exports) {

var N = 14; // most chars on one line
module.exports = function splitNametag(nametag) {
  // Return a string with newlines embedded for longer nametags.
  // Always return an uppercased string. Embedded spaces are treated
  // as "break points", and can result in strings longer than "N" being returned.
  nametag = nametag.toUpperCase();
  if (/ /.test(nametag)) {
    return nametag.replace(/ /g, '\n');
  }
  var numlines = Math.ceil(nametag.length / N);
  var balanced = Math.ceil(nametag.length / numlines);
  var result = '';
  while (nametag.length > balanced) {
    result += nametag.substring(0, balanced) + '\n';
    nametag = nametag.substring(balanced);
  }
  return result + nametag;
};

/***/ }),

/***/ "adOp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"design-preview",class:{roundedCorners: _vm.roundedCorners, imgBorder: _vm.imgBorder, portrait: _vm.portrait, compact: _vm.compact}},[_c('div',[_c('img',{staticClass:"main",attrs:{"src":_vm.currentUrl},on:{"load":_vm.imgLoad}}),_vm._v(" "),(_vm.editButton)?_c('button',{staticClass:"btn edit-design",on:{"click":function($event){return _vm.$emit('edit')}}},[_c('i',{staticClass:"far fa-edit"}),_vm._v(" Edit Design")]):_vm._e()]),_vm._v(" "),(_vm.previewUrls.length > 1)?_c('div',{staticClass:"previews"},_vm._l((_vm.previewUrls),function(url,index){return _c('img',{key:index,attrs:{"src":url},on:{"click":function($event){_vm.currentIndex = index}}})}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aiG8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[(!_vm.savedCardsLoaded)?_c('b-col',[_c('WaveSpinner')],1):(_vm.noSavedCards)?_c('b-col',[_vm._v("\n    You have no saved cards. Please add one in Billing first.\n  ")]):[_c('b-col',{attrs:{"sm":"7"}},[_c('b-form-group',{attrs:{"label":"Select a saved card"}},[_c('b-form-select',{attrs:{"options":_vm.savedCardOptions},model:{value:(_vm.saved_card),callback:function ($$v) {_vm.saved_card=$$v},expression:"saved_card"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"text-right mt-3 mt-sm-0 mb-3",attrs:{"sm":"5"}},[_c('ActionButton',{staticClass:"d-lg-block mb-lg-3",attrs:{"action":"approveOrder","arg":{saved_card: _vm.saved_card},"success":"Order Approved","variant":"success"}},[_vm._v("Pay & Approve Order")])],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aovp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__ = __webpack_require__("uv8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ba34ff_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__ = __webpack_require__("g/q2");
function injectStyle (ssrContext) {
  __webpack_require__("5mjD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46ba34ff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ba34ff_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ap/+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_832d3260_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GetQuote_vue__ = __webpack_require__("6/9m");
function injectStyle (ssrContext) {
  __webpack_require__("hD2Q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-832d3260"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_832d3260_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GetQuote_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "apaE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('SettingsTitleBar',{attrs:{"sub":"Billing","saving":_vm.saving,"buttons":_vm.editing ? 'both' : 'cancel'},on:{"cancel":_vm.cancel}}),_vm._v(" "),_c('b-alert',{attrs:{"show":!!_vm.notification.type,"variant":_vm.notification.type}},[_vm._v(_vm._s(_vm.notification.message))]),_vm._v(" "),(_vm.forceInvoice)?_c('div',[_c('p',[_vm._v("Your team has invoicing enabled")]),_vm._v(" "),(_vm.isStaff)?_c('ActionButton',{attrs:{"action":"updateTeam","arg":{allow_invoice: false}}},[_vm._v("Disable invoicing")]):_vm._e()],1):(_vm.editing)?_c('div',[_c('h2',[_vm._v("Credit Card")]),_vm._v(" "),(_vm.editing.id)?_c('EditSavedCard',{model:{value:(_vm.editing),callback:function ($$v) {_vm.editing=$$v},expression:"editing"}},[_c('p',{attrs:{"id":"edit-card"}},[_vm._v("\n      Please review the saved card information below. To change the card number or billing address, please delete this\n      saved card and create a new one.\n      ")])]):_c('NewSavedCard',{model:{value:(_vm.editing),callback:function ($$v) {_vm.editing=$$v},expression:"editing"}},[_c('p',{attrs:{"id":"edit-card"}},[_vm._v("\n      Enter saved card information below. Once you do, your card information will be securely stored and\n      available for anyone on your team to use during checkout.\n      ")])]),_vm._v(" "),_c('SettingsButtons',{attrs:{"saving":_vm.saving,"bottom":""}})],1):_c('div',[(_vm.hasSavedCards)?_c('div',[_vm._l((_vm.savedCards),function(card){return _c('SavedCard',{key:card.id,attrs:{"card":card}},[_c('div',{staticClass:"card-buttons"},[(_vm.isOwner(card))?_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"pointer",attrs:{"title":"Edit card"},on:{"click":function($event){return _vm.edit(card)}}},[_c('i',{staticClass:"fa fa-edit"})]):_vm._e(),_vm._v(" "),(_vm.isOwner(card))?_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"pointer",attrs:{"title":"Delete card"},on:{"click":function($event){return _vm.del(card)}}},[_c('i',{staticClass:"fa fa-trash"})]):_vm._e(),_vm._v(" "),(card.available_to_team)?_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Team card"}},[_c('i',{staticClass:"fas fa-users"})]):_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Personal card"}},[_c('i',{staticClass:"fas fa-user"})])])])}),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.add}},[_vm._v("Add another saved card")])],2):(_vm.loading)?_c('WaveSpinner'):_c('div',[_c('p',{attrs:{"id":"no-card"}},[_vm._v("\n      You can add a saved card that is used by your team below.\n      Anyone on your team will be able to use this card.\n      ")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.add}},[_vm._v("Add a saved card")]),_vm._v(" "),(_vm.isStaff)?_c('ActionButton',{attrs:{"action":"updateTeam","arg":{allow_invoice: true}}},[_vm._v("Enable invoicing")]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "at1t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "avd0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivateToggle_vue__ = __webpack_require__("7jUO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e709f02a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivateToggle_vue__ = __webpack_require__("6WXE");
function injectStyle (ssrContext) {
  __webpack_require__("w260")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e709f02a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivateToggle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e709f02a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivateToggle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "azN1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbar-wrapper"},[_c('div',{staticClass:"container"},[(_vm.designLoaded)?_c('div',{staticClass:"row"},[(_vm.lockButtons)?_c('div',{staticClass:"col locked-toolbar"},[_c('ul',[_c('li',[_c('b-button-group',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}},{name:"disable-mobile-tooltip",rawName:"v-disable-mobile-tooltip"}],attrs:{"placement":"bottom","title":"Undo (⌘+z)","variant":"clear","disabled":!_vm.canvasState.canUndo},on:{"click":function($event){return _vm.emit('undo')}}},[_c('i',{staticClass:"fa fa-undo",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("Undo")])]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}},{name:"disable-mobile-tooltip",rawName:"v-disable-mobile-tooltip"}],attrs:{"placement":"bottom","title":"Redo (⌘+shift+z)","variant":"clear","disabled":!_vm.canvasState.canRedo},on:{"click":function($event){return _vm.emit('redo')}}},[_c('i',{staticClass:"fa fa-redo",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("Redo")])])],1)],1),_vm._v(" "),_c('li',[_c('b-button-group',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}},{name:"disable-mobile-tooltip",rawName:"v-disable-mobile-tooltip"}],attrs:{"placement":"bottom","title":"Previous field","variant":"clear"},on:{"click":function($event){return _vm.emit('prevObject')}}},[_c('i',{staticClass:"fas fa-arrow-left",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("Prev Field")])]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}},{name:"disable-mobile-tooltip",rawName:"v-disable-mobile-tooltip"}],attrs:{"placement":"bottom","title":"Next field","variant":"clear"},on:{"click":function($event){return _vm.emit('nextObject')}}},[_c('i',{staticClass:"fas fa-arrow-right",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("Next Field")])])],1)],1),_vm._v(" "),(_vm.canvasState.fieldDeletable)?_c('li',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}},{name:"disable-mobile-tooltip",rawName:"v-disable-mobile-tooltip"}],attrs:{"variant":"clear","title":"Delete Object"},on:{"click":function($event){return _vm.emit('deleteField')}}},[_c('i',{staticClass:"fa fa-trash",attrs:{"aria-hidden":"true"}})])],1):_vm._e()])]):_c('div',{staticClass:"col unlocked-toolbar"},[_c('ul',[_c('li',[_c('b-button-group',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}},{name:"disable-mobile-tooltip",rawName:"v-disable-mobile-tooltip"}],attrs:{"placement":"bottom","title":"Undo (⌘+z)","variant":"clear","disabled":!_vm.canvasState.canUndo},on:{"click":function($event){return _vm.emit('undo')}}},[_c('i',{staticClass:"fa fa-undo",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}},{name:"disable-mobile-tooltip",rawName:"v-disable-mobile-tooltip"}],attrs:{"placement":"bottom","title":"Redo (⌘+shift+z)","variant":"clear","disabled":!_vm.canvasState.canRedo},on:{"click":function($event){return _vm.emit('redo')}}},[_c('i',{staticClass:"fa fa-redo",attrs:{"aria-hidden":"true"}})])],1)],1),_vm._v(" "),_c('li',[_c('b-button-group',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}},{name:"disable-mobile-tooltip",rawName:"v-disable-mobile-tooltip"}],attrs:{"placement":"bottom","title":"Duplicate","variant":"clear"},on:{"click":function($event){return _vm.emit('duplicateFieldOrAddText')}}},[_c('i',{staticClass:"fa fa-clone",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}},{name:"disable-mobile-tooltip",rawName:"v-disable-mobile-tooltip"}],attrs:{"variant":"clear","title":"Delete Object"},on:{"click":function($event){return _vm.emit('deleteField')}}},[_c('i',{staticClass:"fa fa-trash",attrs:{"aria-hidden":"true"}})])],1)],1),_vm._v(" "),_c('li',[_c('EditModeToggle',{on:{"onTextMode":function($event){return _vm.emit('onTextMode')},"onMoveMode":function($event){return _vm.emit('onMoveMode')}}})],1),_vm._v(" "),(_vm.flags.toggleCropBleed)?_c('li',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}},{name:"disable-mobile-tooltip",rawName:"v-disable-mobile-tooltip"}],attrs:{"placement":"bottom","title":"Toggle Display Bleed","variant":"clear"},on:{"click":function($event){return _vm.emit('toggleDisplayBleed')}}},[_c('i',{staticClass:"fa fa-crop",attrs:{"aria-hidden":"true"}})])],1):_vm._e(),_vm._v(" "),_c('li',[_c('ul',{staticClass:"list-group"},[_c('li',{staticClass:"item fonts"},[_c('b-dropdown',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}},{name:"disable-mobile-tooltip",rawName:"v-disable-mobile-tooltip"}],staticClass:"m-md-2",style:({fontFamily:_vm.canvasState.fontName}),attrs:{"variant":"clear","text":_vm.canvasState.fontName,"id":"font-dropdown","title":"Click on active text to view font family"}},_vm._l((_vm.canvasState.fonts),function(font){return _c('b-dropdown-item',{key:font,style:({fontFamily:font}),on:{"click":function($event){return _vm.onChangeFontName(font)}}},[_vm._v(_vm._s(font))])}),1)],1),_vm._v(" "),(_vm.flags.debugTools && _vm.dlFontUrl)?_c('li',{staticClass:"item debug-item"},[_c('a',{attrs:{"href":_vm.dlFontUrl}},[_c('i',{staticClass:"fas fa-download"})])]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"item"},[_c('div',{staticClass:"font-size-wrapper dropdown-menu-right"},[_c('input',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}},{name:"disable-mobile-tooltip",rawName:"v-disable-mobile-tooltip"}],attrs:{"type":"text","size":"6","name":"currentFontSize","title":"Click on active text to view font size"},domProps:{"value":_vm.canvasState.fontSize},on:{"change":_vm.onChangeFontSize}})]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('li',{staticClass:"item"},[_c('b-dropdown',{attrs:{"variant":"clear","size":"lg"}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"current color-square",style:(("background-color: " + (_vm.canvasState.color) + ";")),attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('b-dropdown-header',[_vm._v("Document Colors")]),_vm._v(" "),_vm._l((_vm.canvasState.colors),function(color){return _c('b-dropdown-item',{key:color,on:{"click":function($event){return _vm.onChangeColor(color)}}},[_c('button',{staticClass:"dropdown-item color-square",style:(("background-color: " + color + ";"))})])})],2)],1),_vm._v(" "),(_vm.flags.debugTools)?_c('li',{staticClass:"item debug-item",staticStyle:{"white-space":"nowrap"}},[_vm._v("\n                pos: "),_c('input',{attrs:{"type":"text","size":"6","name":"positionX"},domProps:{"value":_vm.posX},on:{"change":_vm.onChangePositionX}}),_vm._v(" "),_c('input',{attrs:{"type":"text","size":"6","name":"positionY"},domProps:{"value":_vm.posY},on:{"change":_vm.onChangePositionY}})]):_vm._e(),_vm._v(" "),(_vm.isTemplate)?_c('li',[_c('b-form-radio-group',{attrs:{"buttons":"","button-variant":"clear","checked":_vm.canvasState.originX,"disabled":!_vm.canvasState.originX},on:{"input":_vm.onChangeAlignment}},[_c('b-form-radio',{attrs:{"value":"left"}},[_c('i',{staticClass:"fas fa-align-left"})]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"center"}},[_c('i',{staticClass:"fas fa-align-center"})]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"right"}},[_c('i',{staticClass:"fas fa-align-right"})])],1)],1):_vm._e(),_vm._v(" "),_c('li',[(_vm.flags.enableSuperscript)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}},{name:"disable-mobile-tooltip",rawName:"v-disable-mobile-tooltip"}],attrs:{"placement":"bottom","title":"Superscript","variant":"clear"},on:{"click":function($event){return _vm.emit('setSuperscript')}}},[_c('i',{staticClass:"fa fa-superscript",attrs:{"aria-hidden":"true"}})]):_vm._e()],1)])]),_vm._v(" "),_c('li',[_c('b-button-group',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}},{name:"disable-mobile-tooltip",rawName:"v-disable-mobile-tooltip"}],attrs:{"placement":"bottom","title":"Upload Image","variant":"clear"},on:{"click":function($event){return _vm.emit('showUploadDialog')}}},[_c('i',{staticClass:"fa fa-upload",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),(_vm.isTemplate)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}},{name:"disable-mobile-tooltip",rawName:"v-disable-mobile-tooltip"}],attrs:{"placement":"bottom","title":"Make Image Placeholder","variant":"clear"},on:{"click":function($event){return _vm.emit('makePlaceholder')}}},[_c('i',{staticClass:"fa fa-image",attrs:{"aria-hidden":"true"}})]):_vm._e()],1)],1),_vm._v(" "),_c('li',[_c('b-button-group',[(_vm.isTemplate && _vm.flags.enableFieldOptions)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}},{name:"disable-mobile-tooltip",rawName:"v-disable-mobile-tooltip"}],class:{active: _vm.showingFieldOptions},attrs:{"placement":"bottom","title":"Field options","variant":"clear"},on:{"click":function($event){return _vm.emit('toggleFieldOptions')}}},[_c('i',{staticClass:"fa fa-code",attrs:{"aria-hidden":"true"}})]):_vm._e()],1)],1),_vm._v(" "),_c('li',[_c('b-button-group',[(_vm.isTemplate && _vm.flags.enableLockTemplate)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}},{name:"disable-mobile-tooltip",rawName:"v-disable-mobile-tooltip"}],class:{active: _vm.designLocked},attrs:{"placement":"bottom","title":"Lock design","variant":"clear"},on:{"click":_vm.toggleLockDesign}},[_c('i',{staticClass:"fa fa-lock",attrs:{"aria-hidden":"true"}})]):_vm._e()],1)],1)])]),_vm._v(" "),_c('DebugTools',{staticStyle:{"float":"right"}})],1):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-menu dropdown-menu-right dropdown-menu-font-sizes",attrs:{"aria-labelledby":"fontSize"}},[_c('button')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b0fZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return { gapiReady: null, gauth: null };
  },
  mounted: function mounted() {
    var _this = this;

    this.gapiReady = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
      window.initGoogle = function () {
        gapi.load('auth2', function () {
          gapi.auth2.init(_this.authConfig);
          _this.gauth = gapi.auth2.getAuthInstance();
          resolve();
        });
      };
    });
    this.addScript('https://apis.google.com/js/api:client.js?onload=initGoogle');
  },

  computed: {
    authConfig: function authConfig() {
      return { client_id: "255072882725-39ksd3fajhgu2nea796vp8nm6qb4ket2.apps.googleusercontent.com" };
    }
  },
  methods: {
    onClick: function onClick() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var info;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('onClick!');
                _context.next = 3;
                return _this2.gapiReady;

              case 3:
                console.log('onClick 2');
                _context.next = 6;
                return _this2.gauth.signIn();

              case 6:
                info = _context.sent;

                console.log('gauth', info);
                _this2.$emit('login', _this2.extractUserInfo(info));

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    extractUserInfo: function extractUserInfo(guser) {
      var profile = guser.getBasicProfile();
      return {
        auth: guser.getAuthResponse(true),
        id: profile.getId(),
        name: profile.getName(),
        givenName: profile.getGivenName(),
        familyName: profile.getFamilyName(),
        imageUrl: profile.getImageUrl(),
        email: profile.getEmail()
      };
    },
    addScript: function addScript(src) {
      var node = document.createElement('script');
      node.setAttribute('src', src);
      node.setAttribute('async', '');
      document.head.appendChild(node);
    }
  }
});

/***/ }),

/***/ "b3El":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TemplateChooser_vue__ = __webpack_require__("1cYv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bdeb90a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TemplateChooser_vue__ = __webpack_require__("RKCl");
function injectStyle (ssrContext) {
  __webpack_require__("sTsO")
  __webpack_require__("81Jc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4bdeb90a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TemplateChooser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bdeb90a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TemplateChooser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "bMIv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      name: "",
      username: "",
      password: ""
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["loginBusy", "loginError", "loginErrorText"]), {
    formValid: function formValid() {
      return this.name && this.username && this.password;
    },
    formEmpty: function formEmpty() {
      return !(this.name || this.username || this.password);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["signUp"]), {
    submit: function submit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var name, username, password;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('submit');
                name = _this.name, username = _this.username, password = _this.password;
                _context.next = 4;
                return _this.signUp({ username: username, password: password, confirm_password: password, name: name });

              case 4:
                if (!_this.loginError) _this.$router.push("/welcome");

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  })
});

/***/ }),

/***/ "bXtv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_flags_Flags_vue__ = __webpack_require__("Zqsl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['wideHeader', 'heroDark'],
  components: { Flags: __WEBPACK_IMPORTED_MODULE_2__pages_flags_Flags_vue__["a" /* default */] },
  data: function data() {
    return { scrolled: false };
  },
  mounted: function mounted() {
    var _this = this;

    this.getNumBasketLines();
    if (window.IntersectionObserver) {
      // Watch for any scroll
      var options = {
        rootMargin: '0px',
        threshold: 1.0
      };

      var callback = function callback(events, observer) {
        _this.scrolled = events[0].intersectionRatio < 1;
      };
      var observer = new IntersectionObserver(callback, options);
      observer.observe(this.$el);
    } else {
      // Watch for any scroll, browsers without new API
      var scrollingElement = document.getElementById('app');
      this.fn = __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(function () {
        return _this.scrolled = scrollingElement.scrollTop > 0;
      }, 100, { leading: true });
      scrollingElement.addEventListener('scroll', this.fn, { passive: true });
      this.unlisten = function () {
        return scrollingElement.removeEventListener('scroll', _this.fn, { passive: true });
      };
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.unlisten) this.unlisten();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['loggedIn', 'user', 'team', 'numBasketLines', 'isAdmin', 'isStaff', 'userTeams']), {
    transparent: function transparent() {
      return !this.scrolled;
    },
    initials: function initials() {
      // Ensure we don't crash without a user. This shouldnt happen though.
      if (!this.user) return '';
      return this.user.first_name.substring(0, 1) + this.user.last_name.substring(0, 1);
    },
    userFullName: function userFullName() {
      var _user = this.user,
          first_name = _user.first_name,
          last_name = _user.last_name;

      return first_name + ' ' + last_name;
    },
    username: function username() {
      return this.user.username;
    },
    teamName: function teamName() {
      return this.team.name;
    },
    showLogin: function showLogin() {
      return !this.loggedIn;
    },
    showLoggedIn: function showLoggedIn() {
      return this.loggedIn;
    },
    numCartItems: function numCartItems() {
      // Return an empty string instead of 0
      return this.numBasketLines || '';
    },
    teamsToSwitch: function teamsToSwitch() {
      var _this2 = this;

      // Exclude current team because a user is already in it.
      return this.userTeams.filter(function (t) {
        return t.id !== _this2.team.id;
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['logout', 'getNumBasketLines', 'enterTeam']), {
    startLongpress: function startLongpress() {
      // Fired on mousedown
      if (this.longpressTimer) return;
      this.longpressTimer = setTimeout(this.onLongpress, 1000);
    },
    stopLongpress: function stopLongpress() {
      // mouseup, before timer goes off => cancel event
      if (!this.longpressTimer) return;
      clearTimeout(this.longpressTimer);
      this.longpressTimer = null;
    },
    onLongpress: function onLongpress() {
      this.$refs.flagsModal.show();
      this.longpressTimer = null;
    },
    onClickLogout: function onClickLogout() {
      this.logout();
      this.$router.push('/signin');
    }
  })
});

/***/ }),

/***/ "bYCz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageFormGroup_vue__ = __webpack_require__("5lwu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2ad2dd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageFormGroup_vue__ = __webpack_require__("dCkL");
function injectStyle (ssrContext) {
  __webpack_require__("Fs9o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageFormGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2ad2dd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageFormGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "bmT6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"x-scroll"},[_c('ul',{staticClass:"dots"},_vm._l((_vm.steps),function(title,index){return _c('li',{key:index,class:{fulfilled: _vm.step-1 > index, current: _vm.step-1 == index}},[_vm._v(_vm._s(title))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bnxi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Header')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bpDn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-menu left-nav"},[_c('b-list-group',{staticClass:"d-none d-sm-block"},_vm._l((_vm.nav),function(item){return _c('b-list-group-item',{key:item.title},[_c('router-link',{class:item.linkClass,attrs:{"to":item.to}},[_c('div',{staticClass:"icon-container"},[(item.icon)?_c('i',{class:item.icon}):_vm._e(),_vm._v(" "),(item.src)?_c('img',{attrs:{"src":item.src}}):_vm._e(),_vm._v(" "),(item.symbol)?_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":("/static/images/dashboard/sprites.svg#" + (item.symbol))}})]):_vm._e()]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.title))])])],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bqQl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bqkq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c2k6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cNJ+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cOIa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debouncePromise;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

function debouncePromise(fn, delay) {
  var timer = void 0,
      p = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
  return inner;

  function inner() {
    var _this = this;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timer);
    timer = setTimeout(function () {
      return p.then(function () {
        timer = setTimeout(call, delay, _this, args);
      });
    }, 0);
  }
  function call(innerThis, args) {
    p = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(fn.apply(innerThis, args));
  }
}

/***/ }),

/***/ "cUJk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = anyBadBleed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);


function anyBadBleed(bleedPoints) {
  var _ref;

  var outerPoints = (_ref = []).concat.apply(_ref, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(bleedPoints.map(function (bleedPoint) {
    return bleedPoint.o;
  })));
  return _.some(outerPoints, function (point) {
    return point.badBleed;
  });
}

/***/ }),

/***/ "cVDX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimplePagination_vue__ = __webpack_require__("0VKA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20b1b6df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimplePagination_vue__ = __webpack_require__("chac");
function injectStyle (ssrContext) {
  __webpack_require__("wLA6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimplePagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20b1b6df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimplePagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "chac":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.pages < _vm.maxPages)?_c('div',[_c('button',{class:_vm.vspbutton + (_vm.vspbuttonfast !== '' ? ' ' + _vm.vspbuttonfast : ''),on:{"click":function($event){return _vm.handlePageChange(1)}}},[_vm._v(" << ")]),_vm._v(" "),_vm._l((_vm.pages),function(item){return _c('button',{key:item,class:_vm.vspbutton + (item == _vm.currPage ? ' ' + _vm.vspbuttonselected : ''),on:{"click":function($event){return _vm.handlePageChange(item)}}},[_vm._v(_vm._s(item))])}),_vm._v(" "),_c('button',{class:_vm.vspbutton + (_vm.vspbuttonfast !== '' ? ' ' + _vm.vspbuttonfast : ''),on:{"click":function($event){return _vm.handlePageChange(_vm.pages)}}},[_vm._v(">>")])],2):_c('div',[_c('button',{class:_vm.vspbutton + (_vm.vspbuttonfast !== '' ? ' ' + _vm.vspbuttonfast : ''),on:{"click":function($event){return _vm.handlePageChange(1)}}},[_vm._v(" << ")]),_vm._v(" "),_vm._l((_vm.leftPages),function(item){return _c('button',{key:item,class:_vm.vspbutton + (item == _vm.currPage ? ' ' + _vm.vspbuttonselected : ''),on:{"click":function($event){return _vm.handlePageChange(item)}}},[_vm._v(_vm._s(item))])}),_vm._v(" "),((_vm.pages - 4) - _vm.currPage > 3)?_c('span',[_vm._v("...")]):_vm._e(),_vm._v(" "),_vm._l(([_vm.pages - 4, _vm.pages - 3, _vm.pages - 2, _vm.pages - 1, _vm.pages]),function(item){return _c('button',{key:item,class:_vm.vspbutton + (item == _vm.currPage ? ' ' + _vm.vspbuttonselected : ''),on:{"click":function($event){return _vm.handlePageChange(item)}}},[_vm._v(_vm._s(item))])}),_vm._v(" "),_c('button',{class:_vm.vspbutton + (_vm.vspbuttonfast !== '' ? ' ' + _vm.vspbuttonfast : ''),on:{"click":function($event){return _vm.handlePageChange(_vm.pages)}}},[_vm._v(">>")])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ckjT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outside-container"},[_c('div',{staticClass:"editor-wrapper"},[_c('div',{staticClass:"editor page-canvas"},[(_vm.currentBus)?_c('ToolBar',{attrs:{"bus":_vm.currentBus,"canvas-state":_vm.currentCanvasState,"designLocked":_vm.designLocked}}):_vm._e(),_vm._v(" "),_c('EditorFonts',{attrs:{"design":_vm.design},on:{"fonts-loaded":_vm.onFontsLoaded,"font-load-error":_vm.onFontLoadError}}),_vm._v(" "),_c('ImageUploadDropzone',{attrs:{"bus":_vm.currentBus,"disabled":_vm.designLocked},on:{"drop-fail":_vm.onDropFail}}),_vm._v(" "),_c('div',{staticClass:"main-area"},[_c('b-alert',{staticClass:"editor-alert",attrs:{"dismissible":"","fade":"","variant":"success","show":_vm.editorMessage ? 5 : 0},on:{"dismissed":_vm.clearMessage}},[_vm._v(_vm._s(_vm.editorMessage)+"\n        ")]),_vm._v(" "),_c('b-alert',{staticClass:"editor-alert",attrs:{"dismissible":"","fade":"","variant":"warning","show":_vm.missingFonts.length > 0}},[_vm._v("Oops! We have more than 70,000 licensed fonts, but we're missing these:"),_c('br'),_vm._v(_vm._s(_vm.missingFonts.join(', '))+"\n        ")]),_vm._v(" "),(_vm.currentBus)?_c('FieldOptionsArea',{attrs:{"bus":_vm.currentBus,"canvas-state":_vm.currentCanvasState}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"canvas-area"},[_c('EditorCanvas',{class:{hide: _vm.pageNum != 0},attrs:{"pageNum":"0","bus":_vm.busses[0],"fontsLoaded":_vm.fontsLoaded,"designLocked":_vm.designLocked,"nofill":_vm.nofill},on:{"input":_vm.onCanvasState}}),_vm._v(" "),_c('EditorCanvas',{class:{hide: _vm.pageNum != 1},attrs:{"pageNum":"1","bus":_vm.busses[1],"fontsLoaded":_vm.fontsLoaded,"designLocked":_vm.designLocked,"nofill":_vm.nofill},on:{"input":_vm.onCanvasState}}),_vm._v(" "),(_vm.fontsLoaded && _vm.showThumbnails)?_c('div',{staticClass:"thumbnail-wrapper"},[_c('EditorThumbnail',{staticClass:"thumbnail",class:{active: _vm.pageNum == 0},attrs:{"pageNum":"0"}}),_vm._v(" "),(_vm.designPageCount > 1)?_c('EditorThumbnail',{staticClass:"thumbnail",class:{active: _vm.pageNum == 1},attrs:{"pageNum":"1"}}):_c('EditorBackPlaceholder',{attrs:{"bus":_vm.currentBus,"locked":_vm.lockButtons}})],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('SideMenu',{attrs:{"bus":_vm.currentBus,"actionParams":_vm.actionParams,"canvas-state":_vm.currentCanvasState},on:{"action":_vm.onAction}})],1),_vm._v(" "),_c('FixedMenu',{attrs:{"actionParams":_vm.actionParams},on:{"action":_vm.onAction}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cpJX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"billing-shipping-wrapper"},[_c('h3',{staticClass:"h3-secondary billing-shipping-header"},[_vm._v(_vm._s(_vm.infoType)+" Details")]),_vm._v(" "),_c('div',{staticClass:"billing-shipping-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6 col-12"},[_c('div',{staticClass:"required"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.first_name),expression:"form.first_name"}],staticClass:"form-control",attrs:{"type":"text","id":_vm.prefix+'-first_name',"required":""},domProps:{"value":(_vm.form.first_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "first_name", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.prefix + '-first_name'}},[_vm._v("First Name")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6 col-12"},[_c('div',{staticClass:"required"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.last_name),expression:"form.last_name"}],staticClass:"form-control",attrs:{"type":"text","id":_vm.prefix+'-last_name',"required":""},domProps:{"value":(_vm.form.last_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "last_name", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.prefix+'-last_name'}},[_vm._v("Last Name")])])])]),_vm._v(" "),(_vm.prefix === 'shipping')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group  col-md-6 col-12"},[_c('div',{staticClass:"required"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email_address),expression:"form.email_address"},{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"form-control",attrs:{"type":"email","id":_vm.prefix+'-email_address',"required":""},domProps:{"value":(_vm.form.email_address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email_address", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.prefix+'-email_address'}},[_vm._v("Email Address")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6 col-12"},[_c('div',{staticClass:"required"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.phone_number),expression:"form.phone_number"},{name:"validate",rawName:"v-validate",value:('required|numeric|digits:10'),expression:"'required|numeric|digits:10'"}],staticClass:"form-control",attrs:{"name":_vm.prefix+'-phone_number',"id":_vm.prefix+'-phone_number',"required":""},domProps:{"value":(_vm.form.phone_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "phone_number", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.prefix+'-phone_number'}},[_vm._v("Phone Number")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.prefix+'-phone_number')),expression:"errors.has(prefix+'-phone_number')"}]},[_vm._v("Enter a ten digit phone number without dashes or spaces.")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"required"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.country),expression:"form.country"}],staticClass:"form-control",attrs:{"id":_vm.prefix+'-country',"autocomplete":_vm.prefix+' country-name',"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Select a Country...")]),_vm._v(" "),(_vm.flags.internationalShipping && _vm.countries.length)?_vm._l((_vm.countries),function(country){return _c('option',{domProps:{"value":country.iso_3166_1_a2}},[_vm._v(_vm._s(country.printable_name))])}):_c('option',{domProps:{"value":_vm.USA.code}},[_vm._v(_vm._s(_vm.USA.name))])],2)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6 col-12"},[_c('div',{staticClass:"required"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.line1),expression:"form.line1"}],staticClass:"form-control",attrs:{"type":"text","id":_vm.prefix+'-line1',"required":""},domProps:{"value":(_vm.form.line1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "line1", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.prefix+'-line1'}},[_vm._v("Address")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6 col-12"},[_c('div',{staticClass:"not-required"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.line2),expression:"form.line2"}],staticClass:"form-control",attrs:{"type":"text","id":_vm.prefix+'-line2',"required":""},domProps:{"value":(_vm.form.line2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "line2", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.prefix+'-line2'}},[_vm._v("Address 2")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"required"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.postcode),expression:"form.postcode"}],staticClass:"form-control",attrs:{"type":"text","id":_vm.prefix+'-postcode',"required":""},domProps:{"value":(_vm.form.postcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "postcode", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.prefix+'-postcode'}},[(_vm.isUSA)?_c('span',[_vm._v("ZIP Code")]):_c('span',[_vm._v("Postal Code")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6 col-12"},[_c('div',{staticClass:"required"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.city),expression:"form.city"}],staticClass:"form-control",attrs:{"type":"text","id":_vm.prefix+'-city',"required":""},domProps:{"value":(_vm.form.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "city", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.prefix+'-city'}},[_vm._v("City")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6 col-12"},[_c('div',{class:{'required': _vm.isUSA, 'not-required': !_vm.isUSA }},[(_vm.isUSA)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.state),expression:"form.state"}],staticClass:"form-control",attrs:{"id":_vm.prefix+'-state',"autocomplete":_vm.prefix+'-state',"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Select a State...")]),_vm._v(" "),_vm._l((_vm.states),function(state,st){return _c('option',{key:st,domProps:{"value":st}},[_vm._v("\n             "+_vm._s(state)+"\n           ")])})],2):_vm._e(),_vm._v(" "),(!_vm.isUSA)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.state),expression:"form.state"}],staticClass:"form-control",attrs:{"type":"text","id":_vm.prefix+'-state',"required":""},domProps:{"value":(_vm.form.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "state", $event.target.value)}}}):_vm._e(),_vm._v(" "),(!_vm.isUSA)?_c('label',{attrs:{"for":_vm.prefix+'-state'}},[_vm._v("Province")]):_vm._e()])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cqAz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "czP3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d3vr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dCkL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{staticClass:"notification-form-group",attrs:{"invalid-feedback":_vm.message,"state":_vm.state},nativeOn:{"notification":function($event){return _vm.messageReceived($event)},"change":function($event){return _vm.clearMessage($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dH6r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewAddresses_vue__ = __webpack_require__("eqyc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33ed431a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewAddresses_vue__ = __webpack_require__("1OZg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewAddresses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33ed431a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewAddresses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dQqr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"feature-heading"},[_c('div',{staticClass:"copy-container"},[_c('div',{staticClass:"copy"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',[_vm._t("default",[_vm._v("Content goes here!")])],2)])])]),_vm._v(" "),_c('div',{staticClass:"parent"},[_c('ul',{staticClass:"list-1"},_vm._l((_vm.items),function(ref){
var title = ref.title;
var description = ref.description;
return _c('li',{staticClass:"item-container-1"},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":"/static/images/homepage/quality.svg","alt":"icon"}})]),_vm._v(" "),_c('div',{staticClass:"list-copy-container-1"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(title))]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v(_vm._s(description))])])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dU0Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dVfd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dXr5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dmV9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopBar_vue__ = __webpack_require__("49VO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59e17e1a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopBar_vue__ = __webpack_require__("5Vav");
function injectStyle (ssrContext) {
  __webpack_require__("Wg25")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59e17e1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59e17e1a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dpH0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_bubble_wrapAction__ = __webpack_require__("514v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MemberRow__ = __webpack_require__("EiWH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TeamMembersImport_vue__ = __webpack_require__("7Jaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TeamSharePanel_vue__ = __webpack_require__("xpjA");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { MemberRow: __WEBPACK_IMPORTED_MODULE_5__MemberRow__["a" /* default */], TeamMembersImport: __WEBPACK_IMPORTED_MODULE_6__TeamMembersImport_vue__["a" /* default */], TeamSharePanel: __WEBPACK_IMPORTED_MODULE_7__TeamSharePanel_vue__["a" /* default */] },
  data: function data() {
    return {
      inviteEmail: '',
      panel: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["members", "flags", "user", "isAdmin", "isTeamBusy", "team"]), {
    showInviteAdmin: function showInviteAdmin() {
      return this.isAdmin;
    },
    showInviteUser: function showInviteUser() {
      // We may decide to limit this to Admins in future.
      return true;
    }
  }),
  mounted: function mounted() {
    this.loadTeamMembers();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["loadTeamMembers", "reloadTeamMembers"]), {
    inviteMember: Object(__WEBPACK_IMPORTED_MODULE_4__lib_bubble_wrapAction__["a" /* default */])({
      action: "inviteMember",
      arg: { data: "inviteEmail" },
      success: "Message has been sent!"
    }),
    inviteAdmin: Object(__WEBPACK_IMPORTED_MODULE_4__lib_bubble_wrapAction__["a" /* default */])({
      action: "inviteAdmin",
      arg: { data: "inviteEmail" },
      success: "Message has been sent!"
    }),
    onClickInviteUser: function onClickInviteUser(event) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.inviteMember(event);

              case 2:
                _this.reloadTeamMembers();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    onClickInviteAdmin: function onClickInviteAdmin(event) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.inviteAdmin(event);

              case 2:
                _this2.reloadTeamMembers();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  })
});

/***/ }),

/***/ "dyV2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dzLO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e40e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardBase_vue__ = __webpack_require__("Jg45");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b78726ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardBase_vue__ = __webpack_require__("Rv1s");
function injectStyle (ssrContext) {
  __webpack_require__("ZBhT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b78726ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardBase_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b78726ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardBase_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e44L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e64a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Upload_vue__ = __webpack_require__("ElTA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e131fece_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Upload_vue__ = __webpack_require__("i57o");
function injectStyle (ssrContext) {
  __webpack_require__("umbr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e131fece"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Upload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e131fece_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Upload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e71P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['basketLines', 'taxAmount', 'shipAmount', 'subtotalPrice', 'totalPrice', 'isShippingCountryUSA'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['loadBasket'])),
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.loadBasket();

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "eFRp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-team"},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eRel":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage-hero-layout"},[_c('div',{staticClass:"hero-container",style:(_vm.heroBG)},[_c('HomepageLayout',[_vm._t("default")],2)],1),_vm._v(" "),_c('div',{staticClass:"below-hero"},[_vm._t("below-hero-content")],2),_vm._v(" "),(_vm.footer !== 'no')?_c('BottomNavigation'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eZpL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__("u5z7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4f703d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__("0R5z");
function injectStyle (ssrContext) {
  __webpack_require__("x1TZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b4f703d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4f703d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "egdY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ehbu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['isAdmin', 'approvalSettings']), {
    orderReviewMessage: function orderReviewMessage() {
      var approvalMode = this.approvalSettings.approvalMode;

      if (this.value) {
        return 'Review skipped for this order';
      } else if (approvalMode === "payment") {
        return 'Billing information will be entered by the admin';
      } else if (approvalMode === "review") {
        return 'Order will be reviewed by the admin';
      } else {
        return '';
      }
    },
    allowSkipApproval: function allowSkipApproval() {
      return this.approvalSettings.approvalMode && this.isAdmin;
    }
  }),
  methods: {
    skipReview: function skipReview() {
      this.$emit('input', true);
    },
    dontSkipReview: function dontSkipReview() {
      this.$emit('input', false);
    }
  }
});

/***/ }),

/***/ "ejR0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploaderBox_vue__ = __webpack_require__("yG03");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cfe79e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploaderBox_vue__ = __webpack_require__("lwls");
function injectStyle (ssrContext) {
  __webpack_require__("p0xR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3cfe79e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploaderBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cfe79e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploaderBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ejcI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Toggle',_vm._g({attrs:{"value":_vm.value,"falseIcon":"unlock","trueIcon":"lock"}},_vm.$listeners),[_c('template',{slot:"trueDescription"},[_vm._t("restrict",[_vm._v("Restrict "+_vm._s(_vm.label))])],2),_vm._v(" "),_c('template',{slot:"falseDescription"},[_vm._t("allow",[_vm._v("Allow "+_vm._s(_vm.label))])],2)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "elvH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomepageWideLayout',{attrs:{"heroDark":""}},[_c('section',[_c('SecondaryHeader',[_c('h2',[_vm._v("Pricing")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("\n        Get high-quality business cards, free second-side printing, and free delivery.\n        The Brandly app is also free so you only pay for the cards you order.\n      ")])]),_vm._v(" "),_c('b-container',{attrs:{"id":"pricing-layer"}},[_c('div',{staticClass:"pricing"},[_c('div',{staticClass:"inside-wrapper"},[_c('div',{staticClass:"copy-container"},[_c('h2',[_vm._v("Paper Options")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("\n            We offer papers in a wide variety of coatings, thicknesses, and textures to best fit your brand and budget.\n          ")])])])]),_vm._v(" "),_c('PricingGrid',{attrs:{"selected":"Standard"}})],1),_vm._v(" "),_c('Portal'),_vm._v(" "),_c('GetQuote'),_vm._v(" "),_c('Demo')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "en40":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eoa9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['sub', 'buttons', // 'none', 'cancel' or 'both'
  'saving'],
  methods: {
    clickCancel: function clickCancel() {
      // Provide a fake event that can be prevented using Vue's @cancel.prevent syntax
      var fakeEvent = {
        doDefault: true,
        preventDefault: function preventDefault() {
          this.doDefault = false;
        }
      };
      this.$emit('cancel', fakeEvent);
      if (fakeEvent.doDefault) this.$router.push('/dashboard/settings');
    }
  },
  computed: {
    btn: function btn() {
      // defaulted button value
      return this.buttons || (this.sub ? 'both' : 'none');
    },
    showButtons: function showButtons() {
      return this.btn !== 'none';
    },
    showSave: function showSave() {
      return this.btn === 'both' || this.btn === 'save';
    },
    showCancel: function showCancel() {
      return this.btn === 'both' || this.btn === 'cancel';
    }
  }
});

/***/ }),

/***/ "eq6f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a8170e5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingPagePortal_vue__ = __webpack_require__("o+FB");
function injectStyle (ssrContext) {
  __webpack_require__("9lrZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a8170e5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a8170e5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingPagePortal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "eqyc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["combinedAddresses"]),
  methods: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])(["loadTeamAddresses", "loadUserAddresses"]),
  mounted: function mounted() {
    this.loadUserAddresses();
    this.loadTeamAddresses();
  }
});

/***/ }),

/***/ "f6ai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-card"},[_c('h2',[_vm._v("File Formatting")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"upload_icons"},[_c('p',[_c('img',{staticClass:"svg",attrs:{"src":"/static/images/sidemenu/dark_pdf.svg"}}),_vm._v("PDF format only")]),_vm._v(" "),_c('p',[_c('img',{staticClass:"svg",attrs:{"src":"/static/images/sidemenu/dark_thumb.svg"}}),_vm._v("Max filesize: 5mb")]),_vm._v(" "),_c('p',[_c('img',{staticClass:"svg",attrs:{"src":"/static/images/sidemenu/dark_cards.svg"}}),_vm._v(" 1 or 2 sided card")]),_vm._v(" "),_c('p',[_c('img',{staticClass:"svg",attrs:{"src":"/static/images/sidemenu/dark_landscape.svg"}}),_vm._v(" Landscape or Portrait")])])]),_vm._v(" "),_c('div',{staticClass:"action-card"},[_c('h2',[_vm._v("Need Help?")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Can’t get everything to look as you want?")]),_vm._v(" "),_c('ul',{staticClass:"help-links"},[_c('li',[_vm._v("\n        Read "),_c('a',{attrs:{"href":"/support/artwork","target":"_blank"}},[_vm._v("Artwork Prep FAQs")])]),_vm._v(" "),_c('li',[_vm._v("\n        Read "),_c('a',{attrs:{"href":"/support/fileupload","target":"_blank"}},[_vm._v("Upload FAQs")])]),_vm._v(" "),_c('li',[_vm._v("Feel free to\n        "),_c('a',{attrs:{"href":"mailto:support@brandly.com","target":"_blank"}},[_vm._v("Email us")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fI1k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-signin",attrs:{"id":"google"},on:{"click":_vm.onClick}},[_c('img',{staticClass:"social-logo",attrs:{"src":"/static/images/signin/google/btn_google_dark_normal_ios.svg"}}),_vm._v(" "),_c('div',{staticClass:"social-text",attrs:{"id":"google"}},[_vm._t("default",[_vm._v("Sign in with Google")])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fS8H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Join_vue__ = __webpack_require__("lb5r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c31a0f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Join_vue__ = __webpack_require__("oKOy");
function injectStyle (ssrContext) {
  __webpack_require__("Pysz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c31a0f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Join_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c31a0f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Join_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "fWrj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_orderStatus__ = __webpack_require__("FPeH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_mixins__ = __webpack_require__("OeeG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrderDetailCommon__ = __webpack_require__("nRpE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OrderFilter__ = __webpack_require__("8fPy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AdminOrderFilter__ = __webpack_require__("6avI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_SearchForm__ = __webpack_require__("FY8P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_debounce__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    OrderDetailCommon: __WEBPACK_IMPORTED_MODULE_4__OrderDetailCommon__["a" /* default */],
    OrderFilter: __WEBPACK_IMPORTED_MODULE_5__OrderFilter__["a" /* default */],
    AdminOrderFilter: __WEBPACK_IMPORTED_MODULE_6__AdminOrderFilter__["a" /* default */],
    SearchForm: __WEBPACK_IMPORTED_MODULE_7__components_shared_SearchForm__["default"]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__services_mixins__["b" /* listWithSearchAndPaginationMixin */]],
  data: function data() {
    return {
      orderList: [],
      orderListFiltered: [],
      statusSelected: this.query.statusSelected || __WEBPACK_IMPORTED_MODULE_2__lib_orderStatus__["d" /* READY_FOR_PRODUCTION */],
      filterInitialStatus: this.query.statusSelected || __WEBPACK_IMPORTED_MODULE_2__lib_orderStatus__["d" /* READY_FOR_PRODUCTION */],

      queryStringKeysToCheck: ['search', 'pageNumber', 'itemsOnPage', 'statusSelected'],

      useMountedFromMixin: false,
      functionToCallOnChange: this.loadOrdersPaginated,
      listPathName: 'order-list'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['flags', 'user', 'recentOrders', 'recentOrdersBusy', 'pageNumberOrders', 'totalOrders']), {
    isStaffDashboard: function isStaffDashboard() {
      return this.$route.path.startsWith('/admin');
    },
    orderListToShow: function orderListToShow() {
      if (this.isStaffDashboard) {
        return this.recentOrders || [];
      }
      return this.orderList;
    },
    loadingParams: function loadingParams() {
      return {
        itemsOnPage: this.itemsOnPage,
        pageNumber: this.pageNumber,
        status: this.statusSelected,
        search: this.search,
        allteams: 1
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['loadRecentOrders', 'updateRecentOrders', 'loadOrdersPaginated', 'reOrder']), {
    showSearchForm: function showSearchForm() {
      // Admins can search (not orderers)
      return this.isStaffDashboard || this.user.user_type === 'admin';
    },

    onSearchTermChange: __WEBPACK_IMPORTED_MODULE_8_lodash_debounce___default()(function (search) {
      var _this = this;

      if (this.isStaffDashboard) {
        // Avoid searching on short search terms (1 to 3 chars)
        if (search.length && search.length < 3) return;

        // If `search == ''` (empty string) it is better to set it to `null`.
        // In this case in URL's query string we will not have "search=".
        var newSearch = search.trim() || null;
        if (this.search !== newSearch) {
          this.search = newSearch;
          // Start from the 1st page on each search term change.
          this.pageNumber = 1;
          this.loadList();
        }
      } else {
        // Search should be made against already filtered results.
        if (search) {
          this.search = search.toLowerCase();
          this.orderList = this.orderListFiltered.filter(function (o) {
            return o.number.includes(_this.search) || o.guest_email.toLowerCase().includes(_this.search);
          });
        } else {
          this.orderList = this.orderListFiltered;
        }
      }
    }, 250),
    onStatusChange: function onStatusChange(data) {
      if (this.isStaffDashboard) {
        if (this.statusSelected !== data) {
          this.statusSelected = data;
          // Start from the 1st page on each status change.
          this.pageNumber = 1;
          this.loadList();
        }
      } else {
        this.orderListFiltered = data;
        // Take into account the search term if it is entered.
        this.onSearchTermChange(this.search);
      }
    }
  }),
  mounted: function mounted() {
    if (this.isStaffDashboard) {
      this.loadList();
    } else {
      this.loadRecentOrders();
    }
  }
});

/***/ }),

/***/ "fnM9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.numberOfPages > 1)?_c('simple-pagination',{staticClass:"text-center",attrs:{"currentpage":_vm.currentPage,"pages":_vm.numberOfPages},on:{"changePage":_vm.onPageNumberChange}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fusB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  Approval is "+_vm._s(_vm.state)+"\n  "),_c('small',[_vm._v(_vm._s(_vm.smallText))]),_vm._v(" "),(_vm.approvalMode != 'none' && _vm.approvalSettings.approverDesignation === 'chooseOnCheckout')?_c('p',[_vm._v("\n    Approving admin will be chosen when ordering\n  ")]):_vm._e(),_vm._v(" "),(_vm.approvalMode != 'none' && _vm.approvalSettings.approvalByGroup)?_c('p',[_vm._v("Approving admin filtered by groups")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g/q2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-settings-overview"},[_c('SettingsTitleBar'),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap",attrs:{"id":"cards"}},_vm._l((_vm.cards),function(ref){
var key = ref.key;
var title = ref.title;
var viewComponent = ref.viewComponent;
return _c('b-card',{key:key,attrs:{"title":title},on:{"click":function($event){return _vm.$router.push('settings/'+key)}}},[_c(viewComponent,{tag:"component"}),_vm._v(" "),_c('i',{staticClass:"fas fa-edit",attrs:{"id":"edit-card"}})],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g7AP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gA2L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getBasketLinesCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getBasket; });
/* unused harmony export expandLines */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return expandOrderLines; });
/* unused harmony export extendOrderLinesKeys */
/* unused harmony export ATTRS */
/* unused harmony export getLineAttr */
/* unused harmony export findAttr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addToBasket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return updateLineItem; });
/* unused harmony export updateLineItemAttr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return removeFromBasket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addVoucher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defineService__ = __webpack_require__("tVbG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common__ = __webpack_require__("Cvgy");





var expandLine = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(lineObj) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return expand(lineObj, { product: product });

          case 2:
            expandAttrs(lineObj);
            ensureLineHasId(lineObj);

          case 4:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function expandLine(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

var expand = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(obj, attrs) {
    var attr;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.t0 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.keys(attrs);

          case 1:
            if ((_context5.t1 = _context5.t0()).done) {
              _context5.next = 16;
              break;
            }

            attr = _context5.t1.value;

            if (!(typeof obj[attr] === 'string')) {
              _context5.next = 14;
              break;
            }

            _context5.prev = 4;
            _context5.next = 7;
            return attrs[attr](obj[attr]);

          case 7:
            obj[attr] = _context5.sent;
            _context5.next = 14;
            break;

          case 10:
            _context5.prev = 10;
            _context5.t2 = _context5['catch'](4);

            // TODO when does this happen
            console.error('Error expanding ' + attr, _context5.t2);
            throw _context5.t2;

          case 14:
            _context5.next = 1;
            break;

          case 16:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this, [[4, 10]]);
  }));

  return function expand(_x5, _x6) {
    return _ref5.apply(this, arguments);
  };
}();




var basket = Object(__WEBPACK_IMPORTED_MODULE_4__defineService__["b" /* default */])('get', 'api/v1/cart/basket/');
var getBasketLinesCount = Object(__WEBPACK_IMPORTED_MODULE_4__defineService__["b" /* default */])('get', 'api/v1/cart/basket/lines/count/');
var product = Object(__WEBPACK_IMPORTED_MODULE_4__defineService__["b" /* default */])('get', 'api/v1/cart/products/:id/', { alternatives: {
    rounded: '-rounded' // rounded product
  } });
var basketLines = Object(__WEBPACK_IMPORTED_MODULE_4__defineService__["b" /* default */])('get', 'api/v1/cart/baskets/:id/lines/', { mainKey: 'results' });
var orderLines = Object(__WEBPACK_IMPORTED_MODULE_4__defineService__["b" /* default */])('get', 'api/v1/cart/orders/:id/lines/', { mainKey: 'results' });
var addProduct = Object(__WEBPACK_IMPORTED_MODULE_4__defineService__["b" /* default */])('post', 'api/v1/cart/basket/add-product/');
var putLine = Object(__WEBPACK_IMPORTED_MODULE_4__defineService__["b" /* default */])('put', 'api/v1/cart/baskets/:basket/lines/:line/');
var deleteLine = Object(__WEBPACK_IMPORTED_MODULE_4__defineService__["b" /* default */])('delete', 'api/v1/cart/baskets/:basket/lines/:line/');
var putLineAttribute = Object(__WEBPACK_IMPORTED_MODULE_4__defineService__["b" /* default */])('put', 'api/v1/cart/baskets/:basket/lines/:line/lineattributes/:id/');
var postVoucher = Object(__WEBPACK_IMPORTED_MODULE_4__defineService__["b" /* default */])('post', 'api/v1/cart/custom/basket/add-voucher/', {
  suffixFunc: function suffixFunc() {
    return '-406';
  }
});

/**
 * Get the current users basket. Expand the lines.
 */
var getBasket = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    var result, updatedLines, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, line;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return basket();

          case 2:
            result = _context.sent;
            updatedLines = [];
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context.prev = 7;

            for (_iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(result.lines); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              line = _step.value;

              expandAttrs(line);
              updatedLines.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, line));
            }
            _context.next = 15;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context['catch'](7);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 15:
            _context.prev = 15;
            _context.prev = 16;

            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }

          case 18:
            _context.prev = 18;

            if (!_didIteratorError) {
              _context.next = 21;
              break;
            }

            throw _iteratorError;

          case 21:
            return _context.finish(18);

          case 22:
            return _context.finish(15);

          case 23:
            result.lines = updatedLines;
            return _context.abrupt('return', result);

          case 25:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[7, 11, 15, 23], [16,, 18, 22]]);
  }));

  return function getBasket() {
    return _ref.apply(this, arguments);
  };
}();

var expandLines = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(basket) {
    var lines = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : basketLines;

    var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, lineObj;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return expand(basket, { lines: lines });

          case 2:
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _iteratorError2 = undefined;
            _context2.prev = 5;
            _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(basket.lines);

          case 7:
            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
              _context2.next = 14;
              break;
            }

            lineObj = _step2.value;
            _context2.next = 11;
            return expandLine(lineObj);

          case 11:
            _iteratorNormalCompletion2 = true;
            _context2.next = 7;
            break;

          case 14:
            _context2.next = 20;
            break;

          case 16:
            _context2.prev = 16;
            _context2.t0 = _context2['catch'](5);
            _didIteratorError2 = true;
            _iteratorError2 = _context2.t0;

          case 20:
            _context2.prev = 20;
            _context2.prev = 21;

            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }

          case 23:
            _context2.prev = 23;

            if (!_didIteratorError2) {
              _context2.next = 26;
              break;
            }

            throw _iteratorError2;

          case 26:
            return _context2.finish(23);

          case 27:
            return _context2.finish(20);

          case 28:
            return _context2.abrupt('return', basket);

          case 29:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this, [[5, 16, 20, 28], [21,, 23, 27]]);
  }));

  return function expandLines(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var expandOrderLines = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(order) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!order.id) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt('return', extendOrderLinesKeys(order));

          case 2:
            ensureHasId(order);
            urlToId(order, 'owner');
            return _context4.abrupt('return', expandLines(order, orderLines));

          case 5:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function expandOrderLines(_x4) {
    return _ref4.apply(this, arguments);
  };
}();

/**
 * Copy existing attrs to "camel cased" attrs for each order's line.
 * Attrs for copying indicated in included `keyArray`.
 *
 * @param {Object} order
 * @returns {Object} Updated order.
 */
function extendOrderLinesKeys(order) {
  var keyArray = ['box_size', 'product_title'];
  var updatedLines = [];
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(order.lines), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var line = _step3.value;

      updatedLines.push(Object(__WEBPACK_IMPORTED_MODULE_5__common__["b" /* objectKeysToCamelCase */])(line, keyArray));
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  order.lines = updatedLines;
  return order;
}

var ATTRS = {
  boxSize: { type: Number, url: "https://www.brandly.com/services/cart/api/v1/cart/options/3/" },
  designId: { type: Number, url: "https://www.brandly.com/services/cart/api/v1/cart/options/1/" }

  /**
   * Get the value for a particular attribute
   * @param {*} line
   * @param {*} attr_url -- eg ATTRS.BOX_SIZE
   */
};function getLineAttr(line, _ref6) {
  var url = _ref6.url,
      type = _ref6.type;

  // The urls won't match directly due to different environments;
  // just match the numeric portion
  var attr = findAttr(line.attributes, url);
  return attr && type(attr.value);
}

function findAttr(attributes, attrUrl) {
  var idFromUrl = function idFromUrl(url) {
    return url.match(/\/\d+\//)[0];
  };
  var attrId = idFromUrl(attrUrl);
  return attributes.find(function (obj) {
    return idFromUrl(obj.option) === attrId;
  });
}

function expandAttrs(line) {
  for (var key in ATTRS) {
    line[key] = getLineAttr(line, ATTRS[key]);
  }
}

/**
 * Ensure line object has an ID, extract from the url if needed.
 * @param {*} line
 */
function ensureLineHasId(line) {
  ensureHasId(line, /lines\/(\d+)\//);
}

/**
 * Ensure object has an ID, extract from the url if needed.
 * @param {*} object
 */
function ensureHasId(obj) {
  var re = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /\/(\d+)\//;

  if (obj.id) return;
  var match = re.exec(obj.url);
  console.assert(match[1]);
  obj.id = +match[1];
}

function urlToId(obj, attr) {
  var re = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : /\/(\d+)\//;

  var value = obj[attr];
  if (!value || typeof value !== 'string') return;
  var m = re.exec(value);
  if (m) obj[attr] = +m[1];
}

/**
 *
 * @param {*} productUrl
 * @param {*} quantity
 * @param {*} designId
 * @param {*} boxSize
 * @param {number} [orderedFor] - `id` of team user
 */
var addToBasket = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(productUrl, quantity, designId, boxSize, orderedFor) {
    var payload, basket;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            payload = {
              url: productUrl,
              quantity: quantity,
              options: [{
                option: ATTRS.designId.url,
                value: designId
              }, {
                option: ATTRS.boxSize.url,
                value: boxSize
              }]
            };

            if (orderedFor) {
              payload.ordered_for = orderedFor;
            }
            _context6.next = 4;
            return addProduct(payload);

          case 4:
            basket = _context6.sent;
            _context6.next = 7;
            return expandLines(basket);

          case 7:
            return _context6.abrupt('return', basket);

          case 8:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function addToBasket(_x9, _x10, _x11, _x12, _x13) {
    return _ref7.apply(this, arguments);
  };
}();

var updateLineItem = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(lineItemUrl, updates) {
    var lineObj, attrKey;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return putLine(lineItemUrl, updates);

          case 2:
            lineObj = _context7.sent;
            _context7.next = 5;
            return expandLine(lineObj);

          case 5:
            _context7.t0 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.keys(ATTRS);

          case 6:
            if ((_context7.t1 = _context7.t0()).done) {
              _context7.next = 13;
              break;
            }

            attrKey = _context7.t1.value;

            if (!updates[attrKey]) {
              _context7.next = 11;
              break;
            }

            _context7.next = 11;
            return updateLineItemAttr(lineObj, attrKey, updates[attrKey]);

          case 11:
            _context7.next = 6;
            break;

          case 13:
            return _context7.abrupt('return', lineObj);

          case 14:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function updateLineItem(_x14, _x15) {
    return _ref8.apply(this, arguments);
  };
}();

var updateLineItemAttr = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(lineItem, attrKey, value) {
    var attrObj, line;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            attrObj = findAttr(lineItem.attributes, ATTRS[attrKey].url);
            line = lineItem.url;
            // Hack, the rest api expects a different way of referencing the line item.

            line = line.replace(/\/baskets\/\d+\//, '/');
            _context8.next = 5;
            return putLineAttribute(attrObj.url, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, attrObj, { line: line, value: value }));

          case 5:
            // Ensure the in-memory structure is updated
            attrObj.value = value;
            lineItem[attrKey] = value;

          case 7:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));

  return function updateLineItemAttr(_x16, _x17, _x18) {
    return _ref9.apply(this, arguments);
  };
}();

var removeFromBasket = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(lineItemUrl) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt('return', deleteLine(lineItemUrl));

          case 1:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, this);
  }));

  return function removeFromBasket(_x19) {
    return _ref10.apply(this, arguments);
  };
}();

var addVoucher = function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(vouchercode) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt('return', postVoucher({ vouchercode: vouchercode }));

          case 1:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, this);
  }));

  return function addVoucher(_x20) {
    return _ref11.apply(this, arguments);
  };
}();

/***/ }),

/***/ "gAjd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gEOo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feature-item"},[_c('h5',[_vm._t("title")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gLNS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2afc2186_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Features_vue__ = __webpack_require__("vRXk");
function injectStyle (ssrContext) {
  __webpack_require__("3pLA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2afc2186"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2afc2186_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Features_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "gX93":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.editing)?[(!_vm.editing)?_c('span',[_vm._v(_vm._s(_vm.value))]):_vm._e(),_vm._v(" "),(!_vm.editing)?_c('span',{key:"i1",on:{"click":function($event){_vm.editing = true}}},[_c('i',{staticClass:"fas fa-edit clickable"})]):_vm._e()]:[_c('span',{staticClass:"embedded-input-container"},[_c('input',{ref:"inp",staticClass:"embedded-input",class:{uppercase: _vm.uppercase},domProps:{"value":_vm.value},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.emit($event)}}}),_vm._v(" "),_c('span',{staticClass:"microbtn ok clickable",on:{"click":_vm.emit}},[_c('i',{staticClass:"fas fa-check-circle"})]),_vm._v(" "),_c('span',{staticClass:"microbtn cancel clickable",on:{"click":function($event){_vm.editing = false}}},[_c('i',{staticClass:"fas fa-times-circle"})])]),_vm._v(" "),(_vm.busy)?_c('WaveSpinner',{attrs:{"inline":""}}):_vm._e(),_vm._v(" "),(_vm.error)?_c('span',{staticClass:"error",domProps:{"innerHTML":_vm._s(_vm.error)}}):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gYqH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "geU/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b9999ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareSection_vue__ = __webpack_require__("HOKS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b9999ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gf4F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"back",attrs:{"to":"."}},[_c('i',{staticClass:"fas fa-chevron-left fa-xs"}),_vm._v(" back\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gfXH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewEmails_vue__ = __webpack_require__("0Gew");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01be231e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewEmails_vue__ = __webpack_require__("22Bo");
function injectStyle (ssrContext) {
  __webpack_require__("/MjH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01be231e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewEmails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01be231e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewEmails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "giay":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['previewUrls', 'rounded', 'imgBorder', 'editButton'],
  data: function data() {
    return { portrait: false };
  },

  computed: {
    one: function one() {
      // One card
      return !this.previewUrls[1];
    },
    two: function two() {
      // Two cards
      return !!this.previewUrls[1];
    }
  },
  methods: {
    imgLoad: function imgLoad(evt) {
      this.portrait = evt.target.naturalWidth < evt.target.naturalHeight;
    }
  }
});

/***/ }),

/***/ "gjI5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"orderFilter"}},[_c('div',{staticClass:"flexer"},[_c('b-form-radio-group',{staticClass:"pillbox",attrs:{"size":"sm","buttons":"","button-variant":"clear"},on:{"input":function($event){return _vm.$emit('input', _vm.status)}},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[(_vm.showReview)?_c('b-form-radio',{attrs:{"value":"review"}},[_vm._v("Review "),(_vm.numToReview)?_c('b-badge',[_vm._v(_vm._s(_vm.numToReview))]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"open"}},[_vm._v("Open")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"shipped"}},[_vm._v("Shipped")]),_vm._v(" "),(_vm.showCancelled)?_c('b-form-radio',{attrs:{"value":"cancelled"}},[_vm._v("Cancelled")]):_vm._e()],1),_vm._v(" "),(_vm.showOwnershipFilters)?_c('b-form-radio-group',{staticClass:"pillbox",attrs:{"size":"sm","buttons":"","button-variant":"clear"},model:{value:(_vm.ownership),callback:function ($$v) {_vm.ownership=$$v},expression:"ownership"}},[_c('b-form-radio',{attrs:{"value":"mine"}},[_c('i',{staticClass:"fas fa-user"}),_vm._v(" Mine")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"all"}},[_c('i',{staticClass:"fas fa-users"}),_vm._v(" Team")])],1):_vm._e()],1),_vm._v(" "),(_vm.noMessage && !_vm.isBusy)?_c('div',{staticClass:"noMessage"},[_vm._v(_vm._s(_vm.noMessage))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h3fy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineDetailRow_vue__ = __webpack_require__("l7iL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b0544c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineDetailRow_vue__ = __webpack_require__("sDZH");
function injectStyle (ssrContext) {
  __webpack_require__("KFJF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b0544c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineDetailRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b0544c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineDetailRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hD2Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hH7a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"saved-card"},[_vm._t("default"),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"required"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value.name),expression:"value.name"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"id":"name","type":"text","placeholder":"Name on Card","required":""},domProps:{"value":(_vm.value.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.value, "name", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"required"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value.card_number),expression:"value.card_number"},{name:"validate",rawName:"v-validate",value:('required|credit_card'),expression:"'required|credit_card'"}],staticClass:"form-control",attrs:{"id":"card_number","type":"text","placeholder":"Credit Card Number","required":""},domProps:{"value":(_vm.value.card_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.value, "card_number", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_c('svg',{staticClass:"icon icon-lock"},[_c('use',{attrs:{"xlink:href":"#icon-lock"}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-md-4"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"required"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value.expiration),expression:"value.expiration"},{name:"validate",rawName:"v-validate",value:('required|date_format:MM/YY'),expression:"'required|date_format:MM/YY'"}],staticClass:"form-control",attrs:{"type":"text","id":"expiration","placeholder":"MM/YY","required":""},domProps:{"value":(_vm.value.expiration)},on:{"blur":_vm.fixExpiration,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.value, "expiration", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"required"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value.cvc),expression:"value.cvc"},{name:"validate",rawName:"v-validate",value:({ required: true, regex: /^\d{3}(\d{1})?$/ }),expression:"{ required: true, regex: /^\\d{3}(\\d{1})?$/ }"}],staticClass:"form-control",attrs:{"type":"text","id":"cvc","placeholder":"CVC","data-stripe":"cvc","required":""},domProps:{"value":(_vm.value.cvc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.value, "cvc", $event.target.value)}}})])])]),_vm._v(" "),_vm._m(1),_c('br')]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9"},[_c('b-form-group',{staticClass:"row compact",attrs:{"label":"Saved Card Options:","label-for":"title"}},[_c('div',{staticClass:"required"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value.title),expression:"value.title"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"id":"title","type":"text","placeholder":"Description of card","required":""},domProps:{"value":(_vm.value.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.value, "title", $event.target.value)}}})]),_vm._v(" "),_c('PrivateToggle',{attrs:{"noun":"card"},model:{value:(_vm.is_private),callback:function ($$v) {_vm.is_private=$$v},expression:"is_private"}})],1)],1)]),_vm._v(" "),_c('section',[_c('h2',[_vm._v("Billing Address")]),_vm._v(" "),_c('b-form-group',_vm._b({staticClass:"row compact",attrs:{"label":"Address:","label-for":"line1"}},'b-form-group',_vm.validationAttrsFor('line1'),false),[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"line1","id":"line1","data-vv-as":"address line 1","placeholder":"Enter address"},model:{value:(_vm.value.line1),callback:function ($$v) {_vm.$set(_vm.value, "line1", $$v)},expression:"value.line1"}})],1),_vm._v(" "),_c('b-form-group',_vm._b({staticClass:"row compact",attrs:{"label":"Address:","label-for":"line2"}},'b-form-group',_vm.validationAttrsFor('line2'),false),[_c('b-form-input',{attrs:{"name":"line2","id":"line2","placeholder":"Enter line 2"},model:{value:(_vm.value.line2),callback:function ($$v) {_vm.$set(_vm.value, "line2", $$v)},expression:"value.line2"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',_vm._b({staticClass:"compact",attrs:{"label":"City:","label-for":"city"}},'b-form-group',_vm.validationAttrsFor('city'),false),[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"city","id":"city","placeholder":"Enter city"},model:{value:(_vm.value.city),callback:function ($$v) {_vm.$set(_vm.value, "city", $$v)},expression:"value.city"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',_vm._b({staticClass:"compact",attrs:{"label":"State:","label-for":"state"}},'b-form-group',_vm.validationAttrsFor('state'),false),[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"state","id":"state","placeholder":"Enter state"},model:{value:(_vm.value.state),callback:function ($$v) {_vm.$set(_vm.value, "state", $$v)},expression:"value.state"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',_vm._b({staticClass:"compact",attrs:{"label":"Zip:","label-for":"postcode"}},'b-form-group',_vm.validationAttrsFor('postcode'),false),[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"postcode","id":"postcode","placeholder":"Enter postcode"},model:{value:(_vm.value.postcode),callback:function ($$v) {_vm.$set(_vm.value, "postcode", $$v)},expression:"value.postcode"}})],1)],1)],1)],1)],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"card-row"},[_c('img',{staticClass:"credit-card",attrs:{"src":"/static/images/creditcards/visa.svg"}}),_vm._v(" "),_c('img',{staticClass:"credit-card",attrs:{"src":"/static/images/creditcards/mastercard.svg"}}),_vm._v(" "),_c('img',{staticClass:"credit-card",attrs:{"src":"/static/images/creditcards/amex.svg"}}),_vm._v(" "),_c('img',{staticClass:"credit-card",attrs:{"src":"/static/images/creditcards/discover.svg"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"secure",attrs:{"target":"_blank","href":"https://ssl.comodo.com/wildcard-ssl-certificates.php"}},[_c('img',{staticStyle:{"border":"0px"},attrs:{"src":"/static/images/creditcards/comodo-seal.svg","alt":"Comodo Trusted Site Seal","width":"auto","height":"40"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hUuU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline-block"},[_c('div',[_c('b-modal',{ref:"verification-data-modal",attrs:{"hide-footer":""}},[_c('div',{attrs:{"slot":"modal-title"},domProps:{"innerHTML":_vm._s(_vm.addressVerificationStatus)},slot:"modal-title"}),_vm._v(" "),_c('pre',{staticClass:"my-4 verification-data"},[_vm._v(_vm._s(_vm.addressVerificationData))])])],1),_vm._v(" "),(_vm.flags.debugTools)?_c('b-dropdown',{staticClass:"icon-button",attrs:{"size":"lg","variant":"link","toggle-class":"text-decoration-none","no-caret":""}},[_c('template',{slot:"button-content"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getIcon)}})]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},domProps:{"innerHTML":_vm._s(_vm.addressVerificationStatus)},on:{"click":_vm.showVerificationData}}),_vm._v(" "),(!_vm.addressVerification)?_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":_vm.verifyAddress}},[_vm._v("Verify")]):_vm._e()],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hZEz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_productAttrs__ = __webpack_require__("X9yx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    line: {
      type: Object
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['flags']), {
    unitPrice: function unitPrice() {
      return this.totalPrice / this.line.quantity;
    },
    totalPrice: function totalPrice() {
      return parseFloat(this.line.price_excl_tax, 10);
    },
    boxSize: function boxSize() {
      return this.line.boxSize;
    },
    lineIsRounded: function lineIsRounded() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__lib_productAttrs__["a" /* isRounded */])(this.line.product);
    }
  }),
  methods: {
    changeQty: function changeQty(quantity) {
      this.$emit('changeQty', { quantity: quantity, line: this.line });
    },
    plus: function plus() {
      this.changeQty(this.line.quantity + 1);
    },
    minus: function minus() {
      if (this.line.quantity > 0) {
        this.changeQty(this.line.quantity - 1);
      }
    },
    goToDetail: function goToDetail() {
      this.$router.push({ name: "Cart Detail", params: { id: this.line.id } });
    }
  }
});

/***/ }),

/***/ "hf/7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_addresses__ = __webpack_require__("FUN9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_combineAddressLists__ = __webpack_require__("F5BH");








/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    userAddresses: [],
    teamAddresses: null,
    memberAddresses: null,
    countries: []
  },
  mutations: {
    setUserAddresses: function setUserAddresses(state, addrs) {
      state.userAddresses = addrs;
    },
    setTeamAddresses: function setTeamAddresses(state, addrs) {
      state.teamAddresses = addrs;
    },
    resetTeamAddresses: function resetTeamAddresses(state) {
      state.teamAddresses = null;
    },
    setCountries: function setCountries(state, countries) {
      // Show only "shipping countries" in the list.
      var shippingCountries = countries.filter(function (country) {
        return country.is_shipping_country;
      });
      // Extend each country with country code.
      var extendedCountries = shippingCountries.map(function (country) {
        var match = void 0;
        match = /countries\/(..)\//.exec(country.url);
        // Key `iso_3166_1_a2` used because this is a name of field
        // that keeps country code on backend.
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, country, { iso_3166_1_a2: match[1] });
      });

      // Set "USA" as the first country in the list.
      state.countries = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(extendedCountries.filter(function (c) {
        return c.iso_3166_1_a3 === "USA";
      })), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(extendedCountries.filter(function (c) {
        return c.iso_3166_1_a3 !== "USA";
      })));
    },
    setMemberAddresses: function setMemberAddresses(state, addrs) {
      state.memberAddresses = addrs;
    }
  },
  actions: {
    // User addresses
    addUserAddress: function addUserAddress(_ref, address) {
      var _this = this;

      var dispatch = _ref.dispatch;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_addresses__["c" /* addUserAddress */])(address);

              case 2:
                _context.next = 4;
                return dispatch('refreshUserAddresses');

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    updateUserAddress: function updateUserAddress(_ref2, address) {
      var _this2 = this;

      var dispatch = _ref2.dispatch;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_addresses__["n" /* updateUserAddress */])(address);

              case 2:
                _context2.next = 4;
                return dispatch('refreshUserAddresses');

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    removeUserAddress: function removeUserAddress(_ref3, address) {
      var _this3 = this;

      var dispatch = _ref3.dispatch;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_addresses__["j" /* removeUserAddress */])(address);

              case 2:
                _context3.next = 4;
                return dispatch('refreshUserAddresses');

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    loadUserAddresses: function loadUserAddresses(_ref4) {
      var _this4 = this;

      var dispatch = _ref4.dispatch,
          getters = _ref4.getters;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var addrs;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                addrs = getters.userAddresses;

                if (!(addrs && addrs.length > 0)) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return");

              case 3:
                _context4.next = 5;
                return dispatch('refreshUserAddresses');

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    refreshUserAddresses: function refreshUserAddresses(_ref5) {
      var _this5 = this;

      var commit = _ref5.commit;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var addrs;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_addresses__["o" /* userAddresses */])();

              case 2:
                addrs = _context5.sent;

                commit('setUserAddresses', addrs);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },

    // Member addresses
    addMemberAddress: function addMemberAddress(_ref6, address) {
      var _this6 = this;

      var getters = _ref6.getters,
          dispatch = _ref6.dispatch;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_addresses__["a" /* addMemberAddress */])(getters.member.id, address);

              case 2:
                _context6.next = 4;
                return dispatch('refreshMemberAddresses');

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    updateMemberAddress: function updateMemberAddress(_ref7, address) {
      var _this7 = this;

      var getters = _ref7.getters,
          dispatch = _ref7.dispatch;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_addresses__["l" /* updateMemberAddress */])(getters.member.id, address);

              case 2:
                _context7.next = 4;
                return dispatch('refreshMemberAddresses');

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    removeMemberAddress: function removeMemberAddress(_ref8, address) {
      var _this8 = this;

      var getters = _ref8.getters,
          dispatch = _ref8.dispatch;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_addresses__["h" /* removeMemberAddress */])(getters.member.id, address);

              case 2:
                _context8.next = 4;
                return dispatch('refreshMemberAddresses');

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    refreshMemberAddresses: function refreshMemberAddresses(_ref9) {
      var _this9 = this;

      var getters = _ref9.getters,
          commit = _ref9.commit;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var addrs;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!getters.member.id) {
                  _context9.next = 6;
                  break;
                }

                _context9.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_addresses__["e" /* memberAddresses */])(getters.member.id);

              case 3:
                _context9.t0 = _context9.sent;
                _context9.next = 7;
                break;

              case 6:
                _context9.t0 = [];

              case 7:
                addrs = _context9.t0;

                commit('setMemberAddresses', addrs);

              case 9:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },

    // Team addresses
    addTeamAddress: function addTeamAddress(_ref10, address) {
      var _this10 = this;

      var dispatch = _ref10.dispatch;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var _ref11, id;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_addresses__["b" /* addTeamAddress */])(address);

              case 2:
                _ref11 = _context10.sent;
                id = _ref11.id;
                _context10.next = 6;
                return dispatch('refreshTeamAddresses');

              case 6:
                return _context10.abrupt("return", id);

              case 7:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this10);
      }))();
    },
    updateTeamAddress: function updateTeamAddress(_ref12, address) {
      var _this11 = this;

      var dispatch = _ref12.dispatch;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_addresses__["m" /* updateTeamAddress */])(address);

              case 2:
                _context11.next = 4;
                return dispatch('refreshTeamAddresses');

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this11);
      }))();
    },
    removeTeamAddress: function removeTeamAddress(_ref13, address) {
      var _this12 = this;

      var dispatch = _ref13.dispatch;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_addresses__["i" /* removeTeamAddress */])(address);

              case 2:
                _context12.next = 4;
                return dispatch('refreshTeamAddresses');

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this12);
      }))();
    },
    loadTeamAddresses: function loadTeamAddresses(_ref14) {
      var _this13 = this;

      var getters = _ref14.getters,
          dispatch = _ref14.dispatch;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var addrs;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                addrs = getters.teamAddresses;

                if (!(addrs && addrs.length > 0)) {
                  _context13.next = 3;
                  break;
                }

                return _context13.abrupt("return");

              case 3:
                dispatch('refreshTeamAddresses');

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this13);
      }))();
    },
    refreshTeamAddresses: function refreshTeamAddresses(_ref15) {
      var _this14 = this;

      var commit = _ref15.commit;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var addrs;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_addresses__["k" /* teamAddresses */])();

              case 2:
                addrs = _context14.sent;

                commit('setTeamAddresses', addrs);

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this14);
      }))();
    },

    // Combined user/team addresses
    // These work with the resuls from combinedAddresses
    addAddress: function addAddress(_ref16, address) {
      var _this15 = this;

      var dispatch = _ref16.dispatch;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee15() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt("return", doCombinedAction(dispatch, address, 'add'));

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this15);
      }))();
    },
    updateAddress: function updateAddress(_ref17, address) {
      var _this16 = this;

      var dispatch = _ref17.dispatch;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var origType, type;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                origType = address.origType, type = address.type;

                if (!(origType && origType !== type)) {
                  _context16.next = 5;
                  break;
                }

                return _context16.abrupt("return", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([doCombinedAction(dispatch, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, address, { type: origType }), 'remove'), doCombinedAction(dispatch, address, 'add')]));

              case 5:
                return _context16.abrupt("return", doCombinedAction(dispatch, address, 'update'));

              case 6:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this16);
      }))();
    },
    removeAddress: function removeAddress(_ref18, address) {
      var _this17 = this;

      var dispatch = _ref18.dispatch;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee17() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                return _context17.abrupt("return", doCombinedAction(dispatch, address, 'remove'));

              case 1:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this17);
      }))();
    },
    refreshAddresses: function refreshAddresses(_ref19) {
      var _this18 = this;

      var dispatch = _ref19.dispatch;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee18() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                return _context18.abrupt("return", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([dispatch('refreshTeamAddresses'), dispatch('refreshUserAddresses'), dispatch('refreshMemberAddresses')]));

              case 1:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this18);
      }))();
    },
    setDefaultUserAddress: function setDefaultUserAddress(_ref20, address) {
      var _this19 = this;

      var dispatch = _ref20.dispatch;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee19() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                if (!(address.type === 'team')) {
                  _context19.next = 4;
                  break;
                }

                return _context19.abrupt("return", dispatch('updateProfile', { default_team_address: address.id }));

              case 4:
                return _context19.abrupt("return", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([dispatch('updateProfile', { default_team_address: null }), dispatch('updateAddress', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, address, { is_default_for_shipping: true }))]));

              case 5:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this19);
      }))();
    },
    loadCountries: function loadCountries(_ref21) {
      var _this20 = this;

      var commit = _ref21.commit;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee20() {
        var _ref22, results;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_addresses__["d" /* getCountries */])();

              case 2:
                _ref22 = _context20.sent;
                results = _ref22.results;

                commit('setCountries', results);

              case 5:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, _this20);
      }))();
    },
    loadMemberAddresses: function loadMemberAddresses(_ref23, memberId) {
      var _this21 = this;

      var commit = _ref23.commit,
          getters = _ref23.getters;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee21() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                // Load the addresses for the current team member.
                // Ensure there is minimal time where we have the addresses for the wrong member.
                commit('setMemberAddresses', null);
                _context21.t0 = commit;
                _context21.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_addresses__["e" /* memberAddresses */])(memberId);

              case 4:
                _context21.t1 = _context21.sent;
                (0, _context21.t0)('setMemberAddresses', _context21.t1);

              case 6:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, _this21);
      }))();
    },
    setDefaultMemberAddress: function setDefaultMemberAddress(_ref24, address) {
      var _this22 = this;

      var getters = _ref24.getters,
          dispatch = _ref24.dispatch;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee22() {
        var id;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                // See setDefaultUserAddress for details.
                id = getters.member.id;

                if (!(address.type === 'team')) {
                  _context22.next = 5;
                  break;
                }

                return _context22.abrupt("return", dispatch('updateUserProfile', { id: id, default_team_address: address.id }));

              case 5:
                return _context22.abrupt("return", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([dispatch('updateUserProfile', { id: id, default_team_address: null }), dispatch('updateMemberAddress', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, address, { is_default_for_shipping: true }))]));

              case 6:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, _this22);
      }))();
    }
  },
  getters: {
    userAddresses: function userAddresses(state) {
      return state.userAddresses || [];
    },
    teamAddresses: function teamAddresses(state) {
      return state.teamAddresses;
    },
    combinedAddresses: function combinedAddresses(state, getters) {
      return getters.user ? Object(__WEBPACK_IMPORTED_MODULE_6__lib_combineAddressLists__["a" /* default */])(state.teamAddresses, getters.userAddresses, getters.user.default_team_address) : null;
    },
    combinedMemberAddresses: function combinedMemberAddresses(state, getters) {
      return getters.member ? Object(__WEBPACK_IMPORTED_MODULE_6__lib_combineAddressLists__["a" /* default */])(state.teamAddresses, state.memberAddresses, getters.member.default_team_address, 'member') : null;
    },
    countries: function countries(state) {
      return state.countries;
    },
    defaultMemberAddress: function defaultMemberAddress(state, getters) {
      if (!getters.member) return;
      // Caller should ensure the team addresses are loaded
      var default_team_address = getters.member.default_team_address;
      // Return team address specified by the address_id, or
      // the personal address has the is_default_for_shipping,

      if (default_team_address) {
        if (!state.teamAddresses) return null; // Team addresses not loaded yet.
        return state.teamAddresses.find(function (addr) {
          return default_team_address == addr.id;
        });
      } else {
        if (!state.memberAddresses) return null; // Unexpected, but to be safe
        return state.memberAddresses.find(function (addr) {
          return addr.is_default_for_shipping;
        });
      }
    }
  }
});

function doCombinedAction(dispatch, address, actionPrefix) {
  var type = address.type;
  console.assert(type === 'user' || type === 'team' || type == 'member');
  var camelType = type[0].toUpperCase() + type.substring(1);
  var action = actionPrefix + camelType + 'Address';
  return dispatch(action, address);
}

/***/ }),

/***/ "hur9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hvE2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hwhm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      message: '',
      type: '',
      confirming: false,
      confirm: null
    };
  },
  mounted: function mounted() {
    console.log(this.$refs.div);
    this.$refs.div.addEventListener('notification', function (event) {
      return console.log('wtf', event);
    });
  },

  computed: {
    show: function show() {
      return !!this.variant;
    },
    variant: function variant() {
      // Only show success and error types
      return { success: 'success', error: 'danger', confirm: 'warning' }[this.type];
    }
  },
  methods: {
    messageReceived: function messageReceived(event) {
      console.log('messageReceived', event);
      var _event$detail = event.detail,
          message = _event$detail.message,
          type = _event$detail.type;

      this.message = message;
      this.type = type;
      this.confirming = false;
    },
    clearMessage: function clearMessage() {
      this.message = '';
      this.type = '';
      this.confirming = false;
    },
    confirmationReceived: function confirmationReceived(event) {
      event.preventDefault();
      this.confirming = true;
      this.type = 'confirm';
      this.message = event.detail.message;
      this.confirm = event.detail.confirm;
      console.log('confirmationReceived!');
    },
    onConfirm: function onConfirm() {
      this.clearMessage();
      this.confirm(true);
    },
    onCancel: function onCancel() {
      this.clearMessage();
      this.confirm(false);
    }
  }
});

/***/ }),

/***/ "i/fC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageAlert_vue__ = __webpack_require__("hwhm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95461644_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageAlert_vue__ = __webpack_require__("82B1");
function injectStyle (ssrContext) {
  __webpack_require__("19NW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-95461644"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95461644_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "i/xQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card-group',{attrs:{"deck":""}},[_c('b-card',{staticClass:"d-none d-sm-block"},[_c('b-card-text',[_c('div',{staticClass:"slide-block"},[_c('img',{staticClass:"testimonial-logo",attrs:{"src":"/static/images/homepage/testimonials/gulfwinds.svg"}}),_vm._v(" "),_c('div',{staticClass:"testimonial-quote"},[_c('div',{staticClass:"quote-container"},[_c('blockquote',[_c('p',[_vm._v("Throughout the implementation of our new ordering system for business cards, the Brandly support staff was always knowledgeable and responsive. With their assistance, we were able to create a solution that was best for our organization.”")])]),_vm._v(" "),_c('cite',[_c('span',[_vm._v("Angie Hernandez")]),_vm._v(" "),_c('br'),_vm._v("Marketing Specialist\n              "),_c('br'),_vm._v("Gulf Winds Credit Union\n            ")])])])])])],1),_vm._v(" "),_c('b-card',[_c('b-card-text',[_c('div',{staticClass:"slide-block"},[_c('img',{staticClass:"testimonial-logo",attrs:{"src":"/static/images/homepage/testimonials/evoque.png"}}),_vm._v(" "),_c('div',{staticClass:"testimonial-quote"},[_c('div',{staticClass:"quote-container"},[_c('blockquote',[_c('p',[_vm._v("Brandly provided a great kick start for Evoque from Day 1, we needed business cards across the country, and they fulfilled that need brilliantly, complimentary shipping was an added bonus.”")])]),_vm._v(" "),_c('cite',[_c('span',[_vm._v("Leigh Tang")]),_vm._v(" "),_c('br'),_vm._v("Corporate Services Manager\n              "),_c('br'),_vm._v("Evoque Data Center Solutions\n            ")])])])])])],1),_vm._v(" "),_c('b-card',{staticClass:"d-none d-lg-block"},[_c('b-card-text',[_c('div',{staticClass:"slide-block"},[_c('img',{staticClass:"testimonial-logo",attrs:{"src":"/static/images/homepage/testimonials/goodhands.svg"}}),_vm._v(" "),_c('div',{staticClass:"testimonial-quote"},[_c('div',{staticClass:"quote-container"},[_c('blockquote',[_c('p',[_vm._v("Our team members can now join our account, edit their info, and order cards for themselves in minutes. As a manager, it's one less thing for me to worry about.”")])]),_vm._v(" "),_c('cite',[_c('span',[_vm._v("Amrit Singh")]),_vm._v(" "),_c('br'),_vm._v("Cofounder\n              "),_c('br'),_vm._v("GoodHands Marketing\n            ")])])])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i0Um":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0244329d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionHeader_vue__ = __webpack_require__("qBbl");
function injectStyle (ssrContext) {
  __webpack_require__("50UU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0244329d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0244329d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "i2MF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i2cO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomePage_vue__ = __webpack_require__("TbTU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_687d6975_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomePage_vue__ = __webpack_require__("9E09");
function injectStyle (ssrContext) {
  __webpack_require__("QduS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-687d6975"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_687d6975_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "i2pp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_526d5bc4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtworkTips_vue__ = __webpack_require__("LuKJ");
function injectStyle (ssrContext) {
  __webpack_require__("l7eF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-526d5bc4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_526d5bc4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtworkTips_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "i57o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-page"},[_c('ToolBar'),_vm._v(" "),(!this.designId)?_c('div',{staticClass:"editor-wrapper"},[_c('UploaderBox',{staticClass:"upload-widget-wrapper",attrs:{"extra":_vm.uploadExtra},on:{"upload":_vm.onUpload,"error":_vm.onError}}),_vm._v(" "),_c('SideMenu',{staticClass:"side-menu d-none d-lg-block"})],1):_vm._e(),_vm._v(" "),_c('FixedMenu')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iGgY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['wideHeader', 'heroDark']
});

/***/ }),

/***/ "iL6W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isMobile;
function isMobile() {
  return typeof window.orientation !== "undefined" || navigator.userAgent.indexOf('IEMobile') !== -1;
}

/***/ }),

/***/ "iObd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LinkedInSignIn_vue__ = __webpack_require__("8RFy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e38140e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LinkedInSignIn_vue__ = __webpack_require__("Rjv0");
function injectStyle (ssrContext) {
  __webpack_require__("oJ6o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LinkedInSignIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e38140e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LinkedInSignIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "iPan":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"no-strings-layer"},[_c('div',{staticClass:"row",attrs:{"id":"no-strings"}},[_c('div',{staticClass:"col-12 col-lg-4 text-center text-lg-left",attrs:{"id":"no-strings-container"}},[_c('div',{staticClass:"no-strings-wrapper"},[_c('img',{staticClass:"no-strings-icon",attrs:{"src":"/static/images/homepage/no-commitments.svg"}}),_vm._v(" "),_c('h3',{staticClass:"no-strings-title"},[_vm._v("No commitments")])]),_vm._v(" "),_c('p',{staticClass:"no-strings-text"},[_vm._v("Get full access to Brandly’s portal and features for free. No hidden fees.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4 text-center text-lg-left",attrs:{"id":"no-strings-container"}},[_c('div',{staticClass:"no-strings-wrapper"},[_c('img',{staticClass:"no-strings-icon",attrs:{"src":"/static/images/homepage/no-minimum.svg"}}),_vm._v(" "),_c('h3',{staticClass:"no-strings-title"},[_vm._v("No minimum")])]),_vm._v(" "),_c('p',{staticClass:"no-strings-text"},[_vm._v("No team is too big or small. Print as much or as little as you need to.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4 text-center text-lg-left",attrs:{"id":"no-strings-container"}},[_c('div',{staticClass:"no-strings-wrapper"},[_c('img',{staticClass:"no-strings-icon",attrs:{"src":"/static/images/homepage/design-cup.svg"}}),_vm._v(" "),_c('h3',{staticClass:"no-strings-title"},[_vm._v("No design? No problem.")])]),_vm._v(" "),_c('p',{staticClass:"no-strings-text"},[_vm._v("Check out Brandly's design templates to help you get started.\n        "),_c('span',{attrs:{"id":"starter-pack"}},[_c('a',{attrs:{"href":"/starterpack","target":"_blank"}},[_vm._v("Download our Starter Pack")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iUmS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['member'],
  data: function data() {
    return { sending: false };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["user", "isAdmin", "flags"])),
  methods: {
    onClickRow: function onClickRow() {
      if (this.isAdmin) {
        this.$router.push({ name: 'member-detail', params: { id: this.member.id } });
      }
    },
    userRoleText: function userRoleText() {
      // Return a label for the user type. If we get an unexpected user_type, just return that.
      return { admin: 'Administrator', user: 'Orderer' }[this.member.user_type] || this.member.user_type;
    }
  }
});

/***/ }),

/***/ "iVxh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.combinedMemberAddresses !== null)?_c('div',{staticClass:"addresses"},[(_vm.address)?_c('div',{staticClass:"chosen-address"},[_c('Address',{attrs:{"value":_vm.address}}),_vm._v(" "),_c('b-button',{attrs:{"variant":"link"},on:{"click":function($event){_vm.choosing = true}}},[_vm._v("Change")])],1):(_vm.adding)?_c('div',{staticClass:"new-address"},[_vm._v("\n    Enter new address:\n    "),_c('address',[_c('b-form-input',{staticClass:"inp",attrs:{"placeholder":"Line1"},model:{value:(_vm.newAddress.line1),callback:function ($$v) {_vm.$set(_vm.newAddress, "line1", $$v)},expression:"newAddress.line1"}}),_vm._v(" "),_c('b-form-input',{staticClass:"inp",attrs:{"placeholder":"Line2"},model:{value:(_vm.newAddress.line2),callback:function ($$v) {_vm.$set(_vm.newAddress, "line2", $$v)},expression:"newAddress.line2"}}),_vm._v(" "),_c('b-form-input',{staticClass:"inp",attrs:{"placeholder":"City"},model:{value:(_vm.newAddress.city),callback:function ($$v) {_vm.$set(_vm.newAddress, "city", $$v)},expression:"newAddress.city"}}),_vm._v(" "),_c('b-form-input',{staticClass:"inp",attrs:{"placeholder":"State"},model:{value:(_vm.newAddress.state),callback:function ($$v) {_vm.$set(_vm.newAddress, "state", $$v)},expression:"newAddress.state"}}),_vm._v(" "),_c('b-form-input',{staticClass:"inp",attrs:{"placeholder":"Zip"},model:{value:(_vm.newAddress.postcode),callback:function ($$v) {_vm.$set(_vm.newAddress, "postcode", $$v)},expression:"newAddress.postcode"}})],1),_vm._v(" "),_c('b-button',{attrs:{"variant":"default","size":"lg"},on:{"click":_vm.addAddress}},[_vm._v("Done")]),_vm._v(" "),(_vm.addError)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.addError))]):_vm._e()],1):_c('div',{staticClass:"address-list"},[_vm._v("\n    Choose address:\n    "),_vm._l((_vm.combinedMemberAddresses),function(addr){return _c('Address',{key:JSON.stringify(addr),staticClass:"addr",attrs:{"value":addr},on:{"click":function($event){return _vm.chooseAddress(addr)}}})}),_vm._v(" "),_c('address',{staticClass:"addr",on:{"click":_vm.startAdding}},[_vm._v("+ New Address")])],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iYzm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GetEmail_vue__ = __webpack_require__("Yo3d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3aaf955f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GetEmail_vue__ = __webpack_require__("QkeZ");
function injectStyle (ssrContext) {
  __webpack_require__("/Kza")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3aaf955f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GetEmail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3aaf955f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GetEmail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "icR4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showSurvey)?_c('div',{staticClass:"survey-link alert alert-primary active"},[_vm._v("\nPlease tell us about your order experience: "),_c('a',{attrs:{"href":"https://brandlyinc.typeform.com/to/adZTzG"}},[_vm._v("take the last mini-survey now")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ikt8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "is0N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WarningBox_vue__ = __webpack_require__("GSN3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0e7bf46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WarningBox_vue__ = __webpack_require__("Uulp");
function injectStyle (ssrContext) {
  __webpack_require__("OHIq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d0e7bf46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WarningBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0e7bf46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WarningBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jEl5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverlappedPreview_vue__ = __webpack_require__("Y/4c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_843ac512_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverlappedPreview_vue__ = __webpack_require__("+pgR");
function injectStyle (ssrContext) {
  __webpack_require__("egdY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-843ac512"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverlappedPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_843ac512_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverlappedPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jd3D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ViewProfile__ = __webpack_require__("9hkR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditProfile__ = __webpack_require__("46x5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ViewTeam__ = __webpack_require__("tCCD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditTeam__ = __webpack_require__("nEbw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ViewAddresses__ = __webpack_require__("dH6r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EditAddresses__ = __webpack_require__("I0no");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ViewBilling__ = __webpack_require__("V2iM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EditBilling__ = __webpack_require__("4OY/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ViewApproval__ = __webpack_require__("qfGN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EditApproval__ = __webpack_require__("ZoSi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ViewEmails__ = __webpack_require__("gfXH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EditEmails__ = __webpack_require__("H0Z0");













/* harmony default export */ __webpack_exports__["a"] = ([{
  key: 'profile',
  title: 'Profile',
  viewComponent: __WEBPACK_IMPORTED_MODULE_0__ViewProfile__["a" /* default */],
  editComponent: __WEBPACK_IMPORTED_MODULE_1__EditProfile__["a" /* default */]
}, {
  key: 'team',
  title: 'Team',
  viewComponent: __WEBPACK_IMPORTED_MODULE_2__ViewTeam__["a" /* default */],
  editComponent: __WEBPACK_IMPORTED_MODULE_3__EditTeam__["a" /* default */]
}, {
  key: 'addrs',
  title: 'Addresses',
  viewComponent: __WEBPACK_IMPORTED_MODULE_4__ViewAddresses__["a" /* default */],
  editComponent: __WEBPACK_IMPORTED_MODULE_5__EditAddresses__["a" /* default */]
}, {
  key: 'billing',
  title: 'Billing',
  viewComponent: __WEBPACK_IMPORTED_MODULE_6__ViewBilling__["a" /* default */],
  editComponent: __WEBPACK_IMPORTED_MODULE_7__EditBilling__["a" /* default */]
}, {
  key: 'approval',
  title: 'Approval',
  viewComponent: __WEBPACK_IMPORTED_MODULE_8__ViewApproval__["a" /* default */],
  editComponent: __WEBPACK_IMPORTED_MODULE_9__EditApproval__["a" /* default */]
}, {
  key: 'emails',
  title: 'Emails',
  viewComponent: __WEBPACK_IMPORTED_MODULE_10__ViewEmails__["a" /* default */],
  editComponent: __WEBPACK_IMPORTED_MODULE_11__EditEmails__["a" /* default */],
  flag: 'enableEmailsSettings'
}]);

/***/ }),

/***/ "jgnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('SettingsTitleBar',{attrs:{"sub":"Approval","saving":_vm.saving}}),_vm._v(" "),_c('b-form-radio-group',{attrs:{"stacked":""},model:{value:(_vm.form.approvalMode),callback:function ($$v) {_vm.$set(_vm.form, "approvalMode", $$v)},expression:"form.approvalMode"}},[_c('b-form-radio',{attrs:{"value":null}},[_vm._v("\n      No approval\n      "),_c('small',[_vm._v("Orders will be sent to production automatically")])]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"review"}},[_vm._v("\n      Centralize review\n      "),_c('small',[_vm._v("An admin will need to review all orders before sending to production.")])]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"payment"}},[_vm._v("\n      Centralize review+payment\n      "),_c('small',[_vm._v("An admin will need to review+enter billing for all orders before sending to production.")])])],1),_vm._v(" "),(_vm.form.approvalMode)?_c('div',[_c('label',{staticClass:"label",attrs:{"for":"ad"}},[_vm._v("How will approver be selected?")]),_vm._v(" "),_c('b-form-radio-group',{attrs:{"id":"ad","stacked":""},model:{value:(_vm.form.approverDesignation),callback:function ($$v) {_vm.$set(_vm.form, "approverDesignation", $$v)},expression:"form.approverDesignation"}},[_c('b-form-radio',{attrs:{"value":null}},[_vm._v("\n        All admins\n        "),_c('small',[_vm._v("Requests will be sent to all admins")])]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"chooseOnCheckout"}},[_vm._v("\n        Orderer chooses\n        "),_c('small',[_vm._v("Orderers may choose from all the admins during checkout.")])])],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jmDq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "joGj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DISPOSABLE */
/* unused harmony export GENERIC */
/* unused harmony export CUSTOM */
/* harmony export (immutable) */ __webpack_exports__["a"] = emailDomainType;
var DISPOSABLE = 'disposable',
    // a throwaway email such as mailinator.com
GENERIC = 'generic',
    // a big email hoster such as hotmail.com
CUSTOM = 'custom' // a custom domain eg brandly.com
;
var DOMAINS = {
  // This is just enough to test if we ever create a different path.
  "mailinator.com": DISPOSABLE,

  // This is not exhaustive at all but covers the vast majority of our generic emails.
  "gmail.com": GENERIC,
  "hotmail.com": GENERIC,
  "yahoo.com": GENERIC,
  "aol.com": GENERIC
};
function emailDomainType(email) {
  var domain = email.split('@', 2)[1].toLowerCase().trim();
  return DOMAINS[domain] || CUSTOM;
}

/***/ }),

/***/ "jw2m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initAligningGuidelines;
// Copied From Fabric.js lib at:
// https://github.com/fabricjs/fabric.js/blob/master/lib/aligning_guidelines.js

//modified by Brandly

/**
 * Should objects be aligned by a bounding box?
 * [Bug] Scaled objects sometimes can not be aligned by edges
 *
 */
function initAligningGuidelines(canvas) {

  var ctx = canvas.getSelectionContext(),
      aligningLineOffset = 5,
      aligningLineMargin = 4,
      aligningLineWidth = 0.5,
      aligningLineColor = 'rgb(153, 184, 250)',
      viewportTransform,
      zoom = 1,
      cacheActiveObject = false,
      // helps determine the start of mouse drag.
  cachedActiveDimension = null;

  function drawVerticalLine(coords) {
    drawLine(coords.x + 0.5, coords.y1 > coords.y2 ? coords.y2 : coords.y1, coords.x + 0.5, coords.y2 > coords.y1 ? coords.y2 : coords.y1);
  }

  function drawHorizontalLine(coords) {
    drawLine(coords.x1 > coords.x2 ? coords.x2 : coords.x1, coords.y + 0.5, coords.x2 > coords.x1 ? coords.x2 : coords.x1, coords.y + 0.5);
  }

  function drawLine(x1, y1, x2, y2) {
    ctx.save();
    ctx.lineWidth = aligningLineWidth;
    ctx.strokeStyle = aligningLineColor;
    ctx.beginPath();
    ctx.moveTo((x1 + viewportTransform[4]) * zoom, (y1 + viewportTransform[5]) * zoom);
    ctx.lineTo((x2 + viewportTransform[4]) * zoom, (y2 + viewportTransform[5]) * zoom);
    ctx.stroke();
    ctx.restore();
  }

  function isInRange(value1, value2) {
    value1 = Math.round(value1);
    value2 = Math.round(value2);
    for (var i = value1 - aligningLineMargin, len = value1 + aligningLineMargin; i <= len; i++) {
      if (i === value2) {
        return true;
      }
    }
    return false;
  }

  var verticalLines = [],
      horizontalLines = [];

  canvas.on('mouse:down', function () {
    viewportTransform = canvas.viewportTransform;
    zoom = canvas.getZoom();
  });

  canvas.on('object:selected', function (e) {
    cacheActiveObject = true;
  });

  canvas.on('object:moving', function (e) {

    var activeObject = e.target,
        canvasObjects = canvas.getObjects(),
        activeObjectCenter = activeObject.getCenterPoint(),
        activeObjectLeft = activeObjectCenter.x,
        activeObjectTop = activeObjectCenter.y,
        activeObjectBoundingRect = activeObject.getBoundingRect(),
        activeObjectHeight = activeObjectBoundingRect.height / viewportTransform[3],
        activeObjectWidth = activeObjectBoundingRect.width / viewportTransform[0],
        horizontalInTheRange = false,
        verticalInTheRange = false,
        transform = canvas._currentTransform;

    //this occurs once on the start of mouse drag.
    if (cacheActiveObject) {
      cachedActiveDimension = {
        left: activeObjectLeft,
        top: activeObjectTop,
        width: activeObjectWidth,
        height: activeObjectHeight
      };
      cacheActiveObject = false;
    }

    if (!transform) return;

    // It should be trivial to DRY this up by encapsulating (repeating) creation of x1, x2, y1, and y2 into functions,
    // but we're not doing it here for perf. reasons -- as this a function that's invoked on every mouse move

    for (var i = canvasObjects.length; i--;) {

      var objectCenter = canvasObjects[i].getCenterPoint(),
          objectLeft = objectCenter.x,
          objectTop = objectCenter.y,
          objectBoundingRect = canvasObjects[i].getBoundingRect(),
          objectHeight = objectBoundingRect.height / viewportTransform[3],
          objectWidth = objectBoundingRect.width / viewportTransform[0];

      //we want to use the cached dimensions (original object location before drag) for the activeObject
      if (canvasObjects[i] === activeObject) {
        objectLeft = cachedActiveDimension.left;
        objectTop = cachedActiveDimension.top;
        objectHeight = cachedActiveDimension.height;
        objectWidth = cachedActiveDimension.width;
      }

      // snap by the horizontal center line
      if (isInRange(objectLeft, activeObjectLeft)) {
        verticalInTheRange = true;
        verticalLines.push({
          x: objectLeft,
          y1: objectTop < activeObjectTop ? objectTop - objectHeight / 2 - aligningLineOffset : objectTop + objectHeight / 2 + aligningLineOffset,
          y2: activeObjectTop > objectTop ? activeObjectTop + activeObjectHeight / 2 + aligningLineOffset : activeObjectTop - activeObjectHeight / 2 - aligningLineOffset
        });
        activeObject.setPositionByOrigin(new fabric.Point(objectLeft, activeObjectTop), 'center', 'center');
      }

      // snap by the left edge
      if (isInRange(objectLeft - objectWidth / 2, activeObjectLeft - activeObjectWidth / 2)) {
        verticalInTheRange = true;
        verticalLines.push({
          x: objectLeft - objectWidth / 2,
          y1: objectTop < activeObjectTop ? objectTop - objectHeight / 2 - aligningLineOffset : objectTop + objectHeight / 2 + aligningLineOffset,
          y2: activeObjectTop > objectTop ? activeObjectTop + activeObjectHeight / 2 + aligningLineOffset : activeObjectTop - activeObjectHeight / 2 - aligningLineOffset
        });
        activeObject.setPositionByOrigin(new fabric.Point(objectLeft - objectWidth / 2 + activeObjectWidth / 2, activeObjectTop), 'center', 'center');
      }

      // snap by the right edge
      if (isInRange(objectLeft + objectWidth / 2, activeObjectLeft + activeObjectWidth / 2)) {
        verticalInTheRange = true;
        verticalLines.push({
          x: objectLeft + objectWidth / 2,
          y1: objectTop < activeObjectTop ? objectTop - objectHeight / 2 - aligningLineOffset : objectTop + objectHeight / 2 + aligningLineOffset,
          y2: activeObjectTop > objectTop ? activeObjectTop + activeObjectHeight / 2 + aligningLineOffset : activeObjectTop - activeObjectHeight / 2 - aligningLineOffset
        });
        activeObject.setPositionByOrigin(new fabric.Point(objectLeft + objectWidth / 2 - activeObjectWidth / 2, activeObjectTop), 'center', 'center');
      }

      // snap by the vertical center line
      if (isInRange(objectTop, activeObjectTop)) {
        horizontalInTheRange = true;
        horizontalLines.push({
          y: objectTop,
          x1: objectLeft < activeObjectLeft ? objectLeft - objectWidth / 2 - aligningLineOffset : objectLeft + objectWidth / 2 + aligningLineOffset,
          x2: activeObjectLeft > objectLeft ? activeObjectLeft + activeObjectWidth / 2 + aligningLineOffset : activeObjectLeft - activeObjectWidth / 2 - aligningLineOffset
        });
        activeObject.setPositionByOrigin(new fabric.Point(activeObjectLeft, objectTop), 'center', 'center');
      }

      // snap by the top edge
      if (isInRange(objectTop - objectHeight / 2, activeObjectTop - activeObjectHeight / 2)) {
        horizontalInTheRange = true;
        horizontalLines.push({
          y: objectTop - objectHeight / 2,
          x1: objectLeft < activeObjectLeft ? objectLeft - objectWidth / 2 - aligningLineOffset : objectLeft + objectWidth / 2 + aligningLineOffset,
          x2: activeObjectLeft > objectLeft ? activeObjectLeft + activeObjectWidth / 2 + aligningLineOffset : activeObjectLeft - activeObjectWidth / 2 - aligningLineOffset
        });
        activeObject.setPositionByOrigin(new fabric.Point(activeObjectLeft, objectTop - objectHeight / 2 + activeObjectHeight / 2), 'center', 'center');
      }

      // snap by the bottom edge
      if (isInRange(objectTop + objectHeight / 2, activeObjectTop + activeObjectHeight / 2)) {
        horizontalInTheRange = true;
        horizontalLines.push({
          y: objectTop + objectHeight / 2,
          x1: objectLeft < activeObjectLeft ? objectLeft - objectWidth / 2 - aligningLineOffset : objectLeft + objectWidth / 2 + aligningLineOffset,
          x2: activeObjectLeft > objectLeft ? activeObjectLeft + activeObjectWidth / 2 + aligningLineOffset : activeObjectLeft - activeObjectWidth / 2 - aligningLineOffset
        });
        activeObject.setPositionByOrigin(new fabric.Point(activeObjectLeft, objectTop + objectHeight / 2 - activeObjectHeight / 2), 'center', 'center');
      }
    }

    if (!horizontalInTheRange) {
      horizontalLines.length = 0;
    }

    if (!verticalInTheRange) {
      verticalLines.length = 0;
    }
  });

  canvas.on('before:render', function () {
    canvas.clearContext(canvas.contextTop);
  });

  canvas.on('after:render', function () {
    for (var i = verticalLines.length; i--;) {
      drawVerticalLine(verticalLines[i]);
    }
    for (var i = horizontalLines.length; i--;) {
      drawHorizontalLine(horizontalLines[i]);
    }

    verticalLines.length = horizontalLines.length = 0;
  });

  canvas.on('mouse:up', function () {
    verticalLines.length = horizontalLines.length = 0;
    canvas.renderAll();
  });
}

/***/ }),

/***/ "jwGj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_authorize__ = __webpack_require__("lKgw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_accounts__ = __webpack_require__("aQz/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__wait__ = __webpack_require__("uBAG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_full_name_splitter__ = __webpack_require__("zImE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_full_name_splitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_full_name_splitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_track_events__ = __webpack_require__("Dg6a");













/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    user: null,
    anonymous: Object(__WEBPACK_IMPORTED_MODULE_7__services_authorize__["c" /* isAnonymous */])(),
    loginBusy: false,
    loginError: null,
    resetState: null, // 'busy', 'ok', 'error'
    resetMessage: null,
    userTeams: []
  },
  mutations: {
    setUser: function setUser(state, user) {
      state.user = user;
      state.anonymous = Object(__WEBPACK_IMPORTED_MODULE_7__services_authorize__["c" /* isAnonymous */])();
      state.loginBusy = false;
      state.loginError = null;
      if (user.hasOwnProperty('brandly_team')) {
        state.userTeams = user.brandly_team;
      }
    },
    mergeUser: function mergeUser(state, partialUser) {
      __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()(state.user, partialUser);
    },
    startLoggingIn: function startLoggingIn(state) {
      state.loginBusy = true;
      state.loginError = null;
    },
    errorLoggingIn: function errorLoggingIn(state, error) {
      if (error.response && error.response.data) {
        error = error.response.data;
      }

      state.user = null;
      state.loginBusy = false;
      state.loginError = error;
    },
    startReset: function startReset(state) {
      state.resetState = 'busy';
      state.resetMessage = null;
    },
    resetFailed: function resetFailed(state, e) {
      state.resetState = 'error';
      state.resetMessage = e.toString();
    },
    resetSuccess: function resetSuccess(state, msg) {
      state.resetState = 'ok';
      state.resetMessage = msg;
    },
    removeTeamFromUserTeams: function removeTeamFromUserTeams(state, teamID) {
      state.userTeams = state.userTeams.filter(function (t) {
        return t.id !== teamID;
      });
    }
  },
  actions: {
    authorize: function authorize(_ref) {
      var _this = this;

      var dispatch = _ref.dispatch;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Object(__WEBPACK_IMPORTED_MODULE_7__services_authorize__["b" /* authorize */])();
                _context.t0 = dispatch;
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_7__services_authorize__["e" /* userInfo */])();

              case 4:
                _context.t1 = _context.sent;
                (0, _context.t0)('setUser', _context.t1);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setUser: function setUser(_ref2, user) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch;

      commit('setUser', user);
      dispatch('resetDashboardUserState');
    },
    login: function login(_ref3, _ref4) {
      var _this2 = this;

      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;
      var username = _ref4.username,
          password = _ref4.password;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var user, errText, errDetails;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit('startLoggingIn');
                _context2.prev = 1;
                _context2.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_8__services_accounts__["d" /* login */])(username, password);

              case 4:
                user = _context2.sent;
                _context2.next = 7;
                return dispatch('setUser', user);

              case 7:
                _context2.next = 15;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](1);

                console.error(_context2.t0);
                errText = _context2.t0;

                try {
                  errDetails = _context2.t0.response.data;

                  if (errDetails.detail) {
                    errText = errDetails.detail;
                  }
                  if (errDetails.non_field_errors) {
                    errText = errDetails.non_field_errors.join(', ');
                  }
                  // fallback
                  if (errText === '[object Object]') {
                    // Log?
                    errText = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(errDetails);
                  }
                } catch (e2) {
                  console.error('Error while unwrapping.', e2);
                }
                commit('errorLoggingIn', errText);

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 9]]);
      }))();
    },
    logout: function logout(_ref5) {
      var _this3 = this;

      var dispatch = _ref5.dispatch;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                Object(__WEBPACK_IMPORTED_MODULE_8__services_accounts__["e" /* logout */])();
                // Authorize so there is a valid lazy user
                dispatch('authorize');

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    signUp: function signUp(_ref6, _ref7) {
      var _this4 = this;

      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;
      var username = _ref7.username,
          password = _ref7.password,
          confirm_password = _ref7.confirm_password,
          name = _ref7.name,
          first_name = _ref7.first_name,
          last_name = _ref7.last_name,
          team = _ref7.team,
          token = _ref7.token;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _splitter, _splitter2, payload, user;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                commit('startLoggingIn');
                _context4.prev = 1;

                if (!(password !== confirm_password)) {
                  _context4.next = 4;
                  break;
                }

                throw 'Passwords must match';

              case 4:
                if (name) {
                  ;
                  _splitter = __WEBPACK_IMPORTED_MODULE_10_full_name_splitter___default()(name);
                  _splitter2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_splitter, 2);
                  first_name = _splitter2[0];
                  last_name = _splitter2[1];
                }first_name = first_name || '';
                last_name = last_name || '';
                payload = { email: username, password: password, first_name: first_name, last_name: last_name, team: team, token: token };

                console.log(payload);
                _context4.next = 11;
                return Object(__WEBPACK_IMPORTED_MODULE_8__services_accounts__["g" /* signUp */])(payload);

              case 11:
                user = _context4.sent;
                _context4.next = 14;
                return dispatch('setUser', user);

              case 14:
                team ? Object(__WEBPACK_IMPORTED_MODULE_11__lib_track_events__["o" /* userJoinedTeam */])() : Object(__WEBPACK_IMPORTED_MODULE_11__lib_track_events__["p" /* userSignedUp */])();
                _context4.next = 20;
                break;

              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4['catch'](1);

                commit('errorLoggingIn', _context4.t0);

              case 20:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[1, 17]]);
      }))();
    },
    resetPassword: function resetPassword(_ref8, email) {
      var _this5 = this;

      var commit = _ref8.commit;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                commit('startReset');
                _context5.prev = 1;
                _context5.t0 = commit;
                _context5.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_8__services_accounts__["f" /* resetPassword */])(email);

              case 5:
                _context5.t1 = _context5.sent;
                (0, _context5.t0)('resetSuccess', _context5.t1);
                _context5.next = 15;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t2 = _context5['catch'](1);

                if (_context5.t2.response && _context5.t2.response.data) _context5.t2 = _context5.t2.response.data;
                if (_context5.t2.no_user || _context5.t2.email && _context5.t2.email.no_user) _context5.t2 = 'No user found for that email';
                if ((typeof _context5.t2 === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_context5.t2)) === 'object') {
                  console.log('Error sending reset email', _context5.t2);
                  _context5.t2 = 'Error sending reset email';
                }
                commit('resetFailed', _context5.t2.toString());

              case 15:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[1, 9]]);
      }))();
    },
    confirmReset: function confirmReset(_ref9, params) {
      var _this6 = this;

      var commit = _ref9.commit,
          dispatch = _ref9.dispatch;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var errText;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                commit('startLoggingIn');
                _context6.prev = 1;
                _context6.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_8__services_accounts__["a" /* confirmReset */])(params);

              case 4:
                dispatch('setUser', null);
                _context6.next = 13;
                break;

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6['catch'](1);
                errText = _context6.t0.toString();

                if (_context6.t0.new_password2) {
                  errText = _context6.t0.new_password2.join(', ');
                } else if (_context6.t0.token) {
                  // expired reset token
                  errText = "Password was already reset, please try your password again";
                }
                console.log(_context6.t0);
                commit('errorLoggingIn', errText);

              case 13:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[1, 7]]);
      }))();
    },
    socialAuth: function socialAuth(_ref10, _ref11) {
      var _this7 = this;

      var commit = _ref10.commit,
          dispatch = _ref10.dispatch;
      var provider = _ref11.provider,
          access_token = _ref11.access_token,
          code = _ref11.code;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var user, errText;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                commit('startLoggingIn');
                _context7.prev = 1;
                _context7.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_8__services_accounts__["h" /* socialAuth */])(provider, { access_token: access_token, code: code });

              case 4:
                user = _context7.sent;

                dispatch('setUser', user);
                Object(__WEBPACK_IMPORTED_MODULE_11__lib_track_events__["p" /* userSignedUp */])();
                _context7.next = 14;
                break;

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7['catch'](1);

                console.error(_context7.t0);
                errText = _context7.t0.toString();

                commit('errorLoggingIn', errText);

              case 14:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[1, 9]]);
      }))();
    },
    waitForLogin: function waitForLogin(context) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!context.getters.isAnonymous) {
                  _context8.next = 2;
                  break;
                }

                throw 'Not logged in';

              case 2:
                return _context8.abrupt('return', Object(__WEBPACK_IMPORTED_MODULE_9__wait__["a" /* waitFor */])('loggedIn', 2000));

              case 3:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    impersonate: function impersonate(_ref12, username) {
      var _this9 = this;

      var dispatch = _ref12.dispatch;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var user;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_8__services_accounts__["c" /* impersonate */])(username);

              case 2:
                user = _context9.sent;
                _context9.next = 5;
                return dispatch('setUser', user);

              case 5:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },
    reloadUser: function reloadUser(_ref13) {
      var _this10 = this;

      var dispatch = _ref13.dispatch;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var user;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_8__services_accounts__["b" /* getUser */])();

              case 2:
                user = _context10.sent;
                return _context10.abrupt('return', dispatch('setUser', user));

              case 4:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this10);
      }))();
    }
  },
  getters: {
    user: function user(state) {
      return state.user;
    },
    loginBusy: function loginBusy(state) {
      return state.loginBusy;
    },
    loginError: function loginError(state) {
      return state.loginError;
    },
    loginErrorText: function loginErrorText(state) {
      if (!state.loginError || typeof state.loginError === "string") return state.loginError;
      // Assume the object is a list of fields -> errors
      // Just drop the field names and return text.
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(state.loginError).join('. ');
    },

    loggedIn: function loggedIn(state) {
      return !!state.user && !state.user.is_lazy_user;
    },
    resetState: function resetState(state) {
      return state.resetState;
    },
    resetMessage: function resetMessage(state) {
      return state.resetMessage;
    },
    isAnonymous: function isAnonymous(state) {
      return state.anonymous;
    },
    isAdmin: function isAdmin(state) {
      return state.user && state.user.user_type == 'admin';
    },
    isStaff: function isStaff(state) {
      return state.user && state.user.is_staff;
    },
    userTeams: function userTeams(state) {
      return state.userTeams;
    }
  }
});

/***/ }),

/***/ "kBE9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kEqj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kHBW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kJc9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showAdminPreferences)?_c('div',[_c('h2',[_vm._v("Admin Preferences")]),_vm._v(" "),_c('Toggle',{attrs:{"trueLabel":"suppress","trueIcon":"ban","falseLabel":"send","falseIcon":"envelope"},model:{value:(_vm.suppressReviewEmails),callback:function ($$v) {_vm.suppressReviewEmails=$$v},expression:"suppressReviewEmails"}},[_c('template',{slot:"trueDescription"},[_vm._v("Suppress")]),_vm._v(" "),_c('template',{slot:"falseDescription"},[_vm._v("Send")]),_vm._v("\n    \"needs review\" emails\n  ")],2)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kR+s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kSec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setup_vue__ = __webpack_require__("3hM4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36550e7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Setup_vue__ = __webpack_require__("3Cm2");
function injectStyle (ssrContext) {
  __webpack_require__("JTlq")
  __webpack_require__("0YTx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36550e7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36550e7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Setup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "kVJo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomepageWideLayout',{attrs:{"heroDark":""}},[_c('section',[_c('SecondaryHeader',[_c('h2',[_vm._v("How it works")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("\n        Follow these\n        "),_c('strong',[_vm._v("three easy steps")]),_vm._v(" to unshackle yourself from the old way of ordering business cards.\n      ")])]),_vm._v(" "),_c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',{attrs:{"id":"image-right"}},[_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"parent"},[_c('div',{staticClass:"copy-container",attrs:{"id":"last"}},[_c('div',{staticClass:"copy"},[_c('p',{staticClass:"eyebrow"},[_vm._v("STEP 1")]),_vm._v(" "),_c('h2',[_vm._v("Open your free company portal")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("Give your organization a productivity boost. Faster, easier online ordering for everyone, admin tools to manage designs, team members, shipping and billing in one place.")]),_vm._v(" "),_c('router-link',{staticClass:"learn-more",attrs:{"to":"/signup","title":""}},[_vm._v("Open your free portal >")])],1)])])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"parent-2"},[_c('div',{staticClass:"parent-image"},[_c('img',{staticClass:"child-image-right",attrs:{"src":"/static/images/howitworks/step1.png","alt":"earn section hero"}})])])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',{attrs:{"id":"image-left"}},[_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"parent-2"},[_c('div',{staticClass:"parent-image"},[_c('img',{staticClass:"child-image-left",attrs:{"src":"/static/images/howitworks/step2.png","alt":"earn section hero"}})])])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"parent"},[_c('div',{staticClass:"copy-container",attrs:{"id":"last"}},[_c('div',{staticClass:"copy"},[_c('p',{staticClass:"eyebrow"},[_vm._v("STEP 2")]),_vm._v(" "),_c('h2',[_vm._v("Set up your business card design")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("Just upload your design and within seconds you'll have an editable (and shareable) online template matching your brand identity. Goodbye design software, hello Brandly.")]),_vm._v(" "),_c('router-link',{staticClass:"learn-more",attrs:{"to":"/signup","title":""}},[_vm._v("Upload your design >")])],1)])])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',{attrs:{"id":"image-right"}},[_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"parent"},[_c('div',{staticClass:"copy-container",attrs:{"id":"last"}},[_c('div',{staticClass:"copy"},[_c('p',{staticClass:"eyebrow"},[_vm._v("STEP 3")]),_vm._v(" "),_c('h2',[_vm._v("Invite team members to order")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("Account admins can order for your entire organization, but for lights-out efficiency, invite team members to self-order their business cards as needed. No design skills required.")]),_vm._v(" "),_c('router-link',{staticClass:"learn-more",attrs:{"to":"/signup","title":""}},[_vm._v("Get started >")])],1)])])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"parent-2",attrs:{"id":"step3-wrapper"}},[_c('div',{staticClass:"parent-image"},[_c('img',{attrs:{"id":"step3","src":"/static/images/howitworks/step3.png","alt":"earn section hero"}})])])])],1)],1)],1),_vm._v(" "),_c('Demo')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kb0k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kq8p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kuvY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressVerification_vue__ = __webpack_require__("o6dd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_658530e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressVerification_vue__ = __webpack_require__("hUuU");
function injectStyle (ssrContext) {
  __webpack_require__("lCys")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressVerification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_658530e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressVerification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "l7eF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l7iL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LineDetailProductForm__ = __webpack_require__("Zz4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { LineDetailProductForm: __WEBPACK_IMPORTED_MODULE_1__LineDetailProductForm__["a" /* default */] },
  props: {
    line: Object,
    order: Object,
    canDelete: Boolean,
    canChange: Boolean
  },
  data: function data() {
    return {
      changing: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['flags']), {
    canEditDesign: function canEditDesign() {
      return this.flags.approvalEditDesign;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['deleteOrderLine']), {
    changeProduct: function changeProduct() {
      // Show the full product editing machinery
      this.changing = true;
    },
    deleteLine: function deleteLine() {
      return this.deleteOrderLine({ line: this.line.id });
    },
    editDesign: function editDesign() {
      var unlock = this.flags.approvalEditDesignUnlocks ? 'yes' : undefined;
      this.$router.push({
        name: 'Editor',
        params: {
          id: this.line.designId,
          from: 'orders/' + this.order.id
        },
        query: {
          fill: 'no',
          unlock: unlock
        }
      });
    }
  })
});

/***/ }),

/***/ "l9ZU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Welcome_vue__ = __webpack_require__("QVrB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67f131bb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Welcome_vue__ = __webpack_require__("7sms");
function injectStyle (ssrContext) {
  __webpack_require__("R/vV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67f131bb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Welcome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67f131bb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Welcome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "lB86":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block"}},[(_vm.dragging)?_c('div',{staticClass:"overlay-dropzone",on:{"drop":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDrop($event)},"dragover":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragOver($event)},"dragenter":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragEnter($event)},"dragleave":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragLeave($event)}}},[_c('i',{staticClass:"fas fa-upload"})]):_vm._e(),_vm._v(" "),(!_vm.flags.legacy)?_c('div',{staticClass:"input-group"},[(_vm.controlStyle === 'combo')?_c('input',{staticClass:"form-control",attrs:{"name":"filename","placeholder":"Upload PDF File","type":"text"},on:{"focus":_vm.startBrowsing}}):_vm._e(),_vm._v(" "),_c('span',{class:'input-group-btn controlStyle-' + _vm.controlStyle},[_c('label',{class:("btn browse-button " + _vm.btnClass),attrs:{"for":"file"}},[(_vm.busy)?_c('WaveSpinner',{attrs:{"inline":"","color":_vm.waveColor}}):_c('span',[_vm._t("default",[_vm._v("Browse…")])],2),_vm._v(" "),_c('input',{ref:"file",staticClass:"file-upload",staticStyle:{"display":"none"},attrs:{"id":"file","type":"file"},on:{"change":_vm.onFileSelected}})],1)])]):_c('b-button',{class:_vm.btnClass,attrs:{"disabled":"","title":"Upload not possible on IE"}},[_vm._v("Upload")]),_vm._v(" "),(_vm.error)?_vm._t("error",[_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))])]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lCys":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lHkn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.options)?_c('div',{staticClass:"dropdown"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchFilter),expression:"searchFilter"}],staticClass:"dropdown-input",attrs:{"name":_vm.name,"disabled":_vm.disabled,"placeholder":_vm.placeholder},domProps:{"value":(_vm.searchFilter)},on:{"focus":function($event){return _vm.showOptions()},"blur":function($event){return _vm.exit()},"keyup":_vm.keyMonitor,"input":function($event){if($event.target.composing){ return; }_vm.searchFilter=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchFilter.length > 0),expression:"searchFilter.length > 0"}],staticClass:"input-clear-button",on:{"click":function($event){return _vm.selectOption({})}}},[_c('i',{staticClass:"fa fa-times"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.optionsShown && _vm.options.length > 0),expression:"optionsShown && options.length > 0"}],staticClass:"dropdown-content"},_vm._l((_vm.filteredOptions),function(option){return _c('div',{key:option.id,staticClass:"dropdown-item",on:{"mousedown":function($event){return _vm.selectOption(option)}}},[_vm._v("\n      "+_vm._s(option.name || option.id || '-')+"\n    ")])}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lKgw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = setAuthState;
/* harmony export (immutable) */ __webpack_exports__["b"] = authorize;
/* harmony export (immutable) */ __webpack_exports__["c"] = isAnonymous;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authHeaders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return userInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tiny_cookie__ = __webpack_require__("+FgK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tiny_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_tiny_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mungeAddress__ = __webpack_require__("RYrk");



var requestToken = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(token) {
    var method, url, response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (token === FAKE_TOKEN) token = null;
            method = 'post';
            url = {"API":"https://www.brandly.com/backend/","APP":"https://www.brandly.com","STATIC":false}.API + 'api/v1/auth/api-token-' + (token ? 'refresh' : 'anonymous') + '/';

            if ({"API":"https://www.brandly.com/backend/","APP":"https://www.brandly.com","STATIC":false}.STATIC) {
              method = 'get';
              url += 'post.json';
            }
            _context.prev = 4;
            _context.next = 7;
            return __WEBPACK_IMPORTED_MODULE_3_axios___default.a[method](url, { token: token });

          case 7:
            response = _context.sent;
            _context.next = 15;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context['catch'](4);

            if (token) {
              _context.next = 14;
              break;
            }

            throw _context.t0;

          case 14:
            return _context.abrupt('return', requestToken());

          case 15:
            setAuthState(response.data);

          case 16:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[4, 10]]);
  }));

  return function requestToken(_x) {
    return _ref2.apply(this, arguments);
  };
}();





var JWT_COOKIE = 'jwtToken';
var JWT_COOKIE_OPTS = {}; // TODO choose opts... mimic current app?
var jwtToken, pending, currentUser;

function setAuthState(_ref) {
  var token = _ref.token,
      user = _ref.user;

  jwtToken = token;
  currentUser = Object(__WEBPACK_IMPORTED_MODULE_4__mungeAddress__["a" /* fromApiAddressFormat */])(user);
  if (jwtToken) {
    Object(__WEBPACK_IMPORTED_MODULE_2_tiny_cookie__["setRawCookie"])(JWT_COOKIE, jwtToken, JWT_COOKIE_OPTS);
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_2_tiny_cookie__["removeCookie"])(JWT_COOKIE, JWT_COOKIE_OPTS);
  }
  return currentUser;
}

/**
 * Kick off authorization process. Should be called before any services.
 */
function authorize() {
  if (jwtToken) return;
  pending = requestToken(Object(__WEBPACK_IMPORTED_MODULE_2_tiny_cookie__["getRawCookie"])(JWT_COOKIE));
}

/**
 * Return whether user is anonymous or real (but without verifying with server).
 * If there is no established user, return true (ie, assume anonymous). This
 * function can be called upon page load.
 */
function isAnonymous() {
  if (currentUser) return !currentUser.email;
  var jwt = Object(__WEBPACK_IMPORTED_MODULE_2_tiny_cookie__["getRawCookie"])(JWT_COOKIE);
  if (!jwt) return true;
  return isTokenAnonymous(jwt);
}
function isTokenAnonymous(jwt) {
  // Decode the jwt payload
  try {
    var payload = JSON.parse(atob(jwt.split('.')[1]));
    return !payload.email;
  } catch (e) {
    // Invalid cookie / coding issue
    // Assume anonymous
    console.error(e, jwt);
    return true;
  }
}

// This must match the value in /services/.../api-token-anonymous/post.json
var FAKE_TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE1OTI5NDY1MzQsImVtYWlsIjoiIiwib3JpZ19pYXQiOjE1NjE0MTA1MzQsInVzZXJfaWQiOjUyLCJ1c2VybmFtZSI6IjY5ODYyZDQ2MWZiMDRhMWNiZjIxMTNkNjU2ZWJiYTE0In0.nYrZN19nRp_s6dklvbYiFxf6JiOj1SgohYGW31TsRo4";
console.assert(isTokenAnonymous(FAKE_TOKEN));

var authHeaders = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (jwtToken) {
              _context2.next = 3;
              break;
            }

            _context2.next = 3;
            return pending;

          case 3:
            return _context2.abrupt('return', jwtToken ? { 'Authorization': 'Bearer ' + jwtToken } : {});

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function authHeaders() {
    return _ref3.apply(this, arguments);
  };
}();

var userInfo = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (currentUser) {
              _context3.next = 3;
              break;
            }

            _context3.next = 3;
            return pending;

          case 3:
            return _context3.abrupt('return', currentUser);

          case 4:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function userInfo() {
    return _ref4.apply(this, arguments);
  };
}();

/***/ }),

/***/ "lUDa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CustomerInfo__ = __webpack_require__("GuAU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__basket_BasketSummary__ = __webpack_require__("uf7q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CheckoutPayment__ = __webpack_require__("I0FD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ReturningCustomerLogin__ = __webpack_require__("7OeA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CheckoutReviewSettings__ = __webpack_require__("Mxjm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OrderReviewMessage__ = __webpack_require__("JZed");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_CheckoutLogic__ = __webpack_require__("KrFv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__("NYxO");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CustomerInfo: __WEBPACK_IMPORTED_MODULE_4__CustomerInfo__["a" /* default */],
    BasketSummary: __WEBPACK_IMPORTED_MODULE_5__basket_BasketSummary__["a" /* default */],
    CheckoutPayment: __WEBPACK_IMPORTED_MODULE_6__CheckoutPayment__["a" /* default */],
    ReturningCustomerLogin: __WEBPACK_IMPORTED_MODULE_7__ReturningCustomerLogin__["a" /* default */],
    CheckoutReviewSettings: __WEBPACK_IMPORTED_MODULE_8__CheckoutReviewSettings__["a" /* default */],
    OrderReviewMessage: __WEBPACK_IMPORTED_MODULE_9__OrderReviewMessage__["a" /* default */]
  },
  data: function data() {
    return {
      user: false,
      payment: Object(__WEBPACK_IMPORTED_MODULE_10__lib_CheckoutLogic__["d" /* empty_payment */])(),
      showLogin: false,
      showCreateAccount: false,
      showIssues: false,
      verifying: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapActions */])(['updateCheckoutInfo', 'loadStripe', 'updatePaymentInfo', 'placeOrder', 'calcTax', 'loadSavedCards', 'verifyShippingAddressData', 'setDefaultCheckoutInfo']), Object(__WEBPACK_IMPORTED_MODULE_11_vuex__["d" /* mapMutations */])(['removeShippingAddressVerification']), {
    onSubmit: function onSubmit() {
      this.showIssues = true;
      this.placeOrder();
    },
    onMouseOver: function onMouseOver() {
      this.showIssues = true;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_11_vuex__["c" /* mapGetters */])(['checkoutInfo', 'loggedIn', 'orderInfo', 'paymentInfoComplete', 'checkoutIssues', 'checkoutBusy', 'needsPayment', 'hasCardOnFile', 'canSaveCardOnFile', 'flags', 'shippingAddressVerification', 'isShippingAddressValid']), {
    billing: checkoutAccessor('billing'),
    shipping: checkoutAccessor('shipping'),
    skip_review: checkoutAccessor('skip_review'),
    copiedShipping: function copiedShipping() {
      // We want to verify address each time it changes. But we cannot use `shipping` directly in `watch`
      // because of `Vue` limitations for mutated Objects/Arrays (https://vuejs.org/v2/api/#vm-watch).
      // `copiedShipping` is a workaround for this case (it is used in `watch`).
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.shipping);
    },

    billing_different_address: checkoutAccessor('billing_different_address'),
    checkoutErrors: function checkoutErrors() {
      return this.showIssues ? this.checkoutIssues : [];
    },
    busy: function busy() {
      return this.checkoutBusy;
    },
    showLoginLink: function showLoginLink() {
      return !this.loggedIn;
    },
    showCreateAccountOption: function showCreateAccountOption() {
      return !this.loggedIn;
    }
  }),
  watch: {
    loggedIn: function loggedIn(newVal, oldVal) {
      console.log('loggedIn changed:', newVal, oldVal);
    },
    checkoutErrors: function checkoutErrors(val) {
      // If any errors mention tax, try to fix
      if (val && val.find(function (s) {
        return (/tax/i.test(s)
        );
      })) {
        this.calcTax();
      }
    },

    payment: {
      deep: true,
      handler: function handler(value) {
        this.updatePaymentInfo(value);
      }
    },
    orderInfo: {
      deep: true,
      handler: function handler(value) {
        if (value.placed) {
          this.$router.push('/invoice');
        }
      }
    },
    copiedShipping: function copiedShipping(newVal, oldVal) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isCountryChanged, isLine1Changed, isLine2Changed, isPostcodeChanged, isCityChanged, isStateChanged, isMainDataChanged;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.flags.verifyCheckoutShippingAddressData && Object(__WEBPACK_IMPORTED_MODULE_10__lib_CheckoutLogic__["f" /* isAddressComplete */])(newVal, __WEBPACK_IMPORTED_MODULE_10__lib_CheckoutLogic__["a" /* ADDRESS_TYPE_VERIFY */]))) {
                  _context.next = 14;
                  break;
                }

                // For address verification we are care only about "address related" fields
                isCountryChanged = newVal.country !== oldVal.country;
                isLine1Changed = newVal.line1 !== oldVal.line1;
                isLine2Changed = newVal.line2 !== oldVal.line2;
                isPostcodeChanged = newVal.postcode !== oldVal.postcode;
                isCityChanged = newVal.city !== oldVal.city;
                isStateChanged = newVal.state !== oldVal.state;
                isMainDataChanged = isCountryChanged || isLine1Changed || isLine2Changed || isPostcodeChanged || isCityChanged || isStateChanged;

                if (!isMainDataChanged) {
                  _context.next = 14;
                  break;
                }

                _this.removeShippingAddressVerification();
                _this.verifying = true;
                _context.next = 13;
                return _this.verifyShippingAddressData(newVal);

              case 13:
                _this.verifying = false;

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mounted: function mounted() {
    this.loadStripe();
    this.setDefaultCheckoutInfo();
  }
});

function checkoutAccessor(field) {
  return {
    get: function get() {
      return this.checkoutInfo[field];
    },
    set: function set(value) {
      this.updateCheckoutInfo(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.checkoutInfo, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, field, value)));
    }
  };
}

/***/ }),

/***/ "lb5r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['team', 'token'],
  data: function data() {
    return {
      name: '',
      email: '',
      password: '',
      error: ''
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['joinTeamName', 'joinTeamLoaded', 'loginErrorText']),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // TODO wait until user is loaded/not loaded
              _this.loadJoinTeamData({ team: _this.team, token: _this.token });

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['signUp', 'loadJoinTeamData']), {
    submit: function submit() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var req, last;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                req = [];

                if (!_this2.name) req.push('Name');
                if (!_this2.email) req.push('Email');
                if (!_this2.password) req.push('Password');

                if (!(req.length === 1)) {
                  _context2.next = 7;
                  break;
                }

                _this2.error = req[0] + ' is required';
                return _context2.abrupt('return');

              case 7:
                if (!(req.length > 1)) {
                  _context2.next = 11;
                  break;
                }

                last = req.pop();

                _this2.error = req.join(', ') + ' and ' + last + ' are required';
                return _context2.abrupt('return');

              case 11:
                _context2.next = 13;
                return _this2.signUp({
                  team: _this2.team,
                  token: _this2.token,
                  name: _this2.name,
                  username: _this2.email,
                  email: _this2.email,
                  password: _this2.password,
                  confirm_password: _this2.password
                });

              case 13:
                if (_this2.loginErrorText) {
                  _this2.error = _this2.loginErrorText;
                } else {
                  _this2.$router.push('/setup');
                }

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  })
});

/***/ }),

/***/ "lwls":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"upload-box"},[_c('div',{staticClass:"action-card"},[_c('h2',[_vm._v("Upload Your Business Card Template")]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"uploader"},[_c('PdfUploader',_vm._g({staticClass:"width-adjust",attrs:{"extra":_vm.extra}},_vm.$listeners))],1),_vm._v(" "),_c('p',{staticClass:"movie"},[_c('WistiaMovie',{attrs:{"asset":"g7myk15el0"}},[_vm._v("Watch movie\n          "),_c('i',{staticClass:"fa fa-play-circle"}),_vm._v(" for file preparation tips")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"placeholder"}},[_c('img',{staticClass:"svg",attrs:{"src":"/static/images/upload/upload-bleed.svg"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lwsu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditorControlsOverlay_vue__ = __webpack_require__("xLm3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0544b698_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditorControlsOverlay_vue__ = __webpack_require__("rTBJ");
function injectStyle (ssrContext) {
  __webpack_require__("9+Cu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0544b698"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditorControlsOverlay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0544b698_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditorControlsOverlay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m+BL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Restrictions',{model:{value:(_vm.settings),callback:function ($$v) {_vm.settings=$$v},expression:"settings"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mCqg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mDBc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TeamMemberList_vue__ = __webpack_require__("Z/fi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MemberDetail_vue__ = __webpack_require__("ojJB");

//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  children: [{
    path: '',
    name: 'team-member-list',
    component: __WEBPACK_IMPORTED_MODULE_1__TeamMemberList_vue__["a" /* default */]
  }, {
    path: ':id',
    name: 'member-detail',
    component: __WEBPACK_IMPORTED_MODULE_2__MemberDetail_vue__["a" /* default */],
    // Ensure that `id` is always passed as a number
    props: function props(route) {
      var props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, route.params);
      props.id = +props.id;
      return props;
    }
  }]
});

/***/ }),

/***/ "mFB8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_checkout__ = __webpack_require__("/HXe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_dashboard__ = __webpack_require__("39Xj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_common__ = __webpack_require__("Cvgy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_products__ = __webpack_require__("6TJt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_productAttrs__ = __webpack_require__("X9yx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__wait__ = __webpack_require__("uBAG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_stripe__ = __webpack_require__("5Lgr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_full_name_splitter__ = __webpack_require__("zImE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_full_name_splitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_full_name_splitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lib_selectedProduct__ = __webpack_require__("D3mI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lib_track_events__ = __webpack_require__("Dg6a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lib_track_identify__ = __webpack_require__("tOs8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services_design__ = __webpack_require__("VFA2");






















function emptyTeam() {
  return { members: [] };
}

function emptyTemplate() {
  return {
    id: null,
    template: null,
    product: null,
    default_qty: null,
    name: null
  };
}

function emptyMember() {
  return {};
}

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    teamInfo: {
      team: emptyTeam(),
      template: emptyTemplate(),
      loaded: false,
      busy: false,
      member: emptyMember(),
      members: []
    },
    recentInfo: {
      orders: null,
      busy: false,
      pageNumber: 1,
      totalOrders: 0
    },
    productInfo: {
      productRecs: null
    },
    cardInfo: {
      cards: null
    },
    allTeamInfo: {
      teams: [],
      busy: false,
      loaded: false,
      pageNumber: 1,
      totalTeams: 0,
      pendingPayload: null
    },
    usersInfo: {
      users: [],
      busy: false,
      pageNumber: 1,
      totalUsers: 0,
      pendingPayload: null
    }
  },
  mutations: {
    setRecentOrders: function setRecentOrders(state, orders) {
      state.recentInfo = { orders: orders, loaded: true, busy: false };
    },
    setOrdersPaginated: function setOrdersPaginated(state, _ref) {
      var results = _ref.results,
          count = _ref.count,
          pageNumber = _ref.pageNumber;

      state.recentInfo = { orders: results, totalOrders: count, pageNumber: pageNumber, loaded: true, busy: false };
    },
    startRecentOrders: function startRecentOrders(state) {
      state.recentInfo.busy = true;
    },
    resetDashboardUserState: function resetDashboardUserState(state) {
      state.recentInfo = { orders: null, busy: false };
      state.teamInfo = {
        team: emptyTeam(), template: emptyTemplate(), loaded: false, busy: false, member: emptyMember(), members: []
      };
    },
    setTeamInfo: function setTeamInfo(state, team) {
      if (team.templates) {
        // Remove this data, so that we can be sure no logic is relying on it.
        // TODO remove from back end
        console.log('team.templates still set!');
        delete team.templates;
      }
      state.teamInfo.team = team;
      state.teamInfo.member = team.member;

      state.teamInfo.busy = false;
      state.teamInfo.loaded = true;
    },
    setCurrentMember: function setCurrentMember(state, id) {
      state.teamInfo.member = state.teamInfo.members.find(function (m) {
        return m.id === id;
      });
    },
    setTeamMembers: function setTeamMembers(state, members) {
      state.teamInfo.members = members;
      state.teamInfo.busy = false;
    },
    determineCurrentProductTemplate: function determineCurrentProductTemplate(state, user) {
      var product_template = void 0;
      var product_templates = state.teamInfo.team ? state.teamInfo.team.product_templates : null;
      if (!product_templates || product_templates.length === 0) {
        state.teamInfo.template = emptyTemplate();
        return;
      }
      var currentId = user && user.current_producttemplate;
      if (currentId && product_templates) {
        // Try to find the template id in the product_templates
        product_template = product_templates.find(function (p) {
          return p.id === currentId;
        });
      }
      // Default to the first product_template
      if (!product_template) product_template = product_templates[0];
      state.teamInfo.template = product_template || emptyTemplate();
    },
    startTeamInfo: function startTeamInfo(state, promise) {
      state.teamInfo.busy = promise;
    },
    setProductRecs: function setProductRecs(state, productRecs) {
      state.productInfo.productRecs = productRecs;
    },
    updateProductTemplate: function updateProductTemplate(state, _ref2) {
      var id = _ref2.id,
          product_template = _ref2.product_template;

      if (id === undefined) id = product_template.id;

      var product_templates = state.teamInfo.team.product_templates;
      var index = product_templates.findIndex(function (p) {
        return p.id === id;
      });
      if (index === -1) throw 'product_template not found';
      product_templates.splice(index, 1, product_template);

      if (state.teamInfo.template && state.teamInfo.template.id === id) {
        state.teamInfo.template = product_template;
      }
    },
    createProductTemplate: function createProductTemplate(state, product_template) {
      // We expect no existing product_templates
      // Caller should update user's current_producttemplate
      state.teamInfo.team.product_templates.push(product_template);
      state.teamInfo.template = product_template;
    },
    setCurrentProductTemplate: function setCurrentProductTemplate(state, product_template_id) {
      // Caller should update user's current_producttemplate
      var product_template = state.teamInfo.team.product_templates.find(function (p) {
        return p.id === product_template_id;
      });
      if (!product_template) {
        // Not found -- no effect
        return;
      }
      state.teamInfo.template = product_template;
    },
    setSavedCards: function setSavedCards(state, cards) {
      state.cardInfo.cards = cards;
    },
    setTeamsLoadingIsBusy: function setTeamsLoadingIsBusy(state) {
      state.allTeamInfo.busy = true;
    },
    setTeamsPaginated: function setTeamsPaginated(state, _ref3) {
      var results = _ref3.results,
          count = _ref3.count,
          pageNumber = _ref3.pageNumber;

      state.allTeamInfo = { teams: results, totalTeams: count, pageNumber: pageNumber, busy: false, loaded: true };
    },
    setTeamsLoadingPending: function setTeamsLoadingPending(state, payload) {
      state.allTeamInfo.pendingPayload = payload;
    },
    updateMember: function updateMember(state, userInfo) {
      // User info got updated. sync with values in the team.users and member.
      var _state$teamInfo = state.teamInfo,
          team = _state$teamInfo.team,
          member = _state$teamInfo.member;

      if (member && member.id === userInfo.id) __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()(member, userInfo);
    },
    setUsersLoadingIsBusy: function setUsersLoadingIsBusy(state) {
      state.usersInfo.busy = true;
    },
    setUsersPaginated: function setUsersPaginated(state, _ref4) {
      var results = _ref4.results,
          count = _ref4.count,
          pageNumber = _ref4.pageNumber;

      state.usersInfo = { users: results, totalUsers: count, pageNumber: pageNumber, busy: false };
    },
    setUsersLoadingPending: function setUsersLoadingPending(state, payload) {
      state.usersInfo.pendingPayload = payload;
    }
  },
  actions: {
    /**
     * Loads recent orders. No action if the orders were recently loaded.
     *
     * @param {*} context
     */
    loadRecentOrders: function loadRecentOrders(context) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
        var orderList;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(context.state.recentInfo.orders !== null)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                context.commit('startRecentOrders');
                _context.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_8__services_checkout__["c" /* orders */])();

              case 5:
                orderList = _context.sent;

                context.commit('setRecentOrders', orderList);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    /**
     * Load orders for provided page.
     */
    loadOrdersPaginated: function loadOrdersPaginated(_ref5, payload) {
      var _this2 = this;

      var commit = _ref5.commit;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref6, results, count, pageNumber;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit('startRecentOrders');
                _context2.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_8__services_checkout__["d" /* ordersPaginated */])(payload);

              case 3:
                _ref6 = _context2.sent;
                results = _ref6.results;
                count = _ref6.count;
                pageNumber = payload.pageNumber;

                commit('setOrdersPaginated', { results: results, count: count, pageNumber: pageNumber });

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    updateRecentOrders: function updateRecentOrders(context) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var orderList;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(context.state.recentInfo.orders === null)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                context.commit('startRecentOrders');
                _context3.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_8__services_checkout__["c" /* orders */])();

              case 5:
                orderList = _context3.sent;

                context.commit('setRecentOrders', orderList);

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    reOrder: function reOrder(_ref7, orderId) {
      var _this4 = this;

      var dispatch = _ref7.dispatch;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_8__services_checkout__["f" /* postReOrder */])(orderId);

              case 2:
                _context4.next = 4;
                return dispatch('reloadBasket');

              case 4:
                _context4.next = 6;
                return __WEBPACK_IMPORTED_MODULE_16__router__["a" /* default */].push({ name: 'Cart' });

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    loadTeamInfo: function loadTeamInfo(_ref8) {
      var _this5 = this;

      var dispatch = _ref8.dispatch,
          state = _ref8.state;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!state.teamInfo.loaded) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt('return');

              case 2:
                if (!state.teamInfo.busy) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt('return', state.teamInfo.busy);

              case 4:
                dispatch('reloadTeamInfo');

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    reloadTeamInfo: function reloadTeamInfo(context) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var promise, teamData;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                promise = Object(__WEBPACK_IMPORTED_MODULE_9__services_dashboard__["o" /* team */])();

                context.commit('startTeamInfo', promise);
                _context6.next = 4;
                return promise;

              case 4:
                teamData = _context6.sent;

                context.commit('setTeamInfo', teamData);
                context.dispatch('setTeamFlags');
                context.commit('determineCurrentProductTemplate', context.getters.user);

              case 8:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    loadTeamMembers: function loadTeamMembers(_ref9) {
      var _this7 = this;

      var dispatch = _ref9.dispatch,
          getters = _ref9.getters;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(getters.members && getters.members.length > 0 || getters.isTeamBusy)) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt('return');

              case 2:
                return _context7.abrupt('return', dispatch('reloadTeamMembers'));

              case 3:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    reloadTeamMembers: function reloadTeamMembers(_ref10) {
      var _this8 = this;

      var commit = _ref10.commit;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                commit('startTeamInfo', true);
                _context8.t0 = commit;
                _context8.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_dashboard__["f" /* getCurrentTeamUsers */])();

              case 4:
                _context8.t1 = _context8.sent;
                (0, _context8.t0)('setTeamMembers', _context8.t1);

              case 6:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    loadTeamMember: function loadTeamMember(_ref11, id) {
      var _this9 = this;

      var dispatch = _ref11.dispatch;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return dispatch('loadTeamInfo');

              case 2:
                return _context9.abrupt('return', dispatch('setTeamMember', id));

              case 3:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },
    setTeamMember: function setTeamMember(_ref12, id) {
      var _this10 = this;

      var dispatch = _ref12.dispatch,
          commit = _ref12.commit,
          getters = _ref12.getters;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return dispatch('loadTeamMembers');

              case 2:
                commit('setCurrentMember', id);
                return _context10.abrupt('return', dispatch('loadMemberAddresses', id));

              case 4:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this10);
      }))();
    },
    setDesignAsTemplate: function setDesignAsTemplate(_ref13) {
      var _this11 = this;

      var getters = _ref13.getters,
          dispatch = _ref13.dispatch;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var template;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                // Set the current design as the team template
                template = getters.designId;
                _context11.next = 3;
                return dispatch('updateProductTemplate', { template: template });

              case 3:
                Object(__WEBPACK_IMPORTED_MODULE_18__lib_track_events__["b" /* designSetTemplate */])();

              case 4:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this11);
      }))();
    },
    updateTeam: function updateTeam(_ref14, updates) {
      var _this12 = this;

      var getters = _ref14.getters,
          commit = _ref14.commit;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var teamData;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                console.log('updateTeam', getters.teamId, updates);
                commit('startTeamInfo');
                // This returns team data but the templates are not serialized in normal way,
                // so make a second call.
                _context12.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_dashboard__["q" /* updateTeam */])(getters.teamId, updates);

              case 4:
                _context12.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_dashboard__["o" /* team */])();

              case 6:
                teamData = _context12.sent;

                commit('setTeamInfo', teamData);
                commit('determineCurrentProductTemplate', getters.user);
                Object(__WEBPACK_IMPORTED_MODULE_19__lib_track_identify__["a" /* default */])(getters.user, getters.team);

              case 10:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this12);
      }))();
    },
    updateProfile: function updateProfile(_ref15, updates) {
      var _this13 = this;

      var getters = _ref15.getters,
          commit = _ref15.commit;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                console.log('updateProfile', updates);
                _context13.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_dashboard__["p" /* updateProfile */])(updates);

              case 3:
                result = _context13.sent;

                console.log('->', result);
                result.id = getters.user.id;
                commit('mergeUser', result);
                commit('updateMember', result);

              case 8:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this13);
      }))();
    },
    updateUserProfile: function updateUserProfile(_ref17, _ref16) {
      var _this14 = this;

      var commit = _ref17.commit,
          dispatch = _ref17.dispatch;

      var id = _ref16.id,
          updates = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_objectWithoutProperties___default()(_ref16, ['id']);

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                console.log('updateUserProfile', id, updates);
                commit('updateMember', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({ id: id }, updates));
                _context14.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_dashboard__["s" /* updateUserProfile */])(id, updates);

              case 4:
                result = _context14.sent;

                console.log('->', result);
                return _context14.abrupt('return', dispatch('reloadTeamInfo'));

              case 7:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this14);
      }))();
    },

    /**
    * resetDashboardUserState -- must be called when logged in user changes
    */
    resetDashboardUserState: function resetDashboardUserState(_ref18) {
      var _this15 = this;

      var commit = _ref18.commit,
          getters = _ref18.getters,
          dispatch = _ref18.dispatch;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee15() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                commit('resetDashboardUserState');

                if (getters.isAnonymous) {
                  _context15.next = 4;
                  break;
                }

                _context15.next = 4;
                return dispatch('loadTeamInfo');

              case 4:
                commit('updateMember', getters.user);

              case 5:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this15);
      }))();
    },
    loadProductRecs: function loadProductRecs(_ref19) {
      var _this16 = this;

      var state = _ref19.state,
          commit = _ref19.commit;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var productRecs;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                if (!state.productInfo.productRecs) {
                  _context16.next = 2;
                  break;
                }

                return _context16.abrupt('return');

              case 2:
                commit('setProductRecs', []); // signal loading in process
                _context16.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_11__services_products__["a" /* products */])('any');

              case 5:
                productRecs = _context16.sent;

                commit('setProductRecs', productRecs);

              case 7:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, _this16);
      }))();
    },
    updateProductTemplate: function updateProductTemplate(_ref20, updates) {
      var _this17 = this;

      var state = _ref20.state,
          getters = _ref20.getters,
          commit = _ref20.commit;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee17() {
        var id, product_template, _team, _product_template;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                // Updates the current product template. Creates one if necessary.
                id = getters.productTemplate.id;


                if (updates.product && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(updates.product) === 'object') {
                  updates.product = updates.product.id;
                }
                if (updates.template && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(updates.template) === 'object') {
                  updates.template = updates.template.id;
                }

                if (!id) {
                  _context17.next = 11;
                  break;
                }

                _context17.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_dashboard__["r" /* updateTeamProductTemplate */])(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, updates, { id: id }));

              case 6:
                product_template = _context17.sent;

                console.log('updates->', product_template);
                commit('updateProductTemplate', { product_template: product_template });
                _context17.next = 18;
                break;

              case 11:
                // Creates a product template
                _team = getters.teamId;
                _context17.next = 14;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_dashboard__["c" /* createProductTeamTemplate */])(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, updates, { team: _team }));

              case 14:
                _product_template = _context17.sent;

                console.log('create->', _product_template);
                if (id === 0) {
                  commit('updateProductTemplate', { id: id, product_template: _product_template });
                } else {
                  commit('createProductTemplate', _product_template);
                }
                commit('setCurrentProductTemplate', _product_template.id);

              case 18:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, _this17);
      }))();
    },
    deleteProductTemplates: function deleteProductTemplates(_ref21) {
      var _this18 = this;

      var getters = _ref21.getters,
          dispatch = _ref21.dispatch;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee18() {
        var id;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                // For debugging purposes, resets all product templates for team
                id = getters.productTemplate.id;

                if (!id) {
                  _context18.next = 4;
                  break;
                }

                _context18.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_dashboard__["k" /* removeTeamProductTemplate */])(id);

              case 4:
                return _context18.abrupt('return', dispatch('reloadTeamInfo'));

              case 5:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, _this18);
      }))();
    },
    startOrderFromProductTemplate: function startOrderFromProductTemplate(_ref22, orderedFor) {
      var _this19 = this;

      var getters = _ref22.getters,
          dispatch = _ref22.dispatch;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee19() {
        var _getters$productTempl, product, default_qty, id;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _getters$productTempl = getters.productTemplate, product = _getters$productTempl.product, default_qty = _getters$productTempl.default_qty, id = _getters$productTempl.template.id;
                _context19.next = 3;
                return dispatch('startDesignFromTemplate', id);

              case 3:
                return _context19.abrupt('return', dispatch('addToCart', {
                  productUrl: product.url,
                  boxSize: default_qty,
                  designId: getters.designId,
                  quantity: 1,
                  orderedFor: orderedFor
                }));

              case 4:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, _this19);
      }))();
    },
    setCurrentProductTemplate: function setCurrentProductTemplate(_ref23, id) {
      var _this20 = this;

      var dispatch = _ref23.dispatch,
          commit = _ref23.commit;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee20() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                dispatch('updateProfile', { current_producttemplate: id });
                commit('setCurrentProductTemplate', id);

              case 2:
              case 'end':
                return _context20.stop();
            }
          }
        }, _callee20, _this20);
      }))();
    },
    addProductTemplate: function addProductTemplate(_ref24) {
      var _this21 = this;

      var commit = _ref24.commit,
          getters = _ref24.getters;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee21() {
        var pt, cur;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                pt = emptyTemplate(), cur = getters.productTemplate;

                pt.default_qty = cur.default_qty;
                pt.product = cur.product.id;
                pt.id = 0; // mark as unsaved, but in list
                commit('createProductTemplate', pt);

              case 5:
              case 'end':
                return _context21.stop();
            }
          }
        }, _callee21, _this21);
      }))();
    },
    cloneProductTemplate: function cloneProductTemplate(_ref25) {
      var _this22 = this;

      var dispatch = _ref25.dispatch,
          commit = _ref25.commit,
          getters = _ref25.getters;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee22() {
        var id, cloned;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                id = getters.productTemplate.template.id; // may error

                _context22.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_20__services_design__["a" /* clone */])(id, true);

              case 3:
                cloned = _context22.sent;
                _context22.next = 6;
                return dispatch('addProductTemplate');

              case 6:
                _context22.next = 8;
                return dispatch('updateProductTemplate', { template: cloned.id });

              case 8:
              case 'end':
                return _context22.stop();
            }
          }
        }, _callee22, _this22);
      }))();
    },
    createClient: function createClient(context, clientTeamInfo) {
      var _this23 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee23() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_dashboard__["b" /* createClient */])(context.getters.teamId, clientTeamInfo);

              case 2:
                return _context23.abrupt('return', context.dispatch('reloadTeamInfo'));

              case 3:
              case 'end':
                return _context23.stop();
            }
          }
        }, _callee23, _this23);
      }))();
    },
    enterTeam: function enterTeam(_ref26, teamId) {
      var _this24 = this;

      var dispatch = _ref26.dispatch,
          commit = _ref26.commit,
          getters = _ref26.getters;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee24() {
        var teamData;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                // Reset stored `TeamAddresses` before switching to another team
                commit('resetTeamAddresses');

                _context24.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_dashboard__["n" /* switchTeam */])(teamId);

              case 3:
                teamData = _context24.sent;

                commit('setTeamInfo', teamData);

                // The user info is out of date.
                _context24.next = 7;
                return dispatch('reloadUser');

              case 7:
                commit('determineCurrentProductTemplate', getters.user);

                // Ensure flags don't carry from one team to other
                return _context24.abrupt('return', dispatch('resetFlags'));

              case 9:
              case 'end':
                return _context24.stop();
            }
          }
        }, _callee24, _this24);
      }))();
    },
    loadSavedCards: function loadSavedCards(_ref27) {
      var _this25 = this;

      var state = _ref27.state,
          dispatch = _ref27.dispatch,
          commit = _ref27.commit,
          getters = _ref27.getters;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee25() {
        var cards;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                if (!(state.cardInfo.cards !== null)) {
                  _context25.next = 2;
                  break;
                }

                return _context25.abrupt('return');

              case 2:
                _context25.next = 4;
                return dispatch('waitForTeam');

              case 4:
                _context25.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_dashboard__["m" /* savedCards */])(getters.teamId);

              case 6:
                cards = _context25.sent;

                commit('setSavedCards', cards || []);

              case 8:
              case 'end':
                return _context25.stop();
            }
          }
        }, _callee25, _this25);
      }))();
    },
    waitForTeam: function waitForTeam(_ref28) {
      var _this26 = this;

      var dispatch = _ref28.dispatch,
          getters = _ref28.getters;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee26() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.next = 2;
                return dispatch('waitForLogin');

              case 2:
                // Ensure the team is getting loaded
                dispatch('loadTeamInfo');
                // Then the team needs to be loaded
                _context26.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_13__wait__["a" /* waitFor */])('hasTeam', 4000);

              case 5:
              case 'end':
                return _context26.stop();
            }
          }
        }, _callee26, _this26);
      }))();
    },
    deleteSavedCard: function deleteSavedCard(_ref29, cardId) {
      var _this27 = this;

      var dispatch = _ref29.dispatch,
          commit = _ref29.commit,
          getters = _ref29.getters;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee27() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_dashboard__["d" /* deleteSavedCard */])(getters.teamId, cardId);

              case 2:
                // Cause a reload
                commit('setSavedCards', null);
                return _context27.abrupt('return', dispatch('loadSavedCards'));

              case 4:
              case 'end':
                return _context27.stop();
            }
          }
        }, _callee27, _this27);
      }))();
    },
    addSavedCard: function addSavedCard(_ref30, info) {
      var _this28 = this;

      var dispatch = _ref30.dispatch,
          commit = _ref30.commit,
          getters = _ref30.getters;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee28() {
        var name, first_name, last_name, title, available_to_team, _splitter, _splitter2, stripeResult;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                // createToken expects first and last name to be split.
                // Split if needed.
                name = info.name, first_name = info.first_name, last_name = info.last_name, title = info.title, available_to_team = info.available_to_team;

                if (name) {
                  ;
                  _splitter = __WEBPACK_IMPORTED_MODULE_15_full_name_splitter___default()(name);
                  _splitter2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_splitter, 2);
                  first_name = _splitter2[0];
                  last_name = _splitter2[1];
                } // createToken expects payment and address as separate objects.
                // Passing the same objects works
                _context28.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_14__services_stripe__["a" /* createToken */])(info, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({ first_name: first_name, last_name: last_name }, info));

              case 4:
                stripeResult = _context28.sent;

                if (stripeResult) {
                  _context28.next = 7;
                  break;
                }

                throw new Error('Unable to get stripe token');

              case 7:
                _context28.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_dashboard__["a" /* addSavedCard */])(getters.teamId, stripeResult.id, title, available_to_team);

              case 9:
                // Cause a reload
                commit('setSavedCards', null);
                return _context28.abrupt('return', dispatch('loadSavedCards'));

              case 11:
              case 'end':
                return _context28.stop();
            }
          }
        }, _callee28, _this28);
      }))();
    },
    editSavedCard: function editSavedCard(_ref31, info) {
      var _this29 = this;

      var dispatch = _ref31.dispatch,
          commit = _ref31.commit,
          getters = _ref31.getters;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee29() {
        var id, title, available_to_team;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                // Edit the title/private attributes from the card
                id = info.id, title = info.title, available_to_team = info.available_to_team;
                _context29.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_dashboard__["e" /* editSavedCard */])(getters.teamId, { id: id, title: title, available_to_team: available_to_team });

              case 3:
                commit('setSavedCards', null);
                // Cause a reload
                return _context29.abrupt('return', dispatch('loadSavedCards'));

              case 5:
              case 'end':
                return _context29.stop();
            }
          }
        }, _callee29, _this29);
      }))();
    },
    loadStripe: function loadStripe(context) {
      var _this30 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee30() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                return _context30.abrupt('return', Object(__WEBPACK_IMPORTED_MODULE_14__services_stripe__["b" /* loadStripe */])());

              case 1:
              case 'end':
                return _context30.stop();
            }
          }
        }, _callee30, _this30);
      }))();
    },
    deleteUser: function deleteUser(_ref32, id) {
      var _this31 = this;

      var dispatch = _ref32.dispatch;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee31() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_dashboard__["l" /* removeUser */])(id);

              case 2:
                return _context31.abrupt('return', dispatch('reloadTeamInfo'));

              case 3:
              case 'end':
                return _context31.stop();
            }
          }
        }, _callee31, _this31);
      }))();
    },
    removeFromTeam: function removeFromTeam(_ref33, user) {
      var _this32 = this;

      var getters = _ref33.getters,
          dispatch = _ref33.dispatch;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee32() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                _context32.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_dashboard__["j" /* removeFromTeam */])(getters.team.id, user.id);

              case 2:
                return _context32.abrupt('return', dispatch('reloadTeamInfo'));

              case 3:
              case 'end':
                return _context32.stop();
            }
          }
        }, _callee32, _this32);
      }))();
    },
    loadTeamsPaginated: function loadTeamsPaginated(_ref34, payload) {
      var _this33 = this;

      var state = _ref34.state,
          commit = _ref34.commit,
          dispatch = _ref34.dispatch;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee33() {
        var _ref35, results, count, pageNumber;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                if (!state.allTeamInfo.busy) {
                  _context33.next = 2;
                  break;
                }

                return _context33.abrupt('return', commit('setTeamsLoadingPending', payload));

              case 2:

                commit('setTeamsLoadingIsBusy');
                _context33.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_10__services_common__["a" /* getItemsPaginated */])(__WEBPACK_IMPORTED_MODULE_9__services_dashboard__["g" /* getTeams */], payload);

              case 5:
                _ref35 = _context33.sent;
                results = _ref35.results;
                count = _ref35.count;
                pageNumber = payload.pageNumber;

                commit('setTeamsPaginated', { results: results, count: count, pageNumber: pageNumber });
                return _context33.abrupt('return', dispatch('loadTeamsPaginatedPending'));

              case 11:
              case 'end':
                return _context33.stop();
            }
          }
        }, _callee33, _this33);
      }))();
    },
    loadTeamsPaginatedPending: function loadTeamsPaginatedPending(_ref36) {
      var _this34 = this;

      var state = _ref36.state,
          commit = _ref36.commit,
          dispatch = _ref36.dispatch;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee34() {
        var pendingPayload;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                pendingPayload = state.allTeamInfo.pendingPayload;

                if (!pendingPayload) {
                  _context34.next = 4;
                  break;
                }

                commit('setTeamsLoadingPending', null);
                return _context34.abrupt('return', dispatch('loadTeamsPaginated', pendingPayload));

              case 4:
              case 'end':
                return _context34.stop();
            }
          }
        }, _callee34, _this34);
      }))();
    },
    loadUsersPaginated: function loadUsersPaginated(_ref37, payload) {
      var _this35 = this;

      var state = _ref37.state,
          commit = _ref37.commit,
          dispatch = _ref37.dispatch;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee35() {
        var _ref38, results, count, pageNumber;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                if (!state.usersInfo.busy) {
                  _context35.next = 2;
                  break;
                }

                return _context35.abrupt('return', commit('setUsersLoadingPending', payload));

              case 2:

                commit('setUsersLoadingIsBusy');
                _context35.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_10__services_common__["a" /* getItemsPaginated */])(__WEBPACK_IMPORTED_MODULE_9__services_dashboard__["h" /* getUsers */], payload);

              case 5:
                _ref38 = _context35.sent;
                results = _ref38.results;
                count = _ref38.count;
                pageNumber = payload.pageNumber;

                commit('setUsersPaginated', { results: results, count: count, pageNumber: pageNumber });
                return _context35.abrupt('return', dispatch('loadUsersPaginatedPending'));

              case 11:
              case 'end':
                return _context35.stop();
            }
          }
        }, _callee35, _this35);
      }))();
    },
    loadUsersPaginatedPending: function loadUsersPaginatedPending(_ref39) {
      var _this36 = this;

      var state = _ref39.state,
          commit = _ref39.commit,
          dispatch = _ref39.dispatch;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee36() {
        var pendingPayload;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                pendingPayload = state.usersInfo.pendingPayload;

                if (!pendingPayload) {
                  _context36.next = 4;
                  break;
                }

                commit('setUsersLoadingPending', null);
                return _context36.abrupt('return', dispatch('loadUsersPaginated', pendingPayload));

              case 4:
              case 'end':
                return _context36.stop();
            }
          }
        }, _callee36, _this36);
      }))();
    },
    makeClient: function makeClient(_ref40, teamId) {
      var _this37 = this;

      var getters = _ref40.getters;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee37() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                _context37.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_dashboard__["q" /* updateTeam */])(teamId, { agency: getters.teamId });

              case 2:
              case 'end':
                return _context37.stop();
            }
          }
        }, _callee37, _this37);
      }))();
    },
    removeClient: function removeClient(_ref41, teamId) {
      var _this38 = this;

      var getters = _ref41.getters;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee38() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                _context38.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_dashboard__["q" /* updateTeam */])(teamId, { agency: null });

              case 2:
              case 'end':
                return _context38.stop();
            }
          }
        }, _callee38, _this38);
      }))();
    },
    setTeamFlags: function setTeamFlags(_ref42) {
      var _this39 = this;

      var dispatch = _ref42.dispatch,
          getters = _ref42.getters;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee39() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                if (getters.team.flags) {
                  dispatch('updateFlags', getters.team.flags);
                }

              case 1:
              case 'end':
                return _context39.stop();
            }
          }
        }, _callee39, _this39);
      }))();
    },
    saveTeamFlags: function saveTeamFlags(_ref43) {
      var _this40 = this;

      var dispatch = _ref43.dispatch,
          getters = _ref43.getters;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee40() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                dispatch('updateTeam', { flags: getters.cleanFlags });

              case 1:
              case 'end':
                return _context40.stop();
            }
          }
        }, _callee40, _this40);
      }))();
    }
  },
  getters: {
    hasTeam: function hasTeam(state) {
      return state.teamInfo.loaded;
    },
    team: function team(state) {
      return state.teamInfo.team || {};
    },
    teamId: function teamId(state) {
      return (state.teamInfo.team || {}).id;
    },
    isTeamBusy: function isTeamBusy(state) {
      return state.teamInfo.busy;
    },
    member: function member(state) {
      return state.teamInfo.member || {};
    },
    members: function members(state) {
      return state.teamInfo.members ? state.teamInfo.members : [];
    },
    recentOrders: function recentOrders(state) {
      return state.recentInfo.orders;
    },
    recentOrdersBusy: function recentOrdersBusy(state) {
      return state.recentInfo.busy;
    },
    pageNumberOrders: function pageNumberOrders(state) {
      return state.recentInfo.pageNumber;
    },
    totalOrders: function totalOrders(state) {
      return state.recentInfo.totalOrders;
    },
    requireProductTemplateChoice: function requireProductTemplateChoice(state) {
      var team = state.teamInfo.team;

      if (!team || !team.product_templates || team.product_templates.length < 2) return false;
      return (team.default_orderer_settings || {}).current_producttemplate === '*choose*';
    },
    productTemplates: function productTemplates(state) {
      var _ref44 = state.teamInfo.team || {},
          _ref44$product_templa = _ref44.product_templates,
          product_templates = _ref44$product_templa === undefined ? [] : _ref44$product_templa;

      return product_templates.map(function (pt, ix) {
        // Decorate product templates with names if not previously named
        if (!pt.name) pt.name = ix ? 'Design ' + (ix + 1) : 'Main Design';
        return pt;
      });
    },
    hasMultipleProductTemplates: function hasMultipleProductTemplates(state) {
      var _ref45 = state.teamInfo.team || {},
          _ref45$product_templa = _ref45.product_templates,
          product_templates = _ref45$product_templa === undefined ? [] : _ref45$product_templa;

      return product_templates.length > 1;
    },
    productTemplate: function productTemplate(state) {
      return state.teamInfo.template;
    },
    productTemplatePreviewUrls: function productTemplatePreviewUrls(state) {
      var _state$teamInfo$templ = state.teamInfo.template.template,
          template = _state$teamInfo$templ === undefined ? {} : _state$teamInfo$templ;

      return template && template.pages && template.pages.map(function (p) {
        return p.preview_data_url;
      });
    },
    productTemplateDesignId: function productTemplateDesignId(state) {
      var _ref46 = state.teamInfo.template || {},
          template = _ref46.template;

      return template && template.id;
    },
    productTemplateIsRounded: function productTemplateIsRounded(state) {
      var t = state.teamInfo.template;
      return t && t.product && Object(__WEBPACK_IMPORTED_MODULE_12__lib_productAttrs__["a" /* isRounded */])(t.product);
    },
    productTemplateAttrs: function productTemplateAttrs(state, getters) {
      var pt = state.teamInfo.template,
          pr = state.productInfo.productRecs;
      if (pt && pt.product && pr) {
        return getProductAttrs(pt.product, pr);
      }
      return {};
    },
    productRecs: function productRecs(state) {
      return state.productInfo.productRecs;
    },
    impersonating: function impersonating(state) {
      return (state.teamInfo.team || {}).impersonating;
    },
    savedCards: function savedCards(state) {
      return state.cardInfo.cards || [];
    },
    savedCardsLoaded: function savedCardsLoaded(state) {
      return state.cardInfo.cards !== null;
    },
    defaultSavedCard: function defaultSavedCard(state) {
      var cards = state.cardInfo.cards;

      console.log('cards', cards);
      // For now return the first one.
      // TODO store last used on users profile
      // TODO is the ordering consistent/sensible?
      // TODO choose "Default" if its there
      if (cards && cards.length > 0) return cards[0].id;
      return null;
    },
    approvalSettings: function approvalSettings(state) {
      return (state.teamInfo.team || {}).approval_settings || {};
    },
    approvalEnabled: function approvalEnabled(state, getters) {
      var mode = getters.approvalSettings.approvalMode;
      return mode && mode !== 'none';
    },
    personalInfoSettings: function personalInfoSettings(state) {
      return (state.teamInfo.team || {}).personal_info_settings || {};
    },
    allTeams: function allTeams(state) {
      return state.allTeamInfo.teams;
    },
    allTeamsBusy: function allTeamsBusy(state) {
      return state.allTeamInfo.busy;
    },
    pageNumberTeams: function pageNumberTeams(state) {
      return state.allTeamInfo.pageNumber;
    },
    totalTeams: function totalTeams(state) {
      return state.allTeamInfo.totalTeams;
    },
    users: function users(state) {
      return state.usersInfo.users;
    },
    usersBusy: function usersBusy(state) {
      return state.usersInfo.busy;
    },
    pageNumberUsers: function pageNumberUsers(state) {
      return state.usersInfo.pageNumber;
    },
    totalUsers: function totalUsers(state) {
      return state.usersInfo.totalUsers;
    },
    // Whether to force invoicing as checkout method
    // Backend allows invoice, front end doesn't give choice.
    forceInvoice: function forceInvoice(state) {
      return (state.teamInfo.team || {}).allow_invoice;
    },
    userSettings: function userSettings(state, getters) {
      return getters.user && getters.user.settings || {};
    }
  }
});

function getProductAttrs(product, productRecs) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(productRecs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref47 = _step.value;
      var vendorProduct = _ref47.product;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(vendorProduct.prices), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref48 = _step2.value;
          var stockrecord = _ref48.stockrecord;

          if (+Object(__WEBPACK_IMPORTED_MODULE_17__lib_selectedProduct__["c" /* idFromProductUrl */])(stockrecord.product) === product.id) {
            // We have the correct vendorProduct. extract attrs
            var result = { paper: vendorProduct.name };
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(vendorProduct.attributes), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var _ref49 = _step3.value;
                var sku_tag = _ref49.sku_tag;

                var _sku_tag$split = sku_tag.split(':'),
                    _sku_tag$split2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_sku_tag$split, 2),
                    key = _sku_tag$split2[0],
                    value = _sku_tag$split2[1];

                result[key] = value;
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }

            return result;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return {};
}

/***/ }),

/***/ "mKdL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Address_vue__ = __webpack_require__("Jn/n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5db3117a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Address_vue__ = __webpack_require__("Vo6e");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Address_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5db3117a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Address_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "mYss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[(_vm.obj.prev)?_c('span',{staticClass:"icon left",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.obj.prev()}}},[_c('i',{staticClass:"fas fa-chevron-left"})]):_vm._e(),_vm._v(" "),(_vm.obj.next)?_c('span',{staticClass:"icon right",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.obj.next()}}},[_c('i',{staticClass:"fas fa-chevron-right"})]):_vm._e(),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.obj.title||_vm.obj.name))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "moCD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selected)?_c('div',{staticClass:"layer"},[_c('b-container',[_c('div',{staticClass:"table-wrapper"},[_c('div',{staticClass:"centered"},[_c('div',{staticClass:"inside-wrapper"},[_c('div',{staticClass:"controls"},[_c('b-form-select',{staticStyle:{"max-width":"12em"},attrs:{"options":_vm.categories},model:{value:(_vm.cur),callback:function ($$v) {_vm.cur=$$v},expression:"cur"}}),_vm._v(" "),_c('b-form-radio-group',{attrs:{"id":"pricing-grid-corners","buttons":"","options":['Square', 'Rounded']},model:{value:(_vm.corners),callback:function ($$v) {_vm.corners=$$v},expression:"corners"}})],1),_vm._v(" "),_c('PricingTable',{attrs:{"category":_vm.cur,"corners":_vm.corners}})],1)])])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "moM2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mpvc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['obj']
});

/***/ }),

/***/ "mvsB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TitlePrevNext_vue__ = __webpack_require__("mpvc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74474036_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TitlePrevNext_vue__ = __webpack_require__("mYss");
function injectStyle (ssrContext) {
  __webpack_require__("kBE9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74474036"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TitlePrevNext_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74474036_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TitlePrevNext_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "mxwC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineItem_vue__ = __webpack_require__("hZEz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37611423_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineItem_vue__ = __webpack_require__("52Su");
function injectStyle (ssrContext) {
  __webpack_require__("7e19")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-37611423"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37611423_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n0l+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36d192da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Portal_vue__ = __webpack_require__("Luf5");
function injectStyle (ssrContext) {
  __webpack_require__("7C3i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36d192da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36d192da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Portal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nEbw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditTeam_vue__ = __webpack_require__("YbXp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_324dbcd5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditTeam_vue__ = __webpack_require__("9F4c");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditTeam_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_324dbcd5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditTeam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nFjB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ProgressDots',{staticClass:"d-none d-sm-block",attrs:{"step":"3","steps":['Accept invitation', 'Enter details', 'Choose Design', 'Place order']}}),_vm._v(" "),_c('b-container',[_c('h1',{staticClass:"d-sm-none"},[_vm._v("Choose Design")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"chooser-area",attrs:{"md":"8"}},[_c('div',{staticClass:"chooser-width"},[_c('TemplateChooser',{attrs:{"no-edit":""}})],1),_vm._v(" "),_c('ProductTemplatePreview',{staticClass:"preview"})],1),_vm._v(" "),_c('b-col',{staticClass:"d-none d-md-block",attrs:{"md":"4"}},[_c('div',{staticClass:"action-card"},[_c('h2',[_vm._v("Choose Your Design")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn-action sidebar-purchase-link",on:{"click":_vm.onContinue}},[_c('span',[_vm._v("Continue")]),_vm._v(" "),_c('i',{staticClass:"fa fa-arrow-right"})])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"fixed-menu d-md-none"},[_c('div',{staticClass:"fixed-menu-body"},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"btn-action sidebar-purchase-link",on:{"click":_vm.onContinue}},[_c('span',[_vm._v("Continue")]),_vm._v(" "),_c('i',{staticClass:"fa fa-arrow-right"})])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-hint"},[_c('a',{attrs:{"href":"mailto:support@brandly.com"}},[_vm._v("Need help?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nILu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nN2H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomepageSecondaryLayout',[_c('div',{staticClass:"wrapper",attrs:{"id":"support"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9",attrs:{"id":"main-content"}},[(_vm.topic)?_c('div',[_c('ol',{staticClass:"breadcrumb"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/support"}},[_vm._v("FAQs")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active"},[_vm._v(_vm._s(_vm.name))])]),_vm._v(" "),_c('h2',{staticClass:"topic-header"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('ul',_vm._l((_vm.questions),function(question,key){return _c('li',{key:key},[_c('h5',{staticClass:"faq"},[_vm._v(_vm._s(question.q))]),_vm._v(" "),_c('p',{staticClass:"answer",domProps:{"innerHTML":_vm._s(question.a)}}),_vm._v(" "),_c('p',{staticClass:"link",domProps:{"innerHTML":_vm._s(question.l)}})])}),0)]):_c('div',{staticClass:"content"},[_c('ul',{staticClass:"question-container"},_vm._l((_vm.topics),function(topic,key){return _c('li',{key:key,staticClass:"topic"},[_c('h3',[_vm._v(_vm._s(topic.name))]),_vm._v(" "),_c('ul',{staticClass:"question"},_vm._l((topic.questions),function(question,slug){return _c('li',{key:slug},[_c('a',{attrs:{"href":'/support/'+key+'/'+slug}},[_vm._v(_vm._s(question.q))])])}),0),_vm._v(" "),_c('a',{staticClass:"button-small",attrs:{"href":'/support/'+key}},[_vm._v("View all")])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-md-3",attrs:{"id":"sidebar"}},[_c('div',{staticClass:"contact"},[_c('h3',[_vm._v("Contact us")]),_vm._v(" "),_c('a',{staticClass:"button-medium",attrs:{"href":"/contact"}},[_vm._v("Email support")])]),_vm._v(" "),_c('div',{staticClass:"topics"},[_c('h3',[_vm._v("Help topics")]),_vm._v(" "),_c('ul',{staticClass:"help-topics"},_vm._l((_vm.topics),function(topic,key){return _c('li',{key:key},[_c('router-link',{attrs:{"to":{name: 'Support', params: {topic: key}}}},[_vm._v(_vm._s(topic.name))])],1)}),0)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nRpE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderDetailCommon_vue__ = __webpack_require__("x9yb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41659cac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderDetailCommon_vue__ = __webpack_require__("G5mD");
function injectStyle (ssrContext) {
  __webpack_require__("kHBW")
  __webpack_require__("L2oh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41659cac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderDetailCommon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41659cac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderDetailCommon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nXIs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DashboardBase',{attrs:{"children":_vm.children}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nlQn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InlineEditToggle_vue__ = __webpack_require__("qGyP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05a3a3ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InlineEditToggle_vue__ = __webpack_require__("gX93");
function injectStyle (ssrContext) {
  __webpack_require__("JXDa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05a3a3ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InlineEditToggle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05a3a3ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InlineEditToggle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "npM1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignIn_vue__ = __webpack_require__("EURA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b4e9d98_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignIn_vue__ = __webpack_require__("SRy8");
function injectStyle (ssrContext) {
  __webpack_require__("7Rgv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b4e9d98"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b4e9d98_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ntQ2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__ = __webpack_require__("03dJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76fad2c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__ = __webpack_require__("fnM9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76fad2c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "o+FB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',{attrs:{"id":"gain-control"}},[_c('b-col',{attrs:{"sm":"12","lg":"7"}},[_c('div',{staticClass:"parent-2 gain-control-images",attrs:{"id":"portal"}},[_c('div',{staticClass:"parent-image"},[_c('img',{staticClass:"child-image",attrs:{"id":"brandly-dash","src":"/static/images/homepage/dashboard.png","alt":"An awesome dashboard"}})]),_vm._v(" "),_c('div',{staticClass:"parent-image-2"},[_c('img',{staticClass:"child-image-2",attrs:{"id":"brandly-dash-2","src":"/static/images/homepage/edit.png","alt":"A fantastic editor"}})])])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"5"}},[_c('SummaryBlock',[_c('p',{staticClass:"eyebrow"},[_vm._v("WHY GET A BRANDLY PORTAL?")]),_vm._v(" "),_c('h2',[_vm._v("\n            Business cards for teams, made simple.\n          ")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("\n            Easier, faster, and more cost-effective. Brandly is the #1 business\n            card portal for companies of all sizes. Get ready to learn why.\n          ")]),_vm._v(" "),_c('b-button',{staticClass:"white-on-red",attrs:{"href":"#scroll-to-signup","variant":"primary"}},[_vm._v("Kick the tires")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o+lR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o3pX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"btn btn-secondary",attrs:{"to":"/signup"}},[_vm._v("OPEN YOUR FREE PORTAL")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o5N7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return { preApproved: false };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['approvalSettings', 'approvers', 'checkoutInfo']), {
    showReviewSettings: function showReviewSettings() {
      var _approvalSettings = this.approvalSettings,
          approvalMode = _approvalSettings.approvalMode,
          approverDesignation = _approvalSettings.approverDesignation;

      if (!approvalMode) return; // approval not set up
      if (this.checkoutInfo.skip_review) return; // approval skipped
      return approverDesignation === 'chooseOnCheckout';
    },
    showManagerNotify: function showManagerNotify() {
      // We show this whether or not approval is enabled.
      return this.approvalSettings.requireNotifyEmail;
    },
    approverOptions: function approverOptions() {
      return this.approvers.map(function (_ref) {
        var name = _ref.name,
            email = _ref.email;
        return { text: name + ' (' + email + ')', value: email };
      });
    }
  }),
  mounted: function mounted() {
    this.loadApprovers();
  },

  methods: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['loadApprovers'])
});

/***/ }),

/***/ "o6dd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_addresses__ = __webpack_require__("FUN9");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    address: { type: Object, required: true },
    addressType: { type: String, required: false },
    onVerificationFinish: { type: Function, required: true }
  },
  data: function data() {
    return {
      isBusy: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["flags"]), {
    addressVerification: function addressVerification() {
      return this.address && this.address.address_verification;
    },
    addressVerificationData: function addressVerificationData() {
      if (this.addressVerification) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.addressVerification.verification_data, null, 2);
      }
    },
    addressVerificationStatus: function addressVerificationStatus() {
      if (this.addressVerification) {
        if (this.addressVerification.is_valid) {
          return '<span class="popover-heading-valid">Valid</span>';
        }
        return '<span class="popover-heading-invalid">Invalid</span>';
      }
      return 'Unvalidated';
    },
    getAddressType: function getAddressType() {
      return this.addressType ? this.addressType : this.address.type;
    },
    getIcon: function getIcon() {
      var iconStatic = '<i class="fas fa-cog light-blue"></i>';
      var iconDynamic = '<i class="fas fa-cog fa-spin light-blue"></i>';
      return this.isBusy ? iconDynamic : iconStatic;
    }
  }),
  methods: {
    showVerificationData: function showVerificationData() {
      if (this.addressVerification) {
        this.$refs['verification-data-modal'].show();
      }
    },
    verifyAddress: function verifyAddress() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isBusy = true;
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_addresses__["g" /* putVerifyAddress */])(_this.address.id, _this.getAddressType);

              case 3:
                _this.onVerificationFinish();
                _this.isBusy = false;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),

/***/ "oIea":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileLeftNav_vue__ = __webpack_require__("9f50");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fa3c35b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileLeftNav_vue__ = __webpack_require__("OEQ+");
function injectStyle (ssrContext) {
  __webpack_require__("2O9G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1fa3c35b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileLeftNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fa3c35b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileLeftNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oJ6o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oK/h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditSavedCard_vue__ = __webpack_require__("K1U0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_305dea59_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditSavedCard_vue__ = __webpack_require__("0C1I");
function injectStyle (ssrContext) {
  __webpack_require__("nILu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-305dea59"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditSavedCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_305dea59_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditSavedCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oKOy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomepageWideLayout',[_c('ProgressDots',{attrs:{"step":"1","steps":['Accept invitation', 'Enter details', 'Place order']}}),_vm._v(" "),_c('b-container',{staticClass:"invite-content text-center"},[_c('h1',[_vm._v("Join "+_vm._s(_vm.joinTeamName||'Team'))]),_vm._v(" "),_c('h2',[_vm._v("You have been invited"),_c('br'),_vm._v("to order business cards")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[(_vm.joinTeamLoaded)?_c('div',{staticClass:"signup-fieldset"},[_c('b-form-input',{staticClass:"signup-account-input",attrs:{"placeholder":"Your name","required":"required","type":"text","autofocus":"autofocus","name":"name"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('b-form-input',{staticClass:"signup-account-input",attrs:{"placeholder":"Your Email","required":"required","type":"email","name":"email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('b-form-input',{staticClass:"signup-account-input",attrs:{"placeholder":"Password","required":"required","type":"password","autofocus":"autofocus","name":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('b-btn',{staticClass:"wide-btn",attrs:{"variant":"default","size":"lg"},on:{"click":_vm.submit}},[_vm._v("Join Team")]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()],1):_vm._e()])],1),_vm._v(" "),_c('p',{staticClass:"fineprint"},[_vm._v("See a mistake or don't want to accept the invite? Just close the window.\n    "),_c('br'),_vm._v("\n    Questions? "),_c('router-link',{attrs:{"to":"/contact"}},[_vm._v("Contact us")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oM9P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oXYQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "obOs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value'],
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['hasMultipleProductTemplates', 'productTemplates']), {
    templateOptions: function templateOptions() {
      return this.productTemplates.map(function (pt) {
        return { value: pt.id, text: pt.name };
      });
    },
    templateDefaultOptions: function templateDefaultOptions() {
      return this.templateOptions.concat({ value: '*choose*', text: 'Choose during signup' });
    },

    currentTemplate: {
      get: function get() {
        return (this.value || {}).current_producttemplate || this.productTemplates[0].id;
      },
      set: function set(value) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
          var settings;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  settings = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this.value || {}, { current_producttemplate: value });

                  console.log('$emit input', settings);
                  _this.$emit('input', settings);

                case 3:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }))();
      }
    },
    restrictDesign: emitValueAccessor('restrictDesign'),
    restrictQty: emitValueAccessor('restrictQty'),
    restrictProduct: emitValueAccessor('restrictProduct')
  })
});
function emitValueAccessor(field) {
  return {
    get: function get() {
      return (this.value || {})[field];
    },
    set: function set(value) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var settings;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                settings = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this2.value || {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, field, value));

                _this2.$emit('input', settings);

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  };
}

/***/ }),

/***/ "oeyE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_track_events__ = __webpack_require__("Dg6a");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['productTemplateDesignId', 'heroState', 'flags']), {
    showTooltip: function showTooltip() {
      return this.heroState === 'step3';
    }
  }),
  methods: {
    onUpload: function onUpload() {
      Object(__WEBPACK_IMPORTED_MODULE_2__lib_track_events__["d" /* designUploadSuccess */])();
    },
    onError: function onError(error) {
      Object(__WEBPACK_IMPORTED_MODULE_2__lib_track_events__["c" /* designUploadError */])(error);
    }
  }
});

/***/ }),

/***/ "ojJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberDetail_vue__ = __webpack_require__("u/Sl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_081a678b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberDetail_vue__ = __webpack_require__("2x/M");
function injectStyle (ssrContext) {
  __webpack_require__("orlz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-081a678b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_081a678b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "orlz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "os0Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return shortenUrl; });
/* harmony export (immutable) */ __webpack_exports__["b"] = validUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__authorize__ = __webpack_require__("lKgw");






var SHORTURL_BASE = 'https://qr1.to/';

var shortenUrl = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(url) {
    var headers, response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default.a;
            _context.t1 = { 'content-type': 'application/json' };
            _context.next = 4;
            return Object(__WEBPACK_IMPORTED_MODULE_4__authorize__["a" /* authHeaders */])();

          case 4:
            _context.t2 = _context.sent;
            headers = (0, _context.t0)(_context.t1, _context.t2);

            console.log(headers);
            _context.next = 9;
            return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(SHORTURL_BASE, { redir: url }, { headers: headers });

          case 9:
            response = _context.sent;
            return _context.abrupt('return', response.data.shorturl);

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function shortenUrl(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Return whether url is valid to be shortened
 *
 * @param {*} url
 */
function validUrl(url) {
  try {
    var u = new URL(url);
    return u.protocol.match(/https?:/i);
  } catch (e) {
    return false;
  }
}

/***/ }),

/***/ "ouxW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.forceInvoice)?_c('div',[_vm._v("\n    You have invoicing enabled.\n  ")]):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"error",on:{"click":function($event){$event.stopPropagation();return _vm.load($event)}}},[_vm._v("⚠️ Unable to load saved cards"),_c('div',{staticStyle:{"font-size":"xx-small"}},[_vm._v(_vm._s(_vm.error))])]):(_vm.loaded)?[(_vm.savedCards.length === 0)?_c('div',[_vm._v("\n      You have no saved cards.\n    ")]):_c('div',[_c('small',[_vm._v("You own "+_vm._s(_vm.numOwned)+" saved cards and have access to "+_vm._s(_vm.numShared)+" team cards.")])]),_vm._v(" "),_vm._l((_vm.savedCards),function(card){return _c('SavedCard',{key:card.last4,attrs:{"card":card}},[_c('div',{staticClass:"card-buttons"},[(card.available_to_team)?_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Team card"}},[_c('i',{staticClass:"fas fa-users"})]):_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Personal card"}},[_c('i',{staticClass:"fas fa-user"})])])])})]:(_vm.loading)?_c('WaveSpinner'):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ox3m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p+bV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"sm":"12","md":"4"}},[_c('div',{staticClass:"card-wrapper"},[_c('a',{attrs:{"href":"Standard"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('input', 'Standard')}}},[_c('img',{staticClass:"bc-image",attrs:{"src":"/static/images/homepage/cards-1.png"}}),_vm._v(" "),_c('div',{staticClass:"card-price"},[_c('h3',[_vm._v("Standard Business Cards")]),_vm._v(" "),_c('p',[_vm._v("\n                50\n                "),_c('span',[_vm._v(" cards from ")]),_vm._v("$18.99\n              ")])])])])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"4"}},[_c('div',{staticClass:"card-wrapper"},[_c('a',{attrs:{"href":"Premium"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('input', 'Premium')}}},[_c('img',{staticClass:"bc-image",attrs:{"src":"/static/images/homepage/cards-2.png"}}),_vm._v(" "),_c('div',{staticClass:"card-price"},[_c('h3',[_vm._v("Premium Business Cards")]),_vm._v(" "),_c('p',[_vm._v("\n                50\n                "),_c('span',[_vm._v(" cards from ")]),_vm._v("$21.99\n              ")])])])])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"4"}},[_c('div',{staticClass:"card-wrapper"},[_c('a',{attrs:{"href":"Classic"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('input', 'Classic')}}},[_c('img',{staticClass:"bc-image",attrs:{"src":"/static/images/homepage/cards-3.png"}}),_vm._v(" "),_c('div',{staticClass:"card-price"},[_c('h3',[_vm._v("Classic Business Cards")]),_vm._v(" "),_c('p',[_vm._v("\n                50\n                "),_c('span',[_vm._v(" cards from ")]),_vm._v("$30.99\n              ")])])])])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p0xR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p28/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_design__ = __webpack_require__("VFA2");





/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    design: null,
    invalidatedId: null, // design Id that must be reloaded
    // Track which pages have had SVG applied (using bits)
    // This facilitates requesting the production File, which is relied
    // upon by the card-tester code.
    pagesSaved: 0,
    pageNum: 0,
    // Vue reactivity likes to have properties pre-defined
    thumbnails: { 0: null, 1: null },
    editorMessage: '',
    // For debugging, track the page SVG. Setting directly on design.pages is not reactive :(
    pageSvg: { 0: '', 1: '' }
  },
  mutations: {
    setDesign: function setDesign(state, design) {
      state.design = design;
      state.pagesSaved = 0;
      state.thumbnails = { 0: null, 1: null };
    },
    clearDesign: function clearDesign(state) {
      console.log('clearDesign');
      state.design = null;
      state.pagesSaved = 0;
      state.thumbnails = { 0: null, 1: null };
    },
    invalidateDesign: function invalidateDesign(state) {
      state.invalidatedId = state.design && state.design.id;
    },
    setPage: function setPage(state, num) {
      state.pageNum = num;
    },
    setThumbnail: function setThumbnail(state, _ref) {
      var pageNum = _ref.pageNum,
          dataUrl = _ref.dataUrl;

      state.thumbnails[pageNum] = dataUrl;
    },
    pageSaved: function pageSaved(state, _ref2) {
      var pageNum = _ref2.pageNum,
          svg = _ref2.svg;

      state.pagesSaved++;
      // Keep SVG updated so that debugTools can access it
      state.pageSvg[pageNum] = svg;
    },
    setEditorMessage: function setEditorMessage(state, message) {
      state.editorMessage = message;
    },
    dropSecondPage: function dropSecondPage(state) {
      // Delete second item of array; use splice so Vue notices the change
      state.design.pages.splice(1, 1);
      state.thumbnails[1] = null;
    },
    setDesignOptions: function setDesignOptions(state, designOptions) {
      state.design.designOptions = designOptions;
    }
  },
  actions: {
    setDesign: function setDesign(context, design) {
      context.commit('setDesign', design);
    },
    setCurrentDesignId: function setCurrentDesignId(_ref3, id) {
      var _this = this;

      var state = _ref3.state,
          getters = _ref3.getters,
          commit = _ref3.commit;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var design;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('setCurrentDesignId', getters.designId, id, state.invalidatedId);
                if (getters.designId != id || state.invalidatedId == id) {
                  commit('clearDesign');
                }

                if (state.design) {
                  _context.next = 7;
                  break;
                }

                _context.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_3__services_design__["d" /* load */])(id);

              case 5:
                design = _context.sent;

                commit('setDesign', design);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    invalidateDesign: function invalidateDesign(_ref4) {
      var commit = _ref4.commit;

      console.log('invalidateDesign');
      commit('invalidateDesign');
    },
    setPage: function setPage(context, num) {
      context.commit('setPage', num);
    },
    setThumbnail: function setThumbnail(context, _ref5) {
      var pageNum = _ref5.pageNum,
          dataUrl = _ref5.dataUrl;

      context.commit('setThumbnail', { pageNum: pageNum, dataUrl: dataUrl });
      context.commit('updateBasketThumbnail', { designId: context.getters.designId, pageNum: pageNum, dataUrl: dataUrl });
    },
    updatePage: function updatePage(_ref6, _ref7) {
      var _this2 = this;

      var state = _ref6.state,
          getters = _ref6.getters,
          commit = _ref6.commit;
      var pageNum = _ref7.pageNum,
          svg = _ref7.svg,
          previewDataUrl = _ref7.previewDataUrl;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var pageId, result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                pageId = state.design.pages[pageNum].id;

                if (pageId) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return', console.error("No pageId, can't update page!", pageNum));

              case 3:
                _context2.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_3__services_design__["j" /* updatePage */])(pageId, svg, previewDataUrl);

              case 5:
                commit('pageSaved', { pageNum: pageNum, svg: svg });

                if (!(state.pagesSaved === getters.designPageCount)) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_3__services_design__["e" /* productionFile */])(state.design.id);

              case 9:
                result = _context2.sent;

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    updateCanvasLayer: function updateCanvasLayer(_ref8, _ref9) {
      var _this3 = this;

      var state = _ref8.state;
      var pageNum = _ref9.pageNum,
          objects = _ref9.objects,
          meta = _ref9.meta;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var layerId;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                layerId = state.design.pages[pageNum].textLayer.id;
                return _context3.abrupt('return', Object(__WEBPACK_IMPORTED_MODULE_3__services_design__["h" /* updateLayerObjects */])(layerId, objects, meta));

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    startDesignFromTemplate: function startDesignFromTemplate(context, template_design_id) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var newDesign;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_3__services_design__["a" /* clone */])(template_design_id);

              case 2:
                newDesign = _context4.sent;

                context.commit('setDesign', newDesign);
                return _context4.abrupt('return', newDesign);

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    dropSecondPageFromDesign: function dropSecondPageFromDesign(_ref10) {
      var _this5 = this;

      var state = _ref10.state,
          commit = _ref10.commit;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var pageId;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                pageId = state.design.pages[1].id;

                commit('dropSecondPage');
                _context5.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_3__services_design__["b" /* deletePage */])(pageId);

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    showEditorMessage: function showEditorMessage(context, message) {
      this.commit('setEditorMessage', message);
    },
    setDesignOptions: function setDesignOptions(_ref11, designOptions) {
      var getters = _ref11.getters,
          commit = _ref11.commit;

      Object(__WEBPACK_IMPORTED_MODULE_3__services_design__["f" /* updateDesign */])(getters.designId, { designOptions: designOptions });
      commit('setDesignOptions', designOptions);
    },
    updateDesignTemplate: function updateDesignTemplate(_ref12, source_template) {
      var _this6 = this;

      var state = _ref12.state,
          commit = _ref12.commit;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var design;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_3__services_design__["g" /* updateDesignTemplate */])(state.design.id, { source_template: source_template });

              case 2:
                design = _context6.sent;

                commit('setDesign', design);

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    updateDesignTemplateClone: function updateDesignTemplateClone(_ref13, source_template) {
      var _this7 = this;

      var state = _ref13.state,
          commit = _ref13.commit;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var design;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_3__services_design__["g" /* updateDesignTemplate */])(state.design.id, { source_template: source_template, clone: true });

              case 2:
                design = _context7.sent;

                console.log('updateDesignTemplate', design.id);
                return _context7.abrupt('return', design.id);

              case 5:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    }
  },
  getters: {
    pageData: function pageData(state) {
      return function (pageNum) {
        return state.design && state.design.pages[pageNum];
      };
    },
    design: function design(state) {
      return state.design;
    },
    designId: function designId(state) {
      return state.design && state.design.id;
    },
    thumbnails: function thumbnails(state) {
      return state.thumbnails;
    },
    designPageCount: function designPageCount(state) {
      return state.design && state.design.pages.length;
    },
    designOrientation: function designOrientation(state) {
      return state.design && orientation(state.design.pages[0].mediaBox);
    },
    pageNum: function pageNum(state) {
      return state.pageNum;
    },
    isTemplate: function isTemplate(state) {
      return state.design && state.design.isTemplate;
    },
    editorMessage: function editorMessage(state) {
      return state.editorMessage;
    },
    designProductId: function designProductId(state) {
      return state.design && state.design.product;
    },
    missingFonts: function missingFonts(state) {
      return state.design && state.design.missingFonts || [];
    },
    validUploadTypes: function validUploadTypes(state, getters) {
      return 'image/png,image/x-png,image/jpeg' + (getters.flags.svgUpload ? ',image/svg+xml,image/svg' : '');
    },
    validUploadTypeText: function validUploadTypeText(state, getters) {
      return getters.flags.svgUpload ? 'PNG, JPEG or SVG' : 'PNG or JPEG';
    },
    designOptions: function designOptions(state) {
      return state.design && (state.design.designOptions || {});
    },
    pageSvg: function pageSvg(state) {
      return state.pageSvg;
    }
  }
});
function orientation(_ref14) {
  var _ref15 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref14, 4),
      x = _ref15[0],
      y = _ref15[1],
      w = _ref15[2],
      h = _ref15[3];

  return w > h ? 'landscape' : 'portrait';
}

/***/ }),

/***/ "pD6U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_oauth_vue__ = __webpack_require__("IKBG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_676288ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_oauth_vue__ = __webpack_require__("0q5t");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_oauth_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_676288ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_oauth_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pG7h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_design__ = __webpack_require__("VFA2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      url: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['designId', 'flags', 'design', 'pageSvg', 'designOptions', 'isTemplate']), {
    showDebugTools: function showDebugTools() {
      return this.flags.debugTools;
    },
    templateUrl: function templateUrl() {
      return '/design/' + this.design.sourceDesign;
    },
    sourceFileUrl: function sourceFileUrl() {
      // Note: this may be only one side, if they uploaded in two steps
      return this.design.sourceFile;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['setDesignOptions', 'updateDesignTemplate', 'updateDesignTemplateClone']), {
    downloadProductionFile: function downloadProductionFile() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_3__services_design__["e" /* productionFile */])(_this.designId);

              case 3:
                result = _context.sent;

                _this.loading = false;
                console.log(result);
                _this.url = result.productionFile;

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    uploadFile: function uploadFile(page, event) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var file, reader;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                file = event.target.files[0];

                if (file) {
                  reader = new FileReader();

                  reader.onload = function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(fileEvent) {
                      var data;
                      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              data = fileEvent.target.result;

                              // Upload to layer...

                              _context2.next = 3;
                              return Object(__WEBPACK_IMPORTED_MODULE_3__services_design__["i" /* updateLayerSvg */])(page.backgroundLayer.id, data);

                            case 3:
                              console.log('done');

                            case 4:
                            case 'end':
                              return _context2.stop();
                          }
                        }
                      }, _callee2, _this2);
                    }));

                    return function (_x) {
                      return _ref.apply(this, arguments);
                    };
                  }();
                  reader.readAsText(file);
                }

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    unlockDesign: function unlockDesign() {
      this.setDesignOptions(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.designOptions, { lockDesign: false }));
    },
    updateDesign: function updateDesign(clone) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var source_template, newDesignId;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                source_template = +prompt('source_design');

                if (!isNaN(source_template)) {
                  _context4.next = 4;
                  break;
                }

                alert('NaN');
                return _context4.abrupt('return');

              case 4:
                if (!clone) {
                  _context4.next = 11;
                  break;
                }

                _context4.next = 7;
                return _this3.updateDesignTemplateClone(source_template);

              case 7:
                newDesignId = _context4.sent;

                // Update url to reflect new design.
                window.open('/design/' + newDesignId, '_blank');
                _context4.next = 13;
                break;

              case 11:
                _context4.next = 13;
                return _this3.updateDesignTemplate(source_template);

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    }
  })
});

/***/ }),

/***/ "pHJi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pN1f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vee_validate__ = __webpack_require__("sUu7");


var stepInfo = [{ key: 'step1', title: 'Create your account' }, { key: 'step2', title: 'Setup your portal' }, { key: 'step3', title: 'Upload your design' }, { key: 'step4', title: 'Share with your team' }];

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    heroState: null,
    onboardingHidden: false
  },
  mutations: {
    hideOnboarding: function hideOnboarding(state) {
      state.onboardingHidden = true;
    },
    setHeroState: function setHeroState(state, heroState) {
      state.heroState = heroState;
    }
  },
  actions: {
    setInitialHeroState: function setInitialHeroState(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch,
          getters = _ref.getters;

      if (getters.allDone) {
        commit('setHeroState', 'allDone');
      } else {
        commit('setHeroState', 'init');
        dispatch('nextHeroState');
      }
    },
    setHeroState: function setHeroState(_ref2, heroState) {
      var commit = _ref2.commit;

      commit('setHeroState', heroState);
    },
    nextHeroState: function nextHeroState(_ref3) {
      var state = _ref3.state,
          getters = _ref3.getters,
          commit = _ref3.commit;

      var advance = {
        init: 'step1',
        step1: 'step2',
        step2: 'step3',
        step3: 'step4',
        step4: 'step1'
      },
          cur = advance[state.heroState],
          n = 10;
      while (getters[cur] && cur && n--) {
        if (cur === 'step4') {
          cur = 'allDone';
          break;
        } else {
          cur = advance[cur];
        }
      }
      commit('setHeroState', cur);
    },
    hideOnboarding: function hideOnboarding(_ref4) {
      var commit = _ref4.commit;

      commit('hideOnboarding');
    }
  },
  getters: {
    heroState: function heroState(state) {
      return state.onboardingHidden ? 'hide' : state.heroState;
    },
    steps: function steps(state, getters) {
      return stepInfo.map(function (_ref5) {
        var key = _ref5.key,
            title = _ref5.title;
        return { key: key, title: title, done: getters[key], active: state.heroState === key };
      });
    },
    onboardingHidden: function onboardingHidden(state, getters) {
      return state.onboardingHidden && !getters.flags.forceOnboarding || state.heroState == 'allDone';
    },
    // Create your acount. Pretty much always true.
    step1: function step1(state) {
      return true;
    },
    // Setup your portal. Have they answered the welcome questions.
    // For now, assume so.
    step2: function step2(state) {
      return true;
    },
    // Upload your design.
    // When they have a design, its true
    step3: function step3(state, getters) {
      return !!getters.productTemplateDesignId;
    },
    // Share with your team
    // have they invited at least one person BESIDES themselves?
    step4: function step4(state, getters) {
      return getters.team.members_qty || 0 > 1;
    },
    allDone: function allDone(state, getters) {
      return getters.step1 && getters.step2 && getters.step3 && getters.step4;
    }
  }
});

/***/ }),

/***/ "pTP1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"footer-wrapper"},[_c('div',{staticClass:"footer-nav"},[_c('b-navbar-brand',{staticStyle:{"align-self":"start"},attrs:{"href":"/"}}),_vm._v(" "),_c('ul',{staticClass:"footer-nav-links"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/support"}},[_vm._v("FAQs")])],1),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('li',{attrs:{"id":"copyright"}},[_vm._v(" © 2019 Brandly, Inc.")])])],1),_vm._v(" "),_c('div',{staticClass:"hide-copyright"},[_vm._v("\n    © 2019 Brandly, Inc.\n    ")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"/about"}},[_vm._v("About")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"/artworkguidelines"}},[_vm._v("Artwork Guidelines")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://www.brandly.com/blog"}},[_vm._v("Blog")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"/contact"}},[_vm._v("Contact")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"/tos"}},[_vm._v("Terms")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"/privacy"}},[_vm._v("Privacy")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pXqx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = notifyPromise;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/**
 * notifyPromise - send custom notification event with the success/error result of a promise.
 *
 * This allows MessageAlert and MessageFormGroup to automatically display success/failures.
 *
 * @param {*} promise
 * @param {*} success -- success message massager
 * @param {*} error -- error message massager
 */
function notifyPromise(path, promise, success, error) {
  return promise.then(function (result) {
    return dispatch(path, 'success', result, success);
  }, function (e) {
    return dispatch(path, 'error', e, error);
  });
}

function dispatch(path, type, obj, massager) {
  var message = massageMessage(obj, massager);
  var messageEvent = new CustomEvent('notification', { detail: { message: message, type: type }, bubbles: true });
  var target = path.find(function (d) {
    return d.isConnected;
  });
  // Target should always be something since path will go all the way up to 'body'
  target.dispatchEvent(messageEvent);
  console.log('Event dispatched', target, messageEvent);
}

function massageMessage(value, massager) {
  if (typeof massager === "string") {
    return massager;
  }
  if (typeof massager === "function") {
    return massager(value);
  }
  if (value instanceof Error) {
    console.error(value);
    return value.message;
  }
  if (massager !== undefined) {
    console.warn('Didn\'t know how to massage message ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(message) + ' using ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(massager));
  }
  return value;
}

/***/ }),

/***/ "pb8y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HubspotForm_vue__ = __webpack_require__("V1/i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27f1fd39_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HubspotForm_vue__ = __webpack_require__("JZOG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HubspotForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27f1fd39_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HubspotForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pwrx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{previews: _vm.previews, no_previews: !_vm.previews, stack: _vm.stack, roundedCorners: _vm.rounded}},_vm._l((_vm.preview_urls),function(url,index){return _c('img',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.bottom",value:(_vm.popoverItem(url)),expression:"popoverItem(url)",modifiers:{"hover":true,"bottom":true}}],key:index,attrs:{"src":url},on:{"load":_vm.setPortraitClass}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pyEl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent"},[_c('div',{staticClass:"copy-container"},[_c('div',{staticClass:"copy"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q1WO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qBbl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-header"},[_c('h4',[_vm._t("title")],2),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qGyP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: String,
    uppercase: Boolean
  },
  data: function data() {
    return { editing: false, busy: false, error: '' };
  },

  methods: {
    emit: function emit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var promise;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // We emit an input to allow easy v-model, plus a custom callback as a second argument.
                // The @input handler can pass a promise to the callback. this will wait for the promise to
                // resolve to remove the input, showing a busy indicator, and showing an error if the promise
                // errors.
                promise = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();

                _this.busy = true;
                _this.error = '';
                _this.$emit('input', _this.$refs.inp.value, function (p) {
                  return promise = p;
                });
                _context.prev = 4;
                _context.next = 7;
                return promise;

              case 7:
                _this.editing = false;
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                console.error(_context.t0);
                _this.error = _context.t0 + '';

              case 14:
                _this.busy = false;

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[4, 10]]);
      }))();
    }
  }
});

/***/ }),

/***/ "qO5r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextBlock_vue__ = __webpack_require__("Zhc1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fb12fff_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextBlock_vue__ = __webpack_require__("BsGs");
function injectStyle (ssrContext) {
  __webpack_require__("68ar")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fb12fff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fb12fff_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextBlock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qYbJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductList_vue__ = __webpack_require__("62Q0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34171d6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductList_vue__ = __webpack_require__("IM/j");
function injectStyle (ssrContext) {
  __webpack_require__("Lqhu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34171d6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34171d6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qeSr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  meta: { useAppHeader: true },
  mounted: function mounted() {
    this.loadTeamInfo();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['loadTeamInfo', 'startOrderFromProductTemplate']), {
    onContinue: function onContinue() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.startOrderFromProductTemplate();

              case 2:
                _this.$router.push({ name: 'Editor', params: { id: _this.designId } });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }),
  computed: Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['designId'])
});

/***/ }),

/***/ "qfGN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewApproval_vue__ = __webpack_require__("uyyg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02475548_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewApproval_vue__ = __webpack_require__("fusB");
function injectStyle (ssrContext) {
  __webpack_require__("5+P3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02475548"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewApproval_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02475548_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewApproval_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qwfB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemsOnPageSelect_vue__ = __webpack_require__("O/BJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1ae2654_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemsOnPageSelect_vue__ = __webpack_require__("UDnD");
function injectStyle (ssrContext) {
  __webpack_require__("ZOM/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e1ae2654"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemsOnPageSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1ae2654_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemsOnPageSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "qxKM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OrdersList_vue__ = __webpack_require__("4KwP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrderDetail_vue__ = __webpack_require__("4hHw");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  children: [{
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_0__OrdersList_vue__["a" /* default */]
  }, {
    path: ':id',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_1__OrderDetail_vue__["a" /* default */]
  }]
});

/***/ }),

/***/ "qz0b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.rows),function(row){return _c('tr',{key:row.name},[_c('td',{staticClass:"product"},[_vm._v(_vm._s(row.name))]),_vm._v(" "),_vm._l(([50,100,250,500,1000]),function(qty){return _c('td',{key:qty,class:{price: true, na: !row.prices[qty]}},[_vm._v(_vm._s(_vm.price(row, qty)))])})],2)}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"qty"},[_vm._v("QTY:")]),_vm._v(" "),_c('th',{staticClass:"qty"},[_vm._v("50")]),_vm._v(" "),_c('th',{staticClass:"qty"},[_vm._v("100")]),_vm._v(" "),_c('th',{staticClass:"qty"},[_vm._v("250")]),_vm._v(" "),_c('th',{staticClass:"qty"},[_vm._v("500")]),_vm._v(" "),_c('th',{staticClass:"qty"},[_vm._v("1000")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r/A8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_020bf4cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomepageLandingLayout_vue__ = __webpack_require__("D8Zu");
function injectStyle (ssrContext) {
  __webpack_require__("CrEO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-020bf4cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_020bf4cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomepageLandingLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "r7EH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__("VaF6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_612288ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__("zYnt");
function injectStyle (ssrContext) {
  __webpack_require__("4hsh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-612288ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_612288ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "r9dy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_136660c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("SwHB");
function injectStyle (ssrContext) {
  __webpack_require__("dyV2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-136660c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_136660c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "rFfw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomepageWideLayout',{attrs:{"footer":"no","wide-header":"yes"}},[_c('b-container',{staticClass:"p-0",attrs:{"fluid":"","id":"product-grid"}},[_c('div',{class:{'d-none': !_vm.product, 'd-sm-none': true},attrs:{"id":"catalog-header"}},[_c('a',{on:{"click":_vm.onClickCrumbs}},[_c('i',{staticClass:"fas fa-chevron-left fa-xs"}),_vm._v(" "),_c('span',{staticStyle:{"padding-left":"17px"}},[_vm._v("Business Cards")]),_vm._v(" "),_c('span',{staticClass:"sep"},[_vm._v("/")]),_vm._v(" "),(_vm.product)?_c('span',[_vm._v(_vm._s(_vm.product.category))]):_vm._e()])]),_vm._v(" "),_c('b-row',{class:{'showing-bar': _vm.isMobile && _vm.product},attrs:{"id":"catalog-page"}},[_c('b-col',{staticClass:"d-sm-block p-0",class:{'d-none': _vm.product},attrs:{"sm":"4","md":"3","lg":"2","id":"products"}},[_c('ProductList',{attrs:{"autoselect":!_vm.isMobile,"slug":_vm.slug},model:{value:(_vm.product),callback:function ($$v) {_vm.product=$$v},expression:"product"}})],1),_vm._v(" "),_c('b-col',{ref:"right",staticClass:"d-sm-block right-side p-0",class:{'d-none': !_vm.product},attrs:{"sm":"8","md":"9","lg":"10"}},[_c('ProductPanel',{attrs:{"product":_vm.product}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rKOG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rMmh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3501c1a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blank_vue__ = __webpack_require__("UAK+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3501c1a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blank_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "rPVX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__("C9Vj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_609ec2dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__("nXIs");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_609ec2dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rQLO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PricingGrid_vue__ = __webpack_require__("Zq/4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79b2916a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PricingGrid_vue__ = __webpack_require__("moCD");
function injectStyle (ssrContext) {
  __webpack_require__("kq8p")
  __webpack_require__("+i0y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79b2916a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PricingGrid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79b2916a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PricingGrid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rTBJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"controls-overlay"},[_c('div',{staticClass:"control-container",staticStyle:{"position":"absolute","transform":"translate(-50%, -50%)","transition":"none"},style:(_vm.controlStyle)},[(_vm.controlTypeToShow === 'placeholder')?_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"placement":"bottom","title":"Replace Image","variant":"clear"},on:{"click":_vm.showUploadDialog}},[_c('i',{staticClass:"fa fa-upload",attrs:{"aria-hidden":"true"}})]):(_vm.controlTypeToShow==='block')?_c('TextBlock',{attrs:{"bus":_vm.bus}}):_vm._e()],1),_vm._v(" "),(_vm.displayBleed)?_c('BleedPointDisplay',{attrs:{"bleedPoints":_vm.bleedPoints}}):_vm._e(),_vm._v(" "),_c('input',{ref:"hiddenFileInput",staticStyle:{"display":"none"},attrs:{"accept":_vm.validUploadTypes,"type":"file"},on:{"change":_vm.uploadFile}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rV1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"current-product-wrapper"},[(_vm.noCurrentProduct)?_c('span',{staticClass:"no-product"},[_vm._v("Team does not have default product\n    "),_c('b-button',{on:{"click":_vm.toggleEditing}},[_vm._v("Choose Product")])],1):_c('div',{staticClass:"has-product"},[(_vm.editing)?_c('TeamProductForm'):_c('dl',[_c('dt',[_vm._v("Paper:")]),_c('dd',[_vm._v(_vm._s(_vm.productTemplateAttrs.paper))]),_vm._v(" "),_c('dt',[_vm._v("Corners:")]),_c('dd',[_vm._v(_vm._s(_vm.productTemplateAttrs.corners))]),_vm._v(" "),_c('dt',[_vm._v("Default Qty:")]),_c('dd',[_vm._v(_vm._s(_vm.productTemplate.default_qty))])]),_vm._v(" "),(_vm.editButton)?_c('span',{staticClass:"edit-product",domProps:{"innerHTML":_vm._s(_vm.editIcon())},on:{"click":_vm.toggleEditing}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rZTG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle-signin",attrs:{"id":"google-circle"},on:{"click":_vm.onClick}},[_c('img',{staticClass:"circle-logo",attrs:{"src":"/static/images/signin/google/google-icon.png"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rcKs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel"},[(!_vm.isImporting)?_c('div',{staticClass:"layout"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('b-button',{attrs:{"variant":"default","disabled":_vm.isImporterBusy},on:{"click":_vm.initImporter}},[(_vm.isImporterBusy)?_c('WaveSpinner',{attrs:{"color":"white","inline":""}}):_c('span',[_vm._v("Start")])],1),_vm._v(" "),(!_vm.isImporterBusy)?_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v("\n        Cancel\n      ")]):_vm._e()],1)]):_c('div',{staticClass:"layout"},[_c('div',{staticClass:"content"},[_c('b-progress',{attrs:{"max":_vm.importerData.length,"height":"40px"}},[_c('b-progress-bar',{staticClass:"custom-progressbar",attrs:{"value":_vm.savedUsersQty,"variant":"success"}},[_vm._v("\n          Saved: "+_vm._s(_vm.savedUsersQty)+" / "+_vm._s(_vm.importerData.length)+"\n        ")]),_vm._v(" "),_c('b-progress-bar',{staticClass:"custom-progressbar",attrs:{"value":_vm.notSavedUsersQty,"variant":"danger"}},[_vm._v("\n          Unsaved: "+_vm._s(_vm.notSavedUsersQty)+" / "+_vm._s(_vm.importerData.length)+"\n        ")])],1),_vm._v(" "),(_vm.cancelled)?_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_vm._v("\n        Operation cancelled\n      ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.invalidData),function(userData,index){return _c('b-alert',{key:index,attrs:{"show":"","variant":"danger"}},[_c('div',[_vm._v("Data: "+_vm._s(userData.first_name)+" "+_vm._s(userData.last_name)+" ("+_vm._s(userData.email)+")")]),_vm._v(" "),_vm._l((userData.errors),function(errorMessages,fieldName){return _c('div',[_c('b',[_vm._v(_vm._s(fieldName)+": "+_vm._s(errorMessages[0]))])])})],2)})],2),_vm._v(" "),_c('div',{staticClass:"buttons"},[(_vm.isImportingDone)?_c('b-button',{attrs:{"variant":"default"},on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v("\n        Done\n      ")]):_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.cancelImporting}},[_vm._v("\n        Cancel\n      ")])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_vm._v("\n      Upload a spreadsheet with one team member per row.\n      Existing members will be uploaded.\n      "),_c('div',{staticClass:"links"},[_c('a',{attrs:{"href":"/static/downloads/Brandly-Sample-Import.xlsx","download":"Brandly-Sample-Import.xlsx"}},[_vm._v("Download a sample file >")])]),_vm._v(" "),_c('p',{staticClass:"fineprint"},[_vm._v("NOTE: Invites will not be sent.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rjIM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"action-card wide-card"},[_c('b-button',{staticClass:"close customClose",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){_vm.show = false}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h2',[_vm._v("Field options")]),_vm._v(" "),_c('b-input',{attrs:{"placeholder":"variable"},model:{value:(_vm.variable),callback:function ($$v) {_vm.variable=$$v},expression:"variable"}}),_vm._v(" "),_c('b-checkbox',{model:{value:(_vm.allowMultiline),callback:function ($$v) {_vm.allowMultiline=$$v},expression:"allowMultiline"}},[_vm._v("Allow multi-line")]),_vm._v(" "),_c('b-checkbox',{model:{value:(_vm.forceCaps),callback:function ($$v) {_vm.forceCaps=$$v},expression:"forceCaps"}},[_vm._v("Force Caps")]),_vm._v(" "),_c('b-checkbox',{model:{value:(_vm.fieldLocked),callback:function ($$v) {_vm.fieldLocked=$$v},expression:"fieldLocked"}},[_vm._v("Field Locked")]),_vm._v(" "),_c('b-checkbox',{model:{value:(_vm.fieldDeletable),callback:function ($$v) {_vm.fieldDeletable=$$v},expression:"fieldDeletable"}},[_vm._v("Field Deletable")]),_vm._v(" "),(_vm.blockId)?_c('div',[_vm._v("\n    Block:\n    "),_vm._v(" "),(_vm.flags.debugTools)?_c('span',{staticStyle:{"text-align":"left","font-size":"small","border":"3px dashed blue","padding":"3px"}},[_vm._v("\n      Id: "+_vm._s(_vm.blockId)+"\n    ")]):_vm._e(),_vm._v(" "),_c('b-form-radio-group',{staticClass:"align-choices",attrs:{"size":"sm","button-variant":"clear","buttons":""},model:{value:(_vm.blockVerticalAlign),callback:function ($$v) {_vm.blockVerticalAlign=$$v},expression:"blockVerticalAlign"}},[_c('b-form-radio',{attrs:{"value":"top"}},[_vm._v("top")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"middle"}},[_vm._v("middle")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"bottom"}},[_vm._v("bottom")])],1),_vm._v(" "),_c('b-button',{attrs:{"variant":"clear","size":"sm"},on:{"click":function($event){return _vm.emit('deleteBlock', _vm.blockId)}}},[_c('i',{staticClass:"fas fa-times"}),_vm._v(" Delete")])],1):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rn8n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rof0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_filestackClient__ = __webpack_require__("saO9");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['bus', 'disabled'],

  data: function data() {
    return {
      filestackDialogOpen: false,
      dragging: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['flags', 'validUploadTypes', 'validUploadTypeText']), {
    dragEnabled: function dragEnabled() {
      return !this.disabled && !this.filestackDialogOpen;
    }
  }),

  methods: {
    uploadFile: function uploadFile(file) {
      var _this = this;

      if (this.validUploadTypes.split(',').includes(file.type)) {
        var reader = new FileReader();

        reader.onload = function (f) {
          var data = f.target.result;
          _this.bus.$emit('imageDataUploadedEvent', data);
        };

        reader.readAsDataURL(file);
      } else {
        var evt = {
          droppedType: file.type,
          allowedTypes: this.validUploadTypes,
          allowedText: this.validUploadTypeText
        };
        this.$emit('drop-fail', evt);
      }
    },
    onDrop: function onDrop(evt) {
      if (this.dragEnabled) {
        this.uploadFile(evt.dataTransfer.files[0]);
      }
      this.dragging = false;
    },
    onDragOver: function onDragOver(evt) {},
    onDragEnter: function onDragEnter() {
      if (this.dragEnabled) {
        this.dragging = true;
      }
    },
    onClick: function onClick() {
      // Allow user to recover from any weirdness thaat leaves dropzone over the top
      this.dragging = false;
    },
    onDragLeave: function onDragLeave() {
      this.dragging = false;
    },
    uploadFileFromInput: function uploadFileFromInput(event) {
      this.uploadFile(event.target.files[0]);
    },
    uploadFileFromFileStack: function uploadFileFromFileStack(blob) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var reader;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                reader = new FileReader();

                reader.onloadend = function () {
                  var data = reader.result;
                  _this2.bus.$emit('imageDataUploadedEvent', data);
                };
                reader.readAsDataURL(blob);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  },

  events: {
    showUploadDialog: function showUploadDialog() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var client;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this3.flags.filestackUpload) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__lib_filestackClient__["a" /* default */])();

              case 3:
                client = _context3.sent;

                client.picker({
                  onOpen: function onOpen() {
                    _this3.filestackDialogOpen = true;
                  },
                  onClose: function onClose() {
                    _this3.filestackDialogOpen = false;
                  },
                  onFileUploadFinished: function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(response) {
                      var blob;
                      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              _context2.next = 2;
                              return client.retrieve(response.handle);

                            case 2:
                              blob = _context2.sent;

                              _this3.uploadFileFromFileStack(blob);

                            case 4:
                            case 'end':
                              return _context2.stop();
                          }
                        }
                      }, _callee2, _this3);
                    }));

                    return function onFileUploadFinished(_x) {
                      return _ref.apply(this, arguments);
                    };
                  }() }).open();
                _context3.next = 8;
                break;

              case 7:
                _this3.$refs.hiddenFileInput.click();

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },


    // filestack dialog can be externally opened and closed from via EditorControlsOverlay
    filestackDialogOpen: function filestackDialogOpen() {
      this.filestackDialogOpen = true;
    },
    filestackDialogClosed: function filestackDialogClosed() {
      this.filestackDialogOpen = false;
    }
  },

  mounted: function mounted() {
    this.dragging = false;
    document.body.addEventListener('dragenter', this.onDragEnter);
  },
  beforeDestroy: function beforeDestroy() {
    document.body.removeEventListener('dragenter', this.onDragEnter);
  }
});

/***/ }),

/***/ "rwXd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',[_c('div',[_vm._v("Name: "+_vm._s(_vm.user.first_name)+" "+_vm._s(_vm.user.last_name))]),_vm._v(" "),_c('div',[_vm._v("Email: "+_vm._s(_vm.user.email))]),_vm._v(" "),(_vm.user.job_role)?_c('div',[_vm._v("Role: "+_vm._s(_vm.user.job_role))]):_vm._e(),_vm._v(" "),_vm._l((_vm.personalVars),function(ref){
var label = ref.label;
var value = ref.value;
return _c('div',{key:label},[_vm._v(_vm._s(label)+": "+_vm._s(value))])})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s47Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-page"},[(_vm.context == 'new-design')?_c('h1',[_vm._v("Upload your Business Card")]):(_vm.context == 'add-design')?_c('h1',[_vm._v("Upload Design")]):(_vm.context == 're-upload')?_c('h1',[_vm._v("Re-upload your Business Card")]):_c('h1',[_vm._v("Upload Business Card")]),_vm._v(" "),_c('div',{staticClass:"editor-wrapper"},[_c('UploaderBox',{attrs:{"extra":{is_template: true}},on:{"upload":_vm.onUpload,"error":_vm.onError}}),_vm._v(" "),_c('SideMenu',{staticClass:"side-menu"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sC/8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__businesscards_shared_ProductPanel__ = __webpack_require__("vdxS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__businesscards_shared_ProductList__ = __webpack_require__("qYbJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["slug"],
  data: function data() {
    return {
      isMobile: false,
      product: null
      // This was the first name. We no longer auto select it.
      //productData.categories[0].products[0].name
    };
  },
  created: function created() {
    var _this = this;

    // We need to know if the user is mobile,
    // since we don't auto-select a product for mobile
    var mql = window.matchMedia("(max-width: 575.98px)");
    var fn = function fn() {
      return _this.isMobile = mql.matches;
    };
    fn();
    mql.addListener(fn);
  },

  methods: {
    onClickCrumbs: function onClickCrumbs() {
      // On mobile, go back to list of items
      if (this.isMobile) this.product = null;
    }
  },
  components: {
    ProductList: __WEBPACK_IMPORTED_MODULE_1__businesscards_shared_ProductList__["a" /* default */],
    ProductPanel: __WEBPACK_IMPORTED_MODULE_0__businesscards_shared_ProductPanel__["a" /* default */]
  }
});

/***/ }),

/***/ "sDZH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',[_c('LineItemThumbnails',{attrs:{"preview_urls":_vm.line.preview_urls,"popover":""}})],1),_vm._v(" "),_c('b-col',[_c('div',[_c('b',[_vm._v("Qty:")]),_vm._v(" "+_vm._s(+_vm.line.quantity * +_vm.line.boxSize))]),_vm._v(" "),_c('div',[_c('b',[_vm._v("Total:")]),_vm._v(" $"+_vm._s(_vm.line.price_incl_tax.toFixed(2)))])]),_vm._v(" "),_c('b-col',[(_vm.canEditDesign)?_c('b-button',{staticClass:"d-lg-block",attrs:{"variant":"clear"},on:{"click":_vm.editDesign}},[_vm._v("Edit Design")]):_vm._e(),_vm._v(" "),(_vm.canChange)?_c('b-button',{staticClass:"d-lg-block",attrs:{"variant":"clear"},on:{"click":_vm.changeProduct}},[_vm._v("Change")]):_vm._e(),_vm._v(" "),(_vm.canDelete)?_c('b-button',{staticClass:"d-lg-block",attrs:{"variant":"clear"},on:{"click":_vm.deleteLine}},[_vm._v("Delete")]):_vm._e()],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12"}},[(!_vm.changing)?_c('div',[_vm._v("\n      "+_vm._s(_vm.line.product ? _vm.line.product.title : '(product information is loading)')+"\n    ")]):_c('LineDetailProductForm',{attrs:{"line":_vm.line},on:{"done":function($event){_vm.changing = false}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sNaF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"benefits-layer"},[_c('b-container',{staticClass:"content"},[_c('b-row',{staticClass:"benefit-row"},[_c('b-col',{attrs:{"md":"6","id":"benefit"}},[_c('div',{staticClass:"illustration-area-sm",attrs:{"id":"left"}},[_c('img',{staticStyle:{"width":"450px"},attrs:{"src":"/static/images/homepage/built-to-scale@3x.png","alt":""}})])]),_vm._v(" "),_c('b-col',{attrs:{"md":"6","id":"benefit"}},[_c('div',{staticClass:"text-area",attrs:{"id":"left"}},[_c('h2',[_vm._v("Fast and easy ordering")]),_vm._v(" "),_c('p',[_vm._v("Manage, edit, and order all of your team's business cards in one place. \n               Our online portal empowers admin level controls and employee self-ordering.")])])])],1),_vm._v(" "),_c('b-row',{staticClass:"benefit-row",attrs:{"id":"flip"}},[_c('b-col',{attrs:{"md":"6","id":"benefit"}},[_c('div',{staticClass:"text-area",attrs:{"id":"right"}},[_c('h2',[_vm._v("Business-level pricing")]),_vm._v(" "),_c('p',[_vm._v("Our everyday, low prices save you from having to wait for a special promotion. And with \"free-backsides\" - \n               no charge for second side printing - and free shipping, you'll never be suprised at checkout.")])])]),_vm._v(" "),_c('b-col',{attrs:{"md":"6","id":"benefit"}},[_c('div',{staticClass:"illustration-area-sm",attrs:{"id":"pig"}},[_c('img',{staticStyle:{"width":"500px"},attrs:{"src":"/static/images/homepage/business.png"}})])])],1),_vm._v(" "),_c('b-row',{staticClass:"benefit-row"},[_c('b-col',{attrs:{"md":"6","id":"benefit"}},[_c('div',{staticClass:"illustration-area-sm",attrs:{"id":"left"}},[_c('img',{staticStyle:{"width":"500px"},attrs:{"src":"/static/images/homepage/branding-matters@3x.png","alt":""}})])]),_vm._v(" "),_c('b-col',{attrs:{"md":"6","id":"benefit"}},[_c('div',{staticClass:"text-area",attrs:{"id":"left"}},[_c('h2',[_vm._v("Branding matters")]),_vm._v(" "),_c('p',[_vm._v("Brand consistency begins with "),_c('em',[_vm._v("your")]),_vm._v(" artwork. Simply upload a PDF of your business card and our software turns it\n               into an orderable online template in seconds! Your original design is preserved and you get on-brand prints every time. ")])])])],1),_vm._v(" "),_c('b-row',{staticClass:"benefit-row",attrs:{"id":"flip"}},[_c('b-col',{attrs:{"md":"6","id":"benefit"}},[_c('div',{staticClass:"text-area",attrs:{"id":"right"}},[_c('h2',[_vm._v("Built to scale")]),_vm._v(" "),_c('p',[_vm._v("Brandly is thoughtfully crafted for growing teams, with features and functionality for busy professionals. \n               From team member management, to access controls, to lockable templates, Brandly is designed to grow with you every step of the way!")])])]),_vm._v(" "),_c('b-col',{attrs:{"md":"6","id":"benefit"}},[_c('div',{staticClass:"illustration-area-sm",attrs:{"id":"right"}},[_c('img',{staticStyle:{"width":"500px"},attrs:{"src":"/static/images/homepage/order-with-confidence@3x.png"}})])])],1)],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"benefits-header"},[_c('h2',[_vm._v("Looking for a business-friendly printer?")]),_vm._v(" "),_c('p',[_vm._v("Achieving brand consistency and increasing your productivity should never cost you extra. \n        That’s why our platform and support are free. ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sTsO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sVcB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QtyPriceForm_vue__ = __webpack_require__("Rmo0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f9d0659_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QtyPriceForm_vue__ = __webpack_require__("Nr6S");
function injectStyle (ssrContext) {
  __webpack_require__("XxLM")
  __webpack_require__("hvE2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f9d0659"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QtyPriceForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f9d0659_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QtyPriceForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sXOC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sk-wave",class:{inline: _vm.inline, block: !_vm.inline}},[_c('div',{staticClass:"sk-rect sk-rect1",style:({backgroundColor: _vm.color})}),_vm._v(" "),_c('div',{staticClass:"sk-rect sk-rect2",style:({backgroundColor: _vm.color})}),_vm._v(" "),_c('div',{staticClass:"sk-rect sk-rect3",style:({backgroundColor: _vm.color})}),_vm._v(" "),_c('div',{staticClass:"sk-rect sk-rect4",style:({backgroundColor: _vm.color})}),_vm._v(" "),_c('div',{staticClass:"sk-rect sk-rect5",style:({backgroundColor: _vm.color})})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sZKJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_common__ = __webpack_require__("Cvgy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_uploads__ = __webpack_require__("O+70");





/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    uploadsInfo: {
      uploads: [],
      busy: false,
      pageNumber: 1,
      totalUploads: 0
    }
  },
  mutations: {
    setUploadsPaginated: function setUploadsPaginated(state, _ref) {
      var results = _ref.results,
          count = _ref.count,
          pageNumber = _ref.pageNumber;

      state.uploadsInfo = { uploads: results, totalUploads: count, pageNumber: pageNumber, busy: false };
    },
    setUploadsLoadingIsBusy: function setUploadsLoadingIsBusy(state) {
      state.uploadsInfo.busy = true;
    }
  },
  actions: {
    loadUploadsPaginated: function loadUploadsPaginated(_ref2, payload) {
      var _this = this;

      var commit = _ref2.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref3, results, count, pageNumber;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit('setUploadsLoadingIsBusy');
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_common__["a" /* getItemsPaginated */])(__WEBPACK_IMPORTED_MODULE_3__services_uploads__["a" /* getUploads */], payload);

              case 3:
                _ref3 = _context.sent;
                results = _ref3.results;
                count = _ref3.count;
                pageNumber = payload.pageNumber;

                commit('setUploadsPaginated', { results: results, count: count, pageNumber: pageNumber });

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  getters: {
    uploads: function uploads(state) {
      return state.uploadsInfo.uploads;
    },
    uploadsBusy: function uploadsBusy(state) {
      return state.uploadsInfo.busy;
    },
    pageNumberUploads: function pageNumberUploads(state) {
      return state.uploadsInfo.pageNumber;
    },
    totalUploads: function totalUploads(state) {
      return state.uploadsInfo.totalUploads;
    }
  }
});

/***/ }),

/***/ "saO9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


var filestack = void 0,
    client = void 0;
/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!client) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return', client);

          case 2:
            if (filestack) {
              _context.next = 6;
              break;
            }

            _context.next = 5;
            return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "i84t"));

          case 5:
            filestack = _context.sent;

          case 6:
            client = filestack.init('Alk3WMOHgRFWXlzfjOqstz');
            return _context.abrupt('return', client);

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  function filestackClient() {
    return _ref.apply(this, arguments);
  }

  return filestackClient;
})());

/***/ }),

/***/ "sked":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      saving: false,
      form: {}
    };
  },
  mounted: function mounted() {
    this.form = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
      requireNotifyEmail: false
    }, this.approvalSettings);
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['approvalSettings'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['updateTeam']), {
    save: function save() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var approval_settings;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.saving = true;
                approval_settings = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this.approvalSettings, _this.form);
                _context.next = 4;
                return _this.updateTeam({ approval_settings: approval_settings });

              case 4:
                _this.saving = false;
                _this.$router.push('/dashboard/settings');

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  })
});

/***/ }),

/***/ "sqHK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineItemPreview_vue__ = __webpack_require__("tuKc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fd08377_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineItemPreview_vue__ = __webpack_require__("UGVJ");
function injectStyle (ssrContext) {
  __webpack_require__("8dmq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0fd08377"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineItemPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fd08377_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineItemPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "stem":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value'],
  watch: {
    value: {
      deep: true,
      handler: function handler(val) {
        this.$emit('input', val);
      }
    }
  },
  computed: {
    is_private: {
      get: function get() {
        return !this.value.available_to_team;
      },
      set: function set(value) {
        this.value.available_to_team = !value;
      }
    }
  },
  methods: {
    fixExpiration: function fixExpiration() {
      this.value.expiration = this.value.expiration.replace(/^(\d\d)(\d\d)$/, "$1/$2");
    },
    validationAttrsFor: function validationAttrsFor(fieldname) {
      var feedback = void 0,
          state = void 0;
      var err = this.errors.first(fieldname);
      feedback = err;
      state = !err; // TODO maybe return null when v-validate "untouched" flag or similar
      return { state: state, 'invalid-feedback': feedback };
    }
  }
});

/***/ }),

/***/ "stvd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "syyg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");




//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['line'],
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['changeOrderLine']), {
    save: function save(_ref) {
      var _this = this;

      var start = _ref.start,
          done = _ref.done,
          boxSize = _ref.boxSize,
          product = _ref.product;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('about to changeOrderLine');
                start();
                _context.prev = 2;
                _context.next = 5;
                return _this.changeOrderLine({
                  line: _this.line.id,
                  boxSize: boxSize,
                  product: product
                });

              case 5:
                console.log('saved!');
                _this.$emit('done');
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](2);

                console.error(_context.t0);
                done();

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 9]]);
      }))();
    }
  })
});

function delay(ms) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (r, e) {
    return setTimeout(r, ms);
  });
}

/***/ }),

/***/ "t2bC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_libraries_js__ = __webpack_require__("VtcT");




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loading: null,
    libraries: null,
    library: {
      name: null,
      id: null,
      templates: []
    }
  },
  mutations: {
    setLibraries: function setLibraries(state, libraries) {
      state.libraries = libraries;
    },
    setLibrary: function setLibrary(state, library) {
      state.library.name = library.name;
      state.library.id = library.id;
      state.library.templates = library.templates;
      state.loading = null;
    },
    loadingLibrary: function loadingLibrary(state, library_id_or_name) {
      state.loading = library_id_or_name;
    }
  },
  actions: {
    loadLibraries: function loadLibraries(_ref) {
      var _this = this;

      var state = _ref.state,
          dispatch = _ref.dispatch;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(state.libraries === null)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', dispatch('reloadLibraries'));

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    reloadLibraries: function reloadLibraries(_ref2) {
      var _this2 = this;

      var commit = _ref2.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var libs;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_libraries_js__["c" /* libraries */])();

              case 2:
                libs = _context2.sent;

                commit('setLibraries', libs);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    loadLibrary: function loadLibrary(_ref3, library_id) {
      var _this3 = this;

      var dispatch = _ref3.dispatch,
          commit = _ref3.commit,
          state = _ref3.state;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                commit('loadingLibrary', library_id);

                if (!/[^0-9]/.test(library_id)) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 4;
                return dispatch('loadLibraries');

              case 4:
                library_id = state.libraries.find(function (_ref4) {
                  var name = _ref4.name;
                  return name === library_id;
                }).id;

              case 5:
                _context3.next = 7;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_libraries_js__["d" /* library */])(library_id);

              case 7:
                result = _context3.sent;

                commit('setLibrary', result);

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    addTemplate: function addTemplate(_ref5, template_id) {
      var _this4 = this;

      var state = _ref5.state,
          commit = _ref5.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var id, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                id = state.library.id;
                _context4.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_libraries_js__["a" /* addTemplateToLibrary */])(id, template_id);

              case 3:
                result = _context4.sent;

                commit('setLibrary', result);

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    removeTemplate: function removeTemplate(_ref6, template_id) {
      var _this5 = this;

      var state = _ref6.state,
          commit = _ref6.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var id, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                id = state.library.id;
                _context5.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_libraries_js__["f" /* removeTemplateFromLibrary */])(id, template_id);

              case 3:
                result = _context5.sent;

                commit('setLibrary', result);

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    setLibrary: function setLibrary(_ref7, library) {
      var dispatch = _ref7.dispatch;

      // library may or may not be a complete representation of the library.
      // Just load it.
      return dispatch('loadLibrary', library.id);
    },
    createLibrary: function createLibrary(_ref8, name) {
      var _this6 = this;

      var commit = _ref8.commit,
          dispatch = _ref8.dispatch;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var library;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_libraries_js__["b" /* createLibrary */])({ name: name });

              case 2:
                library = _context6.sent;

                dispatch('reloadLibraries');
                return _context6.abrupt('return', library);

              case 5:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    deleteLibrary: function deleteLibrary(_ref9, id) {
      var _this7 = this;

      var dispatch = _ref9.dispatch;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__services_libraries_js__["e" /* removeLibrary */])(id);

              case 2:
                return _context7.abrupt('return', dispatch('reloadLibraries'));

              case 3:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    }
  },
  getters: {
    libraryTemplates: function libraryTemplates(state) {
      return state.library.templates;
    },
    libraryName: function libraryName(state) {
      return state.library.name;
    },
    libraries: function libraries(state) {
      return state.libraries;
    }
  }
});

/***/ }),

/***/ "t3BV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t8AH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_606e3e8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__ = __webpack_require__("1BkZ");
function injectStyle (ssrContext) {
  __webpack_require__("hur9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-606e3e8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_606e3e8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "tAcp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa1ead94_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Benefits_vue__ = __webpack_require__("sNaF");
function injectStyle (ssrContext) {
  __webpack_require__("dU0Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aa1ead94"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa1ead94_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Benefits_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "tAjI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamSection_vue__ = __webpack_require__("2c7B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_549dc7b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeamSection_vue__ = __webpack_require__("xYxm");
function injectStyle (ssrContext) {
  __webpack_require__("z7V6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-549dc7b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_549dc7b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeamSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tC48":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('SettingsTitleBar',{attrs:{"sub":"Profile"}}),_vm._v(" "),_c('b-form-group',{attrs:{"label":"First Name:","label-for":"first_name"}},[_c('b-form-input',{attrs:{"id":"first_name","placeholder":"Enter first name"},model:{value:(_vm.form.first_name),callback:function ($$v) {_vm.$set(_vm.form, "first_name", $$v)},expression:"form.first_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Last Name:","label-for":"last_name"}},[_c('b-form-input',{attrs:{"id":"last_name","placeholder":"Enter last name"},model:{value:(_vm.form.last_name),callback:function ($$v) {_vm.$set(_vm.form, "last_name", $$v)},expression:"form.last_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Email:","label-for":"email"}},[_c('b-form-input',{attrs:{"id":"email","type":"email","placeholder":"Enter email"},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Job Role:","label-for":"job_role"}},[_c('b-form-select',{model:{value:(_vm.form.job_role),callback:function ($$v) {_vm.$set(_vm.form, "job_role", $$v)},expression:"form.job_role"}},[_c('option',{attrs:{"value":""}},[_vm._v("(select one)")]),_vm._v(" "),_c('option',[_vm._v("Owner/Founder")]),_vm._v(" "),_c('option',[_vm._v("Office Manager/Admin")]),_vm._v(" "),_c('option',[_vm._v("Designer")]),_vm._v(" "),_c('option',[_vm._v("Marketing")]),_vm._v(" "),_c('option',[_vm._v("HR")]),_vm._v(" "),_c('option',[_vm._v("Sales")]),_vm._v(" "),_c('option',[_vm._v("Other")])])],1),_vm._v(" "),_vm._l((_vm.personalVars),function(ref){
var key = ref.key;
var label = ref.label;
return _c('b-form-group',{key:key,attrs:{"label":label,"label-for":key}},[_c('b-form-input',{attrs:{"type":"text","placeholder":""},model:{value:(_vm.info[key]),callback:function ($$v) {_vm.$set(_vm.info, key, $$v)},expression:"info[key]"}})],1)}),_vm._v(" "),(!_vm.isStaff && _vm.userTeams.length > 1)?_c('div',[_c('b-modal',{attrs:{"id":"leave-team-modal","title":"Leave current team","centered":""},on:{"ok":_vm.leaveCurrentTeam}},[_c('div',[_vm._v("Are you sure you want to leave \""+_vm._s(_vm.team.name)+"\"?")])]),_vm._v(" "),_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.leave-team-modal",modifiers:{"leave-team-modal":true}}],staticClass:"mt-3",attrs:{"size":"sm","variant":"outline-secondary"}},[_c('i',{staticClass:"fas fa-sign-out-alt"}),_vm._v(" Leave "+_vm._s(_vm.team.name)+"\n  ")])],1):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tCCD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewTeam_vue__ = __webpack_require__("/crR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38cd8972_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewTeam_vue__ = __webpack_require__("4gAD");
function injectStyle (ssrContext) {
  __webpack_require__("P61H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38cd8972"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewTeam_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38cd8972_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewTeam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tOs8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identify;
function identify(user, team) {
  if (false) console.log('track/identify', user, team);
  // We expect anonymous users to have no email or name -- skip them.
  // Some sign up methods may not have a name.
  var name = void 0,
      email = user.email,
      first_name = user.first_name,
      last_name = user.last_name;
  if (first_name && last_name) name = first_name + ' ' + last_name;
  if (!email) return;
  var team_name = team && team.name || null;

  // Intercom
  if (window.intercomSettings) {
    if (name) window.intercomSettings.name = name;
    if (email) window.intercomSettings.email = email;
  }

  // Drip.io
  if (window._dcq) {
    window._dcq.push(["identify", {
      email: email,
      first_name: first_name,
      last_name: last_name,
      team_name: team_name
    }]);
  }

  // User Pilot
  if (window.userpilot) {
    var identifyData = {
      // User data
      email: email,
      name: name,
      user_type: user.user_type,
      job_role: user.job_role,
      created_at: user.date_joined,

      // Derived data -- allows for simple A/B testing
      ab: 'ab'[user.id & 1],

      // Team data
      team_id: team.id,
      team_name: team.name,
      team_domain: team.domain,
      company_size: team.company_size,
      have_design: team.have_design
    };
    if (false) console.log('userpilot/identify', identifyData);
    window.userpilot.identify(user.id, identifyData);
  }

  // Amplitude
  if (window.amplitude) {
    var instance = window.amplitude.getInstance();
    instance.setUserId(email);
    instance.setUserProperties({ first_name: first_name, last_name: last_name, email: email, team_name: team.name });
  }

  if (window.LogRocket) {
    window.LogRocket.identify(user.id, {
      name: name,
      email: email
    });
  }
}

/***/ }),

/***/ "tVbG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = defineService;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_ALTERNATIVES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__authorize__ = __webpack_require__("lKgw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_cookie__ = __webpack_require__("+FgK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_tiny_cookie__);





var getStatic = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(url, method, options, args) {
    var _staticTweaks, suffix, status, response;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _staticTweaks = staticTweaks(options, args), suffix = _staticTweaks.suffix, status = _staticTweaks.status;
            _context3.next = 3;
            return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + method + suffix + '.json');

          case 3:
            response = _context3.sent;

            if (!status) {
              _context3.next = 6;
              break;
            }

            throw fakeAxiosError(status, response);

          case 6:
            return _context3.abrupt('return', extractResult(response, options));

          case 7:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function getStatic(_x2, _x3, _x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();

var callService = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(url, method, data, options) {
    var headers;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.t0 = addContentType;
            _context4.next = 3;
            return Object(__WEBPACK_IMPORTED_MODULE_5__authorize__["a" /* authHeaders */])();

          case 3:
            _context4.t1 = _context4.sent;
            _context4.t2 = data;
            headers = (0, _context4.t0)(_context4.t1, _context4.t2);
            return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_4_axios___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({ url: url, method: method, headers: headers }, method === 'get' ? 'params' : 'data', data)).then(function (response) {
              return extractResult(response, options);
            }));

          case 7:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function callService(_x6, _x7, _x8, _x9) {
    return _ref5.apply(this, arguments);
  };
}();





/**
 * Create a service functions that takes (data) or if paramater is passed, (arg, data)
 * and returns an axios promise.
 * When using static urls for development, these are get requests
 * and params/data is ignored.
 * All of these services will send authorization headers (possibly waiting
 * for the authorization service to respond)
 */
function defineService(method, path, options) {
  var _this = this;

  if (options && options.alternatives) {
    // Save all possible alternatives for use in UI
    for (var key in options.alternatives) {
      ALL_ALTERNATIVES[key] = false;
    }
  }
  if ({"API":"https://www.brandly.com/backend/","APP":"https://www.brandly.com","STATIC":false}.STATIC) {
    return function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(data) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', getStatic({"API":"https://www.brandly.com/backend/","APP":"https://www.brandly.com","STATIC":false}.API + path, method, options, data));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  } else {
    return function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var url;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = {"API":"https://www.brandly.com/backend/","APP":"https://www.brandly.com","STATIC":false}.API + expandAndRemoveArgs(path, args);
                return _context2.abrupt('return', callService(url, method, args[0], options));

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function () {
        return _ref2.apply(this, arguments);
      };
    }();
  }
}
var ALL_ALTERNATIVES = {};

/**
 * To facilitate testing, allow the static file to be returned to change.
 *
 * Any flags (defined in the flags cookie) that match an alternative passed
 * in defineService will cause that suffix to be added to the static request URL.
 * Without a mechanism like this, it would be impossible to test all UI states
 * from the `npm run dev`
 *
 * If the suffix ends in a status code (with dash), eg '-wrongpw-400', then that status
 * code is faked as well.
 *
 * @param {string} options -- object containing staticIds, alternatives, suffix
 *
 */
function staticTweaks(options, data) {
  var _ref3 = options || {},
      _ref3$suffixFunc = _ref3.suffixFunc,
      suffixFunc = _ref3$suffixFunc === undefined ? calcSuffix : _ref3$suffixFunc,
      _ref3$alternatives = _ref3.alternatives,
      alternatives = _ref3$alternatives === undefined ? {} : _ref3$alternatives;

  var flags = Object(__WEBPACK_IMPORTED_MODULE_6_tiny_cookie__["getCookie"])('flags', JSON.parse);
  var suffix = suffixFunc(data, flags || {}, alternatives) || '';
  var m = /-([45]\d\d)$/.exec(suffix);
  return { suffix: suffix, status: m && m[1] };
}

function calcSuffix(data, flags, alternatives) {
  if (!alternatives) return;
  for (var alternativeKey in alternatives) {
    if (flags[alternativeKey]) {
      return alternatives[alternativeKey];
    }
  }
}

function fakeAxiosError(status, response) {
  var e = new Error('fake error');
  response.status = status;
  e.response = response;
  return e;
}

function extractResult(response, options) {
  var data = response.data;
  if (options && options.mainKey) data = data[options.mainKey];
  return data;
}

function addContentType(headers, data) {
  if (data instanceof FormData) {
    headers['content-type'] = 'multipart/form-data';
  } else if (data) {
    headers['content-type'] = 'application/json';
  }
  return headers;
}

function expandAndRemoveArgs(url, args) {
  if (args[0] && isUrl(args[0])) {
    return expandFromUrl(url, args.shift());
  } else {
    return url.replace(/:([a-z]+)/g, function (m) {
      return args.shift();
    });
  }
}

function isUrl(arg) {
  return typeof arg === 'string' && arg.startsWith('http');
}

function expandFromUrl(urlPattern, expandedUrl) {
  // Turn parameters in urlPattern into a regex matching numbers
  var re = new RegExp(urlPattern.replace(/(:[a-z]+)/g, '[0-9]+'));
  // Return the portion that matches (or fail)
  var match = re.exec(expandedUrl);
  if (!match) throw new Error("Unable to match url: " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ urlPattern: urlPattern, expandedUrl: expandedUrl }));
  return match[0];
}

/***/ }),

/***/ "tavi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57263775_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingPageSaveTime_vue__ = __webpack_require__("Vwpu");
function injectStyle (ssrContext) {
  __webpack_require__("ZpmN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57263775"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57263775_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingPageSaveTime_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "tciu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Ordering Permissions")]),_vm._v(" "),(_vm.hasMultipleProductTemplates)?_c('div',[_c('RestrictedToggle',{model:{value:(_vm.restrictDesign),callback:function ($$v) {_vm.restrictDesign=$$v},expression:"restrictDesign"}},[_c('template',{slot:"allow"},[_vm._v("Allow choosing any design\n        "),_c('div',{staticStyle:{"margin-left":"3em"}},[_vm._v("Default design to:\n          "),_c('b-form-select',{staticStyle:{"max-width":"20em"},attrs:{"options":_vm.templateDefaultOptions},model:{value:(_vm.currentTemplate),callback:function ($$v) {_vm.currentTemplate=$$v},expression:"currentTemplate"}})],1)]),_vm._v(" "),_c('template',{slot:"restrict"},[_vm._v("\n        Restrict design to:\n        "),_c('b-form-select',{staticStyle:{"margin-left":"3em","max-width":"20em"},attrs:{"options":_vm.templateOptions},model:{value:(_vm.currentTemplate),callback:function ($$v) {_vm.currentTemplate=$$v},expression:"currentTemplate"}})],1)],2)],1):_vm._e(),_vm._v(" "),_c('RestrictedToggle',{attrs:{"label":"changing paper"},model:{value:(_vm.restrictProduct),callback:function ($$v) {_vm.restrictProduct=$$v},expression:"restrictProduct"}}),_vm._v(" "),_c('RestrictedToggle',{attrs:{"label":"changing qty"},model:{value:(_vm.restrictQty),callback:function ($$v) {_vm.restrictQty=$$v},expression:"restrictQty"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tkrX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionButton_vue__ = __webpack_require__("WqWh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b45647dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionButton_vue__ = __webpack_require__("HG0L");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b45647dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "tuKc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_productAttrs__ = __webpack_require__("X9yx");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['line'],
  data: function data() {
    return { currentIndex: 0 };
  },

  computed: {
    currentUrl: function currentUrl() {
      return this.line.preview_urls[this.currentIndex];
    },
    roundedCorners: function roundedCorners() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__lib_productAttrs__["a" /* isRounded */])(this.line.product);
    }
  }
});

/***/ }),

/***/ "tz0Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_states_json__ = __webpack_require__("TeLn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_states_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__data_states_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_CheckoutLogic__ = __webpack_require__("KrFv");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var addressTypeShipping = 'Shipping';

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    infoType: {
      type: String,
      default: addressTypeShipping
    },
    value: {
      type: Object,
      default: Object(__WEBPACK_IMPORTED_MODULE_5__lib_CheckoutLogic__["c" /* empty_address */])()
    }
  },
  data: function data() {
    return {
      USA: __WEBPACK_IMPORTED_MODULE_5__lib_CheckoutLogic__["b" /* USA */],
      states: __WEBPACK_IMPORTED_MODULE_4__data_states_json___default.a,
      form: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.value)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['flags', 'countries']), {
    prefix: function prefix() {
      return this.infoType.toLowerCase();
    },
    isUSA: function isUSA() {
      return Object(__WEBPACK_IMPORTED_MODULE_5__lib_CheckoutLogic__["g" /* isUSA */])(this.form.country);
    }
  }),
  watch: {
    form: {
      deep: true,
      handler: function handler(val) {
        this.$emit('input', val);
      }
    },
    value: function value(val) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val) != __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.form)) {
        // When props change, update the form, but only if the
        // values are different. Otherwise an infinite loop occurs.
        this.form = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, val);
      }
    }
  },
  mounted: function mounted() {
    // Sometimes the validation doesnt seem to trigger
    // on load, causing spurious differences in layout
    this.$validator.validate();

    if (this.flags.internationalShipping && this.countries.length === 0) {
      this.loadCountries();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['loadCountries']))
});

/***/ }),

/***/ "u/Sl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_bubble_wrapAction__ = __webpack_require__("514v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ProfileRow__ = __webpack_require__("6QMR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MemberRestrictions__ = __webpack_require__("GmE8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AdminPreferences__ = __webpack_require__("FuP2");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ProfileRow: __WEBPACK_IMPORTED_MODULE_6__ProfileRow__["a" /* default */],
    MemberRestrictions: __WEBPACK_IMPORTED_MODULE_7__MemberRestrictions__["a" /* default */],
    AdminPreferences: __WEBPACK_IMPORTED_MODULE_8__AdminPreferences__["a" /* default */]
  },
  props: ['id'],
  data: function data() {
    return { sending: false };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["flags", "member", "user", "isAdmin", "impersonating", "isStaff"]), {
    name: function name() {
      var _member = this.member,
          first_name = _member.first_name,
          last_name = _member.last_name;

      if (first_name || last_name) return (first_name + ' ' + last_name).trim();
      return null;
    }
  }),
  watch: {
    id: function id(val) {
      this.loadTeamMember(this.id);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['resendInvite', 'loadTeamMember', 'deleteUser', 'updateUserProfile', 'removeFromTeam', 'impersonate']), {
    onClickResend: function onClickResend() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.sending = true;
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this.resendInvite(_this.member.email), new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (r) {
                  return setTimeout(r, 100);
                }) // wait a little bit so user can notice something happened
                ]);

              case 4:
                _this.sending = false;
                _context.next = 11;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](1);

                // By far most likely cause is user has accepted the invite.
                // Refreshing the list should help inform the user of this fact.
                // TODO implement other error handling
                _this.reloadTeamInfo();
                console.error(_context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 7]]);
      }))();
    },
    showActionDropdown: function showActionDropdown() {
      // Hide if no actions are available
      return this.showResend() || this.showChangeRole() || this.showRemoveFromTeam() || this.showDelete() || this.showImpersonate();
    },
    showResend: function showResend() {
      // Only for inactive users.
      return !this.member.is_active;
    },
    showChangeRole: function showChangeRole() {
      // Only show if the user is active and has a user_type we understand.
      // Can't change your own role. Must be logged in as admin.
      return this.isAdmin && this.otherRole() && this.member.is_active && this.member.id !== this.user.id;
    },

    onClickChangeRole: Object(__WEBPACK_IMPORTED_MODULE_5__lib_bubble_wrapAction__["a" /* default */])({
      action: function action() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
          var user_type, id;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  user_type = { admin: 'user', user: 'admin' }[_this2.member.user_type];

                  if (user_type) {
                    _context2.next = 3;
                    break;
                  }

                  throw "Invalid user type";

                case 3:
                  id = _this2.member.id;
                  // TODO show in process

                  _context2.next = 6;
                  return _this2.updateUserProfile({ id: id, user_type: user_type });

                case 6:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }))();
      },

      success: "Role changed successfully"
    }),

    showRemoveFromTeam: function showRemoveFromTeam() {
      // Can't remove yourself. Must be admin, Can remove active or inactive members.
      return this.isAdmin && this.member.id !== this.user.id;
    },

    onClickRemoveFromTeam: Object(__WEBPACK_IMPORTED_MODULE_5__lib_bubble_wrapAction__["a" /* default */])({
      confirm: 'Remove team member?',
      action: 'removeFromTeam',
      arg: { data: 'member' },
      success: 'Team member removed'
    }),

    showDelete: function showDelete() {
      // Dangerous operation -- hidden behind flag & can't delete yourself
      return this.flags.enableDeleteUser && this.user.is_staff && this.member.id !== this.user.id;
    },

    onClickDelete: Object(__WEBPACK_IMPORTED_MODULE_5__lib_bubble_wrapAction__["a" /* default */])({
      confirm: function confirm() {
        return "Permanently delete " + this.member.email + "?";
      },

      action: 'deleteUser',
      arg: function arg() {
        return this.member.id;
      },

      success: 'Success'
    }),

    showImpersonate: function showImpersonate() {
      return this.impersonating && this.isStaff;
    },
    onClickImpersonate: function onClickImpersonate() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.impersonate(_this3.member.username);

              case 2:
                // To avoid issues with state not being completely updated,
                // just reload.
                window.location.reload();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    showStartOrder: function showStartOrder() {
      // No reason this can't apply for invitees
      return true;
    },
    userRoleText: function userRoleText() {
      // Return a label for the user type. If we get an unexpected user_type, just return that.
      return { admin: 'Admin', user: 'Orderer' }[this.member.user_type] || this.member.user_type;
    },
    otherRole: function otherRole() {
      // Return the OPPOSITE type. If we get an unexpected user_type this returns undefined.
      return { admin: 'Orderer', user: 'Administrator' }[this.member.user_type];
    }
  })
});

/***/ }),

/***/ "u3J8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_CheckoutLogic__ = __webpack_require__("KrFv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      form: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4__lib_CheckoutLogic__["d" /* empty_payment */])(), {
        saved_card: '', // blank signals that a default needs to be chosen
        save_card: false,
        title: '',
        is_private: true
      })
    };
  },

  props: {
    // Note: this is the "incoming" value. We largely ignore this.
    value: {
      type: Object
    },
    hasCardOnFile: {
      default: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(['savedCards', 'savedCardsLoaded', 'defaultSavedCard', 'loggedIn']), {
    savedCardOptions: function savedCardOptions() {
      return this.savedCards.map(function (c) {
        return { value: c.id, text: c.title };
      });
    },
    allowSave: function allowSave() {
      return this.loggedIn;
    }
  }),
  watch: {
    form: {
      deep: true,
      handler: function handler(val) {
        this.$emit('input', val);
      }
    },
    loggedIn: function loggedIn(val) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!val) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return _this.loadSavedCards();

              case 3:
                _this.chooseDefaultCard();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['loadSavedCards']), {
    chooseDefaultCard: function chooseDefaultCard() {
      if (this.form.saved_card !== '') {
        console.log('default already chosen', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.form.saved_card));
        return; // default already chosen
      }
      console.log("chooseDefaultCard=>", this.defaultSavedCard || null);
      this.form.saved_card = this.defaultSavedCard || null;
    },
    fixExpiration: function fixExpiration() {
      this.form.expiration = this.form.expiration.replace(/^(\d\d)(\d\d)$/, "$1/$2");
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this2.loggedIn) {
                _context2.next = 4;
                break;
              }

              _context2.next = 3;
              return _this2.loadSavedCards();

            case 3:
              _this2.chooseDefaultCard();

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),

/***/ "u5z7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cards__ = __webpack_require__("jd3D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Overview__ = __webpack_require__("aovp");
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  // Sub-route configuration
  children: [{
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_1__Overview__["a" /* default */]
  }].concat(__WEBPACK_IMPORTED_MODULE_0__cards__["a" /* default */].map(function (card) {
    return {
      path: card.key,
      component: card.editComponent
    };
  }))
});

/***/ }),

/***/ "u68k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u6P3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f6c9b18_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeatureItem_vue__ = __webpack_require__("gEOo");
function injectStyle (ssrContext) {
  __webpack_require__("FNdV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8f6c9b18"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f6c9b18_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeatureItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "uBAG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = waitPlugin;
/* harmony export (immutable) */ __webpack_exports__["a"] = waitFor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var $store = void 0;
function waitPlugin(store) {
  $store = store;
}
function waitFor(getterName, timeout) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if ($store.getters[getterName]) return resolve();
    var unwatch = $store.watch(function (state, getters) {
      return getters[getterName];
    }, function (value) {
      if (value) {
        unwatch();
        resolve();
      }
    });
    setTimeout(function () {
      unwatch();reject('time out');
    }, timeout);
  });
}

/***/ }),

/***/ "uDoP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);



//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return { gapiReady: null, gauth: null };
  },
  mounted: function mounted() {
    var _this = this;

    this.gapiReady = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
      window.initGoogle = function () {
        gapi.load('auth2', function () {
          gapi.auth2.init(_this.authConfig);
          _this.gauth = gapi.auth2.getAuthInstance();
          resolve();
        });
      };
    });
    this.addScript('https://apis.google.com/js/api:client.js?onload=initGoogle');
  },

  computed: {
    authConfig: function authConfig() {
      return { client_id: "255072882725-39ksd3fajhgu2nea796vp8nm6qb4ket2.apps.googleusercontent.com" };
    }
  },
  methods: {
    onClick: function onClick() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var info;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('onClick!');
                _context.next = 3;
                return _this2.gapiReady;

              case 3:
                console.log('onClick 2');
                _context.next = 6;
                return _this2.gauth.signIn();

              case 6:
                info = _context.sent;

                console.log('gauth', info);
                _this2.$emit('login', _this2.extractUserInfo(info));

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    extractUserInfo: function extractUserInfo(guser) {
      var profile = guser.getBasicProfile();
      return {
        auth: guser.getAuthResponse(true),
        id: profile.getId(),
        name: profile.getName(),
        givenName: profile.getGivenName(),
        familyName: profile.getFamilyName(),
        imageUrl: profile.getImageUrl(),
        email: profile.getEmail()
      };
    },
    addScript: function addScript(src) {
      var node = document.createElement('script');
      node.setAttribute('src', src);
      node.setAttribute('async', '');
      document.head.appendChild(node);
    }
  }
});

/***/ }),

/***/ "uIng":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WelcomeSection_vue__ = __webpack_require__("Xvly");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40c7e6c9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WelcomeSection_vue__ = __webpack_require__("9fhP");
function injectStyle (ssrContext) {
  __webpack_require__("YHMb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40c7e6c9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WelcomeSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40c7e6c9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WelcomeSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uNuT":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./AppHeader.vue": "8eHU",
	"./AppLayout.vue": "LEUq",
	"./BottomNavigation.vue": "X3kG",
	"./Header.vue": "a4KA",
	"./HomepageHeroLayout.vue": "5jPv",
	"./HomepageLandingLayout.vue": "r/A8",
	"./HomepageLayout.vue": "EF6X",
	"./HomepageSecondaryLayout.vue": "5Fl0",
	"./HomepageWideLayout.vue": "Lq8s",
	"./LimitedHeader.vue": "0h4v",
	"./TopBar.vue": "dmV9"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uNuT";

/***/ }),

/***/ "uTlF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleSignIn_vue__ = __webpack_require__("uDoP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c2f320_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleSignIn_vue__ = __webpack_require__("fI1k");
function injectStyle (ssrContext) {
  __webpack_require__("stvd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleSignIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c2f320_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleSignIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ua/p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Qr_vue__ = __webpack_require__("Xcxx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_187e0a6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Qr_vue__ = __webpack_require__("26Aa");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Qr_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_187e0a6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Qr_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ueji":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Orders_vue__ = __webpack_require__("qxKM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65cc239a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Orders_vue__ = __webpack_require__("UnTq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Orders_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65cc239a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Orders_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uexP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uf7q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BasketSummary_vue__ = __webpack_require__("e71P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_587eb3be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BasketSummary_vue__ = __webpack_require__("8N8U");
function injectStyle (ssrContext) {
  __webpack_require__("moM2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-587eb3be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BasketSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_587eb3be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BasketSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "umbr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "up6a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: { value: Boolean, label: String },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['user', 'isAdmin']))
});

/***/ }),

/***/ "us/4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['disabled'],
  data: function data() {
    return {
      selected: 'textMode'
    };
  },

  watch: {
    selected: function selected(val) {
      if (val === 'textMode') {
        this.$emit('onTextMode');
      } else if (val === 'moveMode') {
        this.$emit('onMoveMode');
      }
    }
  }
});

/***/ }),

/***/ "uuvh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomepageWideLayout',[_c('div',{staticClass:"starterpack"},[_c('div',{staticClass:"no-strings-wrapper"},[_c('img',{staticClass:"no-strings-icon",attrs:{"src":"/static/images/starterpack/design-cup.svg"}}),_vm._v(" "),_c('h3',{staticClass:"no-strings-title"},[_vm._v("No design? No problem.")])]),_vm._v(" "),_c('div',{staticClass:"no-strings-text"},[_c('p',[_vm._v("Check out Brandly's design templates to help you get started.")]),_vm._v(" "),_c('p',{attrs:{"id":"starter-pack"}},[_c('a',{attrs:{"href":"static/downloads/starterpack.zip"}},[_vm._v("Download our Starter Pack")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uv8m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cards__ = __webpack_require__("jd3D");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['flags']), {
    cards: function cards() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2__cards__["a" /* default */].filter(function (_ref) {
        var flag = _ref.flag;
        return !flag || _this.flags[flag];
      });
    }
  })
});

/***/ }),

/***/ "uvBe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackButton_vue__ = __webpack_require__("L4y1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26e7ae43_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackButton_vue__ = __webpack_require__("gf4F");
function injectStyle (ssrContext) {
  __webpack_require__("XlDB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26e7ae43"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26e7ae43_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ux69":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.bleedPoints),function(bleedPoint){return (_vm.debug)?_c('div',{staticClass:"bleed-point",style:(_vm.bleedPointStyle(bleedPoint))}):_vm._e()}),_vm._v(" "),_vm._l((_vm.outerPoints),function(outerPoint){return _c('div',{staticClass:"bleed-point",staticStyle:{"background-color":"purple"},style:(_vm.bleedPointStyle(outerPoint, true))})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uxOt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uyyg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['approvalSettings']), {
    approvalMode: function approvalMode() {
      return this.approvalSettings.approvalMode || 'none';
    },
    state: function state() {
      return { none: 'OFF', review: 'ON', payment: 'ON' }[this.approvalMode];
    },
    smallText: function smallText() {
      return {
        none: 'Orders will be sent to production automatically',
        review: 'An admin will need to review all orders',
        payment: 'An admin will need to review+enter billing for all orders'
      }[this.approvalMode];
    }
  })
});

/***/ }),

/***/ "v1OC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v3GA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vEk2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_basket__ = __webpack_require__("gA2L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_productAttrs__ = __webpack_require__("X9yx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_selectedProduct__ = __webpack_require__("D3mI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_tiny_cookie__ = __webpack_require__("+FgK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_tiny_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_tiny_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_track_events__ = __webpack_require__("Dg6a");










var futureVoucher = null;
try {
  futureVoucher = Object(__WEBPACK_IMPORTED_MODULE_7_tiny_cookie__["getCookie"])('futureVoucher', JSON.parse) || null;
} catch (e) {
  console.error(e);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    basketLoaded: false,
    basketUrl: null,
    basketLines: [],
    numBasketLines: 0,
    basketVoucher: null,
    subtotalPrice: 0, // Price of line items only
    totalPrice: 0, // Price of line items, shipping, tax
    selected: null, // selected line
    futureVoucher: futureVoucher
  },
  mutations: {
    setBasketData: function setBasketData(state, basketData) {
      state.basketUrl = basketData.url;
      state.basketLines = basketData.lines;
      state.numBasketLines = basketData.lines.length;
      // We only handle one basket voucher. Set to undefined if no vouchers are present.
      state.basketVoucher = basketData.voucher_discounts[0];
      console.log('basketData:', basketData);
      state.basketLoaded = true;
      if (state.selected) {
        state.selected = state.basketLines.find(function (line) {
          return line.url === state.selected.url;
        });
      }
    },
    setNumBasketLines: function setNumBasketLines(state, numBasketLines) {
      state.numBasketLines = numBasketLines;
    },
    removeLine: function removeLine(state, lineItem) {
      var index = state.basketLines.findIndex(function (curLine) {
        return curLine.url === lineItem.url;
      });
      if (index === -1) {
        // We expected to find the line, this is an error
        console.error("Unable to find line to update!");
        throw "Unable to find line to update!";
      }
      state.basketLines.splice(index, 1);
      state.numBasketLines -= 1;
    },
    updateLine: function updateLine(state, lineItem) {
      var index = state.basketLines.findIndex(function (curLine) {
        return curLine.url === lineItem.url;
      });
      if (index === -1) {
        // We expected to find the line, this is an error
        throw "Unable to find line to update!";
      }

      // Ensure the lineItem we have has expanded data such as product
      if (typeof lineItem.product === 'string') {
        var curLine = state.basketLines[index];
        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(curLine.product) !== 'object' || curLine.product.url !== lineItem.product) {
          throw "New line item needs expanded product info";
        }
        lineItem.product = curLine.product;
      }

      // Replace line that we found. Use splice so Vue reacts properly
      state.basketLines.splice(index, 1, lineItem);
      if (state.selected && state.selected.url === lineItem.url) {
        state.selected = lineItem;
      }
    },
    setSelectedLine: function setSelectedLine(state, lineFilter) {
      state.selected = _.find(state.basketLines, lineFilter);
      console.log('setSelectedLine', lineFilter, '->', state.selected);
    },
    updateBasketThumbnail: function updateBasketThumbnail(state, _ref) {
      var designId = _ref.designId,
          pageNum = _ref.pageNum,
          dataUrl = _ref.dataUrl;

      var line = state.basketLines.find(function (line) {
        return +line.designId === +designId;
      });
      if (!line) return;
      line.preview_urls[pageNum] = dataUrl;
    },
    setFutureVoucher: function setFutureVoucher(state, code) {
      console.log('futureVoucher');
      state.futureVoucher = code;
      Object(__WEBPACK_IMPORTED_MODULE_7_tiny_cookie__["setCookie"])('futureVoucher', code, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default.a);
    }
  },

  actions: {
    loadBasket: function loadBasket(context) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (context.state.basketLoaded) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', _this.dispatch('reloadBasket'));

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getNumBasketLines: function getNumBasketLines(_ref2) {
      var _this2 = this;

      var commit = _ref2.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = commit;
                _context2.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_basket__["e" /* getBasketLinesCount */])();

              case 3:
                _context2.t1 = _context2.sent;
                (0, _context2.t0)('setNumBasketLines', _context2.t1);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    loadSelectedLine: function loadSelectedLine(context, lineFilter) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return context.dispatch('loadBasket');

              case 2:
                context.commit('setSelectedLine', lineFilter);

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    clearSelectedLine: function clearSelectedLine(_ref3) {
      var _this4 = this;

      var dispatch = _ref3.dispatch;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', dispatch('loadSelectedLine', function () {
                  return false;
                }));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    reloadBasket: function reloadBasket(context) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var basket;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_basket__["d" /* getBasket */])();

              case 2:
                basket = _context5.sent;

                context.commit('setBasketData', basket);
                context.dispatch('calcTax');

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    addToCart: function addToCart(context, _ref4) {
      var _this6 = this;

      var productUrl = _ref4.productUrl,
          boxSize = _ref4.boxSize,
          designId = _ref4.designId,
          quantity = _ref4.quantity,
          orderedFor = _ref4.orderedFor;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var basket;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(!productUrl || !boxSize || !quantity)) {
                  _context6.next = 2;
                  break;
                }

                throw new Error();

              case 2:
                designId = designId || context.getters.designId;
                _context6.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_basket__["a" /* addToBasket */])(productUrl, quantity, designId, boxSize, orderedFor);

              case 5:
                basket = _context6.sent;

                context.commit('setBasketData', basket);
                context.commit('setSelectedLine', { designId: designId });
                Object(__WEBPACK_IMPORTED_MODULE_8__lib_track_events__["h" /* lineAddedToCart */])();

              case 9:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    changeNumberOfBoxes: function changeNumberOfBoxes(context, _ref5) {
      var _this7 = this;

      var line = _ref5.line,
          quantity = _ref5.quantity;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_basket__["g" /* updateLineItem */])(line.url, { quantity: quantity });

              case 2:
                result = _context7.sent;

                context.commit('updateLine', result);

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    updateLine: function updateLine(context, _ref6) {
      var _this8 = this;

      var line = _ref6.line,
          product = _ref6.product,
          boxSize = _ref6.boxSize;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!product) product = line.product.url;
                _context8.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_basket__["g" /* updateLineItem */])(line.url, { boxSize: boxSize, product: product });

              case 3:
                result = _context8.sent;

                context.commit('updateLine', result);
                return _context8.abrupt('return', context.dispatch('reloadBasket'));

              case 6:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    removeFromCart: function removeFromCart(context, line) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_basket__["f" /* removeFromBasket */])(line.url);

              case 2:
                context.commit('removeLine', line);

              case 3:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },
    addLineFromProductSelector: function addLineFromProductSelector(_ref7, productSelector) {
      var _this10 = this;

      var dispatch = _ref7.dispatch,
          getters = _ref7.getters;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var numPages, p, productUrl;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                // Design should be set. Adds line from product selector.
                numPages = getters.designPageCount;
                p = Object(__WEBPACK_IMPORTED_MODULE_6__lib_selectedProduct__["b" /* expanded */])(productSelector), productUrl = p[numPages];

                if (productUrl) {
                  _context10.next = 9;
                  break;
                }

                // 1 page upload but only 2 page product, or vice versa
                productUrl = p[3 - numPages];

                if (!(numPages === 2)) {
                  _context10.next = 9;
                  break;
                }

                _context10.next = 7;
                return dispatch('dropSecondPageFromDesign');

              case 7:
                _context10.next = 9;
                return dispatch('showEditorMessage', 'The chosen product can only be printed on one side. The second side has been dropped.');

              case 9:
                _context10.next = 11;
                return dispatch('addToCart', {
                  productUrl: productUrl,
                  quantity: 1,
                  boxSize: p.quantity,
                  designId: getters.designId
                });

              case 11:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this10);
      }))();
    },
    duplicateLineAndDesign: function duplicateLineAndDesign(context, line) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return context.dispatch('startDesignFromTemplate', line.designId);

              case 2:
                return _context11.abrupt('return', context.dispatch('addToCart', {
                  productUrl: line.product.url,
                  boxSize: line.boxSize,
                  designId: context.getters.designId,
                  quantity: 1
                }));

              case 3:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this11);
      }))();
    },
    addVoucher: function addVoucher(context, voucherCode) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                result = void 0;
                _context12.prev = 1;
                _context12.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_4__services_basket__["b" /* addVoucher */])(voucherCode);

              case 4:
                result = _context12.sent;

                console.log('voucher:', result);
                _context12.next = 18;
                break;

              case 8:
                _context12.prev = 8;
                _context12.t0 = _context12['catch'](1);

                // Unwrap the error body
                console.error(_context12.t0);
                if (_context12.t0.response && _context12.t0.response.data) _context12.t0 = _context12.t0.response.data;
                if (_context12.t0.non_field_errors) _context12.t0 = _context12.t0.non_field_errors;
                if (_context12.t0.vouchercode) _context12.t0 = _context12.t0.vouchercode;
                if (_context12.t0.reason) _context12.t0 = _context12.t0.reason;
                if (_context12.t0.join) _context12.t0 = _context12.t0.join(' ');
                // Rewrite to be friendlier
                if (_context12.t0 === "Voucher code unknown") _context12.t0 = "Code not found: " + voucherCode;
                throw _context12.t0;

              case 18:
                context.dispatch('reloadBasket');

              case 19:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this12, [[1, 8]]);
      }))();
    },
    addFutureVoucher: function addFutureVoucher(_ref8, voucherCode) {
      var _this13 = this;

      var commit = _ref8.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                // Adds a future voucher that should be applied
                // later when items are added to the basket.
                // This should be fast and not use an API call.
                commit('setFutureVoucher', voucherCode);

              case 1:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this13);
      }))();
    },
    applyFutureVoucher: function applyFutureVoucher(_ref9) {
      var _this14 = this;

      var state = _ref9.state,
          dispatch = _ref9.dispatch;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (!state.futureVoucher) {
                  _context14.next = 2;
                  break;
                }

                return _context14.abrupt('return', dispatch('addVoucher', state.futureVoucher));

              case 2:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this14);
      }))();
    }
  },

  getters: {
    basketUrl: function basketUrl(state) {
      return state.basketUrl;
    },
    basketLines: function basketLines(state) {
      return state.basketLines;
    },
    subtotalPrice: function subtotalPrice(state) {
      return state.basketLines.reduce(function (sum, lineItem) {
        return sum + parseFloat(lineItem.price_excl_tax, 10);
      }, 0);
    },

    // NB: expects other modules to define getters.taxAmount, getters.shipAmount
    totalPrice: function totalPrice(state, getters) {
      var tax = getters.taxAmount,
          ship = getters.shipAmount;
      if (tax == null || ship == null) return null;
      return getters.subtotalPrice + tax + ship;
    },

    selectedProductIsRounded: function selectedProductIsRounded(state) {
      return state.selected && Object(__WEBPACK_IMPORTED_MODULE_5__lib_productAttrs__["a" /* isRounded */])(state.selected.product);
    },
    selectedLine: function selectedLine(state) {
      return state.selected;
    },
    basketVoucher: function basketVoucher(state) {
      return state.basketVoucher;
    },
    basketVoucherCode: function basketVoucherCode(state) {
      return state.basketVoucher && state.basketVoucher.voucher && state.basketVoucher.voucher.code;
    },
    numBasketLines: function numBasketLines(state) {
      return state.numBasketLines || 0;
    },
    simpleProductDiscount: function simpleProductDiscount(state) {
      return { VIP2018: 1.0, EARLYBIRD: 0.5 }[state.futureVoucher] || 0;
    },
    currentOrFutureVoucher: function currentOrFutureVoucher(state, getters) {
      return getters.basketVoucherCode || state.futureVoucher;
    }
  }
});

/***/ }),

/***/ "vGhO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrderSummary__ = __webpack_require__("KK3D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['id'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['orderInfo']), {
    receivedStatus: function receivedStatus() {
      return this.orderInfo.details.status === 'Waiting for Review' ? 'sent to admin for review' : 'received';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['loadLastOrder', 'setLastOrder'])),
  components: {
    OrderSummary: __WEBPACK_IMPORTED_MODULE_1__OrderSummary__["a" /* default */]
  },
  mounted: function mounted() {
    console.log('this.id', this.id);
    if (this.id) this.setLastOrder(this.id);else this.loadLastOrder();
  }
});

/***/ }),

/***/ "vIT7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_track_events__ = __webpack_require__("Dg6a");

//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      copied: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['joinTeamUrl']), {
    copyButton: function copyButton() {
      return this.copied ? 'Copied!' : '<i class="fas fa-clone"></i> Copy';
    }
  }),
  methods: {
    onCopy: function onCopy() {
      // show message??
      this.copied = true;
      Object(__WEBPACK_IMPORTED_MODULE_2__lib_track_events__["a" /* adminLinkShare */])('copy');
    },
    onCopyError: function onCopyError() {
      // show message??
    }
  }
});

/***/ }),

/***/ "vO8U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Design_vue__ = __webpack_require__("ZcqC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_841df2b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Design_vue__ = __webpack_require__("A8z5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Design_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_841df2b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Design_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vRXk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomepageWideLayout',{attrs:{"heroDark":""}},[_c('section',[_c('SecondaryHeader',[_c('h2',[_vm._v("Features")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("\n        ​​Streamline your company’s business card ordering process and stay in\n        control of your brand identity with our free full featured\n        application.\n      ")])]),_vm._v(" "),_c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',[_c('FeatureSection',{attrs:{"title":"Key Features","items":[
              {
                title: '1-minute setup',
                description: "\n                  Get started with your Brandly portal in a jiffy. No complex integrations, no \n                  coding required. Open your portal, upload your business card template and invite \n                  your team to order!\n                "
              },
              {
                title: 'Free ordering portal',
                description: "\n                  Simplify your business card ordering process dramatically by editing, proofing, \n                  approving, shipping, and paying all in one place. Only pay for the cards \n                  you order.\n                "
              },
              {
                title: 'Free backside printing',
                description: "\n                  Price transparency means no surprises -  like additional charges at checkout.  \n                  Whether you choose to print one or two sides of your cards, the price is always the same.\n                "
              },
              {
                title: 'Business level pricing',
                description: "\n                  We understand business cards are only one of many growth marketing tools your \n                  company invests in. That's why you'll enjoy discounted prices on our advertised \n                  prices.\n                "
              }
            ]}},[_vm._v("Get your portal ready and start ordering business cards for your\n            entire organization in minutes. Shipping is on us!")]),_vm._v(" "),_c('FeatureSection',{attrs:{"title":"Ordering","items":[
              {
                title: 'Admin or employee self-serve',
                description: "\n                  Whether you prefer to have one admin ordering cards for the entire company, or \n                  letting employees self-order, we’ve got you covered. No design skills required.\n                "
              },
              {
                title: 'On-brand templates',
                description: "\n                  Use shared business card templates for all orders. Updates on templates are \n                  automatically reflected on everyone’s personal cards. Brand consistency at its peak.\n                "
              },
              {
                title: 'One-click reorder',
                description: "\n                  Speed up the task of reordering your business cards. We save all of your previous order \n                  details so you can reorder with a simple click of a button.\n                "
              },
              {
                title: 'Auto-populating fields',
                description: "\n                  Stop manually keying in personal information for employee cards. This feature \n                  magically fills in fields for you from team member profiles.\n\n  \n                "
              }
            ]}},[_vm._v("Cross business cards off your to-do list with one of our simple\n            workflows optimized for fast and easy ordering.")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',[_c('FeatureSection',{attrs:{"title":"Product and Support","items":[
              {
                title: 'Top-quality business cards',
                description: "\n                  Brandly business cards are printed on top-quality papers, using state-of-the-art \n                  equipment. Ready to amaze your team?\n                "
              },
              {
                title: '100% satisfaction guarantee',
                description: "\n                  We want you to be absolutely thrilled with your business cards because we are not happy \n                  until you are. We'll fix any issues that crop up and reprint for free.\n                "
              },
              {
                title: 'Human QC on every order',
                description: "\n                  Every order passes through our quality control team before going to production. \n                  We look at each card before it hits the press and we'll get in touch if we spot any errors.\n                "
              },
              {
                title: 'Dedicated Account Managers',
                description: "\n                  Our team of account managers is dedicated to your success. There's always a real person eager to \n                  help you with whatever comes up.\n                "
              }
            ]}},[_vm._v("We stand behind our products and services 100%. We're ready\n            to help you and your company solve it's business card\n            needs.")]),_vm._v(" "),_c('FeatureSection',{attrs:{"title":"Team management","items":[
              {
                title: 'Unlimited users',
                description: "\n                  Brandly is designed for teams of all sizes. That’s why there’s no limit to the number \n                  of users. The larger your team, the more value you’ll realize from automation.\n                "
              },
               {
                title: 'Assign roles',
                description: "\n                  Most teams have admins - employees who manage various programs - and regular\n                  users. Assign roles to empower admins and keep things simple for everyone else.\n                "
              },
              {
                title: 'Easy rollout',
                description: "\n                  Whether your company has 50 or 5,000 employees, rolling out your new portal\n                  company-wide is fast and easy. One email - or sharing an invite link gets the job done.\n                "
              },
              {
                title: 'Bulk team import',
                description: "\n                  Do you have dozens of team members to order for? Use our bulk import tool so \n                  upload a spreadsheet of employees with their contact information in seconds.\n                "
              }
             
            ]}},[_vm._v("Invite team members, manage permissions, and allow your entire\n            organization to order business cards effortlessly.")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',[_c('FeatureSection',{attrs:{"title":"Shipping and tracking","items":[
              {
                title: 'Free U.S. shipping',
                description: "\n                  Because we are fully committed to your growth, and to no surprises at checkout, \n                  free shipping inside the U.S. is included on every order no matter the size.\n                "
              },
              {
                title: 'Delivery times',
                description: "\n                  Most orders are ready to ship within 4 business days and we ship via UPS ground which \n                  adds another 3 - 6 business days. Plan on delivery within 7 -10 days.\n                "
              },
              {
                title: 'Order Tracking and History',
                description: "\n                  Brandly users who are assigned the admin role can get a quick overview of all placed orders and track their \n                  delivery. Get a status update in seconds.\n                "
              }
            ]}},[_vm._v("Your custom business cards are delivered to your office in 7 -10 days, \n            at no additional cost. Ask if you need faster service.")]),_vm._v(" "),_c('FeatureSection',{attrs:{"title":"Permissions and workflows","items":[
              {
                title: 'Approval workflow',
                description: "\n                  Appoint an administrator as a gatekeeper who’ll supervise every order placed by \n                  team members before getting confirmed. Goodbye typos and errors!\n                "
              },
              {
                title: 'Ordering permissions',
                description: "\n                  Get total control of who gets to do what. Lock fields and paper types, assign \n                  designs individually, limit order quantities, and much more.\n                "
              },
              {
                title: 'Restrict editable fields',
                description: "\n                  Determine which text fields on your business card templates can be edited by your \n                  team members at the moment of ordering and which are not.\n                "
              }
            ]}},[_vm._v("Get full control of the entire operation with easy to use\n            controls. Easily manage who does what and when.")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',[_c('FeatureSection',{attrs:{"title":"Payment options","items":[
              {
                title: 'Shared credit card',
                description: "\n                  Choose this payment method if you prefer to use an office or company-wide credit card \n                  for orders placed by your team members.\n                "
              },
              {
                title: 'Individual credit card',
                description: "\n                  Choose this payment method if you want each user to use his or her own credit card to \n                  pay for their orders. Great for independent agents and franchisees!\n                "
              },
              {
                title: 'Invoicing',
                description: "\n                  If you prefer to be invoiced, please let us know. We'll send you an invoice and we simply ask \n                  that you pay by check, ACH, or Credit Card within 2 weeks.\n                "
              }
            ]}},[_vm._v("Choose the payment method that suits your business needs. Ask us if you have other custom\n            reqirements. ")]),_vm._v(" "),_c('FeatureSection',{attrs:{"title":"More features","items":[
              {
                title: 'Unlimited templates',
                description: "\n                  There are no limits to the number of templates you can save. This feature is especially useful \n                  for companies with several designs or brands under their umbrella.\n                "
              },
              {
                title: 'Photo support',
                description: "\n                  Need to add photos to your cards? No problem. Your business card templates can use pictures that can \n                  be easily replaced using the thumbnail feature.\n                "
              },
              {
                title: 'Easy-to-use Editor',
                description: "\n                  Once your business card template is set up, Brandly makes it easy to edit and customize your card's imprint \n                  information, even for those without any design skills.\n                "
              }
           
            ]}},[_vm._v("We're always innovating and thinking of new ways to make our services and products \n            better. Here are a few.\n          ")])],1)],1)],1),_vm._v(" "),_c('Demo')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vdxS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductPanel_vue__ = __webpack_require__("R7IX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30cc712a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductPanel_vue__ = __webpack_require__("Ib14");
function injectStyle (ssrContext) {
  __webpack_require__("oM9P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30cc712a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30cc712a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w260":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w2G8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_cta__ = __webpack_require__("aJbW");



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {},
  mutations: {},
  actions: {
    emailSignUp: function emailSignUp(context, email) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__services_cta__["a" /* emailSignUp */])(email).catch(function (e) {
        // Transform error into plain javascript result with success: true etc
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ success: false }, e.response.data);
      });
    }
  },
  getters: {}
});

/***/ }),

/***/ "wLA6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wa5P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pricing_vue__ = __webpack_require__("3GQm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33b27039_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pricing_vue__ = __webpack_require__("elvH");
function injectStyle (ssrContext) {
  __webpack_require__("MHeR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33b27039"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pricing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33b27039_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pricing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "wpHw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepagewide-layout"},[_c('HomepageLayout',{attrs:{"wide-header":_vm.wideHeader,"heroDark":_vm.heroDark}},[_vm._t("default")],2),_vm._v(" "),(_vm.footer !== 'no')?_c('BottomNavigation'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wtEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__admin__ = __webpack_require__("M8t8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth__ = __webpack_require__("jwGj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flags__ = __webpack_require__("92So");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__design__ = __webpack_require__("p28/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__basket__ = __webpack_require__("vEk2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__checkout__ = __webpack_require__("xt2r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dashboard__ = __webpack_require__("mFB8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cta__ = __webpack_require__("w2G8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__addresses__ = __webpack_require__("hf/7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__onboard__ = __webpack_require__("pN1f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__personalInfo__ = __webpack_require__("Gin7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__invite__ = __webpack_require__("xwS7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__libraries__ = __webpack_require__("t2bC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__join__ = __webpack_require__("Duz3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__products__ = __webpack_require__("+c1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__approval__ = __webpack_require__("6uqK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__vouchers__ = __webpack_require__("Wse+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__uploads__ = __webpack_require__("sZKJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__wait__ = __webpack_require__("uBAG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_logrocket__ = __webpack_require__("oeg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_logrocket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_logrocket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_logrocket_vuex__ = __webpack_require__("drke");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_logrocket_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_logrocket_vuex__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);





















var plugins = [__WEBPACK_IMPORTED_MODULE_20__wait__["b" /* waitPlugin */]];

// Uncomment to log during development or test debugging:
//import createLogger from 'vuex/dist/logger'
//plugins.push([createLogger()]);



plugins.push(__WEBPACK_IMPORTED_MODULE_22_logrocket_vuex___default()(__WEBPACK_IMPORTED_MODULE_21_logrocket___default.a));

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  plugins: plugins,
  modules: {
    admin: __WEBPACK_IMPORTED_MODULE_2__admin__["a" /* default */], auth: __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */], flags: __WEBPACK_IMPORTED_MODULE_4__flags__["a" /* default */], design: __WEBPACK_IMPORTED_MODULE_5__design__["a" /* default */], basket: __WEBPACK_IMPORTED_MODULE_6__basket__["a" /* default */], checkout: __WEBPACK_IMPORTED_MODULE_7__checkout__["a" /* default */], dashboard: __WEBPACK_IMPORTED_MODULE_8__dashboard__["a" /* default */], cta: __WEBPACK_IMPORTED_MODULE_9__cta__["a" /* default */],
    addresses: __WEBPACK_IMPORTED_MODULE_10__addresses__["a" /* default */], onboard: __WEBPACK_IMPORTED_MODULE_11__onboard__["a" /* default */], personalInfo: __WEBPACK_IMPORTED_MODULE_12__personalInfo__["a" /* default */], invite: __WEBPACK_IMPORTED_MODULE_13__invite__["a" /* default */], libraries: __WEBPACK_IMPORTED_MODULE_14__libraries__["a" /* default */], join: __WEBPACK_IMPORTED_MODULE_15__join__["a" /* default */],
    products: __WEBPACK_IMPORTED_MODULE_16__products__["a" /* default */], approval: __WEBPACK_IMPORTED_MODULE_17__approval__["a" /* default */], vouchers: __WEBPACK_IMPORTED_MODULE_18__vouchers__["a" /* default */], uploads: __WEBPACK_IMPORTED_MODULE_19__uploads__["a" /* default */]
  }
}));

/***/ }),

/***/ "wudB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PricingTable_vue__ = __webpack_require__("Q6E8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1866423c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PricingTable_vue__ = __webpack_require__("qz0b");
function injectStyle (ssrContext) {
  __webpack_require__("6r+W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1866423c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PricingTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1866423c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PricingTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x+Up":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = selectTopLeftObject;
function selectTopLeftObject(fabricCanvas) {
  var objects = fabricCanvas.getObjects();
  var minDistanceSquared = 10000000000;
  var topLeftmostObjectIndex = -1;
  if (objects) {
    for (var i = 0; i < objects.length; i++) {
      var obj = objects[i];
      var distanceSquaredFromTopLeft = obj.left * obj.left + obj.top * obj.top;
      if (distanceSquaredFromTopLeft < minDistanceSquared) {
        topLeftmostObjectIndex = i;
        minDistanceSquared = distanceSquaredFromTopLeft;
      }
    }
  }
  // gotta use indices here :-(
  // https://stackoverflow.com/questions/20096949/how-to-select-fabric-js-object-programmatically
  if (topLeftmostObjectIndex >= 0) {
    fabricCanvas.setActiveObject(fabricCanvas.item(topLeftmostObjectIndex));
    var active = fabricCanvas.getActiveObject();

    if (active.type === 'IText') {
      var endCharacterPosition = active.text ? active.text.length : 0;
      active.setSelectionStart(endCharacterPosition);
      active.setSelectionEnd(endCharacterPosition);
    }
  }
}

/***/ }),

/***/ "x1TZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x4PC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomepageSecondaryLayout',[_c('div',{staticClass:"header-dark-container"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"TOS-header"},[_c('h1',[_vm._v("Acceptance of Terms and Conditions")]),_vm._v(" "),_c('h4',[_vm._v("Last Updated:  Sept 25, 2017")]),_vm._v(" "),_c('p',[_vm._v("Welcome to the Brandly website (the \"Site\"). Brandly, Inc. provides its products and services to you subject to the \n            following conditions. Before you may use the Site, you must read and accept all of the terms and conditions in, and linked \n            to, this Terms of Service (\"TOS\") and the Privacy Policy. This TOS is effective upon acceptance. Use of any functionality of \n            the Site constitutes acceptance of this TOS. If this TOS conflicts with any other documents, the TOS will control for the \n            purposes of usage of the Site. You may only use certain portions of the Site if you are a Brandly registered user. If you \n            do not agree to be bound by this TOS and the Privacy Policy, you may not use the Site in any way.")])]),_vm._v(" "),_c('div',{staticClass:"TOS-conditions"},[_c('h4',[_vm._v("USE OF SITE")]),_vm._v(" "),_c('p',[_vm._v("You are granted permission to access and use this Site for the sole purpose of preparing, evaluating, and ordering\n              products solely through Brandly (referred to herein as “Products”). You agree to use this Site in a responsible manner \n              that is in full compliance with these Terms  of Use and with your local laws and regulations, including export and import \n              regulations. Without limitation, this Site may not be  utilized for any pornographic use, for any unlawful purpose or use, \n              to defame any person, to violate any person’s right of privacy or publicity, to infringe upon any copyright, trade name, \n              trademark, service mark or other intellectual property right of any person or entity.You agree that you will not use the \n              Site to produce Products that are offensive, unlawful, harassing, libelous, threatening, harmful, obscene, malicious or \n              otherwise objectionable. Brandly reserves the right, in Brandly’s sole discretion, to refuse to accept any content provided \n              by you to Brandly or to process any order at any time and for any reason. Brandly also may terminate its service to and/or \n              the accounts of customers found to be using Brandly to engage in undesirable activities or otherwise violating these Terms \n              of Use. You agree that Brandly shall have no liability of any kind to you or to any third party arising from such refusal \n              or termination.")]),_vm._v(" "),_c('p',[_vm._v("You are solely responsible for your Content in combination with any other images, graphics, text or other materials\n              you incorporate into your Products. You agree that you will not include any text, image, design, trademark, service mark, \n              or any copyrighted work of any third party in your Products unless you have obtained the appropriate authorizations from\n              the owners. You warrant that your Products do not infringe upon any rights of any third party, including copyright, trademark, \n              right of publicity or privacy, and will not libel or defame any third party, and that you have all required rights or permissions \n              necessary to incorporate third party material into your Products. By placing an order on this Site, you warrant that you have \n              all necessary permission, right and authority to place the order and you authorize Brandly to produce the Products on your \n              behalf. You grant Brandly the right to copy, modify, distribute, use, create derivative works of and vectorize any content you\n              have uploaded for the purpose of fulfilling your order and/or marketing products or services to you. Moreover, you warrant that \n              you have sufficient rights to permit Brandly to copy, distribute, use, modify, create derivative works of and vectorize any \n              uploaded content for the purpose of fulfilling your order and/or marketing products or services to you.")]),_vm._v(" "),_c('p',[_vm._v("You agree that you are responsible for protecting your password and controlling access to your registered account. You \n              agree that you will be responsible for all orders placed or other actions that are taken through your registered account.")]),_vm._v(" "),_c('h4',[_vm._v("LICENSE AND SITE ACCESS")]),_vm._v(" "),_c('p',[_vm._v("Brandly grants you a limited license to access and make use of the Site and the Service. This license does not include any \n              downloading or copying of account information for the benefit of another vendor or any other third party; caching, unauthorized \n              hypertext links to the Site and the framing of any Content available through the Site uploading, posting, or transmitting any \n              content that you do not have a right to make available (such as the intellectual property of another party); uploading, posting, \n              or transmitting any material that contains software viruses or any other computer code, files or programs designed to interrupt, \n              destroy or limit the functionality of any computer software or hardware or telecommunications equipment; any action that imposes \n              or may impose (in Brandly’s sole discretion) an unreasonable or disproportionately large load on Brandly’s infrastructure; or any \n              use of data mining, robots, or similar data gathering and extraction tools. You may not bypass any measures used by Brandly to \n              prevent or restrict access to the Site. Any unauthorized use by you shall terminate the permission or license granted to you or \n              your organization by Brandly.")]),_vm._v(" "),_c('h4',[_vm._v("USER ELIGIBILITY")]),_vm._v(" "),_c('p',[_vm._v("The Brandly service is not available to any users suspended or removed from the system by Brandly for any reason. If you or your \n            organization do not qualify, you may not use the Brandly Service or the Site.")]),_vm._v(" "),_c('p',[_vm._v("In consideration of your use of the Site, you represent that you legally belong to the organization and are not a person barred \n            from receiving services under the laws of the United States or other applicable jurisdiction. You also agree to provide true, accurate, \n            current and complete information about yourself as prompted by the Site's registration form. If you provide any information that is \n            untrue, inaccurate, not current or incomplete (or becomes untrue, inaccurate,not current or incomplete), or Brandly has reasonable \n            grounds to suspect that such information is untrue, inaccurate, not current or incomplete, Brandly has the right to refuse any and all \n            current or future use of the Site (or any portion thereof).")]),_vm._v(" "),_c('h4',[_vm._v("SUBMITTED CONTENT")]),_vm._v(" "),_c('p',[_vm._v("For purposes of this Agreement, the term \"Content\" means any work of authorship and includes, without limitation, video, audio, \n            photographs, images, illustrations, animations, logos, tools, written posts, replies, and comments, information, data, text, software, \n            scripts, executable files, graphics, and interactive features.")]),_vm._v(" "),_c('p',[_vm._v("As between you and Brandly, you retain ownership of all intellectual property rights to your Content, and Brandly retains ownership \n            of all intellectual property rights to its Service and all Content made available through the Service other than your Content. You agree \n            not to sell,license, distribute, copy, modify, publicly perform or display, transmit, publish, edit, adapt, create derivative works from, \n            or otherwise make unauthorized use of the Service or any Content made available through the Service (other than your own Content).")]),_vm._v(" "),_c('p',[_vm._v("As a Subscriber of the Service, you grant to Brandly a worldwide, non-exclusive, royalty-free, full-paid,irrevocable (other than a \n            termination of this Agreement), transferable right and license to download, copy, posted to Brandly for (1) purposes of operating and \n            providing the Service and (2) Brandly's internal business purposes, including without limitation for analyzing usage of and improving \n            its Service.")]),_vm._v(" "),_c('h4',[_vm._v("LIMITATION OF LIABILITY")]),_vm._v(" "),_c('p',[_vm._v("YOU EXPRESSLY UNDERSTAND AND AGREE THAT Brandly AND ITS SUBSIDIARIES, AFFILIATES, OFFICERS, EMPLOYEES,AGENTS, PARTNERS AND LICENSORS \n            SHALL NOT BE LIABLE TO YOU FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES, INCLUDING, BUT NOT LIMITED \n            TO, DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE, DATA OR OTHER INTANGIBLE LOSSES (EVEN IF Brandly HAS BEEN ADVISED OF THE POSSIBILITY OF \n            SUCH DAMAGES), RESULTING FROM USE OF THE SITE, CONTENT OR ANY RELATED SERVICES.")]),_vm._v(" "),_c('h4',[_vm._v("INDEMNITY")]),_vm._v(" "),_c('p',[_vm._v("You agree to indemnify and hold Brandly (and its officers, directors, agents, subsidiaries, joint ventures, and employees) harmless \n            from any claim or demand, including reasonable attorneys’ fees, or arising out of or related to your breach of this TOS, or your violation \n            of any law or the rights of a third party.")]),_vm._v(" "),_c('h4',[_vm._v("ELECTRONIC COMMUNICATION")]),_vm._v(" "),_c('p',[_vm._v("When you use the Site or send emails to Brandly, you are communicating with Brandly electronically. You consent to receive communications \n            electronically from Brandly and its Site Affiliates/Partners (as defined in the Privacy Policy). Brandly will communicate with you by email or \n            by posting notices on the Site. You agree that all agreements, notices, disclosures and other communications that are provided to you \n            electronically satisfy any legal requirement that such communications be in writing.")]),_vm._v(" "),_c('h4',[_vm._v("LINKS")]),_vm._v(" "),_c('p',[_vm._v("The Site or third parties may provide links to other World Wide Web sites or resources. Because Brandly has no control over such sites and \n            resources, you acknowledge and agree that Brandly is not responsible for the availability of such external sites or resources, and does not \n            endorse and is not responsible or liable for any content, advertising, products or other materials on or available from such sites or resources. \n            You further acknowledge and agree that Brandly shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged \n            to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such site or resource.")]),_vm._v(" "),_c('h4',[_vm._v("SITE-PROVIDED EMAIL POSTINGS")]),_vm._v(" "),_c('p',[_vm._v("The Site may provide users with the ability to send email messages to other users and non-users and to post messages on the Site. Brandly is under \n            no obligation to review any messages, information or content (\"Postings\") posted on the Site by users and assumes no responsibility or liability relating \n            to any such Postings. Notwithstanding the above, Brandly may from time to time monitor the Postings on the Site and may decline to accept and/or remove any \n            email or Postings. You understand and agree not to use any functionality provided by the Site to post content or initiate communications that contain:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Any unlawful, harmful, threatening, abusive, harassing, defamatory, vulgar, obscene, profane, hateful, racially, ethnically or otherwise objectionable \n              material of any kind, including, but not limited to, any material which encourages conduct that would constitute a criminal offense, give rise to civil \n              liability or otherwise violate any applicable local, state, national or international law.")]),_vm._v(" "),_c('li',[_vm._v("Advertisements or solicitations of any kind.")]),_vm._v(" "),_c('li',[_vm._v("Impersonate others or provide any kind of false information.")]),_vm._v(" "),_c('li',[_vm._v("Personal information such as messages which state phone numbers, social security numbers, account numbers, addresses, or employer references.")]),_vm._v(" "),_c('li',[_vm._v("Messages by non-spokesperson employees of Brandly purporting to speak on behalf of Brandly or containing confidential information or expressing \n              opinions concerning Brandly.")]),_vm._v(" "),_c('li',[_vm._v("Messages that offer unauthorized downloads of any copyrighted or private information.")]),_vm._v(" "),_c('li',[_vm._v("Multiple messages placed within individual folders by the same user restating the same point.")]),_vm._v(" "),_c('li',[_vm._v("Chain letters of any kind.")]),_vm._v(" "),_c('li',[_vm._v("Identical (or substantially similar) messages to multiple recipients advertising any product or service, expressing a political or other similar \n              message, or any other type of unsolicited commercial message. This prohibition includes but is not limited to a) Using Brandly invitations to send \n              messages to people who don’t know you or who are unlikely to recognize you as a known contact; b) Using Brandly to connect to people who don’t know \n              you and then sending unsolicited promotional messages to those direct connections without their permission; and c) Sending messages to distribution \n              lists, newsgroup aliases, or group aliases.")])]),_vm._v(" "),_c('h4',[_vm._v("ORGANIZATIONS AND COMPANIES")]),_vm._v(" "),_c('p',[_vm._v("In consideration of your use of the Services, you agree to:")]),_vm._v(" "),_c('p',[_vm._v("provide true, accurate, current and complete information about yourself as prompted by the Registration Process (\"Registration Data\"); and")]),_vm._v(" "),_c('p',[_vm._v("maintain and promptly update your Registration Data to keep it true, accurate, current, and complete.")]),_vm._v(" "),_c('p',[_vm._v("If you provide any information that is untrue, inaccurate, outdated, or incomplete, or if Brandly has reasonable grounds to suspect that such information \n            is untrue, inaccurate, outdated, or incomplete, Brandly may terminate your Account and refuse current or future use of any or all of the Services.")]),_vm._v(" "),_c('p',[_vm._v("You may designate authorized users of your account. Those authorized users will have full rights to access your account and to take any actions that \n            you are authorized to take under this Agreement. Users of your site or blog who interact with Brandly widget to purchase offers will agree to Brandly TOS \n            and Privacy Policy. You should be aware of our Return and Shipping policies.")]),_vm._v(" "),_c('h4',[_vm._v("ACCESS TO PASSWORD PROTECTED AREAS")]),_vm._v(" "),_c('p',[_vm._v("Access to and use of password protected and/or secure areas of the Site is restricted to authorized users only. Unauthorized individuals attempting \n            to access these areas of the Site may be subject to prosecution.")]),_vm._v(" "),_c('h4',[_vm._v("TRADEMARKS")]),_vm._v(" "),_c('p',[_vm._v("The trademarks, logos and service marks (\"Marks\") displayed on the Site are the property of Brandly and other parties. Users are prohibited from \n            using any Marks for any purpose including, but not limited to use as metatags on other pages or sites on the World Wide Web without the written permission \n            of Brandly or such third party which may own the Marks. All information and content including any software programs available on or through the Site \n            (\"Content\") is protected by copyright. Users are prohibited from modifying, copying, distributing, transmitting, displaying, publishing, selling, licensing, \n            creating derivative works or using any Content available on or through the Site for commercial or public purposes.")]),_vm._v(" "),_c('h4',[_vm._v("USE OF GOOGLE SERVICES")]),_vm._v(" "),_c('p',{attrs:{"id":"reCAPTCHA"}},[_vm._v("Brandly has implemented the Invisible reCAPTCHA for security purposes, and the usage of Invisible reCAPTCHA by users is subject to \n              the Google "),_c('a',{attrs:{"href":"https://www.google.com/intl/en/policies/privacy/","target":"_blank","rel":"nofollow"}},[_vm._v("Privacy Policy")]),_vm._v("and\n             "),_c('a',{attrs:{"href":"https://www.google.com/intl/en/policies/terms/","target":"_blank","rel":"nofollow"}},[_vm._v("Terms of Use")]),_vm._v(".")]),_vm._v(" "),_c('h4',[_vm._v("MODIFICATION AND NOTIFICATION OF CHANGES")]),_vm._v(" "),_c('p',[_vm._v("Brandly reserves the right to modify or replace this Agreement at any time and in Brandly's sole discretion. Brandly will indicate at the top of \n            this Agreement the date such document was last updated. Any changes will be effective immediately upon posting the revised version (or such later \n            effective date as may be indicated at the top of the revised Agreement). It is your responsibility to regularly check the Site to determine if there \n            have been changes to this Agreement and to review such changes. Your continued use of the Service following the posting of any changes to the Agreement \n            will constitute your acceptance of any such changes. If you do not agree to the changes, you must stop using the Service.")]),_vm._v(" "),_c('h4',[_vm._v("PROCEDURE FOR CLAIMS OF INTELLECTUAL PROPERTY INFRINGEMENT")]),_vm._v(" "),_c('p',[_vm._v("Brandly respects the intellectual property of others, and we ask our users to do the same. Brandly may, in appropriate circumstances and at its \n            discretion, disable and/or terminate the accounts of users who may be infringing the intellectual property of a third party. If you believe that your \n            work has been copied in a way that constitutes copyright infringement, or your intellectual property rights have been otherwise violated, please provide \n            Brandly’s Copyright Agent the following information:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("an electronic or physical signature of the person authorized to act on behalf of the owner of the copyright or other intellectual property interest;")]),_vm._v(" "),_c('li',[_vm._v("a description of the copyrighted work or other intellectual property that you claim has been infringed;")]),_vm._v(" "),_c('li',[_vm._v("a description of where the material that you claim is infringing is located on the Site;")]),_vm._v(" "),_c('li',[_vm._v("your address, telephone number, and email address;")]),_vm._v(" "),_c('li',[_vm._v("a statement by you that you have a good faith belief that the disputed use is not authorized by the copyright owner, its agent, or the law;")]),_vm._v(" "),_c('li',[_vm._v("a statement by you, made under penalty of perjury, that the above information in your notice is accurate and that you are the copyright or intellectual \n              property owner or authorized to act on the copyright or intellectual property owner's behalf.")])]),_vm._v(" "),_c('p',[_vm._v(" Brandly’s agent for notice of claims of copyright or other intellectual property infringement can be reached as follows:")]),_vm._v(" "),_c('div',{staticClass:"brandly-agent"},[_c('table',{staticStyle:{"width":"100%"}},[_c('tr',{staticClass:"agent-table"},[_c('td',{staticClass:"bold"},[_vm._v("By email:")]),_vm._v(" "),_c('td',[_vm._v("support@brandly.com")])]),_vm._v(" "),_c('tr',{staticClass:"agent-table"},[_c('td',{staticClass:"bold",attrs:{"id":"email"}},[_vm._v("By email:")]),_vm._v(" "),_c('td',[_vm._v(" Brandly, Inc."),_c('br'),_vm._v("\n                    101 Winding Way  "),_c('br'),_vm._v("\n                    Woodside, CA 94062")])])])]),_vm._v(" "),_c('h4',[_vm._v("SURVIVAL OF TERMS AFTER AGREEMENT ENDS")]),_vm._v(" "),_c('p',[_vm._v("Notwithstanding any other provisions of this TOS, or any general legal principles to the contrary, any provision of this TOS that imposes or contemplates \n            continuing obligations on a party will survive the expiration or termination of this TOS.")]),_vm._v(" "),_c('h4',[_vm._v("GENERAL")]),_vm._v(" "),_c('p',[_vm._v("If any of these conditions are deemed invalid, void, or for any reason unenforceable, the parties agree that the court should endeavor to give effect to the \n          parties’ intentions as reflected in the provision, and the unenforceable condition shall be deemed severable and shall not affect the validity and enforceability \n          of any remaining condition. From time to time Brandly may offer special promotional offers which may or may not apply to your Brandly account. Headings are for \n          reference purposes only and do not limit the scope or extent of such section. This TOS and the relationship between you and Brandly will be governed by the laws \n          of the State of New York without regard to its conflict of law provisions. You and Brandly agree to submit to the personal jurisdiction of the federal and state \n          courts located in the State of New York with respect to any legal proceedings that may arise in connection with this TOS. The failure of Brandly to act with \n          respect to a breach by you or others does not waive its right to act with respect to subsequent or similar breaches. Brandly does not guarantee it will take \n          action against all breaches of this TOS. Except as otherwise expressly provided in this TOS, there shall be no third-party beneficiaries to this TOS. This TOS \n          constitutes the entire agreement between you and Brandly and governs your use of the Site, superseding any prior agreements between you and Brandly with respect \n          to the Site.")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x9yb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_orderStatus__ = __webpack_require__("FPeH");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    order: { type: Object, required: false },
    isBackButtonShown: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      reOrderId: null // `id` of order for re-order action (used to show spinner).
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['flags', 'user']), {
    isStaffDashboard: function isStaffDashboard() {
      return this.$route.path.startsWith('/admin');
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['reOrder', 'updateRecentOrders']), {
    status: function status(order) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__lib_orderStatus__["e" /* default */])(order.status);
    },
    trackOrder: function trackOrder(order) {
      // Open new window with direct URL for UPS
      // order.tracking_number may have commas. UPS page works if we separate with \r\n
      var tracknum = order.tracking_number.replace(',', '\r\n');
      var url = 'https://www.ups.com/track?loc=en_US&tracknum=' + encodeURIComponent(tracknum) + '&requester=WT/trackdetails';
      window.open(url, 'track');
    },
    showTrackButton: function showTrackButton(order) {
      return this.status(order) === 'shipped' && order.tracking_number;
    },
    onReOrder: function onReOrder(orderId) {
      var _this = this;

      this.reOrderId = orderId;
      this.reOrder(orderId).then(function () {
        _this.reOrderId = null;
      });
    },
    showReorderButton: function showReorderButton(order) {
      // Hide re-order button in "admin" dashboard.
      return !this.isStaffDashboard && this.flags.showUnimplementedOrderActions && !this.showReviewButton(order);
    },
    showReorderButtonSpinner: function showReorderButtonSpinner(orderId) {
      return this.reOrderId === orderId;
    },
    showReviewButton: function showReviewButton(order) {
      return this.user.user_type === 'admin' && this.status(order) === 'review';
    },
    onAddressVerificationFinish: function onAddressVerificationFinish() {
      this.updateRecentOrders();
    },
    reviewPagePath: function reviewPagePath(order) {
      if (this.isStaffDashboard) {
        return '/admin/orders/' + order.id;
      }
      return '/dashboard/orders/' + order.id;
    }
  })
});

/***/ }),

/***/ "xHLl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LineDetailRow__ = __webpack_require__("h3fy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PaymentRow__ = __webpack_require__("KN6e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_bubble_notifyPromise__ = __webpack_require__("pXqx");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { LineDetailRow: __WEBPACK_IMPORTED_MODULE_4__LineDetailRow__["a" /* default */], PaymentRow: __WEBPACK_IMPORTED_MODULE_5__PaymentRow__["a" /* default */] },
  props: ['id'],
  data: function data() {
    return {
      mode: null,
      reason: '',
      isAddVoucherFormShown: false,
      voucherCode: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['loadOrderDetails', 'reloadOrderDetails']), {
    startPayment: function startPayment() {
      this.mode = 'paying';
    },
    startCancel: function startCancel() {
      this.mode = 'cancelling';
    },
    hideVoucherForm: function hideVoucherForm() {
      this.isAddVoucherFormShown = false;
      this.voucherCode = null;
    },
    applyDiscount: function applyDiscount(evt) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var messageSuccess;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.voucherCode) {
                  _context.next = 4;
                  break;
                }

                messageSuccess = 'Discount has been applied';
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_6__lib_bubble_notifyPromise__["a" /* default */])(evt.path, _this.$store.dispatch('addOrderDiscount', _this.voucherCode), messageSuccess);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.loadOrderDetails(_this2.id);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['orderDetails', 'flags']), {
    canDeleteLines: function canDeleteLines() {
      return this.orderDetails.allowed_changes.includes('delete_line') && this.orderDetails.lines.length > 1;
    },
    canChangeLines: function canChangeLines() {
      return this.orderDetails.allowed_changes.includes('change_line');
    },
    canChangeStatus: function canChangeStatus() {
      return this.orderDetails.allowed_changes.includes('change_status');
    },
    showButtons: function showButtons() {
      return !this.mode && this.canChangeStatus && !this.isStaffDashboard;
    },
    showPayment: function showPayment() {
      return this.mode === 'paying' && this.canChangeStatus && !this.isStaffDashboard;
    },
    showCancelDetails: function showCancelDetails() {
      return this.mode === 'cancelling' && this.canChangeStatus && !this.isStaffDashboard;
    },
    isStaffDashboard: function isStaffDashboard() {
      return this.$route.path.startsWith('/admin');
    },
    hasVoucherDiscount: function hasVoucherDiscount() {
      return this.orderDetails.voucher_discounts.length > 0;
    },
    voucherCodeToShow: function voucherCodeToShow() {
      if (this.hasVoucherDiscount) {
        var voucherDiscountFirst = this.orderDetails.voucher_discounts[0];
        return voucherDiscountFirst.voucher.code;
      }
      return '(none)';
    }
  })
});

/***/ }),

/***/ "xIwb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_736aeb58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FixedMenu_vue__ = __webpack_require__("5Mrv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_736aeb58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FixedMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_track_identify__ = __webpack_require__("tOs8");



//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  created: function created() {
    this.authorize();
    this.track();
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['user', 'team']),
  watch: {
    user: function user() {
      this.track();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['authorize', 'waitForTeam']), {
    track: function track() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.user) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _context.next = 4;
                return _this.waitForTeam();

              case 4:
                Object(__WEBPACK_IMPORTED_MODULE_4__lib_track_identify__["a" /* default */])(_this.user, _this.team);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  })
});

/***/ }),

/***/ "xLm3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BleedPointDisplay__ = __webpack_require__("Ctmo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inlineControls_TextBlock__ = __webpack_require__("qO5r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_filestackClient__ = __webpack_require__("saO9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_retrieveBase64FromFilestack__ = __webpack_require__("9f7z");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BleedPointDisplay: __WEBPACK_IMPORTED_MODULE_4__BleedPointDisplay__["a" /* default */],
    TextBlock: __WEBPACK_IMPORTED_MODULE_5__inlineControls_TextBlock__["a" /* default */]
  },
  props: {
    fabricCanvas: {
      type: Object,
      default: null
    },
    bleedPoints: {
      type: Array,
      default: []
    },
    displayBleed: {
      type: Boolean,
      default: true
    },
    bus: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      controlTypeToShow: null,
      controlsX: 0,
      controlsY: 0,
      canvasBound: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['validUploadTypes', 'flags', 'isTemplate']), {
    controlStyle: function controlStyle() {
      var style = {
        position: 'absolute',
        pointerEvents: 'all',

        display: this.controlTypeToShow ? 'block' : 'none',
        top: this.controlsY + 'px',
        left: this.controlsX + 'px'
      };
      return style;
    }
  }),
  methods: {
    bindCanvasEvents: function bindCanvasEvents() {
      var _this = this;

      console.log('bindCanvasEvents');
      this.fabricCanvas.on({
        'object:modified': function objectModified(event) {
          _this.updateControls(event.target);
        },
        'selection:created': function selectionCreated(event) {
          _this.updateControls(event.target);
        },
        'selection:updated': function selectionUpdated(event) {
          _this.updateControls(event.target);
        },
        'object:moving': function objectMoving(event) {
          _this.controlTypeToShow = null;
        },
        'selection:cleared': function selectionCleared(event) {
          _this.controlTypeToShow = null;
        }
      });
    },
    updateControls: function updateControls(obj) {
      var _this2 = this;

      var _ref = (obj || {}).brandly || {},
          isPlaceholder = _ref.isPlaceholder;

      var isSelection = obj ? obj.type === 'activeSelection' : false;

      var setControlType = function setControlType(obj, type) {
        if (obj) {
          _this2.controlTypeToShow = type;
          var objRect = obj.getBoundingRect();
          _this2.controlsX = objRect.left + objRect.width / 2;
          _this2.controlsY = objRect.top + objRect.height / 2;
        } else {
          _this2.controlTypeToShow = null;
        }
      };

      // const isSelection = (obj && obj.type === 'activeSelection');
      if (isPlaceholder) {
        setControlType(obj, 'placeholder');
      } else if (this.flags.enableBlocks && isSelection && this.isTemplate) {
        setControlType(obj, 'block');
      } else {
        this.controlTypeToShow = null;
      }
      this.obj = obj;
    },
    showUploadDialog: function showUploadDialog() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var obj, ratio, rect, client;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this3.flags.filestackUpload) {
                  _context2.next = 11;
                  break;
                }

                obj = _this3.fabricCanvas.getActiveObject();
                ratio = 1;
                rect = obj.getBoundingRect();

                if (rect.width && rect.height) {
                  //prevent div/0
                  ratio = rect.width / rect.height;
                }
                _context2.next = 7;
                return Object(__WEBPACK_IMPORTED_MODULE_6__lib_filestackClient__["a" /* default */])();

              case 7:
                client = _context2.sent;


                client.picker({
                  transformations: {
                    crop: {
                      aspectRatio: ratio,
                      force: true
                    }
                  },
                  onOpen: function onOpen() {
                    _this3.bus.$emit('filestackDialogOpen');
                  },
                  onClose: function onClose() {
                    _this3.bus.$emit('filestackDialogClosed');
                  },
                  onFileUploadFinished: function () {
                    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response) {
                      var base64;
                      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _context.next = 2;
                              return Object(__WEBPACK_IMPORTED_MODULE_7__lib_retrieveBase64FromFilestack__["a" /* default */])(response.handle);

                            case 2:
                              base64 = _context.sent;

                              _this3.$emit('fileData', base64);

                            case 4:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this3);
                    }));

                    return function onFileUploadFinished(_x) {
                      return _ref2.apply(this, arguments);
                    };
                  }() }).open();
                _context2.next = 12;
                break;

              case 11:
                _this3.$refs.hiddenFileInput.click();

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    uploadFile: function uploadFile(event) {
      var _this4 = this;

      var file = event.target.files[0];
      if (file) {
        var reader = new FileReader();
        reader.onload = function (fileEvent) {
          var data = fileEvent.target.result;
          _this4.$emit('fileData', data);
        };
        reader.readAsDataURL(file);
      }
    }
  },
  watch: {
    fabricCanvas: function fabricCanvas(val) {
      if (this.canvasBound || !val) {
        return;
      }
      this.bindCanvasEvents(val);
      var obj = this.fabricCanvas.getActiveObject();
      if (obj) this.updateControls(obj);
      this.canvasBound = true;
    }
  }
});

/***/ }),

/***/ "xS4n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xYxm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"welcome-section"}},[_c('h2',[_vm._v("Team")]),_vm._v(" "),_c('router-link',{staticClass:"minor cta-link",attrs:{"to":"/dashboard/team"}},[_vm._v("View")]),_vm._v(" "),(!_vm.showJoinLink)?_c('div',[(_vm.team.members_qty === 0)?_c('p',[_vm._v("You have no team members, invite one now!")]):_c('p',[_vm._v("Invite more teammates below, or "),_c('router-link',{attrs:{"to":"/dashboard/team"}},[_vm._v("view team")])],1),_vm._v(" "),_c('MessageFormGroup',[_c('b-input-group',[_c('b-form-input',{attrs:{"size":"sm","id":"invite-email","placeholder":"Email"},model:{value:(_vm.inviteEmail),callback:function ($$v) {_vm.inviteEmail=$$v},expression:"inviteEmail"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-btn',{attrs:{"size":"sm","id":"invite-button","variant":"default"},on:{"click":_vm.onClickInvite}},[_c('i',{staticClass:"fa fa-envelope"}),_vm._v(" Invite")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"basic-tooltip",class:{show: _vm.heroState === 'step4'},staticStyle:{"margin-top":"3px"}},[_vm._v("\n      Enter an email here\n    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"button-holder"},[_c('button',{staticClass:"btn switch-btn",on:{"click":_vm.onShowJoinLink}},[_c('i',{staticClass:"fas fa-link"}),_vm._v(" Share using link")])])],1):_c('div',[_c('p',[_vm._v("Share using link:")]),_vm._v(" "),_c('TeamShareInput'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"button-holder"},[_c('button',{staticClass:"btn switch-btn",on:{"click":_vm.onShowEmail}},[_c('i',{staticClass:"fas fa-email"}),_vm._v(" Share using email")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xhDO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    // Add a 'bus' props?
    // Bind events to bus
    Vue.mixin({
      mounted: function mounted() {
        var events = this.$options.events;
        this.listeners = {};
        for (var name in events) {
          var bound = catchErrors(events[name].bind(this));
          this.listeners[name] = bound;
          if (this.bus) this.bus.$on(name, bound);
        }
      },
      beforeDestroy: function beforeDestroy() {
        for (var name in this.listeners) {
          if (this.bus) this.bus.$off(name, this.listeners[name]);
        }
        this.listeners = {};
      },

      watch: {
        bus: function bus(newBus, oldBus) {
          for (var name in this.listeners) {
            var bound = this.listeners[name];
            if (oldBus) oldBus.$off(name, bound);
            if (newBus) newBus.$on(name, bound);
          }
        }
      }
    });
  }
});

function catchErrors(func) {
  return function () {
    try {
      return func.apply(undefined, arguments);
    } catch (e) {
      console.error('Error in VueBus event handler', e);
    }
  };
}

/***/ }),

/***/ "xpjA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98a0c66c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeamSharePanel_vue__ = __webpack_require__("ztMA");
function injectStyle (ssrContext) {
  __webpack_require__("5Xrs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-98a0c66c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98a0c66c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeamSharePanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xt2r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_CheckoutLogic__ = __webpack_require__("KrFv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_checkout__ = __webpack_require__("/HXe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_stripe__ = __webpack_require__("5Lgr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_addresses__ = __webpack_require__("FUN9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_tiny_cookie__ = __webpack_require__("+FgK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_tiny_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_tiny_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_track_events__ = __webpack_require__("Dg6a");














/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    nexus: null,
    taxInfo: {
      amount: null, // Amount not known
      busy: false, // API call not in progress
      error: null, // API call had error
      errCount: 0
    },
    shipInfo: {
      amount: null, // Amount not known
      code: null, // Shipping code for selected method
      methods: [], // list of available shipping methods
      busy: false // API call not in progress
    },
    checkout: {
      billing: Object(__WEBPACK_IMPORTED_MODULE_7__lib_CheckoutLogic__["c" /* empty_address */])(),
      shipping: Object(__WEBPACK_IMPORTED_MODULE_7__lib_CheckoutLogic__["c" /* empty_address */])(),
      shippingAddressVerification: null,
      billing_different_address: false,
      skip_review: false,
      reviewer: null,
      managerCheckbox: null
    },
    paymentInfo: {
      // Payment info, this should not be sent anywhere except to stripe!
      data: Object(__WEBPACK_IMPORTED_MODULE_7__lib_CheckoutLogic__["d" /* empty_payment */])(),

      // Data from stripe request
      stripeResult: null,

      // Whether we're currently trying to get the stripe info
      busy: false,

      // Stripe error object
      error: null
    },
    orderInfo: {
      placed: false,
      busy: false,
      details: null,
      error: null
    }
  },
  mutations: {
    updateNexus: function updateNexus(state, value) {
      state.nexus = value;
      // Reset error count for this nexus
      state.taxInfo.errCount = 0;
    },
    startTaxCalc: function startTaxCalc(state) {
      state.taxInfo.amount = null;
      state.taxInfo.busy = true;
      state.taxInfo.error = null;
    },
    taxCalcFailed: function taxCalcFailed(state, error) {
      state.taxInfo.busy = false;
      state.taxInfo.error = error;
      state.taxInfo.errCount++;
    },
    updateTaxAmount: function updateTaxAmount(state, value) {
      state.taxInfo.amount = value;
      state.taxInfo.busy = false;
      state.taxInfo.errCount = 0;;
      state.taxInfo.error = null;
    },
    startShipCalc: function startShipCalc(state) {
      state.shipInfo.amount = null;
      state.shipInfo.busy = true;
    },
    updateShipMethods: function updateShipMethods(state, methods) {
      state.shipInfo.methods = methods;
      if (!methods || methods.length === 0) {
        // No methods -- clear out amount
        state.shipInfo.code = null;
        state.shipInfo.amount = null;
      } else {
        var method = findCode(methods, state.shipInfo.code);
        if (!method) {
          // Previous code not valid -- choose first code as option
          method = methods[0];
          state.shipInfo.code = method.code;
        }
        state.shipInfo.amount = method.price;
      }
      state.shipInfo.busy = false;
    },
    updateShipCode: function updateShipCode(state, code) {
      var method = findCode(methods, state.shipInfo.code);
      if (!method) throw "Ship code not found!";
      state.shipInfo.code = method.code;
      state.shipInfo.amount = method.price;
    },
    updateCheckout: function updateCheckout(state, checkoutData) {
      state.checkout = checkoutData;
    },
    updatePayment: function updatePayment(state, paymentData) {
      state.paymentInfo.data = paymentData;
    },
    startPayment: function startPayment(state) {
      state.paymentInfo.busy = true;
      // Clear out previous results
      state.paymentInfo.error = null;
      state.paymentInfo.stripeResult = null;
    },
    paymentSucceeded: function paymentSucceeded(state, stripeResult) {
      state.paymentInfo.busy = false;
      state.paymentInfo.stripeResult = stripeResult;
    },
    paymentFailed: function paymentFailed(state, error) {
      state.paymentInfo.busy = false;
      state.paymentInfo.error = error;
    },
    paymentSkipped: function paymentSkipped(state) {
      // This information is not currently used but will
      // be recorded in Vue log for debuggability
      state.paymentInfo.skipped = true;
    },
    startPlaceOrder: function startPlaceOrder(state) {
      console.assert(!state.orderInfo.placed);
      state.orderInfo.busy = true;
      state.orderInfo.error = null;
    },
    placeOrderFailed: function placeOrderFailed(state, error) {
      state.orderInfo.error = error;
      state.orderInfo.busy = false;
    },
    placeOrderSucceeded: function placeOrderSucceeded(state, details) {
      state.orderInfo.details = details;
      state.orderInfo.placed = true;
      state.orderInfo.busy = false;
    },
    loadOrderStarted: function loadOrderStarted(state) {
      state.orderInfo.busy = true;
      state.orderInfo.error = null;
    },
    loadOrderSucceeded: function loadOrderSucceeded(state, details) {
      state.orderInfo.details = details;
      state.orderInfo.placed = true;
      state.orderInfo.busy = false;
    },
    loadOrderFailed: function loadOrderFailed(state, error) {
      state.orderInfo.error = error;
      state.orderInfo.busy = false;
    },
    setShippingAddressVerification: function setShippingAddressVerification(state, data) {
      state.checkout.shippingAddressVerification = data;
    },
    removeShippingAddressVerification: function removeShippingAddressVerification(state) {
      state.checkout.shippingAddressVerification = null;
    }
  },
  actions: {
    /**
     * Updates current checkout data.
     *
     * @param {*} context
     * @param {*} checkoutData
     */
    updateCheckoutInfo: function updateCheckoutInfo(context, checkoutData) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                context.commit('updateCheckout', checkoutData);
                return _context.abrupt('return', context.dispatch('updateNexus', Object(__WEBPACK_IMPORTED_MODULE_7__lib_CheckoutLogic__["h" /* nexus */])(checkoutData)));

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    /**
     * Sets default shipping and billing addresses.
     *
     * @param dispatch
     * @param getters
     * @returns {Promise<void>}
     */
    setDefaultCheckoutInfo: function setDefaultCheckoutInfo(_ref) {
      var _this2 = this;

      var dispatch = _ref.dispatch,
          getters = _ref.getters;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var addresses, shipping, billing, shippingAddressVerification, checkout;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return dispatch('loadUserAddresses');

              case 2:
                addresses = getters.userAddresses;
                shipping = addresses.find(function (addr) {
                  return addr.is_default_for_shipping;
                }) || addresses[0];
                billing = addresses.find(function (addr) {
                  return addr.is_default_for_billing;
                }) || shipping;

                // Since we use address from user's address book, it may already be verified

                shippingAddressVerification = null;

                if (shipping.address_verification) {
                  shippingAddressVerification = shipping.address_verification.verification_data;
                }
                checkout = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, getters.checkoutInfo, { billing: billing, shipping: shipping, shippingAddressVerification: shippingAddressVerification });

                dispatch('updateCheckoutInfo', checkout);

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    updateNexus: function updateNexus(context, nexus) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (context.getters.taxAmount === null || !Object(__WEBPACK_IMPORTED_MODULE_7__lib_CheckoutLogic__["i" /* nexusEqual */])(context.state.nexus, nexus)) {
                  context.commit('updateNexus', nexus);
                  if (nexus) {
                    context.dispatch('calcTax');
                    context.dispatch('calcShipping');
                  }
                }

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    calcTax: function calcTax(_ref2) {
      var _this4 = this;

      var state = _ref2.state,
          commit = _ref2.commit,
          getters = _ref2.getters;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var taxAmount;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (getters.basketLines.length) {
                  _context4.next = 3;
                  break;
                }

                console.log('ignoring calcTax until basket is loaded');
                return _context4.abrupt('return');

              case 3:
                if (state.nexus) {
                  _context4.next = 6;
                  break;
                }

                console.log('ignoring calcTax until nexus is defined');
                return _context4.abrupt('return');

              case 6:
                if (!(state.taxInfo.errCount > 2)) {
                  _context4.next = 9;
                  break;
                }

                console.log('ignoring taxCalc due to too many errors recently');
                return _context4.abrupt('return');

              case 9:
                commit('startTaxCalc');
                _context4.prev = 10;
                _context4.next = 13;
                return Object(__WEBPACK_IMPORTED_MODULE_8__services_checkout__["a" /* calculateSalesTax */])(state.nexus, getters.basketLines);

              case 13:
                taxAmount = _context4.sent;

                commit('updateTaxAmount', taxAmount);
                _context4.next = 21;
                break;

              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4['catch'](10);

                //console.error(e);
                // Unwrap the error body. Typically this won't have much useful info,
                // but its the best we have.
                if (_context4.t0.response && _context4.t0.response.data) _context4.t0 = _context4.t0.response.data;
                commit('taxCalcFailed', _context4.t0);

              case 21:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[10, 17]]);
      }))();
    },
    calcShipping: function calcShipping(_ref3) {
      var _this5 = this;

      var state = _ref3.state,
          commit = _ref3.commit;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var methods;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                commit('startShipCalc');
                _context5.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_8__services_checkout__["g" /* shippingMethods */])();

              case 3:
                methods = _context5.sent;

                commit('updateShipMethods', methods);

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    updatePaymentInfo: function updatePaymentInfo(_ref4, paymentData) {
      var _this6 = this;

      var commit = _ref4.commit;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                commit('updatePayment', paymentData);

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    loadStripe: function loadStripe() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                Object(__WEBPACK_IMPORTED_MODULE_9__services_stripe__["b" /* loadStripe */])();

              case 1:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    createStripeToken: function createStripeToken(_ref5) {
      var _this8 = this;

      var state = _ref5.state,
          dispatch = _ref5.dispatch,
          commit = _ref5.commit,
          getters = _ref5.getters;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var checkout, stripeResult;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (getters.needsPayment) {
                  _context8.next = 3;
                  break;
                }

                commit('paymentSkipped');
                return _context8.abrupt('return', true);

              case 3:
                if (!state.paymentInfo.data.saved_card) {
                  _context8.next = 6;
                  break;
                }

                // Use a null stripe token
                commit('paymentSucceeded', null);
                return _context8.abrupt('return', true);

              case 6:
                checkout = Object(__WEBPACK_IMPORTED_MODULE_7__lib_CheckoutLogic__["e" /* expandCheckoutInfo */])(state.checkout);

                commit('startPayment');
                _context8.prev = 8;
                _context8.next = 11;
                return Object(__WEBPACK_IMPORTED_MODULE_9__services_stripe__["a" /* createToken */])(state.paymentInfo.data, checkout.billing);

              case 11:
                stripeResult = _context8.sent;
                _context8.next = 19;
                break;

              case 14:
                _context8.prev = 14;
                _context8.t0 = _context8['catch'](8);

                console.error(_context8.t0);
                commit('paymentFailed', _context8.t0);
                return _context8.abrupt('return', false);

              case 19:
                commit('paymentSucceeded', stripeResult);
                return _context8.abrupt('return', true);

              case 21:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8, [[8, 14]]);
      }))();
    },
    placeOrder: function placeOrder(_ref6) {
      var _this9 = this;

      var state = _ref6.state,
          dispatch = _ref6.dispatch;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return dispatch('createStripeToken');

              case 2:
                if (!_context9.sent) {
                  _context9.next = 7;
                  break;
                }

                _context9.next = 5;
                return dispatch('submitOrder');

              case 5:
                dispatch('reloadBasket'); // Basket will be empty, sync state with api

                // Set a session cookie that allows the invoice page
                // to gracefully show the most recently placed order
                if (state.orderInfo.details && state.orderInfo.details.url) {
                  Object(__WEBPACK_IMPORTED_MODULE_11_tiny_cookie__["setCookie"])('lastOrder', state.orderInfo.details.url, {});
                } else {
                  console.error("lastOrder not set");
                }

              case 7:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },
    submitOrder: function submitOrder(_ref7) {
      var _this10 = this;

      var state = _ref7.state,
          dispatch = _ref7.dispatch,
          commit = _ref7.commit,
          getters = _ref7.getters;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var _expandCheckoutInfo, shipping, billing, rest, shipping_charge, total, _state$paymentInfo, skipped, data, stripeResult, stripeToken, paymentMethod, title, is_private, orderInfo, numItems;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                commit('startPlaceOrder');
                _expandCheckoutInfo = Object(__WEBPACK_IMPORTED_MODULE_7__lib_CheckoutLogic__["e" /* expandCheckoutInfo */])(state.checkout), shipping = _expandCheckoutInfo.shipping, billing = _expandCheckoutInfo.billing, rest = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties___default()(_expandCheckoutInfo, ['shipping', 'billing']);
                shipping_charge = { excl_tax: state.shipInfo.amount, tax: 0, incl_tax: state.shipInfo.amount };
                _context10.prev = 3;

                // Round the total price here, because Django-oscar-api serializers will fail if the number
                // has more than two decimals. It does accept strings however.
                total = getters.totalPrice.toFixed(2);
                // If the payment info is skipped, tell the backend via
                // a special value for StripeToken.

                _state$paymentInfo = state.paymentInfo, skipped = _state$paymentInfo.skipped, data = _state$paymentInfo.data, stripeResult = _state$paymentInfo.stripeResult;
                stripeToken = void 0, paymentMethod = void 0, title = void 0, is_private = void 0;

                if (!skipped) {
                  if (data.saved_card) {
                    paymentMethod = 'SavedCard';
                    stripeToken = data.saved_card;
                  } else {
                    stripeToken = stripeResult && stripeResult.id;
                    if (data.save_card) {
                      paymentMethod = 'CardSave';
                      title = data.title;
                      is_private = data.is_private;
                    } else {
                      paymentMethod = 'Card';
                    }
                  }
                } else {
                  if (getters.skipPaymentReason === 'centralizedPayment') {
                    stripeToken = 'Defer';
                    paymentMethod = 'DeferToApproval';
                  } else if (getters.forceInvoice) {
                    stripeToken = 'Defer';
                    paymentMethod = 'Invoice';
                  } else {
                    stripeToken = 'FreeVoucher';
                    paymentMethod = 'Voucher';
                  }
                }
                _context10.next = 10;
                return Object(__WEBPACK_IMPORTED_MODULE_8__services_checkout__["e" /* placeOrder */])(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
                  shipping_charge: shipping_charge,
                  total: total,
                  billing_address: billing,
                  shipping_address: shipping,
                  basket: getters.basketUrl,
                  guest_email: shipping.email_address
                }, rest), { paymentMethod: paymentMethod, stripeToken: stripeToken, title: title, is_private: is_private }, getters.basketLines);

              case 10:
                orderInfo = _context10.sent;
                numItems = orderInfo.lines.length;

                Object(__WEBPACK_IMPORTED_MODULE_12__lib_track_events__["i" /* orderPlaced */])({ paymentMethod: paymentMethod, numItems: numItems, total: total });
                commit('placeOrderSucceeded', orderInfo);
                if (data.save_card) {
                  dispatch('loadSavedCards');
                }
                dispatch('updateRecentOrders');
                _context10.next = 25;
                break;

              case 18:
                _context10.prev = 18;
                _context10.t0 = _context10['catch'](3);

                console.error(_context10.t0);
                if (_context10.t0.response && _context10.t0.response.data) _context10.t0 = _context10.t0.response.data;
                if (_context10.t0.detail) _context10.t0 = _context10.t0.detail;
                if (typeof _context10.t0 === 'string' && _context10.t0.trim()[0] === '<' && _context10.t0.length > 40) {
                  // We have a big HTML server error page. There's no useful information,
                  // make a nicer message.
                  _context10.t0 = 'Server error occurred';
                }
                commit('placeOrderFailed', _context10.t0);

              case 25:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this10, [[3, 18]]);
      }))();
    },
    loadLastOrder: function loadLastOrder(_ref8) {
      var _this11 = this;

      var state = _ref8.state,
          commit = _ref8.commit;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var orderUrl, orderInfo;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!state.orderInfo.details) {
                  _context11.next = 2;
                  break;
                }

                return _context11.abrupt('return');

              case 2:

                // Restore from cookie
                orderUrl = Object(__WEBPACK_IMPORTED_MODULE_11_tiny_cookie__["getCookie"])('lastOrder');

                if (orderUrl) {
                  _context11.next = 7;
                  break;
                }

                commit('loadOrderFailed', "Can't find last order");
                _context11.next = 18;
                break;

              case 7:
                commit('loadOrderStarted');
                _context11.prev = 8;
                _context11.next = 11;
                return Object(__WEBPACK_IMPORTED_MODULE_8__services_checkout__["b" /* getOrderInfo */])(orderUrl);

              case 11:
                orderInfo = _context11.sent;

                commit('loadOrderSucceeded', orderInfo);
                _context11.next = 18;
                break;

              case 15:
                _context11.prev = 15;
                _context11.t0 = _context11['catch'](8);

                commit('loadOrderFailed', _context11.t0 + '');

              case 18:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this11, [[8, 15]]);
      }))();
    },
    setLastOrder: function setLastOrder(_ref9, id) {
      var _this12 = this;

      var dispatch = _ref9.dispatch;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee12() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                Object(__WEBPACK_IMPORTED_MODULE_11_tiny_cookie__["setCookie"])('lastOrder', id, {});
                return _context12.abrupt('return', dispatch('loadLastOrder'));

              case 2:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this12);
      }))();
    },
    verifyShippingAddressData: function verifyShippingAddressData(_ref10, addressData) {
      var _this13 = this;

      var commit = _ref10.commit,
          dispatch = _ref10.dispatch;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var verificationData;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_10__services_addresses__["f" /* postVerifyAddressData */])(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, addressData, { line4: addressData.city }));

              case 2:
                verificationData = _context13.sent;

                commit('setShippingAddressVerification', verificationData);

              case 4:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this13);
      }))();
    }
  },
  getters: {
    taxAmount: function taxAmount(state) {
      return state.taxInfo.amount;
    },
    shipAmount: function shipAmount(state) {
      return state.shipInfo.amount;
    },
    isShippingCountryUSA: function isShippingCountryUSA(state) {
      return state.checkout.shipping.country === "US";
    },
    nexusInfoComplete: function nexusInfoComplete(state, getters) {
      return state.nexus && (!getters.needsPayment || state.taxInfo.amount !== null) && !state.taxInfo.busy && state.shipInfo.code && !state.shipInfo.busy;
    },
    paymentInfoComplete: function paymentInfoComplete(state, getters) {
      return getters.nexusInfoComplete && Object(__WEBPACK_IMPORTED_MODULE_7__lib_CheckoutLogic__["j" /* validateInfo */])({
        checkout: state.checkout,
        payment: state.paymentInfo.data,
        needsPayment: getters.needsPayment
      });
    },
    checkoutIssues: function checkoutIssues(state, getters) {
      var issues = [];
      if (state.taxInfo.busy) {
        issues.push('Calculating tax');
      } else if (state.nexus && getters.needsPayment && state.taxInfo.amount == null) {
        issues.push('Unable to calculate tax');
      }
      if (state.shipInfo.busy) {
        issues.push('Calculating shipping');
      } else if (state.nexus && !state.shipInfo.code) {
        issues.push('Unable to calculate shipping');
      }
      Object(__WEBPACK_IMPORTED_MODULE_7__lib_CheckoutLogic__["j" /* validateInfo */])({
        checkout: state.checkout,
        payment: state.paymentInfo.data,
        needsPayment: getters.needsPayment
      }, issues);
      if (state.paymentInfo.error) {
        issues.push(stringify(state.paymentInfo.error));
      }
      if (state.orderInfo.error) {
        issues.push(stringify(state.orderInfo.error));
      }
      if (!getters.isShippingAddressValid) {
        issues.push('Shipping address is invalid');
      }
      if (getters.approvalSettings.requireNotifyEmail) {
        if (!state.checkout.reviewer) {
          issues.push('You must enter a manager email');
        }
        if (!state.checkout.managerCheckbox) {
          issues.push('You must check the box');
        }
      }
      return issues;
    },

    checkoutInfo: function checkoutInfo(state) {
      return state.checkout;
    },
    skipReview: function skipReview(state) {
      return (state.checkout || {}).skip_review;
    },
    checkoutBusy: function checkoutBusy(state) {
      return state.paymentInfo.busy || state.orderInfo.busy;
    },
    orderInfo: function orderInfo(state) {
      return state.orderInfo;
    },
    orderLines: function orderLines(state) {
      return state.orderInfo && state.orderInfo.details && state.orderInfo.details.lines;
    },
    needsPayment: function needsPayment(state, getters) {
      return !getters.skipPaymentReason;
    },
    skipPaymentReason: function skipPaymentReason(state, getters) {
      if (getters.totalPrice === 0 && getters.subtotalPrice === 0) {
        return 'free';
      } else if (getters.approvalSettings.approvalMode === 'payment' && !getters.skipReview) {
        return 'centralizedPayment';
      } else if (getters.forceInvoice) {
        return 'invoice';
      }
      return null;
    },
    orderVoucher: function orderVoucher(state) {
      var o = state.orderInfo;
      o = o && o.details;
      o = o && o.voucher_discounts;
      return o && o[0];
    },
    canSaveCardOnFile: function canSaveCardOnFile(state, getters) {
      return getters.hasTeam && getters.isAdmin;
    },
    hasCardOnFile: function hasCardOnFile(state, getters) {
      return getters.hasTeam && getters.team.stripe_customer;
    },
    shippingAddressVerification: function shippingAddressVerification(state) {
      return state.checkout.shippingAddressVerification;
    },
    isShippingAddressValid: function isShippingAddressValid(state, getters) {
      if (getters.flags.verifyCheckoutShippingAddressData && state.checkout.shippingAddressVerification) {
        var data = state.checkout.shippingAddressVerification;
        if (!data.verifications.delivery.success) {
          return false;
        }
      }
      // Assume that shipping address is always valid w/o verifications
      return true;
    }
  }
});

function findCode(methods, codeToFind) {
  return methods.find(function (_ref11) {
    var code = _ref11.code;
    return code === codeToFind;
  });
}

function stringify(obj) {
  // Turn object into a string without losing information
  return (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj)) === 'object' ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj) : obj.toString();
}

/***/ }),

/***/ "xwS7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_invite__ = __webpack_require__("9e1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_full_name_splitter__ = __webpack_require__("zImE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_full_name_splitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_full_name_splitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_track_events__ = __webpack_require__("Dg6a");









/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    inviteInfo: {
      loaded: false,
      valid: true, // we don't check this yet
      user: null,
      accepted: false
    }
  },
  mutations: {
    setInviteState: function setInviteState(state, obj) {
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(state.inviteInfo, obj);
    }
  },
  actions: {
    loadInviteData: function loadInviteData(_ref, _ref2) {
      var _this = this;

      var commit = _ref.commit;
      var uid = _ref2.uid,
          token = _ref2.token;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (r) {
                  return setTimeout(r, 150);
                });

              case 2:
                console.log('loaded');

                // Uncomment to test out "real" loaded invite info
                // TODO use flags?
                // commit('setInviteState', {
                //   loaded: true,
                //   valid: true,
                //   user: {first_name: 'Tony', last_name: 'Lownds', email:'tony+2@brandly.com'},
                //   accepted: false
                // });
                // return

                commit('setInviteState', {
                  loaded: true,
                  valid: true,
                  user: null,
                  accepted: false
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    inviteMember: function inviteMember(_ref3, email) {
      var _this2 = this;

      var getters = _ref3.getters,
          dispatch = _ref3.dispatch;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (email) {
                  _context2.next = 2;
                  break;
                }

                throw new Error('Please fill in an email');

              case 2:
                console.log('invite->', email);
                _context2.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_invite__["b" /* createAndInviteUser */])(getters.teamId, email);

              case 5:
                Object(__WEBPACK_IMPORTED_MODULE_7__lib_track_events__["n" /* userInviteSent */])(email, 'user');
                // Re-fetch team info so that user appears in list
                return _context2.abrupt('return', dispatch('reloadTeamInfo'));

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    inviteAdmin: function inviteAdmin(_ref4, email) {
      var _this3 = this;

      var getters = _ref4.getters,
          dispatch = _ref4.dispatch;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (email) {
                  _context3.next = 2;
                  break;
                }

                throw new Error('Please fill in an email');

              case 2:
                console.log('invite admin->', email);
                _context3.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_invite__["b" /* createAndInviteUser */])(getters.teamId, email, 'admin');

              case 5:
                Object(__WEBPACK_IMPORTED_MODULE_7__lib_track_events__["n" /* userInviteSent */])(email, 'admin');
                // Re-fetch team info so that user appears in list
                return _context3.abrupt('return', dispatch('reloadTeamInfo'));

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    acceptInvite: function acceptInvite(_ref5, _ref6) {
      var _this4 = this;

      var dispatch = _ref5.dispatch;
      var uid = _ref6.uid,
          token = _ref6.token,
          name = _ref6.name,
          password = _ref6.password,
          first_name = _ref6.first_name,
          last_name = _ref6.last_name;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _splitter, _splitter2, user;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (name) {
                  ;
                  _splitter = __WEBPACK_IMPORTED_MODULE_6_full_name_splitter___default()(name);
                  _splitter2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_splitter, 2);
                  first_name = _splitter2[0];
                  last_name = _splitter2[1];
                }_context4.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_invite__["a" /* acceptInvite */])(uid, token, { password: password, first_name: first_name, last_name: last_name });

              case 3:
                user = _context4.sent;
                _context4.next = 6;
                return dispatch('setUser', user);

              case 6:
                Object(__WEBPACK_IMPORTED_MODULE_7__lib_track_events__["m" /* userInviteAccepted */])();

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    resendInvite: function resendInvite(context, email) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_5__services_invite__["c" /* resendInvite */])(email);

              case 2:
                result = _context5.sent;

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    }
  },
  getters: {
    inviteUser: function inviteUser(state) {
      return state.inviteInfo.user;
    },
    inviteLoaded: function inviteLoaded(state) {
      return state.inviteInfo.loaded;
    }
  }
});

/***/ }),

/***/ "y//D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"start-order-button"}},[(_vm.showDropdown)?_c('b-dropdown',{staticClass:"primary m-2",attrs:{"variant":"danger"}},[_c('template',{slot:"button-content"},[(_vm.busy)?_c('WaveSpinner',{attrs:{"inline":"","color":"white"}}):_c('span',[_vm._v("Start Order")])],1),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.onClickStartOrderForMyself}},[_vm._v("For Myself")]),_vm._v(" "),_c('b-dropdown-divider'),_vm._v(" "),_vm._l((_vm.membersExcludingSelf),function(member){return _c('b-dropdown-item',{key:member.username,on:{"click":function($event){return _vm.onClickStartOrderForMember(member)}}},[_vm._v("For "+_vm._s(_vm.memberName(member)))])})],2):_c('button',{staticClass:"btn btn-default",staticStyle:{"display":"inline-block"},attrs:{"disabled":_vm.flags.legacy,"title":_vm.flags.legacy ? 'Cannot start order on IE11' : ''},on:{"click":_vm.onClickStartOrderButton}},[(_vm.busy)?_c('WaveSpinner',{attrs:{"inline":"","color":"white"}}):_c('span',[_vm._v("Start Order")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yG03":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'extra': {},
    error: {
      type: String,
      default: null
    }

  }
});

/***/ }),

/***/ "yVEb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"sm":"12","lg":"5"}},[_c('SummaryBlock',[_c('p',{staticClass:"eyebrow"},[_vm._v("PRINTING SERVICE")]),_vm._v(" "),_c('h2',[_vm._v("Easy online ordering")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("Printing for large teams can be a headache. We’ll help you automate the process, maintain your brand, and only charge for the cards you order.")]),_vm._v(" "),_c('router-link',{staticClass:"learn-more",attrs:{"to":"/howitworks","title":""}},[_vm._v("See how it works >")])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"7"}},[_c('div',{staticClass:"parent-2"},[_c('ul',{staticClass:"list-1"},[_c('li',{staticClass:"item-container-1"},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":"/static/images/homepage/quality.svg","alt":"icon"}})]),_vm._v(" "),_c('div',{staticClass:"list-copy-container-1"},[_c('p',{staticClass:"title"},[_vm._v("High-quality business cards")]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v("We guarantee the faithful reproduction of your brand on your business cards or your money back.")])])]),_vm._v(" "),_c('li',{staticClass:"item-container-1"},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":"/static/images/homepage/time.svg","alt":"icon"}})]),_vm._v(" "),_c('div',{staticClass:"list-copy-container-1"},[_c('p',{staticClass:"title"},[_vm._v("Save time, order in minutes")]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v("Order for yourself or your team in minutes with streamlined workflows that scale with your needs.")])])]),_vm._v(" "),_c('li',{staticClass:"item-container-1"},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":"/static/images/homepage/control.svg","alt":"icon"}})]),_vm._v(" "),_c('div',{staticClass:"list-copy-container-1"},[_c('p',{staticClass:"title"},[_vm._v("Gain control with a company portal")]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v("Manage your designs, team members, office locations, and payment methods in one place.")])])])])])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{staticClass:"parent",attrs:{"id":"paper-finishing"}},[_c('div',{staticClass:"copy-container"},[_c('div',{staticClass:"copy"},[_c('p',{staticClass:"eyebrow"},[_vm._v("BUSINESS CARDS")]),_vm._v(" "),_c('h2',[_vm._v("Paper and finishing options")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("\n                  Choose from a wide selection of paper and finishing options; from basic to deluxe, uncoated to super-high gloss, with plain or rounded corners.\n                  "),_c('router-link',{staticClass:"view-all",attrs:{"to":"/business-cards"}},[_vm._v("Check all options.")])],1),_vm._v(" "),_c('router-link',{staticClass:"learn-more-paper",attrs:{"to":"/business-cards","title":""}},[_vm._v("Check all options >")])],1)])])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12","md":"4"}},[_c('div',{staticClass:"card-wrapper"},[_c('router-link',{attrs:{"to":"/business-cards/standard"}},[_c('img',{staticClass:"bc-image",attrs:{"src":"/static/images/homepage/cards-1.png"}}),_vm._v(" "),_c('div',{staticClass:"card-price"},[_c('h3',[_vm._v("Standard Business Cards")]),_vm._v(" "),_c('p',[_vm._v("\n                  50\n                  "),_c('span',[_vm._v(" cards from ")]),_vm._v("$18.99\n                ")])])])],1)]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"4"}},[_c('div',{staticClass:"card-wrapper"},[_c('router-link',{attrs:{"to":"/business-cards/premium"}},[_c('img',{staticClass:"bc-image",attrs:{"src":"/static/images/homepage/cards-2.png"}}),_vm._v(" "),_c('div',{staticClass:"card-price"},[_c('h3',[_vm._v("Premium Business Cards")]),_vm._v(" "),_c('p',[_vm._v("\n                  50\n                  "),_c('span',[_vm._v(" cards from ")]),_vm._v("$21.99\n                ")])])])],1)]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"4"}},[_c('div',{staticClass:"card-wrapper"},[_c('router-link',{attrs:{"to":"/business-cards/classic"}},[_c('img',{staticClass:"bc-image",attrs:{"src":"/static/images/homepage/cards-3.png"}}),_vm._v(" "),_c('div',{staticClass:"card-price"},[_c('h3',[_vm._v("Classic Business Cards")]),_vm._v(" "),_c('p',[_vm._v("\n                  50\n                  "),_c('span',[_vm._v(" cards from ")]),_vm._v("$30.99\n                ")])])])],1)])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"sm":"12","lg":"5"}},[_c('SummaryBlockDark',[_c('p',{staticClass:"eyebrow-dark"},[_vm._v("SAVE TIME")]),_vm._v(" "),_c('h2',[_vm._v("Order in minutes")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("We respect your time and budget, that’s why we’ve created a fast, easy, and frictionless process for ordering beautiful, and affordable business cards for your entire team.")]),_vm._v(" "),_c('router-link',{staticClass:"learn-more",attrs:{"to":"/signup","title":""}},[_vm._v("Open your account >")])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"7"}},[_c('div',{staticClass:"parent-2"},[_c('ul',{staticClass:"list-2"},[_c('li',{staticClass:"container-2"},[_c('div',{staticClass:"item-container-2"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"middle"},[_c('img',{attrs:{"src":"/static/images/homepage/quality-dark.svg","alt":"icon"}}),_vm._v(" "),_c('p',{staticClass:"list-copy"},[_vm._v("1-minute onboarding")])])])])]),_vm._v(" "),_c('li',{staticClass:"container-2"},[_c('div',{staticClass:"item-container-2"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"middle"},[_c('img',{attrs:{"src":"/static/images/homepage/quality-dark.svg","alt":"icon"}}),_vm._v(" "),_c('p',{staticClass:"list-copy"},[_vm._v("Admin or employee self-ordering")])])])])]),_vm._v(" "),_c('li',{staticClass:"container-2"},[_c('div',{staticClass:"item-container-2"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"middle"},[_c('img',{attrs:{"src":"/static/images/homepage/quality-dark.svg","alt":"icon"}}),_vm._v(" "),_c('p',{staticClass:"list-copy"},[_vm._v("Editable online templates")])])])])]),_vm._v(" "),_c('li',{staticClass:"container-2"},[_c('div',{staticClass:"item-container-2"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"middle"},[_c('img',{attrs:{"src":"/static/images/homepage/quality-dark.svg","alt":"icon"}}),_vm._v(" "),_c('p',{staticClass:"list-copy"},[_vm._v("Business level pricing")])])])])]),_vm._v(" "),_c('li',{staticClass:"container-2"},[_c('div',{staticClass:"item-container-2"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"middle"},[_c('img',{attrs:{"src":"/static/images/homepage/quality-dark.svg","alt":"icon"}}),_vm._v(" "),_c('p',{staticClass:"list-copy"},[_vm._v("Free second-side printing")])])])])]),_vm._v(" "),_c('li',{staticClass:"container-2"},[_c('div',{staticClass:"item-container-2"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"middle"},[_c('img',{attrs:{"src":"/static/images/homepage/quality-dark.svg","alt":"icon"}}),_vm._v(" "),_c('p',{staticClass:"list-copy"},[_vm._v("Free delivery")])])])])])])])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"layer"},[_c('b-container',[_c('b-row',{attrs:{"id":"gain-control"}},[_c('b-col',{attrs:{"sm":"12","lg":"7"}},[_c('div',{staticClass:"parent-2 gain-control-images",attrs:{"id":"portal"}},[_c('div',{staticClass:"parent-image"},[_c('img',{staticClass:"child-image",attrs:{"id":"brandly-dash","src":"/static/images/homepage/dashboard.png","alt":"earn section hero"}})]),_vm._v(" "),_c('div',{staticClass:"parent-image-2"},[_c('img',{staticClass:"child-image-2",attrs:{"id":"brandly-dash-2","src":"/static/images/homepage/edit.png","alt":"earn section hero"}})])])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"5"}},[_c('SummaryBlock',[_c('p',{staticClass:"eyebrow"},[_vm._v("GAIN CONTROL")]),_vm._v(" "),_c('h2',[_vm._v("\n              Your own company portal,\n              "),_c('br',{staticClass:"rwd-break"}),_vm._v("for free\n            ")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("\n              Our customers enjoy a free private portal where they can order\n              "),_c('strong',[_vm._v("on-brand ")]),_vm._v("business cards,\n              manage their designs, team members, locations, and payment methods.\n            ")]),_vm._v(" "),_c('router-link',{staticClass:"learn-more",attrs:{"to":"/signup","title":""}},[_vm._v("Open your free portal >")])],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yW2/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ymvS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z3lN":
/***/ (function(module, exports) {

module.exports = {"defaultChoice":{"quantity":100,"apiName":"Premium Matte Business Cards","category":"premium","corners":"Square"},"categories":[{"title":"Standard","products":[{"name":"Uncoated","tags":["14pt","font","white","write"],"src":"/static/images/product/businesscards/standard/details-uncoated.png","details":"A popular high quality standard paper stock perfect for minimal design and text. The perfect blend of value and quality.","apiName":"Standard Uncoated Business Cards","slug":"standard"},{"name":"Matte","tags":["14pt","font","color","ink"],"src":"/static/images/product/businesscards/standard/details-coated.png","details":"A popular high quality standard coated paper stock with a smooth matte finish. A versatile paper for any kind of design.","apiName":"Standard Matte Business Cards"},{"name":"Gloss","tags":["14pt","gloss","color","photo"],"src":"/static/images/product/businesscards/standard/details-uv.png","details":"A coated paper with a high gloss finish that leaves a shine and enriches designs and enhances colors. Great for photos and edge-to-edge color.","apiName":"Standard Gloss Business Cards"}]},{"title":"Premium","products":[{"name":"Bright White","tags":["16pt","font","white","write"],"src":"/static/images/product/businesscards/premium/details-brightwhite.png","details":"A beautiful, high quality designer paper that enhances colors and contrast. Leave a bold statement with an ultra white paper.","apiName":"Premium Bright White Business Cards","slug":"premium"},{"name":"Matte","tags":["16pt","font","color","ink"],"src":"/static/images/product/businesscards/premium/details-coated.png","details":"A coated paper stock with a smooth matte finish and a bit more heft than our standard matte. A versatile paper for any kind of design.","apiName":"Premium Matte Business Cards"},{"name":"Gloss","tags":["16pt","gloss","color","photo"],"src":"/static/images/product/businesscards/premium/details-uv.png","details":"A coated paper with a high gloss finish with a bit more heft than our standard gloss. Great for photos and edge-to-edge color.","apiName":"Premium Gloss Business Cards"},{"name":"Double Thick","tags":["34pt","sturdy","font","write"],"src":"/static/images/product/businesscards/premium/details-extra.png","details":"A sturdy bright white paper stock with a superfine eggshell white finish. This double-layered stock has a thickness you can see and feel.","apiName":"Premium Double Thick Business Cards"}]},{"title":"Classic","products":[{"name":"Bright White Linen","tags":["11pt","linen","font","raised"],"src":"/static/images/product/businesscards/classic/details-white-linen.png","details":"A brilliant white paper with a woven texture made up of a cross-hatch pattern. Raised ink gives it a handcrafted yet professional look.","apiName":"Bright White Linen Business Cards","slug":"classic"},{"name":"Warm White Linen","tags":["11pt","linen","font","raised"],"src":"/static/images/product/businesscards/classic/details-warm-linen.png","details":"A warm white paper with a woven texture made up of a cross-hatch pattern. Raised ink gives it a handcrafted yet professional look.","apiName":"Warm White Linen Business Cards"},{"name":"Bright White Vellum","tags":["11pt","vellum","font","raised"],"src":"/static/images/product/businesscards/classic/details-white-vellum.png","details":"An uncoated white paper with a slightly toothy surface. Raised print adds to the traditional look and feel of this paper stock.","apiName":"Bright White Vellum Business Cards"}]},{"title":"Color Core","description":"A color core sandwiched between two premium white paper stocks makes for a sturdy and heavyweight feel and unique look. Comes in a variety of vibrant colors to choose from.","products":[{"name":"Black Color Core","tags":["32pt","black","sturdy","write"],"src":"/static/images/product/businesscards/colorcore/details-black.png","class":"black-edge perspective","details":"A color core sandwiched between two premium white paper stocks. This extra thick triple-layered stock comes with a black color core.","apiName":"Black Color Core Business Cards","slug":"colorcore"},{"name":"Blue Color Core","tags":["32pt","blue","sturdy","write"],"src":"/static/images/product/businesscards/colorcore/details-blue.png","class":"blue-edge perspective","details":"A color core sandwiched between two premium white paper stocks. This extra thick triple-layered stock comes with a blue color core.","apiName":"Blue Color Core Business Cards"},{"name":"Red Color Core","tags":["32pt","red","sturdy","write"],"src":"/static/images/product/businesscards/colorcore/details-red.png","class":"red-edge perspective","details":"A color core sandwiched between two premium white paper stocks. This extra thick triple-layered stock comes with a red color core.","apiName":"Red Color Core Business Cards"},{"name":"Aqua Color Core","tags":["32pt","aqua","sturdy","write"],"src":"/static/images/product/businesscards/colorcore/details-aqua.png","class":"aqua-edge perspective","details":"A color core sandwiched between two premium white paper stocks. This extra thick triple-layered stock comes with an aqua color core.","apiName":"Aqua Color Core Business Cards"},{"name":"Orange Color Core","tags":["32pt","orange","sturdy","write"],"src":"/static/images/product/businesscards/colorcore/details-orange.png","class":"orange-edge perspective","details":"A color core sandwiched between two premium white paper stocks. This extra thick triple-layered stock comes with an orange color core.","apiName":"Orange Color Core Business Cards"}]},{"title":"Specialty","products":[{"name":"Soft-Touch","tags":["16pt","hybrid","color","soft"],"src":"/static/images/product/businesscards/specialty/details-soft.png","details":"A sturdy bright white paper with a stylish matte laminate. Soft-Touch has a velvety texture that’s easy on the fingertips.","apiName":"Soft Touch Business Cards"},{"name":"Plastic","tags":["15mil","hybrid","gloss","plastic"],"src":"/static/images/product/businesscards/specialty/details-plastic.png","details":"A sturdy, flexible, and waterproof PVC material that stands up to wear and tear. It also makes high contrast and bright visuals ‘pop’.","apiName":"Plastic Business Cards"},{"name":"Pearlescent","tags":["13pt","hybrid","pearl","write"],"src":"/static/images/product/businesscards/specialty/details-pearl.png","details":"Pearlized paper stock offer an iridescent finish that gives full color artwork a unique glimmer.","apiName":"Pearlescent Business Cards"}]}],"usecases":[{"title":"Crisp Clean Design","products":[{"name":"16 pt Soft Touch","src":"/static/images/product/businesscards/specialty/details-soft.png","details":"Durable yet soft waxy finish that’s easy on the fingertips and complements classic designs. ","apiName":"Soft Touch Business Cards"},{"name":"15 mil Plastic","src":"/static/images/product/businesscards/specialty/details-coated.png","details":"Sturdy, flexible, and waterproof PVC material. Makes high contrast and bright visuals ‘pop’.","apiName":"Plastic Business Cards"},{"name":"105 lb Pearl","src":"/static/images/product/businesscards/specialty/details-plastic.png","details":"A smooth and glistening finish for a more elegant touch.","apiName":"Pearlized Business Cards"},{"name":"16 pt Magnetic","src":"/static/images/product/businesscards/specialty/details-magnetic.png","details":"Create instant attraction, literally. A magnetic backing to keep your business front of mind. ","apiName":"Magnetic Business Cards"}]},{"title":"Minimal Ink Coverage","products":[{"name":"16 pt Soft Touch","src":"/static/images/product/businesscards/specialty/details-soft.png","details":"Durable yet soft waxy finish that’s easy on the fingertips and complements classic designs. ","apiName":"Soft Touch Business Cards"},{"name":"15 mil Plastic","src":"/static/images/product/businesscards/specialty/details-coated.png","details":"Sturdy, flexible, and waterproof PVC material. Makes high contrast and bright visuals ‘pop’.","apiName":"Plastic Business Cards"},{"name":"105 lb Pearl","src":"/static/images/product/businesscards/specialty/details-plastic.png","details":"A smooth and glistening finish for a more elegant touch.","apiName":"Pearlized Business Cards"},{"name":"16 pt Magnetic","src":"/static/images/product/businesscards/specialty/details-magnetic.png","details":"Create instant attraction, literally. A magnetic backing to keep your business front of mind. ","apiName":"Magnetic Business Cards"}]},{"title":"Full Ink Coverage","products":[{"name":"16 pt Soft Touch","src":"/static/images/product/businesscards/specialty/details-soft.png","details":"Durable yet soft waxy finish that’s easy on the fingertips and complements classic designs. ","apiName":"Soft Touch Business Cards"},{"name":"15 mil Plastic","src":"/static/images/product/businesscards/specialty/details-coated.png","details":"Sturdy, flexible, and waterproof PVC material. Makes high contrast and bright visuals ‘pop’.","apiName":"Plastic Business Cards"},{"name":"105 lb Pearl","src":"/static/images/product/businesscards/specialty/details-plastic.png","details":"A smooth and glistening finish for a more elegant touch.","apiName":"Pearlized Business Cards"},{"name":"16 pt Magnetic","src":"/static/images/product/businesscards/specialty/details-magnetic.png","details":"Create instant attraction, literally. A magnetic backing to keep your business front of mind. ","apiName":"Magnetic Business Cards"}]},{"title":"Super Glossy Surface","products":[{"name":"16 pt Soft Touch","src":"/static/images/product/businesscards/specialty/details-soft.png","details":"Durable yet soft waxy finish that’s easy on the fingertips and complements classic designs. ","apiName":"Soft Touch Business Cards"},{"name":"15 mil Plastic","src":"/static/images/product/businesscards/specialty/details-coated.png","details":"Sturdy, flexible, and waterproof PVC material. Makes high contrast and bright visuals ‘pop’.","apiName":"Plastic Business Cards"},{"name":"105 lb Pearl","src":"/static/images/product/businesscards/specialty/details-plastic.png","details":"A smooth and glistening finish for a more elegant touch.","apiName":"Pearlized Business Cards"},{"name":"16 pt Magnetic","src":"/static/images/product/businesscards/specialty/details-magnetic.png","details":"Create instant attraction, literally. A magnetic backing to keep your business front of mind. ","apiName":"Magnetic Business Cards"}]},{"title":"Uncoated - easy to write on","products":[{"name":"16 pt Soft Touch","src":"/static/images/product/businesscards/specialty/details-soft.png","details":"Durable yet soft waxy finish that’s easy on the fingertips and complements classic designs. ","apiName":"Soft Touch Business Cards"},{"name":"15 mil Plastic","src":"/static/images/product/businesscards/specialty/details-coated.png","details":"Sturdy, flexible, and waterproof PVC material. Makes high contrast and bright visuals ‘pop’.","apiName":"Plastic Business Cards"},{"name":"105 lb Pearl","src":"/static/images/product/businesscards/specialty/details-plastic.png","details":"A smooth and glistening finish for a more elegant touch.","apiName":"Pearlized Business Cards"},{"name":"16 pt Magnetic","src":"/static/images/product/businesscards/specialty/details-magnetic.png","details":"Create instant attraction, literally. A magnetic backing to keep your business front of mind. ","apiName":"Magnetic Business Cards"}]}]}

/***/ }),

/***/ "z7V6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z7cW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LineItemProductForm__ = __webpack_require__("GojV");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { LineItemProductForm: __WEBPACK_IMPORTED_MODULE_4__LineItemProductForm__["a" /* default */] },
  created: function created() {
    var id = this.$route.params.id;

    this.loadSelectedLine({ id: +id });
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["selectedLine", "selectedProductIsRounded", "designId"])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["loadSelectedLine", "removeFromCart", "duplicateLineAndDesign"]), {
    orderAnother: function orderAnother() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.duplicateLineAndDesign(_this.selectedLine);

              case 2:
                _this.$router.push({ name: "Editor", params: { id: _this.designId } });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    editDesign: function editDesign() {
      this.$router.push({
        name: "Editor",
        params: { id: this.selectedLine.designId }
      });
    },
    removeItem: function removeItem() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.removeFromCart(_this2.selectedLine);

              case 2:
                _this2.$router.push({ name: "Cart" });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  })
});

/***/ }),

/***/ "zDIk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WistiaMovie',{attrs:{"asset":"jmfdsuq0sg","autoplay":_vm.autoplay}},[_c('b-btn',[_vm._v("Watch movie "),_c('i',{staticClass:"far fa-play-circle"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zYnt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomepageWideLayout',[_c('div',{staticClass:"vheight"},[_c('div',{staticClass:"vcenter"},[_c('div',{staticClass:"wrapper"},[_c('h2',[_vm._v("Reset your password ")]),_vm._v(" "),_c('h3',[_vm._v("Then sign in again")]),_vm._v(" "),_c('div',{staticClass:"form-wrapper"},[_c('form',{attrs:{"accept-charset":"UTF-8","method":"post"},on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('b-form-group',{staticClass:"signup-form"},[_c('div',{staticClass:"signup-fieldset"},[_c('b-form-input',{staticClass:"signup-account-input",attrs:{"placeholder":"Password","required":"required","type":"password","autofocus":"autofocus","name":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('b-form-input',{staticClass:"signup-account-input",attrs:{"placeholder":"Confirm Password","required":"required","type":"password","autofocus":"autofocus","name":"confirm_password"},model:{value:(_vm.confirm_password),callback:function ($$v) {_vm.confirm_password=$$v},expression:"confirm_password"}}),_vm._v(" "),(_vm.loginError)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.loginError.toString()))]):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"signup-account-submit",attrs:{"type":"submit","name":"commit","disabled":_vm.loginBusy}},[(_vm.loginBusy)?_c('span',[_vm._v("Changing Password...")]):_c('span',[_vm._v("Change Password")])])],1)])],1)])])]),_vm._v(" "),_c('div',{staticClass:"hero-bottom"},[_c('img',{attrs:{"src":"/static/images/footer/product_footer.png"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zaiM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zo2H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zqjF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["designId", "isTemplate", "basketLines"]), {
    lineItem: function lineItem() {
      var _this = this;

      return this.basketLines.find(function (line) {
        return line.designId == _this.designId;
      });
    },
    checkoutUrl: function checkoutUrl() {
      return "/cart";
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["setDesignAsTemplate"]), {
    onSetTemplate: function onSetTemplate() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.setDesignAsTemplate();

              case 2:
                _this2.$router.push("/dashboard");

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log("mounted", _this3);

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  }
});

function on() {
  document.getElementById("overlay").style.display = "block";
}

function off() {
  document.getElementById("overlay").style.display = "none";
}

/***/ }),

/***/ "ztMA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel"},[_c('p',[_vm._v("Share using link:")]),_vm._v(" "),_c('TeamShareInput',{staticClass:"share"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3637e58ab28786a34d34.js